/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: number; output: number; }
  date: { input: string; output: string; }
  float8: { input: number; output: number; }
  jsonb: { input: any; output: any; }
  numeric: { input: number; output: number; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "eatfresh.age_verification" */
export type Eatfresh_Age_Verification = {
  __typename?: 'eatfresh_age_verification';
  /** An object relationship */
  age_verification_status: Eatfresh_Age_Verification_Status;
  /** An object relationship */
  age_verification_type: Eatfresh_Age_Verification_Type;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_checked_at?: Maybe<Scalars['timestamptz']['output']>;
  nonce: Scalars['String']['output'];
  status: Eatfresh_Age_Verification_Status_Enum;
  type: Eatfresh_Age_Verification_Type_Enum;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Aggregate = {
  __typename?: 'eatfresh_age_verification_aggregate';
  aggregate?: Maybe<Eatfresh_Age_Verification_Aggregate_Fields>;
  nodes: Array<Eatfresh_Age_Verification>;
};

export type Eatfresh_Age_Verification_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Age_Verification_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Age_Verification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Aggregate_Fields = {
  __typename?: 'eatfresh_age_verification_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Age_Verification_Max_Fields>;
  min?: Maybe<Eatfresh_Age_Verification_Min_Fields>;
};


/** aggregate fields of "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Age_Verification_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Age_Verification_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Age_Verification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.age_verification". All fields are combined with a logical 'AND'. */
export type Eatfresh_Age_Verification_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Age_Verification_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Age_Verification_Bool_Exp>>;
  age_verification_status?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
  age_verification_type?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  href?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_checked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  nonce?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Age_Verification_Status_Enum_Comparison_Exp>;
  type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.age_verification" */
export enum Eatfresh_Age_Verification_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgeVerificationPkey = 'age_verification_pkey'
}

/** input type for inserting data into table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Insert_Input = {
  age_verification_status?: InputMaybe<Eatfresh_Age_Verification_Status_Obj_Rel_Insert_Input>;
  age_verification_type?: InputMaybe<Eatfresh_Age_Verification_Type_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_checked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Eatfresh_Age_Verification_Status_Enum>;
  type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Age_Verification_Max_Fields = {
  __typename?: 'eatfresh_age_verification_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_checked_at?: Maybe<Scalars['timestamptz']['output']>;
  nonce?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  href?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_checked_at?: InputMaybe<Order_By>;
  nonce?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Age_Verification_Min_Fields = {
  __typename?: 'eatfresh_age_verification_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_checked_at?: Maybe<Scalars['timestamptz']['output']>;
  nonce?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  href?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_checked_at?: InputMaybe<Order_By>;
  nonce?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Mutation_Response = {
  __typename?: 'eatfresh_age_verification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Age_Verification>;
};

/** on_conflict condition type for table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_On_Conflict = {
  constraint: Eatfresh_Age_Verification_Constraint;
  update_columns?: Array<Eatfresh_Age_Verification_Update_Column>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.age_verification". */
export type Eatfresh_Age_Verification_Order_By = {
  age_verification_status?: InputMaybe<Eatfresh_Age_Verification_Status_Order_By>;
  age_verification_type?: InputMaybe<Eatfresh_Age_Verification_Type_Order_By>;
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  href?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_checked_at?: InputMaybe<Order_By>;
  nonce?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.age_verification */
export type Eatfresh_Age_Verification_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.age_verification" */
export enum Eatfresh_Age_Verification_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  Href = 'href',
  /** column name */
  Id = 'id',
  /** column name */
  LastCheckedAt = 'last_checked_at',
  /** column name */
  Nonce = 'nonce',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "eatfresh.age_verification" */
export type Eatfresh_Age_Verification_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_checked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Eatfresh_Age_Verification_Status_Enum>;
  type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status = {
  __typename?: 'eatfresh_age_verification_status';
  /** An array relationship */
  age_verifications: Array<Eatfresh_Age_Verification>;
  /** An aggregate relationship */
  age_verifications_aggregate: Eatfresh_Age_Verification_Aggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_StatusAge_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


/** columns and relationships of "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_StatusAge_Verifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};

/** aggregated selection of "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_Aggregate = {
  __typename?: 'eatfresh_age_verification_status_aggregate';
  aggregate?: Maybe<Eatfresh_Age_Verification_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Age_Verification_Status>;
};

/** aggregate fields of "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_age_verification_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Age_Verification_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Age_Verification_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.age_verification_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Age_Verification_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Bool_Exp>>;
  age_verifications?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
  age_verifications_aggregate?: InputMaybe<Eatfresh_Age_Verification_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.age_verification_status" */
export enum Eatfresh_Age_Verification_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  AgeVerificationStatusPkey = 'age_verification_status_pkey'
}

export enum Eatfresh_Age_Verification_Status_Enum {
  /** Error */
  Error = 'ERROR',
  /** Pending */
  Pending = 'PENDING',
  /** Success */
  Success = 'SUCCESS'
}

/** Boolean expression to compare columns of type "eatfresh_age_verification_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Age_Verification_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Age_Verification_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Age_Verification_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_Insert_Input = {
  age_verifications?: InputMaybe<Eatfresh_Age_Verification_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Age_Verification_Status_Max_Fields = {
  __typename?: 'eatfresh_age_verification_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Age_Verification_Status_Min_Fields = {
  __typename?: 'eatfresh_age_verification_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_Mutation_Response = {
  __typename?: 'eatfresh_age_verification_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Age_Verification_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Age_Verification_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_On_Conflict = {
  constraint: Eatfresh_Age_Verification_Status_Constraint;
  update_columns?: Array<Eatfresh_Age_Verification_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.age_verification_status". */
export type Eatfresh_Age_Verification_Status_Order_By = {
  age_verifications_aggregate?: InputMaybe<Eatfresh_Age_Verification_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.age_verification_status */
export type Eatfresh_Age_Verification_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.age_verification_status" */
export enum Eatfresh_Age_Verification_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.age_verification_status" */
export type Eatfresh_Age_Verification_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_age_verification_status" */
export type Eatfresh_Age_Verification_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Age_Verification_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Age_Verification_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.age_verification_status" */
export enum Eatfresh_Age_Verification_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Age_Verification_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Age_Verification_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Age_Verification_Status_Bool_Exp;
};

/** Streaming cursor of the table "eatfresh_age_verification" */
export type Eatfresh_Age_Verification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Age_Verification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Age_Verification_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_checked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Eatfresh_Age_Verification_Status_Enum>;
  type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type = {
  __typename?: 'eatfresh_age_verification_type';
  /** An array relationship */
  age_verifications: Array<Eatfresh_Age_Verification>;
  /** An aggregate relationship */
  age_verifications_aggregate: Eatfresh_Age_Verification_Aggregate;
  description: Scalars['String']['output'];
  /** An array relationship */
  fridges: Array<Eatfresh_Fridge>;
  /** An aggregate relationship */
  fridges_aggregate: Eatfresh_Fridge_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_TypeAge_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


/** columns and relationships of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_TypeAge_Verifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


/** columns and relationships of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_TypeFridgesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


/** columns and relationships of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_TypeFridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};

/** aggregated selection of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_Aggregate = {
  __typename?: 'eatfresh_age_verification_type_aggregate';
  aggregate?: Maybe<Eatfresh_Age_Verification_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Age_Verification_Type>;
};

/** aggregate fields of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_age_verification_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Age_Verification_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Age_Verification_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.age_verification_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Age_Verification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Bool_Exp>>;
  age_verifications?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
  age_verifications_aggregate?: InputMaybe<Eatfresh_Age_Verification_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridges?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.age_verification_type" */
export enum Eatfresh_Age_Verification_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  AgeVerificationTypePkey = 'age_verification_type_pkey'
}

export enum Eatfresh_Age_Verification_Type_Enum {
  /** Over 16 Credential */
  Over16Credential = 'Over16Credential',
  /** Over 18 Credential */
  Over18Credential = 'Over18Credential'
}

/** Boolean expression to compare columns of type "eatfresh_age_verification_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Age_Verification_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_Insert_Input = {
  age_verifications?: InputMaybe<Eatfresh_Age_Verification_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  fridges?: InputMaybe<Eatfresh_Fridge_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Age_Verification_Type_Max_Fields = {
  __typename?: 'eatfresh_age_verification_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Age_Verification_Type_Min_Fields = {
  __typename?: 'eatfresh_age_verification_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_Mutation_Response = {
  __typename?: 'eatfresh_age_verification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Age_Verification_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Age_Verification_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_On_Conflict = {
  constraint: Eatfresh_Age_Verification_Type_Constraint;
  update_columns?: Array<Eatfresh_Age_Verification_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.age_verification_type". */
export type Eatfresh_Age_Verification_Type_Order_By = {
  age_verifications_aggregate?: InputMaybe<Eatfresh_Age_Verification_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.age_verification_type */
export type Eatfresh_Age_Verification_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.age_verification_type" */
export enum Eatfresh_Age_Verification_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.age_verification_type" */
export type Eatfresh_Age_Verification_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_age_verification_type" */
export type Eatfresh_Age_Verification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Age_Verification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Age_Verification_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.age_verification_type" */
export enum Eatfresh_Age_Verification_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Age_Verification_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Age_Verification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Age_Verification_Type_Bool_Exp;
};

/** update columns of table "eatfresh.age_verification" */
export enum Eatfresh_Age_Verification_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  Href = 'href',
  /** column name */
  Id = 'id',
  /** column name */
  LastCheckedAt = 'last_checked_at',
  /** column name */
  Nonce = 'nonce',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Age_Verification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Age_Verification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Age_Verification_Bool_Exp;
};

/** columns and relationships of "eatfresh.article" */
export type Eatfresh_Article = {
  __typename?: 'eatfresh_article';
  active_for_retail: Scalars['Boolean']['output'];
  active_for_wholesale: Scalars['Boolean']['output'];
  /** An object relationship */
  article_detail?: Maybe<Eatfresh_Article_Details>;
  /** An array relationship */
  article_labeling_processes: Array<Eatfresh_Article_Labeling_Process>;
  /** An aggregate relationship */
  article_labeling_processes_aggregate: Eatfresh_Article_Labeling_Process_Aggregate;
  /** An array relationship */
  box_content_to_articles: Array<Eatfresh_Box_Content_To_Article>;
  /** An aggregate relationship */
  box_content_to_articles_aggregate: Eatfresh_Box_Content_To_Article_Aggregate;
  /** An array relationship */
  commissioning_process_positions: Array<Eatfresh_Commissioning_Process_Position>;
  /** An aggregate relationship */
  commissioning_process_positions_aggregate: Eatfresh_Commissioning_Process_Position_Aggregate;
  created: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  /** An array relationship */
  fridge_layout_level_positions: Array<Eatfresh_Fridge_Layout_Level_Position>;
  /** An aggregate relationship */
  fridge_layout_level_positions_aggregate: Eatfresh_Fridge_Layout_Level_Position_Aggregate;
  /** An array relationship */
  fridge_target_stock_positions: Array<Eatfresh_Fridge_Target_Stock_Position>;
  /** An aggregate relationship */
  fridge_target_stock_positions_aggregate: Eatfresh_Fridge_Target_Stock_Position_Aggregate;
  has_task: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: Maybe<Scalars['String']['output']>;
  margin_euros?: Maybe<Scalars['Int']['output']>;
  margin_percentage?: Maybe<Scalars['Int']['output']>;
  markup_percentage?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  price_changes: Array<Eatfresh_Price_Change>;
  /** An aggregate relationship */
  price_changes_aggregate: Eatfresh_Price_Change_Aggregate;
  /** An array relationship */
  price_locks: Array<Eatfresh_Price_Lock>;
  /** An aggregate relationship */
  price_locks_aggregate: Eatfresh_Price_Lock_Aggregate;
  product_image_id?: Maybe<Scalars['uuid']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Int']['output']>;
  retail_price: Scalars['Int']['output'];
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  supplier?: Maybe<Scalars['String']['output']>;
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploaded_file?: Maybe<Eatfresh_Uploaded_File>;
  /** An array relationship */
  warehouse_order_positions: Array<Eatfresh_Warehouse_Order_Position>;
  /** An aggregate relationship */
  warehouse_order_positions_aggregate: Eatfresh_Warehouse_Order_Position_Aggregate;
  /** An array relationship */
  warehouse_order_receipt_positions: Array<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** An aggregate relationship */
  warehouse_order_receipt_positions_aggregate: Eatfresh_Warehouse_Order_Receipt_Position_Aggregate;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleArticle_Labeling_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleArticle_Labeling_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleBox_Content_To_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleBox_Content_To_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleCommissioning_Process_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleCommissioning_Process_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleFridge_Layout_Level_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleFridge_Layout_Level_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleFridge_Target_Stock_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleFridge_Target_Stock_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticlePrice_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticlePrice_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticlePrice_LocksArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticlePrice_Locks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleWarehouse_Order_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleWarehouse_Order_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleWarehouse_Order_Receipt_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article" */
export type Eatfresh_ArticleWarehouse_Order_Receipt_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.article" */
export type Eatfresh_Article_Aggregate = {
  __typename?: 'eatfresh_article_aggregate';
  aggregate?: Maybe<Eatfresh_Article_Aggregate_Fields>;
  nodes: Array<Eatfresh_Article>;
};

export type Eatfresh_Article_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Article_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Article_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Article_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Article_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Article_Select_Column_Eatfresh_Article_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Article_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Article_Select_Column_Eatfresh_Article_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Article_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.article" */
export type Eatfresh_Article_Aggregate_Fields = {
  __typename?: 'eatfresh_article_aggregate_fields';
  avg?: Maybe<Eatfresh_Article_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Article_Max_Fields>;
  min?: Maybe<Eatfresh_Article_Min_Fields>;
  stddev?: Maybe<Eatfresh_Article_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Article_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Article_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Article_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Article_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Article_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Article_Variance_Fields>;
};


/** aggregate fields of "eatfresh.article" */
export type Eatfresh_Article_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.article" */
export type Eatfresh_Article_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Article_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Article_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Article_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Article_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Article_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Article_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Article_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Article_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Article_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Article_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.article" */
export type Eatfresh_Article_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Article_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Article_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Article_Avg_Fields = {
  __typename?: 'eatfresh_article_avg_fields';
  margin_euros?: Maybe<Scalars['Float']['output']>;
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  markup_percentage?: Maybe<Scalars['Float']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Avg_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.article". All fields are combined with a logical 'AND'. */
export type Eatfresh_Article_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Article_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Article_Bool_Exp>>;
  active_for_retail?: InputMaybe<Boolean_Comparison_Exp>;
  active_for_wholesale?: InputMaybe<Boolean_Comparison_Exp>;
  article_detail?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp>;
  box_content_to_articles?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
  box_content_to_articles_aggregate?: InputMaybe<Eatfresh_Box_Content_To_Article_Aggregate_Bool_Exp>;
  commissioning_process_positions?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
  commissioning_process_positions_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Position_Aggregate_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  ean?: InputMaybe<String_Comparison_Exp>;
  fridge_layout_level_positions?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
  fridge_layout_level_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Bool_Exp>;
  fridge_target_stock_positions?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
  fridge_target_stock_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Aggregate_Bool_Exp>;
  has_task?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  margin_euros?: InputMaybe<Int_Comparison_Exp>;
  margin_percentage?: InputMaybe<Int_Comparison_Exp>;
  markup_percentage?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price_changes?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
  price_changes_aggregate?: InputMaybe<Eatfresh_Price_Change_Aggregate_Bool_Exp>;
  price_locks?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
  price_locks_aggregate?: InputMaybe<Eatfresh_Price_Lock_Aggregate_Bool_Exp>;
  product_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  retail_confirmed_at_purchase_price?: InputMaybe<Int_Comparison_Exp>;
  retail_price?: InputMaybe<Int_Comparison_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  supplier?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  warehouse_order_positions?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
  warehouse_order_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Position_Aggregate_Bool_Exp>;
  warehouse_order_receipt_positions?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
  warehouse_order_receipt_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.article" */
export enum Eatfresh_Article_Constraint {
  /** unique or primary key constraint on columns "ean" */
  EanUnique = 'ean_unique',
  /** unique or primary key constraint on columns "id" */
  EatfreshArticlePkey = 'eatfresh_article_pkey'
}

/** columns and relationships of "eatfresh.article_details" */
export type Eatfresh_Article_Details = {
  __typename?: 'eatfresh_article_details';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  article: Eatfresh_Article;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: Maybe<Scalars['String']['output']>;
  article_id: Scalars['uuid']['output'];
  article_number?: Maybe<Scalars['String']['output']>;
  bio_control_number?: Maybe<Scalars['String']['output']>;
  co_id?: Maybe<Scalars['String']['output']>;
  contains_crustaceans?: Maybe<Scalars['Boolean']['output']>;
  contains_eggs?: Maybe<Scalars['Boolean']['output']>;
  contains_fish?: Maybe<Scalars['Boolean']['output']>;
  contains_gluten?: Maybe<Scalars['Boolean']['output']>;
  contains_lactose?: Maybe<Scalars['Boolean']['output']>;
  contains_milk?: Maybe<Scalars['Boolean']['output']>;
  contains_peanuts?: Maybe<Scalars['Boolean']['output']>;
  contains_soy?: Maybe<Scalars['Boolean']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['bigint']['output']>;
  deposit_value_single_item?: Maybe<Scalars['bigint']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  designation_according_to_lmiv?: Maybe<Scalars['String']['output']>;
  dyes_coloring?: Maybe<Array<Scalars['String']['output']>>;
  ean?: Maybe<Scalars['String']['output']>;
  eu_approval_number?: Maybe<Scalars['String']['output']>;
  flavor_enhancer?: Maybe<Array<Scalars['String']['output']>>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gln?: Maybe<Scalars['String']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  gtin_package_unit?: Maybe<Scalars['String']['output']>;
  halal?: Maybe<Scalars['Boolean']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  id: Scalars['uuid']['output'];
  ifs_broker_certified?: Maybe<Scalars['Boolean']['output']>;
  ingredient_list?: Maybe<Scalars['String']['output']>;
  is_deposit_required?: Maybe<Scalars['Boolean']['output']>;
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  kosher?: Maybe<Scalars['Boolean']['output']>;
  max_storage_temperature?: Maybe<Scalars['Int']['output']>;
  may_contain_traces_of?: Maybe<Array<Scalars['String']['output']>>;
  min_storage_temperature?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  nutrition_information?: Maybe<Eatfresh_Nutrition_Information>;
  origin_country?: Maybe<Scalars['String']['output']>;
  other_additives?: Maybe<Array<Scalars['String']['output']>>;
  /** An object relationship */
  packagingTypeByPackagingType?: Maybe<Eatfresh_Packaging_Type>;
  packaging_confirmed: Scalars['Boolean']['output'];
  packaging_type?: Maybe<Scalars['String']['output']>;
  packaging_type_package_unit?: Maybe<Scalars['String']['output']>;
  preservatives?: Maybe<Array<Scalars['String']['output']>>;
  purchase_price?: Maybe<Scalars['bigint']['output']>;
  recommended_price?: Maybe<Scalars['bigint']['output']>;
  regional?: Maybe<Scalars['Boolean']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Int']['output']>;
  returnable?: Maybe<Scalars['Boolean']['output']>;
  stabilizers?: Maybe<Array<Scalars['String']['output']>>;
  storage_box_capacity?: Maybe<Scalars['Int']['output']>;
  total_mhd?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  vat_category: Eatfresh_Vat_Category;
  vat_category_id: Scalars['uuid']['output'];
  vegan?: Maybe<Scalars['Boolean']['output']>;
  vegetarian?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  vitamin_minerals: Array<Eatfresh_Vitamin_Mineral>;
  /** An aggregate relationship */
  vitamin_minerals_aggregate: Eatfresh_Vitamin_Mineral_Aggregate;
  wholesale_price?: Maybe<Scalars['bigint']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "eatfresh.article_details" */
export type Eatfresh_Article_DetailsVitamin_MineralsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Order_By>>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_details" */
export type Eatfresh_Article_DetailsVitamin_Minerals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Order_By>>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};

/** aggregated selection of "eatfresh.article_details" */
export type Eatfresh_Article_Details_Aggregate = {
  __typename?: 'eatfresh_article_details_aggregate';
  aggregate?: Maybe<Eatfresh_Article_Details_Aggregate_Fields>;
  nodes: Array<Eatfresh_Article_Details>;
};

export type Eatfresh_Article_Details_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Article_Details_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Article_Details_Select_Column_Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Article_Details_Select_Column_Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Article_Details_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.article_details" */
export type Eatfresh_Article_Details_Aggregate_Fields = {
  __typename?: 'eatfresh_article_details_aggregate_fields';
  avg?: Maybe<Eatfresh_Article_Details_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Article_Details_Max_Fields>;
  min?: Maybe<Eatfresh_Article_Details_Min_Fields>;
  stddev?: Maybe<Eatfresh_Article_Details_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Article_Details_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Article_Details_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Article_Details_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Article_Details_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Article_Details_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Article_Details_Variance_Fields>;
};


/** aggregate fields of "eatfresh.article_details" */
export type Eatfresh_Article_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Article_Details_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Article_Details_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Article_Details_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Article_Details_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Article_Details_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Article_Details_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Article_Details_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Article_Details_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Article_Details_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Article_Details_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Article_Details_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Article_Details_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Article_Details_Avg_Fields = {
  __typename?: 'eatfresh_article_details_avg_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['Float']['output']>;
  deposit_value_single_item?: Maybe<Scalars['Float']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  max_storage_temperature?: Maybe<Scalars['Float']['output']>;
  min_storage_temperature?: Maybe<Scalars['Float']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  recommended_price?: Maybe<Scalars['Float']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Float']['output']>;
  storage_box_capacity?: Maybe<Scalars['Float']['output']>;
  total_mhd?: Maybe<Scalars['Float']['output']>;
  wholesale_price?: Maybe<Scalars['Float']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Avg_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.article_details". All fields are combined with a logical 'AND'. */
export type Eatfresh_Article_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Article_Details_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Article_Details_Bool_Exp>>;
  alcohol_content?: InputMaybe<Float_Comparison_Exp>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_category?: InputMaybe<String_Comparison_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  article_number?: InputMaybe<String_Comparison_Exp>;
  bio_control_number?: InputMaybe<String_Comparison_Exp>;
  co_id?: InputMaybe<String_Comparison_Exp>;
  contains_crustaceans?: InputMaybe<Boolean_Comparison_Exp>;
  contains_eggs?: InputMaybe<Boolean_Comparison_Exp>;
  contains_fish?: InputMaybe<Boolean_Comparison_Exp>;
  contains_gluten?: InputMaybe<Boolean_Comparison_Exp>;
  contains_lactose?: InputMaybe<Boolean_Comparison_Exp>;
  contains_milk?: InputMaybe<Boolean_Comparison_Exp>;
  contains_peanuts?: InputMaybe<Boolean_Comparison_Exp>;
  contains_soy?: InputMaybe<Boolean_Comparison_Exp>;
  deposit_value_package_unit?: InputMaybe<Bigint_Comparison_Exp>;
  deposit_value_single_item?: InputMaybe<Bigint_Comparison_Exp>;
  depth_package_unit?: InputMaybe<Float_Comparison_Exp>;
  depth_single_item?: InputMaybe<Float_Comparison_Exp>;
  designation_according_to_lmiv?: InputMaybe<String_Comparison_Exp>;
  dyes_coloring?: InputMaybe<String_Array_Comparison_Exp>;
  ean?: InputMaybe<String_Comparison_Exp>;
  eu_approval_number?: InputMaybe<String_Comparison_Exp>;
  flavor_enhancer?: InputMaybe<String_Array_Comparison_Exp>;
  fruit_content_percentage?: InputMaybe<Float_Comparison_Exp>;
  gln?: InputMaybe<String_Comparison_Exp>;
  gross_weight_single_item?: InputMaybe<Float_Comparison_Exp>;
  gross_weigth_package_unit?: InputMaybe<Float_Comparison_Exp>;
  gtin_package_unit?: InputMaybe<String_Comparison_Exp>;
  halal?: InputMaybe<Boolean_Comparison_Exp>;
  height_package_unit?: InputMaybe<Float_Comparison_Exp>;
  height_single_item?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ifs_broker_certified?: InputMaybe<Boolean_Comparison_Exp>;
  ingredient_list?: InputMaybe<String_Comparison_Exp>;
  is_deposit_required?: InputMaybe<Boolean_Comparison_Exp>;
  items_per_package_unit?: InputMaybe<Int_Comparison_Exp>;
  kosher?: InputMaybe<Boolean_Comparison_Exp>;
  max_storage_temperature?: InputMaybe<Int_Comparison_Exp>;
  may_contain_traces_of?: InputMaybe<String_Array_Comparison_Exp>;
  min_storage_temperature?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  net_fill_volume?: InputMaybe<Float_Comparison_Exp>;
  net_weight?: InputMaybe<Float_Comparison_Exp>;
  nutrition_information?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
  origin_country?: InputMaybe<String_Comparison_Exp>;
  other_additives?: InputMaybe<String_Array_Comparison_Exp>;
  packagingTypeByPackagingType?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
  packaging_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  packaging_type?: InputMaybe<String_Comparison_Exp>;
  packaging_type_package_unit?: InputMaybe<String_Comparison_Exp>;
  preservatives?: InputMaybe<String_Array_Comparison_Exp>;
  purchase_price?: InputMaybe<Bigint_Comparison_Exp>;
  recommended_price?: InputMaybe<Bigint_Comparison_Exp>;
  regional?: InputMaybe<Boolean_Comparison_Exp>;
  remaining_shelf_life?: InputMaybe<Int_Comparison_Exp>;
  returnable?: InputMaybe<Boolean_Comparison_Exp>;
  stabilizers?: InputMaybe<String_Array_Comparison_Exp>;
  storage_box_capacity?: InputMaybe<Int_Comparison_Exp>;
  total_mhd?: InputMaybe<Int_Comparison_Exp>;
  vat_category?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
  vat_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  vegan?: InputMaybe<Boolean_Comparison_Exp>;
  vegetarian?: InputMaybe<Boolean_Comparison_Exp>;
  vitamin_minerals?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
  vitamin_minerals_aggregate?: InputMaybe<Eatfresh_Vitamin_Mineral_Aggregate_Bool_Exp>;
  wholesale_price?: InputMaybe<Bigint_Comparison_Exp>;
  width_package_unit?: InputMaybe<Float_Comparison_Exp>;
  width_single_item?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.article_details" */
export enum Eatfresh_Article_Details_Constraint {
  /** unique or primary key constraint on columns "article_id" */
  ArticleDetailsArticleIdKey = 'article_details_article_id_key',
  /** unique or primary key constraint on columns "id" */
  ArticleDetailsPk = 'article_details_pk'
}

/** input type for incrementing numeric columns in table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Inc_Input = {
  alcohol_content?: InputMaybe<Scalars['Float']['input']>;
  deposit_value_package_unit?: InputMaybe<Scalars['bigint']['input']>;
  deposit_value_single_item?: InputMaybe<Scalars['bigint']['input']>;
  depth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  depth_single_item?: InputMaybe<Scalars['Float']['input']>;
  fruit_content_percentage?: InputMaybe<Scalars['Float']['input']>;
  gross_weight_single_item?: InputMaybe<Scalars['Float']['input']>;
  gross_weigth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  height_package_unit?: InputMaybe<Scalars['Float']['input']>;
  height_single_item?: InputMaybe<Scalars['Float']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  max_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  min_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  net_fill_volume?: InputMaybe<Scalars['Float']['input']>;
  net_weight?: InputMaybe<Scalars['Float']['input']>;
  purchase_price?: InputMaybe<Scalars['bigint']['input']>;
  recommended_price?: InputMaybe<Scalars['bigint']['input']>;
  remaining_shelf_life?: InputMaybe<Scalars['Int']['input']>;
  storage_box_capacity?: InputMaybe<Scalars['Int']['input']>;
  total_mhd?: InputMaybe<Scalars['Int']['input']>;
  wholesale_price?: InputMaybe<Scalars['bigint']['input']>;
  width_package_unit?: InputMaybe<Scalars['Float']['input']>;
  width_single_item?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Insert_Input = {
  alcohol_content?: InputMaybe<Scalars['Float']['input']>;
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: InputMaybe<Scalars['String']['input']>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_number?: InputMaybe<Scalars['String']['input']>;
  bio_control_number?: InputMaybe<Scalars['String']['input']>;
  co_id?: InputMaybe<Scalars['String']['input']>;
  contains_crustaceans?: InputMaybe<Scalars['Boolean']['input']>;
  contains_eggs?: InputMaybe<Scalars['Boolean']['input']>;
  contains_fish?: InputMaybe<Scalars['Boolean']['input']>;
  contains_gluten?: InputMaybe<Scalars['Boolean']['input']>;
  contains_lactose?: InputMaybe<Scalars['Boolean']['input']>;
  contains_milk?: InputMaybe<Scalars['Boolean']['input']>;
  contains_peanuts?: InputMaybe<Scalars['Boolean']['input']>;
  contains_soy?: InputMaybe<Scalars['Boolean']['input']>;
  deposit_value_package_unit?: InputMaybe<Scalars['bigint']['input']>;
  deposit_value_single_item?: InputMaybe<Scalars['bigint']['input']>;
  depth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  depth_single_item?: InputMaybe<Scalars['Float']['input']>;
  designation_according_to_lmiv?: InputMaybe<Scalars['String']['input']>;
  dyes_coloring?: InputMaybe<Array<Scalars['String']['input']>>;
  ean?: InputMaybe<Scalars['String']['input']>;
  eu_approval_number?: InputMaybe<Scalars['String']['input']>;
  flavor_enhancer?: InputMaybe<Array<Scalars['String']['input']>>;
  fruit_content_percentage?: InputMaybe<Scalars['Float']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  gross_weight_single_item?: InputMaybe<Scalars['Float']['input']>;
  gross_weigth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  gtin_package_unit?: InputMaybe<Scalars['String']['input']>;
  halal?: InputMaybe<Scalars['Boolean']['input']>;
  height_package_unit?: InputMaybe<Scalars['Float']['input']>;
  height_single_item?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ifs_broker_certified?: InputMaybe<Scalars['Boolean']['input']>;
  ingredient_list?: InputMaybe<Scalars['String']['input']>;
  is_deposit_required?: InputMaybe<Scalars['Boolean']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  max_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  may_contain_traces_of?: InputMaybe<Array<Scalars['String']['input']>>;
  min_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  net_fill_volume?: InputMaybe<Scalars['Float']['input']>;
  net_weight?: InputMaybe<Scalars['Float']['input']>;
  nutrition_information?: InputMaybe<Eatfresh_Nutrition_Information_Obj_Rel_Insert_Input>;
  origin_country?: InputMaybe<Scalars['String']['input']>;
  other_additives?: InputMaybe<Array<Scalars['String']['input']>>;
  packagingTypeByPackagingType?: InputMaybe<Eatfresh_Packaging_Type_Obj_Rel_Insert_Input>;
  packaging_confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  packaging_type?: InputMaybe<Scalars['String']['input']>;
  packaging_type_package_unit?: InputMaybe<Scalars['String']['input']>;
  preservatives?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_price?: InputMaybe<Scalars['bigint']['input']>;
  recommended_price?: InputMaybe<Scalars['bigint']['input']>;
  regional?: InputMaybe<Scalars['Boolean']['input']>;
  remaining_shelf_life?: InputMaybe<Scalars['Int']['input']>;
  returnable?: InputMaybe<Scalars['Boolean']['input']>;
  stabilizers?: InputMaybe<Array<Scalars['String']['input']>>;
  storage_box_capacity?: InputMaybe<Scalars['Int']['input']>;
  total_mhd?: InputMaybe<Scalars['Int']['input']>;
  vat_category?: InputMaybe<Eatfresh_Vat_Category_Obj_Rel_Insert_Input>;
  vat_category_id?: InputMaybe<Scalars['uuid']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  vitamin_minerals?: InputMaybe<Eatfresh_Vitamin_Mineral_Arr_Rel_Insert_Input>;
  wholesale_price?: InputMaybe<Scalars['bigint']['input']>;
  width_package_unit?: InputMaybe<Scalars['Float']['input']>;
  width_single_item?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Article_Details_Max_Fields = {
  __typename?: 'eatfresh_article_details_max_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: Maybe<Scalars['String']['output']>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_number?: Maybe<Scalars['String']['output']>;
  bio_control_number?: Maybe<Scalars['String']['output']>;
  co_id?: Maybe<Scalars['String']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['bigint']['output']>;
  deposit_value_single_item?: Maybe<Scalars['bigint']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  designation_according_to_lmiv?: Maybe<Scalars['String']['output']>;
  dyes_coloring?: Maybe<Array<Scalars['String']['output']>>;
  ean?: Maybe<Scalars['String']['output']>;
  eu_approval_number?: Maybe<Scalars['String']['output']>;
  flavor_enhancer?: Maybe<Array<Scalars['String']['output']>>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gln?: Maybe<Scalars['String']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  gtin_package_unit?: Maybe<Scalars['String']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ingredient_list?: Maybe<Scalars['String']['output']>;
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  max_storage_temperature?: Maybe<Scalars['Int']['output']>;
  may_contain_traces_of?: Maybe<Array<Scalars['String']['output']>>;
  min_storage_temperature?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  origin_country?: Maybe<Scalars['String']['output']>;
  other_additives?: Maybe<Array<Scalars['String']['output']>>;
  packaging_type?: Maybe<Scalars['String']['output']>;
  packaging_type_package_unit?: Maybe<Scalars['String']['output']>;
  preservatives?: Maybe<Array<Scalars['String']['output']>>;
  purchase_price?: Maybe<Scalars['bigint']['output']>;
  recommended_price?: Maybe<Scalars['bigint']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Int']['output']>;
  stabilizers?: Maybe<Array<Scalars['String']['output']>>;
  storage_box_capacity?: Maybe<Scalars['Int']['output']>;
  total_mhd?: Maybe<Scalars['Int']['output']>;
  vat_category_id?: Maybe<Scalars['uuid']['output']>;
  wholesale_price?: Maybe<Scalars['bigint']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Max_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: InputMaybe<Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_number?: InputMaybe<Order_By>;
  bio_control_number?: InputMaybe<Order_By>;
  co_id?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  designation_according_to_lmiv?: InputMaybe<Order_By>;
  dyes_coloring?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  eu_approval_number?: InputMaybe<Order_By>;
  flavor_enhancer?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gln?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  gtin_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ingredient_list?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  may_contain_traces_of?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  other_additives?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
  packaging_type_package_unit?: InputMaybe<Order_By>;
  preservatives?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  stabilizers?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  vat_category_id?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Article_Details_Min_Fields = {
  __typename?: 'eatfresh_article_details_min_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: Maybe<Scalars['String']['output']>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_number?: Maybe<Scalars['String']['output']>;
  bio_control_number?: Maybe<Scalars['String']['output']>;
  co_id?: Maybe<Scalars['String']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['bigint']['output']>;
  deposit_value_single_item?: Maybe<Scalars['bigint']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  designation_according_to_lmiv?: Maybe<Scalars['String']['output']>;
  dyes_coloring?: Maybe<Array<Scalars['String']['output']>>;
  ean?: Maybe<Scalars['String']['output']>;
  eu_approval_number?: Maybe<Scalars['String']['output']>;
  flavor_enhancer?: Maybe<Array<Scalars['String']['output']>>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gln?: Maybe<Scalars['String']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  gtin_package_unit?: Maybe<Scalars['String']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ingredient_list?: Maybe<Scalars['String']['output']>;
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  max_storage_temperature?: Maybe<Scalars['Int']['output']>;
  may_contain_traces_of?: Maybe<Array<Scalars['String']['output']>>;
  min_storage_temperature?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  origin_country?: Maybe<Scalars['String']['output']>;
  other_additives?: Maybe<Array<Scalars['String']['output']>>;
  packaging_type?: Maybe<Scalars['String']['output']>;
  packaging_type_package_unit?: Maybe<Scalars['String']['output']>;
  preservatives?: Maybe<Array<Scalars['String']['output']>>;
  purchase_price?: Maybe<Scalars['bigint']['output']>;
  recommended_price?: Maybe<Scalars['bigint']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Int']['output']>;
  stabilizers?: Maybe<Array<Scalars['String']['output']>>;
  storage_box_capacity?: Maybe<Scalars['Int']['output']>;
  total_mhd?: Maybe<Scalars['Int']['output']>;
  vat_category_id?: Maybe<Scalars['uuid']['output']>;
  wholesale_price?: Maybe<Scalars['bigint']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Min_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: InputMaybe<Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_number?: InputMaybe<Order_By>;
  bio_control_number?: InputMaybe<Order_By>;
  co_id?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  designation_according_to_lmiv?: InputMaybe<Order_By>;
  dyes_coloring?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  eu_approval_number?: InputMaybe<Order_By>;
  flavor_enhancer?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gln?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  gtin_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ingredient_list?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  may_contain_traces_of?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  other_additives?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
  packaging_type_package_unit?: InputMaybe<Order_By>;
  preservatives?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  stabilizers?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  vat_category_id?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Mutation_Response = {
  __typename?: 'eatfresh_article_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Article_Details>;
};

/** input type for inserting object relation for remote table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Obj_Rel_Insert_Input = {
  data: Eatfresh_Article_Details_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Article_Details_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.article_details" */
export type Eatfresh_Article_Details_On_Conflict = {
  constraint: Eatfresh_Article_Details_Constraint;
  update_columns?: Array<Eatfresh_Article_Details_Update_Column>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.article_details". */
export type Eatfresh_Article_Details_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_category?: InputMaybe<Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_number?: InputMaybe<Order_By>;
  bio_control_number?: InputMaybe<Order_By>;
  co_id?: InputMaybe<Order_By>;
  contains_crustaceans?: InputMaybe<Order_By>;
  contains_eggs?: InputMaybe<Order_By>;
  contains_fish?: InputMaybe<Order_By>;
  contains_gluten?: InputMaybe<Order_By>;
  contains_lactose?: InputMaybe<Order_By>;
  contains_milk?: InputMaybe<Order_By>;
  contains_peanuts?: InputMaybe<Order_By>;
  contains_soy?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  designation_according_to_lmiv?: InputMaybe<Order_By>;
  dyes_coloring?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  eu_approval_number?: InputMaybe<Order_By>;
  flavor_enhancer?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gln?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  gtin_package_unit?: InputMaybe<Order_By>;
  halal?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifs_broker_certified?: InputMaybe<Order_By>;
  ingredient_list?: InputMaybe<Order_By>;
  is_deposit_required?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  kosher?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  may_contain_traces_of?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  nutrition_information?: InputMaybe<Eatfresh_Nutrition_Information_Order_By>;
  origin_country?: InputMaybe<Order_By>;
  other_additives?: InputMaybe<Order_By>;
  packagingTypeByPackagingType?: InputMaybe<Eatfresh_Packaging_Type_Order_By>;
  packaging_confirmed?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
  packaging_type_package_unit?: InputMaybe<Order_By>;
  preservatives?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  regional?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  returnable?: InputMaybe<Order_By>;
  stabilizers?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  vat_category?: InputMaybe<Eatfresh_Vat_Category_Order_By>;
  vat_category_id?: InputMaybe<Order_By>;
  vegan?: InputMaybe<Order_By>;
  vegetarian?: InputMaybe<Order_By>;
  vitamin_minerals_aggregate?: InputMaybe<Eatfresh_Vitamin_Mineral_Aggregate_Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.article_details */
export type Eatfresh_Article_Details_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.article_details" */
export enum Eatfresh_Article_Details_Select_Column {
  /** column name */
  AlcoholContent = 'alcohol_content',
  /** column name */
  ArticleCategory = 'article_category',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  ArticleNumber = 'article_number',
  /** column name */
  BioControlNumber = 'bio_control_number',
  /** column name */
  CoId = 'co_id',
  /** column name */
  ContainsCrustaceans = 'contains_crustaceans',
  /** column name */
  ContainsEggs = 'contains_eggs',
  /** column name */
  ContainsFish = 'contains_fish',
  /** column name */
  ContainsGluten = 'contains_gluten',
  /** column name */
  ContainsLactose = 'contains_lactose',
  /** column name */
  ContainsMilk = 'contains_milk',
  /** column name */
  ContainsPeanuts = 'contains_peanuts',
  /** column name */
  ContainsSoy = 'contains_soy',
  /** column name */
  DepositValuePackageUnit = 'deposit_value_package_unit',
  /** column name */
  DepositValueSingleItem = 'deposit_value_single_item',
  /** column name */
  DepthPackageUnit = 'depth_package_unit',
  /** column name */
  DepthSingleItem = 'depth_single_item',
  /** column name */
  DesignationAccordingToLmiv = 'designation_according_to_lmiv',
  /** column name */
  DyesColoring = 'dyes_coloring',
  /** column name */
  Ean = 'ean',
  /** column name */
  EuApprovalNumber = 'eu_approval_number',
  /** column name */
  FlavorEnhancer = 'flavor_enhancer',
  /** column name */
  FruitContentPercentage = 'fruit_content_percentage',
  /** column name */
  Gln = 'gln',
  /** column name */
  GrossWeightSingleItem = 'gross_weight_single_item',
  /** column name */
  GrossWeigthPackageUnit = 'gross_weigth_package_unit',
  /** column name */
  GtinPackageUnit = 'gtin_package_unit',
  /** column name */
  Halal = 'halal',
  /** column name */
  HeightPackageUnit = 'height_package_unit',
  /** column name */
  HeightSingleItem = 'height_single_item',
  /** column name */
  Id = 'id',
  /** column name */
  IfsBrokerCertified = 'ifs_broker_certified',
  /** column name */
  IngredientList = 'ingredient_list',
  /** column name */
  IsDepositRequired = 'is_deposit_required',
  /** column name */
  ItemsPerPackageUnit = 'items_per_package_unit',
  /** column name */
  Kosher = 'kosher',
  /** column name */
  MaxStorageTemperature = 'max_storage_temperature',
  /** column name */
  MayContainTracesOf = 'may_contain_traces_of',
  /** column name */
  MinStorageTemperature = 'min_storage_temperature',
  /** column name */
  Name = 'name',
  /** column name */
  NetFillVolume = 'net_fill_volume',
  /** column name */
  NetWeight = 'net_weight',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OtherAdditives = 'other_additives',
  /** column name */
  PackagingConfirmed = 'packaging_confirmed',
  /** column name */
  PackagingType = 'packaging_type',
  /** column name */
  PackagingTypePackageUnit = 'packaging_type_package_unit',
  /** column name */
  Preservatives = 'preservatives',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  RecommendedPrice = 'recommended_price',
  /** column name */
  Regional = 'regional',
  /** column name */
  RemainingShelfLife = 'remaining_shelf_life',
  /** column name */
  Returnable = 'returnable',
  /** column name */
  Stabilizers = 'stabilizers',
  /** column name */
  StorageBoxCapacity = 'storage_box_capacity',
  /** column name */
  TotalMhd = 'total_mhd',
  /** column name */
  VatCategoryId = 'vat_category_id',
  /** column name */
  Vegan = 'vegan',
  /** column name */
  Vegetarian = 'vegetarian',
  /** column name */
  WholesalePrice = 'wholesale_price',
  /** column name */
  WidthPackageUnit = 'width_package_unit',
  /** column name */
  WidthSingleItem = 'width_single_item'
}

/** select "eatfresh_article_details_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.article_details" */
export enum Eatfresh_Article_Details_Select_Column_Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ContainsCrustaceans = 'contains_crustaceans',
  /** column name */
  ContainsEggs = 'contains_eggs',
  /** column name */
  ContainsFish = 'contains_fish',
  /** column name */
  ContainsGluten = 'contains_gluten',
  /** column name */
  ContainsLactose = 'contains_lactose',
  /** column name */
  ContainsMilk = 'contains_milk',
  /** column name */
  ContainsPeanuts = 'contains_peanuts',
  /** column name */
  ContainsSoy = 'contains_soy',
  /** column name */
  Halal = 'halal',
  /** column name */
  IfsBrokerCertified = 'ifs_broker_certified',
  /** column name */
  IsDepositRequired = 'is_deposit_required',
  /** column name */
  Kosher = 'kosher',
  /** column name */
  PackagingConfirmed = 'packaging_confirmed',
  /** column name */
  Regional = 'regional',
  /** column name */
  Returnable = 'returnable',
  /** column name */
  Vegan = 'vegan',
  /** column name */
  Vegetarian = 'vegetarian'
}

/** select "eatfresh_article_details_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.article_details" */
export enum Eatfresh_Article_Details_Select_Column_Eatfresh_Article_Details_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ContainsCrustaceans = 'contains_crustaceans',
  /** column name */
  ContainsEggs = 'contains_eggs',
  /** column name */
  ContainsFish = 'contains_fish',
  /** column name */
  ContainsGluten = 'contains_gluten',
  /** column name */
  ContainsLactose = 'contains_lactose',
  /** column name */
  ContainsMilk = 'contains_milk',
  /** column name */
  ContainsPeanuts = 'contains_peanuts',
  /** column name */
  ContainsSoy = 'contains_soy',
  /** column name */
  Halal = 'halal',
  /** column name */
  IfsBrokerCertified = 'ifs_broker_certified',
  /** column name */
  IsDepositRequired = 'is_deposit_required',
  /** column name */
  Kosher = 'kosher',
  /** column name */
  PackagingConfirmed = 'packaging_confirmed',
  /** column name */
  Regional = 'regional',
  /** column name */
  Returnable = 'returnable',
  /** column name */
  Vegan = 'vegan',
  /** column name */
  Vegetarian = 'vegetarian'
}

/** input type for updating data in table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Set_Input = {
  alcohol_content?: InputMaybe<Scalars['Float']['input']>;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: InputMaybe<Scalars['String']['input']>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_number?: InputMaybe<Scalars['String']['input']>;
  bio_control_number?: InputMaybe<Scalars['String']['input']>;
  co_id?: InputMaybe<Scalars['String']['input']>;
  contains_crustaceans?: InputMaybe<Scalars['Boolean']['input']>;
  contains_eggs?: InputMaybe<Scalars['Boolean']['input']>;
  contains_fish?: InputMaybe<Scalars['Boolean']['input']>;
  contains_gluten?: InputMaybe<Scalars['Boolean']['input']>;
  contains_lactose?: InputMaybe<Scalars['Boolean']['input']>;
  contains_milk?: InputMaybe<Scalars['Boolean']['input']>;
  contains_peanuts?: InputMaybe<Scalars['Boolean']['input']>;
  contains_soy?: InputMaybe<Scalars['Boolean']['input']>;
  deposit_value_package_unit?: InputMaybe<Scalars['bigint']['input']>;
  deposit_value_single_item?: InputMaybe<Scalars['bigint']['input']>;
  depth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  depth_single_item?: InputMaybe<Scalars['Float']['input']>;
  designation_according_to_lmiv?: InputMaybe<Scalars['String']['input']>;
  dyes_coloring?: InputMaybe<Array<Scalars['String']['input']>>;
  ean?: InputMaybe<Scalars['String']['input']>;
  eu_approval_number?: InputMaybe<Scalars['String']['input']>;
  flavor_enhancer?: InputMaybe<Array<Scalars['String']['input']>>;
  fruit_content_percentage?: InputMaybe<Scalars['Float']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  gross_weight_single_item?: InputMaybe<Scalars['Float']['input']>;
  gross_weigth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  gtin_package_unit?: InputMaybe<Scalars['String']['input']>;
  halal?: InputMaybe<Scalars['Boolean']['input']>;
  height_package_unit?: InputMaybe<Scalars['Float']['input']>;
  height_single_item?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ifs_broker_certified?: InputMaybe<Scalars['Boolean']['input']>;
  ingredient_list?: InputMaybe<Scalars['String']['input']>;
  is_deposit_required?: InputMaybe<Scalars['Boolean']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  max_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  may_contain_traces_of?: InputMaybe<Array<Scalars['String']['input']>>;
  min_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  net_fill_volume?: InputMaybe<Scalars['Float']['input']>;
  net_weight?: InputMaybe<Scalars['Float']['input']>;
  origin_country?: InputMaybe<Scalars['String']['input']>;
  other_additives?: InputMaybe<Array<Scalars['String']['input']>>;
  packaging_confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  packaging_type?: InputMaybe<Scalars['String']['input']>;
  packaging_type_package_unit?: InputMaybe<Scalars['String']['input']>;
  preservatives?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_price?: InputMaybe<Scalars['bigint']['input']>;
  recommended_price?: InputMaybe<Scalars['bigint']['input']>;
  regional?: InputMaybe<Scalars['Boolean']['input']>;
  remaining_shelf_life?: InputMaybe<Scalars['Int']['input']>;
  returnable?: InputMaybe<Scalars['Boolean']['input']>;
  stabilizers?: InputMaybe<Array<Scalars['String']['input']>>;
  storage_box_capacity?: InputMaybe<Scalars['Int']['input']>;
  total_mhd?: InputMaybe<Scalars['Int']['input']>;
  vat_category_id?: InputMaybe<Scalars['uuid']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  wholesale_price?: InputMaybe<Scalars['bigint']['input']>;
  width_package_unit?: InputMaybe<Scalars['Float']['input']>;
  width_single_item?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Article_Details_Stddev_Fields = {
  __typename?: 'eatfresh_article_details_stddev_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['Float']['output']>;
  deposit_value_single_item?: Maybe<Scalars['Float']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  max_storage_temperature?: Maybe<Scalars['Float']['output']>;
  min_storage_temperature?: Maybe<Scalars['Float']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  recommended_price?: Maybe<Scalars['Float']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Float']['output']>;
  storage_box_capacity?: Maybe<Scalars['Float']['output']>;
  total_mhd?: Maybe<Scalars['Float']['output']>;
  wholesale_price?: Maybe<Scalars['Float']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Stddev_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Article_Details_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_article_details_stddev_pop_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['Float']['output']>;
  deposit_value_single_item?: Maybe<Scalars['Float']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  max_storage_temperature?: Maybe<Scalars['Float']['output']>;
  min_storage_temperature?: Maybe<Scalars['Float']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  recommended_price?: Maybe<Scalars['Float']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Float']['output']>;
  storage_box_capacity?: Maybe<Scalars['Float']['output']>;
  total_mhd?: Maybe<Scalars['Float']['output']>;
  wholesale_price?: Maybe<Scalars['Float']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Stddev_Pop_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Article_Details_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_article_details_stddev_samp_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['Float']['output']>;
  deposit_value_single_item?: Maybe<Scalars['Float']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  max_storage_temperature?: Maybe<Scalars['Float']['output']>;
  min_storage_temperature?: Maybe<Scalars['Float']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  recommended_price?: Maybe<Scalars['Float']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Float']['output']>;
  storage_box_capacity?: Maybe<Scalars['Float']['output']>;
  total_mhd?: Maybe<Scalars['Float']['output']>;
  wholesale_price?: Maybe<Scalars['Float']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Stddev_Samp_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_article_details" */
export type Eatfresh_Article_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Article_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Article_Details_Stream_Cursor_Value_Input = {
  alcohol_content?: InputMaybe<Scalars['Float']['input']>;
  /** Product category from supplier (e.g., Sortiment) */
  article_category?: InputMaybe<Scalars['String']['input']>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_number?: InputMaybe<Scalars['String']['input']>;
  bio_control_number?: InputMaybe<Scalars['String']['input']>;
  co_id?: InputMaybe<Scalars['String']['input']>;
  contains_crustaceans?: InputMaybe<Scalars['Boolean']['input']>;
  contains_eggs?: InputMaybe<Scalars['Boolean']['input']>;
  contains_fish?: InputMaybe<Scalars['Boolean']['input']>;
  contains_gluten?: InputMaybe<Scalars['Boolean']['input']>;
  contains_lactose?: InputMaybe<Scalars['Boolean']['input']>;
  contains_milk?: InputMaybe<Scalars['Boolean']['input']>;
  contains_peanuts?: InputMaybe<Scalars['Boolean']['input']>;
  contains_soy?: InputMaybe<Scalars['Boolean']['input']>;
  deposit_value_package_unit?: InputMaybe<Scalars['bigint']['input']>;
  deposit_value_single_item?: InputMaybe<Scalars['bigint']['input']>;
  depth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  depth_single_item?: InputMaybe<Scalars['Float']['input']>;
  designation_according_to_lmiv?: InputMaybe<Scalars['String']['input']>;
  dyes_coloring?: InputMaybe<Array<Scalars['String']['input']>>;
  ean?: InputMaybe<Scalars['String']['input']>;
  eu_approval_number?: InputMaybe<Scalars['String']['input']>;
  flavor_enhancer?: InputMaybe<Array<Scalars['String']['input']>>;
  fruit_content_percentage?: InputMaybe<Scalars['Float']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  gross_weight_single_item?: InputMaybe<Scalars['Float']['input']>;
  gross_weigth_package_unit?: InputMaybe<Scalars['Float']['input']>;
  gtin_package_unit?: InputMaybe<Scalars['String']['input']>;
  halal?: InputMaybe<Scalars['Boolean']['input']>;
  height_package_unit?: InputMaybe<Scalars['Float']['input']>;
  height_single_item?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ifs_broker_certified?: InputMaybe<Scalars['Boolean']['input']>;
  ingredient_list?: InputMaybe<Scalars['String']['input']>;
  is_deposit_required?: InputMaybe<Scalars['Boolean']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  max_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  may_contain_traces_of?: InputMaybe<Array<Scalars['String']['input']>>;
  min_storage_temperature?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  net_fill_volume?: InputMaybe<Scalars['Float']['input']>;
  net_weight?: InputMaybe<Scalars['Float']['input']>;
  origin_country?: InputMaybe<Scalars['String']['input']>;
  other_additives?: InputMaybe<Array<Scalars['String']['input']>>;
  packaging_confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  packaging_type?: InputMaybe<Scalars['String']['input']>;
  packaging_type_package_unit?: InputMaybe<Scalars['String']['input']>;
  preservatives?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_price?: InputMaybe<Scalars['bigint']['input']>;
  recommended_price?: InputMaybe<Scalars['bigint']['input']>;
  regional?: InputMaybe<Scalars['Boolean']['input']>;
  remaining_shelf_life?: InputMaybe<Scalars['Int']['input']>;
  returnable?: InputMaybe<Scalars['Boolean']['input']>;
  stabilizers?: InputMaybe<Array<Scalars['String']['input']>>;
  storage_box_capacity?: InputMaybe<Scalars['Int']['input']>;
  total_mhd?: InputMaybe<Scalars['Int']['input']>;
  vat_category_id?: InputMaybe<Scalars['uuid']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  wholesale_price?: InputMaybe<Scalars['bigint']['input']>;
  width_package_unit?: InputMaybe<Scalars['Float']['input']>;
  width_single_item?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Article_Details_Sum_Fields = {
  __typename?: 'eatfresh_article_details_sum_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['bigint']['output']>;
  deposit_value_single_item?: Maybe<Scalars['bigint']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  max_storage_temperature?: Maybe<Scalars['Int']['output']>;
  min_storage_temperature?: Maybe<Scalars['Int']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['bigint']['output']>;
  recommended_price?: Maybe<Scalars['bigint']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Int']['output']>;
  storage_box_capacity?: Maybe<Scalars['Int']['output']>;
  total_mhd?: Maybe<Scalars['Int']['output']>;
  wholesale_price?: Maybe<Scalars['bigint']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Sum_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.article_details" */
export enum Eatfresh_Article_Details_Update_Column {
  /** column name */
  AlcoholContent = 'alcohol_content',
  /** column name */
  ArticleCategory = 'article_category',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  ArticleNumber = 'article_number',
  /** column name */
  BioControlNumber = 'bio_control_number',
  /** column name */
  CoId = 'co_id',
  /** column name */
  ContainsCrustaceans = 'contains_crustaceans',
  /** column name */
  ContainsEggs = 'contains_eggs',
  /** column name */
  ContainsFish = 'contains_fish',
  /** column name */
  ContainsGluten = 'contains_gluten',
  /** column name */
  ContainsLactose = 'contains_lactose',
  /** column name */
  ContainsMilk = 'contains_milk',
  /** column name */
  ContainsPeanuts = 'contains_peanuts',
  /** column name */
  ContainsSoy = 'contains_soy',
  /** column name */
  DepositValuePackageUnit = 'deposit_value_package_unit',
  /** column name */
  DepositValueSingleItem = 'deposit_value_single_item',
  /** column name */
  DepthPackageUnit = 'depth_package_unit',
  /** column name */
  DepthSingleItem = 'depth_single_item',
  /** column name */
  DesignationAccordingToLmiv = 'designation_according_to_lmiv',
  /** column name */
  DyesColoring = 'dyes_coloring',
  /** column name */
  Ean = 'ean',
  /** column name */
  EuApprovalNumber = 'eu_approval_number',
  /** column name */
  FlavorEnhancer = 'flavor_enhancer',
  /** column name */
  FruitContentPercentage = 'fruit_content_percentage',
  /** column name */
  Gln = 'gln',
  /** column name */
  GrossWeightSingleItem = 'gross_weight_single_item',
  /** column name */
  GrossWeigthPackageUnit = 'gross_weigth_package_unit',
  /** column name */
  GtinPackageUnit = 'gtin_package_unit',
  /** column name */
  Halal = 'halal',
  /** column name */
  HeightPackageUnit = 'height_package_unit',
  /** column name */
  HeightSingleItem = 'height_single_item',
  /** column name */
  Id = 'id',
  /** column name */
  IfsBrokerCertified = 'ifs_broker_certified',
  /** column name */
  IngredientList = 'ingredient_list',
  /** column name */
  IsDepositRequired = 'is_deposit_required',
  /** column name */
  ItemsPerPackageUnit = 'items_per_package_unit',
  /** column name */
  Kosher = 'kosher',
  /** column name */
  MaxStorageTemperature = 'max_storage_temperature',
  /** column name */
  MayContainTracesOf = 'may_contain_traces_of',
  /** column name */
  MinStorageTemperature = 'min_storage_temperature',
  /** column name */
  Name = 'name',
  /** column name */
  NetFillVolume = 'net_fill_volume',
  /** column name */
  NetWeight = 'net_weight',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OtherAdditives = 'other_additives',
  /** column name */
  PackagingConfirmed = 'packaging_confirmed',
  /** column name */
  PackagingType = 'packaging_type',
  /** column name */
  PackagingTypePackageUnit = 'packaging_type_package_unit',
  /** column name */
  Preservatives = 'preservatives',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  RecommendedPrice = 'recommended_price',
  /** column name */
  Regional = 'regional',
  /** column name */
  RemainingShelfLife = 'remaining_shelf_life',
  /** column name */
  Returnable = 'returnable',
  /** column name */
  Stabilizers = 'stabilizers',
  /** column name */
  StorageBoxCapacity = 'storage_box_capacity',
  /** column name */
  TotalMhd = 'total_mhd',
  /** column name */
  VatCategoryId = 'vat_category_id',
  /** column name */
  Vegan = 'vegan',
  /** column name */
  Vegetarian = 'vegetarian',
  /** column name */
  WholesalePrice = 'wholesale_price',
  /** column name */
  WidthPackageUnit = 'width_package_unit',
  /** column name */
  WidthSingleItem = 'width_single_item'
}

export type Eatfresh_Article_Details_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Article_Details_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Article_Details_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Article_Details_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Article_Details_Var_Pop_Fields = {
  __typename?: 'eatfresh_article_details_var_pop_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['Float']['output']>;
  deposit_value_single_item?: Maybe<Scalars['Float']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  max_storage_temperature?: Maybe<Scalars['Float']['output']>;
  min_storage_temperature?: Maybe<Scalars['Float']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  recommended_price?: Maybe<Scalars['Float']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Float']['output']>;
  storage_box_capacity?: Maybe<Scalars['Float']['output']>;
  total_mhd?: Maybe<Scalars['Float']['output']>;
  wholesale_price?: Maybe<Scalars['Float']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Var_Pop_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Article_Details_Var_Samp_Fields = {
  __typename?: 'eatfresh_article_details_var_samp_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['Float']['output']>;
  deposit_value_single_item?: Maybe<Scalars['Float']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  max_storage_temperature?: Maybe<Scalars['Float']['output']>;
  min_storage_temperature?: Maybe<Scalars['Float']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  recommended_price?: Maybe<Scalars['Float']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Float']['output']>;
  storage_box_capacity?: Maybe<Scalars['Float']['output']>;
  total_mhd?: Maybe<Scalars['Float']['output']>;
  wholesale_price?: Maybe<Scalars['Float']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Var_Samp_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Article_Details_Variance_Fields = {
  __typename?: 'eatfresh_article_details_variance_fields';
  alcohol_content?: Maybe<Scalars['Float']['output']>;
  deposit_value_package_unit?: Maybe<Scalars['Float']['output']>;
  deposit_value_single_item?: Maybe<Scalars['Float']['output']>;
  depth_package_unit?: Maybe<Scalars['Float']['output']>;
  depth_single_item?: Maybe<Scalars['Float']['output']>;
  fruit_content_percentage?: Maybe<Scalars['Float']['output']>;
  gross_weight_single_item?: Maybe<Scalars['Float']['output']>;
  gross_weigth_package_unit?: Maybe<Scalars['Float']['output']>;
  height_package_unit?: Maybe<Scalars['Float']['output']>;
  height_single_item?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  max_storage_temperature?: Maybe<Scalars['Float']['output']>;
  min_storage_temperature?: Maybe<Scalars['Float']['output']>;
  net_fill_volume?: Maybe<Scalars['Float']['output']>;
  net_weight?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  recommended_price?: Maybe<Scalars['Float']['output']>;
  remaining_shelf_life?: Maybe<Scalars['Float']['output']>;
  storage_box_capacity?: Maybe<Scalars['Float']['output']>;
  total_mhd?: Maybe<Scalars['Float']['output']>;
  wholesale_price?: Maybe<Scalars['Float']['output']>;
  width_package_unit?: Maybe<Scalars['Float']['output']>;
  width_single_item?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.article_details" */
export type Eatfresh_Article_Details_Variance_Order_By = {
  alcohol_content?: InputMaybe<Order_By>;
  deposit_value_package_unit?: InputMaybe<Order_By>;
  deposit_value_single_item?: InputMaybe<Order_By>;
  depth_package_unit?: InputMaybe<Order_By>;
  depth_single_item?: InputMaybe<Order_By>;
  fruit_content_percentage?: InputMaybe<Order_By>;
  gross_weight_single_item?: InputMaybe<Order_By>;
  gross_weigth_package_unit?: InputMaybe<Order_By>;
  height_package_unit?: InputMaybe<Order_By>;
  height_single_item?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  max_storage_temperature?: InputMaybe<Order_By>;
  min_storage_temperature?: InputMaybe<Order_By>;
  net_fill_volume?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  recommended_price?: InputMaybe<Order_By>;
  remaining_shelf_life?: InputMaybe<Order_By>;
  storage_box_capacity?: InputMaybe<Order_By>;
  total_mhd?: InputMaybe<Order_By>;
  wholesale_price?: InputMaybe<Order_By>;
  width_package_unit?: InputMaybe<Order_By>;
  width_single_item?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "eatfresh.article" */
export type Eatfresh_Article_Inc_Input = {
  margin_euros?: InputMaybe<Scalars['Int']['input']>;
  margin_percentage?: InputMaybe<Scalars['Int']['input']>;
  retail_confirmed_at_purchase_price?: InputMaybe<Scalars['Int']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.article" */
export type Eatfresh_Article_Insert_Input = {
  active_for_retail?: InputMaybe<Scalars['Boolean']['input']>;
  active_for_wholesale?: InputMaybe<Scalars['Boolean']['input']>;
  article_detail?: InputMaybe<Eatfresh_Article_Details_Obj_Rel_Insert_Input>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Arr_Rel_Insert_Input>;
  box_content_to_articles?: InputMaybe<Eatfresh_Box_Content_To_Article_Arr_Rel_Insert_Input>;
  commissioning_process_positions?: InputMaybe<Eatfresh_Commissioning_Process_Position_Arr_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  fridge_layout_level_positions?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Arr_Rel_Insert_Input>;
  fridge_target_stock_positions?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Arr_Rel_Insert_Input>;
  has_task?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  margin_euros?: InputMaybe<Scalars['Int']['input']>;
  margin_percentage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price_changes?: InputMaybe<Eatfresh_Price_Change_Arr_Rel_Insert_Input>;
  price_locks?: InputMaybe<Eatfresh_Price_Lock_Arr_Rel_Insert_Input>;
  product_image_id?: InputMaybe<Scalars['uuid']['input']>;
  retail_confirmed_at_purchase_price?: InputMaybe<Scalars['Int']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Obj_Rel_Insert_Input>;
  warehouse_order_positions?: InputMaybe<Eatfresh_Warehouse_Order_Position_Arr_Rel_Insert_Input>;
  warehouse_order_receipt_positions?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process = {
  __typename?: 'eatfresh_article_labeling_process';
  /** An object relationship */
  article: Eatfresh_Article;
  article_id: Scalars['uuid']['output'];
  /** An object relationship */
  article_labeling_process_status: Eatfresh_Article_Labeling_Process_Status;
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  best_before_date: Scalars['timestamp']['output'];
  /** An array relationship */
  box_content_plans: Array<Eatfresh_Box_Content_Plan>;
  /** An aggregate relationship */
  box_content_plans_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  cost: Scalars['Int']['output'];
  created_at: Scalars['timestamp']['output'];
  expected_number_of_items: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  logistics_problems: Array<Eatfresh_Logistics_Problem>;
  /** An aggregate relationship */
  logistics_problems_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  receipt_position_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  rfidAssetsByLastLabelingId: Array<Eatfresh_Rfid_Asset>;
  /** An aggregate relationship */
  rfidAssetsByLastLabelingId_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  /** An array relationship */
  rfid_assets: Array<Eatfresh_Rfid_Asset>;
  /** An aggregate relationship */
  rfid_assets_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  /** An array relationship */
  rfid_boxes: Array<Eatfresh_Rfid_Box>;
  /** An aggregate relationship */
  rfid_boxes_aggregate: Eatfresh_Rfid_Box_Aggregate;
  /** An object relationship */
  rfid_scanner?: Maybe<Eatfresh_Rfid_Scanner>;
  /** An array relationship */
  rfid_scans: Array<Eatfresh_Rfid_Scan>;
  /** An aggregate relationship */
  rfid_scans_aggregate: Eatfresh_Rfid_Scan_Aggregate;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  scanner_id?: Maybe<Scalars['uuid']['output']>;
  status: Eatfresh_Article_Labeling_Process_Status_Enum;
  /** An array relationship */
  to_label_assets: Array<Eatfresh_Rfid_Asset>;
  /** An aggregate relationship */
  to_label_assets_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  warehouse_order_receipt_position?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessBox_Content_PlansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessBox_Content_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessLogistics_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessLogistics_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfidAssetsByLastLabelingIdArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfidAssetsByLastLabelingId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_BoxesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_Boxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_ScansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_Scans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessTo_Label_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_ProcessTo_Label_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};

/** aggregated selection of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Aggregate = {
  __typename?: 'eatfresh_article_labeling_process_aggregate';
  aggregate?: Maybe<Eatfresh_Article_Labeling_Process_Aggregate_Fields>;
  nodes: Array<Eatfresh_Article_Labeling_Process>;
};

export type Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Aggregate_Fields = {
  __typename?: 'eatfresh_article_labeling_process_aggregate_fields';
  avg?: Maybe<Eatfresh_Article_Labeling_Process_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Article_Labeling_Process_Max_Fields>;
  min?: Maybe<Eatfresh_Article_Labeling_Process_Min_Fields>;
  stddev?: Maybe<Eatfresh_Article_Labeling_Process_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Article_Labeling_Process_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Article_Labeling_Process_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Article_Labeling_Process_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Article_Labeling_Process_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Article_Labeling_Process_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Article_Labeling_Process_Variance_Fields>;
};


/** aggregate fields of "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Article_Labeling_Process_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Article_Labeling_Process_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Article_Labeling_Process_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Article_Labeling_Process_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Article_Labeling_Process_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Article_Labeling_Process_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Article_Labeling_Process_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Article_Labeling_Process_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Article_Labeling_Process_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Article_Labeling_Process_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Article_Labeling_Process_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Article_Labeling_Process_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Article_Labeling_Process_Avg_Fields = {
  __typename?: 'eatfresh_article_labeling_process_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  expected_number_of_items?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.article_labeling_process". All fields are combined with a logical 'AND'. */
export type Eatfresh_Article_Labeling_Process_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  article_labeling_process_status?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  best_before_date?: InputMaybe<Timestamp_Comparison_Exp>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expected_number_of_items?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp>;
  receipt_position_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfidAssetsByLastLabelingId?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfidAssetsByLastLabelingId_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  scanner_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Enum_Comparison_Exp>;
  to_label_assets?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  to_label_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse_order_receipt_position?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.article_labeling_process" */
export enum Eatfresh_Article_Labeling_Process_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArticleLabelingProcessPkey = 'article_labeling_process_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  expected_number_of_items?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_labeling_process_status?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Obj_Rel_Insert_Input>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  best_before_date?: InputMaybe<Scalars['timestamp']['input']>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Arr_Rel_Insert_Input>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expected_number_of_items?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input>;
  receipt_position_id?: InputMaybe<Scalars['uuid']['input']>;
  rfidAssetsByLastLabelingId?: InputMaybe<Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Arr_Rel_Insert_Input>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Obj_Rel_Insert_Input>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Arr_Rel_Insert_Input>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Enum>;
  to_label_assets?: InputMaybe<Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_position?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Article_Labeling_Process_Max_Fields = {
  __typename?: 'eatfresh_article_labeling_process_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  best_before_date?: Maybe<Scalars['timestamp']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expected_number_of_items?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  receipt_position_id?: Maybe<Scalars['uuid']['output']>;
  scanner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  receipt_position_id?: InputMaybe<Order_By>;
  scanner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Article_Labeling_Process_Min_Fields = {
  __typename?: 'eatfresh_article_labeling_process_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  best_before_date?: Maybe<Scalars['timestamp']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expected_number_of_items?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  receipt_position_id?: Maybe<Scalars['uuid']['output']>;
  scanner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  receipt_position_id?: InputMaybe<Order_By>;
  scanner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Mutation_Response = {
  __typename?: 'eatfresh_article_labeling_process_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Article_Labeling_Process>;
};

/** input type for inserting object relation for remote table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input = {
  data: Eatfresh_Article_Labeling_Process_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Article_Labeling_Process_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_On_Conflict = {
  constraint: Eatfresh_Article_Labeling_Process_Constraint;
  update_columns?: Array<Eatfresh_Article_Labeling_Process_Update_Column>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.article_labeling_process". */
export type Eatfresh_Article_Labeling_Process_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_labeling_process_status?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Order_By>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Order_By>;
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Order_By>;
  receipt_position_id?: InputMaybe<Order_By>;
  rfidAssetsByLastLabelingId_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Order_By>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Order_By>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Order_By>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Order_By>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  scanner_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  to_label_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_position?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>;
};

/** primary key columns input for table: eatfresh.article_labeling_process */
export type Eatfresh_Article_Labeling_Process_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.article_labeling_process" */
export enum Eatfresh_Article_Labeling_Process_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BestBeforeDate = 'best_before_date',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpectedNumberOfItems = 'expected_number_of_items',
  /** column name */
  Id = 'id',
  /** column name */
  ReceiptPositionId = 'receipt_position_id',
  /** column name */
  ScannerId = 'scanner_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  best_before_date?: InputMaybe<Scalars['timestamp']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expected_number_of_items?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  receipt_position_id?: InputMaybe<Scalars['uuid']['input']>;
  scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status = {
  __typename?: 'eatfresh_article_labeling_process_status';
  /** An array relationship */
  article_labeling_processes: Array<Eatfresh_Article_Labeling_Process>;
  /** An aggregate relationship */
  article_labeling_processes_aggregate: Eatfresh_Article_Labeling_Process_Aggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_StatusArticle_Labeling_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_StatusArticle_Labeling_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};

/** aggregated selection of "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Aggregate = {
  __typename?: 'eatfresh_article_labeling_process_status_aggregate';
  aggregate?: Maybe<Eatfresh_Article_Labeling_Process_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Article_Labeling_Process_Status>;
};

/** aggregate fields of "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_article_labeling_process_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Article_Labeling_Process_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Article_Labeling_Process_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.article_labeling_process_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Article_Labeling_Process_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.article_labeling_process_status" */
export enum Eatfresh_Article_Labeling_Process_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ArticleLabelingProcessStatusPkey = 'article_labeling_process_status_pkey'
}

export enum Eatfresh_Article_Labeling_Process_Status_Enum {
  /** Labeling process cancelled */
  Cancelled = 'CANCELLED',
  /** Labeling process error */
  Error = 'ERROR',
  /** Labeling process in progress */
  InProgress = 'IN_PROGRESS',
  /** Labeling process paused */
  Paused = 'PAUSED',
  /** Labeling process success */
  Success = 'SUCCESS'
}

/** Boolean expression to compare columns of type "eatfresh_article_labeling_process_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Article_Labeling_Process_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Insert_Input = {
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Article_Labeling_Process_Status_Max_Fields = {
  __typename?: 'eatfresh_article_labeling_process_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Article_Labeling_Process_Status_Min_Fields = {
  __typename?: 'eatfresh_article_labeling_process_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Mutation_Response = {
  __typename?: 'eatfresh_article_labeling_process_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Article_Labeling_Process_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Article_Labeling_Process_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_On_Conflict = {
  constraint: Eatfresh_Article_Labeling_Process_Status_Constraint;
  update_columns?: Array<Eatfresh_Article_Labeling_Process_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.article_labeling_process_status". */
export type Eatfresh_Article_Labeling_Process_Status_Order_By = {
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.article_labeling_process_status */
export type Eatfresh_Article_Labeling_Process_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.article_labeling_process_status" */
export enum Eatfresh_Article_Labeling_Process_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_article_labeling_process_status" */
export type Eatfresh_Article_Labeling_Process_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Article_Labeling_Process_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Article_Labeling_Process_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.article_labeling_process_status" */
export enum Eatfresh_Article_Labeling_Process_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Article_Labeling_Process_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Article_Labeling_Process_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Eatfresh_Article_Labeling_Process_Stddev_Fields = {
  __typename?: 'eatfresh_article_labeling_process_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  expected_number_of_items?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Article_Labeling_Process_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_article_labeling_process_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  expected_number_of_items?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Article_Labeling_Process_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_article_labeling_process_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  expected_number_of_items?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Article_Labeling_Process_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Article_Labeling_Process_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  best_before_date?: InputMaybe<Scalars['timestamp']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expected_number_of_items?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  receipt_position_id?: InputMaybe<Scalars['uuid']['input']>;
  scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Article_Labeling_Process_Sum_Fields = {
  __typename?: 'eatfresh_article_labeling_process_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  expected_number_of_items?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.article_labeling_process" */
export enum Eatfresh_Article_Labeling_Process_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BestBeforeDate = 'best_before_date',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpectedNumberOfItems = 'expected_number_of_items',
  /** column name */
  Id = 'id',
  /** column name */
  ReceiptPositionId = 'receipt_position_id',
  /** column name */
  ScannerId = 'scanner_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Article_Labeling_Process_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Article_Labeling_Process_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Article_Labeling_Process_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Article_Labeling_Process_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Article_Labeling_Process_Var_Pop_Fields = {
  __typename?: 'eatfresh_article_labeling_process_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  expected_number_of_items?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Article_Labeling_Process_Var_Samp_Fields = {
  __typename?: 'eatfresh_article_labeling_process_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  expected_number_of_items?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Article_Labeling_Process_Variance_Fields = {
  __typename?: 'eatfresh_article_labeling_process_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
  expected_number_of_items?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.article_labeling_process" */
export type Eatfresh_Article_Labeling_Process_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
  expected_number_of_items?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Eatfresh_Article_Max_Fields = {
  __typename?: 'eatfresh_article_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: Maybe<Scalars['String']['output']>;
  margin_euros?: Maybe<Scalars['Int']['output']>;
  margin_percentage?: Maybe<Scalars['Int']['output']>;
  markup_percentage?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_image_id?: Maybe<Scalars['uuid']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Int']['output']>;
  retail_price?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: InputMaybe<Order_By>;
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_image_id?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Article_Min_Fields = {
  __typename?: 'eatfresh_article_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: Maybe<Scalars['String']['output']>;
  margin_euros?: Maybe<Scalars['Int']['output']>;
  margin_percentage?: Maybe<Scalars['Int']['output']>;
  markup_percentage?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_image_id?: Maybe<Scalars['uuid']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Int']['output']>;
  retail_price?: Maybe<Scalars['Int']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: InputMaybe<Order_By>;
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_image_id?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.article" */
export type Eatfresh_Article_Mutation_Response = {
  __typename?: 'eatfresh_article_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Article>;
};

/** input type for inserting object relation for remote table "eatfresh.article" */
export type Eatfresh_Article_Obj_Rel_Insert_Input = {
  data: Eatfresh_Article_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Article_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.article" */
export type Eatfresh_Article_On_Conflict = {
  constraint: Eatfresh_Article_Constraint;
  update_columns?: Array<Eatfresh_Article_Update_Column>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.article". */
export type Eatfresh_Article_Order_By = {
  active_for_retail?: InputMaybe<Order_By>;
  active_for_wholesale?: InputMaybe<Order_By>;
  article_detail?: InputMaybe<Eatfresh_Article_Details_Order_By>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Order_By>;
  box_content_to_articles_aggregate?: InputMaybe<Eatfresh_Box_Content_To_Article_Aggregate_Order_By>;
  commissioning_process_positions_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Position_Aggregate_Order_By>;
  created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  fridge_layout_level_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Order_By>;
  fridge_target_stock_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Aggregate_Order_By>;
  has_task?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price_changes_aggregate?: InputMaybe<Eatfresh_Price_Change_Aggregate_Order_By>;
  price_locks_aggregate?: InputMaybe<Eatfresh_Price_Lock_Aggregate_Order_By>;
  product_image_id?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  supplier?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Order_By>;
  warehouse_order_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Position_Aggregate_Order_By>;
  warehouse_order_receipt_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.article */
export type Eatfresh_Article_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.article" */
export enum Eatfresh_Article_Select_Column {
  /** column name */
  ActiveForRetail = 'active_for_retail',
  /** column name */
  ActiveForWholesale = 'active_for_wholesale',
  /** column name */
  Created = 'created',
  /** column name */
  Description = 'description',
  /** column name */
  Ean = 'ean',
  /** column name */
  HasTask = 'has_task',
  /** column name */
  Id = 'id',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MarginEuros = 'margin_euros',
  /** column name */
  MarginPercentage = 'margin_percentage',
  /** column name */
  MarkupPercentage = 'markup_percentage',
  /** column name */
  Name = 'name',
  /** column name */
  ProductImageId = 'product_image_id',
  /** column name */
  RetailConfirmedAtPurchasePrice = 'retail_confirmed_at_purchase_price',
  /** column name */
  RetailPrice = 'retail_price',
  /** column name */
  Supplier = 'supplier',
  /** column name */
  Updated = 'updated'
}

/** select "eatfresh_article_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.article" */
export enum Eatfresh_Article_Select_Column_Eatfresh_Article_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActiveForRetail = 'active_for_retail',
  /** column name */
  ActiveForWholesale = 'active_for_wholesale',
  /** column name */
  HasTask = 'has_task'
}

/** select "eatfresh_article_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.article" */
export enum Eatfresh_Article_Select_Column_Eatfresh_Article_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActiveForRetail = 'active_for_retail',
  /** column name */
  ActiveForWholesale = 'active_for_wholesale',
  /** column name */
  HasTask = 'has_task'
}

/** input type for updating data in table "eatfresh.article" */
export type Eatfresh_Article_Set_Input = {
  active_for_retail?: InputMaybe<Scalars['Boolean']['input']>;
  active_for_wholesale?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  has_task?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  margin_euros?: InputMaybe<Scalars['Int']['input']>;
  margin_percentage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_image_id?: InputMaybe<Scalars['uuid']['input']>;
  retail_confirmed_at_purchase_price?: InputMaybe<Scalars['Int']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Article_Stddev_Fields = {
  __typename?: 'eatfresh_article_stddev_fields';
  margin_euros?: Maybe<Scalars['Float']['output']>;
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  markup_percentage?: Maybe<Scalars['Float']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Stddev_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Article_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_article_stddev_pop_fields';
  margin_euros?: Maybe<Scalars['Float']['output']>;
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  markup_percentage?: Maybe<Scalars['Float']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Stddev_Pop_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Article_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_article_stddev_samp_fields';
  margin_euros?: Maybe<Scalars['Float']['output']>;
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  markup_percentage?: Maybe<Scalars['Float']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Stddev_Samp_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_article" */
export type Eatfresh_Article_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Article_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Article_Stream_Cursor_Value_Input = {
  active_for_retail?: InputMaybe<Scalars['Boolean']['input']>;
  active_for_wholesale?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  has_task?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Product manufacturer (Hersteller), distinct from supplier (distributor) */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  margin_euros?: InputMaybe<Scalars['Int']['input']>;
  margin_percentage?: InputMaybe<Scalars['Int']['input']>;
  markup_percentage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_image_id?: InputMaybe<Scalars['uuid']['input']>;
  retail_confirmed_at_purchase_price?: InputMaybe<Scalars['Int']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Article_Sum_Fields = {
  __typename?: 'eatfresh_article_sum_fields';
  margin_euros?: Maybe<Scalars['Int']['output']>;
  margin_percentage?: Maybe<Scalars['Int']['output']>;
  markup_percentage?: Maybe<Scalars['Int']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Int']['output']>;
  retail_price?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Sum_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.article" */
export enum Eatfresh_Article_Update_Column {
  /** column name */
  ActiveForRetail = 'active_for_retail',
  /** column name */
  ActiveForWholesale = 'active_for_wholesale',
  /** column name */
  Created = 'created',
  /** column name */
  Description = 'description',
  /** column name */
  Ean = 'ean',
  /** column name */
  HasTask = 'has_task',
  /** column name */
  Id = 'id',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  MarginEuros = 'margin_euros',
  /** column name */
  MarginPercentage = 'margin_percentage',
  /** column name */
  Name = 'name',
  /** column name */
  ProductImageId = 'product_image_id',
  /** column name */
  RetailConfirmedAtPurchasePrice = 'retail_confirmed_at_purchase_price',
  /** column name */
  RetailPrice = 'retail_price',
  /** column name */
  Supplier = 'supplier',
  /** column name */
  Updated = 'updated'
}

export type Eatfresh_Article_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Article_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Article_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Article_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Article_Var_Pop_Fields = {
  __typename?: 'eatfresh_article_var_pop_fields';
  margin_euros?: Maybe<Scalars['Float']['output']>;
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  markup_percentage?: Maybe<Scalars['Float']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Var_Pop_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Article_Var_Samp_Fields = {
  __typename?: 'eatfresh_article_var_samp_fields';
  margin_euros?: Maybe<Scalars['Float']['output']>;
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  markup_percentage?: Maybe<Scalars['Float']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Var_Samp_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Article_Variance_Fields = {
  __typename?: 'eatfresh_article_variance_fields';
  margin_euros?: Maybe<Scalars['Float']['output']>;
  margin_percentage?: Maybe<Scalars['Float']['output']>;
  markup_percentage?: Maybe<Scalars['Float']['output']>;
  retail_confirmed_at_purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.article" */
export type Eatfresh_Article_Variance_Order_By = {
  margin_euros?: InputMaybe<Order_By>;
  margin_percentage?: InputMaybe<Order_By>;
  markup_percentage?: InputMaybe<Order_By>;
  retail_confirmed_at_purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement = {
  __typename?: 'eatfresh_asset_placement';
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fridge?: Maybe<Eatfresh_Fridge>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  pallet_spot?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  place?: Maybe<Eatfresh_Place>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  refill?: Maybe<Eatfresh_Refill>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfid_asset: Eatfresh_Rfid_Asset;
  rfid_asset_id: Scalars['uuid']['output'];
  /** An object relationship */
  rfid_box?: Maybe<Eatfresh_Rfid_Box>;
  rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfid_tag?: Maybe<Eatfresh_Rfid_Tag>;
  shelf_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  warehouse?: Maybe<Eatfresh_Warehouse>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  warehouse_shelf?: Maybe<Eatfresh_Warehouse_Shelf>;
};

/** aggregated selection of "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Aggregate = {
  __typename?: 'eatfresh_asset_placement_aggregate';
  aggregate?: Maybe<Eatfresh_Asset_Placement_Aggregate_Fields>;
  nodes: Array<Eatfresh_Asset_Placement>;
};

export type Eatfresh_Asset_Placement_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Asset_Placement_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Aggregate_Fields = {
  __typename?: 'eatfresh_asset_placement_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Asset_Placement_Max_Fields>;
  min?: Maybe<Eatfresh_Asset_Placement_Min_Fields>;
};


/** aggregate fields of "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Asset_Placement_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Asset_Placement_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Asset_Placement_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Asset_Placement_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.asset_placement". All fields are combined with a logical 'AND'. */
export type Eatfresh_Asset_Placement_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Asset_Placement_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Asset_Placement_Bool_Exp>>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
  pallet_spot_id?: InputMaybe<Uuid_Comparison_Exp>;
  place?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  refill?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refill_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_box_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_tag?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  shelf_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse_shelf?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.asset_placement" */
export enum Eatfresh_Asset_Placement_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetPlacementPkey = 'asset_placement_pkey',
  /** unique or primary key constraint on columns "rfid_asset_id" */
  AssetPlacementRfidAssetIdKey = 'asset_placement_rfid_asset_id_key'
}

/** input type for inserting data into table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Insert_Input = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Obj_Rel_Insert_Input>;
  pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  place?: InputMaybe<Eatfresh_Place_Obj_Rel_Insert_Input>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  refill?: InputMaybe<Eatfresh_Refill_Obj_Rel_Insert_Input>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Obj_Rel_Insert_Input>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Obj_Rel_Insert_Input>;
  rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_tag?: InputMaybe<Eatfresh_Rfid_Tag_Obj_Rel_Insert_Input>;
  shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_shelf?: InputMaybe<Eatfresh_Warehouse_Shelf_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Asset_Placement_Max_Fields = {
  __typename?: 'eatfresh_asset_placement_max_fields';
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  shelf_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Max_Order_By = {
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  pallet_spot_id?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_box_id?: InputMaybe<Order_By>;
  shelf_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Asset_Placement_Min_Fields = {
  __typename?: 'eatfresh_asset_placement_min_fields';
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  shelf_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Min_Order_By = {
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  pallet_spot_id?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_box_id?: InputMaybe<Order_By>;
  shelf_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Mutation_Response = {
  __typename?: 'eatfresh_asset_placement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Asset_Placement>;
};

/** input type for inserting object relation for remote table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Obj_Rel_Insert_Input = {
  data: Eatfresh_Asset_Placement_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Asset_Placement_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_On_Conflict = {
  constraint: Eatfresh_Asset_Placement_Constraint;
  update_columns?: Array<Eatfresh_Asset_Placement_Update_Column>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.asset_placement". */
export type Eatfresh_Asset_Placement_Order_By = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>;
  pallet_spot_id?: InputMaybe<Order_By>;
  place?: InputMaybe<Eatfresh_Place_Order_By>;
  place_id?: InputMaybe<Order_By>;
  refill?: InputMaybe<Eatfresh_Refill_Order_By>;
  refill_id?: InputMaybe<Order_By>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Order_By>;
  rfid_box_id?: InputMaybe<Order_By>;
  rfid_tag?: InputMaybe<Eatfresh_Rfid_Tag_Order_By>;
  shelf_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
  warehouse_shelf?: InputMaybe<Eatfresh_Warehouse_Shelf_Order_By>;
};

/** primary key columns input for table: eatfresh.asset_placement */
export type Eatfresh_Asset_Placement_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.asset_placement" */
export enum Eatfresh_Asset_Placement_Select_Column {
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  PalletSpotId = 'pallet_spot_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  RfidBoxId = 'rfid_box_id',
  /** column name */
  ShelfId = 'shelf_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

/** input type for updating data in table "eatfresh.asset_placement" */
export type Eatfresh_Asset_Placement_Set_Input = {
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_asset_placement" */
export type Eatfresh_Asset_Placement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Asset_Placement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Asset_Placement_Stream_Cursor_Value_Input = {
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.asset_placement" */
export enum Eatfresh_Asset_Placement_Update_Column {
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  PalletSpotId = 'pallet_spot_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  RfidBoxId = 'rfid_box_id',
  /** column name */
  ShelfId = 'shelf_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

export type Eatfresh_Asset_Placement_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Asset_Placement_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Asset_Placement_Bool_Exp;
};

/** columns and relationships of "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer = {
  __typename?: 'eatfresh_asset_transfer';
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** An array relationship */
  asset_transfer_problems: Array<Eatfresh_Asset_Transfer_Problem>;
  /** An aggregate relationship */
  asset_transfer_problems_aggregate: Eatfresh_Asset_Transfer_Problem_Aggregate;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fridge?: Maybe<Eatfresh_Fridge>;
  /** An object relationship */
  fridgeByToFridgeId?: Maybe<Eatfresh_Fridge>;
  from_fridge_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  from_pallet_spot?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  from_pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  from_place_id?: Maybe<Scalars['uuid']['output']>;
  from_rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  from_shelf_id?: Maybe<Scalars['uuid']['output']>;
  from_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  place?: Maybe<Eatfresh_Place>;
  /** An object relationship */
  placeByToPlaceId?: Maybe<Eatfresh_Place>;
  /** An object relationship */
  refill?: Maybe<Eatfresh_Refill>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfidBoxByToRfidBoxId?: Maybe<Eatfresh_Rfid_Box>;
  /** An object relationship */
  rfid_asset: Eatfresh_Rfid_Asset;
  rfid_asset_id: Scalars['uuid']['output'];
  /** An object relationship */
  rfid_box?: Maybe<Eatfresh_Rfid_Box>;
  to_fridge_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  to_pallet_spot?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  to_pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  to_place_id?: Maybe<Scalars['uuid']['output']>;
  to_rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  to_shelf_id?: Maybe<Scalars['uuid']['output']>;
  to_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  warehouse?: Maybe<Eatfresh_Warehouse>;
  /** An object relationship */
  warehouseByToWarehouseId?: Maybe<Eatfresh_Warehouse>;
  /** An object relationship */
  warehouseShelfByToShelfId?: Maybe<Eatfresh_Warehouse_Shelf>;
  /** An object relationship */
  warehouse_shelf?: Maybe<Eatfresh_Warehouse_Shelf>;
};


/** columns and relationships of "eatfresh.asset_transfer" */
export type Eatfresh_Asset_TransferAsset_Transfer_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.asset_transfer" */
export type Eatfresh_Asset_TransferAsset_Transfer_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};

/** aggregated selection of "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Aggregate = {
  __typename?: 'eatfresh_asset_transfer_aggregate';
  aggregate?: Maybe<Eatfresh_Asset_Transfer_Aggregate_Fields>;
  nodes: Array<Eatfresh_Asset_Transfer>;
};

export type Eatfresh_Asset_Transfer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Asset_Transfer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Aggregate_Fields = {
  __typename?: 'eatfresh_asset_transfer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Asset_Transfer_Max_Fields>;
  min?: Maybe<Eatfresh_Asset_Transfer_Min_Fields>;
};


/** aggregate fields of "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Asset_Transfer_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Asset_Transfer_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Asset_Transfer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.asset_transfer". All fields are combined with a logical 'AND'. */
export type Eatfresh_Asset_Transfer_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Asset_Transfer_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Asset_Transfer_Bool_Exp>>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  asset_transfer_problems?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
  asset_transfer_problems_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Bool_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridgeByToFridgeId?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  from_fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
  from_pallet_spot_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_rfid_box_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_shelf_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  place?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  placeByToPlaceId?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  refill?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refill_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfidBoxByToRfidBoxId?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  to_fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
  to_pallet_spot_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_rfid_box_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_shelf_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouseByToWarehouseId?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouseShelfByToShelfId?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
  warehouse_shelf?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.asset_transfer" */
export enum Eatfresh_Asset_Transfer_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetTransferPkey = 'asset_transfer_pkey'
}

/** input type for inserting data into table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Insert_Input = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  asset_transfer_problems?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Arr_Rel_Insert_Input>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridgeByToFridgeId?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  from_fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  from_pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Obj_Rel_Insert_Input>;
  from_pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  from_place_id?: InputMaybe<Scalars['uuid']['input']>;
  from_rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  from_shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  from_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  place?: InputMaybe<Eatfresh_Place_Obj_Rel_Insert_Input>;
  placeByToPlaceId?: InputMaybe<Eatfresh_Place_Obj_Rel_Insert_Input>;
  refill?: InputMaybe<Eatfresh_Refill_Obj_Rel_Insert_Input>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  rfidBoxByToRfidBoxId?: InputMaybe<Eatfresh_Rfid_Box_Obj_Rel_Insert_Input>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Obj_Rel_Insert_Input>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Obj_Rel_Insert_Input>;
  to_fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  to_pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Obj_Rel_Insert_Input>;
  to_pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  to_place_id?: InputMaybe<Scalars['uuid']['input']>;
  to_rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  to_shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  to_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouseByToWarehouseId?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouseShelfByToShelfId?: InputMaybe<Eatfresh_Warehouse_Shelf_Obj_Rel_Insert_Input>;
  warehouse_shelf?: InputMaybe<Eatfresh_Warehouse_Shelf_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Asset_Transfer_Max_Fields = {
  __typename?: 'eatfresh_asset_transfer_max_fields';
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  from_fridge_id?: Maybe<Scalars['uuid']['output']>;
  from_pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  from_place_id?: Maybe<Scalars['uuid']['output']>;
  from_rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  from_shelf_id?: Maybe<Scalars['uuid']['output']>;
  from_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  to_fridge_id?: Maybe<Scalars['uuid']['output']>;
  to_pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  to_place_id?: Maybe<Scalars['uuid']['output']>;
  to_rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  to_shelf_id?: Maybe<Scalars['uuid']['output']>;
  to_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Max_Order_By = {
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  from_fridge_id?: InputMaybe<Order_By>;
  from_pallet_spot_id?: InputMaybe<Order_By>;
  from_place_id?: InputMaybe<Order_By>;
  from_rfid_box_id?: InputMaybe<Order_By>;
  from_shelf_id?: InputMaybe<Order_By>;
  from_warehouse_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  to_fridge_id?: InputMaybe<Order_By>;
  to_pallet_spot_id?: InputMaybe<Order_By>;
  to_place_id?: InputMaybe<Order_By>;
  to_rfid_box_id?: InputMaybe<Order_By>;
  to_shelf_id?: InputMaybe<Order_By>;
  to_warehouse_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Asset_Transfer_Min_Fields = {
  __typename?: 'eatfresh_asset_transfer_min_fields';
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  from_fridge_id?: Maybe<Scalars['uuid']['output']>;
  from_pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  from_place_id?: Maybe<Scalars['uuid']['output']>;
  from_rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  from_shelf_id?: Maybe<Scalars['uuid']['output']>;
  from_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  to_fridge_id?: Maybe<Scalars['uuid']['output']>;
  to_pallet_spot_id?: Maybe<Scalars['uuid']['output']>;
  to_place_id?: Maybe<Scalars['uuid']['output']>;
  to_rfid_box_id?: Maybe<Scalars['uuid']['output']>;
  to_shelf_id?: Maybe<Scalars['uuid']['output']>;
  to_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Min_Order_By = {
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  from_fridge_id?: InputMaybe<Order_By>;
  from_pallet_spot_id?: InputMaybe<Order_By>;
  from_place_id?: InputMaybe<Order_By>;
  from_rfid_box_id?: InputMaybe<Order_By>;
  from_shelf_id?: InputMaybe<Order_By>;
  from_warehouse_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  to_fridge_id?: InputMaybe<Order_By>;
  to_pallet_spot_id?: InputMaybe<Order_By>;
  to_place_id?: InputMaybe<Order_By>;
  to_rfid_box_id?: InputMaybe<Order_By>;
  to_shelf_id?: InputMaybe<Order_By>;
  to_warehouse_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Mutation_Response = {
  __typename?: 'eatfresh_asset_transfer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Asset_Transfer>;
};

/** input type for inserting object relation for remote table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Obj_Rel_Insert_Input = {
  data: Eatfresh_Asset_Transfer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_On_Conflict = {
  constraint: Eatfresh_Asset_Transfer_Constraint;
  update_columns?: Array<Eatfresh_Asset_Transfer_Update_Column>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.asset_transfer". */
export type Eatfresh_Asset_Transfer_Order_By = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  asset_transfer_problems_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridgeByToFridgeId?: InputMaybe<Eatfresh_Fridge_Order_By>;
  from_fridge_id?: InputMaybe<Order_By>;
  from_pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>;
  from_pallet_spot_id?: InputMaybe<Order_By>;
  from_place_id?: InputMaybe<Order_By>;
  from_rfid_box_id?: InputMaybe<Order_By>;
  from_shelf_id?: InputMaybe<Order_By>;
  from_warehouse_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  place?: InputMaybe<Eatfresh_Place_Order_By>;
  placeByToPlaceId?: InputMaybe<Eatfresh_Place_Order_By>;
  refill?: InputMaybe<Eatfresh_Refill_Order_By>;
  refill_id?: InputMaybe<Order_By>;
  rfidBoxByToRfidBoxId?: InputMaybe<Eatfresh_Rfid_Box_Order_By>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Order_By>;
  to_fridge_id?: InputMaybe<Order_By>;
  to_pallet_spot?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>;
  to_pallet_spot_id?: InputMaybe<Order_By>;
  to_place_id?: InputMaybe<Order_By>;
  to_rfid_box_id?: InputMaybe<Order_By>;
  to_shelf_id?: InputMaybe<Order_By>;
  to_warehouse_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouseByToWarehouseId?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouseShelfByToShelfId?: InputMaybe<Eatfresh_Warehouse_Shelf_Order_By>;
  warehouse_shelf?: InputMaybe<Eatfresh_Warehouse_Shelf_Order_By>;
};

/** primary key columns input for table: eatfresh.asset_transfer */
export type Eatfresh_Asset_Transfer_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem = {
  __typename?: 'eatfresh_asset_transfer_problem';
  /** An object relationship */
  asset_transfer: Eatfresh_Asset_Transfer;
  asset_transfer_id: Scalars['uuid']['output'];
  /** An object relationship */
  asset_transfer_problem_severity: Eatfresh_Asset_Transfer_Problem_Severity;
  /** An object relationship */
  asset_transfer_problem_status: Eatfresh_Asset_Transfer_Problem_Status;
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  severity: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Aggregate = {
  __typename?: 'eatfresh_asset_transfer_problem_aggregate';
  aggregate?: Maybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Fields>;
  nodes: Array<Eatfresh_Asset_Transfer_Problem>;
};

export type Eatfresh_Asset_Transfer_Problem_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Asset_Transfer_Problem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Aggregate_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Asset_Transfer_Problem_Max_Fields>;
  min?: Maybe<Eatfresh_Asset_Transfer_Problem_Min_Fields>;
};


/** aggregate fields of "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Asset_Transfer_Problem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.asset_transfer_problem". All fields are combined with a logical 'AND'. */
export type Eatfresh_Asset_Transfer_Problem_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Bool_Exp>>;
  asset_transfer?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfer_id?: InputMaybe<Uuid_Comparison_Exp>;
  asset_transfer_problem_severity?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
  asset_transfer_problem_status?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.asset_transfer_problem" */
export enum Eatfresh_Asset_Transfer_Problem_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetTransferProblemPkey = 'asset_transfer_problem_pkey'
}

/** input type for inserting data into table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Insert_Input = {
  asset_transfer?: InputMaybe<Eatfresh_Asset_Transfer_Obj_Rel_Insert_Input>;
  asset_transfer_id?: InputMaybe<Scalars['uuid']['input']>;
  asset_transfer_problem_severity?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Obj_Rel_Insert_Input>;
  asset_transfer_problem_status?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Asset_Transfer_Problem_Max_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_max_fields';
  asset_transfer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Max_Order_By = {
  asset_transfer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Asset_Transfer_Problem_Min_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_min_fields';
  asset_transfer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Min_Order_By = {
  asset_transfer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Mutation_Response = {
  __typename?: 'eatfresh_asset_transfer_problem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Asset_Transfer_Problem>;
};

/** on_conflict condition type for table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_On_Conflict = {
  constraint: Eatfresh_Asset_Transfer_Problem_Constraint;
  update_columns?: Array<Eatfresh_Asset_Transfer_Problem_Update_Column>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.asset_transfer_problem". */
export type Eatfresh_Asset_Transfer_Problem_Order_By = {
  asset_transfer?: InputMaybe<Eatfresh_Asset_Transfer_Order_By>;
  asset_transfer_id?: InputMaybe<Order_By>;
  asset_transfer_problem_severity?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Order_By>;
  asset_transfer_problem_status?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.asset_transfer_problem */
export type Eatfresh_Asset_Transfer_Problem_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.asset_transfer_problem" */
export enum Eatfresh_Asset_Transfer_Problem_Select_Column {
  /** column name */
  AssetTransferId = 'asset_transfer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Severity = 'severity',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Set_Input = {
  asset_transfer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity = {
  __typename?: 'eatfresh_asset_transfer_problem_severity';
  /** An array relationship */
  asset_transfer_problems: Array<Eatfresh_Asset_Transfer_Problem>;
  /** An aggregate relationship */
  asset_transfer_problems_aggregate: Eatfresh_Asset_Transfer_Problem_Aggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_SeverityAsset_Transfer_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_SeverityAsset_Transfer_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};

/** aggregated selection of "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Aggregate = {
  __typename?: 'eatfresh_asset_transfer_problem_severity_aggregate';
  aggregate?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity_Aggregate_Fields>;
  nodes: Array<Eatfresh_Asset_Transfer_Problem_Severity>;
};

/** aggregate fields of "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Aggregate_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_severity_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity_Max_Fields>;
  min?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity_Min_Fields>;
};


/** aggregate fields of "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.asset_transfer_problem_severity". All fields are combined with a logical 'AND'. */
export type Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>>;
  asset_transfer_problems?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
  asset_transfer_problems_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.asset_transfer_problem_severity" */
export enum Eatfresh_Asset_Transfer_Problem_Severity_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssetTransferProblemSeverityPkey = 'asset_transfer_problem_severity_pkey'
}

/** input type for inserting data into table "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Insert_Input = {
  asset_transfer_problems?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Asset_Transfer_Problem_Severity_Max_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_severity_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Asset_Transfer_Problem_Severity_Min_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_severity_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Mutation_Response = {
  __typename?: 'eatfresh_asset_transfer_problem_severity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Asset_Transfer_Problem_Severity>;
};

/** input type for inserting object relation for remote table "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Obj_Rel_Insert_Input = {
  data: Eatfresh_Asset_Transfer_Problem_Severity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_On_Conflict = {
  constraint: Eatfresh_Asset_Transfer_Problem_Severity_Constraint;
  update_columns?: Array<Eatfresh_Asset_Transfer_Problem_Severity_Update_Column>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.asset_transfer_problem_severity". */
export type Eatfresh_Asset_Transfer_Problem_Severity_Order_By = {
  asset_transfer_problems_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.asset_transfer_problem_severity */
export type Eatfresh_Asset_Transfer_Problem_Severity_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.asset_transfer_problem_severity" */
export enum Eatfresh_Asset_Transfer_Problem_Severity_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_asset_transfer_problem_severity" */
export type Eatfresh_Asset_Transfer_Problem_Severity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Asset_Transfer_Problem_Severity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Asset_Transfer_Problem_Severity_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.asset_transfer_problem_severity" */
export enum Eatfresh_Asset_Transfer_Problem_Severity_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Asset_Transfer_Problem_Severity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp;
};

/** columns and relationships of "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status = {
  __typename?: 'eatfresh_asset_transfer_problem_status';
  /** An array relationship */
  asset_transfer_problems: Array<Eatfresh_Asset_Transfer_Problem>;
  /** An aggregate relationship */
  asset_transfer_problems_aggregate: Eatfresh_Asset_Transfer_Problem_Aggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_StatusAsset_Transfer_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_StatusAsset_Transfer_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};

/** aggregated selection of "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Aggregate = {
  __typename?: 'eatfresh_asset_transfer_problem_status_aggregate';
  aggregate?: Maybe<Eatfresh_Asset_Transfer_Problem_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Asset_Transfer_Problem_Status>;
};

/** aggregate fields of "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Asset_Transfer_Problem_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Asset_Transfer_Problem_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.asset_transfer_problem_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>>;
  asset_transfer_problems?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
  asset_transfer_problems_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.asset_transfer_problem_status" */
export enum Eatfresh_Asset_Transfer_Problem_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssetTransferProblemStatusPkey = 'asset_transfer_problem_status_pkey'
}

/** input type for inserting data into table "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Insert_Input = {
  asset_transfer_problems?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Asset_Transfer_Problem_Status_Max_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Asset_Transfer_Problem_Status_Min_Fields = {
  __typename?: 'eatfresh_asset_transfer_problem_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Mutation_Response = {
  __typename?: 'eatfresh_asset_transfer_problem_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Asset_Transfer_Problem_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Asset_Transfer_Problem_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_On_Conflict = {
  constraint: Eatfresh_Asset_Transfer_Problem_Status_Constraint;
  update_columns?: Array<Eatfresh_Asset_Transfer_Problem_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.asset_transfer_problem_status". */
export type Eatfresh_Asset_Transfer_Problem_Status_Order_By = {
  asset_transfer_problems_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.asset_transfer_problem_status */
export type Eatfresh_Asset_Transfer_Problem_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.asset_transfer_problem_status" */
export enum Eatfresh_Asset_Transfer_Problem_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_asset_transfer_problem_status" */
export type Eatfresh_Asset_Transfer_Problem_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Asset_Transfer_Problem_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Asset_Transfer_Problem_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.asset_transfer_problem_status" */
export enum Eatfresh_Asset_Transfer_Problem_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Asset_Transfer_Problem_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp;
};

/** Streaming cursor of the table "eatfresh_asset_transfer_problem" */
export type Eatfresh_Asset_Transfer_Problem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Asset_Transfer_Problem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Asset_Transfer_Problem_Stream_Cursor_Value_Input = {
  asset_transfer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "eatfresh.asset_transfer_problem" */
export enum Eatfresh_Asset_Transfer_Problem_Update_Column {
  /** column name */
  AssetTransferId = 'asset_transfer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Severity = 'severity',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Asset_Transfer_Problem_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Asset_Transfer_Problem_Bool_Exp;
};

/** select columns of table "eatfresh.asset_transfer" */
export enum Eatfresh_Asset_Transfer_Select_Column {
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FromFridgeId = 'from_fridge_id',
  /** column name */
  FromPalletSpotId = 'from_pallet_spot_id',
  /** column name */
  FromPlaceId = 'from_place_id',
  /** column name */
  FromRfidBoxId = 'from_rfid_box_id',
  /** column name */
  FromShelfId = 'from_shelf_id',
  /** column name */
  FromWarehouseId = 'from_warehouse_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  ToFridgeId = 'to_fridge_id',
  /** column name */
  ToPalletSpotId = 'to_pallet_spot_id',
  /** column name */
  ToPlaceId = 'to_place_id',
  /** column name */
  ToRfidBoxId = 'to_rfid_box_id',
  /** column name */
  ToShelfId = 'to_shelf_id',
  /** column name */
  ToWarehouseId = 'to_warehouse_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.asset_transfer" */
export type Eatfresh_Asset_Transfer_Set_Input = {
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  from_pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  from_place_id?: InputMaybe<Scalars['uuid']['input']>;
  from_rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  from_shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  from_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  to_fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  to_pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  to_place_id?: InputMaybe<Scalars['uuid']['input']>;
  to_rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  to_shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  to_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "eatfresh_asset_transfer" */
export type Eatfresh_Asset_Transfer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Asset_Transfer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Asset_Transfer_Stream_Cursor_Value_Input = {
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  from_pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  from_place_id?: InputMaybe<Scalars['uuid']['input']>;
  from_rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  from_shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  from_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  to_fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  to_pallet_spot_id?: InputMaybe<Scalars['uuid']['input']>;
  to_place_id?: InputMaybe<Scalars['uuid']['input']>;
  to_rfid_box_id?: InputMaybe<Scalars['uuid']['input']>;
  to_shelf_id?: InputMaybe<Scalars['uuid']['input']>;
  to_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "eatfresh.asset_transfer" */
export enum Eatfresh_Asset_Transfer_Update_Column {
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FromFridgeId = 'from_fridge_id',
  /** column name */
  FromPalletSpotId = 'from_pallet_spot_id',
  /** column name */
  FromPlaceId = 'from_place_id',
  /** column name */
  FromRfidBoxId = 'from_rfid_box_id',
  /** column name */
  FromShelfId = 'from_shelf_id',
  /** column name */
  FromWarehouseId = 'from_warehouse_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  ToFridgeId = 'to_fridge_id',
  /** column name */
  ToPalletSpotId = 'to_pallet_spot_id',
  /** column name */
  ToPlaceId = 'to_place_id',
  /** column name */
  ToRfidBoxId = 'to_rfid_box_id',
  /** column name */
  ToShelfId = 'to_shelf_id',
  /** column name */
  ToWarehouseId = 'to_warehouse_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Asset_Transfer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Asset_Transfer_Bool_Exp;
};

/** columns and relationships of "eatfresh.auth_token" */
export type Eatfresh_Auth_Token = {
  __typename?: 'eatfresh_auth_token';
  key: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** aggregated selection of "eatfresh.auth_token" */
export type Eatfresh_Auth_Token_Aggregate = {
  __typename?: 'eatfresh_auth_token_aggregate';
  aggregate?: Maybe<Eatfresh_Auth_Token_Aggregate_Fields>;
  nodes: Array<Eatfresh_Auth_Token>;
};

/** aggregate fields of "eatfresh.auth_token" */
export type Eatfresh_Auth_Token_Aggregate_Fields = {
  __typename?: 'eatfresh_auth_token_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Auth_Token_Max_Fields>;
  min?: Maybe<Eatfresh_Auth_Token_Min_Fields>;
};


/** aggregate fields of "eatfresh.auth_token" */
export type Eatfresh_Auth_Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Auth_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.auth_token". All fields are combined with a logical 'AND'. */
export type Eatfresh_Auth_Token_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Auth_Token_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Auth_Token_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Auth_Token_Bool_Exp>>;
  key?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.auth_token" */
export enum Eatfresh_Auth_Token_Constraint {
  /** unique or primary key constraint on columns "key" */
  AuthTokenPkey = 'auth_token_pkey'
}

/** input type for inserting data into table "eatfresh.auth_token" */
export type Eatfresh_Auth_Token_Insert_Input = {
  key?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Auth_Token_Max_Fields = {
  __typename?: 'eatfresh_auth_token_max_fields';
  key?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Auth_Token_Min_Fields = {
  __typename?: 'eatfresh_auth_token_min_fields';
  key?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.auth_token" */
export type Eatfresh_Auth_Token_Mutation_Response = {
  __typename?: 'eatfresh_auth_token_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Auth_Token>;
};

/** on_conflict condition type for table "eatfresh.auth_token" */
export type Eatfresh_Auth_Token_On_Conflict = {
  constraint: Eatfresh_Auth_Token_Constraint;
  update_columns?: Array<Eatfresh_Auth_Token_Update_Column>;
  where?: InputMaybe<Eatfresh_Auth_Token_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.auth_token". */
export type Eatfresh_Auth_Token_Order_By = {
  key?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.auth_token */
export type Eatfresh_Auth_Token_Pk_Columns_Input = {
  key: Scalars['String']['input'];
};

/** select columns of table "eatfresh.auth_token" */
export enum Eatfresh_Auth_Token_Select_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Token = 'token'
}

/** input type for updating data in table "eatfresh.auth_token" */
export type Eatfresh_Auth_Token_Set_Input = {
  key?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_auth_token" */
export type Eatfresh_Auth_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Auth_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Auth_Token_Stream_Cursor_Value_Input = {
  key?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.auth_token" */
export enum Eatfresh_Auth_Token_Update_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Token = 'token'
}

export type Eatfresh_Auth_Token_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Auth_Token_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Auth_Token_Bool_Exp;
};

/** columns and relationships of "eatfresh.authenticators" */
export type Eatfresh_Authenticators = {
  __typename?: 'eatfresh_authenticators';
  counter: Scalars['bigint']['output'];
  credential_backed_up?: Maybe<Scalars['Boolean']['output']>;
  credential_device_type?: Maybe<Scalars['String']['output']>;
  credential_public_key: Scalars['String']['output'];
  credentialid: Scalars['String']['output'];
  transports?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Aggregate = {
  __typename?: 'eatfresh_authenticators_aggregate';
  aggregate?: Maybe<Eatfresh_Authenticators_Aggregate_Fields>;
  nodes: Array<Eatfresh_Authenticators>;
};

export type Eatfresh_Authenticators_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Authenticators_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Authenticators_Select_Column_Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Authenticators_Select_Column_Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Authenticators_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Aggregate_Fields = {
  __typename?: 'eatfresh_authenticators_aggregate_fields';
  avg?: Maybe<Eatfresh_Authenticators_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Authenticators_Max_Fields>;
  min?: Maybe<Eatfresh_Authenticators_Min_Fields>;
  stddev?: Maybe<Eatfresh_Authenticators_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Authenticators_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Authenticators_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Authenticators_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Authenticators_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Authenticators_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Authenticators_Variance_Fields>;
};


/** aggregate fields of "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Authenticators_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Authenticators_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Authenticators_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Authenticators_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Authenticators_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Authenticators_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Authenticators_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Authenticators_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Authenticators_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Authenticators_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Authenticators_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Authenticators_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Authenticators_Avg_Fields = {
  __typename?: 'eatfresh_authenticators_avg_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Avg_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.authenticators". All fields are combined with a logical 'AND'. */
export type Eatfresh_Authenticators_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Authenticators_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Authenticators_Bool_Exp>>;
  counter?: InputMaybe<Bigint_Comparison_Exp>;
  credential_backed_up?: InputMaybe<Boolean_Comparison_Exp>;
  credential_device_type?: InputMaybe<String_Comparison_Exp>;
  credential_public_key?: InputMaybe<String_Comparison_Exp>;
  credentialid?: InputMaybe<String_Comparison_Exp>;
  transports?: InputMaybe<String_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.authenticators" */
export enum Eatfresh_Authenticators_Constraint {
  /** unique or primary key constraint on columns "credentialid" */
  AuthenticatorsPkey = 'authenticators_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Inc_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Insert_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credential_backed_up?: InputMaybe<Scalars['Boolean']['input']>;
  credential_device_type?: InputMaybe<Scalars['String']['input']>;
  credential_public_key?: InputMaybe<Scalars['String']['input']>;
  credentialid?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Authenticators_Max_Fields = {
  __typename?: 'eatfresh_authenticators_max_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credential_device_type?: Maybe<Scalars['String']['output']>;
  credential_public_key?: Maybe<Scalars['String']['output']>;
  credentialid?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Max_Order_By = {
  counter?: InputMaybe<Order_By>;
  credential_device_type?: InputMaybe<Order_By>;
  credential_public_key?: InputMaybe<Order_By>;
  credentialid?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Authenticators_Min_Fields = {
  __typename?: 'eatfresh_authenticators_min_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credential_device_type?: Maybe<Scalars['String']['output']>;
  credential_public_key?: Maybe<Scalars['String']['output']>;
  credentialid?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Min_Order_By = {
  counter?: InputMaybe<Order_By>;
  credential_device_type?: InputMaybe<Order_By>;
  credential_public_key?: InputMaybe<Order_By>;
  credentialid?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Mutation_Response = {
  __typename?: 'eatfresh_authenticators_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Authenticators>;
};

/** on_conflict condition type for table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_On_Conflict = {
  constraint: Eatfresh_Authenticators_Constraint;
  update_columns?: Array<Eatfresh_Authenticators_Update_Column>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.authenticators". */
export type Eatfresh_Authenticators_Order_By = {
  counter?: InputMaybe<Order_By>;
  credential_backed_up?: InputMaybe<Order_By>;
  credential_device_type?: InputMaybe<Order_By>;
  credential_public_key?: InputMaybe<Order_By>;
  credentialid?: InputMaybe<Order_By>;
  transports?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.authenticators */
export type Eatfresh_Authenticators_Pk_Columns_Input = {
  credentialid: Scalars['String']['input'];
};

/** select columns of table "eatfresh.authenticators" */
export enum Eatfresh_Authenticators_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialBackedUp = 'credential_backed_up',
  /** column name */
  CredentialDeviceType = 'credential_device_type',
  /** column name */
  CredentialPublicKey = 'credential_public_key',
  /** column name */
  Credentialid = 'credentialid',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'user_id'
}

/** select "eatfresh_authenticators_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.authenticators" */
export enum Eatfresh_Authenticators_Select_Column_Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CredentialBackedUp = 'credential_backed_up'
}

/** select "eatfresh_authenticators_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.authenticators" */
export enum Eatfresh_Authenticators_Select_Column_Eatfresh_Authenticators_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CredentialBackedUp = 'credential_backed_up'
}

/** input type for updating data in table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Set_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credential_backed_up?: InputMaybe<Scalars['Boolean']['input']>;
  credential_device_type?: InputMaybe<Scalars['String']['input']>;
  credential_public_key?: InputMaybe<Scalars['String']['input']>;
  credentialid?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Authenticators_Stddev_Fields = {
  __typename?: 'eatfresh_authenticators_stddev_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Stddev_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Authenticators_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_authenticators_stddev_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Stddev_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Authenticators_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_authenticators_stddev_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Stddev_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_authenticators" */
export type Eatfresh_Authenticators_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Authenticators_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Authenticators_Stream_Cursor_Value_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credential_backed_up?: InputMaybe<Scalars['Boolean']['input']>;
  credential_device_type?: InputMaybe<Scalars['String']['input']>;
  credential_public_key?: InputMaybe<Scalars['String']['input']>;
  credentialid?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Authenticators_Sum_Fields = {
  __typename?: 'eatfresh_authenticators_sum_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Sum_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.authenticators" */
export enum Eatfresh_Authenticators_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialBackedUp = 'credential_backed_up',
  /** column name */
  CredentialDeviceType = 'credential_device_type',
  /** column name */
  CredentialPublicKey = 'credential_public_key',
  /** column name */
  Credentialid = 'credentialid',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Authenticators_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Authenticators_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Authenticators_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Authenticators_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Authenticators_Var_Pop_Fields = {
  __typename?: 'eatfresh_authenticators_var_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Var_Pop_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Authenticators_Var_Samp_Fields = {
  __typename?: 'eatfresh_authenticators_var_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Var_Samp_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Authenticators_Variance_Fields = {
  __typename?: 'eatfresh_authenticators_variance_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.authenticators" */
export type Eatfresh_Authenticators_Variance_Order_By = {
  counter?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer = {
  __typename?: 'eatfresh_b2b_customer';
  /** An object relationship */
  billing_address: Eatfresh_Place;
  billing_address_place_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  ss24_company_id?: Maybe<Scalars['String']['output']>;
  ss24_location_id?: Maybe<Scalars['String']['output']>;
  use_smartstore24_api?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  user_accounts: Array<Eatfresh_User_Account>;
  /** An aggregate relationship */
  user_accounts_aggregate: Eatfresh_User_Account_Aggregate;
};


/** columns and relationships of "eatfresh.b2b_customer" */
export type Eatfresh_B2b_CustomerUser_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};


/** columns and relationships of "eatfresh.b2b_customer" */
export type Eatfresh_B2b_CustomerUser_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};

/** aggregated selection of "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_Aggregate = {
  __typename?: 'eatfresh_b2b_customer_aggregate';
  aggregate?: Maybe<Eatfresh_B2b_Customer_Aggregate_Fields>;
  nodes: Array<Eatfresh_B2b_Customer>;
};

/** aggregate fields of "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_Aggregate_Fields = {
  __typename?: 'eatfresh_b2b_customer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_B2b_Customer_Max_Fields>;
  min?: Maybe<Eatfresh_B2b_Customer_Min_Fields>;
};


/** aggregate fields of "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_B2b_Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.b2b_customer". All fields are combined with a logical 'AND'. */
export type Eatfresh_B2b_Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_B2b_Customer_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_B2b_Customer_Bool_Exp>>;
  billing_address?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  billing_address_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ss24_company_id?: InputMaybe<String_Comparison_Exp>;
  ss24_location_id?: InputMaybe<String_Comparison_Exp>;
  use_smartstore24_api?: InputMaybe<Boolean_Comparison_Exp>;
  user_accounts?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_accounts_aggregate?: InputMaybe<Eatfresh_User_Account_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.b2b_customer" */
export enum Eatfresh_B2b_Customer_Constraint {
  /** unique or primary key constraint on columns "id" */
  B2bCustomerPkey = 'b2b_customer_pkey'
}

/** input type for inserting data into table "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_Insert_Input = {
  billing_address?: InputMaybe<Eatfresh_Place_Obj_Rel_Insert_Input>;
  billing_address_place_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ss24_company_id?: InputMaybe<Scalars['String']['input']>;
  ss24_location_id?: InputMaybe<Scalars['String']['input']>;
  use_smartstore24_api?: InputMaybe<Scalars['Boolean']['input']>;
  user_accounts?: InputMaybe<Eatfresh_User_Account_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_B2b_Customer_Max_Fields = {
  __typename?: 'eatfresh_b2b_customer_max_fields';
  billing_address_place_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ss24_company_id?: Maybe<Scalars['String']['output']>;
  ss24_location_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_B2b_Customer_Min_Fields = {
  __typename?: 'eatfresh_b2b_customer_min_fields';
  billing_address_place_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ss24_company_id?: Maybe<Scalars['String']['output']>;
  ss24_location_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_Mutation_Response = {
  __typename?: 'eatfresh_b2b_customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_B2b_Customer>;
};

/** input type for inserting object relation for remote table "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_Obj_Rel_Insert_Input = {
  data: Eatfresh_B2b_Customer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_B2b_Customer_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_On_Conflict = {
  constraint: Eatfresh_B2b_Customer_Constraint;
  update_columns?: Array<Eatfresh_B2b_Customer_Update_Column>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.b2b_customer". */
export type Eatfresh_B2b_Customer_Order_By = {
  billing_address?: InputMaybe<Eatfresh_Place_Order_By>;
  billing_address_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ss24_company_id?: InputMaybe<Order_By>;
  ss24_location_id?: InputMaybe<Order_By>;
  use_smartstore24_api?: InputMaybe<Order_By>;
  user_accounts_aggregate?: InputMaybe<Eatfresh_User_Account_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.b2b_customer */
export type Eatfresh_B2b_Customer_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.b2b_customer" */
export enum Eatfresh_B2b_Customer_Select_Column {
  /** column name */
  BillingAddressPlaceId = 'billing_address_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Ss24CompanyId = 'ss24_company_id',
  /** column name */
  Ss24LocationId = 'ss24_location_id',
  /** column name */
  UseSmartstore24Api = 'use_smartstore24_api'
}

/** input type for updating data in table "eatfresh.b2b_customer" */
export type Eatfresh_B2b_Customer_Set_Input = {
  billing_address_place_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ss24_company_id?: InputMaybe<Scalars['String']['input']>;
  ss24_location_id?: InputMaybe<Scalars['String']['input']>;
  use_smartstore24_api?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "eatfresh_b2b_customer" */
export type Eatfresh_B2b_Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_B2b_Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_B2b_Customer_Stream_Cursor_Value_Input = {
  billing_address_place_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ss24_company_id?: InputMaybe<Scalars['String']['input']>;
  ss24_location_id?: InputMaybe<Scalars['String']['input']>;
  use_smartstore24_api?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type = {
  __typename?: 'eatfresh_b2b_customer_type';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_Aggregate = {
  __typename?: 'eatfresh_b2b_customer_type_aggregate';
  aggregate?: Maybe<Eatfresh_B2b_Customer_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_B2b_Customer_Type>;
};

/** aggregate fields of "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_b2b_customer_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_B2b_Customer_Type_Max_Fields>;
  min?: Maybe<Eatfresh_B2b_Customer_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.b2b_customer_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_B2b_Customer_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_B2b_Customer_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.b2b_customer_type" */
export enum Eatfresh_B2b_Customer_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  B2bCustomerTypePkey = 'b2b_customer_type_pkey'
}

/** input type for inserting data into table "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_B2b_Customer_Type_Max_Fields = {
  __typename?: 'eatfresh_b2b_customer_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_B2b_Customer_Type_Min_Fields = {
  __typename?: 'eatfresh_b2b_customer_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_Mutation_Response = {
  __typename?: 'eatfresh_b2b_customer_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_B2b_Customer_Type>;
};

/** on_conflict condition type for table "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_On_Conflict = {
  constraint: Eatfresh_B2b_Customer_Type_Constraint;
  update_columns?: Array<Eatfresh_B2b_Customer_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.b2b_customer_type". */
export type Eatfresh_B2b_Customer_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.b2b_customer_type */
export type Eatfresh_B2b_Customer_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.b2b_customer_type" */
export enum Eatfresh_B2b_Customer_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_b2b_customer_type" */
export type Eatfresh_B2b_Customer_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_B2b_Customer_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_B2b_Customer_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.b2b_customer_type" */
export enum Eatfresh_B2b_Customer_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_B2b_Customer_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_B2b_Customer_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_B2b_Customer_Type_Bool_Exp;
};

/** update columns of table "eatfresh.b2b_customer" */
export enum Eatfresh_B2b_Customer_Update_Column {
  /** column name */
  BillingAddressPlaceId = 'billing_address_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Ss24CompanyId = 'ss24_company_id',
  /** column name */
  Ss24LocationId = 'ss24_location_id',
  /** column name */
  UseSmartstore24Api = 'use_smartstore24_api'
}

export type Eatfresh_B2b_Customer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_B2b_Customer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_B2b_Customer_Bool_Exp;
};

/** columns and relationships of "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type = {
  __typename?: 'eatfresh_basic_user_type';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_accounts: Array<Eatfresh_User_Account>;
  /** An aggregate relationship */
  user_accounts_aggregate: Eatfresh_User_Account_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_TypeUser_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};


/** columns and relationships of "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_TypeUser_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};

/** aggregated selection of "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_Aggregate = {
  __typename?: 'eatfresh_basic_user_type_aggregate';
  aggregate?: Maybe<Eatfresh_Basic_User_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Basic_User_Type>;
};

/** aggregate fields of "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_basic_user_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Basic_User_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Basic_User_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Basic_User_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.basic_user_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Basic_User_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Basic_User_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Basic_User_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  user_accounts?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_accounts_aggregate?: InputMaybe<Eatfresh_User_Account_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.basic_user_type" */
export enum Eatfresh_Basic_User_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  BasicUserTypePkey = 'basic_user_type_pkey'
}

export enum Eatfresh_Basic_User_Type_Enum {
  /** An admin */
  Admin = 'ADMIN',
  /** An anonymous user */
  Anonymous = 'ANONYMOUS',
  /** B2B wholesale customer (e.g. SmartStore24) */
  B2BWholesale = 'B2B_WHOLESALE',
  /** A customer */
  Customer = 'CUSTOMER',
  /** Fridge event listener */
  Fridge = 'FRIDGE',
  /** A refiller */
  Refiller = 'REFILLER',
  /** Selfly fridge */
  Selfly = 'SELFLY',
  /** Supplier */
  Supplier = 'SUPPLIER'
}

/** Boolean expression to compare columns of type "eatfresh_basic_user_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Basic_User_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Basic_User_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Basic_User_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Basic_User_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Basic_User_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  user_accounts?: InputMaybe<Eatfresh_User_Account_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Basic_User_Type_Max_Fields = {
  __typename?: 'eatfresh_basic_user_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Basic_User_Type_Min_Fields = {
  __typename?: 'eatfresh_basic_user_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_Mutation_Response = {
  __typename?: 'eatfresh_basic_user_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Basic_User_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Basic_User_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Basic_User_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_On_Conflict = {
  constraint: Eatfresh_Basic_User_Type_Constraint;
  update_columns?: Array<Eatfresh_Basic_User_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.basic_user_type". */
export type Eatfresh_Basic_User_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  user_accounts_aggregate?: InputMaybe<Eatfresh_User_Account_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.basic_user_type */
export type Eatfresh_Basic_User_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.basic_user_type" */
export enum Eatfresh_Basic_User_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.basic_user_type" */
export type Eatfresh_Basic_User_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_basic_user_type" */
export type Eatfresh_Basic_User_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Basic_User_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Basic_User_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.basic_user_type" */
export enum Eatfresh_Basic_User_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Basic_User_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Basic_User_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Basic_User_Type_Bool_Exp;
};

/** columns and relationships of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan = {
  __typename?: 'eatfresh_box_content_plan';
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** An object relationship */
  box_content_plan_status: Eatfresh_Box_Content_Plan_Status;
  /** An array relationship */
  box_content_to_articles: Array<Eatfresh_Box_Content_To_Article>;
  /** An aggregate relationship */
  box_content_to_articles_aggregate: Eatfresh_Box_Content_To_Article_Aggregate;
  box_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  fridge_order?: Maybe<Eatfresh_Fridge_Order>;
  fridge_order_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  package_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  refill?: Maybe<Eatfresh_Refill>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfid_box?: Maybe<Eatfresh_Rfid_Box>;
  /** An array relationship */
  rfid_scans: Array<Eatfresh_Rfid_Scan>;
  /** An aggregate relationship */
  rfid_scans_aggregate: Eatfresh_Rfid_Scan_Aggregate;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  shortcode?: Maybe<Scalars['String']['output']>;
  status: Eatfresh_Box_Content_Plan_Status_Enum;
};


/** columns and relationships of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_PlanBox_Content_To_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


/** columns and relationships of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_PlanBox_Content_To_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


/** columns and relationships of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_PlanRfid_ScansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_PlanRfid_Scans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_PlanRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_PlanRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};

/** aggregated selection of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Aggregate = {
  __typename?: 'eatfresh_box_content_plan_aggregate';
  aggregate?: Maybe<Eatfresh_Box_Content_Plan_Aggregate_Fields>;
  nodes: Array<Eatfresh_Box_Content_Plan>;
};

export type Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Aggregate_Fields = {
  __typename?: 'eatfresh_box_content_plan_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Box_Content_Plan_Max_Fields>;
  min?: Maybe<Eatfresh_Box_Content_Plan_Min_Fields>;
};


/** aggregate fields of "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Box_Content_Plan_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Box_Content_Plan_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Box_Content_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Box_Content_Plan_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.box_content_plan". All fields are combined with a logical 'AND'. */
export type Eatfresh_Box_Content_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Bool_Exp>>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  box_content_plan_status?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
  box_content_to_articles?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
  box_content_to_articles_aggregate?: InputMaybe<Eatfresh_Box_Content_To_Article_Aggregate_Bool_Exp>;
  box_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  confirmed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
  fridge_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  package_id?: InputMaybe<String_Comparison_Exp>;
  refill?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refill_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  shortcode?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.box_content_plan" */
export enum Eatfresh_Box_Content_Plan_Constraint {
  /** unique or primary key constraint on columns "package_id" */
  BoxContentPlanPackageIdKey = 'box_content_plan_package_id_key',
  /** unique or primary key constraint on columns "id" */
  BoxContentPlanPkey = 'box_content_plan_pkey'
}

/** input type for inserting data into table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Insert_Input = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  box_content_plan_status?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Obj_Rel_Insert_Input>;
  box_content_to_articles?: InputMaybe<Eatfresh_Box_Content_To_Article_Arr_Rel_Insert_Input>;
  box_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Obj_Rel_Insert_Input>;
  fridge_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  package_id?: InputMaybe<Scalars['String']['input']>;
  refill?: InputMaybe<Eatfresh_Refill_Obj_Rel_Insert_Input>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Obj_Rel_Insert_Input>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Arr_Rel_Insert_Input>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  shortcode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Enum>;
};

/** aggregate max on columns */
export type Eatfresh_Box_Content_Plan_Max_Fields = {
  __typename?: 'eatfresh_box_content_plan_max_fields';
  box_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  package_id?: Maybe<Scalars['String']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  shortcode?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Max_Order_By = {
  box_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  confirmed_at?: InputMaybe<Order_By>;
  fridge_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  shortcode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Box_Content_Plan_Min_Fields = {
  __typename?: 'eatfresh_box_content_plan_min_fields';
  box_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  package_id?: Maybe<Scalars['String']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  shortcode?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Min_Order_By = {
  box_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  confirmed_at?: InputMaybe<Order_By>;
  fridge_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  shortcode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Mutation_Response = {
  __typename?: 'eatfresh_box_content_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Box_Content_Plan>;
};

/** input type for inserting object relation for remote table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Obj_Rel_Insert_Input = {
  data: Eatfresh_Box_Content_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Box_Content_Plan_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_On_Conflict = {
  constraint: Eatfresh_Box_Content_Plan_Constraint;
  update_columns?: Array<Eatfresh_Box_Content_Plan_Update_Column>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.box_content_plan". */
export type Eatfresh_Box_Content_Plan_Order_By = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  box_content_plan_status?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Order_By>;
  box_content_to_articles_aggregate?: InputMaybe<Eatfresh_Box_Content_To_Article_Aggregate_Order_By>;
  box_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  confirmed_at?: InputMaybe<Order_By>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Order_By>;
  fridge_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  package_id?: InputMaybe<Order_By>;
  refill?: InputMaybe<Eatfresh_Refill_Order_By>;
  refill_id?: InputMaybe<Order_By>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Order_By>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  shortcode?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.box_content_plan */
export type Eatfresh_Box_Content_Plan_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.box_content_plan" */
export enum Eatfresh_Box_Content_Plan_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  FridgeOrderId = 'fridge_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  PackageId = 'package_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  Shortcode = 'shortcode',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "eatfresh.box_content_plan" */
export type Eatfresh_Box_Content_Plan_Set_Input = {
  box_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  package_id?: InputMaybe<Scalars['String']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  shortcode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Enum>;
};

/** columns and relationships of "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status = {
  __typename?: 'eatfresh_box_content_plan_status';
  /** An array relationship */
  box_content_plans: Array<Eatfresh_Box_Content_Plan>;
  /** An aggregate relationship */
  box_content_plans_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_StatusBox_Content_PlansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_StatusBox_Content_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};

/** aggregated selection of "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Aggregate = {
  __typename?: 'eatfresh_box_content_plan_status_aggregate';
  aggregate?: Maybe<Eatfresh_Box_Content_Plan_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Box_Content_Plan_Status>;
};

/** aggregate fields of "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_box_content_plan_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Box_Content_Plan_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Box_Content_Plan_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.box_content_plan_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Box_Content_Plan_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Bool_Exp>>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.box_content_plan_status" */
export enum Eatfresh_Box_Content_Plan_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  BoxContentPlanStatusPkey = 'box_content_plan_status_pkey'
}

export enum Eatfresh_Box_Content_Plan_Status_Enum {
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Deprecated */
  Deprecated = 'DEPRECATED',
  /** Error */
  Error = 'ERROR',
  /** Box content plan generated */
  Generated = 'GENERATED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Box matches content plan */
  Match = 'MATCH',
  /** Box does not match content plan */
  Mismatch = 'MISMATCH',
  /** The box has been picked up by the customer */
  PickedUp = 'PICKED_UP',
  /** Quarantined Box */
  Quarantined = 'QUARANTINED'
}

/** Boolean expression to compare columns of type "eatfresh_box_content_plan_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Box_Content_Plan_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Insert_Input = {
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Box_Content_Plan_Status_Max_Fields = {
  __typename?: 'eatfresh_box_content_plan_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Box_Content_Plan_Status_Min_Fields = {
  __typename?: 'eatfresh_box_content_plan_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Mutation_Response = {
  __typename?: 'eatfresh_box_content_plan_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Box_Content_Plan_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Box_Content_Plan_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Box_Content_Plan_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_On_Conflict = {
  constraint: Eatfresh_Box_Content_Plan_Status_Constraint;
  update_columns?: Array<Eatfresh_Box_Content_Plan_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.box_content_plan_status". */
export type Eatfresh_Box_Content_Plan_Status_Order_By = {
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.box_content_plan_status */
export type Eatfresh_Box_Content_Plan_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.box_content_plan_status" */
export enum Eatfresh_Box_Content_Plan_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_box_content_plan_status" */
export type Eatfresh_Box_Content_Plan_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Box_Content_Plan_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Box_Content_Plan_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.box_content_plan_status" */
export enum Eatfresh_Box_Content_Plan_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Box_Content_Plan_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Box_Content_Plan_Status_Bool_Exp;
};

/** Streaming cursor of the table "eatfresh_box_content_plan" */
export type Eatfresh_Box_Content_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Box_Content_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Box_Content_Plan_Stream_Cursor_Value_Input = {
  box_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  package_id?: InputMaybe<Scalars['String']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  shortcode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Enum>;
};

/** update columns of table "eatfresh.box_content_plan" */
export enum Eatfresh_Box_Content_Plan_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  FridgeOrderId = 'fridge_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  PackageId = 'package_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  Shortcode = 'shortcode',
  /** column name */
  Status = 'status'
}

export type Eatfresh_Box_Content_Plan_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Box_Content_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Box_Content_Plan_Bool_Exp;
};

/** columns and relationships of "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article = {
  __typename?: 'eatfresh_box_content_to_article';
  /** An object relationship */
  article: Eatfresh_Article;
  article_id: Scalars['uuid']['output'];
  box_content_id: Scalars['uuid']['output'];
  /** An object relationship */
  box_content_plan: Eatfresh_Box_Content_Plan;
  id: Scalars['uuid']['output'];
  quantity: Scalars['Int']['output'];
};

/** aggregated selection of "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Aggregate = {
  __typename?: 'eatfresh_box_content_to_article_aggregate';
  aggregate?: Maybe<Eatfresh_Box_Content_To_Article_Aggregate_Fields>;
  nodes: Array<Eatfresh_Box_Content_To_Article>;
};

export type Eatfresh_Box_Content_To_Article_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Box_Content_To_Article_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Box_Content_To_Article_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Aggregate_Fields = {
  __typename?: 'eatfresh_box_content_to_article_aggregate_fields';
  avg?: Maybe<Eatfresh_Box_Content_To_Article_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Box_Content_To_Article_Max_Fields>;
  min?: Maybe<Eatfresh_Box_Content_To_Article_Min_Fields>;
  stddev?: Maybe<Eatfresh_Box_Content_To_Article_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Box_Content_To_Article_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Box_Content_To_Article_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Box_Content_To_Article_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Box_Content_To_Article_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Box_Content_To_Article_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Box_Content_To_Article_Variance_Fields>;
};


/** aggregate fields of "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Box_Content_To_Article_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Box_Content_To_Article_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Box_Content_To_Article_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Box_Content_To_Article_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Box_Content_To_Article_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Box_Content_To_Article_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Box_Content_To_Article_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Box_Content_To_Article_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Box_Content_To_Article_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Box_Content_To_Article_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Box_Content_To_Article_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Box_Content_To_Article_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Box_Content_To_Article_Avg_Fields = {
  __typename?: 'eatfresh_box_content_to_article_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.box_content_to_article". All fields are combined with a logical 'AND'. */
export type Eatfresh_Box_Content_To_Article_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  box_content_id?: InputMaybe<Uuid_Comparison_Exp>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.box_content_to_article" */
export enum Eatfresh_Box_Content_To_Article_Constraint {
  /** unique or primary key constraint on columns "id" */
  BoxContentToArticlePkey = 'box_content_to_article_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  box_content_id?: InputMaybe<Scalars['uuid']['input']>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Box_Content_To_Article_Max_Fields = {
  __typename?: 'eatfresh_box_content_to_article_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  box_content_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  box_content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Box_Content_To_Article_Min_Fields = {
  __typename?: 'eatfresh_box_content_to_article_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  box_content_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  box_content_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Mutation_Response = {
  __typename?: 'eatfresh_box_content_to_article_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Box_Content_To_Article>;
};

/** on_conflict condition type for table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_On_Conflict = {
  constraint: Eatfresh_Box_Content_To_Article_Constraint;
  update_columns?: Array<Eatfresh_Box_Content_To_Article_Update_Column>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.box_content_to_article". */
export type Eatfresh_Box_Content_To_Article_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  box_content_id?: InputMaybe<Order_By>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.box_content_to_article */
export type Eatfresh_Box_Content_To_Article_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.box_content_to_article" */
export enum Eatfresh_Box_Content_To_Article_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BoxContentId = 'box_content_id',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity'
}

/** input type for updating data in table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  box_content_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Box_Content_To_Article_Stddev_Fields = {
  __typename?: 'eatfresh_box_content_to_article_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Box_Content_To_Article_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_box_content_to_article_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Box_Content_To_Article_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_box_content_to_article_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Box_Content_To_Article_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Box_Content_To_Article_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  box_content_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Box_Content_To_Article_Sum_Fields = {
  __typename?: 'eatfresh_box_content_to_article_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.box_content_to_article" */
export enum Eatfresh_Box_Content_To_Article_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BoxContentId = 'box_content_id',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity'
}

export type Eatfresh_Box_Content_To_Article_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Box_Content_To_Article_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Box_Content_To_Article_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Box_Content_To_Article_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Box_Content_To_Article_Var_Pop_Fields = {
  __typename?: 'eatfresh_box_content_to_article_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Box_Content_To_Article_Var_Samp_Fields = {
  __typename?: 'eatfresh_box_content_to_article_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Box_Content_To_Article_Variance_Fields = {
  __typename?: 'eatfresh_box_content_to_article_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.box_content_to_article" */
export type Eatfresh_Box_Content_To_Article_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process = {
  __typename?: 'eatfresh_commissioning_process';
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  box_content_plans: Array<Eatfresh_Box_Content_Plan>;
  /** An aggregate relationship */
  box_content_plans_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  /** An array relationship */
  commissioning_process_positions: Array<Eatfresh_Commissioning_Process_Position>;
  /** An aggregate relationship */
  commissioning_process_positions_aggregate: Eatfresh_Commissioning_Process_Position_Aggregate;
  /** An object relationship */
  commissioning_process_status: Eatfresh_Commissioning_Process_Status;
  cost: Scalars['Int']['output'];
  created_at: Scalars['timestamp']['output'];
  /** An object relationship */
  fridge_order: Eatfresh_Fridge_Order;
  fridge_order_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  logistics_problems: Array<Eatfresh_Logistics_Problem>;
  /** An aggregate relationship */
  logistics_problems_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  /** An array relationship */
  rfid_assets: Array<Eatfresh_Rfid_Asset>;
  /** An aggregate relationship */
  rfid_assets_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  /** An array relationship */
  rfid_boxes: Array<Eatfresh_Rfid_Box>;
  /** An aggregate relationship */
  rfid_boxes_aggregate: Eatfresh_Rfid_Box_Aggregate;
  /** An object relationship */
  rfid_scanner: Eatfresh_Rfid_Scanner;
  /** An array relationship */
  rfid_scans: Array<Eatfresh_Rfid_Scan>;
  /** An aggregate relationship */
  rfid_scans_aggregate: Eatfresh_Rfid_Scan_Aggregate;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  scanner_id: Scalars['uuid']['output'];
  status: Eatfresh_Commissioning_Process_Status_Enum;
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  warehouse: Eatfresh_Warehouse;
  warehouse_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessBox_Content_PlansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessBox_Content_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessCommissioning_Process_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessCommissioning_Process_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessLogistics_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessLogistics_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_BoxesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_Boxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_ScansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_Scans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_ProcessRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};

/** aggregated selection of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Aggregate = {
  __typename?: 'eatfresh_commissioning_process_aggregate';
  aggregate?: Maybe<Eatfresh_Commissioning_Process_Aggregate_Fields>;
  nodes: Array<Eatfresh_Commissioning_Process>;
};

export type Eatfresh_Commissioning_Process_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Commissioning_Process_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Aggregate_Fields = {
  __typename?: 'eatfresh_commissioning_process_aggregate_fields';
  avg?: Maybe<Eatfresh_Commissioning_Process_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Commissioning_Process_Max_Fields>;
  min?: Maybe<Eatfresh_Commissioning_Process_Min_Fields>;
  stddev?: Maybe<Eatfresh_Commissioning_Process_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Commissioning_Process_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Commissioning_Process_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Commissioning_Process_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Commissioning_Process_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Commissioning_Process_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Commissioning_Process_Variance_Fields>;
};


/** aggregate fields of "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Commissioning_Process_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Commissioning_Process_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Commissioning_Process_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Commissioning_Process_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Commissioning_Process_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Commissioning_Process_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Commissioning_Process_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Commissioning_Process_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Commissioning_Process_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Commissioning_Process_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Commissioning_Process_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Commissioning_Process_Avg_Fields = {
  __typename?: 'eatfresh_commissioning_process_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.commissioning_process". All fields are combined with a logical 'AND'. */
export type Eatfresh_Commissioning_Process_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Commissioning_Process_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Commissioning_Process_Bool_Exp>>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp>;
  commissioning_process_positions?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
  commissioning_process_positions_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Position_Aggregate_Bool_Exp>;
  commissioning_process_status?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
  fridge_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  scanner_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Commissioning_Process_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.commissioning_process" */
export enum Eatfresh_Commissioning_Process_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommissioningProcessPkey = 'commissioning_process_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Insert_Input = {
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Arr_Rel_Insert_Input>;
  commissioning_process_positions?: InputMaybe<Eatfresh_Commissioning_Process_Position_Arr_Rel_Insert_Input>;
  commissioning_process_status?: InputMaybe<Eatfresh_Commissioning_Process_Status_Obj_Rel_Insert_Input>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Obj_Rel_Insert_Input>;
  fridge_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Arr_Rel_Insert_Input>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Obj_Rel_Insert_Input>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Arr_Rel_Insert_Input>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Commissioning_Process_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Commissioning_Process_Max_Fields = {
  __typename?: 'eatfresh_commissioning_process_max_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fridge_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  scanner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Max_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scanner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Commissioning_Process_Min_Fields = {
  __typename?: 'eatfresh_commissioning_process_min_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fridge_order_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  scanner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Min_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scanner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Mutation_Response = {
  __typename?: 'eatfresh_commissioning_process_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Commissioning_Process>;
};

/** input type for inserting object relation for remote table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input = {
  data: Eatfresh_Commissioning_Process_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_On_Conflict = {
  constraint: Eatfresh_Commissioning_Process_Constraint;
  update_columns?: Array<Eatfresh_Commissioning_Process_Update_Column>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.commissioning_process". */
export type Eatfresh_Commissioning_Process_Order_By = {
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Order_By>;
  commissioning_process_positions_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Position_Aggregate_Order_By>;
  commissioning_process_status?: InputMaybe<Eatfresh_Commissioning_Process_Status_Order_By>;
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Order_By>;
  fridge_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Order_By>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Order_By>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Order_By>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Order_By>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  scanner_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.commissioning_process */
export type Eatfresh_Commissioning_Process_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position = {
  __typename?: 'eatfresh_commissioning_process_position';
  /** An object relationship */
  article: Eatfresh_Article;
  article_id: Scalars['uuid']['output'];
  commissioning_id: Scalars['uuid']['output'];
  /** An object relationship */
  commissioning_process: Eatfresh_Commissioning_Process;
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  quantity: Scalars['Int']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Aggregate = {
  __typename?: 'eatfresh_commissioning_process_position_aggregate';
  aggregate?: Maybe<Eatfresh_Commissioning_Process_Position_Aggregate_Fields>;
  nodes: Array<Eatfresh_Commissioning_Process_Position>;
};

export type Eatfresh_Commissioning_Process_Position_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Commissioning_Process_Position_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Commissioning_Process_Position_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Aggregate_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_aggregate_fields';
  avg?: Maybe<Eatfresh_Commissioning_Process_Position_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Commissioning_Process_Position_Max_Fields>;
  min?: Maybe<Eatfresh_Commissioning_Process_Position_Min_Fields>;
  stddev?: Maybe<Eatfresh_Commissioning_Process_Position_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Commissioning_Process_Position_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Commissioning_Process_Position_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Commissioning_Process_Position_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Commissioning_Process_Position_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Commissioning_Process_Position_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Commissioning_Process_Position_Variance_Fields>;
};


/** aggregate fields of "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Commissioning_Process_Position_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Commissioning_Process_Position_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Commissioning_Process_Position_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Commissioning_Process_Position_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Commissioning_Process_Position_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Commissioning_Process_Position_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Commissioning_Process_Position_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Commissioning_Process_Position_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Commissioning_Process_Position_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Commissioning_Process_Position_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Commissioning_Process_Position_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_Position_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Commissioning_Process_Position_Avg_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.commissioning_process_position". All fields are combined with a logical 'AND'. */
export type Eatfresh_Commissioning_Process_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.commissioning_process_position" */
export enum Eatfresh_Commissioning_Process_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommissioningProcessPositionPkey = 'commissioning_process_position_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Commissioning_Process_Position_Max_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Commissioning_Process_Position_Min_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Mutation_Response = {
  __typename?: 'eatfresh_commissioning_process_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Commissioning_Process_Position>;
};

/** on_conflict condition type for table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_On_Conflict = {
  constraint: Eatfresh_Commissioning_Process_Position_Constraint;
  update_columns?: Array<Eatfresh_Commissioning_Process_Position_Update_Column>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.commissioning_process_position". */
export type Eatfresh_Commissioning_Process_Position_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.commissioning_process_position */
export type Eatfresh_Commissioning_Process_Position_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.commissioning_process_position" */
export enum Eatfresh_Commissioning_Process_Position_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Commissioning_Process_Position_Stddev_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Commissioning_Process_Position_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Commissioning_Process_Position_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Commissioning_Process_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Commissioning_Process_Position_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Commissioning_Process_Position_Sum_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.commissioning_process_position" */
export enum Eatfresh_Commissioning_Process_Position_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Commissioning_Process_Position_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Commissioning_Process_Position_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Commissioning_Process_Position_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Commissioning_Process_Position_Var_Pop_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Commissioning_Process_Position_Var_Samp_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Commissioning_Process_Position_Variance_Fields = {
  __typename?: 'eatfresh_commissioning_process_position_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.commissioning_process_position" */
export type Eatfresh_Commissioning_Process_Position_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.commissioning_process" */
export enum Eatfresh_Commissioning_Process_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeOrderId = 'fridge_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ScannerId = 'scanner_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarehouseId = 'warehouse_id'
}

/** input type for updating data in table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Set_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Commissioning_Process_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status = {
  __typename?: 'eatfresh_commissioning_process_status';
  /** An array relationship */
  commissioning_processes: Array<Eatfresh_Commissioning_Process>;
  /** An aggregate relationship */
  commissioning_processes_aggregate: Eatfresh_Commissioning_Process_Aggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_StatusCommissioning_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_StatusCommissioning_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};

/** aggregated selection of "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Aggregate = {
  __typename?: 'eatfresh_commissioning_process_status_aggregate';
  aggregate?: Maybe<Eatfresh_Commissioning_Process_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Commissioning_Process_Status>;
};

/** aggregate fields of "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_commissioning_process_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Commissioning_Process_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Commissioning_Process_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.commissioning_process_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Commissioning_Process_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Bool_Exp>>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.commissioning_process_status" */
export enum Eatfresh_Commissioning_Process_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  CommissioningProcessStatusPkey = 'commissioning_process_status_pkey'
}

export enum Eatfresh_Commissioning_Process_Status_Enum {
  /** Commissioning process cancelled */
  Cancelled = 'CANCELLED',
  /** Commissioning process error */
  Error = 'ERROR',
  /** Commissioning process in progress */
  InProgress = 'IN_PROGRESS',
  /** Commissioning process paused */
  Paused = 'PAUSED',
  /** Commissioning process success */
  Success = 'SUCCESS'
}

/** Boolean expression to compare columns of type "eatfresh_commissioning_process_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Commissioning_Process_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Commissioning_Process_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Commissioning_Process_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Insert_Input = {
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Commissioning_Process_Status_Max_Fields = {
  __typename?: 'eatfresh_commissioning_process_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Commissioning_Process_Status_Min_Fields = {
  __typename?: 'eatfresh_commissioning_process_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Mutation_Response = {
  __typename?: 'eatfresh_commissioning_process_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Commissioning_Process_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Commissioning_Process_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_On_Conflict = {
  constraint: Eatfresh_Commissioning_Process_Status_Constraint;
  update_columns?: Array<Eatfresh_Commissioning_Process_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.commissioning_process_status". */
export type Eatfresh_Commissioning_Process_Status_Order_By = {
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.commissioning_process_status */
export type Eatfresh_Commissioning_Process_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.commissioning_process_status" */
export enum Eatfresh_Commissioning_Process_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_commissioning_process_status" */
export type Eatfresh_Commissioning_Process_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Commissioning_Process_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Commissioning_Process_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.commissioning_process_status" */
export enum Eatfresh_Commissioning_Process_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Commissioning_Process_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Commissioning_Process_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Eatfresh_Commissioning_Process_Stddev_Fields = {
  __typename?: 'eatfresh_commissioning_process_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Commissioning_Process_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_commissioning_process_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Commissioning_Process_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_commissioning_process_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_commissioning_process" */
export type Eatfresh_Commissioning_Process_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Commissioning_Process_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Commissioning_Process_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_order_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Commissioning_Process_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Commissioning_Process_Sum_Fields = {
  __typename?: 'eatfresh_commissioning_process_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.commissioning_process" */
export enum Eatfresh_Commissioning_Process_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeOrderId = 'fridge_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ScannerId = 'scanner_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarehouseId = 'warehouse_id'
}

export type Eatfresh_Commissioning_Process_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Commissioning_Process_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Commissioning_Process_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Commissioning_Process_Var_Pop_Fields = {
  __typename?: 'eatfresh_commissioning_process_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Commissioning_Process_Var_Samp_Fields = {
  __typename?: 'eatfresh_commissioning_process_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Commissioning_Process_Variance_Fields = {
  __typename?: 'eatfresh_commissioning_process_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.commissioning_process" */
export type Eatfresh_Commissioning_Process_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction = {
  __typename?: 'eatfresh_computop_transaction';
  amount: Scalars['String']['output'];
  trans_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction_Aggregate = {
  __typename?: 'eatfresh_computop_transaction_aggregate';
  aggregate?: Maybe<Eatfresh_Computop_Transaction_Aggregate_Fields>;
  nodes: Array<Eatfresh_Computop_Transaction>;
};

/** aggregate fields of "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction_Aggregate_Fields = {
  __typename?: 'eatfresh_computop_transaction_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Computop_Transaction_Max_Fields>;
  min?: Maybe<Eatfresh_Computop_Transaction_Min_Fields>;
};


/** aggregate fields of "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Computop_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.computop_transaction". All fields are combined with a logical 'AND'. */
export type Eatfresh_Computop_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Computop_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Computop_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Computop_Transaction_Bool_Exp>>;
  amount?: InputMaybe<String_Comparison_Exp>;
  trans_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.computop_transaction" */
export enum Eatfresh_Computop_Transaction_Constraint {
  /** unique or primary key constraint on columns "trans_id" */
  ComputopTransactionPkey = 'computop_transaction_pkey'
}

/** input type for inserting data into table "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction_Insert_Input = {
  amount?: InputMaybe<Scalars['String']['input']>;
  trans_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Computop_Transaction_Max_Fields = {
  __typename?: 'eatfresh_computop_transaction_max_fields';
  amount?: Maybe<Scalars['String']['output']>;
  trans_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Computop_Transaction_Min_Fields = {
  __typename?: 'eatfresh_computop_transaction_min_fields';
  amount?: Maybe<Scalars['String']['output']>;
  trans_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction_Mutation_Response = {
  __typename?: 'eatfresh_computop_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Computop_Transaction>;
};

/** on_conflict condition type for table "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction_On_Conflict = {
  constraint: Eatfresh_Computop_Transaction_Constraint;
  update_columns?: Array<Eatfresh_Computop_Transaction_Update_Column>;
  where?: InputMaybe<Eatfresh_Computop_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.computop_transaction". */
export type Eatfresh_Computop_Transaction_Order_By = {
  amount?: InputMaybe<Order_By>;
  trans_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.computop_transaction */
export type Eatfresh_Computop_Transaction_Pk_Columns_Input = {
  trans_id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.computop_transaction" */
export enum Eatfresh_Computop_Transaction_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  TransId = 'trans_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "eatfresh.computop_transaction" */
export type Eatfresh_Computop_Transaction_Set_Input = {
  amount?: InputMaybe<Scalars['String']['input']>;
  trans_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_computop_transaction" */
export type Eatfresh_Computop_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Computop_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Computop_Transaction_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['String']['input']>;
  trans_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.computop_transaction" */
export enum Eatfresh_Computop_Transaction_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  TransId = 'trans_id',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Computop_Transaction_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Computop_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Computop_Transaction_Bool_Exp;
};

/** columns and relationships of "eatfresh.connection_status" */
export type Eatfresh_Connection_Status = {
  __typename?: 'eatfresh_connection_status';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fridges: Array<Eatfresh_Fridge>;
  /** An aggregate relationship */
  fridges_aggregate: Eatfresh_Fridge_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.connection_status" */
export type Eatfresh_Connection_StatusFridgesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


/** columns and relationships of "eatfresh.connection_status" */
export type Eatfresh_Connection_StatusFridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};

/** aggregated selection of "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_Aggregate = {
  __typename?: 'eatfresh_connection_status_aggregate';
  aggregate?: Maybe<Eatfresh_Connection_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Connection_Status>;
};

/** aggregate fields of "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_connection_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Connection_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Connection_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Connection_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.connection_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Connection_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Connection_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Connection_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridges?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.connection_status" */
export enum Eatfresh_Connection_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ConnectionStatusPkey = 'connection_status_pkey'
}

export enum Eatfresh_Connection_Status_Enum {
  /** The fridge is offline */
  NoConnection = 'NO_CONNECTION',
  /** The fridge is online */
  Online = 'ONLINE'
}

/** Boolean expression to compare columns of type "eatfresh_connection_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Connection_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Connection_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Connection_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Connection_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Connection_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  fridges?: InputMaybe<Eatfresh_Fridge_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Connection_Status_Max_Fields = {
  __typename?: 'eatfresh_connection_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Connection_Status_Min_Fields = {
  __typename?: 'eatfresh_connection_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_Mutation_Response = {
  __typename?: 'eatfresh_connection_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Connection_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Connection_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Connection_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_On_Conflict = {
  constraint: Eatfresh_Connection_Status_Constraint;
  update_columns?: Array<Eatfresh_Connection_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.connection_status". */
export type Eatfresh_Connection_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.connection_status */
export type Eatfresh_Connection_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.connection_status" */
export enum Eatfresh_Connection_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.connection_status" */
export type Eatfresh_Connection_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_connection_status" */
export type Eatfresh_Connection_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Connection_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Connection_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.connection_status" */
export enum Eatfresh_Connection_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Connection_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Connection_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Connection_Status_Bool_Exp;
};

/** columns and relationships of "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration = {
  __typename?: 'eatfresh_cost_configuration';
  /** An object relationship */
  cost_configuration_key: Eatfresh_Cost_Configuration_Key;
  cost_key: Eatfresh_Cost_Configuration_Key_Enum;
  created_at: Scalars['timestamptz']['output'];
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value: Scalars['float8']['output'];
};

/** aggregated selection of "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Aggregate = {
  __typename?: 'eatfresh_cost_configuration_aggregate';
  aggregate?: Maybe<Eatfresh_Cost_Configuration_Aggregate_Fields>;
  nodes: Array<Eatfresh_Cost_Configuration>;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Var_Samp>;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Avg = {
  arguments: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Corr = {
  arguments: Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Max = {
  arguments: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Min = {
  arguments: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Sum = {
  arguments: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Aggregate_Fields = {
  __typename?: 'eatfresh_cost_configuration_aggregate_fields';
  avg?: Maybe<Eatfresh_Cost_Configuration_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Cost_Configuration_Max_Fields>;
  min?: Maybe<Eatfresh_Cost_Configuration_Min_Fields>;
  stddev?: Maybe<Eatfresh_Cost_Configuration_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Cost_Configuration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Cost_Configuration_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Cost_Configuration_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Cost_Configuration_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Cost_Configuration_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Cost_Configuration_Variance_Fields>;
};


/** aggregate fields of "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Cost_Configuration_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Cost_Configuration_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Cost_Configuration_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Cost_Configuration_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Cost_Configuration_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Cost_Configuration_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Cost_Configuration_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Cost_Configuration_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Cost_Configuration_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Cost_Configuration_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Cost_Configuration_Insert_Input>;
};

/** aggregate avg on columns */
export type Eatfresh_Cost_Configuration_Avg_Fields = {
  __typename?: 'eatfresh_cost_configuration_avg_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.cost_configuration". All fields are combined with a logical 'AND'. */
export type Eatfresh_Cost_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Cost_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Cost_Configuration_Bool_Exp>>;
  cost_configuration_key?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
  cost_key?: InputMaybe<Eatfresh_Cost_Configuration_Key_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deprecated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Inc_Input = {
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Insert_Input = {
  cost_configuration_key?: InputMaybe<Eatfresh_Cost_Configuration_Key_Obj_Rel_Insert_Input>;
  cost_key?: InputMaybe<Eatfresh_Cost_Configuration_Key_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** columns and relationships of "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key = {
  __typename?: 'eatfresh_cost_configuration_key';
  /** An array relationship */
  cost_configurations: Array<Eatfresh_Cost_Configuration>;
  /** An aggregate relationship */
  cost_configurations_aggregate: Eatfresh_Cost_Configuration_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_KeyCost_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
};


/** columns and relationships of "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_KeyCost_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
};

/** aggregated selection of "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Aggregate = {
  __typename?: 'eatfresh_cost_configuration_key_aggregate';
  aggregate?: Maybe<Eatfresh_Cost_Configuration_Key_Aggregate_Fields>;
  nodes: Array<Eatfresh_Cost_Configuration_Key>;
};

/** aggregate fields of "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Aggregate_Fields = {
  __typename?: 'eatfresh_cost_configuration_key_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Cost_Configuration_Key_Max_Fields>;
  min?: Maybe<Eatfresh_Cost_Configuration_Key_Min_Fields>;
};


/** aggregate fields of "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.cost_configuration_key". All fields are combined with a logical 'AND'. */
export type Eatfresh_Cost_Configuration_Key_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Bool_Exp>>;
  cost_configurations?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
  cost_configurations_aggregate?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.cost_configuration_key" */
export enum Eatfresh_Cost_Configuration_Key_Constraint {
  /** unique or primary key constraint on columns "value" */
  CostConfigurationKeyPkey = 'cost_configuration_key_pkey'
}

export enum Eatfresh_Cost_Configuration_Key_Enum {
  /** Cost of Labor per product for Commissioning. */
  CommissioningPerProduct = 'commissioning_per_product',
  /** Cost of Labor per product for Labeling. */
  LabelingPerProduct = 'labeling_per_product',
  /** Percentage of the total sum that is charged by Nexi. */
  NexiPercentage = 'nexi_percentage',
  /** Cost of Labor per product for Receipt Inspection. */
  WarehouseOrderReceiptPerProduct = 'warehouse_order_receipt_per_product'
}

/** Boolean expression to compare columns of type "eatfresh_cost_configuration_key_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Cost_Configuration_Key_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Cost_Configuration_Key_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Cost_Configuration_Key_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Enum>>;
};

/** input type for inserting data into table "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Insert_Input = {
  cost_configurations?: InputMaybe<Eatfresh_Cost_Configuration_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Cost_Configuration_Key_Max_Fields = {
  __typename?: 'eatfresh_cost_configuration_key_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Cost_Configuration_Key_Min_Fields = {
  __typename?: 'eatfresh_cost_configuration_key_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Mutation_Response = {
  __typename?: 'eatfresh_cost_configuration_key_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Cost_Configuration_Key>;
};

/** input type for inserting object relation for remote table "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Obj_Rel_Insert_Input = {
  data: Eatfresh_Cost_Configuration_Key_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Cost_Configuration_Key_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_On_Conflict = {
  constraint: Eatfresh_Cost_Configuration_Key_Constraint;
  update_columns?: Array<Eatfresh_Cost_Configuration_Key_Update_Column>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.cost_configuration_key". */
export type Eatfresh_Cost_Configuration_Key_Order_By = {
  cost_configurations_aggregate?: InputMaybe<Eatfresh_Cost_Configuration_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.cost_configuration_key */
export type Eatfresh_Cost_Configuration_Key_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.cost_configuration_key" */
export enum Eatfresh_Cost_Configuration_Key_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_cost_configuration_key" */
export type Eatfresh_Cost_Configuration_Key_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Cost_Configuration_Key_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Cost_Configuration_Key_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.cost_configuration_key" */
export enum Eatfresh_Cost_Configuration_Key_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Cost_Configuration_Key_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Cost_Configuration_Key_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Cost_Configuration_Key_Bool_Exp;
};

/** aggregate max on columns */
export type Eatfresh_Cost_Configuration_Max_Fields = {
  __typename?: 'eatfresh_cost_configuration_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Cost_Configuration_Min_Fields = {
  __typename?: 'eatfresh_cost_configuration_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Mutation_Response = {
  __typename?: 'eatfresh_cost_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Cost_Configuration>;
};

/** Ordering options when selecting data from "eatfresh.cost_configuration". */
export type Eatfresh_Cost_Configuration_Order_By = {
  cost_configuration_key?: InputMaybe<Eatfresh_Cost_Configuration_Key_Order_By>;
  cost_key?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column {
  /** column name */
  CostKey = 'cost_key',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_avg_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_corr_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_max_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_min_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_sum_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** select "eatfresh_cost_configuration_aggregate_bool_exp_var_samp_arguments_columns" columns of table "eatfresh.cost_configuration" */
export enum Eatfresh_Cost_Configuration_Select_Column_Eatfresh_Cost_Configuration_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Set_Input = {
  cost_key?: InputMaybe<Eatfresh_Cost_Configuration_Key_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Cost_Configuration_Stddev_Fields = {
  __typename?: 'eatfresh_cost_configuration_stddev_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Cost_Configuration_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_cost_configuration_stddev_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Cost_Configuration_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_cost_configuration_stddev_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_cost_configuration" */
export type Eatfresh_Cost_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Cost_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Cost_Configuration_Stream_Cursor_Value_Input = {
  cost_key?: InputMaybe<Eatfresh_Cost_Configuration_Key_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Cost_Configuration_Sum_Fields = {
  __typename?: 'eatfresh_cost_configuration_sum_fields';
  value?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Eatfresh_Cost_Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Cost_Configuration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Cost_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Cost_Configuration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Cost_Configuration_Var_Pop_Fields = {
  __typename?: 'eatfresh_cost_configuration_var_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Cost_Configuration_Var_Samp_Fields = {
  __typename?: 'eatfresh_cost_configuration_var_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Cost_Configuration_Variance_Fields = {
  __typename?: 'eatfresh_cost_configuration_variance_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.cost_configuration" */
export type Eatfresh_Cost_Configuration_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.customer" */
export type Eatfresh_Customer = {
  __typename?: 'eatfresh_customer';
  address_line_2?: Maybe<Scalars['String']['output']>;
  address_name_1: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  payment_method?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  street_and_number_3: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
  zip: Scalars['String']['output'];
};

/** aggregated selection of "eatfresh.customer" */
export type Eatfresh_Customer_Aggregate = {
  __typename?: 'eatfresh_customer_aggregate';
  aggregate?: Maybe<Eatfresh_Customer_Aggregate_Fields>;
  nodes: Array<Eatfresh_Customer>;
};

/** aggregate fields of "eatfresh.customer" */
export type Eatfresh_Customer_Aggregate_Fields = {
  __typename?: 'eatfresh_customer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Customer_Max_Fields>;
  min?: Maybe<Eatfresh_Customer_Min_Fields>;
};


/** aggregate fields of "eatfresh.customer" */
export type Eatfresh_Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.customer". All fields are combined with a logical 'AND'. */
export type Eatfresh_Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Customer_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Customer_Bool_Exp>>;
  address_line_2?: InputMaybe<String_Comparison_Exp>;
  address_name_1?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_method?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  street_and_number_3?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.customer" */
export enum Eatfresh_Customer_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  CustomerPkey = 'customer_pkey'
}

/** input type for inserting data into table "eatfresh.customer" */
export type Eatfresh_Customer_Insert_Input = {
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  address_name_1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street_and_number_3?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Customer_Max_Fields = {
  __typename?: 'eatfresh_customer_max_fields';
  address_line_2?: Maybe<Scalars['String']['output']>;
  address_name_1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  street_and_number_3?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Customer_Min_Fields = {
  __typename?: 'eatfresh_customer_min_fields';
  address_line_2?: Maybe<Scalars['String']['output']>;
  address_name_1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  street_and_number_3?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.customer" */
export type Eatfresh_Customer_Mutation_Response = {
  __typename?: 'eatfresh_customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Customer>;
};

/** input type for inserting object relation for remote table "eatfresh.customer" */
export type Eatfresh_Customer_Obj_Rel_Insert_Input = {
  data: Eatfresh_Customer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Customer_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.customer" */
export type Eatfresh_Customer_On_Conflict = {
  constraint: Eatfresh_Customer_Constraint;
  update_columns?: Array<Eatfresh_Customer_Update_Column>;
  where?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
};

/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_Order = {
  __typename?: 'eatfresh_customer_order';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount: Scalars['bigint']['output'];
  created: Scalars['timestamptz']['output'];
  demo_flag?: Maybe<Scalars['Boolean']['output']>;
  door_closed_at?: Maybe<Scalars['timestamptz']['output']>;
  door_opened?: Maybe<Scalars['Boolean']['output']>;
  door_opened_at?: Maybe<Scalars['timestamptz']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  gross_total_sum?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['uuid']['output'];
  is_anonymous?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  orderStatusByOrderStatus: Eatfresh_Order_Status;
  /** An array relationship */
  order_extra_customer_orders: Array<Eatfresh_Order_Extra_Customer_Order>;
  /** An aggregate relationship */
  order_extra_customer_orders_aggregate: Eatfresh_Order_Extra_Customer_Order_Aggregate;
  /** An array relationship */
  order_positions: Array<Eatfresh_Order_Position>;
  /** An aggregate relationship */
  order_positions_aggregate: Eatfresh_Order_Position_Aggregate;
  order_status: Eatfresh_Order_Status_Enum;
  /** An object relationship */
  paymentMethodByPaymentMethodId?: Maybe<Eatfresh_Payment_Method>;
  /** An object relationship */
  paymentMethodByTransId?: Maybe<Eatfresh_Payment_Method>;
  /** An object relationship */
  paymentStatusByPaymentStatus: Eatfresh_Payment_Status;
  payment_added_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_cost: Scalars['Int']['output'];
  payment_details?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['String']['output']>;
  payment_status: Eatfresh_Payment_Status_Enum;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  total_sum: Scalars['bigint']['output'];
  trans_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  transaction_logs: Array<Eatfresh_Transaction_Logs>;
  /** An aggregate relationship */
  transaction_logs_aggregate: Eatfresh_Transaction_Logs_Aggregate;
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_account?: Maybe<Eatfresh_User_Account>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderOrder_Extra_Customer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderOrder_Extra_Customer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderOrder_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderOrder_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderTransaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};


/** columns and relationships of "eatfresh.customer_order" */
export type Eatfresh_Customer_OrderTransaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};

/** aggregated selection of "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Aggregate = {
  __typename?: 'eatfresh_customer_order_aggregate';
  aggregate?: Maybe<Eatfresh_Customer_Order_Aggregate_Fields>;
  nodes: Array<Eatfresh_Customer_Order>;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp_Var_Samp>;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Avg = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Corr = {
  arguments: Eatfresh_Customer_Order_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Eatfresh_Customer_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Max = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Min = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Sum = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Customer_Order_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Aggregate_Fields = {
  __typename?: 'eatfresh_customer_order_aggregate_fields';
  avg?: Maybe<Eatfresh_Customer_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Customer_Order_Max_Fields>;
  min?: Maybe<Eatfresh_Customer_Order_Min_Fields>;
  stddev?: Maybe<Eatfresh_Customer_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Customer_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Customer_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Customer_Order_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Customer_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Customer_Order_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Customer_Order_Variance_Fields>;
};


/** aggregate fields of "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Customer_Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Customer_Order_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Customer_Order_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Customer_Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Customer_Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Customer_Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Customer_Order_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Customer_Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Customer_Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Customer_Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Customer_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Customer_Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Customer_Order_Avg_Fields = {
  __typename?: 'eatfresh_customer_order_avg_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['Float']['output']>;
  gross_total_sum?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  payment_cost?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Avg_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.customer_order". All fields are combined with a logical 'AND'. */
export type Eatfresh_Customer_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Customer_Order_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Customer_Order_Bool_Exp>>;
  collected_amount?: InputMaybe<Bigint_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  demo_flag?: InputMaybe<Boolean_Comparison_Exp>;
  door_closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  door_opened?: InputMaybe<Boolean_Comparison_Exp>;
  door_opened_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  finished_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  given_id?: InputMaybe<String_Comparison_Exp>;
  gross_total_sum?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_anonymous?: InputMaybe<Boolean_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  orderStatusByOrderStatus?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
  order_extra_customer_orders?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
  order_extra_customer_orders_aggregate?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Aggregate_Bool_Exp>;
  order_positions?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
  order_positions_aggregate?: InputMaybe<Eatfresh_Order_Position_Aggregate_Bool_Exp>;
  order_status?: InputMaybe<Eatfresh_Order_Status_Enum_Comparison_Exp>;
  paymentMethodByPaymentMethodId?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  paymentMethodByTransId?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  paymentStatusByPaymentStatus?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
  payment_added_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_cost?: InputMaybe<Int_Comparison_Exp>;
  payment_details?: InputMaybe<String_Comparison_Exp>;
  payment_method?: InputMaybe<String_Comparison_Exp>;
  payment_method_id?: InputMaybe<String_Comparison_Exp>;
  payment_status?: InputMaybe<Eatfresh_Payment_Status_Enum_Comparison_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  total_sum?: InputMaybe<Bigint_Comparison_Exp>;
  trans_id?: InputMaybe<String_Comparison_Exp>;
  transaction_logs?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
  transaction_logs_aggregate?: InputMaybe<Eatfresh_Transaction_Logs_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "eatfresh.customer". */
export type Eatfresh_Customer_Order_By = {
  address_line_2?: InputMaybe<Order_By>;
  address_name_1?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  street_and_number_3?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshCustomerOrderPkey = 'eatfresh_customer_order_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Inc_Input = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Scalars['bigint']['input']>;
  gross_total_sum?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  payment_cost?: InputMaybe<Scalars['Int']['input']>;
  total_sum?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Insert_Input = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Scalars['bigint']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  door_closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  door_opened?: InputMaybe<Scalars['Boolean']['input']>;
  door_opened_at?: InputMaybe<Scalars['timestamptz']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  gross_total_sum?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  orderStatusByOrderStatus?: InputMaybe<Eatfresh_Order_Status_Obj_Rel_Insert_Input>;
  order_extra_customer_orders?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Arr_Rel_Insert_Input>;
  order_positions?: InputMaybe<Eatfresh_Order_Position_Arr_Rel_Insert_Input>;
  order_status?: InputMaybe<Eatfresh_Order_Status_Enum>;
  paymentMethodByPaymentMethodId?: InputMaybe<Eatfresh_Payment_Method_Obj_Rel_Insert_Input>;
  paymentMethodByTransId?: InputMaybe<Eatfresh_Payment_Method_Obj_Rel_Insert_Input>;
  paymentStatusByPaymentStatus?: InputMaybe<Eatfresh_Payment_Status_Obj_Rel_Insert_Input>;
  payment_added_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_cost?: InputMaybe<Scalars['Int']['input']>;
  payment_details?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Eatfresh_Payment_Status_Enum>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  total_sum?: InputMaybe<Scalars['bigint']['input']>;
  trans_id?: InputMaybe<Scalars['String']['input']>;
  transaction_logs?: InputMaybe<Eatfresh_Transaction_Logs_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Customer_Order_Max_Fields = {
  __typename?: 'eatfresh_customer_order_max_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['bigint']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  door_closed_at?: Maybe<Scalars['timestamptz']['output']>;
  door_opened_at?: Maybe<Scalars['timestamptz']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  gross_total_sum?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  payment_added_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_cost?: Maybe<Scalars['Int']['output']>;
  payment_details?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['String']['output']>;
  total_sum?: Maybe<Scalars['bigint']['output']>;
  trans_id?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Max_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  door_closed_at?: InputMaybe<Order_By>;
  door_opened_at?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_added_at?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  payment_details?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
  trans_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Customer_Order_Min_Fields = {
  __typename?: 'eatfresh_customer_order_min_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['bigint']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  door_closed_at?: Maybe<Scalars['timestamptz']['output']>;
  door_opened_at?: Maybe<Scalars['timestamptz']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  gross_total_sum?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  payment_added_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_cost?: Maybe<Scalars['Int']['output']>;
  payment_details?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['String']['output']>;
  total_sum?: Maybe<Scalars['bigint']['output']>;
  trans_id?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Min_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  door_closed_at?: InputMaybe<Order_By>;
  door_opened_at?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_added_at?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  payment_details?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
  trans_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Mutation_Response = {
  __typename?: 'eatfresh_customer_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Customer_Order>;
};

/** input type for inserting object relation for remote table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Obj_Rel_Insert_Input = {
  data: Eatfresh_Customer_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Customer_Order_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_On_Conflict = {
  constraint: Eatfresh_Customer_Order_Constraint;
  update_columns?: Array<Eatfresh_Customer_Order_Update_Column>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.customer_order". */
export type Eatfresh_Customer_Order_Order_By = {
  collected_amount?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  demo_flag?: InputMaybe<Order_By>;
  door_closed_at?: InputMaybe<Order_By>;
  door_opened?: InputMaybe<Order_By>;
  door_opened_at?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_anonymous?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  orderStatusByOrderStatus?: InputMaybe<Eatfresh_Order_Status_Order_By>;
  order_extra_customer_orders_aggregate?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Aggregate_Order_By>;
  order_positions_aggregate?: InputMaybe<Eatfresh_Order_Position_Aggregate_Order_By>;
  order_status?: InputMaybe<Order_By>;
  paymentMethodByPaymentMethodId?: InputMaybe<Eatfresh_Payment_Method_Order_By>;
  paymentMethodByTransId?: InputMaybe<Eatfresh_Payment_Method_Order_By>;
  paymentStatusByPaymentStatus?: InputMaybe<Eatfresh_Payment_Status_Order_By>;
  payment_added_at?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  payment_details?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  total_sum?: InputMaybe<Order_By>;
  trans_id?: InputMaybe<Order_By>;
  transaction_logs_aggregate?: InputMaybe<Eatfresh_Transaction_Logs_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.customer_order */
export type Eatfresh_Customer_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column {
  /** column name */
  CollectedAmount = 'collected_amount',
  /** column name */
  Created = 'created',
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  DoorClosedAt = 'door_closed_at',
  /** column name */
  DoorOpened = 'door_opened',
  /** column name */
  DoorOpenedAt = 'door_opened_at',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  GrossTotalSum = 'gross_total_sum',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Location = 'location',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  OrderStatus = 'order_status',
  /** column name */
  PaymentAddedAt = 'payment_added_at',
  /** column name */
  PaymentCost = 'payment_cost',
  /** column name */
  PaymentDetails = 'payment_details',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  TotalSum = 'total_sum',
  /** column name */
  TransId = 'trans_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserId = 'user_id'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_avg_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  DoorOpened = 'door_opened',
  /** column name */
  IsAnonymous = 'is_anonymous'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  DoorOpened = 'door_opened',
  /** column name */
  IsAnonymous = 'is_anonymous'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_corr_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_max_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_min_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_sum_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_customer_order_aggregate_bool_exp_var_samp_arguments_columns" columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Select_Column_Eatfresh_Customer_Order_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** input type for updating data in table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Set_Input = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Scalars['bigint']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  door_closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  door_opened?: InputMaybe<Scalars['Boolean']['input']>;
  door_opened_at?: InputMaybe<Scalars['timestamptz']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  gross_total_sum?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  order_status?: InputMaybe<Eatfresh_Order_Status_Enum>;
  payment_added_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_cost?: InputMaybe<Scalars['Int']['input']>;
  payment_details?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Eatfresh_Payment_Status_Enum>;
  total_sum?: InputMaybe<Scalars['bigint']['input']>;
  trans_id?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Customer_Order_Stddev_Fields = {
  __typename?: 'eatfresh_customer_order_stddev_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['Float']['output']>;
  gross_total_sum?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  payment_cost?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Stddev_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Customer_Order_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_customer_order_stddev_pop_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['Float']['output']>;
  gross_total_sum?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  payment_cost?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Stddev_Pop_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Customer_Order_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_customer_order_stddev_samp_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['Float']['output']>;
  gross_total_sum?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  payment_cost?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Stddev_Samp_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_customer_order" */
export type Eatfresh_Customer_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Customer_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Customer_Order_Stream_Cursor_Value_Input = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Scalars['bigint']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  door_closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  door_opened?: InputMaybe<Scalars['Boolean']['input']>;
  door_opened_at?: InputMaybe<Scalars['timestamptz']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  gross_total_sum?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  order_status?: InputMaybe<Eatfresh_Order_Status_Enum>;
  payment_added_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_cost?: InputMaybe<Scalars['Int']['input']>;
  payment_details?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Eatfresh_Payment_Status_Enum>;
  total_sum?: InputMaybe<Scalars['bigint']['input']>;
  trans_id?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Customer_Order_Sum_Fields = {
  __typename?: 'eatfresh_customer_order_sum_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['bigint']['output']>;
  gross_total_sum?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  payment_cost?: Maybe<Scalars['Int']['output']>;
  total_sum?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Sum_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.customer_order" */
export enum Eatfresh_Customer_Order_Update_Column {
  /** column name */
  CollectedAmount = 'collected_amount',
  /** column name */
  Created = 'created',
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  DoorClosedAt = 'door_closed_at',
  /** column name */
  DoorOpened = 'door_opened',
  /** column name */
  DoorOpenedAt = 'door_opened_at',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  GrossTotalSum = 'gross_total_sum',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Location = 'location',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  OrderStatus = 'order_status',
  /** column name */
  PaymentAddedAt = 'payment_added_at',
  /** column name */
  PaymentCost = 'payment_cost',
  /** column name */
  PaymentDetails = 'payment_details',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  TotalSum = 'total_sum',
  /** column name */
  TransId = 'trans_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Customer_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Customer_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Customer_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Customer_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Customer_Order_Var_Pop_Fields = {
  __typename?: 'eatfresh_customer_order_var_pop_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['Float']['output']>;
  gross_total_sum?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  payment_cost?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Var_Pop_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Customer_Order_Var_Samp_Fields = {
  __typename?: 'eatfresh_customer_order_var_samp_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['Float']['output']>;
  gross_total_sum?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  payment_cost?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Var_Samp_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Customer_Order_Variance_Fields = {
  __typename?: 'eatfresh_customer_order_variance_fields';
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: Maybe<Scalars['Float']['output']>;
  gross_total_sum?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  payment_cost?: Maybe<Scalars['Float']['output']>;
  total_sum?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.customer_order" */
export type Eatfresh_Customer_Order_Variance_Order_By = {
  /** Cents actually collected from the customer for this order (paygate-confirmed captures + charges). 0 for orders before 2026-08 — not backfilled. */
  collected_amount?: InputMaybe<Order_By>;
  gross_total_sum?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  payment_cost?: InputMaybe<Order_By>;
  total_sum?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.customer */
export type Eatfresh_Customer_Pk_Columns_Input = {
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.customer" */
export enum Eatfresh_Customer_Select_Column {
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  AddressName_1 = 'address_name_1',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  Phone = 'phone',
  /** column name */
  StreetAndNumber_3 = 'street_and_number_3',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "eatfresh.customer" */
export type Eatfresh_Customer_Set_Input = {
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  address_name_1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street_and_number_3?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_customer" */
export type Eatfresh_Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Customer_Stream_Cursor_Value_Input = {
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  address_name_1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street_and_number_3?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.customer" */
export enum Eatfresh_Customer_Update_Column {
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  AddressName_1 = 'address_name_1',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  Phone = 'phone',
  /** column name */
  StreetAndNumber_3 = 'street_and_number_3',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Zip = 'zip'
}

export type Eatfresh_Customer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Customer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Customer_Bool_Exp;
};

/** columns and relationships of "eatfresh.door_status" */
export type Eatfresh_Door_Status = {
  __typename?: 'eatfresh_door_status';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fridges: Array<Eatfresh_Fridge>;
  /** An aggregate relationship */
  fridges_aggregate: Eatfresh_Fridge_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.door_status" */
export type Eatfresh_Door_StatusFridgesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


/** columns and relationships of "eatfresh.door_status" */
export type Eatfresh_Door_StatusFridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};

/** aggregated selection of "eatfresh.door_status" */
export type Eatfresh_Door_Status_Aggregate = {
  __typename?: 'eatfresh_door_status_aggregate';
  aggregate?: Maybe<Eatfresh_Door_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Door_Status>;
};

/** aggregate fields of "eatfresh.door_status" */
export type Eatfresh_Door_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_door_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Door_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Door_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.door_status" */
export type Eatfresh_Door_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Door_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.door_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Door_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Door_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Door_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridges?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.door_status" */
export enum Eatfresh_Door_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  DoorStatusPkey = 'door_status_pkey'
}

export enum Eatfresh_Door_Status_Enum {
  /** The door is closed */
  Closed = 'CLOSED',
  /** The door is open */
  Open = 'OPEN',
  /** The door is in unlocked */
  Unlocked = 'UNLOCKED'
}

/** Boolean expression to compare columns of type "eatfresh_door_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Door_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Door_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Door_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Door_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Door_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.door_status" */
export type Eatfresh_Door_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  fridges?: InputMaybe<Eatfresh_Fridge_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Door_Status_Max_Fields = {
  __typename?: 'eatfresh_door_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Door_Status_Min_Fields = {
  __typename?: 'eatfresh_door_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.door_status" */
export type Eatfresh_Door_Status_Mutation_Response = {
  __typename?: 'eatfresh_door_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Door_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.door_status" */
export type Eatfresh_Door_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Door_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Door_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.door_status" */
export type Eatfresh_Door_Status_On_Conflict = {
  constraint: Eatfresh_Door_Status_Constraint;
  update_columns?: Array<Eatfresh_Door_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.door_status". */
export type Eatfresh_Door_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.door_status */
export type Eatfresh_Door_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.door_status" */
export enum Eatfresh_Door_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.door_status" */
export type Eatfresh_Door_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_door_status" */
export type Eatfresh_Door_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Door_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Door_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.door_status" */
export enum Eatfresh_Door_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Door_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Door_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Door_Status_Bool_Exp;
};

/** columns and relationships of "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission = {
  __typename?: 'eatfresh_easy_refill_permission';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Aggregate = {
  __typename?: 'eatfresh_easy_refill_permission_aggregate';
  aggregate?: Maybe<Eatfresh_Easy_Refill_Permission_Aggregate_Fields>;
  nodes: Array<Eatfresh_Easy_Refill_Permission>;
};

export type Eatfresh_Easy_Refill_Permission_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Easy_Refill_Permission_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Easy_Refill_Permission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Aggregate_Fields = {
  __typename?: 'eatfresh_easy_refill_permission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Easy_Refill_Permission_Max_Fields>;
  min?: Maybe<Eatfresh_Easy_Refill_Permission_Min_Fields>;
};


/** aggregate fields of "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Easy_Refill_Permission_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Easy_Refill_Permission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Easy_Refill_Permission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Easy_Refill_Permission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.easy_refill_permission". All fields are combined with a logical 'AND'. */
export type Eatfresh_Easy_Refill_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  revoked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.easy_refill_permission" */
export enum Eatfresh_Easy_Refill_Permission_Constraint {
  /** unique or primary key constraint on columns "id" */
  EasyRefillPermissionPkey = 'easy_refill_permission_pkey'
}

/** input type for inserting data into table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revoked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Easy_Refill_Permission_Max_Fields = {
  __typename?: 'eatfresh_easy_refill_permission_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Easy_Refill_Permission_Min_Fields = {
  __typename?: 'eatfresh_easy_refill_permission_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Mutation_Response = {
  __typename?: 'eatfresh_easy_refill_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Easy_Refill_Permission>;
};

/** on_conflict condition type for table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_On_Conflict = {
  constraint: Eatfresh_Easy_Refill_Permission_Constraint;
  update_columns?: Array<Eatfresh_Easy_Refill_Permission_Update_Column>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.easy_refill_permission". */
export type Eatfresh_Easy_Refill_Permission_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.easy_refill_permission */
export type Eatfresh_Easy_Refill_Permission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.easy_refill_permission" */
export enum Eatfresh_Easy_Refill_Permission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  RevokedAt = 'revoked_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "eatfresh.easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revoked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_easy_refill_permission" */
export type Eatfresh_Easy_Refill_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Easy_Refill_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Easy_Refill_Permission_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revoked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.easy_refill_permission" */
export enum Eatfresh_Easy_Refill_Permission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  RevokedAt = 'revoked_at',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Easy_Refill_Permission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Easy_Refill_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Easy_Refill_Permission_Bool_Exp;
};

/** columns and relationships of "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot = {
  __typename?: 'eatfresh_external_warehouse_pallet_spot';
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  external_warehouse: Eatfresh_Warehouse;
  external_warehouse_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  warehouse: Eatfresh_Warehouse;
  warehouse_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_SpotAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_SpotAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};

/** aggregated selection of "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Aggregate = {
  __typename?: 'eatfresh_external_warehouse_pallet_spot_aggregate';
  aggregate?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Fields>;
  nodes: Array<Eatfresh_External_Warehouse_Pallet_Spot>;
};

export type Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Fields = {
  __typename?: 'eatfresh_external_warehouse_pallet_spot_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot_Max_Fields>;
  min?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot_Min_Fields>;
};


/** aggregate fields of "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Max_Order_By>;
  min?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_External_Warehouse_Pallet_Spot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.external_warehouse_pallet_spot". All fields are combined with a logical 'AND'. */
export type Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  external_warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.external_warehouse_pallet_spot" */
export enum Eatfresh_External_Warehouse_Pallet_Spot_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExternalWarehousePalletSpotPkey = 'external_warehouse_pallet_spot_pkey',
  /** unique or primary key constraint on columns "warehouse_id", "external_warehouse_id" */
  ExternalWarehousePalletSpotRouteUnique = 'external_warehouse_pallet_spot_route_unique'
}

/** input type for inserting data into table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Insert_Input = {
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  external_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_External_Warehouse_Pallet_Spot_Max_Fields = {
  __typename?: 'eatfresh_external_warehouse_pallet_spot_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_warehouse_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_External_Warehouse_Pallet_Spot_Min_Fields = {
  __typename?: 'eatfresh_external_warehouse_pallet_spot_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_warehouse_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Mutation_Response = {
  __typename?: 'eatfresh_external_warehouse_pallet_spot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_External_Warehouse_Pallet_Spot>;
};

/** input type for inserting object relation for remote table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Obj_Rel_Insert_Input = {
  data: Eatfresh_External_Warehouse_Pallet_Spot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_On_Conflict = {
  constraint: Eatfresh_External_Warehouse_Pallet_Spot_Constraint;
  update_columns?: Array<Eatfresh_External_Warehouse_Pallet_Spot_Update_Column>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.external_warehouse_pallet_spot". */
export type Eatfresh_External_Warehouse_Pallet_Spot_Order_By = {
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  external_warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  external_warehouse_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.external_warehouse_pallet_spot */
export type Eatfresh_External_Warehouse_Pallet_Spot_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.external_warehouse_pallet_spot" */
export enum Eatfresh_External_Warehouse_Pallet_Spot_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalWarehouseId = 'external_warehouse_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

/** input type for updating data in table "eatfresh.external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_external_warehouse_pallet_spot" */
export type Eatfresh_External_Warehouse_Pallet_Spot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_External_Warehouse_Pallet_Spot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_External_Warehouse_Pallet_Spot_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.external_warehouse_pallet_spot" */
export enum Eatfresh_External_Warehouse_Pallet_Spot_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalWarehouseId = 'external_warehouse_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

export type Eatfresh_External_Warehouse_Pallet_Spot_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp;
};

/** columns and relationships of "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History = {
  __typename?: 'eatfresh_flyway_schema_history';
  checksum?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  execution_time: Scalars['Int']['output'];
  installed_by: Scalars['String']['output'];
  installed_on: Scalars['timestamp']['output'];
  installed_rank: Scalars['Int']['output'];
  script: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Aggregate = {
  __typename?: 'eatfresh_flyway_schema_history_aggregate';
  aggregate?: Maybe<Eatfresh_Flyway_Schema_History_Aggregate_Fields>;
  nodes: Array<Eatfresh_Flyway_Schema_History>;
};

/** aggregate fields of "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Aggregate_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_aggregate_fields';
  avg?: Maybe<Eatfresh_Flyway_Schema_History_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Flyway_Schema_History_Max_Fields>;
  min?: Maybe<Eatfresh_Flyway_Schema_History_Min_Fields>;
  stddev?: Maybe<Eatfresh_Flyway_Schema_History_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Flyway_Schema_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Flyway_Schema_History_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Flyway_Schema_History_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Flyway_Schema_History_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Flyway_Schema_History_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Flyway_Schema_History_Variance_Fields>;
};


/** aggregate fields of "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Flyway_Schema_History_Avg_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_avg_fields';
  checksum?: Maybe<Scalars['Float']['output']>;
  execution_time?: Maybe<Scalars['Float']['output']>;
  installed_rank?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.flyway_schema_history". All fields are combined with a logical 'AND'. */
export type Eatfresh_Flyway_Schema_History_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Flyway_Schema_History_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Bool_Exp>>;
  checksum?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  execution_time?: InputMaybe<Int_Comparison_Exp>;
  installed_by?: InputMaybe<String_Comparison_Exp>;
  installed_on?: InputMaybe<Timestamp_Comparison_Exp>;
  installed_rank?: InputMaybe<Int_Comparison_Exp>;
  script?: InputMaybe<String_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.flyway_schema_history" */
export enum Eatfresh_Flyway_Schema_History_Constraint {
  /** unique or primary key constraint on columns "installed_rank" */
  FlywaySchemaHistoryPk = 'flyway_schema_history_pk'
}

/** input type for incrementing numeric columns in table "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Inc_Input = {
  checksum?: InputMaybe<Scalars['Int']['input']>;
  execution_time?: InputMaybe<Scalars['Int']['input']>;
  installed_rank?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Insert_Input = {
  checksum?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  execution_time?: InputMaybe<Scalars['Int']['input']>;
  installed_by?: InputMaybe<Scalars['String']['input']>;
  installed_on?: InputMaybe<Scalars['timestamp']['input']>;
  installed_rank?: InputMaybe<Scalars['Int']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Flyway_Schema_History_Max_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_max_fields';
  checksum?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  execution_time?: Maybe<Scalars['Int']['output']>;
  installed_by?: Maybe<Scalars['String']['output']>;
  installed_on?: Maybe<Scalars['timestamp']['output']>;
  installed_rank?: Maybe<Scalars['Int']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Flyway_Schema_History_Min_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_min_fields';
  checksum?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  execution_time?: Maybe<Scalars['Int']['output']>;
  installed_by?: Maybe<Scalars['String']['output']>;
  installed_on?: Maybe<Scalars['timestamp']['output']>;
  installed_rank?: Maybe<Scalars['Int']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Mutation_Response = {
  __typename?: 'eatfresh_flyway_schema_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Flyway_Schema_History>;
};

/** on_conflict condition type for table "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_On_Conflict = {
  constraint: Eatfresh_Flyway_Schema_History_Constraint;
  update_columns?: Array<Eatfresh_Flyway_Schema_History_Update_Column>;
  where?: InputMaybe<Eatfresh_Flyway_Schema_History_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.flyway_schema_history". */
export type Eatfresh_Flyway_Schema_History_Order_By = {
  checksum?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  execution_time?: InputMaybe<Order_By>;
  installed_by?: InputMaybe<Order_By>;
  installed_on?: InputMaybe<Order_By>;
  installed_rank?: InputMaybe<Order_By>;
  script?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.flyway_schema_history */
export type Eatfresh_Flyway_Schema_History_Pk_Columns_Input = {
  installed_rank: Scalars['Int']['input'];
};

/** select columns of table "eatfresh.flyway_schema_history" */
export enum Eatfresh_Flyway_Schema_History_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  Description = 'description',
  /** column name */
  ExecutionTime = 'execution_time',
  /** column name */
  InstalledBy = 'installed_by',
  /** column name */
  InstalledOn = 'installed_on',
  /** column name */
  InstalledRank = 'installed_rank',
  /** column name */
  Script = 'script',
  /** column name */
  Success = 'success',
  /** column name */
  Type = 'type',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "eatfresh.flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Set_Input = {
  checksum?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  execution_time?: InputMaybe<Scalars['Int']['input']>;
  installed_by?: InputMaybe<Scalars['String']['input']>;
  installed_on?: InputMaybe<Scalars['timestamp']['input']>;
  installed_rank?: InputMaybe<Scalars['Int']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Flyway_Schema_History_Stddev_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_stddev_fields';
  checksum?: Maybe<Scalars['Float']['output']>;
  execution_time?: Maybe<Scalars['Float']['output']>;
  installed_rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Flyway_Schema_History_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_stddev_pop_fields';
  checksum?: Maybe<Scalars['Float']['output']>;
  execution_time?: Maybe<Scalars['Float']['output']>;
  installed_rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Flyway_Schema_History_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_stddev_samp_fields';
  checksum?: Maybe<Scalars['Float']['output']>;
  execution_time?: Maybe<Scalars['Float']['output']>;
  installed_rank?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_flyway_schema_history" */
export type Eatfresh_Flyway_Schema_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Flyway_Schema_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Flyway_Schema_History_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  execution_time?: InputMaybe<Scalars['Int']['input']>;
  installed_by?: InputMaybe<Scalars['String']['input']>;
  installed_on?: InputMaybe<Scalars['timestamp']['input']>;
  installed_rank?: InputMaybe<Scalars['Int']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Flyway_Schema_History_Sum_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_sum_fields';
  checksum?: Maybe<Scalars['Int']['output']>;
  execution_time?: Maybe<Scalars['Int']['output']>;
  installed_rank?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "eatfresh.flyway_schema_history" */
export enum Eatfresh_Flyway_Schema_History_Update_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  Description = 'description',
  /** column name */
  ExecutionTime = 'execution_time',
  /** column name */
  InstalledBy = 'installed_by',
  /** column name */
  InstalledOn = 'installed_on',
  /** column name */
  InstalledRank = 'installed_rank',
  /** column name */
  Script = 'script',
  /** column name */
  Success = 'success',
  /** column name */
  Type = 'type',
  /** column name */
  Version = 'version'
}

export type Eatfresh_Flyway_Schema_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Flyway_Schema_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Flyway_Schema_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Flyway_Schema_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Flyway_Schema_History_Var_Pop_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_var_pop_fields';
  checksum?: Maybe<Scalars['Float']['output']>;
  execution_time?: Maybe<Scalars['Float']['output']>;
  installed_rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Flyway_Schema_History_Var_Samp_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_var_samp_fields';
  checksum?: Maybe<Scalars['Float']['output']>;
  execution_time?: Maybe<Scalars['Float']['output']>;
  installed_rank?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Flyway_Schema_History_Variance_Fields = {
  __typename?: 'eatfresh_flyway_schema_history_variance_fields';
  checksum?: Maybe<Scalars['Float']['output']>;
  execution_time?: Maybe<Scalars['Float']['output']>;
  installed_rank?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_Fridge = {
  __typename?: 'eatfresh_fridge';
  /** An object relationship */
  ageVerificationTypeByAgeVerificationType?: Maybe<Eatfresh_Age_Verification_Type>;
  age_verification_type?: Maybe<Eatfresh_Age_Verification_Type_Enum>;
  /** An array relationship */
  assetTransfersByToFridgeId: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  assetTransfersByToFridgeId_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An object relationship */
  connectionStatusByConnectionStatus: Eatfresh_Connection_Status;
  connection_status: Eatfresh_Connection_Status_Enum;
  created: Scalars['timestamptz']['output'];
  demo_flag?: Maybe<Scalars['Boolean']['output']>;
  directions_summary?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  /** An object relationship */
  doorStatusByDoorStatus: Eatfresh_Door_Status;
  door_status: Eatfresh_Door_Status_Enum;
  /** An array relationship */
  easy_refill_permissions: Array<Eatfresh_Easy_Refill_Permission>;
  /** An aggregate relationship */
  easy_refill_permissions_aggregate: Eatfresh_Easy_Refill_Permission_Aggregate;
  /** An array relationship */
  fridge_alarms: Array<Eatfresh_Fridge_Alarm>;
  /** An aggregate relationship */
  fridge_alarms_aggregate: Eatfresh_Fridge_Alarm_Aggregate;
  /** An array relationship */
  fridge_events: Array<Eatfresh_Fridge_Event>;
  /** An aggregate relationship */
  fridge_events_aggregate: Eatfresh_Fridge_Event_Aggregate;
  /** An array relationship */
  fridge_layout_assignments: Array<Eatfresh_Fridge_Layout_Assignment>;
  /** An aggregate relationship */
  fridge_layout_assignments_aggregate: Eatfresh_Fridge_Layout_Assignment_Aggregate;
  /** An object relationship */
  fridge_order?: Maybe<Eatfresh_Fridge_Order>;
  /** An array relationship */
  fridge_stocks: Array<Eatfresh_Fridge_Stock>;
  /** An aggregate relationship */
  fridge_stocks_aggregate: Eatfresh_Fridge_Stock_Aggregate;
  /** An array relationship */
  fridge_target_stocks: Array<Eatfresh_Fridge_Target_Stock>;
  /** An aggregate relationship */
  fridge_target_stocks_aggregate: Eatfresh_Fridge_Target_Stock_Aggregate;
  /** An object relationship */
  fridge_type: Eatfresh_Fridge_Type;
  given_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  inventory_last_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  inventory_synced: Scalars['Boolean']['output'];
  last_seen_online?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  place: Eatfresh_Place;
  place_id: Scalars['uuid']['output'];
  /** An array relationship */
  price_change_positions: Array<Eatfresh_Price_Change_Position>;
  /** An aggregate relationship */
  price_change_positions_aggregate: Eatfresh_Price_Change_Position_Aggregate;
  /** An array relationship */
  price_locks: Array<Eatfresh_Price_Lock>;
  /** An aggregate relationship */
  price_locks_aggregate: Eatfresh_Price_Lock_Aggregate;
  /** An array relationship */
  refills: Array<Eatfresh_Refill>;
  /** An aggregate relationship */
  refills_aggregate: Eatfresh_Refill_Aggregate;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  /** An object relationship */
  selflyCabinetStateBySelflyCabinetState?: Maybe<Eatfresh_Selfly_Cabinet_State>;
  selfly_cabinet_state?: Maybe<Eatfresh_Selfly_Cabinet_State_Enum>;
  selfly_device_code?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['numeric']['output']>;
  type: Eatfresh_Fridge_Type_Enum;
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeAssetTransfersByToFridgeIdArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeAssetTransfersByToFridgeId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeEasy_Refill_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeEasy_Refill_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_AlarmsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_Alarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_EventsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_Layout_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_Layout_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_StocksArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_Stocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_Target_StocksArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeFridge_Target_Stocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgePrice_Change_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgePrice_Change_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgePrice_LocksArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgePrice_Locks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeRefillsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeRefills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge" */
export type Eatfresh_FridgeRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};

/** columns and relationships of "eatfresh.fridge_active_daily" */
export type Eatfresh_Fridge_Active_Daily = {
  __typename?: 'eatfresh_fridge_active_daily';
  active_count?: Maybe<Scalars['bigint']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  disabled_count?: Maybe<Scalars['bigint']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "eatfresh.fridge_active_daily" */
export type Eatfresh_Fridge_Active_Daily_Aggregate = {
  __typename?: 'eatfresh_fridge_active_daily_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Active_Daily_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Active_Daily>;
};

/** aggregate fields of "eatfresh.fridge_active_daily" */
export type Eatfresh_Fridge_Active_Daily_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Active_Daily_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Active_Daily_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Active_Daily_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Active_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Active_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Active_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Active_Daily_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Active_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Active_Daily_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Active_Daily_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_active_daily" */
export type Eatfresh_Fridge_Active_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Active_Daily_Avg_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_avg_fields';
  active_count?: Maybe<Scalars['Float']['output']>;
  disabled_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_active_daily". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Active_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Active_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Bool_Exp>>;
  active_count?: InputMaybe<Bigint_Comparison_Exp>;
  day?: InputMaybe<Date_Comparison_Exp>;
  disabled_count?: InputMaybe<Bigint_Comparison_Exp>;
  total_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Active_Daily_Max_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_max_fields';
  active_count?: Maybe<Scalars['bigint']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  disabled_count?: Maybe<Scalars['bigint']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Active_Daily_Min_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_min_fields';
  active_count?: Maybe<Scalars['bigint']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  disabled_count?: Maybe<Scalars['bigint']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "eatfresh.fridge_active_daily". */
export type Eatfresh_Fridge_Active_Daily_Order_By = {
  active_count?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  disabled_count?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_active_daily" */
export enum Eatfresh_Fridge_Active_Daily_Select_Column {
  /** column name */
  ActiveCount = 'active_count',
  /** column name */
  Day = 'day',
  /** column name */
  DisabledCount = 'disabled_count',
  /** column name */
  TotalCount = 'total_count'
}

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Active_Daily_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_stddev_fields';
  active_count?: Maybe<Scalars['Float']['output']>;
  disabled_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Active_Daily_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_stddev_pop_fields';
  active_count?: Maybe<Scalars['Float']['output']>;
  disabled_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Active_Daily_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_stddev_samp_fields';
  active_count?: Maybe<Scalars['Float']['output']>;
  disabled_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_active_daily" */
export type Eatfresh_Fridge_Active_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Active_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Active_Daily_Stream_Cursor_Value_Input = {
  active_count?: InputMaybe<Scalars['bigint']['input']>;
  day?: InputMaybe<Scalars['date']['input']>;
  disabled_count?: InputMaybe<Scalars['bigint']['input']>;
  total_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Active_Daily_Sum_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_sum_fields';
  active_count?: Maybe<Scalars['bigint']['output']>;
  disabled_count?: Maybe<Scalars['bigint']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Active_Daily_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_var_pop_fields';
  active_count?: Maybe<Scalars['Float']['output']>;
  disabled_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Active_Daily_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_var_samp_fields';
  active_count?: Maybe<Scalars['Float']['output']>;
  disabled_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Active_Daily_Variance_Fields = {
  __typename?: 'eatfresh_fridge_active_daily_variance_fields';
  active_count?: Maybe<Scalars['Float']['output']>;
  disabled_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "eatfresh.fridge" */
export type Eatfresh_Fridge_Aggregate = {
  __typename?: 'eatfresh_fridge_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge>;
};

export type Eatfresh_Fridge_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Fridge_Select_Column_Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Fridge_Select_Column_Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Fridge_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge" */
export type Eatfresh_Fridge_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge" */
export type Eatfresh_Fridge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Fridge_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Fridge_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Fridge_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Fridge_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Fridge_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Fridge_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Fridge_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Fridge_Variance_Order_By>;
};

/** columns and relationships of "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm = {
  __typename?: 'eatfresh_fridge_alarm';
  active: Scalars['Boolean']['output'];
  active_since: Scalars['timestamptz']['output'];
  alarm_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Aggregate = {
  __typename?: 'eatfresh_fridge_alarm_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Alarm_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Alarm>;
};

export type Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Fridge_Alarm_Select_Column_Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Fridge_Alarm_Select_Column_Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_alarm_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Alarm_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Alarm_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Alarm_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Alarm_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Alarm_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Alarm_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_alarm". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Alarm_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  active_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  alarm_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_alarm" */
export enum Eatfresh_Fridge_Alarm_Constraint {
  /** unique or primary key constraint on columns "alarm_type", "fridge_id" */
  FridgeAlarmFridgeIdAlarmTypeKey = 'fridge_alarm_fridge_id_alarm_type_key',
  /** unique or primary key constraint on columns "id" */
  FridgeAlarmPkey = 'fridge_alarm_pkey'
}

/** input type for inserting data into table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_since?: InputMaybe<Scalars['timestamptz']['input']>;
  alarm_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Alarm_Max_Fields = {
  __typename?: 'eatfresh_fridge_alarm_max_fields';
  active_since?: Maybe<Scalars['timestamptz']['output']>;
  alarm_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Max_Order_By = {
  active_since?: InputMaybe<Order_By>;
  alarm_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Alarm_Min_Fields = {
  __typename?: 'eatfresh_fridge_alarm_min_fields';
  active_since?: Maybe<Scalars['timestamptz']['output']>;
  alarm_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Min_Order_By = {
  active_since?: InputMaybe<Order_By>;
  alarm_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Mutation_Response = {
  __typename?: 'eatfresh_fridge_alarm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Alarm>;
};

/** on_conflict condition type for table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_On_Conflict = {
  constraint: Eatfresh_Fridge_Alarm_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Alarm_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_alarm". */
export type Eatfresh_Fridge_Alarm_Order_By = {
  active?: InputMaybe<Order_By>;
  active_since?: InputMaybe<Order_By>;
  alarm_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_alarm */
export type Eatfresh_Fridge_Alarm_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_alarm" */
export enum Eatfresh_Fridge_Alarm_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AlarmType = 'alarm_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "eatfresh_fridge_alarm_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.fridge_alarm" */
export enum Eatfresh_Fridge_Alarm_Select_Column_Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "eatfresh_fridge_alarm_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.fridge_alarm" */
export enum Eatfresh_Fridge_Alarm_Select_Column_Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "eatfresh.fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_since?: InputMaybe<Scalars['timestamptz']['input']>;
  alarm_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_alarm" */
export type Eatfresh_Fridge_Alarm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Alarm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Alarm_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_since?: InputMaybe<Scalars['timestamptz']['input']>;
  alarm_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "eatfresh.fridge_alarm" */
export enum Eatfresh_Fridge_Alarm_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AlarmType = 'alarm_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Fridge_Alarm_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Alarm_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Alarm_Bool_Exp;
};

/** input type for inserting array relation for remote table "eatfresh.fridge" */
export type Eatfresh_Fridge_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_On_Conflict>;
};

/** columns and relationships of "eatfresh.fridge_article_stock" */
export type Eatfresh_Fridge_Article_Stock = {
  __typename?: 'eatfresh_fridge_article_stock';
  /** An object relationship */
  article?: Maybe<Eatfresh_Article>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_quantity?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  fridge?: Maybe<Eatfresh_Fridge>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "eatfresh.fridge_article_stock" */
export type Eatfresh_Fridge_Article_Stock_Aggregate = {
  __typename?: 'eatfresh_fridge_article_stock_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Article_Stock_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Article_Stock>;
};

/** aggregate fields of "eatfresh.fridge_article_stock" */
export type Eatfresh_Fridge_Article_Stock_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Article_Stock_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Article_Stock_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Article_Stock_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Article_Stock_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Article_Stock_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Article_Stock_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_article_stock" */
export type Eatfresh_Fridge_Article_Stock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Article_Stock_Avg_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_avg_fields';
  article_quantity?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_article_stock". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Article_Stock_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Article_Stock_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  article_quantity?: InputMaybe<Bigint_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Article_Stock_Max_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_quantity?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Article_Stock_Min_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_quantity?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "eatfresh.fridge_article_stock". */
export type Eatfresh_Fridge_Article_Stock_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_quantity?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_article_stock" */
export enum Eatfresh_Fridge_Article_Stock_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  ArticleQuantity = 'article_quantity',
  /** column name */
  FridgeId = 'fridge_id'
}

/** columns and relationships of "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot';
  actual_qty?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  article?: Maybe<Eatfresh_Article>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  empty_ratio?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  fridge?: Maybe<Eatfresh_Fridge>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  granularity: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  snapshot_at: Scalars['timestamptz']['output'];
  snapshot_day: Scalars['date']['output'];
  snapshot_week: Scalars['date']['output'];
  target_qty?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Aggregate = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Article_Stock_Snapshot>;
};

/** aggregate fields of "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Avg_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_avg_fields';
  actual_qty?: Maybe<Scalars['Float']['output']>;
  empty_ratio?: Maybe<Scalars['Float']['output']>;
  target_qty?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_article_stock_snapshot". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>>;
  actual_qty?: InputMaybe<Int_Comparison_Exp>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  empty_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  granularity?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  snapshot_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  snapshot_day?: InputMaybe<Date_Comparison_Exp>;
  snapshot_week?: InputMaybe<Date_Comparison_Exp>;
  target_qty?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_article_stock_snapshot" */
export enum Eatfresh_Fridge_Article_Stock_Snapshot_Constraint {
  /** unique or primary key constraint on columns "id" */
  FridgeArticleStockSnapshotPkey = 'fridge_article_stock_snapshot_pkey',
  /** unique or primary key constraint on columns "granularity", "article_id", "snapshot_at" */
  UqSnapshotArticleAgg = 'uq_snapshot_article_agg',
  /** unique or primary key constraint on columns "granularity", "fridge_id", "snapshot_at" */
  UqSnapshotFridgeAgg = 'uq_snapshot_fridge_agg',
  /** unique or primary key constraint on columns "granularity", "article_id", "fridge_id", "snapshot_at" */
  UqSnapshotGranular = 'uq_snapshot_granular',
  /** unique or primary key constraint on columns "granularity", "snapshot_at" */
  UqSnapshotOverallAgg = 'uq_snapshot_overall_agg'
}

/** columns and relationships of "eatfresh.fridge_article_stock_snapshot_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily';
  article_id?: Maybe<Scalars['uuid']['output']>;
  avg_empty_ratio?: Maybe<Scalars['numeric']['output']>;
  empty_count?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "eatfresh.fridge_article_stock_snapshot_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Aggregate = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily>;
};

/** aggregate fields of "eatfresh.fridge_article_stock_snapshot_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_article_stock_snapshot_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Avg_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_avg_fields';
  avg_empty_ratio?: Maybe<Scalars['Float']['output']>;
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_article_stock_snapshot_daily". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  avg_empty_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  empty_count?: InputMaybe<Bigint_Comparison_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  snapshot_day?: InputMaybe<Date_Comparison_Exp>;
  total_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Max_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  avg_empty_ratio?: Maybe<Scalars['numeric']['output']>;
  empty_count?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Min_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  avg_empty_ratio?: Maybe<Scalars['numeric']['output']>;
  empty_count?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "eatfresh.fridge_article_stock_snapshot_daily". */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Order_By = {
  article_id?: InputMaybe<Order_By>;
  avg_empty_ratio?: InputMaybe<Order_By>;
  empty_count?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  snapshot_day?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_article_stock_snapshot_daily" */
export enum Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  AvgEmptyRatio = 'avg_empty_ratio',
  /** column name */
  EmptyCount = 'empty_count',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  SnapshotDay = 'snapshot_day',
  /** column name */
  TotalCount = 'total_count'
}

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_stddev_fields';
  avg_empty_ratio?: Maybe<Scalars['Float']['output']>;
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_stddev_pop_fields';
  avg_empty_ratio?: Maybe<Scalars['Float']['output']>;
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_stddev_samp_fields';
  avg_empty_ratio?: Maybe<Scalars['Float']['output']>;
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_article_stock_snapshot_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  avg_empty_ratio?: InputMaybe<Scalars['numeric']['input']>;
  empty_count?: InputMaybe<Scalars['bigint']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  snapshot_day?: InputMaybe<Scalars['date']['input']>;
  total_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Sum_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_sum_fields';
  avg_empty_ratio?: Maybe<Scalars['numeric']['output']>;
  empty_count?: Maybe<Scalars['bigint']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_var_pop_fields';
  avg_empty_ratio?: Maybe<Scalars['Float']['output']>;
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_var_samp_fields';
  avg_empty_ratio?: Maybe<Scalars['Float']['output']>;
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Variance_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_daily_variance_fields';
  avg_empty_ratio?: Maybe<Scalars['Float']['output']>;
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily';
  article_id?: Maybe<Scalars['uuid']['output']>;
  demo_flag?: Maybe<Scalars['Boolean']['output']>;
  empty_count?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  fridge_type?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
  was_enabled?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Aggregate = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily>;
};

/** aggregate fields of "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Avg_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_avg_fields';
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_article_stock_snapshot_enabled_daily". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  demo_flag?: InputMaybe<Boolean_Comparison_Exp>;
  empty_count?: InputMaybe<Bigint_Comparison_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge_type?: InputMaybe<String_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  snapshot_day?: InputMaybe<Date_Comparison_Exp>;
  total_count?: InputMaybe<Bigint_Comparison_Exp>;
  was_enabled?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Max_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  empty_count?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  fridge_type?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Min_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  empty_count?: Maybe<Scalars['bigint']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  fridge_type?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "eatfresh.fridge_article_stock_snapshot_enabled_daily". */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Order_By = {
  article_id?: InputMaybe<Order_By>;
  demo_flag?: InputMaybe<Order_By>;
  empty_count?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_type?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  snapshot_day?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  was_enabled?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
export enum Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  EmptyCount = 'empty_count',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  FridgeType = 'fridge_type',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  SnapshotDay = 'snapshot_day',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  WasEnabled = 'was_enabled'
}

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_stddev_fields';
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_stddev_pop_fields';
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_stddev_samp_fields';
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_article_stock_snapshot_enabled_daily" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  empty_count?: InputMaybe<Scalars['bigint']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_type?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  snapshot_day?: InputMaybe<Scalars['date']['input']>;
  total_count?: InputMaybe<Scalars['bigint']['input']>;
  was_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Sum_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_sum_fields';
  empty_count?: Maybe<Scalars['bigint']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_var_pop_fields';
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_var_samp_fields';
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Variance_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily_variance_fields';
  empty_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Inc_Input = {
  actual_qty?: InputMaybe<Scalars['Int']['input']>;
  empty_ratio?: InputMaybe<Scalars['numeric']['input']>;
  target_qty?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Insert_Input = {
  actual_qty?: InputMaybe<Scalars['Int']['input']>;
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  empty_ratio?: InputMaybe<Scalars['numeric']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  snapshot_at?: InputMaybe<Scalars['timestamptz']['input']>;
  snapshot_day?: InputMaybe<Scalars['date']['input']>;
  snapshot_week?: InputMaybe<Scalars['date']['input']>;
  target_qty?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Max_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_max_fields';
  actual_qty?: Maybe<Scalars['Int']['output']>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  empty_ratio?: Maybe<Scalars['numeric']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  granularity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  snapshot_at?: Maybe<Scalars['timestamptz']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  snapshot_week?: Maybe<Scalars['date']['output']>;
  target_qty?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Min_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_min_fields';
  actual_qty?: Maybe<Scalars['Int']['output']>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  empty_ratio?: Maybe<Scalars['numeric']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  granularity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  snapshot_at?: Maybe<Scalars['timestamptz']['output']>;
  snapshot_day?: Maybe<Scalars['date']['output']>;
  snapshot_week?: Maybe<Scalars['date']['output']>;
  target_qty?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Mutation_Response = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Article_Stock_Snapshot>;
};

/** on_conflict condition type for table "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_On_Conflict = {
  constraint: Eatfresh_Fridge_Article_Stock_Snapshot_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_article_stock_snapshot". */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Order_By = {
  actual_qty?: InputMaybe<Order_By>;
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  empty_ratio?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  granularity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  snapshot_at?: InputMaybe<Order_By>;
  snapshot_day?: InputMaybe<Order_By>;
  snapshot_week?: InputMaybe<Order_By>;
  target_qty?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_article_stock_snapshot */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_article_stock_snapshot" */
export enum Eatfresh_Fridge_Article_Stock_Snapshot_Select_Column {
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmptyRatio = 'empty_ratio',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Granularity = 'granularity',
  /** column name */
  Id = 'id',
  /** column name */
  SnapshotAt = 'snapshot_at',
  /** column name */
  SnapshotDay = 'snapshot_day',
  /** column name */
  SnapshotWeek = 'snapshot_week',
  /** column name */
  TargetQty = 'target_qty'
}

/** input type for updating data in table "eatfresh.fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Set_Input = {
  actual_qty?: InputMaybe<Scalars['Int']['input']>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  empty_ratio?: InputMaybe<Scalars['numeric']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  snapshot_at?: InputMaybe<Scalars['timestamptz']['input']>;
  snapshot_day?: InputMaybe<Scalars['date']['input']>;
  snapshot_week?: InputMaybe<Scalars['date']['input']>;
  target_qty?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_stddev_fields';
  actual_qty?: Maybe<Scalars['Float']['output']>;
  empty_ratio?: Maybe<Scalars['Float']['output']>;
  target_qty?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_stddev_pop_fields';
  actual_qty?: Maybe<Scalars['Float']['output']>;
  empty_ratio?: Maybe<Scalars['Float']['output']>;
  target_qty?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_stddev_samp_fields';
  actual_qty?: Maybe<Scalars['Float']['output']>;
  empty_ratio?: Maybe<Scalars['Float']['output']>;
  target_qty?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_article_stock_snapshot" */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Article_Stock_Snapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Stream_Cursor_Value_Input = {
  actual_qty?: InputMaybe<Scalars['Int']['input']>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  empty_ratio?: InputMaybe<Scalars['numeric']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  snapshot_at?: InputMaybe<Scalars['timestamptz']['input']>;
  snapshot_day?: InputMaybe<Scalars['date']['input']>;
  snapshot_week?: InputMaybe<Scalars['date']['input']>;
  target_qty?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Sum_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_sum_fields';
  actual_qty?: Maybe<Scalars['Int']['output']>;
  empty_ratio?: Maybe<Scalars['numeric']['output']>;
  target_qty?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "eatfresh.fridge_article_stock_snapshot" */
export enum Eatfresh_Fridge_Article_Stock_Snapshot_Update_Column {
  /** column name */
  ActualQty = 'actual_qty',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmptyRatio = 'empty_ratio',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Granularity = 'granularity',
  /** column name */
  Id = 'id',
  /** column name */
  SnapshotAt = 'snapshot_at',
  /** column name */
  SnapshotDay = 'snapshot_day',
  /** column name */
  SnapshotWeek = 'snapshot_week',
  /** column name */
  TargetQty = 'target_qty'
}

export type Eatfresh_Fridge_Article_Stock_Snapshot_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_var_pop_fields';
  actual_qty?: Maybe<Scalars['Float']['output']>;
  empty_ratio?: Maybe<Scalars['Float']['output']>;
  target_qty?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_var_samp_fields';
  actual_qty?: Maybe<Scalars['Float']['output']>;
  empty_ratio?: Maybe<Scalars['Float']['output']>;
  target_qty?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Article_Stock_Snapshot_Variance_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_snapshot_variance_fields';
  actual_qty?: Maybe<Scalars['Float']['output']>;
  empty_ratio?: Maybe<Scalars['Float']['output']>;
  target_qty?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Article_Stock_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_stddev_fields';
  article_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_stddev_pop_fields';
  article_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_stddev_samp_fields';
  article_quantity?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_article_stock" */
export type Eatfresh_Fridge_Article_Stock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Article_Stock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Article_Stock_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_quantity?: InputMaybe<Scalars['bigint']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Article_Stock_Sum_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_sum_fields';
  article_quantity?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Article_Stock_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_var_pop_fields';
  article_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Article_Stock_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_var_samp_fields';
  article_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Article_Stock_Variance_Fields = {
  __typename?: 'eatfresh_fridge_article_stock_variance_fields';
  article_quantity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Avg_Fields = {
  __typename?: 'eatfresh_fridge_avg_fields';
  temperature?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Avg_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Bool_Exp>>;
  ageVerificationTypeByAgeVerificationType?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
  age_verification_type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum_Comparison_Exp>;
  assetTransfersByToFridgeId?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  assetTransfersByToFridgeId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  connectionStatusByConnectionStatus?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
  connection_status?: InputMaybe<Eatfresh_Connection_Status_Enum_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  demo_flag?: InputMaybe<Boolean_Comparison_Exp>;
  directions_summary?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  doorStatusByDoorStatus?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
  door_status?: InputMaybe<Eatfresh_Door_Status_Enum_Comparison_Exp>;
  easy_refill_permissions?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
  easy_refill_permissions_aggregate?: InputMaybe<Eatfresh_Easy_Refill_Permission_Aggregate_Bool_Exp>;
  fridge_alarms?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
  fridge_alarms_aggregate?: InputMaybe<Eatfresh_Fridge_Alarm_Aggregate_Bool_Exp>;
  fridge_events?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
  fridge_events_aggregate?: InputMaybe<Eatfresh_Fridge_Event_Aggregate_Bool_Exp>;
  fridge_layout_assignments?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
  fridge_layout_assignments_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Bool_Exp>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
  fridge_stocks?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
  fridge_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Stock_Aggregate_Bool_Exp>;
  fridge_target_stocks?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
  fridge_target_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Aggregate_Bool_Exp>;
  fridge_type?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
  given_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inventory_last_synced_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  inventory_synced?: InputMaybe<Boolean_Comparison_Exp>;
  last_seen_online?: InputMaybe<Timestamptz_Comparison_Exp>;
  place?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Bool_Exp>;
  price_locks?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
  price_locks_aggregate?: InputMaybe<Eatfresh_Price_Lock_Aggregate_Bool_Exp>;
  refills?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Bool_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  selflyCabinetStateBySelflyCabinetState?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
  selfly_cabinet_state?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Enum_Comparison_Exp>;
  selfly_device_code?: InputMaybe<String_Comparison_Exp>;
  temperature?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<Eatfresh_Fridge_Type_Enum_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge" */
export enum Eatfresh_Fridge_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshFridgePkey = 'eatfresh_fridge_pkey',
  /** unique or primary key constraint on columns "given_id" */
  FridgeGivenIdKey = 'fridge_given_id_key'
}

/** columns and relationships of "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event = {
  __typename?: 'eatfresh_fridge_event';
  created: Scalars['timestamptz']['output'];
  event_type: Eatfresh_Fridge_Event_Type_Enum;
  /** An object relationship */
  fridge?: Maybe<Eatfresh_Fridge>;
  /** An object relationship */
  fridge_event_type: Eatfresh_Fridge_Event_Type;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  item_id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Aggregate = {
  __typename?: 'eatfresh_fridge_event_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Event_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Event>;
};

export type Eatfresh_Fridge_Event_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Event_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_event_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Event_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Event_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Event_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Event_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_event". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Event_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Event_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<Eatfresh_Fridge_Event_Type_Enum_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_event_type?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  item_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_event" */
export enum Eatfresh_Fridge_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshFridgeEventPkey = 'eatfresh_fridge_event_pkey'
}

/** input type for inserting data into table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Eatfresh_Fridge_Event_Type_Enum>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_event_type?: InputMaybe<Eatfresh_Fridge_Event_Type_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  item_id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Event_Max_Fields = {
  __typename?: 'eatfresh_fridge_event_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  item_id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Event_Min_Fields = {
  __typename?: 'eatfresh_fridge_event_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  item_id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Mutation_Response = {
  __typename?: 'eatfresh_fridge_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Event>;
};

/** on_conflict condition type for table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_On_Conflict = {
  constraint: Eatfresh_Fridge_Event_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Event_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_event". */
export type Eatfresh_Fridge_Event_Order_By = {
  created?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_event_type?: InputMaybe<Eatfresh_Fridge_Event_Type_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_event */
export type Eatfresh_Fridge_Event_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_event" */
export enum Eatfresh_Fridge_Event_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'item_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "eatfresh.fridge_event" */
export type Eatfresh_Fridge_Event_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Eatfresh_Fridge_Event_Type_Enum>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  item_id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_event" */
export type Eatfresh_Fridge_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Event_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Eatfresh_Fridge_Event_Type_Enum>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  item_id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type = {
  __typename?: 'eatfresh_fridge_event_type';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fridge_events: Array<Eatfresh_Fridge_Event>;
  /** An aggregate relationship */
  fridge_events_aggregate: Eatfresh_Fridge_Event_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_TypeFridge_EventsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_TypeFridge_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};

/** aggregated selection of "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Aggregate = {
  __typename?: 'eatfresh_fridge_event_type_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Event_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Event_Type>;
};

/** aggregate fields of "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_event_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Event_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Event_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_event_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridge_events?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
  fridge_events_aggregate?: InputMaybe<Eatfresh_Fridge_Event_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_event_type" */
export enum Eatfresh_Fridge_Event_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  FridgeEventTypePkey = 'fridge_event_type_pkey'
}

export enum Eatfresh_Fridge_Event_Type_Enum {
  /** The fridge was closed */
  FridgeClosed = 'FRIDGE_CLOSED',
  /** The fridge was opened */
  FridgeOpened = 'FRIDGE_OPENED',
  /** The fridge was scanned */
  FridgeScanned = 'FRIDGE_SCANNED',
  /** An item was added to the fridge */
  ItemAdded = 'ITEM_ADDED',
  /** An item was removed from the fridge */
  ItemRemoved = 'ITEM_REMOVED',
  /** An order is being processed */
  OrderProcessing = 'ORDER_PROCESSING'
}

/** Boolean expression to compare columns of type "eatfresh_fridge_event_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Fridge_Event_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Fridge_Event_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Fridge_Event_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  fridge_events?: InputMaybe<Eatfresh_Fridge_Event_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Event_Type_Max_Fields = {
  __typename?: 'eatfresh_fridge_event_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Event_Type_Min_Fields = {
  __typename?: 'eatfresh_fridge_event_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Mutation_Response = {
  __typename?: 'eatfresh_fridge_event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Event_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Event_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Event_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_On_Conflict = {
  constraint: Eatfresh_Fridge_Event_Type_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Event_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_event_type". */
export type Eatfresh_Fridge_Event_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  fridge_events_aggregate?: InputMaybe<Eatfresh_Fridge_Event_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_event_type */
export type Eatfresh_Fridge_Event_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.fridge_event_type" */
export enum Eatfresh_Fridge_Event_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_event_type" */
export type Eatfresh_Fridge_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Event_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.fridge_event_type" */
export enum Eatfresh_Fridge_Event_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Fridge_Event_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Event_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Event_Type_Bool_Exp;
};

/** update columns of table "eatfresh.fridge_event" */
export enum Eatfresh_Fridge_Event_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'item_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Updated = 'updated'
}

export type Eatfresh_Fridge_Event_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Event_Bool_Exp;
};

/** input type for incrementing numeric columns in table "eatfresh.fridge" */
export type Eatfresh_Fridge_Inc_Input = {
  temperature?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "eatfresh.fridge" */
export type Eatfresh_Fridge_Insert_Input = {
  ageVerificationTypeByAgeVerificationType?: InputMaybe<Eatfresh_Age_Verification_Type_Obj_Rel_Insert_Input>;
  age_verification_type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  assetTransfersByToFridgeId?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  connectionStatusByConnectionStatus?: InputMaybe<Eatfresh_Connection_Status_Obj_Rel_Insert_Input>;
  connection_status?: InputMaybe<Eatfresh_Connection_Status_Enum>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  directions_summary?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  doorStatusByDoorStatus?: InputMaybe<Eatfresh_Door_Status_Obj_Rel_Insert_Input>;
  door_status?: InputMaybe<Eatfresh_Door_Status_Enum>;
  easy_refill_permissions?: InputMaybe<Eatfresh_Easy_Refill_Permission_Arr_Rel_Insert_Input>;
  fridge_alarms?: InputMaybe<Eatfresh_Fridge_Alarm_Arr_Rel_Insert_Input>;
  fridge_events?: InputMaybe<Eatfresh_Fridge_Event_Arr_Rel_Insert_Input>;
  fridge_layout_assignments?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Arr_Rel_Insert_Input>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Obj_Rel_Insert_Input>;
  fridge_stocks?: InputMaybe<Eatfresh_Fridge_Stock_Arr_Rel_Insert_Input>;
  fridge_target_stocks?: InputMaybe<Eatfresh_Fridge_Target_Stock_Arr_Rel_Insert_Input>;
  fridge_type?: InputMaybe<Eatfresh_Fridge_Type_Obj_Rel_Insert_Input>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inventory_last_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  inventory_synced?: InputMaybe<Scalars['Boolean']['input']>;
  last_seen_online?: InputMaybe<Scalars['timestamptz']['input']>;
  place?: InputMaybe<Eatfresh_Place_Obj_Rel_Insert_Input>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Arr_Rel_Insert_Input>;
  price_locks?: InputMaybe<Eatfresh_Price_Lock_Arr_Rel_Insert_Input>;
  refills?: InputMaybe<Eatfresh_Refill_Arr_Rel_Insert_Input>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  selflyCabinetStateBySelflyCabinetState?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Obj_Rel_Insert_Input>;
  selfly_cabinet_state?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Enum>;
  selfly_device_code?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Eatfresh_Fridge_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout = {
  __typename?: 'eatfresh_fridge_layout';
  /** An array relationship */
  child_fridge_layouts: Array<Eatfresh_Fridge_Layout>;
  /** An aggregate relationship */
  child_fridge_layouts_aggregate: Eatfresh_Fridge_Layout_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  fridge_layout_assignments: Array<Eatfresh_Fridge_Layout_Assignment>;
  /** An aggregate relationship */
  fridge_layout_assignments_aggregate: Eatfresh_Fridge_Layout_Assignment_Aggregate;
  /** An array relationship */
  fridge_layout_levels: Array<Eatfresh_Fridge_Layout_Level>;
  /** An aggregate relationship */
  fridge_layout_levels_aggregate: Eatfresh_Fridge_Layout_Level_Aggregate;
  /** An array relationship */
  fridge_target_stocks: Array<Eatfresh_Fridge_Target_Stock>;
  /** An aggregate relationship */
  fridge_target_stocks_aggregate: Eatfresh_Fridge_Target_Stock_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  parent_fridge_layout?: Maybe<Eatfresh_Fridge_Layout>;
  parent_layout_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutChild_Fridge_LayoutsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutChild_Fridge_Layouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutFridge_Layout_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutFridge_Layout_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutFridge_Layout_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutFridge_Layout_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutFridge_Target_StocksArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_LayoutFridge_Target_Stocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};

/** aggregated selection of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Aggregate = {
  __typename?: 'eatfresh_fridge_layout_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Layout_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Layout>;
};

export type Eatfresh_Fridge_Layout_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Layout_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Layout_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_layout_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Layout_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Layout_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Layout_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Layout_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Layout_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_On_Conflict>;
};

/** columns and relationships of "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment = {
  __typename?: 'eatfresh_fridge_layout_assignment';
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  /** An object relationship */
  fridge_layout: Eatfresh_Fridge_Layout;
  /** An object relationship */
  fridge_layout_assignment_status: Eatfresh_Fridge_Layout_Assignment_Status;
  fridge_layout_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  status: Eatfresh_Fridge_Layout_Assignment_Status_Enum;
};

/** aggregated selection of "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Aggregate = {
  __typename?: 'eatfresh_fridge_layout_assignment_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Layout_Assignment>;
};

export type Eatfresh_Fridge_Layout_Assignment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Layout_Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_layout_assignment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Layout_Assignment_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Layout_Assignment_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Layout_Assignment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_layout_assignment". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Layout_Assignment_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>>;
  confirmed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deprecated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  fridge_layout_assignment_status?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
  fridge_layout_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_layout_assignment" */
export enum Eatfresh_Fridge_Layout_Assignment_Constraint {
  /** unique or primary key constraint on columns "id" */
  FridgeLayoutAssignmentPkey = 'fridge_layout_assignment_pkey'
}

/** input type for inserting data into table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Insert_Input = {
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Obj_Rel_Insert_Input>;
  fridge_layout_assignment_status?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Obj_Rel_Insert_Input>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Enum>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Layout_Assignment_Max_Fields = {
  __typename?: 'eatfresh_fridge_layout_assignment_max_fields';
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  fridge_layout_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Max_Order_By = {
  confirmed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Layout_Assignment_Min_Fields = {
  __typename?: 'eatfresh_fridge_layout_assignment_min_fields';
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  fridge_layout_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Min_Order_By = {
  confirmed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Mutation_Response = {
  __typename?: 'eatfresh_fridge_layout_assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Layout_Assignment>;
};

/** on_conflict condition type for table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_On_Conflict = {
  constraint: Eatfresh_Fridge_Layout_Assignment_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Layout_Assignment_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_layout_assignment". */
export type Eatfresh_Fridge_Layout_Assignment_Order_By = {
  confirmed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Order_By>;
  fridge_layout_assignment_status?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_layout_assignment */
export type Eatfresh_Fridge_Layout_Assignment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_layout_assignment" */
export enum Eatfresh_Fridge_Layout_Assignment_Select_Column {
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  FridgeLayoutId = 'fridge_layout_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "eatfresh.fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Set_Input = {
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Enum>;
};

/** columns and relationships of "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status = {
  __typename?: 'eatfresh_fridge_layout_assignment_status';
  description: Scalars['String']['output'];
  /** An array relationship */
  fridge_layout_assignments: Array<Eatfresh_Fridge_Layout_Assignment>;
  /** An aggregate relationship */
  fridge_layout_assignments_aggregate: Eatfresh_Fridge_Layout_Assignment_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_StatusFridge_Layout_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_StatusFridge_Layout_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};

/** aggregated selection of "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Aggregate = {
  __typename?: 'eatfresh_fridge_layout_assignment_status_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Layout_Assignment_Status>;
};

/** aggregate fields of "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_layout_assignment_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_layout_assignment_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridge_layout_assignments?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
  fridge_layout_assignments_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_layout_assignment_status" */
export enum Eatfresh_Fridge_Layout_Assignment_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  FridgeLayoutAssignmentStatusPkey = 'fridge_layout_assignment_status_pkey'
}

export enum Eatfresh_Fridge_Layout_Assignment_Status_Enum {
  /** Confirmed by refiller. */
  Active = 'ACTIVE',
  /** Deprecated because of a new assignment or manually by admin. */
  Deprecated = 'DEPRECATED',
  /** Requested by admin. */
  Requested = 'REQUESTED'
}

/** Boolean expression to compare columns of type "eatfresh_fridge_layout_assignment_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Fridge_Layout_Assignment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  fridge_layout_assignments?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Layout_Assignment_Status_Max_Fields = {
  __typename?: 'eatfresh_fridge_layout_assignment_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Layout_Assignment_Status_Min_Fields = {
  __typename?: 'eatfresh_fridge_layout_assignment_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Mutation_Response = {
  __typename?: 'eatfresh_fridge_layout_assignment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Layout_Assignment_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Layout_Assignment_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_On_Conflict = {
  constraint: Eatfresh_Fridge_Layout_Assignment_Status_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Layout_Assignment_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_layout_assignment_status". */
export type Eatfresh_Fridge_Layout_Assignment_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  fridge_layout_assignments_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_layout_assignment_status */
export type Eatfresh_Fridge_Layout_Assignment_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.fridge_layout_assignment_status" */
export enum Eatfresh_Fridge_Layout_Assignment_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_layout_assignment_status" */
export type Eatfresh_Fridge_Layout_Assignment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Layout_Assignment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Layout_Assignment_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.fridge_layout_assignment_status" */
export enum Eatfresh_Fridge_Layout_Assignment_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Fridge_Layout_Assignment_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp;
};

/** Streaming cursor of the table "eatfresh_fridge_layout_assignment" */
export type Eatfresh_Fridge_Layout_Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Layout_Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Layout_Assignment_Stream_Cursor_Value_Input = {
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Enum>;
};

/** update columns of table "eatfresh.fridge_layout_assignment" */
export enum Eatfresh_Fridge_Layout_Assignment_Update_Column {
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  FridgeLayoutId = 'fridge_layout_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status'
}

export type Eatfresh_Fridge_Layout_Assignment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Layout_Assignment_Bool_Exp;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_layout". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Layout_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Layout_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Layout_Bool_Exp>>;
  child_fridge_layouts?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  child_fridge_layouts_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge_layout_assignments?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
  fridge_layout_assignments_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Bool_Exp>;
  fridge_layout_levels?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
  fridge_layout_levels_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Aggregate_Bool_Exp>;
  fridge_target_stocks?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
  fridge_target_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  parent_layout_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_layout" */
export enum Eatfresh_Fridge_Layout_Constraint {
  /** unique or primary key constraint on columns "name" */
  FridgeLayoutNameKey = 'fridge_layout_name_key',
  /** unique or primary key constraint on columns "id" */
  FridgeLayoutPkey = 'fridge_layout_pkey'
}

/** input type for inserting data into table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Insert_Input = {
  child_fridge_layouts?: InputMaybe<Eatfresh_Fridge_Layout_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_layout_assignments?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Arr_Rel_Insert_Input>;
  fridge_layout_levels?: InputMaybe<Eatfresh_Fridge_Layout_Level_Arr_Rel_Insert_Input>;
  fridge_target_stocks?: InputMaybe<Eatfresh_Fridge_Target_Stock_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Obj_Rel_Insert_Input>;
  parent_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level = {
  __typename?: 'eatfresh_fridge_layout_level';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  fridge_layout: Eatfresh_Fridge_Layout;
  fridge_layout_id: Scalars['uuid']['output'];
  /** An array relationship */
  fridge_layout_level_positions: Array<Eatfresh_Fridge_Layout_Level_Position>;
  /** An aggregate relationship */
  fridge_layout_level_positions_aggregate: Eatfresh_Fridge_Layout_Level_Position_Aggregate;
  id: Scalars['uuid']['output'];
  order_index: Scalars['Int']['output'];
};


/** columns and relationships of "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_LevelFridge_Layout_Level_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_LevelFridge_Layout_Level_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Aggregate = {
  __typename?: 'eatfresh_fridge_layout_level_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Layout_Level_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Layout_Level>;
};

export type Eatfresh_Fridge_Layout_Level_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Layout_Level_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Layout_Level_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Layout_Level_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Layout_Level_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Layout_Level_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Layout_Level_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Layout_Level_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Layout_Level_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Layout_Level_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Layout_Level_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Layout_Level_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Layout_Level_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Fridge_Layout_Level_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Layout_Level_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Layout_Level_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Fridge_Layout_Level_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Fridge_Layout_Level_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Fridge_Layout_Level_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Fridge_Layout_Level_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Fridge_Layout_Level_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Fridge_Layout_Level_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Fridge_Layout_Level_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Layout_Level_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Level_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Layout_Level_Avg_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_avg_fields';
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Avg_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_layout_level". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Layout_Level_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  fridge_layout_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge_layout_level_positions?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
  fridge_layout_level_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order_index?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_layout_level" */
export enum Eatfresh_Fridge_Layout_Level_Constraint {
  /** unique or primary key constraint on columns "id" */
  FridgeLayoutLevelPkey = 'fridge_layout_level_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Inc_Input = {
  order_index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Obj_Rel_Insert_Input>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_layout_level_positions?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Layout_Level_Max_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_layout_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Layout_Level_Min_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_layout_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Mutation_Response = {
  __typename?: 'eatfresh_fridge_layout_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Layout_Level>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Layout_Level_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Level_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_On_Conflict = {
  constraint: Eatfresh_Fridge_Layout_Level_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Layout_Level_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_layout_level". */
export type Eatfresh_Fridge_Layout_Level_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  fridge_layout_level_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_layout_level */
export type Eatfresh_Fridge_Layout_Level_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position = {
  __typename?: 'eatfresh_fridge_layout_level_position';
  /** An object relationship */
  article: Eatfresh_Article;
  article_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  d_orientation: Eatfresh_Product_Orientation_Enum;
  /** An object relationship */
  fridge_layout_level: Eatfresh_Fridge_Layout_Level;
  fridge_layout_level_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  lines_per_slot: Scalars['Int']['output'];
  order_index: Scalars['Int']['output'];
  /** An object relationship */
  productOrientationByWOrientation: Eatfresh_Product_Orientation;
  /** An object relationship */
  product_orientation: Eatfresh_Product_Orientation;
  slots: Scalars['Int']['output'];
  target_quantity: Scalars['Int']['output'];
  w_orientation: Eatfresh_Product_Orientation_Enum;
};

/** aggregated selection of "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Aggregate = {
  __typename?: 'eatfresh_fridge_layout_level_position_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Layout_Level_Position>;
};

export type Eatfresh_Fridge_Layout_Level_Position_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Layout_Level_Position_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Layout_Level_Position_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Avg_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_avg_fields';
  lines_per_slot?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
  slots?: Maybe<Scalars['Float']['output']>;
  target_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Avg_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_layout_level_position". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Layout_Level_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  d_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum_Comparison_Exp>;
  fridge_layout_level?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
  fridge_layout_level_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lines_per_slot?: InputMaybe<Int_Comparison_Exp>;
  order_index?: InputMaybe<Int_Comparison_Exp>;
  productOrientationByWOrientation?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
  product_orientation?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
  slots?: InputMaybe<Int_Comparison_Exp>;
  target_quantity?: InputMaybe<Int_Comparison_Exp>;
  w_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_layout_level_position" */
export enum Eatfresh_Fridge_Layout_Level_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  FridgeLayoutLevelPositionPkey = 'fridge_layout_level_position_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Inc_Input = {
  lines_per_slot?: InputMaybe<Scalars['Int']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  slots?: InputMaybe<Scalars['Int']['input']>;
  target_quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  d_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
  fridge_layout_level?: InputMaybe<Eatfresh_Fridge_Layout_Level_Obj_Rel_Insert_Input>;
  fridge_layout_level_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lines_per_slot?: InputMaybe<Scalars['Int']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  productOrientationByWOrientation?: InputMaybe<Eatfresh_Product_Orientation_Obj_Rel_Insert_Input>;
  product_orientation?: InputMaybe<Eatfresh_Product_Orientation_Obj_Rel_Insert_Input>;
  slots?: InputMaybe<Scalars['Int']['input']>;
  target_quantity?: InputMaybe<Scalars['Int']['input']>;
  w_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Max_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_layout_level_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lines_per_slot?: Maybe<Scalars['Int']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
  slots?: Maybe<Scalars['Int']['output']>;
  target_quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_layout_level_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Min_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_layout_level_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lines_per_slot?: Maybe<Scalars['Int']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
  slots?: Maybe<Scalars['Int']['output']>;
  target_quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_layout_level_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Mutation_Response = {
  __typename?: 'eatfresh_fridge_layout_level_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Layout_Level_Position>;
};

/** on_conflict condition type for table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_On_Conflict = {
  constraint: Eatfresh_Fridge_Layout_Level_Position_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Layout_Level_Position_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_layout_level_position". */
export type Eatfresh_Fridge_Layout_Level_Position_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  d_orientation?: InputMaybe<Order_By>;
  fridge_layout_level?: InputMaybe<Eatfresh_Fridge_Layout_Level_Order_By>;
  fridge_layout_level_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  productOrientationByWOrientation?: InputMaybe<Eatfresh_Product_Orientation_Order_By>;
  product_orientation?: InputMaybe<Eatfresh_Product_Orientation_Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
  w_orientation?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_layout_level_position */
export type Eatfresh_Fridge_Layout_Level_Position_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_layout_level_position" */
export enum Eatfresh_Fridge_Layout_Level_Position_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DOrientation = 'd_orientation',
  /** column name */
  FridgeLayoutLevelId = 'fridge_layout_level_id',
  /** column name */
  Id = 'id',
  /** column name */
  LinesPerSlot = 'lines_per_slot',
  /** column name */
  OrderIndex = 'order_index',
  /** column name */
  Slots = 'slots',
  /** column name */
  TargetQuantity = 'target_quantity',
  /** column name */
  WOrientation = 'w_orientation'
}

/** input type for updating data in table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  d_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
  fridge_layout_level_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lines_per_slot?: InputMaybe<Scalars['Int']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  slots?: InputMaybe<Scalars['Int']['input']>;
  target_quantity?: InputMaybe<Scalars['Int']['input']>;
  w_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_stddev_fields';
  lines_per_slot?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
  slots?: Maybe<Scalars['Float']['output']>;
  target_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Stddev_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_stddev_pop_fields';
  lines_per_slot?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
  slots?: Maybe<Scalars['Float']['output']>;
  target_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Stddev_Pop_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_stddev_samp_fields';
  lines_per_slot?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
  slots?: Maybe<Scalars['Float']['output']>;
  target_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Stddev_Samp_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Layout_Level_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Layout_Level_Position_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  d_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
  fridge_layout_level_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lines_per_slot?: InputMaybe<Scalars['Int']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  slots?: InputMaybe<Scalars['Int']['input']>;
  target_quantity?: InputMaybe<Scalars['Int']['input']>;
  w_orientation?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Sum_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_sum_fields';
  lines_per_slot?: Maybe<Scalars['Int']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
  slots?: Maybe<Scalars['Int']['output']>;
  target_quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Sum_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.fridge_layout_level_position" */
export enum Eatfresh_Fridge_Layout_Level_Position_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DOrientation = 'd_orientation',
  /** column name */
  FridgeLayoutLevelId = 'fridge_layout_level_id',
  /** column name */
  Id = 'id',
  /** column name */
  LinesPerSlot = 'lines_per_slot',
  /** column name */
  OrderIndex = 'order_index',
  /** column name */
  Slots = 'slots',
  /** column name */
  TargetQuantity = 'target_quantity',
  /** column name */
  WOrientation = 'w_orientation'
}

export type Eatfresh_Fridge_Layout_Level_Position_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Layout_Level_Position_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_var_pop_fields';
  lines_per_slot?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
  slots?: Maybe<Scalars['Float']['output']>;
  target_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Var_Pop_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_var_samp_fields';
  lines_per_slot?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
  slots?: Maybe<Scalars['Float']['output']>;
  target_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Var_Samp_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Layout_Level_Position_Variance_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_position_variance_fields';
  lines_per_slot?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
  slots?: Maybe<Scalars['Float']['output']>;
  target_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.fridge_layout_level_position" */
export type Eatfresh_Fridge_Layout_Level_Position_Variance_Order_By = {
  lines_per_slot?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  slots?: InputMaybe<Order_By>;
  target_quantity?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_layout_level" */
export enum Eatfresh_Fridge_Layout_Level_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeLayoutId = 'fridge_layout_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrderIndex = 'order_index'
}

/** input type for updating data in table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Layout_Level_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_stddev_fields';
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Stddev_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Layout_Level_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_stddev_pop_fields';
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Stddev_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Layout_Level_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_stddev_samp_fields';
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Stddev_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Layout_Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Layout_Level_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Layout_Level_Sum_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_sum_fields';
  order_index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Sum_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.fridge_layout_level" */
export enum Eatfresh_Fridge_Layout_Level_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeLayoutId = 'fridge_layout_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrderIndex = 'order_index'
}

export type Eatfresh_Fridge_Layout_Level_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Fridge_Layout_Level_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Level_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Layout_Level_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Layout_Level_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_var_pop_fields';
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Var_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Layout_Level_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_var_samp_fields';
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Var_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Layout_Level_Variance_Fields = {
  __typename?: 'eatfresh_fridge_layout_level_variance_fields';
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.fridge_layout_level" */
export type Eatfresh_Fridge_Layout_Level_Variance_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Layout_Max_Fields = {
  __typename?: 'eatfresh_fridge_layout_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_layout_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_layout_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Layout_Min_Fields = {
  __typename?: 'eatfresh_fridge_layout_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_layout_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_layout_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Mutation_Response = {
  __typename?: 'eatfresh_fridge_layout_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Layout>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Layout_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_On_Conflict = {
  constraint: Eatfresh_Fridge_Layout_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Layout_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_layout". */
export type Eatfresh_Fridge_Layout_Order_By = {
  child_fridge_layouts_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_layout_assignments_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Order_By>;
  fridge_layout_levels_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Aggregate_Order_By>;
  fridge_target_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Order_By>;
  parent_layout_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_layout */
export type Eatfresh_Fridge_Layout_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_layout" */
export enum Eatfresh_Fridge_Layout_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentLayoutId = 'parent_layout_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.fridge_layout" */
export type Eatfresh_Fridge_Layout_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_layout" */
export type Eatfresh_Fridge_Layout_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Layout_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Layout_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "eatfresh.fridge_layout" */
export enum Eatfresh_Fridge_Layout_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentLayoutId = 'parent_layout_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Fridge_Layout_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Layout_Bool_Exp;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Max_Fields = {
  __typename?: 'eatfresh_fridge_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  directions_summary?: Maybe<Scalars['String']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inventory_last_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  last_seen_online?: Maybe<Scalars['timestamptz']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  selfly_device_code?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['numeric']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  directions_summary?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inventory_last_synced_at?: InputMaybe<Order_By>;
  last_seen_online?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  selfly_device_code?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Min_Fields = {
  __typename?: 'eatfresh_fridge_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  directions_summary?: Maybe<Scalars['String']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  inventory_last_synced_at?: Maybe<Scalars['timestamptz']['output']>;
  last_seen_online?: Maybe<Scalars['timestamptz']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  selfly_device_code?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['numeric']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  directions_summary?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inventory_last_synced_at?: InputMaybe<Order_By>;
  last_seen_online?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  selfly_device_code?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge" */
export type Eatfresh_Fridge_Mutation_Response = {
  __typename?: 'eatfresh_fridge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge" */
export type Eatfresh_Fridge_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge" */
export type Eatfresh_Fridge_On_Conflict = {
  constraint: Eatfresh_Fridge_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};

/** columns and relationships of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order = {
  __typename?: 'eatfresh_fridge_order';
  active: Scalars['Boolean']['output'];
  /** An array relationship */
  box_content_plans: Array<Eatfresh_Box_Content_Plan>;
  /** An aggregate relationship */
  box_content_plans_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  /** An array relationship */
  commissioning_processes: Array<Eatfresh_Commissioning_Process>;
  /** An aggregate relationship */
  commissioning_processes_aggregate: Eatfresh_Commissioning_Process_Aggregate;
  created_at: Scalars['timestamp']['output'];
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_serviced_at?: Maybe<Scalars['timestamp']['output']>;
  priority: Scalars['Int']['output'];
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_OrderBox_Content_PlansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_OrderBox_Content_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_OrderCommissioning_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_OrderCommissioning_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};

/** aggregated selection of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Aggregate = {
  __typename?: 'eatfresh_fridge_order_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Order_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Order>;
};

/** aggregate fields of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_order_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Order_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Order_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Order_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Order_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Order_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Order_Avg_Fields = {
  __typename?: 'eatfresh_fridge_order_avg_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_order". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Order_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Order_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_serviced_at?: InputMaybe<Timestamp_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge". */
export type Eatfresh_Fridge_Order_By = {
  ageVerificationTypeByAgeVerificationType?: InputMaybe<Eatfresh_Age_Verification_Type_Order_By>;
  age_verification_type?: InputMaybe<Order_By>;
  assetTransfersByToFridgeId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  connectionStatusByConnectionStatus?: InputMaybe<Eatfresh_Connection_Status_Order_By>;
  connection_status?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  demo_flag?: InputMaybe<Order_By>;
  directions_summary?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  doorStatusByDoorStatus?: InputMaybe<Eatfresh_Door_Status_Order_By>;
  door_status?: InputMaybe<Order_By>;
  easy_refill_permissions_aggregate?: InputMaybe<Eatfresh_Easy_Refill_Permission_Aggregate_Order_By>;
  fridge_alarms_aggregate?: InputMaybe<Eatfresh_Fridge_Alarm_Aggregate_Order_By>;
  fridge_events_aggregate?: InputMaybe<Eatfresh_Fridge_Event_Aggregate_Order_By>;
  fridge_layout_assignments_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Aggregate_Order_By>;
  fridge_order?: InputMaybe<Eatfresh_Fridge_Order_Order_By>;
  fridge_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Stock_Aggregate_Order_By>;
  fridge_target_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Aggregate_Order_By>;
  fridge_type?: InputMaybe<Eatfresh_Fridge_Type_Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inventory_last_synced_at?: InputMaybe<Order_By>;
  inventory_synced?: InputMaybe<Order_By>;
  last_seen_online?: InputMaybe<Order_By>;
  place?: InputMaybe<Eatfresh_Place_Order_By>;
  place_id?: InputMaybe<Order_By>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Order_By>;
  price_locks_aggregate?: InputMaybe<Eatfresh_Price_Lock_Aggregate_Order_By>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  selflyCabinetStateBySelflyCabinetState?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Order_By>;
  selfly_cabinet_state?: InputMaybe<Order_By>;
  selfly_device_code?: InputMaybe<Order_By>;
  temperature?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "eatfresh.fridge_order" */
export enum Eatfresh_Fridge_Order_Constraint {
  /** unique or primary key constraint on columns "fridge_id" */
  FridgeOrderFridgeIdKey = 'fridge_order_fridge_id_key',
  /** unique or primary key constraint on columns "id" */
  FridgeOrderPkey = 'fridge_order_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Inc_Input = {
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Arr_Rel_Insert_Input>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_serviced_at?: InputMaybe<Scalars['timestamp']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Order_Max_Fields = {
  __typename?: 'eatfresh_fridge_order_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_serviced_at?: Maybe<Scalars['timestamp']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Order_Min_Fields = {
  __typename?: 'eatfresh_fridge_order_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_serviced_at?: Maybe<Scalars['timestamp']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Mutation_Response = {
  __typename?: 'eatfresh_fridge_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Order>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Order_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_On_Conflict = {
  constraint: Eatfresh_Fridge_Order_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Order_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_order". */
export type Eatfresh_Fridge_Order_Order_By = {
  active?: InputMaybe<Order_By>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Order_By>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_serviced_at?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_order */
export type Eatfresh_Fridge_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_order" */
export enum Eatfresh_Fridge_Order_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastServicedAt = 'last_serviced_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.fridge_order" */
export type Eatfresh_Fridge_Order_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_serviced_at?: InputMaybe<Scalars['timestamp']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Order_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_order_stddev_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Order_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_order_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Order_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_order_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_order" */
export type Eatfresh_Fridge_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Order_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_serviced_at?: InputMaybe<Scalars['timestamp']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Order_Sum_Fields = {
  __typename?: 'eatfresh_fridge_order_sum_fields';
  priority?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "eatfresh.fridge_order" */
export enum Eatfresh_Fridge_Order_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastServicedAt = 'last_serviced_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Fridge_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Fridge_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Order_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_order_var_pop_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Order_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_order_var_samp_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Order_Variance_Fields = {
  __typename?: 'eatfresh_fridge_order_variance_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

/** primary key columns input for table: eatfresh.fridge */
export type Eatfresh_Fridge_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge" */
export enum Eatfresh_Fridge_Select_Column {
  /** column name */
  AgeVerificationType = 'age_verification_type',
  /** column name */
  ConnectionStatus = 'connection_status',
  /** column name */
  Created = 'created',
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  DirectionsSummary = 'directions_summary',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DoorStatus = 'door_status',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  Id = 'id',
  /** column name */
  InventoryLastSyncedAt = 'inventory_last_synced_at',
  /** column name */
  InventorySynced = 'inventory_synced',
  /** column name */
  LastSeenOnline = 'last_seen_online',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  SelflyCabinetState = 'selfly_cabinet_state',
  /** column name */
  SelflyDeviceCode = 'selfly_device_code',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

/** select "eatfresh_fridge_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.fridge" */
export enum Eatfresh_Fridge_Select_Column_Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  InventorySynced = 'inventory_synced'
}

/** select "eatfresh_fridge_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.fridge" */
export enum Eatfresh_Fridge_Select_Column_Eatfresh_Fridge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  InventorySynced = 'inventory_synced'
}

/** input type for updating data in table "eatfresh.fridge" */
export type Eatfresh_Fridge_Set_Input = {
  age_verification_type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  connection_status?: InputMaybe<Eatfresh_Connection_Status_Enum>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  directions_summary?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  door_status?: InputMaybe<Eatfresh_Door_Status_Enum>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inventory_last_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  inventory_synced?: InputMaybe<Scalars['Boolean']['input']>;
  last_seen_online?: InputMaybe<Scalars['timestamptz']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  selfly_cabinet_state?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Enum>;
  selfly_device_code?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Eatfresh_Fridge_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History = {
  __typename?: 'eatfresh_fridge_status_history';
  changed_at: Scalars['timestamptz']['output'];
  changed_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  changed_by_user?: Maybe<Eatfresh_User_Account>;
  disabled: Scalars['Boolean']['output'];
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History_Aggregate = {
  __typename?: 'eatfresh_fridge_status_history_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Status_History_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Status_History>;
};

/** aggregate fields of "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_status_history_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Status_History_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Status_History_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_status_history". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Status_History_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Status_History_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Bool_Exp>>;
  changed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  changed_by?: InputMaybe<Uuid_Comparison_Exp>;
  changed_by_user?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_status_history" */
export enum Eatfresh_Fridge_Status_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  FridgeStatusHistoryPkey = 'fridge_status_history_pkey'
}

/** input type for inserting data into table "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History_Insert_Input = {
  changed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_by?: InputMaybe<Scalars['uuid']['input']>;
  changed_by_user?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Status_History_Max_Fields = {
  __typename?: 'eatfresh_fridge_status_history_max_fields';
  changed_at?: Maybe<Scalars['timestamptz']['output']>;
  changed_by?: Maybe<Scalars['uuid']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Status_History_Min_Fields = {
  __typename?: 'eatfresh_fridge_status_history_min_fields';
  changed_at?: Maybe<Scalars['timestamptz']['output']>;
  changed_by?: Maybe<Scalars['uuid']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History_Mutation_Response = {
  __typename?: 'eatfresh_fridge_status_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Status_History>;
};

/** on_conflict condition type for table "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History_On_Conflict = {
  constraint: Eatfresh_Fridge_Status_History_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Status_History_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Status_History_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_status_history". */
export type Eatfresh_Fridge_Status_History_Order_By = {
  changed_at?: InputMaybe<Order_By>;
  changed_by?: InputMaybe<Order_By>;
  changed_by_user?: InputMaybe<Eatfresh_User_Account_Order_By>;
  disabled?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_status_history */
export type Eatfresh_Fridge_Status_History_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_status_history" */
export enum Eatfresh_Fridge_Status_History_Select_Column {
  /** column name */
  ChangedAt = 'changed_at',
  /** column name */
  ChangedBy = 'changed_by',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "eatfresh.fridge_status_history" */
export type Eatfresh_Fridge_Status_History_Set_Input = {
  changed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_by?: InputMaybe<Scalars['uuid']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_status_history" */
export type Eatfresh_Fridge_Status_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Status_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Status_History_Stream_Cursor_Value_Input = {
  changed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  changed_by?: InputMaybe<Scalars['uuid']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.fridge_status_history" */
export enum Eatfresh_Fridge_Status_History_Update_Column {
  /** column name */
  ChangedAt = 'changed_at',
  /** column name */
  ChangedBy = 'changed_by',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id'
}

export type Eatfresh_Fridge_Status_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Status_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Status_History_Bool_Exp;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_stddev_fields';
  temperature?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Stddev_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_stddev_pop_fields';
  temperature?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Stddev_Pop_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_stddev_samp_fields';
  temperature?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Stddev_Samp_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock = {
  __typename?: 'eatfresh_fridge_stock';
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  fridge?: Maybe<Eatfresh_Fridge>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  rfid_tag?: Maybe<Eatfresh_Rfid_Tag>;
  rfid_tag_id?: Maybe<Scalars['uuid']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Aggregate = {
  __typename?: 'eatfresh_fridge_stock_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Stock_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Stock>;
};

export type Eatfresh_Fridge_Stock_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Stock_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Stock_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_stock_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Stock_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Stock_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Stock_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Stock_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Stock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Stock_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Stock_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Stock_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Stock_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Stock_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Fridge_Stock_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Stock_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Stock_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Fridge_Stock_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Fridge_Stock_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Fridge_Stock_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Fridge_Stock_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Fridge_Stock_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Fridge_Stock_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Fridge_Stock_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Stock_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Stock_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Stock_Avg_Fields = {
  __typename?: 'eatfresh_fridge_stock_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_stock". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Stock_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Stock_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Stock_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  rfid_tag?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tag_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_stock" */
export enum Eatfresh_Fridge_Stock_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshFridgeStockPkey = 'eatfresh_fridge_stock_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rfid_tag?: InputMaybe<Eatfresh_Rfid_Tag_Obj_Rel_Insert_Input>;
  rfid_tag_id?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Stock_Max_Fields = {
  __typename?: 'eatfresh_fridge_stock_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rfid_tag_id?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rfid_tag_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Stock_Min_Fields = {
  __typename?: 'eatfresh_fridge_stock_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rfid_tag_id?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rfid_tag_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Mutation_Response = {
  __typename?: 'eatfresh_fridge_stock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Stock>;
};

/** on_conflict condition type for table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_On_Conflict = {
  constraint: Eatfresh_Fridge_Stock_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Stock_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_stock". */
export type Eatfresh_Fridge_Stock_Order_By = {
  created?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rfid_tag?: InputMaybe<Eatfresh_Rfid_Tag_Order_By>;
  rfid_tag_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_stock */
export type Eatfresh_Fridge_Stock_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_stock" */
export enum Eatfresh_Fridge_Stock_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RfidTagId = 'rfid_tag_id',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rfid_tag_id?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Stock_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_stock_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Stock_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_stock_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Stock_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_stock_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_fridge_stock" */
export type Eatfresh_Fridge_Stock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Stock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Stock_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rfid_tag_id?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Stock_Sum_Fields = {
  __typename?: 'eatfresh_fridge_stock_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.fridge_stock" */
export enum Eatfresh_Fridge_Stock_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RfidTagId = 'rfid_tag_id',
  /** column name */
  Updated = 'updated'
}

export type Eatfresh_Fridge_Stock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Fridge_Stock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Stock_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Stock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Stock_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_stock_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Stock_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_stock_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Stock_Variance_Fields = {
  __typename?: 'eatfresh_fridge_stock_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.fridge_stock" */
export type Eatfresh_Fridge_Stock_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.fridge_stocked_enabled_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Daily = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily';
  article_id?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "eatfresh.fridge_stocked_enabled_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Aggregate = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Stocked_Enabled_Daily>;
};

/** aggregate fields of "eatfresh.fridge_stocked_enabled_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_stocked_enabled_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Avg_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_avg_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_stocked_enabled_daily". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  day?: InputMaybe<Date_Comparison_Exp>;
  enabled_fridge_count?: InputMaybe<Bigint_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_fridge_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Max_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Min_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "eatfresh.fridge_stocked_enabled_daily". */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Order_By = {
  article_id?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  enabled_fridge_count?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  total_fridge_count?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_stocked_enabled_daily" */
export enum Eatfresh_Fridge_Stocked_Enabled_Daily_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Day = 'day',
  /** column name */
  EnabledFridgeCount = 'enabled_fridge_count',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TotalFridgeCount = 'total_fridge_count'
}

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_stddev_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_stddev_pop_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_stddev_samp_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_stocked_enabled_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Stocked_Enabled_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['date']['input']>;
  enabled_fridge_count?: InputMaybe<Scalars['bigint']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  total_fridge_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Sum_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_sum_fields';
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_var_pop_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_var_samp_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Daily_Variance_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_daily_variance_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "eatfresh.fridge_stocked_enabled_per_place_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily';
  day?: Maybe<Scalars['date']['output']>;
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "eatfresh.fridge_stocked_enabled_per_place_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Aggregate = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily>;
};

/** aggregate fields of "eatfresh.fridge_stocked_enabled_per_place_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_stocked_enabled_per_place_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Avg_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_avg_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_stocked_enabled_per_place_daily". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>>;
  day?: InputMaybe<Date_Comparison_Exp>;
  enabled_fridge_count?: InputMaybe<Bigint_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_fridge_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Max_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_max_fields';
  day?: Maybe<Scalars['date']['output']>;
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Min_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_min_fields';
  day?: Maybe<Scalars['date']['output']>;
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "eatfresh.fridge_stocked_enabled_per_place_daily". */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Order_By = {
  day?: InputMaybe<Order_By>;
  enabled_fridge_count?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  total_fridge_count?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_stocked_enabled_per_place_daily" */
export enum Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Select_Column {
  /** column name */
  Day = 'day',
  /** column name */
  EnabledFridgeCount = 'enabled_fridge_count',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TotalFridgeCount = 'total_fridge_count'
}

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_stddev_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_stddev_pop_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_stddev_samp_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge_stocked_enabled_per_place_daily" */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stream_Cursor_Value_Input = {
  day?: InputMaybe<Scalars['date']['input']>;
  enabled_fridge_count?: InputMaybe<Scalars['bigint']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  total_fridge_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Sum_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_sum_fields';
  enabled_fridge_count?: Maybe<Scalars['bigint']['output']>;
  total_fridge_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_var_pop_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_var_samp_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Variance_Fields = {
  __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily_variance_fields';
  enabled_fridge_count?: Maybe<Scalars['Float']['output']>;
  total_fridge_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_fridge" */
export type Eatfresh_Fridge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Stream_Cursor_Value_Input = {
  age_verification_type?: InputMaybe<Eatfresh_Age_Verification_Type_Enum>;
  connection_status?: InputMaybe<Eatfresh_Connection_Status_Enum>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  directions_summary?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  door_status?: InputMaybe<Eatfresh_Door_Status_Enum>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inventory_last_synced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  inventory_synced?: InputMaybe<Scalars['Boolean']['input']>;
  last_seen_online?: InputMaybe<Scalars['timestamptz']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  selfly_cabinet_state?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Enum>;
  selfly_device_code?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Eatfresh_Fridge_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Sum_Fields = {
  __typename?: 'eatfresh_fridge_sum_fields';
  temperature?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Sum_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock = {
  __typename?: 'eatfresh_fridge_target_stock';
  created_at: Scalars['timestamp']['output'];
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  /** An object relationship */
  fridge_layout?: Maybe<Eatfresh_Fridge_Layout>;
  fridge_layout_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  fridge_target_stock_positions: Array<Eatfresh_Fridge_Target_Stock_Position>;
  /** An aggregate relationship */
  fridge_target_stock_positions_aggregate: Eatfresh_Fridge_Target_Stock_Position_Aggregate;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_StockFridge_Target_Stock_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_StockFridge_Target_Stock_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Aggregate = {
  __typename?: 'eatfresh_fridge_target_stock_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Target_Stock_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Target_Stock>;
};

export type Eatfresh_Fridge_Target_Stock_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Target_Stock_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Target_Stock_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Target_Stock_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Target_Stock_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Target_Stock_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Target_Stock_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Target_Stock_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Target_Stock_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_target_stock". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Target_Stock_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deprecated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  fridge_layout_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge_target_stock_positions?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
  fridge_target_stock_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_target_stock" */
export enum Eatfresh_Fridge_Target_Stock_Constraint {
  /** unique or primary key constraint on columns "id" */
  FridgeTargetStockPkey = 'fridge_target_stock_pkey'
}

/** input type for inserting data into table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Obj_Rel_Insert_Input>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_target_stock_positions?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Target_Stock_Max_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  fridge_layout_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Target_Stock_Min_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  fridge_layout_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Mutation_Response = {
  __typename?: 'eatfresh_fridge_target_stock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Target_Stock>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Target_Stock_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Target_Stock_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_On_Conflict = {
  constraint: Eatfresh_Fridge_Target_Stock_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Target_Stock_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_target_stock". */
export type Eatfresh_Fridge_Target_Stock_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_layout?: InputMaybe<Eatfresh_Fridge_Layout_Order_By>;
  fridge_layout_id?: InputMaybe<Order_By>;
  fridge_target_stock_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_target_stock */
export type Eatfresh_Fridge_Target_Stock_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position = {
  __typename?: 'eatfresh_fridge_target_stock_position';
  /** An object relationship */
  article: Eatfresh_Article;
  article_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamp']['output'];
  /** An object relationship */
  fridge_target_stock: Eatfresh_Fridge_Target_Stock;
  fridge_target_stock_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  quantity: Scalars['Int']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Aggregate = {
  __typename?: 'eatfresh_fridge_target_stock_position_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Target_Stock_Position>;
};

export type Eatfresh_Fridge_Target_Stock_Position_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Fridge_Target_Stock_Position_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_aggregate_fields';
  avg?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Min_Fields>;
  stddev?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Variance_Fields>;
};


/** aggregate fields of "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Fridge_Target_Stock_Position_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Avg_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_avg_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_target_stock_position". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Target_Stock_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fridge_target_stock?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
  fridge_target_stock_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_target_stock_position" */
export enum Eatfresh_Fridge_Target_Stock_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  FridgeTargetStockPositionPkey = 'fridge_target_stock_position_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_target_stock?: InputMaybe<Eatfresh_Fridge_Target_Stock_Obj_Rel_Insert_Input>;
  fridge_target_stock_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Max_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fridge_target_stock_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_target_stock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Min_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  fridge_target_stock_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_target_stock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Mutation_Response = {
  __typename?: 'eatfresh_fridge_target_stock_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Target_Stock_Position>;
};

/** on_conflict condition type for table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_On_Conflict = {
  constraint: Eatfresh_Fridge_Target_Stock_Position_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Target_Stock_Position_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_target_stock_position". */
export type Eatfresh_Fridge_Target_Stock_Position_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fridge_target_stock?: InputMaybe<Eatfresh_Fridge_Target_Stock_Order_By>;
  fridge_target_stock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_target_stock_position */
export type Eatfresh_Fridge_Target_Stock_Position_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.fridge_target_stock_position" */
export enum Eatfresh_Fridge_Target_Stock_Position_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeTargetStockId = 'fridge_target_stock_id',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_target_stock_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Stddev_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_stddev_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Target_Stock_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Target_Stock_Position_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  fridge_target_stock_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Sum_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_sum_fields';
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.fridge_target_stock_position" */
export enum Eatfresh_Fridge_Target_Stock_Position_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FridgeTargetStockId = 'fridge_target_stock_id',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Fridge_Target_Stock_Position_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Target_Stock_Position_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_var_pop_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_var_samp_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Target_Stock_Position_Variance_Fields = {
  __typename?: 'eatfresh_fridge_target_stock_position_variance_fields';
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.fridge_target_stock_position" */
export type Eatfresh_Fridge_Target_Stock_Position_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.fridge_target_stock" */
export enum Eatfresh_Fridge_Target_Stock_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  FridgeLayoutId = 'fridge_layout_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_target_stock" */
export type Eatfresh_Fridge_Target_Stock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Target_Stock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Target_Stock_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_layout_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "eatfresh.fridge_target_stock" */
export enum Eatfresh_Fridge_Target_Stock_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  FridgeLayoutId = 'fridge_layout_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Fridge_Target_Stock_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Target_Stock_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Target_Stock_Bool_Exp;
};

/** columns and relationships of "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type = {
  __typename?: 'eatfresh_fridge_type';
  description: Scalars['String']['output'];
  /** An array relationship */
  fridges: Array<Eatfresh_Fridge>;
  /** An aggregate relationship */
  fridges_aggregate: Eatfresh_Fridge_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.fridge_type" */
export type Eatfresh_Fridge_TypeFridgesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


/** columns and relationships of "eatfresh.fridge_type" */
export type Eatfresh_Fridge_TypeFridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};

/** aggregated selection of "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_Aggregate = {
  __typename?: 'eatfresh_fridge_type_aggregate';
  aggregate?: Maybe<Eatfresh_Fridge_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Fridge_Type>;
};

/** aggregate fields of "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_fridge_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Fridge_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Fridge_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Fridge_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.fridge_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Fridge_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Fridge_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Fridge_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridges?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.fridge_type" */
export enum Eatfresh_Fridge_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  FridgeTypePkey = 'fridge_type_pkey'
}

export enum Eatfresh_Fridge_Type_Enum {
  /** Demo Fridges where Payment-step gets skipped */
  Demo = 'DEMO',
  /** Mock fridge */
  Mock = 'MOCK',
  /** Selfly fridge */
  Selfly = 'SELFLY'
}

/** Boolean expression to compare columns of type "eatfresh_fridge_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Fridge_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Fridge_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Fridge_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Fridge_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Fridge_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  fridges?: InputMaybe<Eatfresh_Fridge_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Fridge_Type_Max_Fields = {
  __typename?: 'eatfresh_fridge_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Fridge_Type_Min_Fields = {
  __typename?: 'eatfresh_fridge_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_Mutation_Response = {
  __typename?: 'eatfresh_fridge_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Fridge_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Fridge_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Fridge_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_On_Conflict = {
  constraint: Eatfresh_Fridge_Type_Constraint;
  update_columns?: Array<Eatfresh_Fridge_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.fridge_type". */
export type Eatfresh_Fridge_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.fridge_type */
export type Eatfresh_Fridge_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.fridge_type" */
export enum Eatfresh_Fridge_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.fridge_type" */
export type Eatfresh_Fridge_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_fridge_type" */
export type Eatfresh_Fridge_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Fridge_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Fridge_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.fridge_type" */
export enum Eatfresh_Fridge_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Fridge_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Type_Bool_Exp;
};

/** update columns of table "eatfresh.fridge" */
export enum Eatfresh_Fridge_Update_Column {
  /** column name */
  AgeVerificationType = 'age_verification_type',
  /** column name */
  ConnectionStatus = 'connection_status',
  /** column name */
  Created = 'created',
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  DirectionsSummary = 'directions_summary',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DoorStatus = 'door_status',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  Id = 'id',
  /** column name */
  InventoryLastSyncedAt = 'inventory_last_synced_at',
  /** column name */
  InventorySynced = 'inventory_synced',
  /** column name */
  LastSeenOnline = 'last_seen_online',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  SelflyCabinetState = 'selfly_cabinet_state',
  /** column name */
  SelflyDeviceCode = 'selfly_device_code',
  /** column name */
  Temperature = 'temperature',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

export type Eatfresh_Fridge_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Fridge_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Fridge_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Fridge_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Fridge_Var_Pop_Fields = {
  __typename?: 'eatfresh_fridge_var_pop_fields';
  temperature?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Var_Pop_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Fridge_Var_Samp_Fields = {
  __typename?: 'eatfresh_fridge_var_samp_fields';
  temperature?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Var_Samp_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Fridge_Variance_Fields = {
  __typename?: 'eatfresh_fridge_variance_fields';
  temperature?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.fridge" */
export type Eatfresh_Fridge_Variance_Order_By = {
  temperature?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem = {
  __typename?: 'eatfresh_logistics_problem';
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  commission_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  logistics_problem_images: Array<Eatfresh_Logistics_Problem_Image>;
  /** An aggregate relationship */
  logistics_problem_images_aggregate: Eatfresh_Logistics_Problem_Image_Aggregate;
  /** An object relationship */
  logistics_problem_status: Eatfresh_Logistics_Problem_Status;
  /** An object relationship */
  logistics_process_type: Eatfresh_Logistics_Process_Type;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  problem_type: Scalars['String']['output'];
  process_type: Eatfresh_Logistics_Process_Type_Enum;
  /** An object relationship */
  refill?: Maybe<Eatfresh_Refill>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  status: Eatfresh_Logistics_Problem_Status_Enum;
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  warehouse_order_receipt?: Maybe<Eatfresh_Warehouse_Order_Receipt>;
  warehouse_order_receipt_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_ProblemLogistics_Problem_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


/** columns and relationships of "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_ProblemLogistics_Problem_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


/** columns and relationships of "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_ProblemMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Aggregate = {
  __typename?: 'eatfresh_logistics_problem_aggregate';
  aggregate?: Maybe<Eatfresh_Logistics_Problem_Aggregate_Fields>;
  nodes: Array<Eatfresh_Logistics_Problem>;
};

export type Eatfresh_Logistics_Problem_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Logistics_Problem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Aggregate_Fields = {
  __typename?: 'eatfresh_logistics_problem_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Logistics_Problem_Max_Fields>;
  min?: Maybe<Eatfresh_Logistics_Problem_Min_Fields>;
};


/** aggregate fields of "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Logistics_Problem_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Logistics_Problem_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Eatfresh_Logistics_Problem_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Logistics_Problem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.logistics_problem". All fields are combined with a logical 'AND'. */
export type Eatfresh_Logistics_Problem_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Logistics_Problem_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Logistics_Problem_Bool_Exp>>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  commission_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  logistics_problem_images?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
  logistics_problem_images_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Image_Aggregate_Bool_Exp>;
  logistics_problem_status?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
  logistics_process_type?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  problem_type?: InputMaybe<String_Comparison_Exp>;
  process_type?: InputMaybe<Eatfresh_Logistics_Process_Type_Enum_Comparison_Exp>;
  refill?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refill_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Logistics_Problem_Status_Enum_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  warehouse_order_receipt_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.logistics_problem" */
export enum Eatfresh_Logistics_Problem_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogisticsProblemPkey = 'logistics_problem_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Eatfresh_Logistics_Problem_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Eatfresh_Logistics_Problem_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Eatfresh_Logistics_Problem_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image = {
  __typename?: 'eatfresh_logistics_problem_image';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  logistics_problem: Eatfresh_Logistics_Problem;
  logistics_problem_id: Scalars['uuid']['output'];
  /** An object relationship */
  uploaded_file: Eatfresh_Uploaded_File;
  uploaded_file_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Aggregate = {
  __typename?: 'eatfresh_logistics_problem_image_aggregate';
  aggregate?: Maybe<Eatfresh_Logistics_Problem_Image_Aggregate_Fields>;
  nodes: Array<Eatfresh_Logistics_Problem_Image>;
};

export type Eatfresh_Logistics_Problem_Image_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Logistics_Problem_Image_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Logistics_Problem_Image_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Aggregate_Fields = {
  __typename?: 'eatfresh_logistics_problem_image_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Logistics_Problem_Image_Max_Fields>;
  min?: Maybe<Eatfresh_Logistics_Problem_Image_Min_Fields>;
};


/** aggregate fields of "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Logistics_Problem_Image_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Logistics_Problem_Image_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Logistics_Problem_Image_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_Image_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.logistics_problem_image". All fields are combined with a logical 'AND'. */
export type Eatfresh_Logistics_Problem_Image_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logistics_problem?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problem_id?: InputMaybe<Uuid_Comparison_Exp>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  uploaded_file_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.logistics_problem_image" */
export enum Eatfresh_Logistics_Problem_Image_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogisticsProblemImagePkey = 'logistics_problem_image_pkey'
}

/** input type for inserting data into table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problem?: InputMaybe<Eatfresh_Logistics_Problem_Obj_Rel_Insert_Input>;
  logistics_problem_id?: InputMaybe<Scalars['uuid']['input']>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Obj_Rel_Insert_Input>;
  uploaded_file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Logistics_Problem_Image_Max_Fields = {
  __typename?: 'eatfresh_logistics_problem_image_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logistics_problem_id?: Maybe<Scalars['uuid']['output']>;
  uploaded_file_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_problem_id?: InputMaybe<Order_By>;
  uploaded_file_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Logistics_Problem_Image_Min_Fields = {
  __typename?: 'eatfresh_logistics_problem_image_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logistics_problem_id?: Maybe<Scalars['uuid']['output']>;
  uploaded_file_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_problem_id?: InputMaybe<Order_By>;
  uploaded_file_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Mutation_Response = {
  __typename?: 'eatfresh_logistics_problem_image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Logistics_Problem_Image>;
};

/** on_conflict condition type for table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_On_Conflict = {
  constraint: Eatfresh_Logistics_Problem_Image_Constraint;
  update_columns?: Array<Eatfresh_Logistics_Problem_Image_Update_Column>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.logistics_problem_image". */
export type Eatfresh_Logistics_Problem_Image_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_problem?: InputMaybe<Eatfresh_Logistics_Problem_Order_By>;
  logistics_problem_id?: InputMaybe<Order_By>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Order_By>;
  uploaded_file_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.logistics_problem_image */
export type Eatfresh_Logistics_Problem_Image_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.logistics_problem_image" */
export enum Eatfresh_Logistics_Problem_Image_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogisticsProblemId = 'logistics_problem_id',
  /** column name */
  UploadedFileId = 'uploaded_file_id'
}

/** input type for updating data in table "eatfresh.logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problem_id?: InputMaybe<Scalars['uuid']['input']>;
  uploaded_file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_logistics_problem_image" */
export type Eatfresh_Logistics_Problem_Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Logistics_Problem_Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Logistics_Problem_Image_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problem_id?: InputMaybe<Scalars['uuid']['input']>;
  uploaded_file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.logistics_problem_image" */
export enum Eatfresh_Logistics_Problem_Image_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogisticsProblemId = 'logistics_problem_id',
  /** column name */
  UploadedFileId = 'uploaded_file_id'
}

export type Eatfresh_Logistics_Problem_Image_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Logistics_Problem_Image_Bool_Exp;
};

/** input type for inserting data into table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Insert_Input = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  commission_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problem_images?: InputMaybe<Eatfresh_Logistics_Problem_Image_Arr_Rel_Insert_Input>;
  logistics_problem_status?: InputMaybe<Eatfresh_Logistics_Problem_Status_Obj_Rel_Insert_Input>;
  logistics_process_type?: InputMaybe<Eatfresh_Logistics_Process_Type_Obj_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  problem_type?: InputMaybe<Scalars['String']['input']>;
  process_type?: InputMaybe<Eatfresh_Logistics_Process_Type_Enum>;
  refill?: InputMaybe<Eatfresh_Refill_Obj_Rel_Insert_Input>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Logistics_Problem_Status_Enum>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Obj_Rel_Insert_Input>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Logistics_Problem_Max_Fields = {
  __typename?: 'eatfresh_logistics_problem_max_fields';
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  commission_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  problem_type?: Maybe<Scalars['String']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_order_receipt_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Max_Order_By = {
  closed_at?: InputMaybe<Order_By>;
  commission_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  problem_type?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Logistics_Problem_Min_Fields = {
  __typename?: 'eatfresh_logistics_problem_min_fields';
  closed_at?: Maybe<Scalars['timestamptz']['output']>;
  commission_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  problem_type?: Maybe<Scalars['String']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_order_receipt_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Min_Order_By = {
  closed_at?: InputMaybe<Order_By>;
  commission_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  problem_type?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Mutation_Response = {
  __typename?: 'eatfresh_logistics_problem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Logistics_Problem>;
};

/** input type for inserting object relation for remote table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Obj_Rel_Insert_Input = {
  data: Eatfresh_Logistics_Problem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_On_Conflict = {
  constraint: Eatfresh_Logistics_Problem_Constraint;
  update_columns?: Array<Eatfresh_Logistics_Problem_Update_Column>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.logistics_problem". */
export type Eatfresh_Logistics_Problem_Order_By = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  closed_at?: InputMaybe<Order_By>;
  commission_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  logistics_problem_images_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Image_Aggregate_Order_By>;
  logistics_problem_status?: InputMaybe<Eatfresh_Logistics_Problem_Status_Order_By>;
  logistics_process_type?: InputMaybe<Eatfresh_Logistics_Process_Type_Order_By>;
  metadata?: InputMaybe<Order_By>;
  problem_type?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refill?: InputMaybe<Eatfresh_Refill_Order_By>;
  refill_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.logistics_problem */
export type Eatfresh_Logistics_Problem_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Eatfresh_Logistics_Problem_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "eatfresh.logistics_problem" */
export enum Eatfresh_Logistics_Problem_Select_Column {
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  CommissionId = 'commission_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ProblemType = 'problem_type',
  /** column name */
  ProcessType = 'process_type',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarehouseOrderReceiptId = 'warehouse_order_receipt_id'
}

/** input type for updating data in table "eatfresh.logistics_problem" */
export type Eatfresh_Logistics_Problem_Set_Input = {
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  commission_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  problem_type?: InputMaybe<Scalars['String']['input']>;
  process_type?: InputMaybe<Eatfresh_Logistics_Process_Type_Enum>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Logistics_Problem_Status_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status = {
  __typename?: 'eatfresh_logistics_problem_status';
  description: Scalars['String']['output'];
  /** An array relationship */
  logistics_problems: Array<Eatfresh_Logistics_Problem>;
  /** An aggregate relationship */
  logistics_problems_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_StatusLogistics_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_StatusLogistics_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};

/** aggregated selection of "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Aggregate = {
  __typename?: 'eatfresh_logistics_problem_status_aggregate';
  aggregate?: Maybe<Eatfresh_Logistics_Problem_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Logistics_Problem_Status>;
};

/** aggregate fields of "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_logistics_problem_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Logistics_Problem_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Logistics_Problem_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.logistics_problem_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Logistics_Problem_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.logistics_problem_status" */
export enum Eatfresh_Logistics_Problem_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  LogisticsProblemStatusPkey = 'logistics_problem_status_pkey'
}

export enum Eatfresh_Logistics_Problem_Status_Enum {
  /** Closed */
  Closed = 'CLOSED',
  /** Not yet submitted */
  Draft = 'DRAFT',
  /** Submitted */
  Open = 'OPEN'
}

/** Boolean expression to compare columns of type "eatfresh_logistics_problem_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Logistics_Problem_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Logistics_Problem_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Logistics_Problem_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Logistics_Problem_Status_Max_Fields = {
  __typename?: 'eatfresh_logistics_problem_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Logistics_Problem_Status_Min_Fields = {
  __typename?: 'eatfresh_logistics_problem_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Mutation_Response = {
  __typename?: 'eatfresh_logistics_problem_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Logistics_Problem_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Logistics_Problem_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_On_Conflict = {
  constraint: Eatfresh_Logistics_Problem_Status_Constraint;
  update_columns?: Array<Eatfresh_Logistics_Problem_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.logistics_problem_status". */
export type Eatfresh_Logistics_Problem_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.logistics_problem_status */
export type Eatfresh_Logistics_Problem_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.logistics_problem_status" */
export enum Eatfresh_Logistics_Problem_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_logistics_problem_status" */
export type Eatfresh_Logistics_Problem_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Logistics_Problem_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Logistics_Problem_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.logistics_problem_status" */
export enum Eatfresh_Logistics_Problem_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Logistics_Problem_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Logistics_Problem_Status_Bool_Exp;
};

/** Streaming cursor of the table "eatfresh_logistics_problem" */
export type Eatfresh_Logistics_Problem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Logistics_Problem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Logistics_Problem_Stream_Cursor_Value_Input = {
  closed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  commission_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  problem_type?: InputMaybe<Scalars['String']['input']>;
  process_type?: InputMaybe<Eatfresh_Logistics_Process_Type_Enum>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Logistics_Problem_Status_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.logistics_problem" */
export enum Eatfresh_Logistics_Problem_Update_Column {
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  CommissionId = 'commission_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ProblemType = 'problem_type',
  /** column name */
  ProcessType = 'process_type',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarehouseOrderReceiptId = 'warehouse_order_receipt_id'
}

export type Eatfresh_Logistics_Problem_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Eatfresh_Logistics_Problem_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Eatfresh_Logistics_Problem_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Eatfresh_Logistics_Problem_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Eatfresh_Logistics_Problem_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Eatfresh_Logistics_Problem_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Logistics_Problem_Bool_Exp;
};

/** columns and relationships of "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type = {
  __typename?: 'eatfresh_logistics_process_type';
  description: Scalars['String']['output'];
  /** An array relationship */
  logistics_problems: Array<Eatfresh_Logistics_Problem>;
  /** An aggregate relationship */
  logistics_problems_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_TypeLogistics_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_TypeLogistics_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};

/** aggregated selection of "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Aggregate = {
  __typename?: 'eatfresh_logistics_process_type_aggregate';
  aggregate?: Maybe<Eatfresh_Logistics_Process_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Logistics_Process_Type>;
};

/** aggregate fields of "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_logistics_process_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Logistics_Process_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Logistics_Process_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.logistics_process_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Logistics_Process_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.logistics_process_type" */
export enum Eatfresh_Logistics_Process_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  LogisticsProcessTypePkey = 'logistics_process_type_pkey'
}

export enum Eatfresh_Logistics_Process_Type_Enum {
  /** Commissioning Process */
  Commissioning = 'COMMISSIONING',
  /** Labeling Process */
  Labeling = 'LABELING',
  /** Other Process */
  Other = 'OTHER',
  /** Receipt Inspection */
  ReceiptInspection = 'RECEIPT_INSPECTION',
  /** Refill Process */
  Refill = 'REFILL'
}

/** Boolean expression to compare columns of type "eatfresh_logistics_process_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Logistics_Process_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Logistics_Process_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Logistics_Process_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Logistics_Process_Type_Max_Fields = {
  __typename?: 'eatfresh_logistics_process_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Logistics_Process_Type_Min_Fields = {
  __typename?: 'eatfresh_logistics_process_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Mutation_Response = {
  __typename?: 'eatfresh_logistics_process_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Logistics_Process_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Logistics_Process_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Logistics_Process_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_On_Conflict = {
  constraint: Eatfresh_Logistics_Process_Type_Constraint;
  update_columns?: Array<Eatfresh_Logistics_Process_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.logistics_process_type". */
export type Eatfresh_Logistics_Process_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.logistics_process_type */
export type Eatfresh_Logistics_Process_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.logistics_process_type" */
export enum Eatfresh_Logistics_Process_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_logistics_process_type" */
export type Eatfresh_Logistics_Process_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Logistics_Process_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Logistics_Process_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.logistics_process_type" */
export enum Eatfresh_Logistics_Process_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Logistics_Process_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Logistics_Process_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Logistics_Process_Type_Bool_Exp;
};

/** columns and relationships of "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information = {
  __typename?: 'eatfresh_nutrition_information';
  /** An object relationship */
  article_detail: Eatfresh_Article_Details;
  article_details_id: Scalars['uuid']['output'];
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  id: Scalars['uuid']['output'];
  nutritional_values_unit?: Maybe<Scalars['String']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Aggregate = {
  __typename?: 'eatfresh_nutrition_information_aggregate';
  aggregate?: Maybe<Eatfresh_Nutrition_Information_Aggregate_Fields>;
  nodes: Array<Eatfresh_Nutrition_Information>;
};

/** aggregate fields of "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Aggregate_Fields = {
  __typename?: 'eatfresh_nutrition_information_aggregate_fields';
  avg?: Maybe<Eatfresh_Nutrition_Information_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Nutrition_Information_Max_Fields>;
  min?: Maybe<Eatfresh_Nutrition_Information_Min_Fields>;
  stddev?: Maybe<Eatfresh_Nutrition_Information_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Nutrition_Information_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Nutrition_Information_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Nutrition_Information_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Nutrition_Information_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Nutrition_Information_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Nutrition_Information_Variance_Fields>;
};


/** aggregate fields of "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Nutrition_Information_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Nutrition_Information_Avg_Fields = {
  __typename?: 'eatfresh_nutrition_information_avg_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.nutrition_information". All fields are combined with a logical 'AND'. */
export type Eatfresh_Nutrition_Information_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Nutrition_Information_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Nutrition_Information_Bool_Exp>>;
  article_detail?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  article_details_id?: InputMaybe<Uuid_Comparison_Exp>;
  calories_kcal?: InputMaybe<Float_Comparison_Exp>;
  calories_kj?: InputMaybe<Float_Comparison_Exp>;
  carbohydrates_g?: InputMaybe<Float_Comparison_Exp>;
  fat_g?: InputMaybe<Float_Comparison_Exp>;
  fiber_g?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nutritional_values_unit?: InputMaybe<String_Comparison_Exp>;
  protein_g?: InputMaybe<Float_Comparison_Exp>;
  salt_g?: InputMaybe<Float_Comparison_Exp>;
  saturated_fat_g?: InputMaybe<Float_Comparison_Exp>;
  sugar_g?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.nutrition_information" */
export enum Eatfresh_Nutrition_Information_Constraint {
  /** unique or primary key constraint on columns "article_details_id" */
  NutritionInformationArticleDetailsIdKey = 'nutrition_information_article_details_id_key',
  /** unique or primary key constraint on columns "id" */
  NutritionInformationPk = 'nutrition_information_pk'
}

/** input type for incrementing numeric columns in table "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Inc_Input = {
  calories_kcal?: InputMaybe<Scalars['Float']['input']>;
  calories_kj?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_g?: InputMaybe<Scalars['Float']['input']>;
  fat_g?: InputMaybe<Scalars['Float']['input']>;
  fiber_g?: InputMaybe<Scalars['Float']['input']>;
  protein_g?: InputMaybe<Scalars['Float']['input']>;
  salt_g?: InputMaybe<Scalars['Float']['input']>;
  saturated_fat_g?: InputMaybe<Scalars['Float']['input']>;
  sugar_g?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Insert_Input = {
  article_detail?: InputMaybe<Eatfresh_Article_Details_Obj_Rel_Insert_Input>;
  article_details_id?: InputMaybe<Scalars['uuid']['input']>;
  calories_kcal?: InputMaybe<Scalars['Float']['input']>;
  calories_kj?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_g?: InputMaybe<Scalars['Float']['input']>;
  fat_g?: InputMaybe<Scalars['Float']['input']>;
  fiber_g?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nutritional_values_unit?: InputMaybe<Scalars['String']['input']>;
  protein_g?: InputMaybe<Scalars['Float']['input']>;
  salt_g?: InputMaybe<Scalars['Float']['input']>;
  saturated_fat_g?: InputMaybe<Scalars['Float']['input']>;
  sugar_g?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Nutrition_Information_Max_Fields = {
  __typename?: 'eatfresh_nutrition_information_max_fields';
  article_details_id?: Maybe<Scalars['uuid']['output']>;
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nutritional_values_unit?: Maybe<Scalars['String']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Nutrition_Information_Min_Fields = {
  __typename?: 'eatfresh_nutrition_information_min_fields';
  article_details_id?: Maybe<Scalars['uuid']['output']>;
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nutritional_values_unit?: Maybe<Scalars['String']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** response of any mutation on the table "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Mutation_Response = {
  __typename?: 'eatfresh_nutrition_information_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Nutrition_Information>;
};

/** input type for inserting object relation for remote table "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Obj_Rel_Insert_Input = {
  data: Eatfresh_Nutrition_Information_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Nutrition_Information_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_On_Conflict = {
  constraint: Eatfresh_Nutrition_Information_Constraint;
  update_columns?: Array<Eatfresh_Nutrition_Information_Update_Column>;
  where?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.nutrition_information". */
export type Eatfresh_Nutrition_Information_Order_By = {
  article_detail?: InputMaybe<Eatfresh_Article_Details_Order_By>;
  article_details_id?: InputMaybe<Order_By>;
  calories_kcal?: InputMaybe<Order_By>;
  calories_kj?: InputMaybe<Order_By>;
  carbohydrates_g?: InputMaybe<Order_By>;
  fat_g?: InputMaybe<Order_By>;
  fiber_g?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nutritional_values_unit?: InputMaybe<Order_By>;
  protein_g?: InputMaybe<Order_By>;
  salt_g?: InputMaybe<Order_By>;
  saturated_fat_g?: InputMaybe<Order_By>;
  sugar_g?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.nutrition_information */
export type Eatfresh_Nutrition_Information_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.nutrition_information" */
export enum Eatfresh_Nutrition_Information_Select_Column {
  /** column name */
  ArticleDetailsId = 'article_details_id',
  /** column name */
  CaloriesKcal = 'calories_kcal',
  /** column name */
  CaloriesKj = 'calories_kj',
  /** column name */
  CarbohydratesG = 'carbohydrates_g',
  /** column name */
  FatG = 'fat_g',
  /** column name */
  FiberG = 'fiber_g',
  /** column name */
  Id = 'id',
  /** column name */
  NutritionalValuesUnit = 'nutritional_values_unit',
  /** column name */
  ProteinG = 'protein_g',
  /** column name */
  SaltG = 'salt_g',
  /** column name */
  SaturatedFatG = 'saturated_fat_g',
  /** column name */
  SugarG = 'sugar_g'
}

/** input type for updating data in table "eatfresh.nutrition_information" */
export type Eatfresh_Nutrition_Information_Set_Input = {
  article_details_id?: InputMaybe<Scalars['uuid']['input']>;
  calories_kcal?: InputMaybe<Scalars['Float']['input']>;
  calories_kj?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_g?: InputMaybe<Scalars['Float']['input']>;
  fat_g?: InputMaybe<Scalars['Float']['input']>;
  fiber_g?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nutritional_values_unit?: InputMaybe<Scalars['String']['input']>;
  protein_g?: InputMaybe<Scalars['Float']['input']>;
  salt_g?: InputMaybe<Scalars['Float']['input']>;
  saturated_fat_g?: InputMaybe<Scalars['Float']['input']>;
  sugar_g?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Nutrition_Information_Stddev_Fields = {
  __typename?: 'eatfresh_nutrition_information_stddev_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Nutrition_Information_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_nutrition_information_stddev_pop_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Nutrition_Information_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_nutrition_information_stddev_samp_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_nutrition_information" */
export type Eatfresh_Nutrition_Information_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Nutrition_Information_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Nutrition_Information_Stream_Cursor_Value_Input = {
  article_details_id?: InputMaybe<Scalars['uuid']['input']>;
  calories_kcal?: InputMaybe<Scalars['Float']['input']>;
  calories_kj?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates_g?: InputMaybe<Scalars['Float']['input']>;
  fat_g?: InputMaybe<Scalars['Float']['input']>;
  fiber_g?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nutritional_values_unit?: InputMaybe<Scalars['String']['input']>;
  protein_g?: InputMaybe<Scalars['Float']['input']>;
  salt_g?: InputMaybe<Scalars['Float']['input']>;
  saturated_fat_g?: InputMaybe<Scalars['Float']['input']>;
  sugar_g?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Nutrition_Information_Sum_Fields = {
  __typename?: 'eatfresh_nutrition_information_sum_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "eatfresh.nutrition_information" */
export enum Eatfresh_Nutrition_Information_Update_Column {
  /** column name */
  ArticleDetailsId = 'article_details_id',
  /** column name */
  CaloriesKcal = 'calories_kcal',
  /** column name */
  CaloriesKj = 'calories_kj',
  /** column name */
  CarbohydratesG = 'carbohydrates_g',
  /** column name */
  FatG = 'fat_g',
  /** column name */
  FiberG = 'fiber_g',
  /** column name */
  Id = 'id',
  /** column name */
  NutritionalValuesUnit = 'nutritional_values_unit',
  /** column name */
  ProteinG = 'protein_g',
  /** column name */
  SaltG = 'salt_g',
  /** column name */
  SaturatedFatG = 'saturated_fat_g',
  /** column name */
  SugarG = 'sugar_g'
}

export type Eatfresh_Nutrition_Information_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Nutrition_Information_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Nutrition_Information_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Nutrition_Information_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Nutrition_Information_Var_Pop_Fields = {
  __typename?: 'eatfresh_nutrition_information_var_pop_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Nutrition_Information_Var_Samp_Fields = {
  __typename?: 'eatfresh_nutrition_information_var_samp_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Nutrition_Information_Variance_Fields = {
  __typename?: 'eatfresh_nutrition_information_variance_fields';
  calories_kcal?: Maybe<Scalars['Float']['output']>;
  calories_kj?: Maybe<Scalars['Float']['output']>;
  carbohydrates_g?: Maybe<Scalars['Float']['output']>;
  fat_g?: Maybe<Scalars['Float']['output']>;
  fiber_g?: Maybe<Scalars['Float']['output']>;
  protein_g?: Maybe<Scalars['Float']['output']>;
  salt_g?: Maybe<Scalars['Float']['output']>;
  saturated_fat_g?: Maybe<Scalars['Float']['output']>;
  sugar_g?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "eatfresh.order_extra" */
export type Eatfresh_Order_Extra = {
  __typename?: 'eatfresh_order_extra';
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  order_extra_customer_orders: Array<Eatfresh_Order_Extra_Customer_Order>;
  /** An aggregate relationship */
  order_extra_customer_orders_aggregate: Eatfresh_Order_Extra_Customer_Order_Aggregate;
  price: Scalars['bigint']['output'];
  slug: Scalars['String']['output'];
  /** An object relationship */
  vat_category: Eatfresh_Vat_Category;
  vat_category_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.order_extra" */
export type Eatfresh_Order_ExtraOrder_Extra_Customer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.order_extra" */
export type Eatfresh_Order_ExtraOrder_Extra_Customer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};

/** aggregated selection of "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Aggregate = {
  __typename?: 'eatfresh_order_extra_aggregate';
  aggregate?: Maybe<Eatfresh_Order_Extra_Aggregate_Fields>;
  nodes: Array<Eatfresh_Order_Extra>;
};

export type Eatfresh_Order_Extra_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Order_Extra_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Order_Extra_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Aggregate_Fields = {
  __typename?: 'eatfresh_order_extra_aggregate_fields';
  avg?: Maybe<Eatfresh_Order_Extra_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Order_Extra_Max_Fields>;
  min?: Maybe<Eatfresh_Order_Extra_Min_Fields>;
  stddev?: Maybe<Eatfresh_Order_Extra_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Order_Extra_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Order_Extra_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Order_Extra_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Order_Extra_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Order_Extra_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Order_Extra_Variance_Fields>;
};


/** aggregate fields of "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Order_Extra_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Order_Extra_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Order_Extra_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Order_Extra_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Order_Extra_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Order_Extra_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Order_Extra_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Order_Extra_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Order_Extra_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Order_Extra_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Order_Extra_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Order_Extra_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Order_Extra_Avg_Fields = {
  __typename?: 'eatfresh_order_extra_avg_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.order_extra". All fields are combined with a logical 'AND'. */
export type Eatfresh_Order_Extra_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Order_Extra_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Order_Extra_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_extra_customer_orders?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
  order_extra_customer_orders_aggregate?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Aggregate_Bool_Exp>;
  price?: InputMaybe<Bigint_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  vat_category?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
  vat_category_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.order_extra" */
export enum Eatfresh_Order_Extra_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderExtraPkey = 'order_extra_pkey',
  /** unique or primary key constraint on columns "slug" */
  OrderExtraSlugKey = 'order_extra_slug_key'
}

/** columns and relationships of "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order = {
  __typename?: 'eatfresh_order_extra_customer_order';
  /** An object relationship */
  customer_order: Eatfresh_Customer_Order;
  customer_order_id: Scalars['uuid']['output'];
  /** An object relationship */
  order_extra: Eatfresh_Order_Extra;
  order_extra_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Aggregate = {
  __typename?: 'eatfresh_order_extra_customer_order_aggregate';
  aggregate?: Maybe<Eatfresh_Order_Extra_Customer_Order_Aggregate_Fields>;
  nodes: Array<Eatfresh_Order_Extra_Customer_Order>;
};

export type Eatfresh_Order_Extra_Customer_Order_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Order_Extra_Customer_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Aggregate_Fields = {
  __typename?: 'eatfresh_order_extra_customer_order_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Order_Extra_Customer_Order_Max_Fields>;
  min?: Maybe<Eatfresh_Order_Extra_Customer_Order_Min_Fields>;
};


/** aggregate fields of "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Order_Extra_Customer_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.order_extra_customer_order". All fields are combined with a logical 'AND'. */
export type Eatfresh_Order_Extra_Customer_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_extra?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
  order_extra_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.order_extra_customer_order" */
export enum Eatfresh_Order_Extra_Customer_Order_Constraint {
  /** unique or primary key constraint on columns "order_extra_id", "customer_order_id" */
  OrderExtraCustomerOrderPkey = 'order_extra_customer_order_pkey'
}

/** input type for inserting data into table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Insert_Input = {
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  order_extra?: InputMaybe<Eatfresh_Order_Extra_Obj_Rel_Insert_Input>;
  order_extra_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Order_Extra_Customer_Order_Max_Fields = {
  __typename?: 'eatfresh_order_extra_customer_order_max_fields';
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  order_extra_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Max_Order_By = {
  customer_order_id?: InputMaybe<Order_By>;
  order_extra_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Order_Extra_Customer_Order_Min_Fields = {
  __typename?: 'eatfresh_order_extra_customer_order_min_fields';
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  order_extra_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Min_Order_By = {
  customer_order_id?: InputMaybe<Order_By>;
  order_extra_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Mutation_Response = {
  __typename?: 'eatfresh_order_extra_customer_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Order_Extra_Customer_Order>;
};

/** on_conflict condition type for table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_On_Conflict = {
  constraint: Eatfresh_Order_Extra_Customer_Order_Constraint;
  update_columns?: Array<Eatfresh_Order_Extra_Customer_Order_Update_Column>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.order_extra_customer_order". */
export type Eatfresh_Order_Extra_Customer_Order_Order_By = {
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  order_extra?: InputMaybe<Eatfresh_Order_Extra_Order_By>;
  order_extra_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.order_extra_customer_order */
export type Eatfresh_Order_Extra_Customer_Order_Pk_Columns_Input = {
  customer_order_id: Scalars['uuid']['input'];
  order_extra_id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.order_extra_customer_order" */
export enum Eatfresh_Order_Extra_Customer_Order_Select_Column {
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  OrderExtraId = 'order_extra_id'
}

/** input type for updating data in table "eatfresh.order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Set_Input = {
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  order_extra_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_order_extra_customer_order" */
export type Eatfresh_Order_Extra_Customer_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Order_Extra_Customer_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Order_Extra_Customer_Order_Stream_Cursor_Value_Input = {
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  order_extra_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.order_extra_customer_order" */
export enum Eatfresh_Order_Extra_Customer_Order_Update_Column {
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  OrderExtraId = 'order_extra_id'
}

export type Eatfresh_Order_Extra_Customer_Order_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Order_Extra_Customer_Order_Bool_Exp;
};

/** input type for incrementing numeric columns in table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Inc_Input = {
  price?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_extra_customer_orders?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  vat_category?: InputMaybe<Eatfresh_Vat_Category_Obj_Rel_Insert_Input>;
  vat_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Order_Extra_Max_Fields = {
  __typename?: 'eatfresh_order_extra_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  vat_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  vat_category_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Order_Extra_Min_Fields = {
  __typename?: 'eatfresh_order_extra_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  vat_category_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  vat_category_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Mutation_Response = {
  __typename?: 'eatfresh_order_extra_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Order_Extra>;
};

/** input type for inserting object relation for remote table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Obj_Rel_Insert_Input = {
  data: Eatfresh_Order_Extra_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Order_Extra_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_On_Conflict = {
  constraint: Eatfresh_Order_Extra_Constraint;
  update_columns?: Array<Eatfresh_Order_Extra_Update_Column>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.order_extra". */
export type Eatfresh_Order_Extra_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_extra_customer_orders_aggregate?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  vat_category?: InputMaybe<Eatfresh_Vat_Category_Order_By>;
  vat_category_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.order_extra */
export type Eatfresh_Order_Extra_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.order_extra" */
export enum Eatfresh_Order_Extra_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Slug = 'slug',
  /** column name */
  VatCategoryId = 'vat_category_id'
}

/** input type for updating data in table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  vat_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Order_Extra_Stddev_Fields = {
  __typename?: 'eatfresh_order_extra_stddev_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Order_Extra_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_order_extra_stddev_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Order_Extra_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_order_extra_stddev_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_order_extra" */
export type Eatfresh_Order_Extra_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Order_Extra_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Order_Extra_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['bigint']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  vat_category_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Order_Extra_Sum_Fields = {
  __typename?: 'eatfresh_order_extra_sum_fields';
  price?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.order_extra" */
export enum Eatfresh_Order_Extra_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Slug = 'slug',
  /** column name */
  VatCategoryId = 'vat_category_id'
}

export type Eatfresh_Order_Extra_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Order_Extra_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Order_Extra_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Order_Extra_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Order_Extra_Var_Pop_Fields = {
  __typename?: 'eatfresh_order_extra_var_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Order_Extra_Var_Samp_Fields = {
  __typename?: 'eatfresh_order_extra_var_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Order_Extra_Variance_Fields = {
  __typename?: 'eatfresh_order_extra_variance_fields';
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.order_extra" */
export type Eatfresh_Order_Extra_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.order_position" */
export type Eatfresh_Order_Position = {
  __typename?: 'eatfresh_order_position';
  article_name: Scalars['String']['output'];
  category: Eatfresh_Order_Position_Category_Enum;
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer_order: Eatfresh_Customer_Order;
  deposit?: Maybe<Scalars['Int']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  gross_sales_price?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['uuid']['output'];
  order_id: Scalars['uuid']['output'];
  /** An object relationship */
  order_position_category: Eatfresh_Order_Position_Category;
  quantity?: Maybe<Scalars['bigint']['output']>;
  tax_rate?: Maybe<Scalars['bigint']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "eatfresh.order_position" */
export type Eatfresh_Order_Position_Aggregate = {
  __typename?: 'eatfresh_order_position_aggregate';
  aggregate?: Maybe<Eatfresh_Order_Position_Aggregate_Fields>;
  nodes: Array<Eatfresh_Order_Position>;
};

export type Eatfresh_Order_Position_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Order_Position_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Order_Position_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.order_position" */
export type Eatfresh_Order_Position_Aggregate_Fields = {
  __typename?: 'eatfresh_order_position_aggregate_fields';
  avg?: Maybe<Eatfresh_Order_Position_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Order_Position_Max_Fields>;
  min?: Maybe<Eatfresh_Order_Position_Min_Fields>;
  stddev?: Maybe<Eatfresh_Order_Position_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Order_Position_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Order_Position_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Order_Position_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Order_Position_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Order_Position_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Order_Position_Variance_Fields>;
};


/** aggregate fields of "eatfresh.order_position" */
export type Eatfresh_Order_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Order_Position_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Order_Position_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Order_Position_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Order_Position_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Order_Position_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Order_Position_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Order_Position_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Order_Position_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Order_Position_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Order_Position_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Order_Position_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Order_Position_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Order_Position_Avg_Fields = {
  __typename?: 'eatfresh_order_position_avg_fields';
  deposit?: Maybe<Scalars['Float']['output']>;
  gross_sales_price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Avg_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.order_position". All fields are combined with a logical 'AND'. */
export type Eatfresh_Order_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Order_Position_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Order_Position_Bool_Exp>>;
  article_name?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<Eatfresh_Order_Position_Category_Enum_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  deposit?: InputMaybe<Int_Comparison_Exp>;
  ean?: InputMaybe<String_Comparison_Exp>;
  gross_sales_price?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_position_category?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
  quantity?: InputMaybe<Bigint_Comparison_Exp>;
  tax_rate?: InputMaybe<Bigint_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category = {
  __typename?: 'eatfresh_order_position_category';
  description: Scalars['String']['output'];
  /** An array relationship */
  order_positions: Array<Eatfresh_Order_Position>;
  /** An aggregate relationship */
  order_positions_aggregate: Eatfresh_Order_Position_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_CategoryOrder_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_CategoryOrder_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_Aggregate = {
  __typename?: 'eatfresh_order_position_category_aggregate';
  aggregate?: Maybe<Eatfresh_Order_Position_Category_Aggregate_Fields>;
  nodes: Array<Eatfresh_Order_Position_Category>;
};

/** aggregate fields of "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_Aggregate_Fields = {
  __typename?: 'eatfresh_order_position_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Order_Position_Category_Max_Fields>;
  min?: Maybe<Eatfresh_Order_Position_Category_Min_Fields>;
};


/** aggregate fields of "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Order_Position_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.order_position_category". All fields are combined with a logical 'AND'. */
export type Eatfresh_Order_Position_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Order_Position_Category_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Order_Position_Category_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  order_positions?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
  order_positions_aggregate?: InputMaybe<Eatfresh_Order_Position_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.order_position_category" */
export enum Eatfresh_Order_Position_Category_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrderPositionCategoryPkey = 'order_position_category_pkey'
}

export enum Eatfresh_Order_Position_Category_Enum {
  /** Article */
  Article = 'ARTICLE',
  /** Order Extra */
  OrderExtra = 'ORDER_EXTRA'
}

/** Boolean expression to compare columns of type "eatfresh_order_position_category_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Order_Position_Category_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Order_Position_Category_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Order_Position_Category_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Order_Position_Category_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Order_Position_Category_Enum>>;
};

/** input type for inserting data into table "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  order_positions?: InputMaybe<Eatfresh_Order_Position_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Order_Position_Category_Max_Fields = {
  __typename?: 'eatfresh_order_position_category_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Order_Position_Category_Min_Fields = {
  __typename?: 'eatfresh_order_position_category_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_Mutation_Response = {
  __typename?: 'eatfresh_order_position_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Order_Position_Category>;
};

/** input type for inserting object relation for remote table "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_Obj_Rel_Insert_Input = {
  data: Eatfresh_Order_Position_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Order_Position_Category_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_On_Conflict = {
  constraint: Eatfresh_Order_Position_Category_Constraint;
  update_columns?: Array<Eatfresh_Order_Position_Category_Update_Column>;
  where?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.order_position_category". */
export type Eatfresh_Order_Position_Category_Order_By = {
  description?: InputMaybe<Order_By>;
  order_positions_aggregate?: InputMaybe<Eatfresh_Order_Position_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.order_position_category */
export type Eatfresh_Order_Position_Category_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.order_position_category" */
export enum Eatfresh_Order_Position_Category_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.order_position_category" */
export type Eatfresh_Order_Position_Category_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_order_position_category" */
export type Eatfresh_Order_Position_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Order_Position_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Order_Position_Category_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.order_position_category" */
export enum Eatfresh_Order_Position_Category_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Order_Position_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Order_Position_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Order_Position_Category_Bool_Exp;
};

/** unique or primary key constraints on table "eatfresh.order_position" */
export enum Eatfresh_Order_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshOrderPositionPkey = 'eatfresh_order_position_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Inc_Input = {
  deposit?: InputMaybe<Scalars['Int']['input']>;
  gross_sales_price?: InputMaybe<Scalars['bigint']['input']>;
  quantity?: InputMaybe<Scalars['bigint']['input']>;
  tax_rate?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Insert_Input = {
  article_name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Eatfresh_Order_Position_Category_Enum>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Obj_Rel_Insert_Input>;
  deposit?: InputMaybe<Scalars['Int']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  gross_sales_price?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  order_position_category?: InputMaybe<Eatfresh_Order_Position_Category_Obj_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['bigint']['input']>;
  tax_rate?: InputMaybe<Scalars['bigint']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Order_Position_Max_Fields = {
  __typename?: 'eatfresh_order_position_max_fields';
  article_name?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  deposit?: Maybe<Scalars['Int']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  gross_sales_price?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['bigint']['output']>;
  tax_rate?: Maybe<Scalars['bigint']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Max_Order_By = {
  article_name?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  deposit?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Order_Position_Min_Fields = {
  __typename?: 'eatfresh_order_position_min_fields';
  article_name?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  deposit?: Maybe<Scalars['Int']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  gross_sales_price?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['bigint']['output']>;
  tax_rate?: Maybe<Scalars['bigint']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Min_Order_By = {
  article_name?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  deposit?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Mutation_Response = {
  __typename?: 'eatfresh_order_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Order_Position>;
};

/** on_conflict condition type for table "eatfresh.order_position" */
export type Eatfresh_Order_Position_On_Conflict = {
  constraint: Eatfresh_Order_Position_Constraint;
  update_columns?: Array<Eatfresh_Order_Position_Update_Column>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.order_position". */
export type Eatfresh_Order_Position_Order_By = {
  article_name?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Order_By>;
  deposit?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  order_position_category?: InputMaybe<Eatfresh_Order_Position_Category_Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.order_position */
export type Eatfresh_Order_Position_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.order_position" */
export enum Eatfresh_Order_Position_Select_Column {
  /** column name */
  ArticleName = 'article_name',
  /** column name */
  Category = 'category',
  /** column name */
  Created = 'created',
  /** column name */
  Deposit = 'deposit',
  /** column name */
  Ean = 'ean',
  /** column name */
  GrossSalesPrice = 'gross_sales_price',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TaxRate = 'tax_rate',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Set_Input = {
  article_name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Eatfresh_Order_Position_Category_Enum>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  deposit?: InputMaybe<Scalars['Int']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  gross_sales_price?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['bigint']['input']>;
  tax_rate?: InputMaybe<Scalars['bigint']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Order_Position_Stddev_Fields = {
  __typename?: 'eatfresh_order_position_stddev_fields';
  deposit?: Maybe<Scalars['Float']['output']>;
  gross_sales_price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Stddev_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Order_Position_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_order_position_stddev_pop_fields';
  deposit?: Maybe<Scalars['Float']['output']>;
  gross_sales_price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Stddev_Pop_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Order_Position_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_order_position_stddev_samp_fields';
  deposit?: Maybe<Scalars['Float']['output']>;
  gross_sales_price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Stddev_Samp_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_order_position" */
export type Eatfresh_Order_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Order_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Order_Position_Stream_Cursor_Value_Input = {
  article_name?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Eatfresh_Order_Position_Category_Enum>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  deposit?: InputMaybe<Scalars['Int']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  gross_sales_price?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['bigint']['input']>;
  tax_rate?: InputMaybe<Scalars['bigint']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Order_Position_Sum_Fields = {
  __typename?: 'eatfresh_order_position_sum_fields';
  deposit?: Maybe<Scalars['Int']['output']>;
  gross_sales_price?: Maybe<Scalars['bigint']['output']>;
  quantity?: Maybe<Scalars['bigint']['output']>;
  tax_rate?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Sum_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.order_position" */
export enum Eatfresh_Order_Position_Update_Column {
  /** column name */
  ArticleName = 'article_name',
  /** column name */
  Category = 'category',
  /** column name */
  Created = 'created',
  /** column name */
  Deposit = 'deposit',
  /** column name */
  Ean = 'ean',
  /** column name */
  GrossSalesPrice = 'gross_sales_price',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TaxRate = 'tax_rate',
  /** column name */
  Updated = 'updated'
}

export type Eatfresh_Order_Position_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Order_Position_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Order_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Order_Position_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Order_Position_Var_Pop_Fields = {
  __typename?: 'eatfresh_order_position_var_pop_fields';
  deposit?: Maybe<Scalars['Float']['output']>;
  gross_sales_price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Var_Pop_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Order_Position_Var_Samp_Fields = {
  __typename?: 'eatfresh_order_position_var_samp_fields';
  deposit?: Maybe<Scalars['Float']['output']>;
  gross_sales_price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Var_Samp_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Order_Position_Variance_Fields = {
  __typename?: 'eatfresh_order_position_variance_fields';
  deposit?: Maybe<Scalars['Float']['output']>;
  gross_sales_price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.order_position" */
export type Eatfresh_Order_Position_Variance_Order_By = {
  deposit?: InputMaybe<Order_By>;
  gross_sales_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.order_status" */
export type Eatfresh_Order_Status = {
  __typename?: 'eatfresh_order_status';
  /** An array relationship */
  customer_orders: Array<Eatfresh_Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Eatfresh_Customer_Order_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.order_status" */
export type Eatfresh_Order_StatusCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.order_status" */
export type Eatfresh_Order_StatusCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};

/** aggregated selection of "eatfresh.order_status" */
export type Eatfresh_Order_Status_Aggregate = {
  __typename?: 'eatfresh_order_status_aggregate';
  aggregate?: Maybe<Eatfresh_Order_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Order_Status>;
};

/** aggregate fields of "eatfresh.order_status" */
export type Eatfresh_Order_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_order_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Order_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Order_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.order_status" */
export type Eatfresh_Order_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Order_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.order_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Order_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Order_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Order_Status_Bool_Exp>>;
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.order_status" */
export enum Eatfresh_Order_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrderStatusPkey = 'order_status_pkey'
}

export enum Eatfresh_Order_Status_Enum {
  /** Clicked on a payment method. */
  AddingPayment = 'ADDING_PAYMENT',
  /** Attempted to add payment method but never succeeded. */
  AddingPaymentFailed = 'ADDING_PAYMENT_FAILED',
  /** Fridge cabinetState was not readyForPurchase */
  CabinetStateFail = 'CABINET_STATE_FAIL',
  /** the order was canceled or fridge time-outed or there was an empty order */
  Canceled = 'CANCELED',
  /** the order is being processed */
  Draft = 'DRAFT',
  /** The order did not have any items */
  Empty = 'EMPTY',
  /** Fridge had another draft order. */
  FridgeBusyFail = 'FRIDGE_BUSY_FAIL',
  /** Fridge was disabled. */
  FridgeDisabledFail = 'FRIDGE_DISABLED_FAIL',
  /** The Selfly check-in API returned an error. */
  SelflyCheckinFail = 'SELFLY_CHECKIN_FAIL',
  /** the order was a success */
  Success = 'SUCCESS',
  /** The order timed out */
  Timeout = 'TIMEOUT',
  /** An unknown error happened when trying to check-in. */
  UnknownFail = 'UNKNOWN_FAIL'
}

/** Boolean expression to compare columns of type "eatfresh_order_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Order_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Order_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Order_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Order_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Order_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.order_status" */
export type Eatfresh_Order_Status_Insert_Input = {
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Order_Status_Max_Fields = {
  __typename?: 'eatfresh_order_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Order_Status_Min_Fields = {
  __typename?: 'eatfresh_order_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.order_status" */
export type Eatfresh_Order_Status_Mutation_Response = {
  __typename?: 'eatfresh_order_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Order_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.order_status" */
export type Eatfresh_Order_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Order_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Order_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.order_status" */
export type Eatfresh_Order_Status_On_Conflict = {
  constraint: Eatfresh_Order_Status_Constraint;
  update_columns?: Array<Eatfresh_Order_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.order_status". */
export type Eatfresh_Order_Status_Order_By = {
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.order_status */
export type Eatfresh_Order_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.order_status" */
export enum Eatfresh_Order_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.order_status" */
export type Eatfresh_Order_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_order_status" */
export type Eatfresh_Order_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Order_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Order_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.order_status" */
export enum Eatfresh_Order_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Order_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Order_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Order_Status_Bool_Exp;
};

/** columns and relationships of "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type = {
  __typename?: 'eatfresh_packaging_type';
  /** An array relationship */
  article_details: Array<Eatfresh_Article_Details>;
  /** An aggregate relationship */
  article_details_aggregate: Eatfresh_Article_Details_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.packaging_type" */
export type Eatfresh_Packaging_TypeArticle_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


/** columns and relationships of "eatfresh.packaging_type" */
export type Eatfresh_Packaging_TypeArticle_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};

/** aggregated selection of "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_Aggregate = {
  __typename?: 'eatfresh_packaging_type_aggregate';
  aggregate?: Maybe<Eatfresh_Packaging_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Packaging_Type>;
};

/** aggregate fields of "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_packaging_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Packaging_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Packaging_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Packaging_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.packaging_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Packaging_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Packaging_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Packaging_Type_Bool_Exp>>;
  article_details?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  article_details_aggregate?: InputMaybe<Eatfresh_Article_Details_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.packaging_type" */
export enum Eatfresh_Packaging_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PackagingTypePkey = 'packaging_type_pkey'
}

/** input type for inserting data into table "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_Insert_Input = {
  article_details?: InputMaybe<Eatfresh_Article_Details_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Packaging_Type_Max_Fields = {
  __typename?: 'eatfresh_packaging_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Packaging_Type_Min_Fields = {
  __typename?: 'eatfresh_packaging_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_Mutation_Response = {
  __typename?: 'eatfresh_packaging_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Packaging_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Packaging_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Packaging_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_On_Conflict = {
  constraint: Eatfresh_Packaging_Type_Constraint;
  update_columns?: Array<Eatfresh_Packaging_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.packaging_type". */
export type Eatfresh_Packaging_Type_Order_By = {
  article_details_aggregate?: InputMaybe<Eatfresh_Article_Details_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.packaging_type */
export type Eatfresh_Packaging_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.packaging_type" */
export enum Eatfresh_Packaging_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.packaging_type" */
export type Eatfresh_Packaging_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_packaging_type" */
export type Eatfresh_Packaging_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Packaging_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Packaging_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.packaging_type" */
export enum Eatfresh_Packaging_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Packaging_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Packaging_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Packaging_Type_Bool_Exp;
};

/** columns and relationships of "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token = {
  __typename?: 'eatfresh_password_reset_token';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  token: Scalars['String']['output'];
  used: Scalars['Boolean']['output'];
  /** An object relationship */
  userAccountByUserEmail: Eatfresh_User_Account;
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_email: Scalars['String']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Aggregate = {
  __typename?: 'eatfresh_password_reset_token_aggregate';
  aggregate?: Maybe<Eatfresh_Password_Reset_Token_Aggregate_Fields>;
  nodes: Array<Eatfresh_Password_Reset_Token>;
};

export type Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Password_Reset_Token_Select_Column_Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Password_Reset_Token_Select_Column_Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Aggregate_Fields = {
  __typename?: 'eatfresh_password_reset_token_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Password_Reset_Token_Max_Fields>;
  min?: Maybe<Eatfresh_Password_Reset_Token_Min_Fields>;
};


/** aggregate fields of "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Password_Reset_Token_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Password_Reset_Token_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Password_Reset_Token_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Password_Reset_Token_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.password_reset_token". All fields are combined with a logical 'AND'. */
export type Eatfresh_Password_Reset_Token_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  used?: InputMaybe<Boolean_Comparison_Exp>;
  userAccountByUserEmail?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_email?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.password_reset_token" */
export enum Eatfresh_Password_Reset_Token_Constraint {
  /** unique or primary key constraint on columns "id" */
  PasswordResetTokensTempPkey = 'password_reset_tokens_temp_pkey',
  /** unique or primary key constraint on columns "token" */
  PasswordResetTokensTempTokenKey = 'password_reset_tokens_temp_token_key'
}

/** input type for inserting data into table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  userAccountByUserEmail?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Password_Reset_Token_Max_Fields = {
  __typename?: 'eatfresh_password_reset_token_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Password_Reset_Token_Min_Fields = {
  __typename?: 'eatfresh_password_reset_token_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Mutation_Response = {
  __typename?: 'eatfresh_password_reset_token_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Password_Reset_Token>;
};

/** on_conflict condition type for table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_On_Conflict = {
  constraint: Eatfresh_Password_Reset_Token_Constraint;
  update_columns?: Array<Eatfresh_Password_Reset_Token_Update_Column>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.password_reset_token". */
export type Eatfresh_Password_Reset_Token_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
  userAccountByUserEmail?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.password_reset_token */
export type Eatfresh_Password_Reset_Token_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.password_reset_token" */
export enum Eatfresh_Password_Reset_Token_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  Used = 'used',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id'
}

/** select "eatfresh_password_reset_token_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.password_reset_token" */
export enum Eatfresh_Password_Reset_Token_Select_Column_Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Used = 'used'
}

/** select "eatfresh_password_reset_token_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.password_reset_token" */
export enum Eatfresh_Password_Reset_Token_Select_Column_Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Used = 'used'
}

/** input type for updating data in table "eatfresh.password_reset_token" */
export type Eatfresh_Password_Reset_Token_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_password_reset_token" */
export type Eatfresh_Password_Reset_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Password_Reset_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Password_Reset_Token_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.password_reset_token" */
export enum Eatfresh_Password_Reset_Token_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  Used = 'used',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Password_Reset_Token_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Password_Reset_Token_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Password_Reset_Token_Bool_Exp;
};

/** columns and relationships of "eatfresh.payment_method" */
export type Eatfresh_Payment_Method = {
  __typename?: 'eatfresh_payment_method';
  brand?: Maybe<Scalars['String']['output']>;
  capture?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  customerOrdersByPaymentMethodId: Array<Eatfresh_Customer_Order>;
  /** An aggregate relationship */
  customerOrdersByPaymentMethodId_aggregate: Eatfresh_Customer_Order_Aggregate;
  /** An array relationship */
  customer_orders: Array<Eatfresh_Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Eatfresh_Customer_Order_Aggregate;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  expirydate?: Maybe<Scalars['String']['output']>;
  hold_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  payid?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  paymentMethodTypeByPaymentMethodType: Eatfresh_Payment_Method_Type;
  payment_method_type: Eatfresh_Payment_Method_Type_Enum;
  pseudo_card_number?: Maybe<Scalars['String']['output']>;
  schemereferenceid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trans_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.payment_method" */
export type Eatfresh_Payment_MethodCustomerOrdersByPaymentMethodIdArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.payment_method" */
export type Eatfresh_Payment_MethodCustomerOrdersByPaymentMethodId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.payment_method" */
export type Eatfresh_Payment_MethodCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.payment_method" */
export type Eatfresh_Payment_MethodCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};

/** aggregated selection of "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Aggregate = {
  __typename?: 'eatfresh_payment_method_aggregate';
  aggregate?: Maybe<Eatfresh_Payment_Method_Aggregate_Fields>;
  nodes: Array<Eatfresh_Payment_Method>;
};

export type Eatfresh_Payment_Method_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Payment_Method_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Payment_Method_Select_Column_Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Payment_Method_Select_Column_Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Payment_Method_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Aggregate_Fields = {
  __typename?: 'eatfresh_payment_method_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Payment_Method_Max_Fields>;
  min?: Maybe<Eatfresh_Payment_Method_Min_Fields>;
};


/** aggregate fields of "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Payment_Method_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Payment_Method_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Payment_Method_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Payment_Method_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.payment_method". All fields are combined with a logical 'AND'. */
export type Eatfresh_Payment_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Payment_Method_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Payment_Method_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  capture?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customerOrdersByPaymentMethodId?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  customerOrdersByPaymentMethodId_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp>;
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expirydate?: InputMaybe<String_Comparison_Exp>;
  hold_minted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  payid?: InputMaybe<String_Comparison_Exp>;
  paymentMethodTypeByPaymentMethodType?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
  payment_method_type?: InputMaybe<Eatfresh_Payment_Method_Type_Enum_Comparison_Exp>;
  pseudo_card_number?: InputMaybe<String_Comparison_Exp>;
  schemereferenceid?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trans_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.payment_method" */
export enum Eatfresh_Payment_Method_Constraint {
  /** unique or primary key constraint on columns "trans_id" */
  PaymentMethodPkey = 'payment_method_pkey'
}

/** input type for inserting data into table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Insert_Input = {
  brand?: InputMaybe<Scalars['String']['input']>;
  capture?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customerOrdersByPaymentMethodId?: InputMaybe<Eatfresh_Customer_Order_Arr_Rel_Insert_Input>;
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Arr_Rel_Insert_Input>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expirydate?: InputMaybe<Scalars['String']['input']>;
  hold_minted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payid?: InputMaybe<Scalars['String']['input']>;
  paymentMethodTypeByPaymentMethodType?: InputMaybe<Eatfresh_Payment_Method_Type_Obj_Rel_Insert_Input>;
  payment_method_type?: InputMaybe<Eatfresh_Payment_Method_Type_Enum>;
  pseudo_card_number?: InputMaybe<Scalars['String']['input']>;
  schemereferenceid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trans_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Payment_Method_Max_Fields = {
  __typename?: 'eatfresh_payment_method_max_fields';
  brand?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  expirydate?: Maybe<Scalars['String']['output']>;
  hold_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  payid?: Maybe<Scalars['String']['output']>;
  pseudo_card_number?: Maybe<Scalars['String']['output']>;
  schemereferenceid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trans_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Max_Order_By = {
  brand?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  expirydate?: InputMaybe<Order_By>;
  hold_minted_at?: InputMaybe<Order_By>;
  payid?: InputMaybe<Order_By>;
  pseudo_card_number?: InputMaybe<Order_By>;
  schemereferenceid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trans_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Payment_Method_Min_Fields = {
  __typename?: 'eatfresh_payment_method_min_fields';
  brand?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  expirydate?: Maybe<Scalars['String']['output']>;
  hold_minted_at?: Maybe<Scalars['timestamptz']['output']>;
  payid?: Maybe<Scalars['String']['output']>;
  pseudo_card_number?: Maybe<Scalars['String']['output']>;
  schemereferenceid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trans_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Min_Order_By = {
  brand?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  expirydate?: InputMaybe<Order_By>;
  hold_minted_at?: InputMaybe<Order_By>;
  payid?: InputMaybe<Order_By>;
  pseudo_card_number?: InputMaybe<Order_By>;
  schemereferenceid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trans_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Mutation_Response = {
  __typename?: 'eatfresh_payment_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Payment_Method>;
};

/** input type for inserting object relation for remote table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Obj_Rel_Insert_Input = {
  data: Eatfresh_Payment_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Payment_Method_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_On_Conflict = {
  constraint: Eatfresh_Payment_Method_Constraint;
  update_columns?: Array<Eatfresh_Payment_Method_Update_Column>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.payment_method". */
export type Eatfresh_Payment_Method_Order_By = {
  brand?: InputMaybe<Order_By>;
  capture?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customerOrdersByPaymentMethodId_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Order_By>;
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  expirydate?: InputMaybe<Order_By>;
  hold_minted_at?: InputMaybe<Order_By>;
  payid?: InputMaybe<Order_By>;
  paymentMethodTypeByPaymentMethodType?: InputMaybe<Eatfresh_Payment_Method_Type_Order_By>;
  payment_method_type?: InputMaybe<Order_By>;
  pseudo_card_number?: InputMaybe<Order_By>;
  schemereferenceid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trans_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.payment_method */
export type Eatfresh_Payment_Method_Pk_Columns_Input = {
  trans_id: Scalars['String']['input'];
};

/** select columns of table "eatfresh.payment_method" */
export enum Eatfresh_Payment_Method_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  Capture = 'capture',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Expirydate = 'expirydate',
  /** column name */
  HoldMintedAt = 'hold_minted_at',
  /** column name */
  Payid = 'payid',
  /** column name */
  PaymentMethodType = 'payment_method_type',
  /** column name */
  PseudoCardNumber = 'pseudo_card_number',
  /** column name */
  Schemereferenceid = 'schemereferenceid',
  /** column name */
  Status = 'status',
  /** column name */
  TransId = 'trans_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "eatfresh_payment_method_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.payment_method" */
export enum Eatfresh_Payment_Method_Select_Column_Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Capture = 'capture'
}

/** select "eatfresh_payment_method_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.payment_method" */
export enum Eatfresh_Payment_Method_Select_Column_Eatfresh_Payment_Method_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Capture = 'capture'
}

/** input type for updating data in table "eatfresh.payment_method" */
export type Eatfresh_Payment_Method_Set_Input = {
  brand?: InputMaybe<Scalars['String']['input']>;
  capture?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expirydate?: InputMaybe<Scalars['String']['input']>;
  hold_minted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payid?: InputMaybe<Scalars['String']['input']>;
  payment_method_type?: InputMaybe<Eatfresh_Payment_Method_Type_Enum>;
  pseudo_card_number?: InputMaybe<Scalars['String']['input']>;
  schemereferenceid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trans_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_payment_method" */
export type Eatfresh_Payment_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Payment_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Payment_Method_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']['input']>;
  capture?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expirydate?: InputMaybe<Scalars['String']['input']>;
  hold_minted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payid?: InputMaybe<Scalars['String']['input']>;
  payment_method_type?: InputMaybe<Eatfresh_Payment_Method_Type_Enum>;
  pseudo_card_number?: InputMaybe<Scalars['String']['input']>;
  schemereferenceid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trans_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type = {
  __typename?: 'eatfresh_payment_method_type';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  payment_methods: Array<Eatfresh_Payment_Method>;
  /** An aggregate relationship */
  payment_methods_aggregate: Eatfresh_Payment_Method_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_TypePayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


/** columns and relationships of "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_TypePayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};

/** aggregated selection of "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_Aggregate = {
  __typename?: 'eatfresh_payment_method_type_aggregate';
  aggregate?: Maybe<Eatfresh_Payment_Method_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Payment_Method_Type>;
};

/** aggregate fields of "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_payment_method_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Payment_Method_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Payment_Method_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.payment_method_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Payment_Method_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  payment_methods?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Eatfresh_Payment_Method_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.payment_method_type" */
export enum Eatfresh_Payment_Method_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PaymentMethodTypePkey = 'payment_method_type_pkey'
}

export enum Eatfresh_Payment_Method_Type_Enum {
  ApplePay = 'ApplePay',
  Cc = 'CC',
  CreditCard = 'CreditCard',
  GooglePay = 'GooglePay',
  MasterCard = 'MasterCard',
  PayPal = 'PayPal',
  Ssl = 'SSL',
  Visa = 'Visa'
}

/** Boolean expression to compare columns of type "eatfresh_payment_method_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Payment_Method_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Payment_Method_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Payment_Method_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  payment_methods?: InputMaybe<Eatfresh_Payment_Method_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Payment_Method_Type_Max_Fields = {
  __typename?: 'eatfresh_payment_method_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Payment_Method_Type_Min_Fields = {
  __typename?: 'eatfresh_payment_method_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_Mutation_Response = {
  __typename?: 'eatfresh_payment_method_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Payment_Method_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Payment_Method_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Payment_Method_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_On_Conflict = {
  constraint: Eatfresh_Payment_Method_Type_Constraint;
  update_columns?: Array<Eatfresh_Payment_Method_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.payment_method_type". */
export type Eatfresh_Payment_Method_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  payment_methods_aggregate?: InputMaybe<Eatfresh_Payment_Method_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.payment_method_type */
export type Eatfresh_Payment_Method_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.payment_method_type" */
export enum Eatfresh_Payment_Method_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.payment_method_type" */
export type Eatfresh_Payment_Method_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_payment_method_type" */
export type Eatfresh_Payment_Method_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Payment_Method_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Payment_Method_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.payment_method_type" */
export enum Eatfresh_Payment_Method_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Payment_Method_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Payment_Method_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Payment_Method_Type_Bool_Exp;
};

/** update columns of table "eatfresh.payment_method" */
export enum Eatfresh_Payment_Method_Update_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  Capture = 'capture',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Expirydate = 'expirydate',
  /** column name */
  HoldMintedAt = 'hold_minted_at',
  /** column name */
  Payid = 'payid',
  /** column name */
  PaymentMethodType = 'payment_method_type',
  /** column name */
  PseudoCardNumber = 'pseudo_card_number',
  /** column name */
  Schemereferenceid = 'schemereferenceid',
  /** column name */
  Status = 'status',
  /** column name */
  TransId = 'trans_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Payment_Method_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Payment_Method_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Payment_Method_Bool_Exp;
};

/** columns and relationships of "eatfresh.payment_status" */
export type Eatfresh_Payment_Status = {
  __typename?: 'eatfresh_payment_status';
  /** An array relationship */
  customer_orders: Array<Eatfresh_Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Eatfresh_Customer_Order_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.payment_status" */
export type Eatfresh_Payment_StatusCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.payment_status" */
export type Eatfresh_Payment_StatusCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};

/** aggregated selection of "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_Aggregate = {
  __typename?: 'eatfresh_payment_status_aggregate';
  aggregate?: Maybe<Eatfresh_Payment_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Payment_Status>;
};

/** aggregate fields of "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_payment_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Payment_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Payment_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Payment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.payment_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Payment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Payment_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Payment_Status_Bool_Exp>>;
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.payment_status" */
export enum Eatfresh_Payment_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  PaymentStatusPkey = 'payment_status_pkey'
}

export enum Eatfresh_Payment_Status_Enum {
  /** The payment was canceled */
  Canceled = 'CANCELED',
  /** The payment was completed */
  Completed = 'COMPLETED',
  /** The payment failed */
  Failed = 'FAILED',
  /** The payment is pending */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "eatfresh_payment_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Payment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Payment_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Payment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Payment_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Payment_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_Insert_Input = {
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Payment_Status_Max_Fields = {
  __typename?: 'eatfresh_payment_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Payment_Status_Min_Fields = {
  __typename?: 'eatfresh_payment_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_Mutation_Response = {
  __typename?: 'eatfresh_payment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Payment_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Payment_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Payment_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_On_Conflict = {
  constraint: Eatfresh_Payment_Status_Constraint;
  update_columns?: Array<Eatfresh_Payment_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.payment_status". */
export type Eatfresh_Payment_Status_Order_By = {
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.payment_status */
export type Eatfresh_Payment_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.payment_status" */
export enum Eatfresh_Payment_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.payment_status" */
export type Eatfresh_Payment_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_payment_status" */
export type Eatfresh_Payment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Payment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Payment_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.payment_status" */
export enum Eatfresh_Payment_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Payment_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Payment_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Payment_Status_Bool_Exp;
};

/** columns and relationships of "eatfresh.place" */
export type Eatfresh_Place = {
  __typename?: 'eatfresh_place';
  additional_line?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  assetTransfersByToPlaceId: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  assetTransfersByToPlaceId_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  directions_pdf_id?: Maybe<Scalars['uuid']['output']>;
  directions_summary?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fridges: Array<Eatfresh_Fridge>;
  /** An aggregate relationship */
  fridges_aggregate: Eatfresh_Fridge_Aggregate;
  google_maps_url: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_sync?: Maybe<Scalars['timestamptz']['output']>;
  latitude: Scalars['float8']['output'];
  location_name?: Maybe<Scalars['String']['output']>;
  longitude: Scalars['float8']['output'];
  name: Scalars['String']['output'];
  nb: Scalars['String']['output'];
  street: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploaded_file?: Maybe<Eatfresh_Uploaded_File>;
  /** An array relationship */
  warehouses: Array<Eatfresh_Warehouse>;
  /** An aggregate relationship */
  warehouses_aggregate: Eatfresh_Warehouse_Aggregate;
  zip_code: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceAssetTransfersByToPlaceIdArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceAssetTransfersByToPlaceId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceFridgesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceFridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceWarehousesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};


/** columns and relationships of "eatfresh.place" */
export type Eatfresh_PlaceWarehouses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};

/** aggregated selection of "eatfresh.place" */
export type Eatfresh_Place_Aggregate = {
  __typename?: 'eatfresh_place_aggregate';
  aggregate?: Maybe<Eatfresh_Place_Aggregate_Fields>;
  nodes: Array<Eatfresh_Place>;
};

export type Eatfresh_Place_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp_Var_Samp>;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Avg = {
  arguments: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Corr = {
  arguments: Eatfresh_Place_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Eatfresh_Place_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Max = {
  arguments: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Min = {
  arguments: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Sum = {
  arguments: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Eatfresh_Place_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "eatfresh.place" */
export type Eatfresh_Place_Aggregate_Fields = {
  __typename?: 'eatfresh_place_aggregate_fields';
  avg?: Maybe<Eatfresh_Place_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Place_Max_Fields>;
  min?: Maybe<Eatfresh_Place_Min_Fields>;
  stddev?: Maybe<Eatfresh_Place_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Place_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Place_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Place_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Place_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Place_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Place_Variance_Fields>;
};


/** aggregate fields of "eatfresh.place" */
export type Eatfresh_Place_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.place" */
export type Eatfresh_Place_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Place_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Place_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Place_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Place_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Place_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Place_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Place_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Place_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Place_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Place_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.place" */
export type Eatfresh_Place_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Place_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Place_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Place_Avg_Fields = {
  __typename?: 'eatfresh_place_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Avg_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.place". All fields are combined with a logical 'AND'. */
export type Eatfresh_Place_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Place_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Place_Bool_Exp>>;
  additional_line?: InputMaybe<String_Comparison_Exp>;
  assetTransfersByToPlaceId?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  assetTransfersByToPlaceId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  directions_pdf_id?: InputMaybe<Uuid_Comparison_Exp>;
  directions_summary?: InputMaybe<String_Comparison_Exp>;
  fridges?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp>;
  google_maps_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_sync?: InputMaybe<Timestamptz_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  location_name?: InputMaybe<String_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nb?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  warehouses?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouses_aggregate?: InputMaybe<Eatfresh_Warehouse_Aggregate_Bool_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.place" */
export enum Eatfresh_Place_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlacePkey = 'place_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.place" */
export type Eatfresh_Place_Inc_Input = {
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "eatfresh.place" */
export type Eatfresh_Place_Insert_Input = {
  additional_line?: InputMaybe<Scalars['String']['input']>;
  assetTransfersByToPlaceId?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  directions_pdf_id?: InputMaybe<Scalars['uuid']['input']>;
  directions_summary?: InputMaybe<Scalars['String']['input']>;
  fridges?: InputMaybe<Eatfresh_Fridge_Arr_Rel_Insert_Input>;
  google_maps_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nb?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Obj_Rel_Insert_Input>;
  warehouses?: InputMaybe<Eatfresh_Warehouse_Arr_Rel_Insert_Input>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Place_Max_Fields = {
  __typename?: 'eatfresh_place_max_fields';
  additional_line?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions_pdf_id?: Maybe<Scalars['uuid']['output']>;
  directions_summary?: Maybe<Scalars['String']['output']>;
  google_maps_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_sync?: Maybe<Scalars['timestamptz']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nb?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Max_Order_By = {
  additional_line?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  directions_pdf_id?: InputMaybe<Order_By>;
  directions_summary?: InputMaybe<Order_By>;
  google_maps_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_sync?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Place_Min_Fields = {
  __typename?: 'eatfresh_place_min_fields';
  additional_line?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions_pdf_id?: Maybe<Scalars['uuid']['output']>;
  directions_summary?: Maybe<Scalars['String']['output']>;
  google_maps_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_sync?: Maybe<Scalars['timestamptz']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nb?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Min_Order_By = {
  additional_line?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  directions_pdf_id?: InputMaybe<Order_By>;
  directions_summary?: InputMaybe<Order_By>;
  google_maps_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_sync?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.place" */
export type Eatfresh_Place_Mutation_Response = {
  __typename?: 'eatfresh_place_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Place>;
};

/** input type for inserting object relation for remote table "eatfresh.place" */
export type Eatfresh_Place_Obj_Rel_Insert_Input = {
  data: Eatfresh_Place_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Place_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.place" */
export type Eatfresh_Place_On_Conflict = {
  constraint: Eatfresh_Place_Constraint;
  update_columns?: Array<Eatfresh_Place_Update_Column>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.place". */
export type Eatfresh_Place_Order_By = {
  additional_line?: InputMaybe<Order_By>;
  assetTransfersByToPlaceId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  directions_pdf_id?: InputMaybe<Order_By>;
  directions_summary?: InputMaybe<Order_By>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Order_By>;
  google_maps_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_sync?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nb?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Order_By>;
  warehouses_aggregate?: InputMaybe<Eatfresh_Warehouse_Aggregate_Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.place */
export type Eatfresh_Place_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column {
  /** column name */
  AdditionalLine = 'additional_line',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  Description = 'description',
  /** column name */
  DirectionsPdfId = 'directions_pdf_id',
  /** column name */
  DirectionsSummary = 'directions_summary',
  /** column name */
  GoogleMapsUrl = 'google_maps_url',
  /** column name */
  Id = 'id',
  /** column name */
  LastSync = 'last_sync',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Nb = 'nb',
  /** column name */
  Street = 'street',
  /** column name */
  Updated = 'updated',
  /** column name */
  ZipCode = 'zip_code'
}

/** select "eatfresh_place_aggregate_bool_exp_avg_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_place_aggregate_bool_exp_corr_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_place_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_place_aggregate_bool_exp_max_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_place_aggregate_bool_exp_min_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_place_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_place_aggregate_bool_exp_sum_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "eatfresh_place_aggregate_bool_exp_var_samp_arguments_columns" columns of table "eatfresh.place" */
export enum Eatfresh_Place_Select_Column_Eatfresh_Place_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** input type for updating data in table "eatfresh.place" */
export type Eatfresh_Place_Set_Input = {
  additional_line?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  directions_pdf_id?: InputMaybe<Scalars['uuid']['input']>;
  directions_summary?: InputMaybe<Scalars['String']['input']>;
  google_maps_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nb?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Place_Stddev_Fields = {
  __typename?: 'eatfresh_place_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Stddev_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Place_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_place_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Stddev_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Place_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_place_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Stddev_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_place" */
export type Eatfresh_Place_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Place_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Place_Stream_Cursor_Value_Input = {
  additional_line?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  directions_pdf_id?: InputMaybe<Scalars['uuid']['input']>;
  directions_summary?: InputMaybe<Scalars['String']['input']>;
  google_maps_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  location_name?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nb?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Place_Sum_Fields = {
  __typename?: 'eatfresh_place_sum_fields';
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Sum_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.place" */
export enum Eatfresh_Place_Update_Column {
  /** column name */
  AdditionalLine = 'additional_line',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  Description = 'description',
  /** column name */
  DirectionsPdfId = 'directions_pdf_id',
  /** column name */
  DirectionsSummary = 'directions_summary',
  /** column name */
  GoogleMapsUrl = 'google_maps_url',
  /** column name */
  Id = 'id',
  /** column name */
  LastSync = 'last_sync',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name',
  /** column name */
  Nb = 'nb',
  /** column name */
  Street = 'street',
  /** column name */
  Updated = 'updated',
  /** column name */
  ZipCode = 'zip_code'
}

export type Eatfresh_Place_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Place_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Place_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Place_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Place_Var_Pop_Fields = {
  __typename?: 'eatfresh_place_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Var_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Place_Var_Samp_Fields = {
  __typename?: 'eatfresh_place_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Var_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Place_Variance_Fields = {
  __typename?: 'eatfresh_place_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.place" */
export type Eatfresh_Place_Variance_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.price_change" */
export type Eatfresh_Price_Change = {
  __typename?: 'eatfresh_price_change';
  /** An object relationship */
  article: Eatfresh_Article;
  article_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  new_retail_price: Scalars['Int']['output'];
  old_retail_price: Scalars['Int']['output'];
  /** An array relationship */
  price_change_positions: Array<Eatfresh_Price_Change_Position>;
  /** An aggregate relationship */
  price_change_positions_aggregate: Eatfresh_Price_Change_Position_Aggregate;
  /** An object relationship */
  price_lock?: Maybe<Eatfresh_Price_Lock>;
  price_lock_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "eatfresh.price_change" */
export type Eatfresh_Price_ChangePrice_Change_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.price_change" */
export type Eatfresh_Price_ChangePrice_Change_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.price_change" */
export type Eatfresh_Price_Change_Aggregate = {
  __typename?: 'eatfresh_price_change_aggregate';
  aggregate?: Maybe<Eatfresh_Price_Change_Aggregate_Fields>;
  nodes: Array<Eatfresh_Price_Change>;
};

export type Eatfresh_Price_Change_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Price_Change_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Price_Change_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.price_change" */
export type Eatfresh_Price_Change_Aggregate_Fields = {
  __typename?: 'eatfresh_price_change_aggregate_fields';
  avg?: Maybe<Eatfresh_Price_Change_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Price_Change_Max_Fields>;
  min?: Maybe<Eatfresh_Price_Change_Min_Fields>;
  stddev?: Maybe<Eatfresh_Price_Change_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Price_Change_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Price_Change_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Price_Change_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Price_Change_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Price_Change_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Price_Change_Variance_Fields>;
};


/** aggregate fields of "eatfresh.price_change" */
export type Eatfresh_Price_Change_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Price_Change_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Price_Change_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Price_Change_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Price_Change_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Price_Change_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Price_Change_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Price_Change_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Price_Change_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Price_Change_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Price_Change_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Price_Change_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Price_Change_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Price_Change_Avg_Fields = {
  __typename?: 'eatfresh_price_change_avg_fields';
  new_retail_price?: Maybe<Scalars['Float']['output']>;
  old_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Avg_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.price_change". All fields are combined with a logical 'AND'. */
export type Eatfresh_Price_Change_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Price_Change_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Price_Change_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_retail_price?: InputMaybe<Int_Comparison_Exp>;
  old_retail_price?: InputMaybe<Int_Comparison_Exp>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Bool_Exp>;
  price_lock?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
  price_lock_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.price_change" */
export enum Eatfresh_Price_Change_Constraint {
  /** unique or primary key constraint on columns "id" */
  PriceChangePkey = 'price_change_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Inc_Input = {
  new_retail_price?: InputMaybe<Scalars['Int']['input']>;
  old_retail_price?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_retail_price?: InputMaybe<Scalars['Int']['input']>;
  old_retail_price?: InputMaybe<Scalars['Int']['input']>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Arr_Rel_Insert_Input>;
  price_lock?: InputMaybe<Eatfresh_Price_Lock_Obj_Rel_Insert_Input>;
  price_lock_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Price_Change_Max_Fields = {
  __typename?: 'eatfresh_price_change_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  new_retail_price?: Maybe<Scalars['Int']['output']>;
  old_retail_price?: Maybe<Scalars['Int']['output']>;
  price_lock_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
  price_lock_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Price_Change_Min_Fields = {
  __typename?: 'eatfresh_price_change_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  new_retail_price?: Maybe<Scalars['Int']['output']>;
  old_retail_price?: Maybe<Scalars['Int']['output']>;
  price_lock_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
  price_lock_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Mutation_Response = {
  __typename?: 'eatfresh_price_change_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Price_Change>;
};

/** input type for inserting object relation for remote table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Obj_Rel_Insert_Input = {
  data: Eatfresh_Price_Change_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Price_Change_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.price_change" */
export type Eatfresh_Price_Change_On_Conflict = {
  constraint: Eatfresh_Price_Change_Constraint;
  update_columns?: Array<Eatfresh_Price_Change_Update_Column>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.price_change". */
export type Eatfresh_Price_Change_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Order_By>;
  price_lock?: InputMaybe<Eatfresh_Price_Lock_Order_By>;
  price_lock_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.price_change */
export type Eatfresh_Price_Change_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position = {
  __typename?: 'eatfresh_price_change_position';
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  confirmed_by_user?: Maybe<Eatfresh_User_Account>;
  confirmed_by_user_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  price_change: Eatfresh_Price_Change;
  price_change_id: Scalars['uuid']['output'];
  /** An object relationship */
  price_change_position_status: Eatfresh_Price_Change_Position_Status;
  /** An object relationship */
  refill?: Maybe<Eatfresh_Refill>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  status: Eatfresh_Price_Change_Position_Status_Enum;
};

/** aggregated selection of "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Aggregate = {
  __typename?: 'eatfresh_price_change_position_aggregate';
  aggregate?: Maybe<Eatfresh_Price_Change_Position_Aggregate_Fields>;
  nodes: Array<Eatfresh_Price_Change_Position>;
};

export type Eatfresh_Price_Change_Position_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Price_Change_Position_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Aggregate_Fields = {
  __typename?: 'eatfresh_price_change_position_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Price_Change_Position_Max_Fields>;
  min?: Maybe<Eatfresh_Price_Change_Position_Min_Fields>;
};


/** aggregate fields of "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Price_Change_Position_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Price_Change_Position_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Price_Change_Position_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Price_Change_Position_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.price_change_position". All fields are combined with a logical 'AND'. */
export type Eatfresh_Price_Change_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Price_Change_Position_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Price_Change_Position_Bool_Exp>>;
  confirmed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  confirmed_by_user?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  confirmed_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deprecated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price_change?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
  price_change_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_change_position_status?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
  refill?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refill_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Price_Change_Position_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.price_change_position" */
export enum Eatfresh_Price_Change_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  PriceChangePositionPkey = 'price_change_position_pkey',
  /** unique or primary key constraint on columns "price_change_id", "fridge_id" */
  PriceChangePositionPriceChangeIdFridgeIdKey = 'price_change_position_price_change_id_fridge_id_key'
}

/** input type for inserting data into table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Insert_Input = {
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmed_by_user?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  confirmed_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_change?: InputMaybe<Eatfresh_Price_Change_Obj_Rel_Insert_Input>;
  price_change_id?: InputMaybe<Scalars['uuid']['input']>;
  price_change_position_status?: InputMaybe<Eatfresh_Price_Change_Position_Status_Obj_Rel_Insert_Input>;
  refill?: InputMaybe<Eatfresh_Refill_Obj_Rel_Insert_Input>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Price_Change_Position_Status_Enum>;
};

/** aggregate max on columns */
export type Eatfresh_Price_Change_Position_Max_Fields = {
  __typename?: 'eatfresh_price_change_position_max_fields';
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  confirmed_by_user_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price_change_id?: Maybe<Scalars['uuid']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Max_Order_By = {
  confirmed_at?: InputMaybe<Order_By>;
  confirmed_by_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_change_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Price_Change_Position_Min_Fields = {
  __typename?: 'eatfresh_price_change_position_min_fields';
  confirmed_at?: Maybe<Scalars['timestamptz']['output']>;
  confirmed_by_user_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price_change_id?: Maybe<Scalars['uuid']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Min_Order_By = {
  confirmed_at?: InputMaybe<Order_By>;
  confirmed_by_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_change_id?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Mutation_Response = {
  __typename?: 'eatfresh_price_change_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Price_Change_Position>;
};

/** on_conflict condition type for table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_On_Conflict = {
  constraint: Eatfresh_Price_Change_Position_Constraint;
  update_columns?: Array<Eatfresh_Price_Change_Position_Update_Column>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.price_change_position". */
export type Eatfresh_Price_Change_Position_Order_By = {
  confirmed_at?: InputMaybe<Order_By>;
  confirmed_by_user?: InputMaybe<Eatfresh_User_Account_Order_By>;
  confirmed_by_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_change?: InputMaybe<Eatfresh_Price_Change_Order_By>;
  price_change_id?: InputMaybe<Order_By>;
  price_change_position_status?: InputMaybe<Eatfresh_Price_Change_Position_Status_Order_By>;
  refill?: InputMaybe<Eatfresh_Refill_Order_By>;
  refill_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.price_change_position */
export type Eatfresh_Price_Change_Position_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.price_change_position" */
export enum Eatfresh_Price_Change_Position_Select_Column {
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  ConfirmedByUserId = 'confirmed_by_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  PriceChangeId = 'price_change_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "eatfresh.price_change_position" */
export type Eatfresh_Price_Change_Position_Set_Input = {
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmed_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_change_id?: InputMaybe<Scalars['uuid']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Price_Change_Position_Status_Enum>;
};

/** columns and relationships of "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status = {
  __typename?: 'eatfresh_price_change_position_status';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_change_positions: Array<Eatfresh_Price_Change_Position>;
  /** An aggregate relationship */
  price_change_positions_aggregate: Eatfresh_Price_Change_Position_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_StatusPrice_Change_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_StatusPrice_Change_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Aggregate = {
  __typename?: 'eatfresh_price_change_position_status_aggregate';
  aggregate?: Maybe<Eatfresh_Price_Change_Position_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Price_Change_Position_Status>;
};

/** aggregate fields of "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_price_change_position_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Price_Change_Position_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Price_Change_Position_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.price_change_position_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Price_Change_Position_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.price_change_position_status" */
export enum Eatfresh_Price_Change_Position_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  PriceChangePositionStatusPkey = 'price_change_position_status_pkey'
}

export enum Eatfresh_Price_Change_Position_Status_Enum {
  /** Price change confirmed, new price is active */
  Confirmed = 'CONFIRMED',
  /** Price change superseded by a newer change */
  Deprecated = 'DEPRECATED',
  /** Price change awaiting confirmation by refiller */
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "eatfresh_price_change_position_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Price_Change_Position_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Price_Change_Position_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Price_Change_Position_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Price_Change_Position_Status_Max_Fields = {
  __typename?: 'eatfresh_price_change_position_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Price_Change_Position_Status_Min_Fields = {
  __typename?: 'eatfresh_price_change_position_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Mutation_Response = {
  __typename?: 'eatfresh_price_change_position_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Price_Change_Position_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Price_Change_Position_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Price_Change_Position_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_On_Conflict = {
  constraint: Eatfresh_Price_Change_Position_Status_Constraint;
  update_columns?: Array<Eatfresh_Price_Change_Position_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.price_change_position_status". */
export type Eatfresh_Price_Change_Position_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.price_change_position_status */
export type Eatfresh_Price_Change_Position_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.price_change_position_status" */
export enum Eatfresh_Price_Change_Position_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_price_change_position_status" */
export type Eatfresh_Price_Change_Position_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Price_Change_Position_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Price_Change_Position_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.price_change_position_status" */
export enum Eatfresh_Price_Change_Position_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Price_Change_Position_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Price_Change_Position_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Price_Change_Position_Status_Bool_Exp;
};

/** Streaming cursor of the table "eatfresh_price_change_position" */
export type Eatfresh_Price_Change_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Price_Change_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Price_Change_Position_Stream_Cursor_Value_Input = {
  confirmed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  confirmed_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  price_change_id?: InputMaybe<Scalars['uuid']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Eatfresh_Price_Change_Position_Status_Enum>;
};

/** update columns of table "eatfresh.price_change_position" */
export enum Eatfresh_Price_Change_Position_Update_Column {
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  ConfirmedByUserId = 'confirmed_by_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  PriceChangeId = 'price_change_id',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  Status = 'status'
}

export type Eatfresh_Price_Change_Position_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Price_Change_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Price_Change_Position_Bool_Exp;
};

/** select columns of table "eatfresh.price_change" */
export enum Eatfresh_Price_Change_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewRetailPrice = 'new_retail_price',
  /** column name */
  OldRetailPrice = 'old_retail_price',
  /** column name */
  PriceLockId = 'price_lock_id'
}

/** input type for updating data in table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_retail_price?: InputMaybe<Scalars['Int']['input']>;
  old_retail_price?: InputMaybe<Scalars['Int']['input']>;
  price_lock_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Price_Change_Stddev_Fields = {
  __typename?: 'eatfresh_price_change_stddev_fields';
  new_retail_price?: Maybe<Scalars['Float']['output']>;
  old_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Stddev_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Price_Change_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_price_change_stddev_pop_fields';
  new_retail_price?: Maybe<Scalars['Float']['output']>;
  old_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Stddev_Pop_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Price_Change_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_price_change_stddev_samp_fields';
  new_retail_price?: Maybe<Scalars['Float']['output']>;
  old_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Stddev_Samp_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_price_change" */
export type Eatfresh_Price_Change_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Price_Change_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Price_Change_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  new_retail_price?: InputMaybe<Scalars['Int']['input']>;
  old_retail_price?: InputMaybe<Scalars['Int']['input']>;
  price_lock_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Price_Change_Sum_Fields = {
  __typename?: 'eatfresh_price_change_sum_fields';
  new_retail_price?: Maybe<Scalars['Int']['output']>;
  old_retail_price?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Sum_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.price_change" */
export enum Eatfresh_Price_Change_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewRetailPrice = 'new_retail_price',
  /** column name */
  OldRetailPrice = 'old_retail_price',
  /** column name */
  PriceLockId = 'price_lock_id'
}

export type Eatfresh_Price_Change_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Price_Change_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Price_Change_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Price_Change_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Price_Change_Var_Pop_Fields = {
  __typename?: 'eatfresh_price_change_var_pop_fields';
  new_retail_price?: Maybe<Scalars['Float']['output']>;
  old_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Var_Pop_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Price_Change_Var_Samp_Fields = {
  __typename?: 'eatfresh_price_change_var_samp_fields';
  new_retail_price?: Maybe<Scalars['Float']['output']>;
  old_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Var_Samp_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Price_Change_Variance_Fields = {
  __typename?: 'eatfresh_price_change_variance_fields';
  new_retail_price?: Maybe<Scalars['Float']['output']>;
  old_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.price_change" */
export type Eatfresh_Price_Change_Variance_Order_By = {
  new_retail_price?: InputMaybe<Order_By>;
  old_retail_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.price_lock" */
export type Eatfresh_Price_Lock = {
  __typename?: 'eatfresh_price_lock';
  /** An object relationship */
  article: Eatfresh_Article;
  article_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  locked_retail_price: Scalars['Int']['output'];
  /** An array relationship */
  price_changes: Array<Eatfresh_Price_Change>;
  /** An aggregate relationship */
  price_changes_aggregate: Eatfresh_Price_Change_Aggregate;
};


/** columns and relationships of "eatfresh.price_lock" */
export type Eatfresh_Price_LockPrice_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


/** columns and relationships of "eatfresh.price_lock" */
export type Eatfresh_Price_LockPrice_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};

/** aggregated selection of "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Aggregate = {
  __typename?: 'eatfresh_price_lock_aggregate';
  aggregate?: Maybe<Eatfresh_Price_Lock_Aggregate_Fields>;
  nodes: Array<Eatfresh_Price_Lock>;
};

export type Eatfresh_Price_Lock_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Price_Lock_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Price_Lock_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Aggregate_Fields = {
  __typename?: 'eatfresh_price_lock_aggregate_fields';
  avg?: Maybe<Eatfresh_Price_Lock_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Price_Lock_Max_Fields>;
  min?: Maybe<Eatfresh_Price_Lock_Min_Fields>;
  stddev?: Maybe<Eatfresh_Price_Lock_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Price_Lock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Price_Lock_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Price_Lock_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Price_Lock_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Price_Lock_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Price_Lock_Variance_Fields>;
};


/** aggregate fields of "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Price_Lock_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Price_Lock_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Price_Lock_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Price_Lock_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Price_Lock_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Price_Lock_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Price_Lock_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Price_Lock_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Price_Lock_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Price_Lock_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Price_Lock_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Price_Lock_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Price_Lock_Avg_Fields = {
  __typename?: 'eatfresh_price_lock_avg_fields';
  locked_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Avg_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.price_lock". All fields are combined with a logical 'AND'. */
export type Eatfresh_Price_Lock_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Price_Lock_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Price_Lock_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deprecated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locked_retail_price?: InputMaybe<Int_Comparison_Exp>;
  price_changes?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
  price_changes_aggregate?: InputMaybe<Eatfresh_Price_Change_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.price_lock" */
export enum Eatfresh_Price_Lock_Constraint {
  /** unique or primary key constraint on columns "id" */
  PriceLockPkey = 'price_lock_pkey',
  /** unique or primary key constraint on columns "article_id", "fridge_id" */
  UqPriceLockActiveFridgeArticle = 'uq_price_lock_active_fridge_article'
}

/** input type for incrementing numeric columns in table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Inc_Input = {
  locked_retail_price?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locked_retail_price?: InputMaybe<Scalars['Int']['input']>;
  price_changes?: InputMaybe<Eatfresh_Price_Change_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Price_Lock_Max_Fields = {
  __typename?: 'eatfresh_price_lock_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locked_retail_price?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locked_retail_price?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Price_Lock_Min_Fields = {
  __typename?: 'eatfresh_price_lock_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deprecated_at?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locked_retail_price?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locked_retail_price?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Mutation_Response = {
  __typename?: 'eatfresh_price_lock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Price_Lock>;
};

/** input type for inserting object relation for remote table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Obj_Rel_Insert_Input = {
  data: Eatfresh_Price_Lock_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Price_Lock_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_On_Conflict = {
  constraint: Eatfresh_Price_Lock_Constraint;
  update_columns?: Array<Eatfresh_Price_Lock_Update_Column>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.price_lock". */
export type Eatfresh_Price_Lock_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deprecated_at?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locked_retail_price?: InputMaybe<Order_By>;
  price_changes_aggregate?: InputMaybe<Eatfresh_Price_Change_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.price_lock */
export type Eatfresh_Price_Lock_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.price_lock" */
export enum Eatfresh_Price_Lock_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  LockedRetailPrice = 'locked_retail_price'
}

/** input type for updating data in table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locked_retail_price?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Price_Lock_Stddev_Fields = {
  __typename?: 'eatfresh_price_lock_stddev_fields';
  locked_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Stddev_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Price_Lock_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_price_lock_stddev_pop_fields';
  locked_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Stddev_Pop_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Price_Lock_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_price_lock_stddev_samp_fields';
  locked_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Stddev_Samp_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_price_lock" */
export type Eatfresh_Price_Lock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Price_Lock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Price_Lock_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locked_retail_price?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Price_Lock_Sum_Fields = {
  __typename?: 'eatfresh_price_lock_sum_fields';
  locked_retail_price?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Sum_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.price_lock" */
export enum Eatfresh_Price_Lock_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  LockedRetailPrice = 'locked_retail_price'
}

export type Eatfresh_Price_Lock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Price_Lock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Price_Lock_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Price_Lock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Price_Lock_Var_Pop_Fields = {
  __typename?: 'eatfresh_price_lock_var_pop_fields';
  locked_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Var_Pop_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Price_Lock_Var_Samp_Fields = {
  __typename?: 'eatfresh_price_lock_var_samp_fields';
  locked_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Var_Samp_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Price_Lock_Variance_Fields = {
  __typename?: 'eatfresh_price_lock_variance_fields';
  locked_retail_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.price_lock" */
export type Eatfresh_Price_Lock_Variance_Order_By = {
  locked_retail_price?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation = {
  __typename?: 'eatfresh_product_orientation';
  description: Scalars['String']['output'];
  /** An array relationship */
  fridgeLayoutLevelPositionsByWOrientation: Array<Eatfresh_Fridge_Layout_Level_Position>;
  /** An aggregate relationship */
  fridgeLayoutLevelPositionsByWOrientation_aggregate: Eatfresh_Fridge_Layout_Level_Position_Aggregate;
  /** An array relationship */
  fridge_layout_level_positions: Array<Eatfresh_Fridge_Layout_Level_Position>;
  /** An aggregate relationship */
  fridge_layout_level_positions_aggregate: Eatfresh_Fridge_Layout_Level_Position_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.product_orientation" */
export type Eatfresh_Product_OrientationFridgeLayoutLevelPositionsByWOrientationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.product_orientation" */
export type Eatfresh_Product_OrientationFridgeLayoutLevelPositionsByWOrientation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.product_orientation" */
export type Eatfresh_Product_OrientationFridge_Layout_Level_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.product_orientation" */
export type Eatfresh_Product_OrientationFridge_Layout_Level_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_Aggregate = {
  __typename?: 'eatfresh_product_orientation_aggregate';
  aggregate?: Maybe<Eatfresh_Product_Orientation_Aggregate_Fields>;
  nodes: Array<Eatfresh_Product_Orientation>;
};

/** aggregate fields of "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_Aggregate_Fields = {
  __typename?: 'eatfresh_product_orientation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Product_Orientation_Max_Fields>;
  min?: Maybe<Eatfresh_Product_Orientation_Min_Fields>;
};


/** aggregate fields of "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Product_Orientation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.product_orientation". All fields are combined with a logical 'AND'. */
export type Eatfresh_Product_Orientation_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Product_Orientation_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Product_Orientation_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridgeLayoutLevelPositionsByWOrientation?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
  fridgeLayoutLevelPositionsByWOrientation_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Bool_Exp>;
  fridge_layout_level_positions?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
  fridge_layout_level_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.product_orientation" */
export enum Eatfresh_Product_Orientation_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProductOrientationPkey = 'product_orientation_pkey'
}

export enum Eatfresh_Product_Orientation_Enum {
  /** Depth */
  D = 'D',
  /** Height */
  H = 'H',
  /** Width */
  W = 'W'
}

/** Boolean expression to compare columns of type "eatfresh_product_orientation_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Product_Orientation_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Product_Orientation_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Product_Orientation_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Product_Orientation_Enum>>;
};

/** input type for inserting data into table "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  fridgeLayoutLevelPositionsByWOrientation?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Arr_Rel_Insert_Input>;
  fridge_layout_level_positions?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Product_Orientation_Max_Fields = {
  __typename?: 'eatfresh_product_orientation_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Product_Orientation_Min_Fields = {
  __typename?: 'eatfresh_product_orientation_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_Mutation_Response = {
  __typename?: 'eatfresh_product_orientation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Product_Orientation>;
};

/** input type for inserting object relation for remote table "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_Obj_Rel_Insert_Input = {
  data: Eatfresh_Product_Orientation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Product_Orientation_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_On_Conflict = {
  constraint: Eatfresh_Product_Orientation_Constraint;
  update_columns?: Array<Eatfresh_Product_Orientation_Update_Column>;
  where?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.product_orientation". */
export type Eatfresh_Product_Orientation_Order_By = {
  description?: InputMaybe<Order_By>;
  fridgeLayoutLevelPositionsByWOrientation_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Order_By>;
  fridge_layout_level_positions_aggregate?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.product_orientation */
export type Eatfresh_Product_Orientation_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.product_orientation" */
export enum Eatfresh_Product_Orientation_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.product_orientation" */
export type Eatfresh_Product_Orientation_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_product_orientation" */
export type Eatfresh_Product_Orientation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Product_Orientation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Product_Orientation_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.product_orientation" */
export enum Eatfresh_Product_Orientation_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Product_Orientation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Product_Orientation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Product_Orientation_Bool_Exp;
};

/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_Refill = {
  __typename?: 'eatfresh_refill';
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  box_content_plans: Array<Eatfresh_Box_Content_Plan>;
  /** An aggregate relationship */
  box_content_plans_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  confirmation_image_id?: Maybe<Scalars['uuid']['output']>;
  confirmation_image_required: Scalars['Boolean']['output'];
  cost: Scalars['Int']['output'];
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  fridge: Eatfresh_Fridge;
  fridge_id: Scalars['uuid']['output'];
  given_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  logistics_problems: Array<Eatfresh_Logistics_Problem>;
  /** An aggregate relationship */
  logistics_problems_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  /** An array relationship */
  price_change_positions: Array<Eatfresh_Price_Change_Position>;
  /** An aggregate relationship */
  price_change_positions_aggregate: Eatfresh_Price_Change_Position_Aggregate;
  /** An object relationship */
  refillStatusByRefillStatus: Eatfresh_Refill_Status;
  refill_status: Eatfresh_Refill_Status_Enum;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploaded_file?: Maybe<Eatfresh_Uploaded_File>;
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillBox_Content_PlansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillBox_Content_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillLogistics_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillLogistics_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillPrice_Change_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillPrice_Change_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill" */
export type Eatfresh_RefillRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};

/** aggregated selection of "eatfresh.refill" */
export type Eatfresh_Refill_Aggregate = {
  __typename?: 'eatfresh_refill_aggregate';
  aggregate?: Maybe<Eatfresh_Refill_Aggregate_Fields>;
  nodes: Array<Eatfresh_Refill>;
};

export type Eatfresh_Refill_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Refill_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Refill_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Refill_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Refill_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Refill_Select_Column_Eatfresh_Refill_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Refill_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Refill_Select_Column_Eatfresh_Refill_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Refill_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.refill" */
export type Eatfresh_Refill_Aggregate_Fields = {
  __typename?: 'eatfresh_refill_aggregate_fields';
  avg?: Maybe<Eatfresh_Refill_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Refill_Max_Fields>;
  min?: Maybe<Eatfresh_Refill_Min_Fields>;
  stddev?: Maybe<Eatfresh_Refill_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Refill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Refill_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Refill_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Refill_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Refill_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Refill_Variance_Fields>;
};


/** aggregate fields of "eatfresh.refill" */
export type Eatfresh_Refill_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.refill" */
export type Eatfresh_Refill_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Refill_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Refill_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Refill_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Refill_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Refill_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Refill_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Refill_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Refill_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Refill_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Refill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.refill" */
export type Eatfresh_Refill_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Refill_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Refill_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Refill_Avg_Fields = {
  __typename?: 'eatfresh_refill_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.refill". All fields are combined with a logical 'AND'. */
export type Eatfresh_Refill_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Refill_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Refill_Bool_Exp>>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp>;
  confirmation_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  confirmation_image_required?: InputMaybe<Boolean_Comparison_Exp>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  given_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Bool_Exp>;
  refillStatusByRefillStatus?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
  refill_status?: InputMaybe<Eatfresh_Refill_Status_Enum_Comparison_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.refill" */
export enum Eatfresh_Refill_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshRefillPkey = 'eatfresh_refill_pkey',
  /** unique or primary key constraint on columns "fridge_id" */
  UqRefillActiveFridge = 'uq_refill_active_fridge'
}

/** input type for incrementing numeric columns in table "eatfresh.refill" */
export type Eatfresh_Refill_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.refill" */
export type Eatfresh_Refill_Insert_Input = {
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Arr_Rel_Insert_Input>;
  confirmation_image_id?: InputMaybe<Scalars['uuid']['input']>;
  confirmation_image_required?: InputMaybe<Scalars['Boolean']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input>;
  price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Arr_Rel_Insert_Input>;
  refillStatusByRefillStatus?: InputMaybe<Eatfresh_Refill_Status_Obj_Rel_Insert_Input>;
  refill_status?: InputMaybe<Eatfresh_Refill_Status_Enum>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Obj_Rel_Insert_Input>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Refill_Max_Fields = {
  __typename?: 'eatfresh_refill_max_fields';
  confirmation_image_id?: Maybe<Scalars['uuid']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Max_Order_By = {
  confirmation_image_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Refill_Min_Fields = {
  __typename?: 'eatfresh_refill_min_fields';
  confirmation_image_id?: Maybe<Scalars['uuid']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Min_Order_By = {
  confirmation_image_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.refill" */
export type Eatfresh_Refill_Mutation_Response = {
  __typename?: 'eatfresh_refill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Refill>;
};

/** input type for inserting object relation for remote table "eatfresh.refill" */
export type Eatfresh_Refill_Obj_Rel_Insert_Input = {
  data: Eatfresh_Refill_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Refill_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.refill" */
export type Eatfresh_Refill_On_Conflict = {
  constraint: Eatfresh_Refill_Constraint;
  update_columns?: Array<Eatfresh_Refill_Update_Column>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.refill". */
export type Eatfresh_Refill_Order_By = {
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Order_By>;
  confirmation_image_id?: InputMaybe<Order_By>;
  confirmation_image_required?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Order_By>;
  price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Order_By>;
  refillStatusByRefillStatus?: InputMaybe<Eatfresh_Refill_Status_Order_By>;
  refill_status?: InputMaybe<Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.refill */
export type Eatfresh_Refill_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.refill" */
export enum Eatfresh_Refill_Select_Column {
  /** column name */
  ConfirmationImageId = 'confirmation_image_id',
  /** column name */
  ConfirmationImageRequired = 'confirmation_image_required',
  /** column name */
  Cost = 'cost',
  /** column name */
  Created = 'created',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  Id = 'id',
  /** column name */
  RefillStatus = 'refill_status',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserId = 'user_id'
}

/** select "eatfresh_refill_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.refill" */
export enum Eatfresh_Refill_Select_Column_Eatfresh_Refill_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ConfirmationImageRequired = 'confirmation_image_required'
}

/** select "eatfresh_refill_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.refill" */
export enum Eatfresh_Refill_Select_Column_Eatfresh_Refill_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ConfirmationImageRequired = 'confirmation_image_required'
}

/** input type for updating data in table "eatfresh.refill" */
export type Eatfresh_Refill_Set_Input = {
  confirmation_image_id?: InputMaybe<Scalars['uuid']['input']>;
  confirmation_image_required?: InputMaybe<Scalars['Boolean']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refill_status?: InputMaybe<Eatfresh_Refill_Status_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.refill_status" */
export type Eatfresh_Refill_Status = {
  __typename?: 'eatfresh_refill_status';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refills: Array<Eatfresh_Refill>;
  /** An aggregate relationship */
  refills_aggregate: Eatfresh_Refill_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.refill_status" */
export type Eatfresh_Refill_StatusRefillsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


/** columns and relationships of "eatfresh.refill_status" */
export type Eatfresh_Refill_StatusRefills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};

/** aggregated selection of "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_Aggregate = {
  __typename?: 'eatfresh_refill_status_aggregate';
  aggregate?: Maybe<Eatfresh_Refill_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Refill_Status>;
};

/** aggregate fields of "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_refill_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Refill_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Refill_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Refill_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.refill_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Refill_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Refill_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Refill_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  refills?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.refill_status" */
export enum Eatfresh_Refill_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefillStatusPkey = 'refill_status_pkey'
}

export enum Eatfresh_Refill_Status_Enum {
  /** The refillment was canceled or fridge time-outed */
  Canceled = 'CANCELED',
  /** The cleaning process was a success */
  Cleaned = 'CLEANED',
  /** Cleaning the fridge */
  Cleaning = 'CLEANING',
  /** The refillment is being processed */
  Draft = 'DRAFT',
  /** There was an error in the refillment process */
  Error = 'ERROR',
  /** Refilling items in the fridge was a success */
  Refilled = 'REFILLED',
  /** Refilling the fridge */
  Refilling = 'REFILLING',
  /** Removing expired products */
  RemovingExpired = 'REMOVING_EXPIRED',
  /** The refillment process was a success */
  Success = 'SUCCESS',
  /** There are unknown products in the fridge */
  UnknownProducts = 'UNKNOWN_PRODUCTS'
}

/** Boolean expression to compare columns of type "eatfresh_refill_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Refill_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Refill_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Refill_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Refill_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Refill_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  refills?: InputMaybe<Eatfresh_Refill_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Refill_Status_Max_Fields = {
  __typename?: 'eatfresh_refill_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Refill_Status_Min_Fields = {
  __typename?: 'eatfresh_refill_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_Mutation_Response = {
  __typename?: 'eatfresh_refill_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Refill_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Refill_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Refill_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_On_Conflict = {
  constraint: Eatfresh_Refill_Status_Constraint;
  update_columns?: Array<Eatfresh_Refill_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.refill_status". */
export type Eatfresh_Refill_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.refill_status */
export type Eatfresh_Refill_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.refill_status" */
export enum Eatfresh_Refill_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.refill_status" */
export type Eatfresh_Refill_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_refill_status" */
export type Eatfresh_Refill_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Refill_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Refill_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.refill_status" */
export enum Eatfresh_Refill_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Refill_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Refill_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Refill_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Eatfresh_Refill_Stddev_Fields = {
  __typename?: 'eatfresh_refill_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Refill_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_refill_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Refill_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_refill_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_refill" */
export type Eatfresh_Refill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Refill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Refill_Stream_Cursor_Value_Input = {
  confirmation_image_id?: InputMaybe<Scalars['uuid']['input']>;
  confirmation_image_required?: InputMaybe<Scalars['Boolean']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  refill_status?: InputMaybe<Eatfresh_Refill_Status_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Refill_Sum_Fields = {
  __typename?: 'eatfresh_refill_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.refill" */
export enum Eatfresh_Refill_Update_Column {
  /** column name */
  ConfirmationImageId = 'confirmation_image_id',
  /** column name */
  ConfirmationImageRequired = 'confirmation_image_required',
  /** column name */
  Cost = 'cost',
  /** column name */
  Created = 'created',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  Id = 'id',
  /** column name */
  RefillStatus = 'refill_status',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Refill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Refill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Refill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Refill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Refill_Var_Pop_Fields = {
  __typename?: 'eatfresh_refill_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Refill_Var_Samp_Fields = {
  __typename?: 'eatfresh_refill_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Refill_Variance_Fields = {
  __typename?: 'eatfresh_refill_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.refill" */
export type Eatfresh_Refill_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset = {
  __typename?: 'eatfresh_rfid_asset';
  /** An object relationship */
  articleLabelingProcessByLastLabelingId?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** An object relationship */
  asset_placement?: Maybe<Eatfresh_Asset_Placement>;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  box_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  created_at: Scalars['timestamp']['output'];
  epc: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  last_labeling_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfid_asset_type: Eatfresh_Rfid_Asset_Type;
  /** An object relationship */
  rfid_box?: Maybe<Eatfresh_Rfid_Box>;
  /** An array relationship */
  rfid_boxes: Array<Eatfresh_Rfid_Box>;
  /** An aggregate relationship */
  rfid_boxes_aggregate: Eatfresh_Rfid_Box_Aggregate;
  /** An object relationship */
  rfid_scan?: Maybe<Eatfresh_Rfid_Scan>;
  rfid_scan_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  type: Eatfresh_Rfid_Asset_Type_Enum;
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_AssetAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_AssetAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_AssetRfid_BoxesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_AssetRfid_Boxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_AssetRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_AssetRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Aggregate = {
  __typename?: 'eatfresh_rfid_asset_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Asset_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Asset>;
};

export type Eatfresh_Rfid_Asset_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Rfid_Asset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_asset_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Asset_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Asset_Min_Fields>;
};


/** aggregate fields of "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Rfid_Asset_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Rfid_Asset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Rfid_Asset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Asset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_asset". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Asset_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Asset_Bool_Exp>>;
  articleLabelingProcessByLastLabelingId?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  asset_placement?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  box_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  epc?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_asset_type?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp>;
  rfid_scan?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  rfid_scan_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  type?: InputMaybe<Eatfresh_Rfid_Asset_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_asset" */
export enum Eatfresh_Rfid_Asset_Constraint {
  /** unique or primary key constraint on columns "epc" */
  RfidAssetEpcKey = 'rfid_asset_epc_key',
  /** unique or primary key constraint on columns "id" */
  RfidAssetPkey = 'rfid_asset_pkey'
}

/** input type for inserting data into table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Insert_Input = {
  articleLabelingProcessByLastLabelingId?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  asset_placement?: InputMaybe<Eatfresh_Asset_Placement_Obj_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  box_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  epc?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  last_labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset_type?: InputMaybe<Eatfresh_Rfid_Asset_Type_Obj_Rel_Insert_Input>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Obj_Rel_Insert_Input>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Arr_Rel_Insert_Input>;
  rfid_scan?: InputMaybe<Eatfresh_Rfid_Scan_Obj_Rel_Insert_Input>;
  rfid_scan_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Eatfresh_Rfid_Asset_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Asset_Max_Fields = {
  __typename?: 'eatfresh_rfid_asset_max_fields';
  box_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  epc?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  last_labeling_id?: Maybe<Scalars['uuid']['output']>;
  rfid_scan_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Max_Order_By = {
  box_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  epc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  last_labeling_id?: InputMaybe<Order_By>;
  rfid_scan_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Asset_Min_Fields = {
  __typename?: 'eatfresh_rfid_asset_min_fields';
  box_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  epc?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  last_labeling_id?: Maybe<Scalars['uuid']['output']>;
  rfid_scan_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Min_Order_By = {
  box_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  epc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  last_labeling_id?: InputMaybe<Order_By>;
  rfid_scan_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Mutation_Response = {
  __typename?: 'eatfresh_rfid_asset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Asset>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Asset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Asset_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_On_Conflict = {
  constraint: Eatfresh_Rfid_Asset_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Asset_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_asset". */
export type Eatfresh_Rfid_Asset_Order_By = {
  articleLabelingProcessByLastLabelingId?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  asset_placement?: InputMaybe<Eatfresh_Asset_Placement_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  box_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  created_at?: InputMaybe<Order_By>;
  epc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  last_labeling_id?: InputMaybe<Order_By>;
  rfid_asset_type?: InputMaybe<Eatfresh_Rfid_Asset_Type_Order_By>;
  rfid_box?: InputMaybe<Eatfresh_Rfid_Box_Order_By>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Order_By>;
  rfid_scan?: InputMaybe<Eatfresh_Rfid_Scan_Order_By>;
  rfid_scan_id?: InputMaybe<Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_asset */
export type Eatfresh_Rfid_Asset_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.rfid_asset" */
export enum Eatfresh_Rfid_Asset_Select_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Epc = 'epc',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  LastLabelingId = 'last_labeling_id',
  /** column name */
  RfidScanId = 'rfid_scan_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "eatfresh.rfid_asset" */
export type Eatfresh_Rfid_Asset_Set_Input = {
  box_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  epc?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  last_labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_scan_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Eatfresh_Rfid_Asset_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "eatfresh_rfid_asset" */
export type Eatfresh_Rfid_Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Asset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Asset_Stream_Cursor_Value_Input = {
  box_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  epc?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  last_labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_scan_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Eatfresh_Rfid_Asset_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type = {
  __typename?: 'eatfresh_rfid_asset_type';
  description: Scalars['String']['output'];
  /** An array relationship */
  rfid_assets: Array<Eatfresh_Rfid_Asset>;
  /** An aggregate relationship */
  rfid_assets_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_TypeRfid_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_TypeRfid_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Aggregate = {
  __typename?: 'eatfresh_rfid_asset_type_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Asset_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Asset_Type>;
};

/** aggregate fields of "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_asset_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Asset_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Asset_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_asset_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Asset_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_asset_type" */
export enum Eatfresh_Rfid_Asset_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  RfidAssetTypePkey = 'rfid_asset_type_pkey'
}

export enum Eatfresh_Rfid_Asset_Type_Enum {
  /** Component/Part Identifier CPI-96 */
  Cpi96 = 'CPI96',
  /** Document Type Identifier GDTI-96 */
  Gdti96 = 'GDTI96',
  /** Document Type Identifier GDTI-174 */
  Gdti174 = 'GDTI174',
  /** Individual Asset Identifier GIAI-96 */
  Giai96 = 'GIAI96',
  /** Individual Asset Identifier GIAI-202 */
  Giai202 = 'GIAI202',
  /** Individual Asset Identifier GID-96 */
  Gid96 = 'GID96',
  /** Global Product Identifier GPI-96 */
  Gpi96 = 'GPI96',
  /** Returnable Asset Identifier GRAI-96 */
  Grai96 = 'GRAI96',
  /** Returnable Asset Identifier GRAI-170 */
  Grai170 = 'GRAI170',
  /** Service Relation Number GSRN-96 */
  Gsrn96 = 'GSRN96',
  /** Global Coupon Number SGCN-96 */
  Sgcn96 = 'SGCN96',
  /** Location Identifier SGLN-96 */
  Sgln96 = 'SGLN96',
  /** Location Identifier SGLN-195 */
  Sgln195 = 'SGLN195',
  /** Product/Service Identifier SGTIN-96 */
  Sgtin96 = 'SGTIN96',
  /** Product/Service Identifier SGTIN-198 */
  Sgtin198 = 'SGTIN198',
  /** Logistics Unit Identifier SSCC-96 */
  Sscc96 = 'SSCC96',
  /** Unknown RFID asset type */
  Unknown = 'UNKNOWN'
}

/** Boolean expression to compare columns of type "eatfresh_rfid_asset_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Rfid_Asset_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Rfid_Asset_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Rfid_Asset_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Asset_Type_Max_Fields = {
  __typename?: 'eatfresh_rfid_asset_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Asset_Type_Min_Fields = {
  __typename?: 'eatfresh_rfid_asset_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Mutation_Response = {
  __typename?: 'eatfresh_rfid_asset_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Asset_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Asset_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Asset_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_On_Conflict = {
  constraint: Eatfresh_Rfid_Asset_Type_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Asset_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_asset_type". */
export type Eatfresh_Rfid_Asset_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_asset_type */
export type Eatfresh_Rfid_Asset_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.rfid_asset_type" */
export enum Eatfresh_Rfid_Asset_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_rfid_asset_type" */
export type Eatfresh_Rfid_Asset_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Asset_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Asset_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.rfid_asset_type" */
export enum Eatfresh_Rfid_Asset_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Rfid_Asset_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Asset_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Asset_Type_Bool_Exp;
};

/** update columns of table "eatfresh.rfid_asset" */
export enum Eatfresh_Rfid_Asset_Update_Column {
  /** column name */
  BoxId = 'box_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Epc = 'epc',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  LastLabelingId = 'last_labeling_id',
  /** column name */
  RfidScanId = 'rfid_scan_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Rfid_Asset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Asset_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Asset_Bool_Exp;
};

/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box = {
  __typename?: 'eatfresh_rfid_box';
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** An array relationship */
  assetTransfersByToRfidBoxId: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  assetTransfersByToRfidBoxId_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  box_content_plans: Array<Eatfresh_Box_Content_Plan>;
  /** An aggregate relationship */
  box_content_plans_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  id: Scalars['uuid']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfid_asset: Eatfresh_Rfid_Asset;
  rfid_asset_id: Scalars['uuid']['output'];
  /** An array relationship */
  rfid_assets: Array<Eatfresh_Rfid_Asset>;
  /** An aggregate relationship */
  rfid_assets_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  /** An object relationship */
  rfid_box_type: Eatfresh_Rfid_Box_Type;
  type: Eatfresh_Rfid_Box_Type_Enum;
  virtual: Scalars['Boolean']['output'];
  /** An object relationship */
  warehouse: Eatfresh_Warehouse;
  warehouse_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxAssetTransfersByToRfidBoxIdArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxAssetTransfersByToRfidBoxId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxBox_Content_PlansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxBox_Content_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxRfid_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_BoxRfid_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Aggregate = {
  __typename?: 'eatfresh_rfid_box_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Box_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Box>;
};

export type Eatfresh_Rfid_Box_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Rfid_Box_Select_Column_Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Rfid_Box_Select_Column_Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_box_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Box_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Box_Min_Fields>;
};


/** aggregate fields of "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Rfid_Box_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Rfid_Box_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Rfid_Box_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Box_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_box". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Box_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Box_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Box_Bool_Exp>>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  assetTransfersByToRfidBoxId?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  assetTransfersByToRfidBoxId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Bool_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp>;
  rfid_box_type?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
  type?: InputMaybe<Eatfresh_Rfid_Box_Type_Enum_Comparison_Exp>;
  virtual?: InputMaybe<Boolean_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_box" */
export enum Eatfresh_Rfid_Box_Constraint {
  /** unique or primary key constraint on columns "id" */
  RfidBoxPkey = 'rfid_box_pkey'
}

/** input type for inserting data into table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Insert_Input = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  assetTransfersByToRfidBoxId?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  box_content_plans?: InputMaybe<Eatfresh_Box_Content_Plan_Arr_Rel_Insert_Input>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Obj_Rel_Insert_Input>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input>;
  rfid_box_type?: InputMaybe<Eatfresh_Rfid_Box_Type_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Eatfresh_Rfid_Box_Type_Enum>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Box_Max_Fields = {
  __typename?: 'eatfresh_rfid_box_max_fields';
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Max_Order_By = {
  commissioning_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Box_Min_Fields = {
  __typename?: 'eatfresh_rfid_box_min_fields';
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Min_Order_By = {
  commissioning_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Mutation_Response = {
  __typename?: 'eatfresh_rfid_box_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Box>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Box_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Box_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_On_Conflict = {
  constraint: Eatfresh_Rfid_Box_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Box_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_box". */
export type Eatfresh_Rfid_Box_Order_By = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  assetTransfersByToRfidBoxId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  box_content_plans_aggregate?: InputMaybe<Eatfresh_Box_Content_Plan_Aggregate_Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Order_By>;
  rfid_box_type?: InputMaybe<Eatfresh_Rfid_Box_Type_Order_By>;
  type?: InputMaybe<Order_By>;
  virtual?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_box */
export type Eatfresh_Rfid_Box_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.rfid_box" */
export enum Eatfresh_Rfid_Box_Select_Column {
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  Type = 'type',
  /** column name */
  Virtual = 'virtual',
  /** column name */
  WarehouseId = 'warehouse_id'
}

/** select "eatfresh_rfid_box_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.rfid_box" */
export enum Eatfresh_Rfid_Box_Select_Column_Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Virtual = 'virtual'
}

/** select "eatfresh_rfid_box_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.rfid_box" */
export enum Eatfresh_Rfid_Box_Select_Column_Eatfresh_Rfid_Box_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Virtual = 'virtual'
}

/** input type for updating data in table "eatfresh.rfid_box" */
export type Eatfresh_Rfid_Box_Set_Input = {
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Eatfresh_Rfid_Box_Type_Enum>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_rfid_box" */
export type Eatfresh_Rfid_Box_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Box_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Box_Stream_Cursor_Value_Input = {
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Eatfresh_Rfid_Box_Type_Enum>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type = {
  __typename?: 'eatfresh_rfid_box_type';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rfid_boxes: Array<Eatfresh_Rfid_Box>;
  /** An aggregate relationship */
  rfid_boxes_aggregate: Eatfresh_Rfid_Box_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_TypeRfid_BoxesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_TypeRfid_Boxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Aggregate = {
  __typename?: 'eatfresh_rfid_box_type_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Box_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Box_Type>;
};

/** aggregate fields of "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_box_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Box_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Box_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_box_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Box_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_box_type" */
export enum Eatfresh_Rfid_Box_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  RfidBoxTypePkey = 'rfid_box_type_pkey'
}

export enum Eatfresh_Rfid_Box_Type_Enum {
  /** Storage box */
  Storage = 'STORAGE',
  /** Transport box */
  Transport = 'TRANSPORT'
}

/** Boolean expression to compare columns of type "eatfresh_rfid_box_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Rfid_Box_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Rfid_Box_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Rfid_Box_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Box_Type_Max_Fields = {
  __typename?: 'eatfresh_rfid_box_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Box_Type_Min_Fields = {
  __typename?: 'eatfresh_rfid_box_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Mutation_Response = {
  __typename?: 'eatfresh_rfid_box_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Box_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Box_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Box_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_On_Conflict = {
  constraint: Eatfresh_Rfid_Box_Type_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Box_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_box_type". */
export type Eatfresh_Rfid_Box_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_box_type */
export type Eatfresh_Rfid_Box_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.rfid_box_type" */
export enum Eatfresh_Rfid_Box_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_rfid_box_type" */
export type Eatfresh_Rfid_Box_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Box_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Box_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.rfid_box_type" */
export enum Eatfresh_Rfid_Box_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Rfid_Box_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Box_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Box_Type_Bool_Exp;
};

/** update columns of table "eatfresh.rfid_box" */
export enum Eatfresh_Rfid_Box_Update_Column {
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  Type = 'type',
  /** column name */
  Virtual = 'virtual',
  /** column name */
  WarehouseId = 'warehouse_id'
}

export type Eatfresh_Rfid_Box_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Box_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Box_Bool_Exp;
};

/** columns and relationships of "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan = {
  __typename?: 'eatfresh_rfid_scan';
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** An object relationship */
  box_content_plan?: Maybe<Eatfresh_Box_Content_Plan>;
  box_content_plan_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  created_at: Scalars['timestamptz']['output'];
  epcs: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  power_in_dbm?: Maybe<Scalars['Int']['output']>;
  processing_time_ms?: Maybe<Scalars['Int']['output']>;
  read_finished: Scalars['Boolean']['output'];
  reading_time: Scalars['Int']['output'];
  reading_time_left: Scalars['Int']['output'];
  /** An array relationship */
  rfid_assets: Array<Eatfresh_Rfid_Asset>;
  /** An aggregate relationship */
  rfid_assets_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  /** An object relationship */
  rfid_scan_status: Eatfresh_Rfid_Scan_Status;
  /** An object relationship */
  rfid_scanner: Eatfresh_Rfid_Scanner;
  rfid_scanner_id: Scalars['uuid']['output'];
  scan_id?: Maybe<Scalars['String']['output']>;
  scanned_at: Scalars['timestamptz']['output'];
  status: Eatfresh_Rfid_Scan_Status_Enum;
};


/** columns and relationships of "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_ScanRfid_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_ScanRfid_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Aggregate = {
  __typename?: 'eatfresh_rfid_scan_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Scan_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Scan>;
};

export type Eatfresh_Rfid_Scan_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Rfid_Scan_Select_Column_Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Rfid_Scan_Select_Column_Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_scan_aggregate_fields';
  avg?: Maybe<Eatfresh_Rfid_Scan_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Scan_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Scan_Min_Fields>;
  stddev?: Maybe<Eatfresh_Rfid_Scan_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Rfid_Scan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Rfid_Scan_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Rfid_Scan_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Rfid_Scan_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Rfid_Scan_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Rfid_Scan_Variance_Fields>;
};


/** aggregate fields of "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Rfid_Scan_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Rfid_Scan_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Rfid_Scan_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Rfid_Scan_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Rfid_Scan_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Rfid_Scan_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Rfid_Scan_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Rfid_Scan_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Rfid_Scan_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Rfid_Scan_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Rfid_Scan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scan_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Rfid_Scan_Avg_Fields = {
  __typename?: 'eatfresh_rfid_scan_avg_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
  processing_time_ms?: Maybe<Scalars['Float']['output']>;
  reading_time?: Maybe<Scalars['Float']['output']>;
  reading_time_left?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Avg_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_scan". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Scan_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Scan_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Scan_Bool_Exp>>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  epcs?: InputMaybe<String_Array_Comparison_Exp>;
  error?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  power_in_dbm?: InputMaybe<Int_Comparison_Exp>;
  processing_time_ms?: InputMaybe<Int_Comparison_Exp>;
  read_finished?: InputMaybe<Boolean_Comparison_Exp>;
  reading_time?: InputMaybe<Int_Comparison_Exp>;
  reading_time_left?: InputMaybe<Int_Comparison_Exp>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Bool_Exp>;
  rfid_scan_status?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  rfid_scanner_id?: InputMaybe<Uuid_Comparison_Exp>;
  scan_id?: InputMaybe<String_Comparison_Exp>;
  scanned_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Eatfresh_Rfid_Scan_Status_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_scan" */
export enum Eatfresh_Rfid_Scan_Constraint {
  /** unique or primary key constraint on columns "id" */
  RfidScanPkey = 'rfid_scan_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Inc_Input = {
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
  processing_time_ms?: InputMaybe<Scalars['Int']['input']>;
  reading_time?: InputMaybe<Scalars['Int']['input']>;
  reading_time_left?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Insert_Input = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Obj_Rel_Insert_Input>;
  box_content_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  epcs?: InputMaybe<Array<Scalars['String']['input']>>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
  processing_time_ms?: InputMaybe<Scalars['Int']['input']>;
  read_finished?: InputMaybe<Scalars['Boolean']['input']>;
  reading_time?: InputMaybe<Scalars['Int']['input']>;
  reading_time_left?: InputMaybe<Scalars['Int']['input']>;
  rfid_assets?: InputMaybe<Eatfresh_Rfid_Asset_Arr_Rel_Insert_Input>;
  rfid_scan_status?: InputMaybe<Eatfresh_Rfid_Scan_Status_Obj_Rel_Insert_Input>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Obj_Rel_Insert_Input>;
  rfid_scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  scan_id?: InputMaybe<Scalars['String']['input']>;
  scanned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Eatfresh_Rfid_Scan_Status_Enum>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Scan_Max_Fields = {
  __typename?: 'eatfresh_rfid_scan_max_fields';
  box_content_plan_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  epcs?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  power_in_dbm?: Maybe<Scalars['Int']['output']>;
  processing_time_ms?: Maybe<Scalars['Int']['output']>;
  reading_time?: Maybe<Scalars['Int']['output']>;
  reading_time_left?: Maybe<Scalars['Int']['output']>;
  rfid_scanner_id?: Maybe<Scalars['uuid']['output']>;
  scan_id?: Maybe<Scalars['String']['output']>;
  scanned_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Max_Order_By = {
  box_content_plan_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  epcs?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
  rfid_scanner_id?: InputMaybe<Order_By>;
  scan_id?: InputMaybe<Order_By>;
  scanned_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Scan_Min_Fields = {
  __typename?: 'eatfresh_rfid_scan_min_fields';
  box_content_plan_id?: Maybe<Scalars['uuid']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  epcs?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  power_in_dbm?: Maybe<Scalars['Int']['output']>;
  processing_time_ms?: Maybe<Scalars['Int']['output']>;
  reading_time?: Maybe<Scalars['Int']['output']>;
  reading_time_left?: Maybe<Scalars['Int']['output']>;
  rfid_scanner_id?: Maybe<Scalars['uuid']['output']>;
  scan_id?: Maybe<Scalars['String']['output']>;
  scanned_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Min_Order_By = {
  box_content_plan_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  epcs?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
  rfid_scanner_id?: InputMaybe<Order_By>;
  scan_id?: InputMaybe<Order_By>;
  scanned_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Mutation_Response = {
  __typename?: 'eatfresh_rfid_scan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Scan>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Scan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scan_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_On_Conflict = {
  constraint: Eatfresh_Rfid_Scan_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Scan_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_scan". */
export type Eatfresh_Rfid_Scan_Order_By = {
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Order_By>;
  box_content_plan_id?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  created_at?: InputMaybe<Order_By>;
  epcs?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  read_finished?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
  rfid_assets_aggregate?: InputMaybe<Eatfresh_Rfid_Asset_Aggregate_Order_By>;
  rfid_scan_status?: InputMaybe<Eatfresh_Rfid_Scan_Status_Order_By>;
  rfid_scanner?: InputMaybe<Eatfresh_Rfid_Scanner_Order_By>;
  rfid_scanner_id?: InputMaybe<Order_By>;
  scan_id?: InputMaybe<Order_By>;
  scanned_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_scan */
export type Eatfresh_Rfid_Scan_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.rfid_scan" */
export enum Eatfresh_Rfid_Scan_Select_Column {
  /** column name */
  BoxContentPlanId = 'box_content_plan_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Epcs = 'epcs',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  PowerInDbm = 'power_in_dbm',
  /** column name */
  ProcessingTimeMs = 'processing_time_ms',
  /** column name */
  ReadFinished = 'read_finished',
  /** column name */
  ReadingTime = 'reading_time',
  /** column name */
  ReadingTimeLeft = 'reading_time_left',
  /** column name */
  RfidScannerId = 'rfid_scanner_id',
  /** column name */
  ScanId = 'scan_id',
  /** column name */
  ScannedAt = 'scanned_at',
  /** column name */
  Status = 'status'
}

/** select "eatfresh_rfid_scan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.rfid_scan" */
export enum Eatfresh_Rfid_Scan_Select_Column_Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ReadFinished = 'read_finished'
}

/** select "eatfresh_rfid_scan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.rfid_scan" */
export enum Eatfresh_Rfid_Scan_Select_Column_Eatfresh_Rfid_Scan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ReadFinished = 'read_finished'
}

/** input type for updating data in table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Set_Input = {
  box_content_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  epcs?: InputMaybe<Array<Scalars['String']['input']>>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
  processing_time_ms?: InputMaybe<Scalars['Int']['input']>;
  read_finished?: InputMaybe<Scalars['Boolean']['input']>;
  reading_time?: InputMaybe<Scalars['Int']['input']>;
  reading_time_left?: InputMaybe<Scalars['Int']['input']>;
  rfid_scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  scan_id?: InputMaybe<Scalars['String']['input']>;
  scanned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Eatfresh_Rfid_Scan_Status_Enum>;
};

/** columns and relationships of "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status = {
  __typename?: 'eatfresh_rfid_scan_status';
  description: Scalars['String']['output'];
  /** An array relationship */
  rfid_scans: Array<Eatfresh_Rfid_Scan>;
  /** An aggregate relationship */
  rfid_scans_aggregate: Eatfresh_Rfid_Scan_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_StatusRfid_ScansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_StatusRfid_Scans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Aggregate = {
  __typename?: 'eatfresh_rfid_scan_status_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Scan_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Scan_Status>;
};

/** aggregate fields of "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_scan_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Scan_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Scan_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_scan_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Scan_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_scan_status" */
export enum Eatfresh_Rfid_Scan_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  RfidScanStatusPkey = 'rfid_scan_status_pkey'
}

export enum Eatfresh_Rfid_Scan_Status_Enum {
  /** RFID scan error */
  Error = 'ERROR',
  /** RFID scan finished */
  Finished = 'FINISHED',
  /** RFID scan in progress */
  InProgress = 'IN_PROGRESS',
  /** The scan is currently being processed */
  Processing = 'PROCESSING'
}

/** Boolean expression to compare columns of type "eatfresh_rfid_scan_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Rfid_Scan_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Rfid_Scan_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Rfid_Scan_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Scan_Status_Max_Fields = {
  __typename?: 'eatfresh_rfid_scan_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Scan_Status_Min_Fields = {
  __typename?: 'eatfresh_rfid_scan_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Mutation_Response = {
  __typename?: 'eatfresh_rfid_scan_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Scan_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Scan_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scan_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_On_Conflict = {
  constraint: Eatfresh_Rfid_Scan_Status_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Scan_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_scan_status". */
export type Eatfresh_Rfid_Scan_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_scan_status */
export type Eatfresh_Rfid_Scan_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.rfid_scan_status" */
export enum Eatfresh_Rfid_Scan_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_rfid_scan_status" */
export type Eatfresh_Rfid_Scan_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Scan_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Scan_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.rfid_scan_status" */
export enum Eatfresh_Rfid_Scan_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Rfid_Scan_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Scan_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Scan_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Eatfresh_Rfid_Scan_Stddev_Fields = {
  __typename?: 'eatfresh_rfid_scan_stddev_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
  processing_time_ms?: Maybe<Scalars['Float']['output']>;
  reading_time?: Maybe<Scalars['Float']['output']>;
  reading_time_left?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Stddev_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Rfid_Scan_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_rfid_scan_stddev_pop_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
  processing_time_ms?: Maybe<Scalars['Float']['output']>;
  reading_time?: Maybe<Scalars['Float']['output']>;
  reading_time_left?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Stddev_Pop_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Rfid_Scan_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_rfid_scan_stddev_samp_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
  processing_time_ms?: Maybe<Scalars['Float']['output']>;
  reading_time?: Maybe<Scalars['Float']['output']>;
  reading_time_left?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Stddev_Samp_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_rfid_scan" */
export type Eatfresh_Rfid_Scan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Scan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Scan_Stream_Cursor_Value_Input = {
  box_content_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  epcs?: InputMaybe<Array<Scalars['String']['input']>>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
  processing_time_ms?: InputMaybe<Scalars['Int']['input']>;
  read_finished?: InputMaybe<Scalars['Boolean']['input']>;
  reading_time?: InputMaybe<Scalars['Int']['input']>;
  reading_time_left?: InputMaybe<Scalars['Int']['input']>;
  rfid_scanner_id?: InputMaybe<Scalars['uuid']['input']>;
  scan_id?: InputMaybe<Scalars['String']['input']>;
  scanned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Eatfresh_Rfid_Scan_Status_Enum>;
};

/** aggregate sum on columns */
export type Eatfresh_Rfid_Scan_Sum_Fields = {
  __typename?: 'eatfresh_rfid_scan_sum_fields';
  power_in_dbm?: Maybe<Scalars['Int']['output']>;
  processing_time_ms?: Maybe<Scalars['Int']['output']>;
  reading_time?: Maybe<Scalars['Int']['output']>;
  reading_time_left?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Sum_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.rfid_scan" */
export enum Eatfresh_Rfid_Scan_Update_Column {
  /** column name */
  BoxContentPlanId = 'box_content_plan_id',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Epcs = 'epcs',
  /** column name */
  Error = 'error',
  /** column name */
  Id = 'id',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  PowerInDbm = 'power_in_dbm',
  /** column name */
  ProcessingTimeMs = 'processing_time_ms',
  /** column name */
  ReadFinished = 'read_finished',
  /** column name */
  ReadingTime = 'reading_time',
  /** column name */
  ReadingTimeLeft = 'reading_time_left',
  /** column name */
  RfidScannerId = 'rfid_scanner_id',
  /** column name */
  ScanId = 'scan_id',
  /** column name */
  ScannedAt = 'scanned_at',
  /** column name */
  Status = 'status'
}

export type Eatfresh_Rfid_Scan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Rfid_Scan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Scan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Scan_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Rfid_Scan_Var_Pop_Fields = {
  __typename?: 'eatfresh_rfid_scan_var_pop_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
  processing_time_ms?: Maybe<Scalars['Float']['output']>;
  reading_time?: Maybe<Scalars['Float']['output']>;
  reading_time_left?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Var_Pop_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Rfid_Scan_Var_Samp_Fields = {
  __typename?: 'eatfresh_rfid_scan_var_samp_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
  processing_time_ms?: Maybe<Scalars['Float']['output']>;
  reading_time?: Maybe<Scalars['Float']['output']>;
  reading_time_left?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Var_Samp_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Rfid_Scan_Variance_Fields = {
  __typename?: 'eatfresh_rfid_scan_variance_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
  processing_time_ms?: Maybe<Scalars['Float']['output']>;
  reading_time?: Maybe<Scalars['Float']['output']>;
  reading_time_left?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.rfid_scan" */
export type Eatfresh_Rfid_Scan_Variance_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
  processing_time_ms?: InputMaybe<Order_By>;
  reading_time?: InputMaybe<Order_By>;
  reading_time_left?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner = {
  __typename?: 'eatfresh_rfid_scanner';
  /** An array relationship */
  article_labeling_processes: Array<Eatfresh_Article_Labeling_Process>;
  /** An aggregate relationship */
  article_labeling_processes_aggregate: Eatfresh_Article_Labeling_Process_Aggregate;
  authtoken?: Maybe<Scalars['String']['output']>;
  baseurl?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  commissioning_processes: Array<Eatfresh_Commissioning_Process>;
  /** An aggregate relationship */
  commissioning_processes_aggregate: Eatfresh_Commissioning_Process_Aggregate;
  created_at: Scalars['timestamp']['output'];
  given_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  power_in_dbm: Scalars['Int']['output'];
  /** An object relationship */
  rfid_scanner_type: Eatfresh_Rfid_Scanner_Type;
  /** An array relationship */
  rfid_scans: Array<Eatfresh_Rfid_Scan>;
  /** An aggregate relationship */
  rfid_scans_aggregate: Eatfresh_Rfid_Scan_Aggregate;
  type: Eatfresh_Rfid_Scanner_Type_Enum;
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  warehouse: Eatfresh_Warehouse;
  warehouse_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_ScannerArticle_Labeling_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_ScannerArticle_Labeling_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_ScannerCommissioning_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_ScannerCommissioning_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_ScannerRfid_ScansArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_ScannerRfid_Scans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Aggregate = {
  __typename?: 'eatfresh_rfid_scanner_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Scanner_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Scanner>;
};

export type Eatfresh_Rfid_Scanner_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Rfid_Scanner_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Rfid_Scanner_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_scanner_aggregate_fields';
  avg?: Maybe<Eatfresh_Rfid_Scanner_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Scanner_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Scanner_Min_Fields>;
  stddev?: Maybe<Eatfresh_Rfid_Scanner_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Rfid_Scanner_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Rfid_Scanner_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Rfid_Scanner_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Rfid_Scanner_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Rfid_Scanner_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Rfid_Scanner_Variance_Fields>;
};


/** aggregate fields of "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Rfid_Scanner_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Rfid_Scanner_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Rfid_Scanner_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Rfid_Scanner_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Rfid_Scanner_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Rfid_Scanner_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Rfid_Scanner_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Rfid_Scanner_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Rfid_Scanner_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Rfid_Scanner_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Rfid_Scanner_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scanner_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Rfid_Scanner_Avg_Fields = {
  __typename?: 'eatfresh_rfid_scanner_avg_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Avg_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_scanner". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Scanner_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Bool_Exp>>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp>;
  authtoken?: InputMaybe<String_Comparison_Exp>;
  baseurl?: InputMaybe<String_Comparison_Exp>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  given_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  power_in_dbm?: InputMaybe<Int_Comparison_Exp>;
  rfid_scanner_type?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Bool_Exp>;
  type?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_scanner" */
export enum Eatfresh_Rfid_Scanner_Constraint {
  /** unique or primary key constraint on columns "given_id" */
  RfidScannerGivenIdKey = 'rfid_scanner_given_id_key',
  /** unique or primary key constraint on columns "id" */
  RfidScannerPkey = 'rfid_scanner_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Inc_Input = {
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Insert_Input = {
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Arr_Rel_Insert_Input>;
  authtoken?: InputMaybe<Scalars['String']['input']>;
  baseurl?: InputMaybe<Scalars['String']['input']>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
  rfid_scanner_type?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Obj_Rel_Insert_Input>;
  rfid_scans?: InputMaybe<Eatfresh_Rfid_Scan_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Scanner_Max_Fields = {
  __typename?: 'eatfresh_rfid_scanner_max_fields';
  authtoken?: Maybe<Scalars['String']['output']>;
  baseurl?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  power_in_dbm?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Max_Order_By = {
  authtoken?: InputMaybe<Order_By>;
  baseurl?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  power_in_dbm?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Scanner_Min_Fields = {
  __typename?: 'eatfresh_rfid_scanner_min_fields';
  authtoken?: Maybe<Scalars['String']['output']>;
  baseurl?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  power_in_dbm?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Min_Order_By = {
  authtoken?: InputMaybe<Order_By>;
  baseurl?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  power_in_dbm?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Mutation_Response = {
  __typename?: 'eatfresh_rfid_scanner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Scanner>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Scanner_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scanner_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_On_Conflict = {
  constraint: Eatfresh_Rfid_Scanner_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Scanner_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_scanner". */
export type Eatfresh_Rfid_Scanner_Order_By = {
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Order_By>;
  authtoken?: InputMaybe<Order_By>;
  baseurl?: InputMaybe<Order_By>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  power_in_dbm?: InputMaybe<Order_By>;
  rfid_scanner_type?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Order_By>;
  rfid_scans_aggregate?: InputMaybe<Eatfresh_Rfid_Scan_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_scanner */
export type Eatfresh_Rfid_Scanner_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.rfid_scanner" */
export enum Eatfresh_Rfid_Scanner_Select_Column {
  /** column name */
  Authtoken = 'authtoken',
  /** column name */
  Baseurl = 'baseurl',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PowerInDbm = 'power_in_dbm',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

/** input type for updating data in table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Set_Input = {
  authtoken?: InputMaybe<Scalars['String']['input']>;
  baseurl?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Rfid_Scanner_Stddev_Fields = {
  __typename?: 'eatfresh_rfid_scanner_stddev_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Stddev_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Rfid_Scanner_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_rfid_scanner_stddev_pop_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Stddev_Pop_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Rfid_Scanner_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_rfid_scanner_stddev_samp_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Stddev_Samp_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Scanner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Scanner_Stream_Cursor_Value_Input = {
  authtoken?: InputMaybe<Scalars['String']['input']>;
  baseurl?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  power_in_dbm?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Rfid_Scanner_Sum_Fields = {
  __typename?: 'eatfresh_rfid_scanner_sum_fields';
  power_in_dbm?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Sum_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type = {
  __typename?: 'eatfresh_rfid_scanner_type';
  description: Scalars['String']['output'];
  /** An array relationship */
  rfid_scanners: Array<Eatfresh_Rfid_Scanner>;
  /** An aggregate relationship */
  rfid_scanners_aggregate: Eatfresh_Rfid_Scanner_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_TypeRfid_ScannersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_TypeRfid_Scanners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Aggregate = {
  __typename?: 'eatfresh_rfid_scanner_type_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Scanner_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Scanner_Type>;
};

/** aggregate fields of "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_scanner_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Scanner_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Scanner_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_scanner_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Scanner_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  rfid_scanners?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  rfid_scanners_aggregate?: InputMaybe<Eatfresh_Rfid_Scanner_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_scanner_type" */
export enum Eatfresh_Rfid_Scanner_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  RfidScannerTypePkey = 'rfid_scanner_type_pkey'
}

export enum Eatfresh_Rfid_Scanner_Type_Enum {
  /** Portable RFID scanner */
  Portable = 'PORTABLE',
  /** Tunnel RFID scanner */
  Tunnel = 'TUNNEL'
}

/** Boolean expression to compare columns of type "eatfresh_rfid_scanner_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Rfid_Scanner_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  rfid_scanners?: InputMaybe<Eatfresh_Rfid_Scanner_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Scanner_Type_Max_Fields = {
  __typename?: 'eatfresh_rfid_scanner_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Scanner_Type_Min_Fields = {
  __typename?: 'eatfresh_rfid_scanner_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Mutation_Response = {
  __typename?: 'eatfresh_rfid_scanner_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Scanner_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Scanner_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scanner_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_On_Conflict = {
  constraint: Eatfresh_Rfid_Scanner_Type_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Scanner_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_scanner_type". */
export type Eatfresh_Rfid_Scanner_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  rfid_scanners_aggregate?: InputMaybe<Eatfresh_Rfid_Scanner_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_scanner_type */
export type Eatfresh_Rfid_Scanner_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.rfid_scanner_type" */
export enum Eatfresh_Rfid_Scanner_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_rfid_scanner_type" */
export type Eatfresh_Rfid_Scanner_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Scanner_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Scanner_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.rfid_scanner_type" */
export enum Eatfresh_Rfid_Scanner_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Rfid_Scanner_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Scanner_Type_Bool_Exp;
};

/** update columns of table "eatfresh.rfid_scanner" */
export enum Eatfresh_Rfid_Scanner_Update_Column {
  /** column name */
  Authtoken = 'authtoken',
  /** column name */
  Baseurl = 'baseurl',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PowerInDbm = 'power_in_dbm',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

export type Eatfresh_Rfid_Scanner_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Rfid_Scanner_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Scanner_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Scanner_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Rfid_Scanner_Var_Pop_Fields = {
  __typename?: 'eatfresh_rfid_scanner_var_pop_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Var_Pop_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Rfid_Scanner_Var_Samp_Fields = {
  __typename?: 'eatfresh_rfid_scanner_var_samp_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Var_Samp_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Rfid_Scanner_Variance_Fields = {
  __typename?: 'eatfresh_rfid_scanner_variance_fields';
  power_in_dbm?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.rfid_scanner" */
export type Eatfresh_Rfid_Scanner_Variance_Order_By = {
  power_in_dbm?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status = {
  __typename?: 'eatfresh_rfid_status';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.rfid_status" */
export type Eatfresh_Rfid_StatusRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_status" */
export type Eatfresh_Rfid_StatusRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_Aggregate = {
  __typename?: 'eatfresh_rfid_status_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Status>;
};

/** aggregate fields of "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_status" */
export enum Eatfresh_Rfid_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  RfidStatusPkey = 'rfid_status_pkey'
}

export enum Eatfresh_Rfid_Status_Enum {
  /** Thrown away. */
  Discarded = 'DISCARDED',
  /** Sold from a fridge */
  Dispensed = 'DISPENSED',
  /** In a fridge */
  InFridge = 'IN_FRIDGE',
  /** In storage box in the warehouse */
  InStorageBox = 'IN_STORAGE_BOX',
  /** In transport box after comissioning */
  InTransportBox = 'IN_TRANSPORT_BOX',
  /** The Product is missing */
  Missing = 'MISSING',
  /** Unknown location */
  Unstored = 'UNSTORED'
}

/** Boolean expression to compare columns of type "eatfresh_rfid_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Rfid_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Rfid_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Rfid_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Rfid_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Rfid_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Status_Max_Fields = {
  __typename?: 'eatfresh_rfid_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Status_Min_Fields = {
  __typename?: 'eatfresh_rfid_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_Mutation_Response = {
  __typename?: 'eatfresh_rfid_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_On_Conflict = {
  constraint: Eatfresh_Rfid_Status_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_status". */
export type Eatfresh_Rfid_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_status */
export type Eatfresh_Rfid_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.rfid_status" */
export enum Eatfresh_Rfid_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.rfid_status" */
export type Eatfresh_Rfid_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_rfid_status" */
export type Eatfresh_Rfid_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.rfid_status" */
export enum Eatfresh_Rfid_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Rfid_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Status_Bool_Exp;
};

/** columns and relationships of "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag = {
  __typename?: 'eatfresh_rfid_tag';
  /** An object relationship */
  article?: Maybe<Eatfresh_Article>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** An object relationship */
  asset_placement?: Maybe<Eatfresh_Asset_Placement>;
  best_before_date: Scalars['date']['output'];
  /** An object relationship */
  box_content_plan?: Maybe<Eatfresh_Box_Content_Plan>;
  box_content_plan_id?: Maybe<Scalars['uuid']['output']>;
  commissioned_at?: Maybe<Scalars['timestamptz']['output']>;
  commissioning_cost_attribution: Scalars['Int']['output'];
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  commissioning_process?: Maybe<Eatfresh_Commissioning_Process>;
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer_order?: Maybe<Eatfresh_Customer_Order>;
  delivery_cost_attribution: Scalars['Int']['output'];
  discarded_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  external_warehouse_order?: Maybe<Eatfresh_Warehouse_Order>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  fridge?: Maybe<Eatfresh_Fridge>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  fridge_stocks: Array<Eatfresh_Fridge_Stock>;
  /** An aggregate relationship */
  fridge_stocks_aggregate: Eatfresh_Fridge_Stock_Aggregate;
  id: Scalars['uuid']['output'];
  is_whitelabel?: Maybe<Scalars['Boolean']['output']>;
  labeling_cost_attribution: Scalars['Int']['output'];
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  missing_at?: Maybe<Scalars['timestamptz']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  payment_cost_attribution: Scalars['Int']['output'];
  purchase_price: Scalars['Int']['output'];
  /** An object relationship */
  refill?: Maybe<Eatfresh_Refill>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  refilled_at?: Maybe<Scalars['timestamptz']['output']>;
  retail_price: Scalars['Int']['output'];
  /** An object relationship */
  rfidStatusByRfidStatus: Eatfresh_Rfid_Status;
  /** An object relationship */
  rfid_asset?: Maybe<Eatfresh_Rfid_Asset>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  rfid_number?: Maybe<Scalars['String']['output']>;
  rfid_status: Eatfresh_Rfid_Status_Enum;
  sold_at?: Maybe<Scalars['timestamptz']['output']>;
  unstored_at?: Maybe<Scalars['timestamptz']['output']>;
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  warehouse_order?: Maybe<Eatfresh_Warehouse_Order>;
  warehouse_order_cost_attribution: Scalars['Int']['output'];
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_order_receipt_cost_attribution: Scalars['Int']['output'];
  /** An object relationship */
  wholesale_order?: Maybe<Eatfresh_Warehouse_Order>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_TagFridge_StocksArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


/** columns and relationships of "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_TagFridge_Stocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};

/** aggregated selection of "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Aggregate = {
  __typename?: 'eatfresh_rfid_tag_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Tag_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Tag>;
};

export type Eatfresh_Rfid_Tag_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Rfid_Tag_Select_Column_Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Rfid_Tag_Select_Column_Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_tag_aggregate_fields';
  avg?: Maybe<Eatfresh_Rfid_Tag_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Tag_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Tag_Min_Fields>;
  stddev?: Maybe<Eatfresh_Rfid_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Rfid_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Rfid_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Rfid_Tag_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Rfid_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Rfid_Tag_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Rfid_Tag_Variance_Fields>;
};


/** aggregate fields of "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Rfid_Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Rfid_Tag_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Rfid_Tag_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Rfid_Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Rfid_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Rfid_Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Rfid_Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Rfid_Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Rfid_Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Rfid_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Rfid_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Rfid_Tag_Avg_Fields = {
  __typename?: 'eatfresh_rfid_tag_avg_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Float']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Float']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Float']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Float']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Avg_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_tag". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Tag_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Tag_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  asset_placement?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  best_before_date?: InputMaybe<Date_Comparison_Exp>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
  box_content_plan_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioned_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  commissioning_cost_attribution?: InputMaybe<Int_Comparison_Exp>;
  commissioning_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  delivery_cost_attribution?: InputMaybe<Int_Comparison_Exp>;
  discarded_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  external_warehouse_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge_stocks?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
  fridge_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Stock_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_whitelabel?: InputMaybe<Boolean_Comparison_Exp>;
  labeling_cost_attribution?: InputMaybe<Int_Comparison_Exp>;
  labeling_id?: InputMaybe<Uuid_Comparison_Exp>;
  missing_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_cost_attribution?: InputMaybe<Int_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  refill?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refill_id?: InputMaybe<Uuid_Comparison_Exp>;
  refilled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  retail_price?: InputMaybe<Int_Comparison_Exp>;
  rfidStatusByRfidStatus?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
  rfid_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_number?: InputMaybe<String_Comparison_Exp>;
  rfid_status?: InputMaybe<Eatfresh_Rfid_Status_Enum_Comparison_Exp>;
  sold_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  unstored_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  warehouse_order_cost_attribution?: InputMaybe<Int_Comparison_Exp>;
  warehouse_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Int_Comparison_Exp>;
  wholesale_order?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  wholesale_order_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.rfid_tag" */
export enum Eatfresh_Rfid_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshRfidTagPkey = 'eatfresh_rfid_tag_pkey',
  /** unique or primary key constraint on columns "rfid_number" */
  RfidTagRfidNumberKey = 'rfid_tag_rfid_number_key'
}

/** input type for incrementing numeric columns in table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Inc_Input = {
  commissioning_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  delivery_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  labeling_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  payment_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
  warehouse_order_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Obj_Rel_Insert_Input>;
  asset_placement?: InputMaybe<Eatfresh_Asset_Placement_Obj_Rel_Insert_Input>;
  best_before_date?: InputMaybe<Scalars['date']['input']>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Obj_Rel_Insert_Input>;
  box_content_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  commissioning_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Obj_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Obj_Rel_Insert_Input>;
  delivery_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  discarded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Obj_Rel_Insert_Input>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge?: InputMaybe<Eatfresh_Fridge_Obj_Rel_Insert_Input>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_stocks?: InputMaybe<Eatfresh_Fridge_Stock_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_whitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  labeling_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  missing_at?: InputMaybe<Scalars['timestamptz']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  refill?: InputMaybe<Eatfresh_Refill_Obj_Rel_Insert_Input>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  refilled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
  rfidStatusByRfidStatus?: InputMaybe<Eatfresh_Rfid_Status_Obj_Rel_Insert_Input>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Obj_Rel_Insert_Input>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_number?: InputMaybe<Scalars['String']['input']>;
  rfid_status?: InputMaybe<Eatfresh_Rfid_Status_Enum>;
  sold_at?: InputMaybe<Scalars['timestamptz']['input']>;
  unstored_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Obj_Rel_Insert_Input>;
  warehouse_order_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  wholesale_order?: InputMaybe<Eatfresh_Warehouse_Order_Obj_Rel_Insert_Input>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Tag_Max_Fields = {
  __typename?: 'eatfresh_rfid_tag_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  best_before_date?: Maybe<Scalars['date']['output']>;
  box_content_plan_id?: Maybe<Scalars['uuid']['output']>;
  commissioned_at?: Maybe<Scalars['timestamptz']['output']>;
  commissioning_cost_attribution?: Maybe<Scalars['Int']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Int']['output']>;
  discarded_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Int']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  missing_at?: Maybe<Scalars['timestamptz']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  refilled_at?: Maybe<Scalars['timestamptz']['output']>;
  retail_price?: Maybe<Scalars['Int']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  rfid_number?: Maybe<Scalars['String']['output']>;
  sold_at?: Maybe<Scalars['timestamptz']['output']>;
  unstored_at?: Maybe<Scalars['timestamptz']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Int']['output']>;
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Int']['output']>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  box_content_plan_id?: InputMaybe<Order_By>;
  commissioned_at?: InputMaybe<Order_By>;
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  discarded_at?: InputMaybe<Order_By>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  missing_at?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  refilled_at?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_number?: InputMaybe<Order_By>;
  sold_at?: InputMaybe<Order_By>;
  unstored_at?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Tag_Min_Fields = {
  __typename?: 'eatfresh_rfid_tag_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  best_before_date?: Maybe<Scalars['date']['output']>;
  box_content_plan_id?: Maybe<Scalars['uuid']['output']>;
  commissioned_at?: Maybe<Scalars['timestamptz']['output']>;
  commissioning_cost_attribution?: Maybe<Scalars['Int']['output']>;
  commissioning_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Int']['output']>;
  discarded_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Int']['output']>;
  labeling_id?: Maybe<Scalars['uuid']['output']>;
  missing_at?: Maybe<Scalars['timestamptz']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  refill_id?: Maybe<Scalars['uuid']['output']>;
  refilled_at?: Maybe<Scalars['timestamptz']['output']>;
  retail_price?: Maybe<Scalars['Int']['output']>;
  rfid_asset_id?: Maybe<Scalars['uuid']['output']>;
  rfid_number?: Maybe<Scalars['String']['output']>;
  sold_at?: Maybe<Scalars['timestamptz']['output']>;
  unstored_at?: Maybe<Scalars['timestamptz']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Int']['output']>;
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Int']['output']>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  box_content_plan_id?: InputMaybe<Order_By>;
  commissioned_at?: InputMaybe<Order_By>;
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  discarded_at?: InputMaybe<Order_By>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  missing_at?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  refill_id?: InputMaybe<Order_By>;
  refilled_at?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_number?: InputMaybe<Order_By>;
  sold_at?: InputMaybe<Order_By>;
  unstored_at?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Mutation_Response = {
  __typename?: 'eatfresh_rfid_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Rfid_Tag>;
};

/** input type for inserting object relation for remote table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Obj_Rel_Insert_Input = {
  data: Eatfresh_Rfid_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Rfid_Tag_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_On_Conflict = {
  constraint: Eatfresh_Rfid_Tag_Constraint;
  update_columns?: Array<Eatfresh_Rfid_Tag_Update_Column>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.rfid_tag". */
export type Eatfresh_Rfid_Tag_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_labeling_process?: InputMaybe<Eatfresh_Article_Labeling_Process_Order_By>;
  asset_placement?: InputMaybe<Eatfresh_Asset_Placement_Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  box_content_plan?: InputMaybe<Eatfresh_Box_Content_Plan_Order_By>;
  box_content_plan_id?: InputMaybe<Order_By>;
  commissioned_at?: InputMaybe<Order_By>;
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  commissioning_id?: InputMaybe<Order_By>;
  commissioning_process?: InputMaybe<Eatfresh_Commissioning_Process_Order_By>;
  created?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  discarded_at?: InputMaybe<Order_By>;
  external_warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Order_By>;
  external_warehouse_order_id?: InputMaybe<Order_By>;
  fridge?: InputMaybe<Eatfresh_Fridge_Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  fridge_stocks_aggregate?: InputMaybe<Eatfresh_Fridge_Stock_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_whitelabel?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  labeling_id?: InputMaybe<Order_By>;
  missing_at?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  refill?: InputMaybe<Eatfresh_Refill_Order_By>;
  refill_id?: InputMaybe<Order_By>;
  refilled_at?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  rfidStatusByRfidStatus?: InputMaybe<Eatfresh_Rfid_Status_Order_By>;
  rfid_asset?: InputMaybe<Eatfresh_Rfid_Asset_Order_By>;
  rfid_asset_id?: InputMaybe<Order_By>;
  rfid_number?: InputMaybe<Order_By>;
  rfid_status?: InputMaybe<Order_By>;
  sold_at?: InputMaybe<Order_By>;
  unstored_at?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
  wholesale_order?: InputMaybe<Eatfresh_Warehouse_Order_Order_By>;
  wholesale_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.rfid_tag */
export type Eatfresh_Rfid_Tag_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.rfid_tag_sales_daily" */
export type Eatfresh_Rfid_Tag_Sales_Daily = {
  __typename?: 'eatfresh_rfid_tag_sales_daily';
  article_id?: Maybe<Scalars['uuid']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  sale_count?: Maybe<Scalars['bigint']['output']>;
  sale_day?: Maybe<Scalars['date']['output']>;
};

/** aggregated selection of "eatfresh.rfid_tag_sales_daily" */
export type Eatfresh_Rfid_Tag_Sales_Daily_Aggregate = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_aggregate';
  aggregate?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Aggregate_Fields>;
  nodes: Array<Eatfresh_Rfid_Tag_Sales_Daily>;
};

/** aggregate fields of "eatfresh.rfid_tag_sales_daily" */
export type Eatfresh_Rfid_Tag_Sales_Daily_Aggregate_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_aggregate_fields';
  avg?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Max_Fields>;
  min?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Min_Fields>;
  stddev?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Rfid_Tag_Sales_Daily_Variance_Fields>;
};


/** aggregate fields of "eatfresh.rfid_tag_sales_daily" */
export type Eatfresh_Rfid_Tag_Sales_Daily_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Avg_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_avg_fields';
  sale_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.rfid_tag_sales_daily". All fields are combined with a logical 'AND'. */
export type Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  fridge_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_count?: InputMaybe<Bigint_Comparison_Exp>;
  sale_day?: InputMaybe<Date_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Max_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  sale_count?: Maybe<Scalars['bigint']['output']>;
  sale_day?: Maybe<Scalars['date']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Min_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  fridge_id?: Maybe<Scalars['uuid']['output']>;
  sale_count?: Maybe<Scalars['bigint']['output']>;
  sale_day?: Maybe<Scalars['date']['output']>;
};

/** Ordering options when selecting data from "eatfresh.rfid_tag_sales_daily". */
export type Eatfresh_Rfid_Tag_Sales_Daily_Order_By = {
  article_id?: InputMaybe<Order_By>;
  fridge_id?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_day?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.rfid_tag_sales_daily" */
export enum Eatfresh_Rfid_Tag_Sales_Daily_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleDay = 'sale_day'
}

/** aggregate stddev on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Stddev_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_stddev_fields';
  sale_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_stddev_pop_fields';
  sale_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_stddev_samp_fields';
  sale_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_rfid_tag_sales_daily" */
export type Eatfresh_Rfid_Tag_Sales_Daily_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Tag_Sales_Daily_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Tag_Sales_Daily_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_count?: InputMaybe<Scalars['bigint']['input']>;
  sale_day?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Sum_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_sum_fields';
  sale_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Var_Pop_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_var_pop_fields';
  sale_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Var_Samp_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_var_samp_fields';
  sale_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Rfid_Tag_Sales_Daily_Variance_Fields = {
  __typename?: 'eatfresh_rfid_tag_sales_daily_variance_fields';
  sale_count?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "eatfresh.rfid_tag" */
export enum Eatfresh_Rfid_Tag_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BestBeforeDate = 'best_before_date',
  /** column name */
  BoxContentPlanId = 'box_content_plan_id',
  /** column name */
  CommissionedAt = 'commissioned_at',
  /** column name */
  CommissioningCostAttribution = 'commissioning_cost_attribution',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  Created = 'created',
  /** column name */
  DeliveryCostAttribution = 'delivery_cost_attribution',
  /** column name */
  DiscardedAt = 'discarded_at',
  /** column name */
  ExternalWarehouseOrderId = 'external_warehouse_order_id',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsWhitelabel = 'is_whitelabel',
  /** column name */
  LabelingCostAttribution = 'labeling_cost_attribution',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  MissingAt = 'missing_at',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PaymentCostAttribution = 'payment_cost_attribution',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  RefilledAt = 'refilled_at',
  /** column name */
  RetailPrice = 'retail_price',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  RfidNumber = 'rfid_number',
  /** column name */
  RfidStatus = 'rfid_status',
  /** column name */
  SoldAt = 'sold_at',
  /** column name */
  UnstoredAt = 'unstored_at',
  /** column name */
  Updated = 'updated',
  /** column name */
  WarehouseOrderCostAttribution = 'warehouse_order_cost_attribution',
  /** column name */
  WarehouseOrderId = 'warehouse_order_id',
  /** column name */
  WarehouseOrderReceiptCostAttribution = 'warehouse_order_receipt_cost_attribution',
  /** column name */
  WholesaleOrderId = 'wholesale_order_id'
}

/** select "eatfresh_rfid_tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.rfid_tag" */
export enum Eatfresh_Rfid_Tag_Select_Column_Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsWhitelabel = 'is_whitelabel'
}

/** select "eatfresh_rfid_tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.rfid_tag" */
export enum Eatfresh_Rfid_Tag_Select_Column_Eatfresh_Rfid_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsWhitelabel = 'is_whitelabel'
}

/** input type for updating data in table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  best_before_date?: InputMaybe<Scalars['date']['input']>;
  box_content_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  commissioning_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  discarded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_whitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  labeling_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  missing_at?: InputMaybe<Scalars['timestamptz']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  refilled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_number?: InputMaybe<Scalars['String']['input']>;
  rfid_status?: InputMaybe<Eatfresh_Rfid_Status_Enum>;
  sold_at?: InputMaybe<Scalars['timestamptz']['input']>;
  unstored_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_order_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Rfid_Tag_Stddev_Fields = {
  __typename?: 'eatfresh_rfid_tag_stddev_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Float']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Float']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Float']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Float']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Stddev_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Rfid_Tag_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_rfid_tag_stddev_pop_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Float']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Float']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Float']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Float']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Stddev_Pop_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Rfid_Tag_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_rfid_tag_stddev_samp_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Float']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Float']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Float']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Float']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Stddev_Samp_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_rfid_tag" */
export type Eatfresh_Rfid_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Rfid_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Rfid_Tag_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  best_before_date?: InputMaybe<Scalars['date']['input']>;
  box_content_plan_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioned_at?: InputMaybe<Scalars['timestamptz']['input']>;
  commissioning_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  commissioning_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  discarded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Outbound: which external warehouse order this product is assigned to */
  external_warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
  fridge_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_whitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  labeling_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  labeling_id?: InputMaybe<Scalars['uuid']['input']>;
  missing_at?: InputMaybe<Scalars['timestamptz']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  refill_id?: InputMaybe<Scalars['uuid']['input']>;
  refilled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  retail_price?: InputMaybe<Scalars['Int']['input']>;
  rfid_asset_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_number?: InputMaybe<Scalars['String']['input']>;
  rfid_status?: InputMaybe<Eatfresh_Rfid_Status_Enum>;
  sold_at?: InputMaybe<Scalars['timestamptz']['input']>;
  unstored_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_order_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  /** Inbound: which supplier order this product came from */
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Scalars['Int']['input']>;
  /** Outbound: which wholesale order this product is assigned to */
  wholesale_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Rfid_Tag_Sum_Fields = {
  __typename?: 'eatfresh_rfid_tag_sum_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Int']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Int']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Int']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  retail_price?: Maybe<Scalars['Int']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Int']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Sum_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.rfid_tag" */
export enum Eatfresh_Rfid_Tag_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BestBeforeDate = 'best_before_date',
  /** column name */
  BoxContentPlanId = 'box_content_plan_id',
  /** column name */
  CommissionedAt = 'commissioned_at',
  /** column name */
  CommissioningCostAttribution = 'commissioning_cost_attribution',
  /** column name */
  CommissioningId = 'commissioning_id',
  /** column name */
  Created = 'created',
  /** column name */
  DeliveryCostAttribution = 'delivery_cost_attribution',
  /** column name */
  DiscardedAt = 'discarded_at',
  /** column name */
  ExternalWarehouseOrderId = 'external_warehouse_order_id',
  /** column name */
  FridgeId = 'fridge_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsWhitelabel = 'is_whitelabel',
  /** column name */
  LabelingCostAttribution = 'labeling_cost_attribution',
  /** column name */
  LabelingId = 'labeling_id',
  /** column name */
  MissingAt = 'missing_at',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PaymentCostAttribution = 'payment_cost_attribution',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  RefillId = 'refill_id',
  /** column name */
  RefilledAt = 'refilled_at',
  /** column name */
  RetailPrice = 'retail_price',
  /** column name */
  RfidAssetId = 'rfid_asset_id',
  /** column name */
  RfidNumber = 'rfid_number',
  /** column name */
  RfidStatus = 'rfid_status',
  /** column name */
  SoldAt = 'sold_at',
  /** column name */
  UnstoredAt = 'unstored_at',
  /** column name */
  Updated = 'updated',
  /** column name */
  WarehouseOrderCostAttribution = 'warehouse_order_cost_attribution',
  /** column name */
  WarehouseOrderId = 'warehouse_order_id',
  /** column name */
  WarehouseOrderReceiptCostAttribution = 'warehouse_order_receipt_cost_attribution',
  /** column name */
  WholesaleOrderId = 'wholesale_order_id'
}

export type Eatfresh_Rfid_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Rfid_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Rfid_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Rfid_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Rfid_Tag_Var_Pop_Fields = {
  __typename?: 'eatfresh_rfid_tag_var_pop_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Float']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Float']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Float']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Float']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Var_Pop_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Rfid_Tag_Var_Samp_Fields = {
  __typename?: 'eatfresh_rfid_tag_var_samp_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Float']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Float']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Float']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Float']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Var_Samp_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Rfid_Tag_Variance_Fields = {
  __typename?: 'eatfresh_rfid_tag_variance_fields';
  commissioning_cost_attribution?: Maybe<Scalars['Float']['output']>;
  delivery_cost_attribution?: Maybe<Scalars['Float']['output']>;
  labeling_cost_attribution?: Maybe<Scalars['Float']['output']>;
  payment_cost_attribution?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  retail_price?: Maybe<Scalars['Float']['output']>;
  warehouse_order_cost_attribution?: Maybe<Scalars['Float']['output']>;
  warehouse_order_receipt_cost_attribution?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.rfid_tag" */
export type Eatfresh_Rfid_Tag_Variance_Order_By = {
  commissioning_cost_attribution?: InputMaybe<Order_By>;
  delivery_cost_attribution?: InputMaybe<Order_By>;
  labeling_cost_attribution?: InputMaybe<Order_By>;
  payment_cost_attribution?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  retail_price?: InputMaybe<Order_By>;
  warehouse_order_cost_attribution?: InputMaybe<Order_By>;
  warehouse_order_receipt_cost_attribution?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State = {
  __typename?: 'eatfresh_selfly_cabinet_state';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  fridges: Array<Eatfresh_Fridge>;
  /** An aggregate relationship */
  fridges_aggregate: Eatfresh_Fridge_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_StateFridgesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


/** columns and relationships of "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_StateFridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};

/** aggregated selection of "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Aggregate = {
  __typename?: 'eatfresh_selfly_cabinet_state_aggregate';
  aggregate?: Maybe<Eatfresh_Selfly_Cabinet_State_Aggregate_Fields>;
  nodes: Array<Eatfresh_Selfly_Cabinet_State>;
};

/** aggregate fields of "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Aggregate_Fields = {
  __typename?: 'eatfresh_selfly_cabinet_state_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Selfly_Cabinet_State_Max_Fields>;
  min?: Maybe<Eatfresh_Selfly_Cabinet_State_Min_Fields>;
};


/** aggregate fields of "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.selfly_cabinet_state". All fields are combined with a logical 'AND'. */
export type Eatfresh_Selfly_Cabinet_State_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  fridges?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.selfly_cabinet_state" */
export enum Eatfresh_Selfly_Cabinet_State_Constraint {
  /** unique or primary key constraint on columns "value" */
  SelflyCabinetStatePkey = 'selfly_cabinet_state_pkey'
}

export enum Eatfresh_Selfly_Cabinet_State_Enum {
  DoorClosed = 'doorClosed',
  DoorOpened = 'doorOpened',
  DoorUnlocked = 'doorUnlocked',
  MaintenanceModeEnter = 'maintenanceModeEnter',
  MaintenanceModeExit = 'maintenanceModeExit',
  OutOfServiceEnter = 'outOfServiceEnter',
  OutOfServiceExit = 'outOfServiceExit',
  PurchaseEnter = 'purchaseEnter',
  PurchaseExit = 'purchaseExit',
  ReadyForPurchase = 'readyForPurchase',
  RefillEnd = 'refillEnd',
  RefillStart = 'refillStart',
  Unknown = 'unknown'
}

/** Boolean expression to compare columns of type "eatfresh_selfly_cabinet_state_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Selfly_Cabinet_State_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Enum>>;
};

/** input type for inserting data into table "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  fridges?: InputMaybe<Eatfresh_Fridge_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Selfly_Cabinet_State_Max_Fields = {
  __typename?: 'eatfresh_selfly_cabinet_state_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Selfly_Cabinet_State_Min_Fields = {
  __typename?: 'eatfresh_selfly_cabinet_state_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Mutation_Response = {
  __typename?: 'eatfresh_selfly_cabinet_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Selfly_Cabinet_State>;
};

/** input type for inserting object relation for remote table "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Obj_Rel_Insert_Input = {
  data: Eatfresh_Selfly_Cabinet_State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Selfly_Cabinet_State_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_On_Conflict = {
  constraint: Eatfresh_Selfly_Cabinet_State_Constraint;
  update_columns?: Array<Eatfresh_Selfly_Cabinet_State_Update_Column>;
  where?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.selfly_cabinet_state". */
export type Eatfresh_Selfly_Cabinet_State_Order_By = {
  description?: InputMaybe<Order_By>;
  fridges_aggregate?: InputMaybe<Eatfresh_Fridge_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.selfly_cabinet_state */
export type Eatfresh_Selfly_Cabinet_State_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.selfly_cabinet_state" */
export enum Eatfresh_Selfly_Cabinet_State_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_selfly_cabinet_state" */
export type Eatfresh_Selfly_Cabinet_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Selfly_Cabinet_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Selfly_Cabinet_State_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.selfly_cabinet_state" */
export enum Eatfresh_Selfly_Cabinet_State_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Selfly_Cabinet_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Selfly_Cabinet_State_Bool_Exp;
};

/** columns and relationships of "eatfresh.session_step" */
export type Eatfresh_Session_Step = {
  __typename?: 'eatfresh_session_step';
  created: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  sent_at: Scalars['timestamptz']['output'];
  sent_from?: Maybe<Scalars['String']['output']>;
  session_id: Scalars['uuid']['output'];
  step: Scalars['String']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "eatfresh.session_step" */
export type Eatfresh_Session_Step_Aggregate = {
  __typename?: 'eatfresh_session_step_aggregate';
  aggregate?: Maybe<Eatfresh_Session_Step_Aggregate_Fields>;
  nodes: Array<Eatfresh_Session_Step>;
};

/** aggregate fields of "eatfresh.session_step" */
export type Eatfresh_Session_Step_Aggregate_Fields = {
  __typename?: 'eatfresh_session_step_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Session_Step_Max_Fields>;
  min?: Maybe<Eatfresh_Session_Step_Min_Fields>;
};


/** aggregate fields of "eatfresh.session_step" */
export type Eatfresh_Session_Step_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Session_Step_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.session_step". All fields are combined with a logical 'AND'. */
export type Eatfresh_Session_Step_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Session_Step_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Session_Step_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Session_Step_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sent_from?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<Uuid_Comparison_Exp>;
  step?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.session_step" */
export enum Eatfresh_Session_Step_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionStepPkey = 'session_step_pkey'
}

/** input type for inserting data into table "eatfresh.session_step" */
export type Eatfresh_Session_Step_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_from?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Session_Step_Max_Fields = {
  __typename?: 'eatfresh_session_step_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  sent_from?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['uuid']['output']>;
  step?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Session_Step_Min_Fields = {
  __typename?: 'eatfresh_session_step_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  sent_from?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['uuid']['output']>;
  step?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "eatfresh.session_step" */
export type Eatfresh_Session_Step_Mutation_Response = {
  __typename?: 'eatfresh_session_step_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Session_Step>;
};

/** on_conflict condition type for table "eatfresh.session_step" */
export type Eatfresh_Session_Step_On_Conflict = {
  constraint: Eatfresh_Session_Step_Constraint;
  update_columns?: Array<Eatfresh_Session_Step_Update_Column>;
  where?: InputMaybe<Eatfresh_Session_Step_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.session_step". */
export type Eatfresh_Session_Step_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_from?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  step?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.session_step */
export type Eatfresh_Session_Step_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.session_step" */
export enum Eatfresh_Session_Step_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentFrom = 'sent_from',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Step = 'step',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "eatfresh.session_step" */
export type Eatfresh_Session_Step_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_from?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_session_step" */
export type Eatfresh_Session_Step_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Session_Step_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Session_Step_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sent_from?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['uuid']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.session_step" */
export enum Eatfresh_Session_Step_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentFrom = 'sent_from',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Step = 'step',
  /** column name */
  UserId = 'user_id'
}

export type Eatfresh_Session_Step_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Session_Step_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Session_Step_Bool_Exp;
};

/** columns and relationships of "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type = {
  __typename?: 'eatfresh_shelf_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
  /** An array relationship */
  warehouse_shelves: Array<Eatfresh_Warehouse_Shelf>;
  /** An aggregate relationship */
  warehouse_shelves_aggregate: Eatfresh_Warehouse_Shelf_Aggregate;
};


/** columns and relationships of "eatfresh.shelf_type" */
export type Eatfresh_Shelf_TypeWarehouse_ShelvesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};


/** columns and relationships of "eatfresh.shelf_type" */
export type Eatfresh_Shelf_TypeWarehouse_Shelves_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};

/** aggregated selection of "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_Aggregate = {
  __typename?: 'eatfresh_shelf_type_aggregate';
  aggregate?: Maybe<Eatfresh_Shelf_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Shelf_Type>;
};

/** aggregate fields of "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_shelf_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Shelf_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Shelf_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Shelf_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.shelf_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Shelf_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Shelf_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Shelf_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  warehouse_shelves?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
  warehouse_shelves_aggregate?: InputMaybe<Eatfresh_Warehouse_Shelf_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.shelf_type" */
export enum Eatfresh_Shelf_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  ShelfTypePkey = 'shelf_type_pkey'
}

/** input type for inserting data into table "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  warehouse_shelves?: InputMaybe<Eatfresh_Warehouse_Shelf_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Shelf_Type_Max_Fields = {
  __typename?: 'eatfresh_shelf_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Shelf_Type_Min_Fields = {
  __typename?: 'eatfresh_shelf_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_Mutation_Response = {
  __typename?: 'eatfresh_shelf_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Shelf_Type>;
};

/** input type for inserting object relation for remote table "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_Obj_Rel_Insert_Input = {
  data: Eatfresh_Shelf_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Shelf_Type_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_On_Conflict = {
  constraint: Eatfresh_Shelf_Type_Constraint;
  update_columns?: Array<Eatfresh_Shelf_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.shelf_type". */
export type Eatfresh_Shelf_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  warehouse_shelves_aggregate?: InputMaybe<Eatfresh_Warehouse_Shelf_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.shelf_type */
export type Eatfresh_Shelf_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.shelf_type" */
export enum Eatfresh_Shelf_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.shelf_type" */
export type Eatfresh_Shelf_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_shelf_type" */
export type Eatfresh_Shelf_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Shelf_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Shelf_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.shelf_type" */
export enum Eatfresh_Shelf_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Shelf_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Shelf_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Shelf_Type_Bool_Exp;
};

/** columns and relationships of "eatfresh.sold_item_cost" */
export type Eatfresh_Sold_Item_Cost = {
  __typename?: 'eatfresh_sold_item_cost';
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_name?: Maybe<Scalars['String']['output']>;
  cost_cents?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  demo_flag?: Maybe<Scalars['Boolean']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  revenue_cents?: Maybe<Scalars['Int']['output']>;
  rfid_tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "eatfresh.sold_item_cost" */
export type Eatfresh_Sold_Item_Cost_Aggregate = {
  __typename?: 'eatfresh_sold_item_cost_aggregate';
  aggregate?: Maybe<Eatfresh_Sold_Item_Cost_Aggregate_Fields>;
  nodes: Array<Eatfresh_Sold_Item_Cost>;
};

/** aggregate fields of "eatfresh.sold_item_cost" */
export type Eatfresh_Sold_Item_Cost_Aggregate_Fields = {
  __typename?: 'eatfresh_sold_item_cost_aggregate_fields';
  avg?: Maybe<Eatfresh_Sold_Item_Cost_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Sold_Item_Cost_Max_Fields>;
  min?: Maybe<Eatfresh_Sold_Item_Cost_Min_Fields>;
  stddev?: Maybe<Eatfresh_Sold_Item_Cost_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Sold_Item_Cost_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Sold_Item_Cost_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Sold_Item_Cost_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Sold_Item_Cost_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Sold_Item_Cost_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Sold_Item_Cost_Variance_Fields>;
};


/** aggregate fields of "eatfresh.sold_item_cost" */
export type Eatfresh_Sold_Item_Cost_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Sold_Item_Cost_Avg_Fields = {
  __typename?: 'eatfresh_sold_item_cost_avg_fields';
  cost_cents?: Maybe<Scalars['Float']['output']>;
  revenue_cents?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.sold_item_cost". All fields are combined with a logical 'AND'. */
export type Eatfresh_Sold_Item_Cost_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Sold_Item_Cost_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Bool_Exp>>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  article_name?: InputMaybe<String_Comparison_Exp>;
  cost_cents?: InputMaybe<Int_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  demo_flag?: InputMaybe<Boolean_Comparison_Exp>;
  ean?: InputMaybe<String_Comparison_Exp>;
  given_id?: InputMaybe<String_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_status?: InputMaybe<String_Comparison_Exp>;
  revenue_cents?: InputMaybe<Int_Comparison_Exp>;
  rfid_tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Eatfresh_Sold_Item_Cost_Max_Fields = {
  __typename?: 'eatfresh_sold_item_cost_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_name?: Maybe<Scalars['String']['output']>;
  cost_cents?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  revenue_cents?: Maybe<Scalars['Int']['output']>;
  rfid_tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Sold_Item_Cost_Min_Fields = {
  __typename?: 'eatfresh_sold_item_cost_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  article_name?: Maybe<Scalars['String']['output']>;
  cost_cents?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  given_id?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  revenue_cents?: Maybe<Scalars['Int']['output']>;
  rfid_tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "eatfresh.sold_item_cost". */
export type Eatfresh_Sold_Item_Cost_Order_By = {
  article_id?: InputMaybe<Order_By>;
  article_name?: InputMaybe<Order_By>;
  cost_cents?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  demo_flag?: InputMaybe<Order_By>;
  ean?: InputMaybe<Order_By>;
  given_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  order_status?: InputMaybe<Order_By>;
  revenue_cents?: InputMaybe<Order_By>;
  rfid_tag_id?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.sold_item_cost" */
export enum Eatfresh_Sold_Item_Cost_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  ArticleName = 'article_name',
  /** column name */
  CostCents = 'cost_cents',
  /** column name */
  Created = 'created',
  /** column name */
  DemoFlag = 'demo_flag',
  /** column name */
  Ean = 'ean',
  /** column name */
  GivenId = 'given_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OrderStatus = 'order_status',
  /** column name */
  RevenueCents = 'revenue_cents',
  /** column name */
  RfidTagId = 'rfid_tag_id'
}

/** aggregate stddev on columns */
export type Eatfresh_Sold_Item_Cost_Stddev_Fields = {
  __typename?: 'eatfresh_sold_item_cost_stddev_fields';
  cost_cents?: Maybe<Scalars['Float']['output']>;
  revenue_cents?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Sold_Item_Cost_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_sold_item_cost_stddev_pop_fields';
  cost_cents?: Maybe<Scalars['Float']['output']>;
  revenue_cents?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Sold_Item_Cost_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_sold_item_cost_stddev_samp_fields';
  cost_cents?: Maybe<Scalars['Float']['output']>;
  revenue_cents?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_sold_item_cost" */
export type Eatfresh_Sold_Item_Cost_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Sold_Item_Cost_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Sold_Item_Cost_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_name?: InputMaybe<Scalars['String']['input']>;
  cost_cents?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  demo_flag?: InputMaybe<Scalars['Boolean']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  given_id?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  order_status?: InputMaybe<Scalars['String']['input']>;
  revenue_cents?: InputMaybe<Scalars['Int']['input']>;
  rfid_tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Sold_Item_Cost_Sum_Fields = {
  __typename?: 'eatfresh_sold_item_cost_sum_fields';
  cost_cents?: Maybe<Scalars['Int']['output']>;
  revenue_cents?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Eatfresh_Sold_Item_Cost_Var_Pop_Fields = {
  __typename?: 'eatfresh_sold_item_cost_var_pop_fields';
  cost_cents?: Maybe<Scalars['Float']['output']>;
  revenue_cents?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Sold_Item_Cost_Var_Samp_Fields = {
  __typename?: 'eatfresh_sold_item_cost_var_samp_fields';
  cost_cents?: Maybe<Scalars['Float']['output']>;
  revenue_cents?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Sold_Item_Cost_Variance_Fields = {
  __typename?: 'eatfresh_sold_item_cost_variance_fields';
  cost_cents?: Maybe<Scalars['Float']['output']>;
  revenue_cents?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem = {
  __typename?: 'eatfresh_supplier_problem';
  created_at: Scalars['timestamp']['output'];
  damaged_quantity?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  supplier_problem_to_files: Array<Eatfresh_Supplier_Problem_To_File>;
  /** An aggregate relationship */
  supplier_problem_to_files_aggregate: Eatfresh_Supplier_Problem_To_File_Aggregate;
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  warehouse_order_receipt: Eatfresh_Warehouse_Order_Receipt;
  warehouse_order_receipt_id: Scalars['uuid']['output'];
  /** An object relationship */
  warehouse_order_receipt_position: Eatfresh_Warehouse_Order_Receipt_Position;
  warehouse_order_receipt_position_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_ProblemSupplier_Problem_To_FilesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};


/** columns and relationships of "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_ProblemSupplier_Problem_To_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};

/** aggregated selection of "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Aggregate = {
  __typename?: 'eatfresh_supplier_problem_aggregate';
  aggregate?: Maybe<Eatfresh_Supplier_Problem_Aggregate_Fields>;
  nodes: Array<Eatfresh_Supplier_Problem>;
};

export type Eatfresh_Supplier_Problem_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Supplier_Problem_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Supplier_Problem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Aggregate_Fields = {
  __typename?: 'eatfresh_supplier_problem_aggregate_fields';
  avg?: Maybe<Eatfresh_Supplier_Problem_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Supplier_Problem_Max_Fields>;
  min?: Maybe<Eatfresh_Supplier_Problem_Min_Fields>;
  stddev?: Maybe<Eatfresh_Supplier_Problem_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Supplier_Problem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Supplier_Problem_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Supplier_Problem_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Supplier_Problem_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Supplier_Problem_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Supplier_Problem_Variance_Fields>;
};


/** aggregate fields of "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Supplier_Problem_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Supplier_Problem_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Supplier_Problem_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Supplier_Problem_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Supplier_Problem_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Supplier_Problem_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Supplier_Problem_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Supplier_Problem_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Supplier_Problem_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Supplier_Problem_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Supplier_Problem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Supplier_Problem_Avg_Fields = {
  __typename?: 'eatfresh_supplier_problem_avg_fields';
  damaged_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Avg_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.supplier_problem". All fields are combined with a logical 'AND'. */
export type Eatfresh_Supplier_Problem_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Supplier_Problem_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Supplier_Problem_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  damaged_quantity?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_problem_to_files?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
  supplier_problem_to_files_aggregate?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  warehouse_order_receipt_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse_order_receipt_position?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
  warehouse_order_receipt_position_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.supplier_problem" */
export enum Eatfresh_Supplier_Problem_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupplierProblemPkey = 'supplier_problem_pkey',
  /** unique or primary key constraint on columns "warehouse_order_receipt_position_id" */
  SupplierProblemWarehouseOrderReceiptPositionIdKey = 'supplier_problem_warehouse_order_receipt_position_id_key'
}

/** input type for incrementing numeric columns in table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Inc_Input = {
  damaged_quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  damaged_quantity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_problem_to_files?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Obj_Rel_Insert_Input>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_position?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Obj_Rel_Insert_Input>;
  warehouse_order_receipt_position_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Supplier_Problem_Max_Fields = {
  __typename?: 'eatfresh_supplier_problem_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  damaged_quantity?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_order_receipt_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_order_receipt_position_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  damaged_quantity?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_position_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Supplier_Problem_Min_Fields = {
  __typename?: 'eatfresh_supplier_problem_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  damaged_quantity?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_order_receipt_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_order_receipt_position_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  damaged_quantity?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_position_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Mutation_Response = {
  __typename?: 'eatfresh_supplier_problem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Supplier_Problem>;
};

/** input type for inserting object relation for remote table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Obj_Rel_Insert_Input = {
  data: Eatfresh_Supplier_Problem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_On_Conflict = {
  constraint: Eatfresh_Supplier_Problem_Constraint;
  update_columns?: Array<Eatfresh_Supplier_Problem_Update_Column>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.supplier_problem". */
export type Eatfresh_Supplier_Problem_Order_By = {
  created_at?: InputMaybe<Order_By>;
  damaged_quantity?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  supplier_problem_to_files_aggregate?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_position?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>;
  warehouse_order_receipt_position_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.supplier_problem */
export type Eatfresh_Supplier_Problem_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.supplier_problem" */
export enum Eatfresh_Supplier_Problem_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DamagedQuantity = 'damaged_quantity',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseOrderReceiptId = 'warehouse_order_receipt_id',
  /** column name */
  WarehouseOrderReceiptPositionId = 'warehouse_order_receipt_position_id'
}

/** input type for updating data in table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  damaged_quantity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_position_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Supplier_Problem_Stddev_Fields = {
  __typename?: 'eatfresh_supplier_problem_stddev_fields';
  damaged_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Stddev_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Supplier_Problem_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_supplier_problem_stddev_pop_fields';
  damaged_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Stddev_Pop_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Supplier_Problem_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_supplier_problem_stddev_samp_fields';
  damaged_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Stddev_Samp_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_supplier_problem" */
export type Eatfresh_Supplier_Problem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Supplier_Problem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Supplier_Problem_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  damaged_quantity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_position_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Supplier_Problem_Sum_Fields = {
  __typename?: 'eatfresh_supplier_problem_sum_fields';
  damaged_quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Sum_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File = {
  __typename?: 'eatfresh_supplier_problem_to_file';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  supplier_problem: Eatfresh_Supplier_Problem;
  supplier_problem_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  uploaded_file: Eatfresh_Uploaded_File;
  uploaded_file_id: Scalars['uuid']['output'];
};

/** aggregated selection of "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Aggregate = {
  __typename?: 'eatfresh_supplier_problem_to_file_aggregate';
  aggregate?: Maybe<Eatfresh_Supplier_Problem_To_File_Aggregate_Fields>;
  nodes: Array<Eatfresh_Supplier_Problem_To_File>;
};

export type Eatfresh_Supplier_Problem_To_File_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Supplier_Problem_To_File_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Aggregate_Fields = {
  __typename?: 'eatfresh_supplier_problem_to_file_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Supplier_Problem_To_File_Max_Fields>;
  min?: Maybe<Eatfresh_Supplier_Problem_To_File_Min_Fields>;
};


/** aggregate fields of "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Supplier_Problem_To_File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_To_File_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.supplier_problem_to_file". All fields are combined with a logical 'AND'. */
export type Eatfresh_Supplier_Problem_To_File_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_problem?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
  supplier_problem_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  uploaded_file_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.supplier_problem_to_file" */
export enum Eatfresh_Supplier_Problem_To_File_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupplierProblemToFilePkey = 'supplier_problem_to_file_pkey',
  /** unique or primary key constraint on columns "uploaded_file_id" */
  SupplierProblemToFileUploadedFileIdKey = 'supplier_problem_to_file_uploaded_file_id_key'
}

/** input type for inserting data into table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_problem?: InputMaybe<Eatfresh_Supplier_Problem_Obj_Rel_Insert_Input>;
  supplier_problem_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Obj_Rel_Insert_Input>;
  uploaded_file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Supplier_Problem_To_File_Max_Fields = {
  __typename?: 'eatfresh_supplier_problem_to_file_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  supplier_problem_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uploaded_file_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  supplier_problem_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_file_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Supplier_Problem_To_File_Min_Fields = {
  __typename?: 'eatfresh_supplier_problem_to_file_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  supplier_problem_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uploaded_file_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  supplier_problem_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_file_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Mutation_Response = {
  __typename?: 'eatfresh_supplier_problem_to_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Supplier_Problem_To_File>;
};

/** input type for inserting object relation for remote table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Obj_Rel_Insert_Input = {
  data: Eatfresh_Supplier_Problem_To_File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_To_File_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_On_Conflict = {
  constraint: Eatfresh_Supplier_Problem_To_File_Constraint;
  update_columns?: Array<Eatfresh_Supplier_Problem_To_File_Update_Column>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.supplier_problem_to_file". */
export type Eatfresh_Supplier_Problem_To_File_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  supplier_problem?: InputMaybe<Eatfresh_Supplier_Problem_Order_By>;
  supplier_problem_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Order_By>;
  uploaded_file_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.supplier_problem_to_file */
export type Eatfresh_Supplier_Problem_To_File_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.supplier_problem_to_file" */
export enum Eatfresh_Supplier_Problem_To_File_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SupplierProblemId = 'supplier_problem_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedFileId = 'uploaded_file_id'
}

/** input type for updating data in table "eatfresh.supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_problem_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uploaded_file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_supplier_problem_to_file" */
export type Eatfresh_Supplier_Problem_To_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Supplier_Problem_To_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Supplier_Problem_To_File_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_problem_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uploaded_file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.supplier_problem_to_file" */
export enum Eatfresh_Supplier_Problem_To_File_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SupplierProblemId = 'supplier_problem_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedFileId = 'uploaded_file_id'
}

export type Eatfresh_Supplier_Problem_To_File_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Supplier_Problem_To_File_Bool_Exp;
};

/** update columns of table "eatfresh.supplier_problem" */
export enum Eatfresh_Supplier_Problem_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DamagedQuantity = 'damaged_quantity',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseOrderReceiptId = 'warehouse_order_receipt_id',
  /** column name */
  WarehouseOrderReceiptPositionId = 'warehouse_order_receipt_position_id'
}

export type Eatfresh_Supplier_Problem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Supplier_Problem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Supplier_Problem_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Supplier_Problem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Supplier_Problem_Var_Pop_Fields = {
  __typename?: 'eatfresh_supplier_problem_var_pop_fields';
  damaged_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Var_Pop_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Supplier_Problem_Var_Samp_Fields = {
  __typename?: 'eatfresh_supplier_problem_var_samp_fields';
  damaged_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Var_Samp_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Supplier_Problem_Variance_Fields = {
  __typename?: 'eatfresh_supplier_problem_variance_fields';
  damaged_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.supplier_problem" */
export type Eatfresh_Supplier_Problem_Variance_Order_By = {
  damaged_quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs = {
  __typename?: 'eatfresh_transaction_logs';
  code: Scalars['String']['output'];
  cost: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer_order?: Maybe<Eatfresh_Customer_Order>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  route: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Aggregate = {
  __typename?: 'eatfresh_transaction_logs_aggregate';
  aggregate?: Maybe<Eatfresh_Transaction_Logs_Aggregate_Fields>;
  nodes: Array<Eatfresh_Transaction_Logs>;
};

export type Eatfresh_Transaction_Logs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Transaction_Logs_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Transaction_Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Aggregate_Fields = {
  __typename?: 'eatfresh_transaction_logs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Transaction_Logs_Max_Fields>;
  min?: Maybe<Eatfresh_Transaction_Logs_Min_Fields>;
};


/** aggregate fields of "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Transaction_Logs_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Transaction_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Transaction_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Transaction_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.transaction_logs". All fields are combined with a logical 'AND'. */
export type Eatfresh_Transaction_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Transaction_Logs_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Transaction_Logs_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  cost?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  customer_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.transaction_logs" */
export enum Eatfresh_Transaction_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransactionLogsPkey = 'transaction_logs_pkey'
}

/** input type for inserting data into table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Obj_Rel_Insert_Input>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Transaction_Logs_Max_Fields = {
  __typename?: 'eatfresh_transaction_logs_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Transaction_Logs_Min_Fields = {
  __typename?: 'eatfresh_transaction_logs_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customer_order_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Mutation_Response = {
  __typename?: 'eatfresh_transaction_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Transaction_Logs>;
};

/** on_conflict condition type for table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_On_Conflict = {
  constraint: Eatfresh_Transaction_Logs_Constraint;
  update_columns?: Array<Eatfresh_Transaction_Logs_Update_Column>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.transaction_logs". */
export type Eatfresh_Transaction_Logs_Order_By = {
  code?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customer_order?: InputMaybe<Eatfresh_Customer_Order_Order_By>;
  customer_order_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.transaction_logs */
export type Eatfresh_Transaction_Logs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.transaction_logs" */
export enum Eatfresh_Transaction_Logs_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Cost = 'cost',
  /** column name */
  Created = 'created',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Route = 'route',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "eatfresh.transaction_logs" */
export type Eatfresh_Transaction_Logs_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "eatfresh_transaction_logs" */
export type Eatfresh_Transaction_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Transaction_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Transaction_Logs_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_order_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "eatfresh.transaction_logs" */
export enum Eatfresh_Transaction_Logs_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Cost = 'cost',
  /** column name */
  Created = 'created',
  /** column name */
  CustomerOrderId = 'customer_order_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Route = 'route',
  /** column name */
  Updated = 'updated'
}

export type Eatfresh_Transaction_Logs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Transaction_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Transaction_Logs_Bool_Exp;
};

/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File = {
  __typename?: 'eatfresh_uploaded_file';
  /** An array relationship */
  articles: Array<Eatfresh_Article>;
  /** An aggregate relationship */
  articles_aggregate: Eatfresh_Article_Aggregate;
  basic_user_id?: Maybe<Scalars['uuid']['output']>;
  created: Scalars['timestamptz']['output'];
  file_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  invalid: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  logistics_problem_images: Array<Eatfresh_Logistics_Problem_Image>;
  /** An aggregate relationship */
  logistics_problem_images_aggregate: Eatfresh_Logistics_Problem_Image_Aggregate;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  places: Array<Eatfresh_Place>;
  /** An aggregate relationship */
  places_aggregate: Eatfresh_Place_Aggregate;
  /** An array relationship */
  refills: Array<Eatfresh_Refill>;
  /** An aggregate relationship */
  refills_aggregate: Eatfresh_Refill_Aggregate;
  /** An object relationship */
  supplier_problem_to_file?: Maybe<Eatfresh_Supplier_Problem_To_File>;
  updated: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user_account?: Maybe<Eatfresh_User_Account>;
  /** An array relationship */
  warehouse_order_receipts: Array<Eatfresh_Warehouse_Order_Receipt>;
  /** An aggregate relationship */
  warehouse_order_receipts_aggregate: Eatfresh_Warehouse_Order_Receipt_Aggregate;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileArticlesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileLogistics_Problem_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileLogistics_Problem_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FilePlacesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Place_Order_By>>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FilePlaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Place_Order_By>>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileRefillsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileRefills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileWarehouse_Order_ReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};


/** columns and relationships of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_FileWarehouse_Order_Receipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};

/** aggregated selection of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Aggregate = {
  __typename?: 'eatfresh_uploaded_file_aggregate';
  aggregate?: Maybe<Eatfresh_Uploaded_File_Aggregate_Fields>;
  nodes: Array<Eatfresh_Uploaded_File>;
};

export type Eatfresh_Uploaded_File_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Uploaded_File_Select_Column_Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Uploaded_File_Select_Column_Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Aggregate_Fields = {
  __typename?: 'eatfresh_uploaded_file_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Uploaded_File_Max_Fields>;
  min?: Maybe<Eatfresh_Uploaded_File_Min_Fields>;
};


/** aggregate fields of "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Uploaded_File_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Uploaded_File_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Uploaded_File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Uploaded_File_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.uploaded_file". All fields are combined with a logical 'AND'. */
export type Eatfresh_Uploaded_File_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Uploaded_File_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Uploaded_File_Bool_Exp>>;
  articles?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  articles_aggregate?: InputMaybe<Eatfresh_Article_Aggregate_Bool_Exp>;
  basic_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalid?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  logistics_problem_images?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
  logistics_problem_images_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Image_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  places_aggregate?: InputMaybe<Eatfresh_Place_Aggregate_Bool_Exp>;
  refills?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Bool_Exp>;
  supplier_problem_to_file?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  warehouse_order_receipts?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  warehouse_order_receipts_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.uploaded_file" */
export enum Eatfresh_Uploaded_File_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshUploadedFilePkey = 'eatfresh_uploaded_file_pkey'
}

/** input type for inserting data into table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Insert_Input = {
  articles?: InputMaybe<Eatfresh_Article_Arr_Rel_Insert_Input>;
  basic_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  logistics_problem_images?: InputMaybe<Eatfresh_Logistics_Problem_Image_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  places?: InputMaybe<Eatfresh_Place_Arr_Rel_Insert_Input>;
  refills?: InputMaybe<Eatfresh_Refill_Arr_Rel_Insert_Input>;
  supplier_problem_to_file?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Obj_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  warehouse_order_receipts?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Uploaded_File_Max_Fields = {
  __typename?: 'eatfresh_uploaded_file_max_fields';
  basic_user_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  file_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Max_Order_By = {
  basic_user_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Uploaded_File_Min_Fields = {
  __typename?: 'eatfresh_uploaded_file_min_fields';
  basic_user_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  file_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Min_Order_By = {
  basic_user_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Mutation_Response = {
  __typename?: 'eatfresh_uploaded_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Uploaded_File>;
};

/** input type for inserting object relation for remote table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Obj_Rel_Insert_Input = {
  data: Eatfresh_Uploaded_File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Uploaded_File_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_On_Conflict = {
  constraint: Eatfresh_Uploaded_File_Constraint;
  update_columns?: Array<Eatfresh_Uploaded_File_Update_Column>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.uploaded_file". */
export type Eatfresh_Uploaded_File_Order_By = {
  articles_aggregate?: InputMaybe<Eatfresh_Article_Aggregate_Order_By>;
  basic_user_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalid?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  logistics_problem_images_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Image_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Eatfresh_Place_Aggregate_Order_By>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Order_By>;
  supplier_problem_to_file?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  warehouse_order_receipts_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.uploaded_file */
export type Eatfresh_Uploaded_File_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.uploaded_file" */
export enum Eatfresh_Uploaded_File_Select_Column {
  /** column name */
  BasicUserId = 'basic_user_id',
  /** column name */
  Created = 'created',
  /** column name */
  FileType = 'file_type',
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Path = 'path',
  /** column name */
  Updated = 'updated',
  /** column name */
  Url = 'url'
}

/** select "eatfresh_uploaded_file_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.uploaded_file" */
export enum Eatfresh_Uploaded_File_Select_Column_Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Invalid = 'invalid'
}

/** select "eatfresh_uploaded_file_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.uploaded_file" */
export enum Eatfresh_Uploaded_File_Select_Column_Eatfresh_Uploaded_File_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Invalid = 'invalid'
}

/** input type for updating data in table "eatfresh.uploaded_file" */
export type Eatfresh_Uploaded_File_Set_Input = {
  basic_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_uploaded_file" */
export type Eatfresh_Uploaded_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Uploaded_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Uploaded_File_Stream_Cursor_Value_Input = {
  basic_user_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.uploaded_file" */
export enum Eatfresh_Uploaded_File_Update_Column {
  /** column name */
  BasicUserId = 'basic_user_id',
  /** column name */
  Created = 'created',
  /** column name */
  FileType = 'file_type',
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Path = 'path',
  /** column name */
  Updated = 'updated',
  /** column name */
  Url = 'url'
}

export type Eatfresh_Uploaded_File_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Uploaded_File_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Uploaded_File_Bool_Exp;
};

/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_Account = {
  __typename?: 'eatfresh_user_account';
  active?: Maybe<Scalars['Boolean']['output']>;
  agb_accepted: Scalars['Boolean']['output'];
  /** An array relationship */
  age_verifications: Array<Eatfresh_Age_Verification>;
  /** An aggregate relationship */
  age_verifications_aggregate: Eatfresh_Age_Verification_Aggregate;
  /** An array relationship */
  article_labeling_processes: Array<Eatfresh_Article_Labeling_Process>;
  /** An aggregate relationship */
  article_labeling_processes_aggregate: Eatfresh_Article_Labeling_Process_Aggregate;
  /** An array relationship */
  authenticators: Array<Eatfresh_Authenticators>;
  /** An aggregate relationship */
  authenticators_aggregate: Eatfresh_Authenticators_Aggregate;
  /** An object relationship */
  b2b_customer?: Maybe<Eatfresh_B2b_Customer>;
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  basicUserTypeByBasicUserType: Eatfresh_Basic_User_Type;
  basic_user_type: Eatfresh_Basic_User_Type_Enum;
  /** True while a throwaway account is awaiting completion of biometric signup; used to distinguish new signups from existing anonymous checkout accounts during cancel */
  biometric_signup_pending: Scalars['Boolean']['output'];
  biometrics?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  commissioning_processes: Array<Eatfresh_Commissioning_Process>;
  /** An aggregate relationship */
  commissioning_processes_aggregate: Eatfresh_Commissioning_Process_Aggregate;
  /** An array relationship */
  confirmed_price_change_positions: Array<Eatfresh_Price_Change_Position>;
  /** An aggregate relationship */
  confirmed_price_change_positions_aggregate: Eatfresh_Price_Change_Position_Aggregate;
  contact_accepted?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['timestamptz']['output'];
  current_challenge?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  customer?: Maybe<Eatfresh_Customer>;
  /** An array relationship */
  customer_orders: Array<Eatfresh_Customer_Order>;
  /** An aggregate relationship */
  customer_orders_aggregate: Eatfresh_Customer_Order_Aggregate;
  /** An array relationship */
  easy_refill_permissions: Array<Eatfresh_Easy_Refill_Permission>;
  /** An aggregate relationship */
  easy_refill_permissions_aggregate: Eatfresh_Easy_Refill_Permission_Aggregate;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  has_password?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  logistics_problems: Array<Eatfresh_Logistics_Problem>;
  /** An aggregate relationship */
  logistics_problems_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  password?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  passwordResetTokensByUserEmail: Array<Eatfresh_Password_Reset_Token>;
  /** An aggregate relationship */
  passwordResetTokensByUserEmail_aggregate: Eatfresh_Password_Reset_Token_Aggregate;
  /** An array relationship */
  password_reset_tokens: Array<Eatfresh_Password_Reset_Token>;
  /** An aggregate relationship */
  password_reset_tokens_aggregate: Eatfresh_Password_Reset_Token_Aggregate;
  /** An array relationship */
  payment_methods: Array<Eatfresh_Payment_Method>;
  /** An aggregate relationship */
  payment_methods_aggregate: Eatfresh_Payment_Method_Aggregate;
  /** An array relationship */
  refills: Array<Eatfresh_Refill>;
  /** An aggregate relationship */
  refills_aggregate: Eatfresh_Refill_Aggregate;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  requires_password_change?: Maybe<Scalars['Boolean']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  updated: Scalars['timestamptz']['output'];
  /** An array relationship */
  uploaded_files: Array<Eatfresh_Uploaded_File>;
  /** An aggregate relationship */
  uploaded_files_aggregate: Eatfresh_Uploaded_File_Aggregate;
  /** An array relationship */
  warehouse_assignments: Array<Eatfresh_Warehouse_Assignment>;
  /** An aggregate relationship */
  warehouse_assignments_aggregate: Eatfresh_Warehouse_Assignment_Aggregate;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountAge_VerificationsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountAge_Verifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountArticle_Labeling_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountArticle_Labeling_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountAuthenticatorsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Authenticators_Order_By>>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountAuthenticators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Authenticators_Order_By>>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountCommissioning_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountCommissioning_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountConfirmed_Price_Change_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountConfirmed_Price_Change_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountCustomer_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountCustomer_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountEasy_Refill_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountEasy_Refill_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountLogistics_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountLogistics_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountPasswordResetTokensByUserEmailArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountPasswordResetTokensByUserEmail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountPassword_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountPassword_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountRefillsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountRefills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountUploaded_FilesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Uploaded_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountUploaded_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Uploaded_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountWarehouse_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.user_account" */
export type Eatfresh_User_AccountWarehouse_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};

/** aggregated selection of "eatfresh.user_account" */
export type Eatfresh_User_Account_Aggregate = {
  __typename?: 'eatfresh_user_account_aggregate';
  aggregate?: Maybe<Eatfresh_User_Account_Aggregate_Fields>;
  nodes: Array<Eatfresh_User_Account>;
};

export type Eatfresh_User_Account_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_User_Account_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_User_Account_Select_Column_Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_User_Account_Select_Column_Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_User_Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.user_account" */
export type Eatfresh_User_Account_Aggregate_Fields = {
  __typename?: 'eatfresh_user_account_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_User_Account_Max_Fields>;
  min?: Maybe<Eatfresh_User_Account_Min_Fields>;
};


/** aggregate fields of "eatfresh.user_account" */
export type Eatfresh_User_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.user_account" */
export type Eatfresh_User_Account_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_User_Account_Max_Order_By>;
  min?: InputMaybe<Eatfresh_User_Account_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.user_account" */
export type Eatfresh_User_Account_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_User_Account_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_User_Account_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.user_account". All fields are combined with a logical 'AND'. */
export type Eatfresh_User_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_User_Account_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_User_Account_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  agb_accepted?: InputMaybe<Boolean_Comparison_Exp>;
  age_verifications?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
  age_verifications_aggregate?: InputMaybe<Eatfresh_Age_Verification_Aggregate_Bool_Exp>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp>;
  authenticators?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
  authenticators_aggregate?: InputMaybe<Eatfresh_Authenticators_Aggregate_Bool_Exp>;
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
  b2b_customer_id?: InputMaybe<Uuid_Comparison_Exp>;
  basicUserTypeByBasicUserType?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
  basic_user_type?: InputMaybe<Eatfresh_Basic_User_Type_Enum_Comparison_Exp>;
  biometric_signup_pending?: InputMaybe<Boolean_Comparison_Exp>;
  biometrics?: InputMaybe<Boolean_Comparison_Exp>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Bool_Exp>;
  confirmed_price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
  confirmed_price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Bool_Exp>;
  contact_accepted?: InputMaybe<Boolean_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_challenge?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Bool_Exp>;
  easy_refill_permissions?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
  easy_refill_permissions_aggregate?: InputMaybe<Eatfresh_Easy_Refill_Permission_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  has_password?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  passwordResetTokensByUserEmail?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
  passwordResetTokensByUserEmail_aggregate?: InputMaybe<Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp>;
  password_reset_tokens?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
  password_reset_tokens_aggregate?: InputMaybe<Eatfresh_Password_Reset_Token_Aggregate_Bool_Exp>;
  payment_methods?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Eatfresh_Payment_Method_Aggregate_Bool_Exp>;
  refills?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Bool_Exp>;
  registered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  requires_password_change?: InputMaybe<Boolean_Comparison_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploaded_files?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  uploaded_files_aggregate?: InputMaybe<Eatfresh_Uploaded_File_Aggregate_Bool_Exp>;
  warehouse_assignments?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
  warehouse_assignments_aggregate?: InputMaybe<Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.user_account" */
export enum Eatfresh_User_Account_Constraint {
  /** unique or primary key constraint on columns "id" */
  EatfreshUserAccountPkey = 'eatfresh_user_account_pkey',
  /** unique or primary key constraint on columns "email" */
  UserAccountEmailKey = 'user_account_email_key',
  /** unique or primary key constraint on columns "stripe_customer_id" */
  UserAccountStripeCustomerIdKey = 'user_account_stripe_customer_id_key'
}

/** input type for inserting data into table "eatfresh.user_account" */
export type Eatfresh_User_Account_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agb_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  age_verifications?: InputMaybe<Eatfresh_Age_Verification_Arr_Rel_Insert_Input>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Arr_Rel_Insert_Input>;
  authenticators?: InputMaybe<Eatfresh_Authenticators_Arr_Rel_Insert_Input>;
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Obj_Rel_Insert_Input>;
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  basicUserTypeByBasicUserType?: InputMaybe<Eatfresh_Basic_User_Type_Obj_Rel_Insert_Input>;
  basic_user_type?: InputMaybe<Eatfresh_Basic_User_Type_Enum>;
  /** True while a throwaway account is awaiting completion of biometric signup; used to distinguish new signups from existing anonymous checkout accounts during cancel */
  biometric_signup_pending?: InputMaybe<Scalars['Boolean']['input']>;
  biometrics?: InputMaybe<Scalars['Boolean']['input']>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Arr_Rel_Insert_Input>;
  confirmed_price_change_positions?: InputMaybe<Eatfresh_Price_Change_Position_Arr_Rel_Insert_Input>;
  contact_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  current_challenge?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Eatfresh_Customer_Obj_Rel_Insert_Input>;
  customer_orders?: InputMaybe<Eatfresh_Customer_Order_Arr_Rel_Insert_Input>;
  easy_refill_permissions?: InputMaybe<Eatfresh_Easy_Refill_Permission_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_password?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordResetTokensByUserEmail?: InputMaybe<Eatfresh_Password_Reset_Token_Arr_Rel_Insert_Input>;
  password_reset_tokens?: InputMaybe<Eatfresh_Password_Reset_Token_Arr_Rel_Insert_Input>;
  payment_methods?: InputMaybe<Eatfresh_Payment_Method_Arr_Rel_Insert_Input>;
  refills?: InputMaybe<Eatfresh_Refill_Arr_Rel_Insert_Input>;
  registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requires_password_change?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  uploaded_files?: InputMaybe<Eatfresh_Uploaded_File_Arr_Rel_Insert_Input>;
  warehouse_assignments?: InputMaybe<Eatfresh_Warehouse_Assignment_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_User_Account_Max_Fields = {
  __typename?: 'eatfresh_user_account_max_fields';
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  current_challenge?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eatfresh.user_account" */
export type Eatfresh_User_Account_Max_Order_By = {
  b2b_customer_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  current_challenge?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_User_Account_Min_Fields = {
  __typename?: 'eatfresh_user_account_min_fields';
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  current_challenge?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eatfresh.user_account" */
export type Eatfresh_User_Account_Min_Order_By = {
  b2b_customer_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  current_challenge?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.user_account" */
export type Eatfresh_User_Account_Mutation_Response = {
  __typename?: 'eatfresh_user_account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_User_Account>;
};

/** input type for inserting object relation for remote table "eatfresh.user_account" */
export type Eatfresh_User_Account_Obj_Rel_Insert_Input = {
  data: Eatfresh_User_Account_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_User_Account_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.user_account" */
export type Eatfresh_User_Account_On_Conflict = {
  constraint: Eatfresh_User_Account_Constraint;
  update_columns?: Array<Eatfresh_User_Account_Update_Column>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.user_account". */
export type Eatfresh_User_Account_Order_By = {
  active?: InputMaybe<Order_By>;
  agb_accepted?: InputMaybe<Order_By>;
  age_verifications_aggregate?: InputMaybe<Eatfresh_Age_Verification_Aggregate_Order_By>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Order_By>;
  authenticators_aggregate?: InputMaybe<Eatfresh_Authenticators_Aggregate_Order_By>;
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Order_By>;
  b2b_customer_id?: InputMaybe<Order_By>;
  basicUserTypeByBasicUserType?: InputMaybe<Eatfresh_Basic_User_Type_Order_By>;
  basic_user_type?: InputMaybe<Order_By>;
  biometric_signup_pending?: InputMaybe<Order_By>;
  biometrics?: InputMaybe<Order_By>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Order_By>;
  confirmed_price_change_positions_aggregate?: InputMaybe<Eatfresh_Price_Change_Position_Aggregate_Order_By>;
  contact_accepted?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  current_challenge?: InputMaybe<Order_By>;
  customer?: InputMaybe<Eatfresh_Customer_Order_By>;
  customer_orders_aggregate?: InputMaybe<Eatfresh_Customer_Order_Aggregate_Order_By>;
  easy_refill_permissions_aggregate?: InputMaybe<Eatfresh_Easy_Refill_Permission_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  has_password?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  passwordResetTokensByUserEmail_aggregate?: InputMaybe<Eatfresh_Password_Reset_Token_Aggregate_Order_By>;
  password_reset_tokens_aggregate?: InputMaybe<Eatfresh_Password_Reset_Token_Aggregate_Order_By>;
  payment_methods_aggregate?: InputMaybe<Eatfresh_Payment_Method_Aggregate_Order_By>;
  refills_aggregate?: InputMaybe<Eatfresh_Refill_Aggregate_Order_By>;
  registered_at?: InputMaybe<Order_By>;
  requires_password_change?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  uploaded_files_aggregate?: InputMaybe<Eatfresh_Uploaded_File_Aggregate_Order_By>;
  warehouse_assignments_aggregate?: InputMaybe<Eatfresh_Warehouse_Assignment_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.user_account */
export type Eatfresh_User_Account_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.user_account" */
export enum Eatfresh_User_Account_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  AgbAccepted = 'agb_accepted',
  /** column name */
  B2bCustomerId = 'b2b_customer_id',
  /** column name */
  BasicUserType = 'basic_user_type',
  /** column name */
  BiometricSignupPending = 'biometric_signup_pending',
  /** column name */
  Biometrics = 'biometrics',
  /** column name */
  ContactAccepted = 'contact_accepted',
  /** column name */
  Created = 'created',
  /** column name */
  CurrentChallenge = 'current_challenge',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasPassword = 'has_password',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  RequiresPasswordChange = 'requires_password_change',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Updated = 'updated'
}

/** select "eatfresh_user_account_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.user_account" */
export enum Eatfresh_User_Account_Select_Column_Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  AgbAccepted = 'agb_accepted',
  /** column name */
  BiometricSignupPending = 'biometric_signup_pending',
  /** column name */
  Biometrics = 'biometrics',
  /** column name */
  ContactAccepted = 'contact_accepted',
  /** column name */
  HasPassword = 'has_password',
  /** column name */
  RequiresPasswordChange = 'requires_password_change'
}

/** select "eatfresh_user_account_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.user_account" */
export enum Eatfresh_User_Account_Select_Column_Eatfresh_User_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  AgbAccepted = 'agb_accepted',
  /** column name */
  BiometricSignupPending = 'biometric_signup_pending',
  /** column name */
  Biometrics = 'biometrics',
  /** column name */
  ContactAccepted = 'contact_accepted',
  /** column name */
  HasPassword = 'has_password',
  /** column name */
  RequiresPasswordChange = 'requires_password_change'
}

/** input type for updating data in table "eatfresh.user_account" */
export type Eatfresh_User_Account_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agb_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  basic_user_type?: InputMaybe<Eatfresh_Basic_User_Type_Enum>;
  /** True while a throwaway account is awaiting completion of biometric signup; used to distinguish new signups from existing anonymous checkout accounts during cancel */
  biometric_signup_pending?: InputMaybe<Scalars['Boolean']['input']>;
  biometrics?: InputMaybe<Scalars['Boolean']['input']>;
  contact_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  current_challenge?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_password?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requires_password_change?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "eatfresh_user_account" */
export type Eatfresh_User_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_User_Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_User_Account_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  agb_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  basic_user_type?: InputMaybe<Eatfresh_Basic_User_Type_Enum>;
  /** True while a throwaway account is awaiting completion of biometric signup; used to distinguish new signups from existing anonymous checkout accounts during cancel */
  biometric_signup_pending?: InputMaybe<Scalars['Boolean']['input']>;
  biometrics?: InputMaybe<Scalars['Boolean']['input']>;
  contact_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  current_challenge?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_password?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requires_password_change?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "eatfresh.user_account" */
export enum Eatfresh_User_Account_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  AgbAccepted = 'agb_accepted',
  /** column name */
  B2bCustomerId = 'b2b_customer_id',
  /** column name */
  BasicUserType = 'basic_user_type',
  /** column name */
  BiometricSignupPending = 'biometric_signup_pending',
  /** column name */
  Biometrics = 'biometrics',
  /** column name */
  ContactAccepted = 'contact_accepted',
  /** column name */
  Created = 'created',
  /** column name */
  CurrentChallenge = 'current_challenge',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasPassword = 'has_password',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  RequiresPasswordChange = 'requires_password_change',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Updated = 'updated'
}

export type Eatfresh_User_Account_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_User_Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_User_Account_Bool_Exp;
};

/** columns and relationships of "eatfresh.vat_category" */
export type Eatfresh_Vat_Category = {
  __typename?: 'eatfresh_vat_category';
  /** An array relationship */
  article_details: Array<Eatfresh_Article_Details>;
  /** An aggregate relationship */
  article_details_aggregate: Eatfresh_Article_Details_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  order_extras: Array<Eatfresh_Order_Extra>;
  /** An aggregate relationship */
  order_extras_aggregate: Eatfresh_Order_Extra_Aggregate;
  rate: Scalars['Float']['output'];
};


/** columns and relationships of "eatfresh.vat_category" */
export type Eatfresh_Vat_CategoryArticle_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


/** columns and relationships of "eatfresh.vat_category" */
export type Eatfresh_Vat_CategoryArticle_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


/** columns and relationships of "eatfresh.vat_category" */
export type Eatfresh_Vat_CategoryOrder_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};


/** columns and relationships of "eatfresh.vat_category" */
export type Eatfresh_Vat_CategoryOrder_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};

/** aggregated selection of "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Aggregate = {
  __typename?: 'eatfresh_vat_category_aggregate';
  aggregate?: Maybe<Eatfresh_Vat_Category_Aggregate_Fields>;
  nodes: Array<Eatfresh_Vat_Category>;
};

/** aggregate fields of "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Aggregate_Fields = {
  __typename?: 'eatfresh_vat_category_aggregate_fields';
  avg?: Maybe<Eatfresh_Vat_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Vat_Category_Max_Fields>;
  min?: Maybe<Eatfresh_Vat_Category_Min_Fields>;
  stddev?: Maybe<Eatfresh_Vat_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Vat_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Vat_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Vat_Category_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Vat_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Vat_Category_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Vat_Category_Variance_Fields>;
};


/** aggregate fields of "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Vat_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Eatfresh_Vat_Category_Avg_Fields = {
  __typename?: 'eatfresh_vat_category_avg_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eatfresh.vat_category". All fields are combined with a logical 'AND'. */
export type Eatfresh_Vat_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Vat_Category_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Vat_Category_Bool_Exp>>;
  article_details?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  article_details_aggregate?: InputMaybe<Eatfresh_Article_Details_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_extras?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
  order_extras_aggregate?: InputMaybe<Eatfresh_Order_Extra_Aggregate_Bool_Exp>;
  rate?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.vat_category" */
export enum Eatfresh_Vat_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  VatCategoryPkey = 'vat_category_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Inc_Input = {
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Insert_Input = {
  article_details?: InputMaybe<Eatfresh_Article_Details_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_extras?: InputMaybe<Eatfresh_Order_Extra_Arr_Rel_Insert_Input>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Vat_Category_Max_Fields = {
  __typename?: 'eatfresh_vat_category_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Vat_Category_Min_Fields = {
  __typename?: 'eatfresh_vat_category_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** response of any mutation on the table "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Mutation_Response = {
  __typename?: 'eatfresh_vat_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Vat_Category>;
};

/** input type for inserting object relation for remote table "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Obj_Rel_Insert_Input = {
  data: Eatfresh_Vat_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Vat_Category_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_On_Conflict = {
  constraint: Eatfresh_Vat_Category_Constraint;
  update_columns?: Array<Eatfresh_Vat_Category_Update_Column>;
  where?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.vat_category". */
export type Eatfresh_Vat_Category_Order_By = {
  article_details_aggregate?: InputMaybe<Eatfresh_Article_Details_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_extras_aggregate?: InputMaybe<Eatfresh_Order_Extra_Aggregate_Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.vat_category */
export type Eatfresh_Vat_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.vat_category" */
export enum Eatfresh_Vat_Category_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Rate = 'rate'
}

/** input type for updating data in table "eatfresh.vat_category" */
export type Eatfresh_Vat_Category_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Vat_Category_Stddev_Fields = {
  __typename?: 'eatfresh_vat_category_stddev_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Vat_Category_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_vat_category_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Vat_Category_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_vat_category_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eatfresh_vat_category" */
export type Eatfresh_Vat_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Vat_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Vat_Category_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Vat_Category_Sum_Fields = {
  __typename?: 'eatfresh_vat_category_sum_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "eatfresh.vat_category" */
export enum Eatfresh_Vat_Category_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Rate = 'rate'
}

export type Eatfresh_Vat_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Vat_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Vat_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Vat_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Vat_Category_Var_Pop_Fields = {
  __typename?: 'eatfresh_vat_category_var_pop_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Vat_Category_Var_Samp_Fields = {
  __typename?: 'eatfresh_vat_category_var_samp_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Eatfresh_Vat_Category_Variance_Fields = {
  __typename?: 'eatfresh_vat_category_variance_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral = {
  __typename?: 'eatfresh_vitamin_mineral';
  /** An object relationship */
  article_detail: Eatfresh_Article_Details;
  article_details_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Aggregate = {
  __typename?: 'eatfresh_vitamin_mineral_aggregate';
  aggregate?: Maybe<Eatfresh_Vitamin_Mineral_Aggregate_Fields>;
  nodes: Array<Eatfresh_Vitamin_Mineral>;
};

export type Eatfresh_Vitamin_Mineral_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Vitamin_Mineral_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Vitamin_Mineral_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Aggregate_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_aggregate_fields';
  avg?: Maybe<Eatfresh_Vitamin_Mineral_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Vitamin_Mineral_Max_Fields>;
  min?: Maybe<Eatfresh_Vitamin_Mineral_Min_Fields>;
  stddev?: Maybe<Eatfresh_Vitamin_Mineral_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Vitamin_Mineral_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Vitamin_Mineral_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Vitamin_Mineral_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Vitamin_Mineral_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Vitamin_Mineral_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Vitamin_Mineral_Variance_Fields>;
};


/** aggregate fields of "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Vitamin_Mineral_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Vitamin_Mineral_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Vitamin_Mineral_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Vitamin_Mineral_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Vitamin_Mineral_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Vitamin_Mineral_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Vitamin_Mineral_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Vitamin_Mineral_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Vitamin_Mineral_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Vitamin_Mineral_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Vitamin_Mineral_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Vitamin_Mineral_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Vitamin_Mineral_Avg_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_avg_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Avg_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.vitamin_mineral". All fields are combined with a logical 'AND'. */
export type Eatfresh_Vitamin_Mineral_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Bool_Exp>>;
  article_detail?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
  article_details_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Float_Comparison_Exp>;
  weight?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.vitamin_mineral" */
export enum Eatfresh_Vitamin_Mineral_Constraint {
  /** unique or primary key constraint on columns "id" */
  VitaminMineralPk = 'vitamin_mineral_pk'
}

/** input type for incrementing numeric columns in table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Inc_Input = {
  percentage?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Insert_Input = {
  article_detail?: InputMaybe<Eatfresh_Article_Details_Obj_Rel_Insert_Input>;
  article_details_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Vitamin_Mineral_Max_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_max_fields';
  article_details_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Max_Order_By = {
  article_details_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Vitamin_Mineral_Min_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_min_fields';
  article_details_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Min_Order_By = {
  article_details_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Mutation_Response = {
  __typename?: 'eatfresh_vitamin_mineral_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Vitamin_Mineral>;
};

/** on_conflict condition type for table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_On_Conflict = {
  constraint: Eatfresh_Vitamin_Mineral_Constraint;
  update_columns?: Array<Eatfresh_Vitamin_Mineral_Update_Column>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.vitamin_mineral". */
export type Eatfresh_Vitamin_Mineral_Order_By = {
  article_detail?: InputMaybe<Eatfresh_Article_Details_Order_By>;
  article_details_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.vitamin_mineral */
export type Eatfresh_Vitamin_Mineral_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.vitamin_mineral" */
export enum Eatfresh_Vitamin_Mineral_Select_Column {
  /** column name */
  ArticleDetailsId = 'article_details_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Set_Input = {
  article_details_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Vitamin_Mineral_Stddev_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_stddev_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Stddev_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Vitamin_Mineral_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_stddev_pop_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Stddev_Pop_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Vitamin_Mineral_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_stddev_samp_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Stddev_Samp_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Vitamin_Mineral_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Vitamin_Mineral_Stream_Cursor_Value_Input = {
  article_details_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Vitamin_Mineral_Sum_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_sum_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Sum_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.vitamin_mineral" */
export enum Eatfresh_Vitamin_Mineral_Update_Column {
  /** column name */
  ArticleDetailsId = 'article_details_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  Weight = 'weight'
}

export type Eatfresh_Vitamin_Mineral_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Vitamin_Mineral_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Vitamin_Mineral_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Vitamin_Mineral_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Vitamin_Mineral_Var_Pop_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_var_pop_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Var_Pop_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Vitamin_Mineral_Var_Samp_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_var_samp_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Var_Samp_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Vitamin_Mineral_Variance_Fields = {
  __typename?: 'eatfresh_vitamin_mineral_variance_fields';
  percentage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.vitamin_mineral" */
export type Eatfresh_Vitamin_Mineral_Variance_Order_By = {
  percentage?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_Warehouse = {
  __typename?: 'eatfresh_warehouse';
  /** An array relationship */
  assetTransfersByToWarehouseId: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  assetTransfersByToWarehouseId_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An object relationship */
  b2b_customer?: Maybe<Eatfresh_B2b_Customer>;
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  commissioning_processes: Array<Eatfresh_Commissioning_Process>;
  /** An aggregate relationship */
  commissioning_processes_aggregate: Eatfresh_Commissioning_Process_Aggregate;
  created_at: Scalars['timestamp']['output'];
  external: Scalars['Boolean']['output'];
  /** An array relationship */
  external_warehouse_pallet_spots: Array<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** An aggregate relationship */
  external_warehouse_pallet_spots_aggregate: Eatfresh_External_Warehouse_Pallet_Spot_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  pallet_spots_as_source: Array<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** An aggregate relationship */
  pallet_spots_as_source_aggregate: Eatfresh_External_Warehouse_Pallet_Spot_Aggregate;
  /** An object relationship */
  place: Eatfresh_Place;
  place_id: Scalars['uuid']['output'];
  /** An array relationship */
  rfid_boxes: Array<Eatfresh_Rfid_Box>;
  /** An aggregate relationship */
  rfid_boxes_aggregate: Eatfresh_Rfid_Box_Aggregate;
  /** An array relationship */
  rfid_scanners: Array<Eatfresh_Rfid_Scanner>;
  /** An aggregate relationship */
  rfid_scanners_aggregate: Eatfresh_Rfid_Scanner_Aggregate;
  updated_at: Scalars['timestamp']['output'];
  /** An array relationship */
  warehouse_assignments: Array<Eatfresh_Warehouse_Assignment>;
  /** An aggregate relationship */
  warehouse_assignments_aggregate: Eatfresh_Warehouse_Assignment_Aggregate;
  /** An array relationship */
  warehouse_orders: Array<Eatfresh_Warehouse_Order>;
  /** An aggregate relationship */
  warehouse_orders_aggregate: Eatfresh_Warehouse_Order_Aggregate;
  /** An array relationship */
  warehouse_orders_as_source: Array<Eatfresh_Warehouse_Order>;
  /** An aggregate relationship */
  warehouse_orders_as_source_aggregate: Eatfresh_Warehouse_Order_Aggregate;
  /** An array relationship */
  warehouse_shelves: Array<Eatfresh_Warehouse_Shelf>;
  /** An aggregate relationship */
  warehouse_shelves_aggregate: Eatfresh_Warehouse_Shelf_Aggregate;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseAssetTransfersByToWarehouseIdArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseAssetTransfersByToWarehouseId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseCommissioning_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseCommissioning_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseExternal_Warehouse_Pallet_SpotsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseExternal_Warehouse_Pallet_Spots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehousePallet_Spots_As_SourceArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehousePallet_Spots_As_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseRfid_BoxesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseRfid_Boxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseRfid_ScannersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseRfid_Scanners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_Orders_As_SourceArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_Orders_As_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_ShelvesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse" */
export type Eatfresh_WarehouseWarehouse_Shelves_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};

/** aggregated selection of "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Aggregate = {
  __typename?: 'eatfresh_warehouse_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse>;
};

export type Eatfresh_Warehouse_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Warehouse_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Warehouse_Select_Column_Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Warehouse_Select_Column_Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Warehouse_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Min_Fields>;
};


/** aggregate fields of "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Warehouse_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Warehouse_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Warehouse_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_On_Conflict>;
};

/** columns and relationships of "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment = {
  __typename?: 'eatfresh_warehouse_assignment';
  created_at: Scalars['timestamptz']['output'];
  enforce_quick_labeling: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  user_account: Eatfresh_User_Account;
  user_id: Scalars['uuid']['output'];
  /** An object relationship */
  warehouse?: Maybe<Eatfresh_Warehouse>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Aggregate = {
  __typename?: 'eatfresh_warehouse_assignment_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Assignment_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Assignment>;
};

export type Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Warehouse_Assignment_Select_Column_Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Warehouse_Assignment_Select_Column_Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_assignment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Assignment_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Assignment_Min_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Warehouse_Assignment_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Warehouse_Assignment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Warehouse_Assignment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Assignment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_assignment". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Assignment_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enforce_quick_labeling?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_account?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_assignment" */
export enum Eatfresh_Warehouse_Assignment_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehouseAssignmentPkey = 'warehouse_assignment_pkey',
  /** unique or primary key constraint on columns "user_id" */
  WarehouseAssignmentUserIdKey = 'warehouse_assignment_user_id_key'
}

/** input type for inserting data into table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enforce_quick_labeling?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_account?: InputMaybe<Eatfresh_User_Account_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Assignment_Max_Fields = {
  __typename?: 'eatfresh_warehouse_assignment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Assignment_Min_Fields = {
  __typename?: 'eatfresh_warehouse_assignment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Assignment>;
};

/** on_conflict condition type for table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_On_Conflict = {
  constraint: Eatfresh_Warehouse_Assignment_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Assignment_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_assignment". */
export type Eatfresh_Warehouse_Assignment_Order_By = {
  created_at?: InputMaybe<Order_By>;
  enforce_quick_labeling?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_account?: InputMaybe<Eatfresh_User_Account_Order_By>;
  user_id?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_assignment */
export type Eatfresh_Warehouse_Assignment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.warehouse_assignment" */
export enum Eatfresh_Warehouse_Assignment_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforceQuickLabeling = 'enforce_quick_labeling',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarehouseId = 'warehouse_id'
}

/** select "eatfresh_warehouse_assignment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.warehouse_assignment" */
export enum Eatfresh_Warehouse_Assignment_Select_Column_Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EnforceQuickLabeling = 'enforce_quick_labeling'
}

/** select "eatfresh_warehouse_assignment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.warehouse_assignment" */
export enum Eatfresh_Warehouse_Assignment_Select_Column_Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EnforceQuickLabeling = 'enforce_quick_labeling'
}

/** input type for updating data in table "eatfresh.warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enforce_quick_labeling?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "eatfresh_warehouse_assignment" */
export type Eatfresh_Warehouse_Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Assignment_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enforce_quick_labeling?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "eatfresh.warehouse_assignment" */
export enum Eatfresh_Warehouse_Assignment_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforceQuickLabeling = 'enforce_quick_labeling',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WarehouseId = 'warehouse_id'
}

export type Eatfresh_Warehouse_Assignment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Assignment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Assignment_Bool_Exp;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Bool_Exp>>;
  assetTransfersByToWarehouseId?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  assetTransfersByToWarehouseId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
  b2b_customer_id?: InputMaybe<Uuid_Comparison_Exp>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  external?: InputMaybe<Boolean_Comparison_Exp>;
  external_warehouse_pallet_spots?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
  external_warehouse_pallet_spots_aggregate?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pallet_spots_as_source?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
  pallet_spots_as_source_aggregate?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Bool_Exp>;
  place?: InputMaybe<Eatfresh_Place_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Bool_Exp>;
  rfid_scanners?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  rfid_scanners_aggregate?: InputMaybe<Eatfresh_Rfid_Scanner_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  warehouse_assignments?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
  warehouse_assignments_aggregate?: InputMaybe<Eatfresh_Warehouse_Assignment_Aggregate_Bool_Exp>;
  warehouse_orders?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  warehouse_orders_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Aggregate_Bool_Exp>;
  warehouse_orders_as_source?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  warehouse_orders_as_source_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Aggregate_Bool_Exp>;
  warehouse_shelves?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
  warehouse_shelves_aggregate?: InputMaybe<Eatfresh_Warehouse_Shelf_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse" */
export enum Eatfresh_Warehouse_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehousePkey = 'warehouse_pkey'
}

/** input type for inserting data into table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Insert_Input = {
  assetTransfersByToWarehouseId?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Obj_Rel_Insert_Input>;
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  commissioning_processes?: InputMaybe<Eatfresh_Commissioning_Process_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  external_warehouse_pallet_spots?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pallet_spots_as_source?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Arr_Rel_Insert_Input>;
  place?: InputMaybe<Eatfresh_Place_Obj_Rel_Insert_Input>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  rfid_boxes?: InputMaybe<Eatfresh_Rfid_Box_Arr_Rel_Insert_Input>;
  rfid_scanners?: InputMaybe<Eatfresh_Rfid_Scanner_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_assignments?: InputMaybe<Eatfresh_Warehouse_Assignment_Arr_Rel_Insert_Input>;
  warehouse_orders?: InputMaybe<Eatfresh_Warehouse_Order_Arr_Rel_Insert_Input>;
  warehouse_orders_as_source?: InputMaybe<Eatfresh_Warehouse_Order_Arr_Rel_Insert_Input>;
  warehouse_shelves?: InputMaybe<Eatfresh_Warehouse_Shelf_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Max_Fields = {
  __typename?: 'eatfresh_warehouse_max_fields';
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Max_Order_By = {
  b2b_customer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Min_Fields = {
  __typename?: 'eatfresh_warehouse_min_fields';
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Min_Order_By = {
  b2b_customer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse>;
};

/** input type for inserting object relation for remote table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Obj_Rel_Insert_Input = {
  data: Eatfresh_Warehouse_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_On_Conflict = {
  constraint: Eatfresh_Warehouse_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};

/** columns and relationships of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order = {
  __typename?: 'eatfresh_warehouse_order';
  /** An object relationship */
  b2b_customer?: Maybe<Eatfresh_B2b_Customer>;
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  cost: Scalars['Int']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  logistics_order_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rfid_tags: Array<Eatfresh_Rfid_Tag>;
  /** An aggregate relationship */
  rfid_tags_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  shipped_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  source_warehouse?: Maybe<Eatfresh_Warehouse>;
  source_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  type: Eatfresh_Warehouse_Order_Type_Enum;
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  warehouse: Eatfresh_Warehouse;
  /** An object relationship */
  warehouseOrderStatusByWarehouseOrderStatus: Eatfresh_Warehouse_Order_Status;
  warehouse_id: Scalars['uuid']['output'];
  /** An array relationship */
  warehouse_order_positions: Array<Eatfresh_Warehouse_Order_Position>;
  /** An aggregate relationship */
  warehouse_order_positions_aggregate: Eatfresh_Warehouse_Order_Position_Aggregate;
  /** An object relationship */
  warehouse_order_receipt?: Maybe<Eatfresh_Warehouse_Order_Receipt>;
  /** An array relationship */
  warehouse_order_receipts: Array<Eatfresh_Warehouse_Order_Receipt>;
  /** An aggregate relationship */
  warehouse_order_receipts_aggregate: Eatfresh_Warehouse_Order_Receipt_Aggregate;
  warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum;
};


/** columns and relationships of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_OrderRfid_TagsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_OrderRfid_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_OrderWarehouse_Order_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_OrderWarehouse_Order_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_OrderWarehouse_Order_ReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_OrderWarehouse_Order_Receipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};

/** aggregated selection of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Aggregate = {
  __typename?: 'eatfresh_warehouse_order_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Order_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Order>;
};

export type Eatfresh_Warehouse_Order_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Warehouse_Order_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Warehouse_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_order_aggregate_fields';
  avg?: Maybe<Eatfresh_Warehouse_Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Order_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Order_Min_Fields>;
  stddev?: Maybe<Eatfresh_Warehouse_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Warehouse_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Warehouse_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Warehouse_Order_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Warehouse_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Warehouse_Order_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Warehouse_Order_Variance_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Warehouse_Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Warehouse_Order_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Warehouse_Order_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Warehouse_Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Warehouse_Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Warehouse_Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Warehouse_Order_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Warehouse_Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Warehouse_Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Warehouse_Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Warehouse_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Warehouse_Order_Avg_Fields = {
  __typename?: 'eatfresh_warehouse_order_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_order". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Order_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Order_Bool_Exp>>;
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
  b2b_customer_id?: InputMaybe<Uuid_Comparison_Exp>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logistics_order_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Bool_Exp>;
  shipped_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  source_warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
  supplier?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Eatfresh_Warehouse_Order_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouseOrderStatusByWarehouseOrderStatus?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse_order_positions?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
  warehouse_order_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Position_Aggregate_Bool_Exp>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  warehouse_order_receipts?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  warehouse_order_receipts_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Aggregate_Bool_Exp>;
  warehouse_order_status?: InputMaybe<Eatfresh_Warehouse_Order_Status_Enum_Comparison_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse". */
export type Eatfresh_Warehouse_Order_By = {
  assetTransfersByToWarehouseId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Order_By>;
  b2b_customer_id?: InputMaybe<Order_By>;
  commissioning_processes_aggregate?: InputMaybe<Eatfresh_Commissioning_Process_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  external?: InputMaybe<Order_By>;
  external_warehouse_pallet_spots_aggregate?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pallet_spots_as_source_aggregate?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Aggregate_Order_By>;
  place?: InputMaybe<Eatfresh_Place_Order_By>;
  place_id?: InputMaybe<Order_By>;
  rfid_boxes_aggregate?: InputMaybe<Eatfresh_Rfid_Box_Aggregate_Order_By>;
  rfid_scanners_aggregate?: InputMaybe<Eatfresh_Rfid_Scanner_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_assignments_aggregate?: InputMaybe<Eatfresh_Warehouse_Assignment_Aggregate_Order_By>;
  warehouse_orders_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Aggregate_Order_By>;
  warehouse_orders_as_source_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Aggregate_Order_By>;
  warehouse_shelves_aggregate?: InputMaybe<Eatfresh_Warehouse_Shelf_Aggregate_Order_By>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_order" */
export enum Eatfresh_Warehouse_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehouseOrderPkey = 'warehouse_order_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Insert_Input = {
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Obj_Rel_Insert_Input>;
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_order_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rfid_tags?: InputMaybe<Eatfresh_Rfid_Tag_Arr_Rel_Insert_Input>;
  shipped_at?: InputMaybe<Scalars['timestamptz']['input']>;
  source_warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  source_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Eatfresh_Warehouse_Order_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouseOrderStatusByWarehouseOrderStatus?: InputMaybe<Eatfresh_Warehouse_Order_Status_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_positions?: InputMaybe<Eatfresh_Warehouse_Order_Position_Arr_Rel_Insert_Input>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Obj_Rel_Insert_Input>;
  warehouse_order_receipts?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Arr_Rel_Insert_Input>;
  warehouse_order_status?: InputMaybe<Eatfresh_Warehouse_Order_Status_Enum>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Order_Max_Fields = {
  __typename?: 'eatfresh_warehouse_order_max_fields';
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logistics_order_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shipped_at?: Maybe<Scalars['timestamptz']['output']>;
  source_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Max_Order_By = {
  b2b_customer_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_order_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shipped_at?: InputMaybe<Order_By>;
  source_warehouse_id?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Order_Min_Fields = {
  __typename?: 'eatfresh_warehouse_order_min_fields';
  b2b_customer_id?: Maybe<Scalars['uuid']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logistics_order_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shipped_at?: Maybe<Scalars['timestamptz']['output']>;
  source_warehouse_id?: Maybe<Scalars['uuid']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Min_Order_By = {
  b2b_customer_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_order_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shipped_at?: InputMaybe<Order_By>;
  source_warehouse_id?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Order>;
};

/** input type for inserting object relation for remote table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Obj_Rel_Insert_Input = {
  data: Eatfresh_Warehouse_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_On_Conflict = {
  constraint: Eatfresh_Warehouse_Order_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Order_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_order". */
export type Eatfresh_Warehouse_Order_Order_By = {
  b2b_customer?: InputMaybe<Eatfresh_B2b_Customer_Order_By>;
  b2b_customer_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_order_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rfid_tags_aggregate?: InputMaybe<Eatfresh_Rfid_Tag_Aggregate_Order_By>;
  shipped_at?: InputMaybe<Order_By>;
  source_warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  source_warehouse_id?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouseOrderStatusByWarehouseOrderStatus?: InputMaybe<Eatfresh_Warehouse_Order_Status_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
  warehouse_order_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Position_Aggregate_Order_By>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Order_By>;
  warehouse_order_receipts_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Aggregate_Order_By>;
  warehouse_order_status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_order */
export type Eatfresh_Warehouse_Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position = {
  __typename?: 'eatfresh_warehouse_order_position';
  /** An object relationship */
  article?: Maybe<Eatfresh_Article>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  boxes?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  items_per_pu?: Maybe<Scalars['Int']['output']>;
  packaging_units?: Maybe<Scalars['Int']['output']>;
  purchase_price: Scalars['Int']['output'];
  total_articles: Scalars['Int']['output'];
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  warehouse_order?: Maybe<Eatfresh_Warehouse_Order>;
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Aggregate = {
  __typename?: 'eatfresh_warehouse_order_position_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Order_Position_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Order_Position>;
};

export type Eatfresh_Warehouse_Order_Position_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Warehouse_Order_Position_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Warehouse_Order_Position_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_aggregate_fields';
  avg?: Maybe<Eatfresh_Warehouse_Order_Position_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Order_Position_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Order_Position_Min_Fields>;
  stddev?: Maybe<Eatfresh_Warehouse_Order_Position_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Warehouse_Order_Position_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Warehouse_Order_Position_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Warehouse_Order_Position_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Warehouse_Order_Position_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Warehouse_Order_Position_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Warehouse_Order_Position_Variance_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Warehouse_Order_Position_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Warehouse_Order_Position_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Warehouse_Order_Position_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Warehouse_Order_Position_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Warehouse_Order_Position_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Warehouse_Order_Position_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Warehouse_Order_Position_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Warehouse_Order_Position_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Warehouse_Order_Position_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Warehouse_Order_Position_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Warehouse_Order_Position_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Position_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Warehouse_Order_Position_Avg_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_avg_fields';
  boxes?: Maybe<Scalars['Float']['output']>;
  items_per_pu?: Maybe<Scalars['Float']['output']>;
  packaging_units?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  total_articles?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Avg_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_order_position". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Order_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Bool_Exp>>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  boxes?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  items_per_pu?: InputMaybe<Int_Comparison_Exp>;
  packaging_units?: InputMaybe<Int_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  total_articles?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  warehouse_order_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_order_position" */
export enum Eatfresh_Warehouse_Order_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehouseOrderPositionPkey = 'warehouse_order_position_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Inc_Input = {
  boxes?: InputMaybe<Scalars['Int']['input']>;
  items_per_pu?: InputMaybe<Scalars['Int']['input']>;
  packaging_units?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  total_articles?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Insert_Input = {
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  boxes?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items_per_pu?: InputMaybe<Scalars['Int']['input']>;
  packaging_units?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  total_articles?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Obj_Rel_Insert_Input>;
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Order_Position_Max_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  boxes?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  items_per_pu?: Maybe<Scalars['Int']['output']>;
  packaging_units?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  total_articles?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  boxes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Order_Position_Min_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  boxes?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  items_per_pu?: Maybe<Scalars['Int']['output']>;
  packaging_units?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  total_articles?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  boxes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_order_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Order_Position>;
};

/** on_conflict condition type for table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_On_Conflict = {
  constraint: Eatfresh_Warehouse_Order_Position_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Order_Position_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_order_position". */
export type Eatfresh_Warehouse_Order_Position_Order_By = {
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  boxes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Order_By>;
  warehouse_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_order_position */
export type Eatfresh_Warehouse_Order_Position_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.warehouse_order_position" */
export enum Eatfresh_Warehouse_Order_Position_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Boxes = 'boxes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ItemsPerPu = 'items_per_pu',
  /** column name */
  PackagingUnits = 'packaging_units',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  TotalArticles = 'total_articles',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseOrderId = 'warehouse_order_id'
}

/** input type for updating data in table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  boxes?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items_per_pu?: InputMaybe<Scalars['Int']['input']>;
  packaging_units?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  total_articles?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Warehouse_Order_Position_Stddev_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_stddev_fields';
  boxes?: Maybe<Scalars['Float']['output']>;
  items_per_pu?: Maybe<Scalars['Float']['output']>;
  packaging_units?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  total_articles?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Stddev_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Warehouse_Order_Position_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_stddev_pop_fields';
  boxes?: Maybe<Scalars['Float']['output']>;
  items_per_pu?: Maybe<Scalars['Float']['output']>;
  packaging_units?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  total_articles?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Stddev_Pop_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Warehouse_Order_Position_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_stddev_samp_fields';
  boxes?: Maybe<Scalars['Float']['output']>;
  items_per_pu?: Maybe<Scalars['Float']['output']>;
  packaging_units?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  total_articles?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Stddev_Samp_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Order_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Order_Position_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  boxes?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items_per_pu?: InputMaybe<Scalars['Int']['input']>;
  packaging_units?: InputMaybe<Scalars['Int']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  total_articles?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Warehouse_Order_Position_Sum_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_sum_fields';
  boxes?: Maybe<Scalars['Int']['output']>;
  items_per_pu?: Maybe<Scalars['Int']['output']>;
  packaging_units?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  total_articles?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Sum_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.warehouse_order_position" */
export enum Eatfresh_Warehouse_Order_Position_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Boxes = 'boxes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ItemsPerPu = 'items_per_pu',
  /** column name */
  PackagingUnits = 'packaging_units',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  TotalArticles = 'total_articles',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseOrderId = 'warehouse_order_id'
}

export type Eatfresh_Warehouse_Order_Position_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Position_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Order_Position_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Warehouse_Order_Position_Var_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_var_pop_fields';
  boxes?: Maybe<Scalars['Float']['output']>;
  items_per_pu?: Maybe<Scalars['Float']['output']>;
  packaging_units?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  total_articles?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Var_Pop_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Warehouse_Order_Position_Var_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_var_samp_fields';
  boxes?: Maybe<Scalars['Float']['output']>;
  items_per_pu?: Maybe<Scalars['Float']['output']>;
  packaging_units?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  total_articles?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Var_Samp_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Warehouse_Order_Position_Variance_Fields = {
  __typename?: 'eatfresh_warehouse_order_position_variance_fields';
  boxes?: Maybe<Scalars['Float']['output']>;
  items_per_pu?: Maybe<Scalars['Float']['output']>;
  packaging_units?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  total_articles?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.warehouse_order_position" */
export type Eatfresh_Warehouse_Order_Position_Variance_Order_By = {
  boxes?: InputMaybe<Order_By>;
  items_per_pu?: InputMaybe<Order_By>;
  packaging_units?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  total_articles?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt = {
  __typename?: 'eatfresh_warehouse_order_receipt';
  cost: Scalars['Int']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  logistics_problems: Array<Eatfresh_Logistics_Problem>;
  /** An aggregate relationship */
  logistics_problems_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  received_at?: Maybe<Scalars['timestamp']['output']>;
  signature_image_id: Scalars['uuid']['output'];
  /** An array relationship */
  supplier_problems: Array<Eatfresh_Supplier_Problem>;
  /** An aggregate relationship */
  supplier_problems_aggregate: Eatfresh_Supplier_Problem_Aggregate;
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  uploaded_file: Eatfresh_Uploaded_File;
  /** An object relationship */
  warehouse_order: Eatfresh_Warehouse_Order;
  warehouse_order_id: Scalars['uuid']['output'];
  /** An array relationship */
  warehouse_order_receipt_positions: Array<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** An aggregate relationship */
  warehouse_order_receipt_positions_aggregate: Eatfresh_Warehouse_Order_Receipt_Position_Aggregate;
};


/** columns and relationships of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_ReceiptLogistics_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_ReceiptLogistics_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_ReceiptSupplier_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_ReceiptSupplier_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_ReceiptWarehouse_Order_Receipt_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_ReceiptWarehouse_Order_Receipt_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};

/** aggregated selection of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Aggregate = {
  __typename?: 'eatfresh_warehouse_order_receipt_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Order_Receipt_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Order_Receipt>;
};

export type Eatfresh_Warehouse_Order_Receipt_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Warehouse_Order_Receipt_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_aggregate_fields';
  avg?: Maybe<Eatfresh_Warehouse_Order_Receipt_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Order_Receipt_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Order_Receipt_Min_Fields>;
  stddev?: Maybe<Eatfresh_Warehouse_Order_Receipt_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Warehouse_Order_Receipt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Warehouse_Order_Receipt_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Warehouse_Order_Receipt_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Warehouse_Order_Receipt_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Warehouse_Order_Receipt_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Warehouse_Order_Receipt_Variance_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Warehouse_Order_Receipt_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Warehouse_Order_Receipt_Avg_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_avg_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_order_receipt". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Order_Receipt_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Bool_Exp>;
  received_at?: InputMaybe<Timestamp_Comparison_Exp>;
  signature_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  supplier_problems?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
  supplier_problems_aggregate?: InputMaybe<Eatfresh_Supplier_Problem_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  warehouse_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  warehouse_order_receipt_positions?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
  warehouse_order_receipt_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_order_receipt" */
export enum Eatfresh_Warehouse_Order_Receipt_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehouseOrderReceiptPkey = 'warehouse_order_receipt_pkey',
  /** unique or primary key constraint on columns "warehouse_order_id" */
  WarehouseOrderReceiptWarehouseOrderIdKey = 'warehouse_order_receipt_warehouse_order_id_key'
}

/** input type for incrementing numeric columns in table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Inc_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Insert_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_problems?: InputMaybe<Eatfresh_Logistics_Problem_Arr_Rel_Insert_Input>;
  received_at?: InputMaybe<Scalars['timestamp']['input']>;
  signature_image_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier_problems?: InputMaybe<Eatfresh_Supplier_Problem_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Obj_Rel_Insert_Input>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Obj_Rel_Insert_Input>;
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_receipt_positions?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Order_Receipt_Max_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_max_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  received_at?: Maybe<Scalars['timestamp']['output']>;
  signature_image_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Max_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  signature_image_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Order_Receipt_Min_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_min_fields';
  cost?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  received_at?: Maybe<Scalars['timestamp']['output']>;
  signature_image_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  warehouse_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Min_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  signature_image_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_order_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_order_receipt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Order_Receipt>;
};

/** input type for inserting object relation for remote table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Obj_Rel_Insert_Input = {
  data: Eatfresh_Warehouse_Order_Receipt_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_On_Conflict = {
  constraint: Eatfresh_Warehouse_Order_Receipt_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Order_Receipt_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_order_receipt". */
export type Eatfresh_Warehouse_Order_Receipt_Order_By = {
  cost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logistics_problems_aggregate?: InputMaybe<Eatfresh_Logistics_Problem_Aggregate_Order_By>;
  received_at?: InputMaybe<Order_By>;
  signature_image_id?: InputMaybe<Order_By>;
  supplier_problems_aggregate?: InputMaybe<Eatfresh_Supplier_Problem_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_file?: InputMaybe<Eatfresh_Uploaded_File_Order_By>;
  warehouse_order?: InputMaybe<Eatfresh_Warehouse_Order_Order_By>;
  warehouse_order_id?: InputMaybe<Order_By>;
  warehouse_order_receipt_positions_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_order_receipt */
export type Eatfresh_Warehouse_Order_Receipt_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position = {
  __typename?: 'eatfresh_warehouse_order_receipt_position';
  actual_quantity: Scalars['Int']['output'];
  /** An object relationship */
  article?: Maybe<Eatfresh_Article>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  article_labeling_processes: Array<Eatfresh_Article_Labeling_Process>;
  /** An aggregate relationship */
  article_labeling_processes_aggregate: Eatfresh_Article_Labeling_Process_Aggregate;
  best_before_date?: Maybe<Scalars['timestamp']['output']>;
  created_at: Scalars['timestamp']['output'];
  expected_quantity: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  is_labeled: Scalars['Boolean']['output'];
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  labeled_quantity: Scalars['Int']['output'];
  quality?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  supplier_problem?: Maybe<Eatfresh_Supplier_Problem>;
  updated_at: Scalars['timestamp']['output'];
  usable_quantity?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  warehouse_order_receipt: Eatfresh_Warehouse_Order_Receipt;
  warehouse_order_receipt_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_PositionArticle_Labeling_ProcessesArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_PositionArticle_Labeling_Processes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};

/** aggregated selection of "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Order_Receipt_Position>;
};

export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_And = {
  arguments: Eatfresh_Warehouse_Order_Receipt_Position_Select_Column_Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Eatfresh_Warehouse_Order_Receipt_Position_Select_Column_Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_aggregate_fields';
  avg?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Min_Fields>;
  stddev?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Variance_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Warehouse_Order_Receipt_Position_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Avg_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_avg_fields';
  actual_quantity?: Maybe<Scalars['Float']['output']>;
  expected_quantity?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  labeled_quantity?: Maybe<Scalars['Float']['output']>;
  usable_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Avg_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_order_receipt_position". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>>;
  actual_quantity?: InputMaybe<Int_Comparison_Exp>;
  article?: InputMaybe<Eatfresh_Article_Bool_Exp>;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Bool_Exp>;
  best_before_date?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expected_quantity?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_labeled?: InputMaybe<Boolean_Comparison_Exp>;
  items_per_package_unit?: InputMaybe<Int_Comparison_Exp>;
  labeled_quantity?: InputMaybe<Int_Comparison_Exp>;
  quality?: InputMaybe<Boolean_Comparison_Exp>;
  supplier_problem?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  usable_quantity?: InputMaybe<Int_Comparison_Exp>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
  warehouse_order_receipt_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_order_receipt_position" */
export enum Eatfresh_Warehouse_Order_Receipt_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehouseOrderReceiptPositionPkey = 'warehouse_order_receipt_position_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Inc_Input = {
  actual_quantity?: InputMaybe<Scalars['Int']['input']>;
  expected_quantity?: InputMaybe<Scalars['Int']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  labeled_quantity?: InputMaybe<Scalars['Int']['input']>;
  usable_quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Insert_Input = {
  actual_quantity?: InputMaybe<Scalars['Int']['input']>;
  article?: InputMaybe<Eatfresh_Article_Obj_Rel_Insert_Input>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  article_labeling_processes?: InputMaybe<Eatfresh_Article_Labeling_Process_Arr_Rel_Insert_Input>;
  best_before_date?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expected_quantity?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_labeled?: InputMaybe<Scalars['Boolean']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  labeled_quantity?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Boolean']['input']>;
  supplier_problem?: InputMaybe<Eatfresh_Supplier_Problem_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  usable_quantity?: InputMaybe<Scalars['Int']['input']>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Obj_Rel_Insert_Input>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Max_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_max_fields';
  actual_quantity?: Maybe<Scalars['Int']['output']>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  best_before_date?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expected_quantity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  labeled_quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  usable_quantity?: Maybe<Scalars['Int']['output']>;
  warehouse_order_receipt_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Max_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  article_id?: InputMaybe<Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Min_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_min_fields';
  actual_quantity?: Maybe<Scalars['Int']['output']>;
  article_id?: Maybe<Scalars['uuid']['output']>;
  best_before_date?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  expected_quantity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  labeled_quantity?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  usable_quantity?: Maybe<Scalars['Int']['output']>;
  warehouse_order_receipt_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Min_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  article_id?: InputMaybe<Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Order_Receipt_Position>;
};

/** input type for inserting object relation for remote table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Obj_Rel_Insert_Input = {
  data: Eatfresh_Warehouse_Order_Receipt_Position_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_On_Conflict = {
  constraint: Eatfresh_Warehouse_Order_Receipt_Position_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Order_Receipt_Position_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_order_receipt_position". */
export type Eatfresh_Warehouse_Order_Receipt_Position_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  article?: InputMaybe<Eatfresh_Article_Order_By>;
  article_id?: InputMaybe<Order_By>;
  article_labeling_processes_aggregate?: InputMaybe<Eatfresh_Article_Labeling_Process_Aggregate_Order_By>;
  best_before_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_labeled?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  quality?: InputMaybe<Order_By>;
  supplier_problem?: InputMaybe<Eatfresh_Supplier_Problem_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
  warehouse_order_receipt?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Order_By>;
  warehouse_order_receipt_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_order_receipt_position */
export type Eatfresh_Warehouse_Order_Receipt_Position_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.warehouse_order_receipt_position" */
export enum Eatfresh_Warehouse_Order_Receipt_Position_Select_Column {
  /** column name */
  ActualQuantity = 'actual_quantity',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BestBeforeDate = 'best_before_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpectedQuantity = 'expected_quantity',
  /** column name */
  Id = 'id',
  /** column name */
  IsLabeled = 'is_labeled',
  /** column name */
  ItemsPerPackageUnit = 'items_per_package_unit',
  /** column name */
  LabeledQuantity = 'labeled_quantity',
  /** column name */
  Quality = 'quality',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableQuantity = 'usable_quantity',
  /** column name */
  WarehouseOrderReceiptId = 'warehouse_order_receipt_id'
}

/** select "eatfresh_warehouse_order_receipt_position_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.warehouse_order_receipt_position" */
export enum Eatfresh_Warehouse_Order_Receipt_Position_Select_Column_Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsLabeled = 'is_labeled',
  /** column name */
  Quality = 'quality'
}

/** select "eatfresh_warehouse_order_receipt_position_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.warehouse_order_receipt_position" */
export enum Eatfresh_Warehouse_Order_Receipt_Position_Select_Column_Eatfresh_Warehouse_Order_Receipt_Position_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsLabeled = 'is_labeled',
  /** column name */
  Quality = 'quality'
}

/** input type for updating data in table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Set_Input = {
  actual_quantity?: InputMaybe<Scalars['Int']['input']>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  best_before_date?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expected_quantity?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_labeled?: InputMaybe<Scalars['Boolean']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  labeled_quantity?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  usable_quantity?: InputMaybe<Scalars['Int']['input']>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_stddev_fields';
  actual_quantity?: Maybe<Scalars['Float']['output']>;
  expected_quantity?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  labeled_quantity?: Maybe<Scalars['Float']['output']>;
  usable_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_stddev_pop_fields';
  actual_quantity?: Maybe<Scalars['Float']['output']>;
  expected_quantity?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  labeled_quantity?: Maybe<Scalars['Float']['output']>;
  usable_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Pop_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_stddev_samp_fields';
  actual_quantity?: Maybe<Scalars['Float']['output']>;
  expected_quantity?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  labeled_quantity?: Maybe<Scalars['Float']['output']>;
  usable_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stddev_Samp_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Order_Receipt_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Order_Receipt_Position_Stream_Cursor_Value_Input = {
  actual_quantity?: InputMaybe<Scalars['Int']['input']>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  best_before_date?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  expected_quantity?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_labeled?: InputMaybe<Scalars['Boolean']['input']>;
  items_per_package_unit?: InputMaybe<Scalars['Int']['input']>;
  labeled_quantity?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  usable_quantity?: InputMaybe<Scalars['Int']['input']>;
  warehouse_order_receipt_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Sum_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_sum_fields';
  actual_quantity?: Maybe<Scalars['Int']['output']>;
  expected_quantity?: Maybe<Scalars['Int']['output']>;
  items_per_package_unit?: Maybe<Scalars['Int']['output']>;
  labeled_quantity?: Maybe<Scalars['Int']['output']>;
  usable_quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Sum_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.warehouse_order_receipt_position" */
export enum Eatfresh_Warehouse_Order_Receipt_Position_Update_Column {
  /** column name */
  ActualQuantity = 'actual_quantity',
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  BestBeforeDate = 'best_before_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpectedQuantity = 'expected_quantity',
  /** column name */
  Id = 'id',
  /** column name */
  IsLabeled = 'is_labeled',
  /** column name */
  ItemsPerPackageUnit = 'items_per_package_unit',
  /** column name */
  LabeledQuantity = 'labeled_quantity',
  /** column name */
  Quality = 'quality',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableQuantity = 'usable_quantity',
  /** column name */
  WarehouseOrderReceiptId = 'warehouse_order_receipt_id'
}

export type Eatfresh_Warehouse_Order_Receipt_Position_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Var_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_var_pop_fields';
  actual_quantity?: Maybe<Scalars['Float']['output']>;
  expected_quantity?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  labeled_quantity?: Maybe<Scalars['Float']['output']>;
  usable_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Var_Pop_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Var_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_var_samp_fields';
  actual_quantity?: Maybe<Scalars['Float']['output']>;
  expected_quantity?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  labeled_quantity?: Maybe<Scalars['Float']['output']>;
  usable_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Var_Samp_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Warehouse_Order_Receipt_Position_Variance_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_position_variance_fields';
  actual_quantity?: Maybe<Scalars['Float']['output']>;
  expected_quantity?: Maybe<Scalars['Float']['output']>;
  items_per_package_unit?: Maybe<Scalars['Float']['output']>;
  labeled_quantity?: Maybe<Scalars['Float']['output']>;
  usable_quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.warehouse_order_receipt_position" */
export type Eatfresh_Warehouse_Order_Receipt_Position_Variance_Order_By = {
  actual_quantity?: InputMaybe<Order_By>;
  expected_quantity?: InputMaybe<Order_By>;
  items_per_package_unit?: InputMaybe<Order_By>;
  labeled_quantity?: InputMaybe<Order_By>;
  usable_quantity?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.warehouse_order_receipt" */
export enum Eatfresh_Warehouse_Order_Receipt_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  SignatureImageId = 'signature_image_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseOrderId = 'warehouse_order_id'
}

/** input type for updating data in table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Set_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  received_at?: InputMaybe<Scalars['timestamp']['input']>;
  signature_image_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Warehouse_Order_Receipt_Stddev_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Warehouse_Order_Receipt_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Warehouse_Order_Receipt_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Order_Receipt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Order_Receipt_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  received_at?: InputMaybe<Scalars['timestamp']['input']>;
  signature_image_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Warehouse_Order_Receipt_Sum_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.warehouse_order_receipt" */
export enum Eatfresh_Warehouse_Order_Receipt_Update_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  SignatureImageId = 'signature_image_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseOrderId = 'warehouse_order_id'
}

export type Eatfresh_Warehouse_Order_Receipt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Order_Receipt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Warehouse_Order_Receipt_Var_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Warehouse_Order_Receipt_Var_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Warehouse_Order_Receipt_Variance_Fields = {
  __typename?: 'eatfresh_warehouse_order_receipt_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.warehouse_order_receipt" */
export type Eatfresh_Warehouse_Order_Receipt_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** select columns of table "eatfresh.warehouse_order" */
export enum Eatfresh_Warehouse_Order_Select_Column {
  /** column name */
  B2bCustomerId = 'b2b_customer_id',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogisticsOrderId = 'logistics_order_id',
  /** column name */
  Name = 'name',
  /** column name */
  ShippedAt = 'shipped_at',
  /** column name */
  SourceWarehouseId = 'source_warehouse_id',
  /** column name */
  Supplier = 'supplier',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id',
  /** column name */
  WarehouseOrderStatus = 'warehouse_order_status'
}

/** input type for updating data in table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Set_Input = {
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_order_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Eatfresh_Warehouse_Order_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_status?: InputMaybe<Eatfresh_Warehouse_Order_Status_Enum>;
};

/** columns and relationships of "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status = {
  __typename?: 'eatfresh_warehouse_order_status';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
  /** An array relationship */
  warehouse_orders: Array<Eatfresh_Warehouse_Order>;
  /** An aggregate relationship */
  warehouse_orders_aggregate: Eatfresh_Warehouse_Order_Aggregate;
};


/** columns and relationships of "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_StatusWarehouse_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_StatusWarehouse_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};

/** aggregated selection of "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Aggregate = {
  __typename?: 'eatfresh_warehouse_order_status_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Order_Status_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Order_Status>;
};

/** aggregate fields of "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_order_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Order_Status_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Order_Status_Min_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_order_status". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Order_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  warehouse_orders?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
  warehouse_orders_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_order_status" */
export enum Eatfresh_Warehouse_Order_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  WarehouseOrderStatusPkey = 'warehouse_order_status_pkey'
}

export enum Eatfresh_Warehouse_Order_Status_Enum {
  /** Order has been cancelled */
  Cancelled = 'CANCELLED',
  /** Order has been delivered */
  Delivered = 'DELIVERED',
  /** Order is in draft state */
  Draft = 'DRAFT',
  /** Order is in transit */
  InTransit = 'IN_TRANSIT',
  /** Order payment is due */
  PaymentDue = 'PAYMENT_DUE',
  /** Order has been placed with supplier */
  Placed = 'PLACED',
  /** There was a problem with the order */
  Problem = 'PROBLEM',
  /** Order is ready to be shipped */
  ReadyToShip = 'READY_TO_SHIP',
  /** Order has been returned */
  Returned = 'RETURNED',
  /** Transport has been requested from logistics provider */
  TransportRequested = 'TRANSPORT_REQUESTED'
}

/** Boolean expression to compare columns of type "eatfresh_warehouse_order_status_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Warehouse_Order_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Warehouse_Order_Status_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Warehouse_Order_Status_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Enum>>;
};

/** input type for inserting data into table "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  warehouse_orders?: InputMaybe<Eatfresh_Warehouse_Order_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Order_Status_Max_Fields = {
  __typename?: 'eatfresh_warehouse_order_status_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Order_Status_Min_Fields = {
  __typename?: 'eatfresh_warehouse_order_status_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_order_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Order_Status>;
};

/** input type for inserting object relation for remote table "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Obj_Rel_Insert_Input = {
  data: Eatfresh_Warehouse_Order_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Status_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_On_Conflict = {
  constraint: Eatfresh_Warehouse_Order_Status_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Order_Status_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_order_status". */
export type Eatfresh_Warehouse_Order_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  warehouse_orders_aggregate?: InputMaybe<Eatfresh_Warehouse_Order_Aggregate_Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_order_status */
export type Eatfresh_Warehouse_Order_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.warehouse_order_status" */
export enum Eatfresh_Warehouse_Order_Status_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_warehouse_order_status" */
export type Eatfresh_Warehouse_Order_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Order_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Order_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.warehouse_order_status" */
export enum Eatfresh_Warehouse_Order_Status_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Warehouse_Order_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Order_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Eatfresh_Warehouse_Order_Stddev_Fields = {
  __typename?: 'eatfresh_warehouse_order_stddev_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Warehouse_Order_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Warehouse_Order_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_warehouse_order" */
export type Eatfresh_Warehouse_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Order_Stream_Cursor_Value_Input = {
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logistics_order_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Eatfresh_Warehouse_Order_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
  warehouse_order_status?: InputMaybe<Eatfresh_Warehouse_Order_Status_Enum>;
};

/** aggregate sum on columns */
export type Eatfresh_Warehouse_Order_Sum_Fields = {
  __typename?: 'eatfresh_warehouse_order_sum_fields';
  cost?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type = {
  __typename?: 'eatfresh_warehouse_order_type';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_Aggregate = {
  __typename?: 'eatfresh_warehouse_order_type_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Order_Type_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Order_Type>;
};

/** aggregate fields of "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_order_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Order_Type_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Order_Type_Min_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_order_type". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Order_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Order_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_order_type" */
export enum Eatfresh_Warehouse_Order_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  WarehouseOrderTypePkey = 'warehouse_order_type_pkey'
}

export enum Eatfresh_Warehouse_Order_Type_Enum {
  /** Orders we buy from suppliers  */
  Supplier = 'SUPPLIER',
  /** we shift the location of goods from one warehouse to another without a change in ownership */
  Warehouse = 'WAREHOUSE',
  /** we sell goods to b2b customers directly */
  Wholesale = 'WHOLESALE'
}

/** Boolean expression to compare columns of type "eatfresh_warehouse_order_type_enum". All fields are combined with logical 'AND'. */
export type Eatfresh_Warehouse_Order_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Eatfresh_Warehouse_Order_Type_Enum>;
  _in?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Eatfresh_Warehouse_Order_Type_Enum>;
  _nin?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Enum>>;
};

/** input type for inserting data into table "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Order_Type_Max_Fields = {
  __typename?: 'eatfresh_warehouse_order_type_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Order_Type_Min_Fields = {
  __typename?: 'eatfresh_warehouse_order_type_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_order_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Order_Type>;
};

/** on_conflict condition type for table "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_On_Conflict = {
  constraint: Eatfresh_Warehouse_Order_Type_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Order_Type_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_order_type". */
export type Eatfresh_Warehouse_Order_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_order_type */
export type Eatfresh_Warehouse_Order_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "eatfresh.warehouse_order_type" */
export enum Eatfresh_Warehouse_Order_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eatfresh.warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "eatfresh_warehouse_order_type" */
export type Eatfresh_Warehouse_Order_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Order_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Order_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "eatfresh.warehouse_order_type" */
export enum Eatfresh_Warehouse_Order_Type_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Eatfresh_Warehouse_Order_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Order_Type_Bool_Exp;
};

/** update columns of table "eatfresh.warehouse_order" */
export enum Eatfresh_Warehouse_Order_Update_Column {
  /** column name */
  B2bCustomerId = 'b2b_customer_id',
  /** column name */
  Cost = 'cost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LogisticsOrderId = 'logistics_order_id',
  /** column name */
  Name = 'name',
  /** column name */
  ShippedAt = 'shipped_at',
  /** column name */
  SourceWarehouseId = 'source_warehouse_id',
  /** column name */
  Supplier = 'supplier',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id',
  /** column name */
  WarehouseOrderStatus = 'warehouse_order_status'
}

export type Eatfresh_Warehouse_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Warehouse_Order_Var_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_order_var_pop_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Warehouse_Order_Var_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_order_var_samp_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Warehouse_Order_Variance_Fields = {
  __typename?: 'eatfresh_warehouse_order_variance_fields';
  cost?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.warehouse_order" */
export type Eatfresh_Warehouse_Order_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse */
export type Eatfresh_Warehouse_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.warehouse" */
export enum Eatfresh_Warehouse_Select_Column {
  /** column name */
  B2bCustomerId = 'b2b_customer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  External = 'external',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "eatfresh_warehouse_aggregate_bool_exp_bool_and_arguments_columns" columns of table "eatfresh.warehouse" */
export enum Eatfresh_Warehouse_Select_Column_Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  External = 'external'
}

/** select "eatfresh_warehouse_aggregate_bool_exp_bool_or_arguments_columns" columns of table "eatfresh.warehouse" */
export enum Eatfresh_Warehouse_Select_Column_Eatfresh_Warehouse_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  External = 'external'
}

/** input type for updating data in table "eatfresh.warehouse" */
export type Eatfresh_Warehouse_Set_Input = {
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf = {
  __typename?: 'eatfresh_warehouse_shelf';
  /** An array relationship */
  assetTransfersByToShelfId: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  assetTransfersByToShelfId_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** An array relationship */
  asset_placements: Array<Eatfresh_Asset_Placement>;
  /** An aggregate relationship */
  asset_placements_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** An array relationship */
  asset_transfers: Array<Eatfresh_Asset_Transfer>;
  /** An aggregate relationship */
  asset_transfers_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  shelf_column: Scalars['Int']['output'];
  shelf_row: Scalars['Int']['output'];
  /** An object relationship */
  shelf_type: Eatfresh_Shelf_Type;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  warehouse: Eatfresh_Warehouse;
  warehouse_id: Scalars['uuid']['output'];
};


/** columns and relationships of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_ShelfAssetTransfersByToShelfIdArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_ShelfAssetTransfersByToShelfId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_ShelfAsset_PlacementsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_ShelfAsset_Placements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_ShelfAsset_TransfersArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


/** columns and relationships of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_ShelfAsset_Transfers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};

/** aggregated selection of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Aggregate = {
  __typename?: 'eatfresh_warehouse_shelf_aggregate';
  aggregate?: Maybe<Eatfresh_Warehouse_Shelf_Aggregate_Fields>;
  nodes: Array<Eatfresh_Warehouse_Shelf>;
};

export type Eatfresh_Warehouse_Shelf_Aggregate_Bool_Exp = {
  count?: InputMaybe<Eatfresh_Warehouse_Shelf_Aggregate_Bool_Exp_Count>;
};

export type Eatfresh_Warehouse_Shelf_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Aggregate_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_aggregate_fields';
  avg?: Maybe<Eatfresh_Warehouse_Shelf_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Eatfresh_Warehouse_Shelf_Max_Fields>;
  min?: Maybe<Eatfresh_Warehouse_Shelf_Min_Fields>;
  stddev?: Maybe<Eatfresh_Warehouse_Shelf_Stddev_Fields>;
  stddev_pop?: Maybe<Eatfresh_Warehouse_Shelf_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eatfresh_Warehouse_Shelf_Stddev_Samp_Fields>;
  sum?: Maybe<Eatfresh_Warehouse_Shelf_Sum_Fields>;
  var_pop?: Maybe<Eatfresh_Warehouse_Shelf_Var_Pop_Fields>;
  var_samp?: Maybe<Eatfresh_Warehouse_Shelf_Var_Samp_Fields>;
  variance?: Maybe<Eatfresh_Warehouse_Shelf_Variance_Fields>;
};


/** aggregate fields of "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Aggregate_Order_By = {
  avg?: InputMaybe<Eatfresh_Warehouse_Shelf_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Eatfresh_Warehouse_Shelf_Max_Order_By>;
  min?: InputMaybe<Eatfresh_Warehouse_Shelf_Min_Order_By>;
  stddev?: InputMaybe<Eatfresh_Warehouse_Shelf_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Eatfresh_Warehouse_Shelf_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Eatfresh_Warehouse_Shelf_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Eatfresh_Warehouse_Shelf_Sum_Order_By>;
  var_pop?: InputMaybe<Eatfresh_Warehouse_Shelf_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Eatfresh_Warehouse_Shelf_Var_Samp_Order_By>;
  variance?: InputMaybe<Eatfresh_Warehouse_Shelf_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Arr_Rel_Insert_Input = {
  data: Array<Eatfresh_Warehouse_Shelf_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Shelf_On_Conflict>;
};

/** aggregate avg on columns */
export type Eatfresh_Warehouse_Shelf_Avg_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_avg_fields';
  shelf_column?: Maybe<Scalars['Float']['output']>;
  shelf_row?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Avg_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eatfresh.warehouse_shelf". All fields are combined with a logical 'AND'. */
export type Eatfresh_Warehouse_Shelf_Bool_Exp = {
  _and?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Bool_Exp>>;
  _not?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
  _or?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Bool_Exp>>;
  assetTransfersByToShelfId?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  assetTransfersByToShelfId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Bool_Exp>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  shelf_column?: InputMaybe<Int_Comparison_Exp>;
  shelf_row?: InputMaybe<Int_Comparison_Exp>;
  shelf_type?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
  warehouse_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "eatfresh.warehouse_shelf" */
export enum Eatfresh_Warehouse_Shelf_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehouseShelfPkey = 'warehouse_shelf_pkey'
}

/** input type for incrementing numeric columns in table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Inc_Input = {
  shelf_column?: InputMaybe<Scalars['Int']['input']>;
  shelf_row?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Insert_Input = {
  assetTransfersByToShelfId?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  asset_placements?: InputMaybe<Eatfresh_Asset_Placement_Arr_Rel_Insert_Input>;
  asset_transfers?: InputMaybe<Eatfresh_Asset_Transfer_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  shelf_column?: InputMaybe<Scalars['Int']['input']>;
  shelf_row?: InputMaybe<Scalars['Int']['input']>;
  shelf_type?: InputMaybe<Eatfresh_Shelf_Type_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Obj_Rel_Insert_Input>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Eatfresh_Warehouse_Shelf_Max_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  shelf_column?: Maybe<Scalars['Int']['output']>;
  shelf_row?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Eatfresh_Warehouse_Shelf_Min_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  shelf_column?: Maybe<Scalars['Int']['output']>;
  shelf_row?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  warehouse_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Mutation_Response = {
  __typename?: 'eatfresh_warehouse_shelf_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Eatfresh_Warehouse_Shelf>;
};

/** input type for inserting object relation for remote table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Obj_Rel_Insert_Input = {
  data: Eatfresh_Warehouse_Shelf_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Shelf_On_Conflict>;
};

/** on_conflict condition type for table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_On_Conflict = {
  constraint: Eatfresh_Warehouse_Shelf_Constraint;
  update_columns?: Array<Eatfresh_Warehouse_Shelf_Update_Column>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};

/** Ordering options when selecting data from "eatfresh.warehouse_shelf". */
export type Eatfresh_Warehouse_Shelf_Order_By = {
  assetTransfersByToShelfId_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  asset_placements_aggregate?: InputMaybe<Eatfresh_Asset_Placement_Aggregate_Order_By>;
  asset_transfers_aggregate?: InputMaybe<Eatfresh_Asset_Transfer_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
  shelf_type?: InputMaybe<Eatfresh_Shelf_Type_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Eatfresh_Warehouse_Order_By>;
  warehouse_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eatfresh.warehouse_shelf */
export type Eatfresh_Warehouse_Shelf_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "eatfresh.warehouse_shelf" */
export enum Eatfresh_Warehouse_Shelf_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ShelfColumn = 'shelf_column',
  /** column name */
  ShelfRow = 'shelf_row',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

/** input type for updating data in table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  shelf_column?: InputMaybe<Scalars['Int']['input']>;
  shelf_row?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Eatfresh_Warehouse_Shelf_Stddev_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_stddev_fields';
  shelf_column?: Maybe<Scalars['Float']['output']>;
  shelf_row?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Stddev_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Eatfresh_Warehouse_Shelf_Stddev_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_stddev_pop_fields';
  shelf_column?: Maybe<Scalars['Float']['output']>;
  shelf_row?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Stddev_Pop_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Eatfresh_Warehouse_Shelf_Stddev_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_stddev_samp_fields';
  shelf_column?: Maybe<Scalars['Float']['output']>;
  shelf_row?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Stddev_Samp_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Shelf_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Shelf_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  shelf_column?: InputMaybe<Scalars['Int']['input']>;
  shelf_row?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  warehouse_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Eatfresh_Warehouse_Shelf_Sum_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_sum_fields';
  shelf_column?: Maybe<Scalars['Int']['output']>;
  shelf_row?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Sum_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** update columns of table "eatfresh.warehouse_shelf" */
export enum Eatfresh_Warehouse_Shelf_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ShelfColumn = 'shelf_column',
  /** column name */
  ShelfRow = 'shelf_row',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarehouseId = 'warehouse_id'
}

export type Eatfresh_Warehouse_Shelf_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eatfresh_Warehouse_Shelf_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Shelf_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Shelf_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eatfresh_Warehouse_Shelf_Var_Pop_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_var_pop_fields';
  shelf_column?: Maybe<Scalars['Float']['output']>;
  shelf_row?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Var_Pop_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Eatfresh_Warehouse_Shelf_Var_Samp_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_var_samp_fields';
  shelf_column?: Maybe<Scalars['Float']['output']>;
  shelf_row?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Var_Samp_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Eatfresh_Warehouse_Shelf_Variance_Fields = {
  __typename?: 'eatfresh_warehouse_shelf_variance_fields';
  shelf_column?: Maybe<Scalars['Float']['output']>;
  shelf_row?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eatfresh.warehouse_shelf" */
export type Eatfresh_Warehouse_Shelf_Variance_Order_By = {
  shelf_column?: InputMaybe<Order_By>;
  shelf_row?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eatfresh_warehouse" */
export type Eatfresh_Warehouse_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eatfresh_Warehouse_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eatfresh_Warehouse_Stream_Cursor_Value_Input = {
  b2b_customer_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "eatfresh.warehouse" */
export enum Eatfresh_Warehouse_Update_Column {
  /** column name */
  B2bCustomerId = 'b2b_customer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  External = 'external',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Eatfresh_Warehouse_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eatfresh_Warehouse_Set_Input>;
  /** filter the rows which have to be updated */
  where: Eatfresh_Warehouse_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "eatfresh.age_verification" */
  delete_eatfresh_age_verification?: Maybe<Eatfresh_Age_Verification_Mutation_Response>;
  /** delete single row from the table: "eatfresh.age_verification" */
  delete_eatfresh_age_verification_by_pk?: Maybe<Eatfresh_Age_Verification>;
  /** delete data from the table: "eatfresh.age_verification_status" */
  delete_eatfresh_age_verification_status?: Maybe<Eatfresh_Age_Verification_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.age_verification_status" */
  delete_eatfresh_age_verification_status_by_pk?: Maybe<Eatfresh_Age_Verification_Status>;
  /** delete data from the table: "eatfresh.age_verification_type" */
  delete_eatfresh_age_verification_type?: Maybe<Eatfresh_Age_Verification_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.age_verification_type" */
  delete_eatfresh_age_verification_type_by_pk?: Maybe<Eatfresh_Age_Verification_Type>;
  /** delete data from the table: "eatfresh.article" */
  delete_eatfresh_article?: Maybe<Eatfresh_Article_Mutation_Response>;
  /** delete single row from the table: "eatfresh.article" */
  delete_eatfresh_article_by_pk?: Maybe<Eatfresh_Article>;
  /** delete data from the table: "eatfresh.article_details" */
  delete_eatfresh_article_details?: Maybe<Eatfresh_Article_Details_Mutation_Response>;
  /** delete single row from the table: "eatfresh.article_details" */
  delete_eatfresh_article_details_by_pk?: Maybe<Eatfresh_Article_Details>;
  /** delete data from the table: "eatfresh.article_labeling_process" */
  delete_eatfresh_article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process_Mutation_Response>;
  /** delete single row from the table: "eatfresh.article_labeling_process" */
  delete_eatfresh_article_labeling_process_by_pk?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** delete data from the table: "eatfresh.article_labeling_process_status" */
  delete_eatfresh_article_labeling_process_status?: Maybe<Eatfresh_Article_Labeling_Process_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.article_labeling_process_status" */
  delete_eatfresh_article_labeling_process_status_by_pk?: Maybe<Eatfresh_Article_Labeling_Process_Status>;
  /** delete data from the table: "eatfresh.asset_placement" */
  delete_eatfresh_asset_placement?: Maybe<Eatfresh_Asset_Placement_Mutation_Response>;
  /** delete single row from the table: "eatfresh.asset_placement" */
  delete_eatfresh_asset_placement_by_pk?: Maybe<Eatfresh_Asset_Placement>;
  /** delete data from the table: "eatfresh.asset_transfer" */
  delete_eatfresh_asset_transfer?: Maybe<Eatfresh_Asset_Transfer_Mutation_Response>;
  /** delete single row from the table: "eatfresh.asset_transfer" */
  delete_eatfresh_asset_transfer_by_pk?: Maybe<Eatfresh_Asset_Transfer>;
  /** delete data from the table: "eatfresh.asset_transfer_problem" */
  delete_eatfresh_asset_transfer_problem?: Maybe<Eatfresh_Asset_Transfer_Problem_Mutation_Response>;
  /** delete single row from the table: "eatfresh.asset_transfer_problem" */
  delete_eatfresh_asset_transfer_problem_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem>;
  /** delete data from the table: "eatfresh.asset_transfer_problem_severity" */
  delete_eatfresh_asset_transfer_problem_severity?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity_Mutation_Response>;
  /** delete single row from the table: "eatfresh.asset_transfer_problem_severity" */
  delete_eatfresh_asset_transfer_problem_severity_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** delete data from the table: "eatfresh.asset_transfer_problem_status" */
  delete_eatfresh_asset_transfer_problem_status?: Maybe<Eatfresh_Asset_Transfer_Problem_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.asset_transfer_problem_status" */
  delete_eatfresh_asset_transfer_problem_status_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Status>;
  /** delete data from the table: "eatfresh.auth_token" */
  delete_eatfresh_auth_token?: Maybe<Eatfresh_Auth_Token_Mutation_Response>;
  /** delete single row from the table: "eatfresh.auth_token" */
  delete_eatfresh_auth_token_by_pk?: Maybe<Eatfresh_Auth_Token>;
  /** delete data from the table: "eatfresh.authenticators" */
  delete_eatfresh_authenticators?: Maybe<Eatfresh_Authenticators_Mutation_Response>;
  /** delete single row from the table: "eatfresh.authenticators" */
  delete_eatfresh_authenticators_by_pk?: Maybe<Eatfresh_Authenticators>;
  /** delete data from the table: "eatfresh.b2b_customer" */
  delete_eatfresh_b2b_customer?: Maybe<Eatfresh_B2b_Customer_Mutation_Response>;
  /** delete single row from the table: "eatfresh.b2b_customer" */
  delete_eatfresh_b2b_customer_by_pk?: Maybe<Eatfresh_B2b_Customer>;
  /** delete data from the table: "eatfresh.b2b_customer_type" */
  delete_eatfresh_b2b_customer_type?: Maybe<Eatfresh_B2b_Customer_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.b2b_customer_type" */
  delete_eatfresh_b2b_customer_type_by_pk?: Maybe<Eatfresh_B2b_Customer_Type>;
  /** delete data from the table: "eatfresh.basic_user_type" */
  delete_eatfresh_basic_user_type?: Maybe<Eatfresh_Basic_User_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.basic_user_type" */
  delete_eatfresh_basic_user_type_by_pk?: Maybe<Eatfresh_Basic_User_Type>;
  /** delete data from the table: "eatfresh.box_content_plan" */
  delete_eatfresh_box_content_plan?: Maybe<Eatfresh_Box_Content_Plan_Mutation_Response>;
  /** delete single row from the table: "eatfresh.box_content_plan" */
  delete_eatfresh_box_content_plan_by_pk?: Maybe<Eatfresh_Box_Content_Plan>;
  /** delete data from the table: "eatfresh.box_content_plan_status" */
  delete_eatfresh_box_content_plan_status?: Maybe<Eatfresh_Box_Content_Plan_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.box_content_plan_status" */
  delete_eatfresh_box_content_plan_status_by_pk?: Maybe<Eatfresh_Box_Content_Plan_Status>;
  /** delete data from the table: "eatfresh.box_content_to_article" */
  delete_eatfresh_box_content_to_article?: Maybe<Eatfresh_Box_Content_To_Article_Mutation_Response>;
  /** delete single row from the table: "eatfresh.box_content_to_article" */
  delete_eatfresh_box_content_to_article_by_pk?: Maybe<Eatfresh_Box_Content_To_Article>;
  /** delete data from the table: "eatfresh.commissioning_process" */
  delete_eatfresh_commissioning_process?: Maybe<Eatfresh_Commissioning_Process_Mutation_Response>;
  /** delete single row from the table: "eatfresh.commissioning_process" */
  delete_eatfresh_commissioning_process_by_pk?: Maybe<Eatfresh_Commissioning_Process>;
  /** delete data from the table: "eatfresh.commissioning_process_position" */
  delete_eatfresh_commissioning_process_position?: Maybe<Eatfresh_Commissioning_Process_Position_Mutation_Response>;
  /** delete single row from the table: "eatfresh.commissioning_process_position" */
  delete_eatfresh_commissioning_process_position_by_pk?: Maybe<Eatfresh_Commissioning_Process_Position>;
  /** delete data from the table: "eatfresh.commissioning_process_status" */
  delete_eatfresh_commissioning_process_status?: Maybe<Eatfresh_Commissioning_Process_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.commissioning_process_status" */
  delete_eatfresh_commissioning_process_status_by_pk?: Maybe<Eatfresh_Commissioning_Process_Status>;
  /** delete data from the table: "eatfresh.computop_transaction" */
  delete_eatfresh_computop_transaction?: Maybe<Eatfresh_Computop_Transaction_Mutation_Response>;
  /** delete single row from the table: "eatfresh.computop_transaction" */
  delete_eatfresh_computop_transaction_by_pk?: Maybe<Eatfresh_Computop_Transaction>;
  /** delete data from the table: "eatfresh.connection_status" */
  delete_eatfresh_connection_status?: Maybe<Eatfresh_Connection_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.connection_status" */
  delete_eatfresh_connection_status_by_pk?: Maybe<Eatfresh_Connection_Status>;
  /** delete data from the table: "eatfresh.cost_configuration" */
  delete_eatfresh_cost_configuration?: Maybe<Eatfresh_Cost_Configuration_Mutation_Response>;
  /** delete data from the table: "eatfresh.cost_configuration_key" */
  delete_eatfresh_cost_configuration_key?: Maybe<Eatfresh_Cost_Configuration_Key_Mutation_Response>;
  /** delete single row from the table: "eatfresh.cost_configuration_key" */
  delete_eatfresh_cost_configuration_key_by_pk?: Maybe<Eatfresh_Cost_Configuration_Key>;
  /** delete data from the table: "eatfresh.customer" */
  delete_eatfresh_customer?: Maybe<Eatfresh_Customer_Mutation_Response>;
  /** delete single row from the table: "eatfresh.customer" */
  delete_eatfresh_customer_by_pk?: Maybe<Eatfresh_Customer>;
  /** delete data from the table: "eatfresh.customer_order" */
  delete_eatfresh_customer_order?: Maybe<Eatfresh_Customer_Order_Mutation_Response>;
  /** delete single row from the table: "eatfresh.customer_order" */
  delete_eatfresh_customer_order_by_pk?: Maybe<Eatfresh_Customer_Order>;
  /** delete data from the table: "eatfresh.door_status" */
  delete_eatfresh_door_status?: Maybe<Eatfresh_Door_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.door_status" */
  delete_eatfresh_door_status_by_pk?: Maybe<Eatfresh_Door_Status>;
  /** delete data from the table: "eatfresh.easy_refill_permission" */
  delete_eatfresh_easy_refill_permission?: Maybe<Eatfresh_Easy_Refill_Permission_Mutation_Response>;
  /** delete single row from the table: "eatfresh.easy_refill_permission" */
  delete_eatfresh_easy_refill_permission_by_pk?: Maybe<Eatfresh_Easy_Refill_Permission>;
  /** delete data from the table: "eatfresh.external_warehouse_pallet_spot" */
  delete_eatfresh_external_warehouse_pallet_spot?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot_Mutation_Response>;
  /** delete single row from the table: "eatfresh.external_warehouse_pallet_spot" */
  delete_eatfresh_external_warehouse_pallet_spot_by_pk?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** delete data from the table: "eatfresh.flyway_schema_history" */
  delete_eatfresh_flyway_schema_history?: Maybe<Eatfresh_Flyway_Schema_History_Mutation_Response>;
  /** delete single row from the table: "eatfresh.flyway_schema_history" */
  delete_eatfresh_flyway_schema_history_by_pk?: Maybe<Eatfresh_Flyway_Schema_History>;
  /** delete data from the table: "eatfresh.fridge" */
  delete_eatfresh_fridge?: Maybe<Eatfresh_Fridge_Mutation_Response>;
  /** delete data from the table: "eatfresh.fridge_alarm" */
  delete_eatfresh_fridge_alarm?: Maybe<Eatfresh_Fridge_Alarm_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_alarm" */
  delete_eatfresh_fridge_alarm_by_pk?: Maybe<Eatfresh_Fridge_Alarm>;
  /** delete data from the table: "eatfresh.fridge_article_stock_snapshot" */
  delete_eatfresh_fridge_article_stock_snapshot?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_article_stock_snapshot" */
  delete_eatfresh_fridge_article_stock_snapshot_by_pk?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** delete single row from the table: "eatfresh.fridge" */
  delete_eatfresh_fridge_by_pk?: Maybe<Eatfresh_Fridge>;
  /** delete data from the table: "eatfresh.fridge_event" */
  delete_eatfresh_fridge_event?: Maybe<Eatfresh_Fridge_Event_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_event" */
  delete_eatfresh_fridge_event_by_pk?: Maybe<Eatfresh_Fridge_Event>;
  /** delete data from the table: "eatfresh.fridge_event_type" */
  delete_eatfresh_fridge_event_type?: Maybe<Eatfresh_Fridge_Event_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_event_type" */
  delete_eatfresh_fridge_event_type_by_pk?: Maybe<Eatfresh_Fridge_Event_Type>;
  /** delete data from the table: "eatfresh.fridge_layout" */
  delete_eatfresh_fridge_layout?: Maybe<Eatfresh_Fridge_Layout_Mutation_Response>;
  /** delete data from the table: "eatfresh.fridge_layout_assignment" */
  delete_eatfresh_fridge_layout_assignment?: Maybe<Eatfresh_Fridge_Layout_Assignment_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_layout_assignment" */
  delete_eatfresh_fridge_layout_assignment_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment>;
  /** delete data from the table: "eatfresh.fridge_layout_assignment_status" */
  delete_eatfresh_fridge_layout_assignment_status?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_layout_assignment_status" */
  delete_eatfresh_fridge_layout_assignment_status_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** delete single row from the table: "eatfresh.fridge_layout" */
  delete_eatfresh_fridge_layout_by_pk?: Maybe<Eatfresh_Fridge_Layout>;
  /** delete data from the table: "eatfresh.fridge_layout_level" */
  delete_eatfresh_fridge_layout_level?: Maybe<Eatfresh_Fridge_Layout_Level_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_layout_level" */
  delete_eatfresh_fridge_layout_level_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level>;
  /** delete data from the table: "eatfresh.fridge_layout_level_position" */
  delete_eatfresh_fridge_layout_level_position?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_layout_level_position" */
  delete_eatfresh_fridge_layout_level_position_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level_Position>;
  /** delete data from the table: "eatfresh.fridge_order" */
  delete_eatfresh_fridge_order?: Maybe<Eatfresh_Fridge_Order_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_order" */
  delete_eatfresh_fridge_order_by_pk?: Maybe<Eatfresh_Fridge_Order>;
  /** delete data from the table: "eatfresh.fridge_status_history" */
  delete_eatfresh_fridge_status_history?: Maybe<Eatfresh_Fridge_Status_History_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_status_history" */
  delete_eatfresh_fridge_status_history_by_pk?: Maybe<Eatfresh_Fridge_Status_History>;
  /** delete data from the table: "eatfresh.fridge_stock" */
  delete_eatfresh_fridge_stock?: Maybe<Eatfresh_Fridge_Stock_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_stock" */
  delete_eatfresh_fridge_stock_by_pk?: Maybe<Eatfresh_Fridge_Stock>;
  /** delete data from the table: "eatfresh.fridge_target_stock" */
  delete_eatfresh_fridge_target_stock?: Maybe<Eatfresh_Fridge_Target_Stock_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_target_stock" */
  delete_eatfresh_fridge_target_stock_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock>;
  /** delete data from the table: "eatfresh.fridge_target_stock_position" */
  delete_eatfresh_fridge_target_stock_position?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_target_stock_position" */
  delete_eatfresh_fridge_target_stock_position_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock_Position>;
  /** delete data from the table: "eatfresh.fridge_type" */
  delete_eatfresh_fridge_type?: Maybe<Eatfresh_Fridge_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.fridge_type" */
  delete_eatfresh_fridge_type_by_pk?: Maybe<Eatfresh_Fridge_Type>;
  /** delete data from the table: "eatfresh.logistics_problem" */
  delete_eatfresh_logistics_problem?: Maybe<Eatfresh_Logistics_Problem_Mutation_Response>;
  /** delete single row from the table: "eatfresh.logistics_problem" */
  delete_eatfresh_logistics_problem_by_pk?: Maybe<Eatfresh_Logistics_Problem>;
  /** delete data from the table: "eatfresh.logistics_problem_image" */
  delete_eatfresh_logistics_problem_image?: Maybe<Eatfresh_Logistics_Problem_Image_Mutation_Response>;
  /** delete single row from the table: "eatfresh.logistics_problem_image" */
  delete_eatfresh_logistics_problem_image_by_pk?: Maybe<Eatfresh_Logistics_Problem_Image>;
  /** delete data from the table: "eatfresh.logistics_problem_status" */
  delete_eatfresh_logistics_problem_status?: Maybe<Eatfresh_Logistics_Problem_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.logistics_problem_status" */
  delete_eatfresh_logistics_problem_status_by_pk?: Maybe<Eatfresh_Logistics_Problem_Status>;
  /** delete data from the table: "eatfresh.logistics_process_type" */
  delete_eatfresh_logistics_process_type?: Maybe<Eatfresh_Logistics_Process_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.logistics_process_type" */
  delete_eatfresh_logistics_process_type_by_pk?: Maybe<Eatfresh_Logistics_Process_Type>;
  /** delete data from the table: "eatfresh.nutrition_information" */
  delete_eatfresh_nutrition_information?: Maybe<Eatfresh_Nutrition_Information_Mutation_Response>;
  /** delete single row from the table: "eatfresh.nutrition_information" */
  delete_eatfresh_nutrition_information_by_pk?: Maybe<Eatfresh_Nutrition_Information>;
  /** delete data from the table: "eatfresh.order_extra" */
  delete_eatfresh_order_extra?: Maybe<Eatfresh_Order_Extra_Mutation_Response>;
  /** delete single row from the table: "eatfresh.order_extra" */
  delete_eatfresh_order_extra_by_pk?: Maybe<Eatfresh_Order_Extra>;
  /** delete data from the table: "eatfresh.order_extra_customer_order" */
  delete_eatfresh_order_extra_customer_order?: Maybe<Eatfresh_Order_Extra_Customer_Order_Mutation_Response>;
  /** delete single row from the table: "eatfresh.order_extra_customer_order" */
  delete_eatfresh_order_extra_customer_order_by_pk?: Maybe<Eatfresh_Order_Extra_Customer_Order>;
  /** delete data from the table: "eatfresh.order_position" */
  delete_eatfresh_order_position?: Maybe<Eatfresh_Order_Position_Mutation_Response>;
  /** delete single row from the table: "eatfresh.order_position" */
  delete_eatfresh_order_position_by_pk?: Maybe<Eatfresh_Order_Position>;
  /** delete data from the table: "eatfresh.order_position_category" */
  delete_eatfresh_order_position_category?: Maybe<Eatfresh_Order_Position_Category_Mutation_Response>;
  /** delete single row from the table: "eatfresh.order_position_category" */
  delete_eatfresh_order_position_category_by_pk?: Maybe<Eatfresh_Order_Position_Category>;
  /** delete data from the table: "eatfresh.order_status" */
  delete_eatfresh_order_status?: Maybe<Eatfresh_Order_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.order_status" */
  delete_eatfresh_order_status_by_pk?: Maybe<Eatfresh_Order_Status>;
  /** delete data from the table: "eatfresh.packaging_type" */
  delete_eatfresh_packaging_type?: Maybe<Eatfresh_Packaging_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.packaging_type" */
  delete_eatfresh_packaging_type_by_pk?: Maybe<Eatfresh_Packaging_Type>;
  /** delete data from the table: "eatfresh.password_reset_token" */
  delete_eatfresh_password_reset_token?: Maybe<Eatfresh_Password_Reset_Token_Mutation_Response>;
  /** delete single row from the table: "eatfresh.password_reset_token" */
  delete_eatfresh_password_reset_token_by_pk?: Maybe<Eatfresh_Password_Reset_Token>;
  /** delete data from the table: "eatfresh.payment_method" */
  delete_eatfresh_payment_method?: Maybe<Eatfresh_Payment_Method_Mutation_Response>;
  /** delete single row from the table: "eatfresh.payment_method" */
  delete_eatfresh_payment_method_by_pk?: Maybe<Eatfresh_Payment_Method>;
  /** delete data from the table: "eatfresh.payment_method_type" */
  delete_eatfresh_payment_method_type?: Maybe<Eatfresh_Payment_Method_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.payment_method_type" */
  delete_eatfresh_payment_method_type_by_pk?: Maybe<Eatfresh_Payment_Method_Type>;
  /** delete data from the table: "eatfresh.payment_status" */
  delete_eatfresh_payment_status?: Maybe<Eatfresh_Payment_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.payment_status" */
  delete_eatfresh_payment_status_by_pk?: Maybe<Eatfresh_Payment_Status>;
  /** delete data from the table: "eatfresh.place" */
  delete_eatfresh_place?: Maybe<Eatfresh_Place_Mutation_Response>;
  /** delete single row from the table: "eatfresh.place" */
  delete_eatfresh_place_by_pk?: Maybe<Eatfresh_Place>;
  /** delete data from the table: "eatfresh.price_change" */
  delete_eatfresh_price_change?: Maybe<Eatfresh_Price_Change_Mutation_Response>;
  /** delete single row from the table: "eatfresh.price_change" */
  delete_eatfresh_price_change_by_pk?: Maybe<Eatfresh_Price_Change>;
  /** delete data from the table: "eatfresh.price_change_position" */
  delete_eatfresh_price_change_position?: Maybe<Eatfresh_Price_Change_Position_Mutation_Response>;
  /** delete single row from the table: "eatfresh.price_change_position" */
  delete_eatfresh_price_change_position_by_pk?: Maybe<Eatfresh_Price_Change_Position>;
  /** delete data from the table: "eatfresh.price_change_position_status" */
  delete_eatfresh_price_change_position_status?: Maybe<Eatfresh_Price_Change_Position_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.price_change_position_status" */
  delete_eatfresh_price_change_position_status_by_pk?: Maybe<Eatfresh_Price_Change_Position_Status>;
  /** delete data from the table: "eatfresh.price_lock" */
  delete_eatfresh_price_lock?: Maybe<Eatfresh_Price_Lock_Mutation_Response>;
  /** delete single row from the table: "eatfresh.price_lock" */
  delete_eatfresh_price_lock_by_pk?: Maybe<Eatfresh_Price_Lock>;
  /** delete data from the table: "eatfresh.product_orientation" */
  delete_eatfresh_product_orientation?: Maybe<Eatfresh_Product_Orientation_Mutation_Response>;
  /** delete single row from the table: "eatfresh.product_orientation" */
  delete_eatfresh_product_orientation_by_pk?: Maybe<Eatfresh_Product_Orientation>;
  /** delete data from the table: "eatfresh.refill" */
  delete_eatfresh_refill?: Maybe<Eatfresh_Refill_Mutation_Response>;
  /** delete single row from the table: "eatfresh.refill" */
  delete_eatfresh_refill_by_pk?: Maybe<Eatfresh_Refill>;
  /** delete data from the table: "eatfresh.refill_status" */
  delete_eatfresh_refill_status?: Maybe<Eatfresh_Refill_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.refill_status" */
  delete_eatfresh_refill_status_by_pk?: Maybe<Eatfresh_Refill_Status>;
  /** delete data from the table: "eatfresh.rfid_asset" */
  delete_eatfresh_rfid_asset?: Maybe<Eatfresh_Rfid_Asset_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_asset" */
  delete_eatfresh_rfid_asset_by_pk?: Maybe<Eatfresh_Rfid_Asset>;
  /** delete data from the table: "eatfresh.rfid_asset_type" */
  delete_eatfresh_rfid_asset_type?: Maybe<Eatfresh_Rfid_Asset_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_asset_type" */
  delete_eatfresh_rfid_asset_type_by_pk?: Maybe<Eatfresh_Rfid_Asset_Type>;
  /** delete data from the table: "eatfresh.rfid_box" */
  delete_eatfresh_rfid_box?: Maybe<Eatfresh_Rfid_Box_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_box" */
  delete_eatfresh_rfid_box_by_pk?: Maybe<Eatfresh_Rfid_Box>;
  /** delete data from the table: "eatfresh.rfid_box_type" */
  delete_eatfresh_rfid_box_type?: Maybe<Eatfresh_Rfid_Box_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_box_type" */
  delete_eatfresh_rfid_box_type_by_pk?: Maybe<Eatfresh_Rfid_Box_Type>;
  /** delete data from the table: "eatfresh.rfid_scan" */
  delete_eatfresh_rfid_scan?: Maybe<Eatfresh_Rfid_Scan_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_scan" */
  delete_eatfresh_rfid_scan_by_pk?: Maybe<Eatfresh_Rfid_Scan>;
  /** delete data from the table: "eatfresh.rfid_scan_status" */
  delete_eatfresh_rfid_scan_status?: Maybe<Eatfresh_Rfid_Scan_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_scan_status" */
  delete_eatfresh_rfid_scan_status_by_pk?: Maybe<Eatfresh_Rfid_Scan_Status>;
  /** delete data from the table: "eatfresh.rfid_scanner" */
  delete_eatfresh_rfid_scanner?: Maybe<Eatfresh_Rfid_Scanner_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_scanner" */
  delete_eatfresh_rfid_scanner_by_pk?: Maybe<Eatfresh_Rfid_Scanner>;
  /** delete data from the table: "eatfresh.rfid_scanner_type" */
  delete_eatfresh_rfid_scanner_type?: Maybe<Eatfresh_Rfid_Scanner_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_scanner_type" */
  delete_eatfresh_rfid_scanner_type_by_pk?: Maybe<Eatfresh_Rfid_Scanner_Type>;
  /** delete data from the table: "eatfresh.rfid_status" */
  delete_eatfresh_rfid_status?: Maybe<Eatfresh_Rfid_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_status" */
  delete_eatfresh_rfid_status_by_pk?: Maybe<Eatfresh_Rfid_Status>;
  /** delete data from the table: "eatfresh.rfid_tag" */
  delete_eatfresh_rfid_tag?: Maybe<Eatfresh_Rfid_Tag_Mutation_Response>;
  /** delete single row from the table: "eatfresh.rfid_tag" */
  delete_eatfresh_rfid_tag_by_pk?: Maybe<Eatfresh_Rfid_Tag>;
  /** delete data from the table: "eatfresh.selfly_cabinet_state" */
  delete_eatfresh_selfly_cabinet_state?: Maybe<Eatfresh_Selfly_Cabinet_State_Mutation_Response>;
  /** delete single row from the table: "eatfresh.selfly_cabinet_state" */
  delete_eatfresh_selfly_cabinet_state_by_pk?: Maybe<Eatfresh_Selfly_Cabinet_State>;
  /** delete data from the table: "eatfresh.session_step" */
  delete_eatfresh_session_step?: Maybe<Eatfresh_Session_Step_Mutation_Response>;
  /** delete single row from the table: "eatfresh.session_step" */
  delete_eatfresh_session_step_by_pk?: Maybe<Eatfresh_Session_Step>;
  /** delete data from the table: "eatfresh.shelf_type" */
  delete_eatfresh_shelf_type?: Maybe<Eatfresh_Shelf_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.shelf_type" */
  delete_eatfresh_shelf_type_by_pk?: Maybe<Eatfresh_Shelf_Type>;
  /** delete data from the table: "eatfresh.supplier_problem" */
  delete_eatfresh_supplier_problem?: Maybe<Eatfresh_Supplier_Problem_Mutation_Response>;
  /** delete single row from the table: "eatfresh.supplier_problem" */
  delete_eatfresh_supplier_problem_by_pk?: Maybe<Eatfresh_Supplier_Problem>;
  /** delete data from the table: "eatfresh.supplier_problem_to_file" */
  delete_eatfresh_supplier_problem_to_file?: Maybe<Eatfresh_Supplier_Problem_To_File_Mutation_Response>;
  /** delete single row from the table: "eatfresh.supplier_problem_to_file" */
  delete_eatfresh_supplier_problem_to_file_by_pk?: Maybe<Eatfresh_Supplier_Problem_To_File>;
  /** delete data from the table: "eatfresh.transaction_logs" */
  delete_eatfresh_transaction_logs?: Maybe<Eatfresh_Transaction_Logs_Mutation_Response>;
  /** delete single row from the table: "eatfresh.transaction_logs" */
  delete_eatfresh_transaction_logs_by_pk?: Maybe<Eatfresh_Transaction_Logs>;
  /** delete data from the table: "eatfresh.uploaded_file" */
  delete_eatfresh_uploaded_file?: Maybe<Eatfresh_Uploaded_File_Mutation_Response>;
  /** delete single row from the table: "eatfresh.uploaded_file" */
  delete_eatfresh_uploaded_file_by_pk?: Maybe<Eatfresh_Uploaded_File>;
  /** delete data from the table: "eatfresh.user_account" */
  delete_eatfresh_user_account?: Maybe<Eatfresh_User_Account_Mutation_Response>;
  /** delete single row from the table: "eatfresh.user_account" */
  delete_eatfresh_user_account_by_pk?: Maybe<Eatfresh_User_Account>;
  /** delete data from the table: "eatfresh.vat_category" */
  delete_eatfresh_vat_category?: Maybe<Eatfresh_Vat_Category_Mutation_Response>;
  /** delete single row from the table: "eatfresh.vat_category" */
  delete_eatfresh_vat_category_by_pk?: Maybe<Eatfresh_Vat_Category>;
  /** delete data from the table: "eatfresh.vitamin_mineral" */
  delete_eatfresh_vitamin_mineral?: Maybe<Eatfresh_Vitamin_Mineral_Mutation_Response>;
  /** delete single row from the table: "eatfresh.vitamin_mineral" */
  delete_eatfresh_vitamin_mineral_by_pk?: Maybe<Eatfresh_Vitamin_Mineral>;
  /** delete data from the table: "eatfresh.warehouse" */
  delete_eatfresh_warehouse?: Maybe<Eatfresh_Warehouse_Mutation_Response>;
  /** delete data from the table: "eatfresh.warehouse_assignment" */
  delete_eatfresh_warehouse_assignment?: Maybe<Eatfresh_Warehouse_Assignment_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_assignment" */
  delete_eatfresh_warehouse_assignment_by_pk?: Maybe<Eatfresh_Warehouse_Assignment>;
  /** delete single row from the table: "eatfresh.warehouse" */
  delete_eatfresh_warehouse_by_pk?: Maybe<Eatfresh_Warehouse>;
  /** delete data from the table: "eatfresh.warehouse_order" */
  delete_eatfresh_warehouse_order?: Maybe<Eatfresh_Warehouse_Order_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_order" */
  delete_eatfresh_warehouse_order_by_pk?: Maybe<Eatfresh_Warehouse_Order>;
  /** delete data from the table: "eatfresh.warehouse_order_position" */
  delete_eatfresh_warehouse_order_position?: Maybe<Eatfresh_Warehouse_Order_Position_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_order_position" */
  delete_eatfresh_warehouse_order_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Position>;
  /** delete data from the table: "eatfresh.warehouse_order_receipt" */
  delete_eatfresh_warehouse_order_receipt?: Maybe<Eatfresh_Warehouse_Order_Receipt_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_order_receipt" */
  delete_eatfresh_warehouse_order_receipt_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt>;
  /** delete data from the table: "eatfresh.warehouse_order_receipt_position" */
  delete_eatfresh_warehouse_order_receipt_position?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_order_receipt_position" */
  delete_eatfresh_warehouse_order_receipt_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** delete data from the table: "eatfresh.warehouse_order_status" */
  delete_eatfresh_warehouse_order_status?: Maybe<Eatfresh_Warehouse_Order_Status_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_order_status" */
  delete_eatfresh_warehouse_order_status_by_pk?: Maybe<Eatfresh_Warehouse_Order_Status>;
  /** delete data from the table: "eatfresh.warehouse_order_type" */
  delete_eatfresh_warehouse_order_type?: Maybe<Eatfresh_Warehouse_Order_Type_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_order_type" */
  delete_eatfresh_warehouse_order_type_by_pk?: Maybe<Eatfresh_Warehouse_Order_Type>;
  /** delete data from the table: "eatfresh.warehouse_shelf" */
  delete_eatfresh_warehouse_shelf?: Maybe<Eatfresh_Warehouse_Shelf_Mutation_Response>;
  /** delete single row from the table: "eatfresh.warehouse_shelf" */
  delete_eatfresh_warehouse_shelf_by_pk?: Maybe<Eatfresh_Warehouse_Shelf>;
  /** insert data into the table: "eatfresh.age_verification" */
  insert_eatfresh_age_verification?: Maybe<Eatfresh_Age_Verification_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.age_verification" */
  insert_eatfresh_age_verification_one?: Maybe<Eatfresh_Age_Verification>;
  /** insert data into the table: "eatfresh.age_verification_status" */
  insert_eatfresh_age_verification_status?: Maybe<Eatfresh_Age_Verification_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.age_verification_status" */
  insert_eatfresh_age_verification_status_one?: Maybe<Eatfresh_Age_Verification_Status>;
  /** insert data into the table: "eatfresh.age_verification_type" */
  insert_eatfresh_age_verification_type?: Maybe<Eatfresh_Age_Verification_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.age_verification_type" */
  insert_eatfresh_age_verification_type_one?: Maybe<Eatfresh_Age_Verification_Type>;
  /** insert data into the table: "eatfresh.article" */
  insert_eatfresh_article?: Maybe<Eatfresh_Article_Mutation_Response>;
  /** insert data into the table: "eatfresh.article_details" */
  insert_eatfresh_article_details?: Maybe<Eatfresh_Article_Details_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.article_details" */
  insert_eatfresh_article_details_one?: Maybe<Eatfresh_Article_Details>;
  /** insert data into the table: "eatfresh.article_labeling_process" */
  insert_eatfresh_article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.article_labeling_process" */
  insert_eatfresh_article_labeling_process_one?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** insert data into the table: "eatfresh.article_labeling_process_status" */
  insert_eatfresh_article_labeling_process_status?: Maybe<Eatfresh_Article_Labeling_Process_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.article_labeling_process_status" */
  insert_eatfresh_article_labeling_process_status_one?: Maybe<Eatfresh_Article_Labeling_Process_Status>;
  /** insert a single row into the table: "eatfresh.article" */
  insert_eatfresh_article_one?: Maybe<Eatfresh_Article>;
  /** insert data into the table: "eatfresh.asset_placement" */
  insert_eatfresh_asset_placement?: Maybe<Eatfresh_Asset_Placement_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.asset_placement" */
  insert_eatfresh_asset_placement_one?: Maybe<Eatfresh_Asset_Placement>;
  /** insert data into the table: "eatfresh.asset_transfer" */
  insert_eatfresh_asset_transfer?: Maybe<Eatfresh_Asset_Transfer_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.asset_transfer" */
  insert_eatfresh_asset_transfer_one?: Maybe<Eatfresh_Asset_Transfer>;
  /** insert data into the table: "eatfresh.asset_transfer_problem" */
  insert_eatfresh_asset_transfer_problem?: Maybe<Eatfresh_Asset_Transfer_Problem_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.asset_transfer_problem" */
  insert_eatfresh_asset_transfer_problem_one?: Maybe<Eatfresh_Asset_Transfer_Problem>;
  /** insert data into the table: "eatfresh.asset_transfer_problem_severity" */
  insert_eatfresh_asset_transfer_problem_severity?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.asset_transfer_problem_severity" */
  insert_eatfresh_asset_transfer_problem_severity_one?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** insert data into the table: "eatfresh.asset_transfer_problem_status" */
  insert_eatfresh_asset_transfer_problem_status?: Maybe<Eatfresh_Asset_Transfer_Problem_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.asset_transfer_problem_status" */
  insert_eatfresh_asset_transfer_problem_status_one?: Maybe<Eatfresh_Asset_Transfer_Problem_Status>;
  /** insert data into the table: "eatfresh.auth_token" */
  insert_eatfresh_auth_token?: Maybe<Eatfresh_Auth_Token_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.auth_token" */
  insert_eatfresh_auth_token_one?: Maybe<Eatfresh_Auth_Token>;
  /** insert data into the table: "eatfresh.authenticators" */
  insert_eatfresh_authenticators?: Maybe<Eatfresh_Authenticators_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.authenticators" */
  insert_eatfresh_authenticators_one?: Maybe<Eatfresh_Authenticators>;
  /** insert data into the table: "eatfresh.b2b_customer" */
  insert_eatfresh_b2b_customer?: Maybe<Eatfresh_B2b_Customer_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.b2b_customer" */
  insert_eatfresh_b2b_customer_one?: Maybe<Eatfresh_B2b_Customer>;
  /** insert data into the table: "eatfresh.b2b_customer_type" */
  insert_eatfresh_b2b_customer_type?: Maybe<Eatfresh_B2b_Customer_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.b2b_customer_type" */
  insert_eatfresh_b2b_customer_type_one?: Maybe<Eatfresh_B2b_Customer_Type>;
  /** insert data into the table: "eatfresh.basic_user_type" */
  insert_eatfresh_basic_user_type?: Maybe<Eatfresh_Basic_User_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.basic_user_type" */
  insert_eatfresh_basic_user_type_one?: Maybe<Eatfresh_Basic_User_Type>;
  /** insert data into the table: "eatfresh.box_content_plan" */
  insert_eatfresh_box_content_plan?: Maybe<Eatfresh_Box_Content_Plan_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.box_content_plan" */
  insert_eatfresh_box_content_plan_one?: Maybe<Eatfresh_Box_Content_Plan>;
  /** insert data into the table: "eatfresh.box_content_plan_status" */
  insert_eatfresh_box_content_plan_status?: Maybe<Eatfresh_Box_Content_Plan_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.box_content_plan_status" */
  insert_eatfresh_box_content_plan_status_one?: Maybe<Eatfresh_Box_Content_Plan_Status>;
  /** insert data into the table: "eatfresh.box_content_to_article" */
  insert_eatfresh_box_content_to_article?: Maybe<Eatfresh_Box_Content_To_Article_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.box_content_to_article" */
  insert_eatfresh_box_content_to_article_one?: Maybe<Eatfresh_Box_Content_To_Article>;
  /** insert data into the table: "eatfresh.commissioning_process" */
  insert_eatfresh_commissioning_process?: Maybe<Eatfresh_Commissioning_Process_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.commissioning_process" */
  insert_eatfresh_commissioning_process_one?: Maybe<Eatfresh_Commissioning_Process>;
  /** insert data into the table: "eatfresh.commissioning_process_position" */
  insert_eatfresh_commissioning_process_position?: Maybe<Eatfresh_Commissioning_Process_Position_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.commissioning_process_position" */
  insert_eatfresh_commissioning_process_position_one?: Maybe<Eatfresh_Commissioning_Process_Position>;
  /** insert data into the table: "eatfresh.commissioning_process_status" */
  insert_eatfresh_commissioning_process_status?: Maybe<Eatfresh_Commissioning_Process_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.commissioning_process_status" */
  insert_eatfresh_commissioning_process_status_one?: Maybe<Eatfresh_Commissioning_Process_Status>;
  /** insert data into the table: "eatfresh.computop_transaction" */
  insert_eatfresh_computop_transaction?: Maybe<Eatfresh_Computop_Transaction_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.computop_transaction" */
  insert_eatfresh_computop_transaction_one?: Maybe<Eatfresh_Computop_Transaction>;
  /** insert data into the table: "eatfresh.connection_status" */
  insert_eatfresh_connection_status?: Maybe<Eatfresh_Connection_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.connection_status" */
  insert_eatfresh_connection_status_one?: Maybe<Eatfresh_Connection_Status>;
  /** insert data into the table: "eatfresh.cost_configuration" */
  insert_eatfresh_cost_configuration?: Maybe<Eatfresh_Cost_Configuration_Mutation_Response>;
  /** insert data into the table: "eatfresh.cost_configuration_key" */
  insert_eatfresh_cost_configuration_key?: Maybe<Eatfresh_Cost_Configuration_Key_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.cost_configuration_key" */
  insert_eatfresh_cost_configuration_key_one?: Maybe<Eatfresh_Cost_Configuration_Key>;
  /** insert a single row into the table: "eatfresh.cost_configuration" */
  insert_eatfresh_cost_configuration_one?: Maybe<Eatfresh_Cost_Configuration>;
  /** insert data into the table: "eatfresh.customer" */
  insert_eatfresh_customer?: Maybe<Eatfresh_Customer_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.customer" */
  insert_eatfresh_customer_one?: Maybe<Eatfresh_Customer>;
  /** insert data into the table: "eatfresh.customer_order" */
  insert_eatfresh_customer_order?: Maybe<Eatfresh_Customer_Order_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.customer_order" */
  insert_eatfresh_customer_order_one?: Maybe<Eatfresh_Customer_Order>;
  /** insert data into the table: "eatfresh.door_status" */
  insert_eatfresh_door_status?: Maybe<Eatfresh_Door_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.door_status" */
  insert_eatfresh_door_status_one?: Maybe<Eatfresh_Door_Status>;
  /** insert data into the table: "eatfresh.easy_refill_permission" */
  insert_eatfresh_easy_refill_permission?: Maybe<Eatfresh_Easy_Refill_Permission_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.easy_refill_permission" */
  insert_eatfresh_easy_refill_permission_one?: Maybe<Eatfresh_Easy_Refill_Permission>;
  /** insert data into the table: "eatfresh.external_warehouse_pallet_spot" */
  insert_eatfresh_external_warehouse_pallet_spot?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.external_warehouse_pallet_spot" */
  insert_eatfresh_external_warehouse_pallet_spot_one?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** insert data into the table: "eatfresh.flyway_schema_history" */
  insert_eatfresh_flyway_schema_history?: Maybe<Eatfresh_Flyway_Schema_History_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.flyway_schema_history" */
  insert_eatfresh_flyway_schema_history_one?: Maybe<Eatfresh_Flyway_Schema_History>;
  /** insert data into the table: "eatfresh.fridge" */
  insert_eatfresh_fridge?: Maybe<Eatfresh_Fridge_Mutation_Response>;
  /** insert data into the table: "eatfresh.fridge_alarm" */
  insert_eatfresh_fridge_alarm?: Maybe<Eatfresh_Fridge_Alarm_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_alarm" */
  insert_eatfresh_fridge_alarm_one?: Maybe<Eatfresh_Fridge_Alarm>;
  /** insert data into the table: "eatfresh.fridge_article_stock_snapshot" */
  insert_eatfresh_fridge_article_stock_snapshot?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_article_stock_snapshot" */
  insert_eatfresh_fridge_article_stock_snapshot_one?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** insert data into the table: "eatfresh.fridge_event" */
  insert_eatfresh_fridge_event?: Maybe<Eatfresh_Fridge_Event_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_event" */
  insert_eatfresh_fridge_event_one?: Maybe<Eatfresh_Fridge_Event>;
  /** insert data into the table: "eatfresh.fridge_event_type" */
  insert_eatfresh_fridge_event_type?: Maybe<Eatfresh_Fridge_Event_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_event_type" */
  insert_eatfresh_fridge_event_type_one?: Maybe<Eatfresh_Fridge_Event_Type>;
  /** insert data into the table: "eatfresh.fridge_layout" */
  insert_eatfresh_fridge_layout?: Maybe<Eatfresh_Fridge_Layout_Mutation_Response>;
  /** insert data into the table: "eatfresh.fridge_layout_assignment" */
  insert_eatfresh_fridge_layout_assignment?: Maybe<Eatfresh_Fridge_Layout_Assignment_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_layout_assignment" */
  insert_eatfresh_fridge_layout_assignment_one?: Maybe<Eatfresh_Fridge_Layout_Assignment>;
  /** insert data into the table: "eatfresh.fridge_layout_assignment_status" */
  insert_eatfresh_fridge_layout_assignment_status?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_layout_assignment_status" */
  insert_eatfresh_fridge_layout_assignment_status_one?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** insert data into the table: "eatfresh.fridge_layout_level" */
  insert_eatfresh_fridge_layout_level?: Maybe<Eatfresh_Fridge_Layout_Level_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_layout_level" */
  insert_eatfresh_fridge_layout_level_one?: Maybe<Eatfresh_Fridge_Layout_Level>;
  /** insert data into the table: "eatfresh.fridge_layout_level_position" */
  insert_eatfresh_fridge_layout_level_position?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_layout_level_position" */
  insert_eatfresh_fridge_layout_level_position_one?: Maybe<Eatfresh_Fridge_Layout_Level_Position>;
  /** insert a single row into the table: "eatfresh.fridge_layout" */
  insert_eatfresh_fridge_layout_one?: Maybe<Eatfresh_Fridge_Layout>;
  /** insert a single row into the table: "eatfresh.fridge" */
  insert_eatfresh_fridge_one?: Maybe<Eatfresh_Fridge>;
  /** insert data into the table: "eatfresh.fridge_order" */
  insert_eatfresh_fridge_order?: Maybe<Eatfresh_Fridge_Order_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_order" */
  insert_eatfresh_fridge_order_one?: Maybe<Eatfresh_Fridge_Order>;
  /** insert data into the table: "eatfresh.fridge_status_history" */
  insert_eatfresh_fridge_status_history?: Maybe<Eatfresh_Fridge_Status_History_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_status_history" */
  insert_eatfresh_fridge_status_history_one?: Maybe<Eatfresh_Fridge_Status_History>;
  /** insert data into the table: "eatfresh.fridge_stock" */
  insert_eatfresh_fridge_stock?: Maybe<Eatfresh_Fridge_Stock_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_stock" */
  insert_eatfresh_fridge_stock_one?: Maybe<Eatfresh_Fridge_Stock>;
  /** insert data into the table: "eatfresh.fridge_target_stock" */
  insert_eatfresh_fridge_target_stock?: Maybe<Eatfresh_Fridge_Target_Stock_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_target_stock" */
  insert_eatfresh_fridge_target_stock_one?: Maybe<Eatfresh_Fridge_Target_Stock>;
  /** insert data into the table: "eatfresh.fridge_target_stock_position" */
  insert_eatfresh_fridge_target_stock_position?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_target_stock_position" */
  insert_eatfresh_fridge_target_stock_position_one?: Maybe<Eatfresh_Fridge_Target_Stock_Position>;
  /** insert data into the table: "eatfresh.fridge_type" */
  insert_eatfresh_fridge_type?: Maybe<Eatfresh_Fridge_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.fridge_type" */
  insert_eatfresh_fridge_type_one?: Maybe<Eatfresh_Fridge_Type>;
  /** insert data into the table: "eatfresh.logistics_problem" */
  insert_eatfresh_logistics_problem?: Maybe<Eatfresh_Logistics_Problem_Mutation_Response>;
  /** insert data into the table: "eatfresh.logistics_problem_image" */
  insert_eatfresh_logistics_problem_image?: Maybe<Eatfresh_Logistics_Problem_Image_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.logistics_problem_image" */
  insert_eatfresh_logistics_problem_image_one?: Maybe<Eatfresh_Logistics_Problem_Image>;
  /** insert a single row into the table: "eatfresh.logistics_problem" */
  insert_eatfresh_logistics_problem_one?: Maybe<Eatfresh_Logistics_Problem>;
  /** insert data into the table: "eatfresh.logistics_problem_status" */
  insert_eatfresh_logistics_problem_status?: Maybe<Eatfresh_Logistics_Problem_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.logistics_problem_status" */
  insert_eatfresh_logistics_problem_status_one?: Maybe<Eatfresh_Logistics_Problem_Status>;
  /** insert data into the table: "eatfresh.logistics_process_type" */
  insert_eatfresh_logistics_process_type?: Maybe<Eatfresh_Logistics_Process_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.logistics_process_type" */
  insert_eatfresh_logistics_process_type_one?: Maybe<Eatfresh_Logistics_Process_Type>;
  /** insert data into the table: "eatfresh.nutrition_information" */
  insert_eatfresh_nutrition_information?: Maybe<Eatfresh_Nutrition_Information_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.nutrition_information" */
  insert_eatfresh_nutrition_information_one?: Maybe<Eatfresh_Nutrition_Information>;
  /** insert data into the table: "eatfresh.order_extra" */
  insert_eatfresh_order_extra?: Maybe<Eatfresh_Order_Extra_Mutation_Response>;
  /** insert data into the table: "eatfresh.order_extra_customer_order" */
  insert_eatfresh_order_extra_customer_order?: Maybe<Eatfresh_Order_Extra_Customer_Order_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.order_extra_customer_order" */
  insert_eatfresh_order_extra_customer_order_one?: Maybe<Eatfresh_Order_Extra_Customer_Order>;
  /** insert a single row into the table: "eatfresh.order_extra" */
  insert_eatfresh_order_extra_one?: Maybe<Eatfresh_Order_Extra>;
  /** insert data into the table: "eatfresh.order_position" */
  insert_eatfresh_order_position?: Maybe<Eatfresh_Order_Position_Mutation_Response>;
  /** insert data into the table: "eatfresh.order_position_category" */
  insert_eatfresh_order_position_category?: Maybe<Eatfresh_Order_Position_Category_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.order_position_category" */
  insert_eatfresh_order_position_category_one?: Maybe<Eatfresh_Order_Position_Category>;
  /** insert a single row into the table: "eatfresh.order_position" */
  insert_eatfresh_order_position_one?: Maybe<Eatfresh_Order_Position>;
  /** insert data into the table: "eatfresh.order_status" */
  insert_eatfresh_order_status?: Maybe<Eatfresh_Order_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.order_status" */
  insert_eatfresh_order_status_one?: Maybe<Eatfresh_Order_Status>;
  /** insert data into the table: "eatfresh.packaging_type" */
  insert_eatfresh_packaging_type?: Maybe<Eatfresh_Packaging_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.packaging_type" */
  insert_eatfresh_packaging_type_one?: Maybe<Eatfresh_Packaging_Type>;
  /** insert data into the table: "eatfresh.password_reset_token" */
  insert_eatfresh_password_reset_token?: Maybe<Eatfresh_Password_Reset_Token_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.password_reset_token" */
  insert_eatfresh_password_reset_token_one?: Maybe<Eatfresh_Password_Reset_Token>;
  /** insert data into the table: "eatfresh.payment_method" */
  insert_eatfresh_payment_method?: Maybe<Eatfresh_Payment_Method_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.payment_method" */
  insert_eatfresh_payment_method_one?: Maybe<Eatfresh_Payment_Method>;
  /** insert data into the table: "eatfresh.payment_method_type" */
  insert_eatfresh_payment_method_type?: Maybe<Eatfresh_Payment_Method_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.payment_method_type" */
  insert_eatfresh_payment_method_type_one?: Maybe<Eatfresh_Payment_Method_Type>;
  /** insert data into the table: "eatfresh.payment_status" */
  insert_eatfresh_payment_status?: Maybe<Eatfresh_Payment_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.payment_status" */
  insert_eatfresh_payment_status_one?: Maybe<Eatfresh_Payment_Status>;
  /** insert data into the table: "eatfresh.place" */
  insert_eatfresh_place?: Maybe<Eatfresh_Place_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.place" */
  insert_eatfresh_place_one?: Maybe<Eatfresh_Place>;
  /** insert data into the table: "eatfresh.price_change" */
  insert_eatfresh_price_change?: Maybe<Eatfresh_Price_Change_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.price_change" */
  insert_eatfresh_price_change_one?: Maybe<Eatfresh_Price_Change>;
  /** insert data into the table: "eatfresh.price_change_position" */
  insert_eatfresh_price_change_position?: Maybe<Eatfresh_Price_Change_Position_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.price_change_position" */
  insert_eatfresh_price_change_position_one?: Maybe<Eatfresh_Price_Change_Position>;
  /** insert data into the table: "eatfresh.price_change_position_status" */
  insert_eatfresh_price_change_position_status?: Maybe<Eatfresh_Price_Change_Position_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.price_change_position_status" */
  insert_eatfresh_price_change_position_status_one?: Maybe<Eatfresh_Price_Change_Position_Status>;
  /** insert data into the table: "eatfresh.price_lock" */
  insert_eatfresh_price_lock?: Maybe<Eatfresh_Price_Lock_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.price_lock" */
  insert_eatfresh_price_lock_one?: Maybe<Eatfresh_Price_Lock>;
  /** insert data into the table: "eatfresh.product_orientation" */
  insert_eatfresh_product_orientation?: Maybe<Eatfresh_Product_Orientation_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.product_orientation" */
  insert_eatfresh_product_orientation_one?: Maybe<Eatfresh_Product_Orientation>;
  /** insert data into the table: "eatfresh.refill" */
  insert_eatfresh_refill?: Maybe<Eatfresh_Refill_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.refill" */
  insert_eatfresh_refill_one?: Maybe<Eatfresh_Refill>;
  /** insert data into the table: "eatfresh.refill_status" */
  insert_eatfresh_refill_status?: Maybe<Eatfresh_Refill_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.refill_status" */
  insert_eatfresh_refill_status_one?: Maybe<Eatfresh_Refill_Status>;
  /** insert data into the table: "eatfresh.rfid_asset" */
  insert_eatfresh_rfid_asset?: Maybe<Eatfresh_Rfid_Asset_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_asset" */
  insert_eatfresh_rfid_asset_one?: Maybe<Eatfresh_Rfid_Asset>;
  /** insert data into the table: "eatfresh.rfid_asset_type" */
  insert_eatfresh_rfid_asset_type?: Maybe<Eatfresh_Rfid_Asset_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_asset_type" */
  insert_eatfresh_rfid_asset_type_one?: Maybe<Eatfresh_Rfid_Asset_Type>;
  /** insert data into the table: "eatfresh.rfid_box" */
  insert_eatfresh_rfid_box?: Maybe<Eatfresh_Rfid_Box_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_box" */
  insert_eatfresh_rfid_box_one?: Maybe<Eatfresh_Rfid_Box>;
  /** insert data into the table: "eatfresh.rfid_box_type" */
  insert_eatfresh_rfid_box_type?: Maybe<Eatfresh_Rfid_Box_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_box_type" */
  insert_eatfresh_rfid_box_type_one?: Maybe<Eatfresh_Rfid_Box_Type>;
  /** insert data into the table: "eatfresh.rfid_scan" */
  insert_eatfresh_rfid_scan?: Maybe<Eatfresh_Rfid_Scan_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_scan" */
  insert_eatfresh_rfid_scan_one?: Maybe<Eatfresh_Rfid_Scan>;
  /** insert data into the table: "eatfresh.rfid_scan_status" */
  insert_eatfresh_rfid_scan_status?: Maybe<Eatfresh_Rfid_Scan_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_scan_status" */
  insert_eatfresh_rfid_scan_status_one?: Maybe<Eatfresh_Rfid_Scan_Status>;
  /** insert data into the table: "eatfresh.rfid_scanner" */
  insert_eatfresh_rfid_scanner?: Maybe<Eatfresh_Rfid_Scanner_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_scanner" */
  insert_eatfresh_rfid_scanner_one?: Maybe<Eatfresh_Rfid_Scanner>;
  /** insert data into the table: "eatfresh.rfid_scanner_type" */
  insert_eatfresh_rfid_scanner_type?: Maybe<Eatfresh_Rfid_Scanner_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_scanner_type" */
  insert_eatfresh_rfid_scanner_type_one?: Maybe<Eatfresh_Rfid_Scanner_Type>;
  /** insert data into the table: "eatfresh.rfid_status" */
  insert_eatfresh_rfid_status?: Maybe<Eatfresh_Rfid_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_status" */
  insert_eatfresh_rfid_status_one?: Maybe<Eatfresh_Rfid_Status>;
  /** insert data into the table: "eatfresh.rfid_tag" */
  insert_eatfresh_rfid_tag?: Maybe<Eatfresh_Rfid_Tag_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.rfid_tag" */
  insert_eatfresh_rfid_tag_one?: Maybe<Eatfresh_Rfid_Tag>;
  /** insert data into the table: "eatfresh.selfly_cabinet_state" */
  insert_eatfresh_selfly_cabinet_state?: Maybe<Eatfresh_Selfly_Cabinet_State_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.selfly_cabinet_state" */
  insert_eatfresh_selfly_cabinet_state_one?: Maybe<Eatfresh_Selfly_Cabinet_State>;
  /** insert data into the table: "eatfresh.session_step" */
  insert_eatfresh_session_step?: Maybe<Eatfresh_Session_Step_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.session_step" */
  insert_eatfresh_session_step_one?: Maybe<Eatfresh_Session_Step>;
  /** insert data into the table: "eatfresh.shelf_type" */
  insert_eatfresh_shelf_type?: Maybe<Eatfresh_Shelf_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.shelf_type" */
  insert_eatfresh_shelf_type_one?: Maybe<Eatfresh_Shelf_Type>;
  /** insert data into the table: "eatfresh.supplier_problem" */
  insert_eatfresh_supplier_problem?: Maybe<Eatfresh_Supplier_Problem_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.supplier_problem" */
  insert_eatfresh_supplier_problem_one?: Maybe<Eatfresh_Supplier_Problem>;
  /** insert data into the table: "eatfresh.supplier_problem_to_file" */
  insert_eatfresh_supplier_problem_to_file?: Maybe<Eatfresh_Supplier_Problem_To_File_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.supplier_problem_to_file" */
  insert_eatfresh_supplier_problem_to_file_one?: Maybe<Eatfresh_Supplier_Problem_To_File>;
  /** insert data into the table: "eatfresh.transaction_logs" */
  insert_eatfresh_transaction_logs?: Maybe<Eatfresh_Transaction_Logs_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.transaction_logs" */
  insert_eatfresh_transaction_logs_one?: Maybe<Eatfresh_Transaction_Logs>;
  /** insert data into the table: "eatfresh.uploaded_file" */
  insert_eatfresh_uploaded_file?: Maybe<Eatfresh_Uploaded_File_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.uploaded_file" */
  insert_eatfresh_uploaded_file_one?: Maybe<Eatfresh_Uploaded_File>;
  /** insert data into the table: "eatfresh.user_account" */
  insert_eatfresh_user_account?: Maybe<Eatfresh_User_Account_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.user_account" */
  insert_eatfresh_user_account_one?: Maybe<Eatfresh_User_Account>;
  /** insert data into the table: "eatfresh.vat_category" */
  insert_eatfresh_vat_category?: Maybe<Eatfresh_Vat_Category_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.vat_category" */
  insert_eatfresh_vat_category_one?: Maybe<Eatfresh_Vat_Category>;
  /** insert data into the table: "eatfresh.vitamin_mineral" */
  insert_eatfresh_vitamin_mineral?: Maybe<Eatfresh_Vitamin_Mineral_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.vitamin_mineral" */
  insert_eatfresh_vitamin_mineral_one?: Maybe<Eatfresh_Vitamin_Mineral>;
  /** insert data into the table: "eatfresh.warehouse" */
  insert_eatfresh_warehouse?: Maybe<Eatfresh_Warehouse_Mutation_Response>;
  /** insert data into the table: "eatfresh.warehouse_assignment" */
  insert_eatfresh_warehouse_assignment?: Maybe<Eatfresh_Warehouse_Assignment_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_assignment" */
  insert_eatfresh_warehouse_assignment_one?: Maybe<Eatfresh_Warehouse_Assignment>;
  /** insert a single row into the table: "eatfresh.warehouse" */
  insert_eatfresh_warehouse_one?: Maybe<Eatfresh_Warehouse>;
  /** insert data into the table: "eatfresh.warehouse_order" */
  insert_eatfresh_warehouse_order?: Maybe<Eatfresh_Warehouse_Order_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_order" */
  insert_eatfresh_warehouse_order_one?: Maybe<Eatfresh_Warehouse_Order>;
  /** insert data into the table: "eatfresh.warehouse_order_position" */
  insert_eatfresh_warehouse_order_position?: Maybe<Eatfresh_Warehouse_Order_Position_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_order_position" */
  insert_eatfresh_warehouse_order_position_one?: Maybe<Eatfresh_Warehouse_Order_Position>;
  /** insert data into the table: "eatfresh.warehouse_order_receipt" */
  insert_eatfresh_warehouse_order_receipt?: Maybe<Eatfresh_Warehouse_Order_Receipt_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_order_receipt" */
  insert_eatfresh_warehouse_order_receipt_one?: Maybe<Eatfresh_Warehouse_Order_Receipt>;
  /** insert data into the table: "eatfresh.warehouse_order_receipt_position" */
  insert_eatfresh_warehouse_order_receipt_position?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_order_receipt_position" */
  insert_eatfresh_warehouse_order_receipt_position_one?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** insert data into the table: "eatfresh.warehouse_order_status" */
  insert_eatfresh_warehouse_order_status?: Maybe<Eatfresh_Warehouse_Order_Status_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_order_status" */
  insert_eatfresh_warehouse_order_status_one?: Maybe<Eatfresh_Warehouse_Order_Status>;
  /** insert data into the table: "eatfresh.warehouse_order_type" */
  insert_eatfresh_warehouse_order_type?: Maybe<Eatfresh_Warehouse_Order_Type_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_order_type" */
  insert_eatfresh_warehouse_order_type_one?: Maybe<Eatfresh_Warehouse_Order_Type>;
  /** insert data into the table: "eatfresh.warehouse_shelf" */
  insert_eatfresh_warehouse_shelf?: Maybe<Eatfresh_Warehouse_Shelf_Mutation_Response>;
  /** insert a single row into the table: "eatfresh.warehouse_shelf" */
  insert_eatfresh_warehouse_shelf_one?: Maybe<Eatfresh_Warehouse_Shelf>;
  /** update data of the table: "eatfresh.age_verification" */
  update_eatfresh_age_verification?: Maybe<Eatfresh_Age_Verification_Mutation_Response>;
  /** update single row of the table: "eatfresh.age_verification" */
  update_eatfresh_age_verification_by_pk?: Maybe<Eatfresh_Age_Verification>;
  /** update multiples rows of table: "eatfresh.age_verification" */
  update_eatfresh_age_verification_many?: Maybe<Array<Maybe<Eatfresh_Age_Verification_Mutation_Response>>>;
  /** update data of the table: "eatfresh.age_verification_status" */
  update_eatfresh_age_verification_status?: Maybe<Eatfresh_Age_Verification_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.age_verification_status" */
  update_eatfresh_age_verification_status_by_pk?: Maybe<Eatfresh_Age_Verification_Status>;
  /** update multiples rows of table: "eatfresh.age_verification_status" */
  update_eatfresh_age_verification_status_many?: Maybe<Array<Maybe<Eatfresh_Age_Verification_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.age_verification_type" */
  update_eatfresh_age_verification_type?: Maybe<Eatfresh_Age_Verification_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.age_verification_type" */
  update_eatfresh_age_verification_type_by_pk?: Maybe<Eatfresh_Age_Verification_Type>;
  /** update multiples rows of table: "eatfresh.age_verification_type" */
  update_eatfresh_age_verification_type_many?: Maybe<Array<Maybe<Eatfresh_Age_Verification_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.article" */
  update_eatfresh_article?: Maybe<Eatfresh_Article_Mutation_Response>;
  /** update single row of the table: "eatfresh.article" */
  update_eatfresh_article_by_pk?: Maybe<Eatfresh_Article>;
  /** update data of the table: "eatfresh.article_details" */
  update_eatfresh_article_details?: Maybe<Eatfresh_Article_Details_Mutation_Response>;
  /** update single row of the table: "eatfresh.article_details" */
  update_eatfresh_article_details_by_pk?: Maybe<Eatfresh_Article_Details>;
  /** update multiples rows of table: "eatfresh.article_details" */
  update_eatfresh_article_details_many?: Maybe<Array<Maybe<Eatfresh_Article_Details_Mutation_Response>>>;
  /** update data of the table: "eatfresh.article_labeling_process" */
  update_eatfresh_article_labeling_process?: Maybe<Eatfresh_Article_Labeling_Process_Mutation_Response>;
  /** update single row of the table: "eatfresh.article_labeling_process" */
  update_eatfresh_article_labeling_process_by_pk?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** update multiples rows of table: "eatfresh.article_labeling_process" */
  update_eatfresh_article_labeling_process_many?: Maybe<Array<Maybe<Eatfresh_Article_Labeling_Process_Mutation_Response>>>;
  /** update data of the table: "eatfresh.article_labeling_process_status" */
  update_eatfresh_article_labeling_process_status?: Maybe<Eatfresh_Article_Labeling_Process_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.article_labeling_process_status" */
  update_eatfresh_article_labeling_process_status_by_pk?: Maybe<Eatfresh_Article_Labeling_Process_Status>;
  /** update multiples rows of table: "eatfresh.article_labeling_process_status" */
  update_eatfresh_article_labeling_process_status_many?: Maybe<Array<Maybe<Eatfresh_Article_Labeling_Process_Status_Mutation_Response>>>;
  /** update multiples rows of table: "eatfresh.article" */
  update_eatfresh_article_many?: Maybe<Array<Maybe<Eatfresh_Article_Mutation_Response>>>;
  /** update data of the table: "eatfresh.asset_placement" */
  update_eatfresh_asset_placement?: Maybe<Eatfresh_Asset_Placement_Mutation_Response>;
  /** update single row of the table: "eatfresh.asset_placement" */
  update_eatfresh_asset_placement_by_pk?: Maybe<Eatfresh_Asset_Placement>;
  /** update multiples rows of table: "eatfresh.asset_placement" */
  update_eatfresh_asset_placement_many?: Maybe<Array<Maybe<Eatfresh_Asset_Placement_Mutation_Response>>>;
  /** update data of the table: "eatfresh.asset_transfer" */
  update_eatfresh_asset_transfer?: Maybe<Eatfresh_Asset_Transfer_Mutation_Response>;
  /** update single row of the table: "eatfresh.asset_transfer" */
  update_eatfresh_asset_transfer_by_pk?: Maybe<Eatfresh_Asset_Transfer>;
  /** update multiples rows of table: "eatfresh.asset_transfer" */
  update_eatfresh_asset_transfer_many?: Maybe<Array<Maybe<Eatfresh_Asset_Transfer_Mutation_Response>>>;
  /** update data of the table: "eatfresh.asset_transfer_problem" */
  update_eatfresh_asset_transfer_problem?: Maybe<Eatfresh_Asset_Transfer_Problem_Mutation_Response>;
  /** update single row of the table: "eatfresh.asset_transfer_problem" */
  update_eatfresh_asset_transfer_problem_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem>;
  /** update multiples rows of table: "eatfresh.asset_transfer_problem" */
  update_eatfresh_asset_transfer_problem_many?: Maybe<Array<Maybe<Eatfresh_Asset_Transfer_Problem_Mutation_Response>>>;
  /** update data of the table: "eatfresh.asset_transfer_problem_severity" */
  update_eatfresh_asset_transfer_problem_severity?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity_Mutation_Response>;
  /** update single row of the table: "eatfresh.asset_transfer_problem_severity" */
  update_eatfresh_asset_transfer_problem_severity_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** update multiples rows of table: "eatfresh.asset_transfer_problem_severity" */
  update_eatfresh_asset_transfer_problem_severity_many?: Maybe<Array<Maybe<Eatfresh_Asset_Transfer_Problem_Severity_Mutation_Response>>>;
  /** update data of the table: "eatfresh.asset_transfer_problem_status" */
  update_eatfresh_asset_transfer_problem_status?: Maybe<Eatfresh_Asset_Transfer_Problem_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.asset_transfer_problem_status" */
  update_eatfresh_asset_transfer_problem_status_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Status>;
  /** update multiples rows of table: "eatfresh.asset_transfer_problem_status" */
  update_eatfresh_asset_transfer_problem_status_many?: Maybe<Array<Maybe<Eatfresh_Asset_Transfer_Problem_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.auth_token" */
  update_eatfresh_auth_token?: Maybe<Eatfresh_Auth_Token_Mutation_Response>;
  /** update single row of the table: "eatfresh.auth_token" */
  update_eatfresh_auth_token_by_pk?: Maybe<Eatfresh_Auth_Token>;
  /** update multiples rows of table: "eatfresh.auth_token" */
  update_eatfresh_auth_token_many?: Maybe<Array<Maybe<Eatfresh_Auth_Token_Mutation_Response>>>;
  /** update data of the table: "eatfresh.authenticators" */
  update_eatfresh_authenticators?: Maybe<Eatfresh_Authenticators_Mutation_Response>;
  /** update single row of the table: "eatfresh.authenticators" */
  update_eatfresh_authenticators_by_pk?: Maybe<Eatfresh_Authenticators>;
  /** update multiples rows of table: "eatfresh.authenticators" */
  update_eatfresh_authenticators_many?: Maybe<Array<Maybe<Eatfresh_Authenticators_Mutation_Response>>>;
  /** update data of the table: "eatfresh.b2b_customer" */
  update_eatfresh_b2b_customer?: Maybe<Eatfresh_B2b_Customer_Mutation_Response>;
  /** update single row of the table: "eatfresh.b2b_customer" */
  update_eatfresh_b2b_customer_by_pk?: Maybe<Eatfresh_B2b_Customer>;
  /** update multiples rows of table: "eatfresh.b2b_customer" */
  update_eatfresh_b2b_customer_many?: Maybe<Array<Maybe<Eatfresh_B2b_Customer_Mutation_Response>>>;
  /** update data of the table: "eatfresh.b2b_customer_type" */
  update_eatfresh_b2b_customer_type?: Maybe<Eatfresh_B2b_Customer_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.b2b_customer_type" */
  update_eatfresh_b2b_customer_type_by_pk?: Maybe<Eatfresh_B2b_Customer_Type>;
  /** update multiples rows of table: "eatfresh.b2b_customer_type" */
  update_eatfresh_b2b_customer_type_many?: Maybe<Array<Maybe<Eatfresh_B2b_Customer_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.basic_user_type" */
  update_eatfresh_basic_user_type?: Maybe<Eatfresh_Basic_User_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.basic_user_type" */
  update_eatfresh_basic_user_type_by_pk?: Maybe<Eatfresh_Basic_User_Type>;
  /** update multiples rows of table: "eatfresh.basic_user_type" */
  update_eatfresh_basic_user_type_many?: Maybe<Array<Maybe<Eatfresh_Basic_User_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.box_content_plan" */
  update_eatfresh_box_content_plan?: Maybe<Eatfresh_Box_Content_Plan_Mutation_Response>;
  /** update single row of the table: "eatfresh.box_content_plan" */
  update_eatfresh_box_content_plan_by_pk?: Maybe<Eatfresh_Box_Content_Plan>;
  /** update multiples rows of table: "eatfresh.box_content_plan" */
  update_eatfresh_box_content_plan_many?: Maybe<Array<Maybe<Eatfresh_Box_Content_Plan_Mutation_Response>>>;
  /** update data of the table: "eatfresh.box_content_plan_status" */
  update_eatfresh_box_content_plan_status?: Maybe<Eatfresh_Box_Content_Plan_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.box_content_plan_status" */
  update_eatfresh_box_content_plan_status_by_pk?: Maybe<Eatfresh_Box_Content_Plan_Status>;
  /** update multiples rows of table: "eatfresh.box_content_plan_status" */
  update_eatfresh_box_content_plan_status_many?: Maybe<Array<Maybe<Eatfresh_Box_Content_Plan_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.box_content_to_article" */
  update_eatfresh_box_content_to_article?: Maybe<Eatfresh_Box_Content_To_Article_Mutation_Response>;
  /** update single row of the table: "eatfresh.box_content_to_article" */
  update_eatfresh_box_content_to_article_by_pk?: Maybe<Eatfresh_Box_Content_To_Article>;
  /** update multiples rows of table: "eatfresh.box_content_to_article" */
  update_eatfresh_box_content_to_article_many?: Maybe<Array<Maybe<Eatfresh_Box_Content_To_Article_Mutation_Response>>>;
  /** update data of the table: "eatfresh.commissioning_process" */
  update_eatfresh_commissioning_process?: Maybe<Eatfresh_Commissioning_Process_Mutation_Response>;
  /** update single row of the table: "eatfresh.commissioning_process" */
  update_eatfresh_commissioning_process_by_pk?: Maybe<Eatfresh_Commissioning_Process>;
  /** update multiples rows of table: "eatfresh.commissioning_process" */
  update_eatfresh_commissioning_process_many?: Maybe<Array<Maybe<Eatfresh_Commissioning_Process_Mutation_Response>>>;
  /** update data of the table: "eatfresh.commissioning_process_position" */
  update_eatfresh_commissioning_process_position?: Maybe<Eatfresh_Commissioning_Process_Position_Mutation_Response>;
  /** update single row of the table: "eatfresh.commissioning_process_position" */
  update_eatfresh_commissioning_process_position_by_pk?: Maybe<Eatfresh_Commissioning_Process_Position>;
  /** update multiples rows of table: "eatfresh.commissioning_process_position" */
  update_eatfresh_commissioning_process_position_many?: Maybe<Array<Maybe<Eatfresh_Commissioning_Process_Position_Mutation_Response>>>;
  /** update data of the table: "eatfresh.commissioning_process_status" */
  update_eatfresh_commissioning_process_status?: Maybe<Eatfresh_Commissioning_Process_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.commissioning_process_status" */
  update_eatfresh_commissioning_process_status_by_pk?: Maybe<Eatfresh_Commissioning_Process_Status>;
  /** update multiples rows of table: "eatfresh.commissioning_process_status" */
  update_eatfresh_commissioning_process_status_many?: Maybe<Array<Maybe<Eatfresh_Commissioning_Process_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.computop_transaction" */
  update_eatfresh_computop_transaction?: Maybe<Eatfresh_Computop_Transaction_Mutation_Response>;
  /** update single row of the table: "eatfresh.computop_transaction" */
  update_eatfresh_computop_transaction_by_pk?: Maybe<Eatfresh_Computop_Transaction>;
  /** update multiples rows of table: "eatfresh.computop_transaction" */
  update_eatfresh_computop_transaction_many?: Maybe<Array<Maybe<Eatfresh_Computop_Transaction_Mutation_Response>>>;
  /** update data of the table: "eatfresh.connection_status" */
  update_eatfresh_connection_status?: Maybe<Eatfresh_Connection_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.connection_status" */
  update_eatfresh_connection_status_by_pk?: Maybe<Eatfresh_Connection_Status>;
  /** update multiples rows of table: "eatfresh.connection_status" */
  update_eatfresh_connection_status_many?: Maybe<Array<Maybe<Eatfresh_Connection_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.cost_configuration" */
  update_eatfresh_cost_configuration?: Maybe<Eatfresh_Cost_Configuration_Mutation_Response>;
  /** update data of the table: "eatfresh.cost_configuration_key" */
  update_eatfresh_cost_configuration_key?: Maybe<Eatfresh_Cost_Configuration_Key_Mutation_Response>;
  /** update single row of the table: "eatfresh.cost_configuration_key" */
  update_eatfresh_cost_configuration_key_by_pk?: Maybe<Eatfresh_Cost_Configuration_Key>;
  /** update multiples rows of table: "eatfresh.cost_configuration_key" */
  update_eatfresh_cost_configuration_key_many?: Maybe<Array<Maybe<Eatfresh_Cost_Configuration_Key_Mutation_Response>>>;
  /** update multiples rows of table: "eatfresh.cost_configuration" */
  update_eatfresh_cost_configuration_many?: Maybe<Array<Maybe<Eatfresh_Cost_Configuration_Mutation_Response>>>;
  /** update data of the table: "eatfresh.customer" */
  update_eatfresh_customer?: Maybe<Eatfresh_Customer_Mutation_Response>;
  /** update single row of the table: "eatfresh.customer" */
  update_eatfresh_customer_by_pk?: Maybe<Eatfresh_Customer>;
  /** update multiples rows of table: "eatfresh.customer" */
  update_eatfresh_customer_many?: Maybe<Array<Maybe<Eatfresh_Customer_Mutation_Response>>>;
  /** update data of the table: "eatfresh.customer_order" */
  update_eatfresh_customer_order?: Maybe<Eatfresh_Customer_Order_Mutation_Response>;
  /** update single row of the table: "eatfresh.customer_order" */
  update_eatfresh_customer_order_by_pk?: Maybe<Eatfresh_Customer_Order>;
  /** update multiples rows of table: "eatfresh.customer_order" */
  update_eatfresh_customer_order_many?: Maybe<Array<Maybe<Eatfresh_Customer_Order_Mutation_Response>>>;
  /** update data of the table: "eatfresh.door_status" */
  update_eatfresh_door_status?: Maybe<Eatfresh_Door_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.door_status" */
  update_eatfresh_door_status_by_pk?: Maybe<Eatfresh_Door_Status>;
  /** update multiples rows of table: "eatfresh.door_status" */
  update_eatfresh_door_status_many?: Maybe<Array<Maybe<Eatfresh_Door_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.easy_refill_permission" */
  update_eatfresh_easy_refill_permission?: Maybe<Eatfresh_Easy_Refill_Permission_Mutation_Response>;
  /** update single row of the table: "eatfresh.easy_refill_permission" */
  update_eatfresh_easy_refill_permission_by_pk?: Maybe<Eatfresh_Easy_Refill_Permission>;
  /** update multiples rows of table: "eatfresh.easy_refill_permission" */
  update_eatfresh_easy_refill_permission_many?: Maybe<Array<Maybe<Eatfresh_Easy_Refill_Permission_Mutation_Response>>>;
  /** update data of the table: "eatfresh.external_warehouse_pallet_spot" */
  update_eatfresh_external_warehouse_pallet_spot?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot_Mutation_Response>;
  /** update single row of the table: "eatfresh.external_warehouse_pallet_spot" */
  update_eatfresh_external_warehouse_pallet_spot_by_pk?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** update multiples rows of table: "eatfresh.external_warehouse_pallet_spot" */
  update_eatfresh_external_warehouse_pallet_spot_many?: Maybe<Array<Maybe<Eatfresh_External_Warehouse_Pallet_Spot_Mutation_Response>>>;
  /** update data of the table: "eatfresh.flyway_schema_history" */
  update_eatfresh_flyway_schema_history?: Maybe<Eatfresh_Flyway_Schema_History_Mutation_Response>;
  /** update single row of the table: "eatfresh.flyway_schema_history" */
  update_eatfresh_flyway_schema_history_by_pk?: Maybe<Eatfresh_Flyway_Schema_History>;
  /** update multiples rows of table: "eatfresh.flyway_schema_history" */
  update_eatfresh_flyway_schema_history_many?: Maybe<Array<Maybe<Eatfresh_Flyway_Schema_History_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge" */
  update_eatfresh_fridge?: Maybe<Eatfresh_Fridge_Mutation_Response>;
  /** update data of the table: "eatfresh.fridge_alarm" */
  update_eatfresh_fridge_alarm?: Maybe<Eatfresh_Fridge_Alarm_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_alarm" */
  update_eatfresh_fridge_alarm_by_pk?: Maybe<Eatfresh_Fridge_Alarm>;
  /** update multiples rows of table: "eatfresh.fridge_alarm" */
  update_eatfresh_fridge_alarm_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Alarm_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_article_stock_snapshot" */
  update_eatfresh_fridge_article_stock_snapshot?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_article_stock_snapshot" */
  update_eatfresh_fridge_article_stock_snapshot_by_pk?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** update multiples rows of table: "eatfresh.fridge_article_stock_snapshot" */
  update_eatfresh_fridge_article_stock_snapshot_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Article_Stock_Snapshot_Mutation_Response>>>;
  /** update single row of the table: "eatfresh.fridge" */
  update_eatfresh_fridge_by_pk?: Maybe<Eatfresh_Fridge>;
  /** update data of the table: "eatfresh.fridge_event" */
  update_eatfresh_fridge_event?: Maybe<Eatfresh_Fridge_Event_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_event" */
  update_eatfresh_fridge_event_by_pk?: Maybe<Eatfresh_Fridge_Event>;
  /** update multiples rows of table: "eatfresh.fridge_event" */
  update_eatfresh_fridge_event_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Event_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_event_type" */
  update_eatfresh_fridge_event_type?: Maybe<Eatfresh_Fridge_Event_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_event_type" */
  update_eatfresh_fridge_event_type_by_pk?: Maybe<Eatfresh_Fridge_Event_Type>;
  /** update multiples rows of table: "eatfresh.fridge_event_type" */
  update_eatfresh_fridge_event_type_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Event_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_layout" */
  update_eatfresh_fridge_layout?: Maybe<Eatfresh_Fridge_Layout_Mutation_Response>;
  /** update data of the table: "eatfresh.fridge_layout_assignment" */
  update_eatfresh_fridge_layout_assignment?: Maybe<Eatfresh_Fridge_Layout_Assignment_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_layout_assignment" */
  update_eatfresh_fridge_layout_assignment_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment>;
  /** update multiples rows of table: "eatfresh.fridge_layout_assignment" */
  update_eatfresh_fridge_layout_assignment_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Layout_Assignment_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_layout_assignment_status" */
  update_eatfresh_fridge_layout_assignment_status?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_layout_assignment_status" */
  update_eatfresh_fridge_layout_assignment_status_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** update multiples rows of table: "eatfresh.fridge_layout_assignment_status" */
  update_eatfresh_fridge_layout_assignment_status_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Layout_Assignment_Status_Mutation_Response>>>;
  /** update single row of the table: "eatfresh.fridge_layout" */
  update_eatfresh_fridge_layout_by_pk?: Maybe<Eatfresh_Fridge_Layout>;
  /** update data of the table: "eatfresh.fridge_layout_level" */
  update_eatfresh_fridge_layout_level?: Maybe<Eatfresh_Fridge_Layout_Level_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_layout_level" */
  update_eatfresh_fridge_layout_level_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level>;
  /** update multiples rows of table: "eatfresh.fridge_layout_level" */
  update_eatfresh_fridge_layout_level_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Layout_Level_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_layout_level_position" */
  update_eatfresh_fridge_layout_level_position?: Maybe<Eatfresh_Fridge_Layout_Level_Position_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_layout_level_position" */
  update_eatfresh_fridge_layout_level_position_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level_Position>;
  /** update multiples rows of table: "eatfresh.fridge_layout_level_position" */
  update_eatfresh_fridge_layout_level_position_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Layout_Level_Position_Mutation_Response>>>;
  /** update multiples rows of table: "eatfresh.fridge_layout" */
  update_eatfresh_fridge_layout_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Layout_Mutation_Response>>>;
  /** update multiples rows of table: "eatfresh.fridge" */
  update_eatfresh_fridge_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_order" */
  update_eatfresh_fridge_order?: Maybe<Eatfresh_Fridge_Order_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_order" */
  update_eatfresh_fridge_order_by_pk?: Maybe<Eatfresh_Fridge_Order>;
  /** update multiples rows of table: "eatfresh.fridge_order" */
  update_eatfresh_fridge_order_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Order_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_status_history" */
  update_eatfresh_fridge_status_history?: Maybe<Eatfresh_Fridge_Status_History_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_status_history" */
  update_eatfresh_fridge_status_history_by_pk?: Maybe<Eatfresh_Fridge_Status_History>;
  /** update multiples rows of table: "eatfresh.fridge_status_history" */
  update_eatfresh_fridge_status_history_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Status_History_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_stock" */
  update_eatfresh_fridge_stock?: Maybe<Eatfresh_Fridge_Stock_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_stock" */
  update_eatfresh_fridge_stock_by_pk?: Maybe<Eatfresh_Fridge_Stock>;
  /** update multiples rows of table: "eatfresh.fridge_stock" */
  update_eatfresh_fridge_stock_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Stock_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_target_stock" */
  update_eatfresh_fridge_target_stock?: Maybe<Eatfresh_Fridge_Target_Stock_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_target_stock" */
  update_eatfresh_fridge_target_stock_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock>;
  /** update multiples rows of table: "eatfresh.fridge_target_stock" */
  update_eatfresh_fridge_target_stock_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Target_Stock_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_target_stock_position" */
  update_eatfresh_fridge_target_stock_position?: Maybe<Eatfresh_Fridge_Target_Stock_Position_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_target_stock_position" */
  update_eatfresh_fridge_target_stock_position_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock_Position>;
  /** update multiples rows of table: "eatfresh.fridge_target_stock_position" */
  update_eatfresh_fridge_target_stock_position_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Target_Stock_Position_Mutation_Response>>>;
  /** update data of the table: "eatfresh.fridge_type" */
  update_eatfresh_fridge_type?: Maybe<Eatfresh_Fridge_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.fridge_type" */
  update_eatfresh_fridge_type_by_pk?: Maybe<Eatfresh_Fridge_Type>;
  /** update multiples rows of table: "eatfresh.fridge_type" */
  update_eatfresh_fridge_type_many?: Maybe<Array<Maybe<Eatfresh_Fridge_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.logistics_problem" */
  update_eatfresh_logistics_problem?: Maybe<Eatfresh_Logistics_Problem_Mutation_Response>;
  /** update single row of the table: "eatfresh.logistics_problem" */
  update_eatfresh_logistics_problem_by_pk?: Maybe<Eatfresh_Logistics_Problem>;
  /** update data of the table: "eatfresh.logistics_problem_image" */
  update_eatfresh_logistics_problem_image?: Maybe<Eatfresh_Logistics_Problem_Image_Mutation_Response>;
  /** update single row of the table: "eatfresh.logistics_problem_image" */
  update_eatfresh_logistics_problem_image_by_pk?: Maybe<Eatfresh_Logistics_Problem_Image>;
  /** update multiples rows of table: "eatfresh.logistics_problem_image" */
  update_eatfresh_logistics_problem_image_many?: Maybe<Array<Maybe<Eatfresh_Logistics_Problem_Image_Mutation_Response>>>;
  /** update multiples rows of table: "eatfresh.logistics_problem" */
  update_eatfresh_logistics_problem_many?: Maybe<Array<Maybe<Eatfresh_Logistics_Problem_Mutation_Response>>>;
  /** update data of the table: "eatfresh.logistics_problem_status" */
  update_eatfresh_logistics_problem_status?: Maybe<Eatfresh_Logistics_Problem_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.logistics_problem_status" */
  update_eatfresh_logistics_problem_status_by_pk?: Maybe<Eatfresh_Logistics_Problem_Status>;
  /** update multiples rows of table: "eatfresh.logistics_problem_status" */
  update_eatfresh_logistics_problem_status_many?: Maybe<Array<Maybe<Eatfresh_Logistics_Problem_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.logistics_process_type" */
  update_eatfresh_logistics_process_type?: Maybe<Eatfresh_Logistics_Process_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.logistics_process_type" */
  update_eatfresh_logistics_process_type_by_pk?: Maybe<Eatfresh_Logistics_Process_Type>;
  /** update multiples rows of table: "eatfresh.logistics_process_type" */
  update_eatfresh_logistics_process_type_many?: Maybe<Array<Maybe<Eatfresh_Logistics_Process_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.nutrition_information" */
  update_eatfresh_nutrition_information?: Maybe<Eatfresh_Nutrition_Information_Mutation_Response>;
  /** update single row of the table: "eatfresh.nutrition_information" */
  update_eatfresh_nutrition_information_by_pk?: Maybe<Eatfresh_Nutrition_Information>;
  /** update multiples rows of table: "eatfresh.nutrition_information" */
  update_eatfresh_nutrition_information_many?: Maybe<Array<Maybe<Eatfresh_Nutrition_Information_Mutation_Response>>>;
  /** update data of the table: "eatfresh.order_extra" */
  update_eatfresh_order_extra?: Maybe<Eatfresh_Order_Extra_Mutation_Response>;
  /** update single row of the table: "eatfresh.order_extra" */
  update_eatfresh_order_extra_by_pk?: Maybe<Eatfresh_Order_Extra>;
  /** update data of the table: "eatfresh.order_extra_customer_order" */
  update_eatfresh_order_extra_customer_order?: Maybe<Eatfresh_Order_Extra_Customer_Order_Mutation_Response>;
  /** update single row of the table: "eatfresh.order_extra_customer_order" */
  update_eatfresh_order_extra_customer_order_by_pk?: Maybe<Eatfresh_Order_Extra_Customer_Order>;
  /** update multiples rows of table: "eatfresh.order_extra_customer_order" */
  update_eatfresh_order_extra_customer_order_many?: Maybe<Array<Maybe<Eatfresh_Order_Extra_Customer_Order_Mutation_Response>>>;
  /** update multiples rows of table: "eatfresh.order_extra" */
  update_eatfresh_order_extra_many?: Maybe<Array<Maybe<Eatfresh_Order_Extra_Mutation_Response>>>;
  /** update data of the table: "eatfresh.order_position" */
  update_eatfresh_order_position?: Maybe<Eatfresh_Order_Position_Mutation_Response>;
  /** update single row of the table: "eatfresh.order_position" */
  update_eatfresh_order_position_by_pk?: Maybe<Eatfresh_Order_Position>;
  /** update data of the table: "eatfresh.order_position_category" */
  update_eatfresh_order_position_category?: Maybe<Eatfresh_Order_Position_Category_Mutation_Response>;
  /** update single row of the table: "eatfresh.order_position_category" */
  update_eatfresh_order_position_category_by_pk?: Maybe<Eatfresh_Order_Position_Category>;
  /** update multiples rows of table: "eatfresh.order_position_category" */
  update_eatfresh_order_position_category_many?: Maybe<Array<Maybe<Eatfresh_Order_Position_Category_Mutation_Response>>>;
  /** update multiples rows of table: "eatfresh.order_position" */
  update_eatfresh_order_position_many?: Maybe<Array<Maybe<Eatfresh_Order_Position_Mutation_Response>>>;
  /** update data of the table: "eatfresh.order_status" */
  update_eatfresh_order_status?: Maybe<Eatfresh_Order_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.order_status" */
  update_eatfresh_order_status_by_pk?: Maybe<Eatfresh_Order_Status>;
  /** update multiples rows of table: "eatfresh.order_status" */
  update_eatfresh_order_status_many?: Maybe<Array<Maybe<Eatfresh_Order_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.packaging_type" */
  update_eatfresh_packaging_type?: Maybe<Eatfresh_Packaging_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.packaging_type" */
  update_eatfresh_packaging_type_by_pk?: Maybe<Eatfresh_Packaging_Type>;
  /** update multiples rows of table: "eatfresh.packaging_type" */
  update_eatfresh_packaging_type_many?: Maybe<Array<Maybe<Eatfresh_Packaging_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.password_reset_token" */
  update_eatfresh_password_reset_token?: Maybe<Eatfresh_Password_Reset_Token_Mutation_Response>;
  /** update single row of the table: "eatfresh.password_reset_token" */
  update_eatfresh_password_reset_token_by_pk?: Maybe<Eatfresh_Password_Reset_Token>;
  /** update multiples rows of table: "eatfresh.password_reset_token" */
  update_eatfresh_password_reset_token_many?: Maybe<Array<Maybe<Eatfresh_Password_Reset_Token_Mutation_Response>>>;
  /** update data of the table: "eatfresh.payment_method" */
  update_eatfresh_payment_method?: Maybe<Eatfresh_Payment_Method_Mutation_Response>;
  /** update single row of the table: "eatfresh.payment_method" */
  update_eatfresh_payment_method_by_pk?: Maybe<Eatfresh_Payment_Method>;
  /** update multiples rows of table: "eatfresh.payment_method" */
  update_eatfresh_payment_method_many?: Maybe<Array<Maybe<Eatfresh_Payment_Method_Mutation_Response>>>;
  /** update data of the table: "eatfresh.payment_method_type" */
  update_eatfresh_payment_method_type?: Maybe<Eatfresh_Payment_Method_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.payment_method_type" */
  update_eatfresh_payment_method_type_by_pk?: Maybe<Eatfresh_Payment_Method_Type>;
  /** update multiples rows of table: "eatfresh.payment_method_type" */
  update_eatfresh_payment_method_type_many?: Maybe<Array<Maybe<Eatfresh_Payment_Method_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.payment_status" */
  update_eatfresh_payment_status?: Maybe<Eatfresh_Payment_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.payment_status" */
  update_eatfresh_payment_status_by_pk?: Maybe<Eatfresh_Payment_Status>;
  /** update multiples rows of table: "eatfresh.payment_status" */
  update_eatfresh_payment_status_many?: Maybe<Array<Maybe<Eatfresh_Payment_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.place" */
  update_eatfresh_place?: Maybe<Eatfresh_Place_Mutation_Response>;
  /** update single row of the table: "eatfresh.place" */
  update_eatfresh_place_by_pk?: Maybe<Eatfresh_Place>;
  /** update multiples rows of table: "eatfresh.place" */
  update_eatfresh_place_many?: Maybe<Array<Maybe<Eatfresh_Place_Mutation_Response>>>;
  /** update data of the table: "eatfresh.price_change" */
  update_eatfresh_price_change?: Maybe<Eatfresh_Price_Change_Mutation_Response>;
  /** update single row of the table: "eatfresh.price_change" */
  update_eatfresh_price_change_by_pk?: Maybe<Eatfresh_Price_Change>;
  /** update multiples rows of table: "eatfresh.price_change" */
  update_eatfresh_price_change_many?: Maybe<Array<Maybe<Eatfresh_Price_Change_Mutation_Response>>>;
  /** update data of the table: "eatfresh.price_change_position" */
  update_eatfresh_price_change_position?: Maybe<Eatfresh_Price_Change_Position_Mutation_Response>;
  /** update single row of the table: "eatfresh.price_change_position" */
  update_eatfresh_price_change_position_by_pk?: Maybe<Eatfresh_Price_Change_Position>;
  /** update multiples rows of table: "eatfresh.price_change_position" */
  update_eatfresh_price_change_position_many?: Maybe<Array<Maybe<Eatfresh_Price_Change_Position_Mutation_Response>>>;
  /** update data of the table: "eatfresh.price_change_position_status" */
  update_eatfresh_price_change_position_status?: Maybe<Eatfresh_Price_Change_Position_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.price_change_position_status" */
  update_eatfresh_price_change_position_status_by_pk?: Maybe<Eatfresh_Price_Change_Position_Status>;
  /** update multiples rows of table: "eatfresh.price_change_position_status" */
  update_eatfresh_price_change_position_status_many?: Maybe<Array<Maybe<Eatfresh_Price_Change_Position_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.price_lock" */
  update_eatfresh_price_lock?: Maybe<Eatfresh_Price_Lock_Mutation_Response>;
  /** update single row of the table: "eatfresh.price_lock" */
  update_eatfresh_price_lock_by_pk?: Maybe<Eatfresh_Price_Lock>;
  /** update multiples rows of table: "eatfresh.price_lock" */
  update_eatfresh_price_lock_many?: Maybe<Array<Maybe<Eatfresh_Price_Lock_Mutation_Response>>>;
  /** update data of the table: "eatfresh.product_orientation" */
  update_eatfresh_product_orientation?: Maybe<Eatfresh_Product_Orientation_Mutation_Response>;
  /** update single row of the table: "eatfresh.product_orientation" */
  update_eatfresh_product_orientation_by_pk?: Maybe<Eatfresh_Product_Orientation>;
  /** update multiples rows of table: "eatfresh.product_orientation" */
  update_eatfresh_product_orientation_many?: Maybe<Array<Maybe<Eatfresh_Product_Orientation_Mutation_Response>>>;
  /** update data of the table: "eatfresh.refill" */
  update_eatfresh_refill?: Maybe<Eatfresh_Refill_Mutation_Response>;
  /** update single row of the table: "eatfresh.refill" */
  update_eatfresh_refill_by_pk?: Maybe<Eatfresh_Refill>;
  /** update multiples rows of table: "eatfresh.refill" */
  update_eatfresh_refill_many?: Maybe<Array<Maybe<Eatfresh_Refill_Mutation_Response>>>;
  /** update data of the table: "eatfresh.refill_status" */
  update_eatfresh_refill_status?: Maybe<Eatfresh_Refill_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.refill_status" */
  update_eatfresh_refill_status_by_pk?: Maybe<Eatfresh_Refill_Status>;
  /** update multiples rows of table: "eatfresh.refill_status" */
  update_eatfresh_refill_status_many?: Maybe<Array<Maybe<Eatfresh_Refill_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_asset" */
  update_eatfresh_rfid_asset?: Maybe<Eatfresh_Rfid_Asset_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_asset" */
  update_eatfresh_rfid_asset_by_pk?: Maybe<Eatfresh_Rfid_Asset>;
  /** update multiples rows of table: "eatfresh.rfid_asset" */
  update_eatfresh_rfid_asset_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Asset_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_asset_type" */
  update_eatfresh_rfid_asset_type?: Maybe<Eatfresh_Rfid_Asset_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_asset_type" */
  update_eatfresh_rfid_asset_type_by_pk?: Maybe<Eatfresh_Rfid_Asset_Type>;
  /** update multiples rows of table: "eatfresh.rfid_asset_type" */
  update_eatfresh_rfid_asset_type_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Asset_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_box" */
  update_eatfresh_rfid_box?: Maybe<Eatfresh_Rfid_Box_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_box" */
  update_eatfresh_rfid_box_by_pk?: Maybe<Eatfresh_Rfid_Box>;
  /** update multiples rows of table: "eatfresh.rfid_box" */
  update_eatfresh_rfid_box_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Box_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_box_type" */
  update_eatfresh_rfid_box_type?: Maybe<Eatfresh_Rfid_Box_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_box_type" */
  update_eatfresh_rfid_box_type_by_pk?: Maybe<Eatfresh_Rfid_Box_Type>;
  /** update multiples rows of table: "eatfresh.rfid_box_type" */
  update_eatfresh_rfid_box_type_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Box_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_scan" */
  update_eatfresh_rfid_scan?: Maybe<Eatfresh_Rfid_Scan_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_scan" */
  update_eatfresh_rfid_scan_by_pk?: Maybe<Eatfresh_Rfid_Scan>;
  /** update multiples rows of table: "eatfresh.rfid_scan" */
  update_eatfresh_rfid_scan_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Scan_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_scan_status" */
  update_eatfresh_rfid_scan_status?: Maybe<Eatfresh_Rfid_Scan_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_scan_status" */
  update_eatfresh_rfid_scan_status_by_pk?: Maybe<Eatfresh_Rfid_Scan_Status>;
  /** update multiples rows of table: "eatfresh.rfid_scan_status" */
  update_eatfresh_rfid_scan_status_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Scan_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_scanner" */
  update_eatfresh_rfid_scanner?: Maybe<Eatfresh_Rfid_Scanner_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_scanner" */
  update_eatfresh_rfid_scanner_by_pk?: Maybe<Eatfresh_Rfid_Scanner>;
  /** update multiples rows of table: "eatfresh.rfid_scanner" */
  update_eatfresh_rfid_scanner_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Scanner_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_scanner_type" */
  update_eatfresh_rfid_scanner_type?: Maybe<Eatfresh_Rfid_Scanner_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_scanner_type" */
  update_eatfresh_rfid_scanner_type_by_pk?: Maybe<Eatfresh_Rfid_Scanner_Type>;
  /** update multiples rows of table: "eatfresh.rfid_scanner_type" */
  update_eatfresh_rfid_scanner_type_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Scanner_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_status" */
  update_eatfresh_rfid_status?: Maybe<Eatfresh_Rfid_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_status" */
  update_eatfresh_rfid_status_by_pk?: Maybe<Eatfresh_Rfid_Status>;
  /** update multiples rows of table: "eatfresh.rfid_status" */
  update_eatfresh_rfid_status_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.rfid_tag" */
  update_eatfresh_rfid_tag?: Maybe<Eatfresh_Rfid_Tag_Mutation_Response>;
  /** update single row of the table: "eatfresh.rfid_tag" */
  update_eatfresh_rfid_tag_by_pk?: Maybe<Eatfresh_Rfid_Tag>;
  /** update multiples rows of table: "eatfresh.rfid_tag" */
  update_eatfresh_rfid_tag_many?: Maybe<Array<Maybe<Eatfresh_Rfid_Tag_Mutation_Response>>>;
  /** update data of the table: "eatfresh.selfly_cabinet_state" */
  update_eatfresh_selfly_cabinet_state?: Maybe<Eatfresh_Selfly_Cabinet_State_Mutation_Response>;
  /** update single row of the table: "eatfresh.selfly_cabinet_state" */
  update_eatfresh_selfly_cabinet_state_by_pk?: Maybe<Eatfresh_Selfly_Cabinet_State>;
  /** update multiples rows of table: "eatfresh.selfly_cabinet_state" */
  update_eatfresh_selfly_cabinet_state_many?: Maybe<Array<Maybe<Eatfresh_Selfly_Cabinet_State_Mutation_Response>>>;
  /** update data of the table: "eatfresh.session_step" */
  update_eatfresh_session_step?: Maybe<Eatfresh_Session_Step_Mutation_Response>;
  /** update single row of the table: "eatfresh.session_step" */
  update_eatfresh_session_step_by_pk?: Maybe<Eatfresh_Session_Step>;
  /** update multiples rows of table: "eatfresh.session_step" */
  update_eatfresh_session_step_many?: Maybe<Array<Maybe<Eatfresh_Session_Step_Mutation_Response>>>;
  /** update data of the table: "eatfresh.shelf_type" */
  update_eatfresh_shelf_type?: Maybe<Eatfresh_Shelf_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.shelf_type" */
  update_eatfresh_shelf_type_by_pk?: Maybe<Eatfresh_Shelf_Type>;
  /** update multiples rows of table: "eatfresh.shelf_type" */
  update_eatfresh_shelf_type_many?: Maybe<Array<Maybe<Eatfresh_Shelf_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.supplier_problem" */
  update_eatfresh_supplier_problem?: Maybe<Eatfresh_Supplier_Problem_Mutation_Response>;
  /** update single row of the table: "eatfresh.supplier_problem" */
  update_eatfresh_supplier_problem_by_pk?: Maybe<Eatfresh_Supplier_Problem>;
  /** update multiples rows of table: "eatfresh.supplier_problem" */
  update_eatfresh_supplier_problem_many?: Maybe<Array<Maybe<Eatfresh_Supplier_Problem_Mutation_Response>>>;
  /** update data of the table: "eatfresh.supplier_problem_to_file" */
  update_eatfresh_supplier_problem_to_file?: Maybe<Eatfresh_Supplier_Problem_To_File_Mutation_Response>;
  /** update single row of the table: "eatfresh.supplier_problem_to_file" */
  update_eatfresh_supplier_problem_to_file_by_pk?: Maybe<Eatfresh_Supplier_Problem_To_File>;
  /** update multiples rows of table: "eatfresh.supplier_problem_to_file" */
  update_eatfresh_supplier_problem_to_file_many?: Maybe<Array<Maybe<Eatfresh_Supplier_Problem_To_File_Mutation_Response>>>;
  /** update data of the table: "eatfresh.transaction_logs" */
  update_eatfresh_transaction_logs?: Maybe<Eatfresh_Transaction_Logs_Mutation_Response>;
  /** update single row of the table: "eatfresh.transaction_logs" */
  update_eatfresh_transaction_logs_by_pk?: Maybe<Eatfresh_Transaction_Logs>;
  /** update multiples rows of table: "eatfresh.transaction_logs" */
  update_eatfresh_transaction_logs_many?: Maybe<Array<Maybe<Eatfresh_Transaction_Logs_Mutation_Response>>>;
  /** update data of the table: "eatfresh.uploaded_file" */
  update_eatfresh_uploaded_file?: Maybe<Eatfresh_Uploaded_File_Mutation_Response>;
  /** update single row of the table: "eatfresh.uploaded_file" */
  update_eatfresh_uploaded_file_by_pk?: Maybe<Eatfresh_Uploaded_File>;
  /** update multiples rows of table: "eatfresh.uploaded_file" */
  update_eatfresh_uploaded_file_many?: Maybe<Array<Maybe<Eatfresh_Uploaded_File_Mutation_Response>>>;
  /** update data of the table: "eatfresh.user_account" */
  update_eatfresh_user_account?: Maybe<Eatfresh_User_Account_Mutation_Response>;
  /** update single row of the table: "eatfresh.user_account" */
  update_eatfresh_user_account_by_pk?: Maybe<Eatfresh_User_Account>;
  /** update multiples rows of table: "eatfresh.user_account" */
  update_eatfresh_user_account_many?: Maybe<Array<Maybe<Eatfresh_User_Account_Mutation_Response>>>;
  /** update data of the table: "eatfresh.vat_category" */
  update_eatfresh_vat_category?: Maybe<Eatfresh_Vat_Category_Mutation_Response>;
  /** update single row of the table: "eatfresh.vat_category" */
  update_eatfresh_vat_category_by_pk?: Maybe<Eatfresh_Vat_Category>;
  /** update multiples rows of table: "eatfresh.vat_category" */
  update_eatfresh_vat_category_many?: Maybe<Array<Maybe<Eatfresh_Vat_Category_Mutation_Response>>>;
  /** update data of the table: "eatfresh.vitamin_mineral" */
  update_eatfresh_vitamin_mineral?: Maybe<Eatfresh_Vitamin_Mineral_Mutation_Response>;
  /** update single row of the table: "eatfresh.vitamin_mineral" */
  update_eatfresh_vitamin_mineral_by_pk?: Maybe<Eatfresh_Vitamin_Mineral>;
  /** update multiples rows of table: "eatfresh.vitamin_mineral" */
  update_eatfresh_vitamin_mineral_many?: Maybe<Array<Maybe<Eatfresh_Vitamin_Mineral_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse" */
  update_eatfresh_warehouse?: Maybe<Eatfresh_Warehouse_Mutation_Response>;
  /** update data of the table: "eatfresh.warehouse_assignment" */
  update_eatfresh_warehouse_assignment?: Maybe<Eatfresh_Warehouse_Assignment_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_assignment" */
  update_eatfresh_warehouse_assignment_by_pk?: Maybe<Eatfresh_Warehouse_Assignment>;
  /** update multiples rows of table: "eatfresh.warehouse_assignment" */
  update_eatfresh_warehouse_assignment_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Assignment_Mutation_Response>>>;
  /** update single row of the table: "eatfresh.warehouse" */
  update_eatfresh_warehouse_by_pk?: Maybe<Eatfresh_Warehouse>;
  /** update multiples rows of table: "eatfresh.warehouse" */
  update_eatfresh_warehouse_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse_order" */
  update_eatfresh_warehouse_order?: Maybe<Eatfresh_Warehouse_Order_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_order" */
  update_eatfresh_warehouse_order_by_pk?: Maybe<Eatfresh_Warehouse_Order>;
  /** update multiples rows of table: "eatfresh.warehouse_order" */
  update_eatfresh_warehouse_order_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Order_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse_order_position" */
  update_eatfresh_warehouse_order_position?: Maybe<Eatfresh_Warehouse_Order_Position_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_order_position" */
  update_eatfresh_warehouse_order_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Position>;
  /** update multiples rows of table: "eatfresh.warehouse_order_position" */
  update_eatfresh_warehouse_order_position_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Order_Position_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse_order_receipt" */
  update_eatfresh_warehouse_order_receipt?: Maybe<Eatfresh_Warehouse_Order_Receipt_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_order_receipt" */
  update_eatfresh_warehouse_order_receipt_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt>;
  /** update multiples rows of table: "eatfresh.warehouse_order_receipt" */
  update_eatfresh_warehouse_order_receipt_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Order_Receipt_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse_order_receipt_position" */
  update_eatfresh_warehouse_order_receipt_position?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_order_receipt_position" */
  update_eatfresh_warehouse_order_receipt_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** update multiples rows of table: "eatfresh.warehouse_order_receipt_position" */
  update_eatfresh_warehouse_order_receipt_position_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Order_Receipt_Position_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse_order_status" */
  update_eatfresh_warehouse_order_status?: Maybe<Eatfresh_Warehouse_Order_Status_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_order_status" */
  update_eatfresh_warehouse_order_status_by_pk?: Maybe<Eatfresh_Warehouse_Order_Status>;
  /** update multiples rows of table: "eatfresh.warehouse_order_status" */
  update_eatfresh_warehouse_order_status_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Order_Status_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse_order_type" */
  update_eatfresh_warehouse_order_type?: Maybe<Eatfresh_Warehouse_Order_Type_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_order_type" */
  update_eatfresh_warehouse_order_type_by_pk?: Maybe<Eatfresh_Warehouse_Order_Type>;
  /** update multiples rows of table: "eatfresh.warehouse_order_type" */
  update_eatfresh_warehouse_order_type_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Order_Type_Mutation_Response>>>;
  /** update data of the table: "eatfresh.warehouse_shelf" */
  update_eatfresh_warehouse_shelf?: Maybe<Eatfresh_Warehouse_Shelf_Mutation_Response>;
  /** update single row of the table: "eatfresh.warehouse_shelf" */
  update_eatfresh_warehouse_shelf_by_pk?: Maybe<Eatfresh_Warehouse_Shelf>;
  /** update multiples rows of table: "eatfresh.warehouse_shelf" */
  update_eatfresh_warehouse_shelf_many?: Maybe<Array<Maybe<Eatfresh_Warehouse_Shelf_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Age_VerificationArgs = {
  where: Eatfresh_Age_Verification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Age_Verification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Age_Verification_StatusArgs = {
  where: Eatfresh_Age_Verification_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Age_Verification_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Age_Verification_TypeArgs = {
  where: Eatfresh_Age_Verification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Age_Verification_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_ArticleArgs = {
  where: Eatfresh_Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Article_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Article_DetailsArgs = {
  where: Eatfresh_Article_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Article_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Article_Labeling_ProcessArgs = {
  where: Eatfresh_Article_Labeling_Process_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Article_Labeling_Process_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Article_Labeling_Process_StatusArgs = {
  where: Eatfresh_Article_Labeling_Process_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Article_Labeling_Process_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_PlacementArgs = {
  where: Eatfresh_Asset_Placement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Placement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_TransferArgs = {
  where: Eatfresh_Asset_Transfer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Transfer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Transfer_ProblemArgs = {
  where: Eatfresh_Asset_Transfer_Problem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Transfer_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Transfer_Problem_SeverityArgs = {
  where: Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Transfer_Problem_Severity_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Transfer_Problem_StatusArgs = {
  where: Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Asset_Transfer_Problem_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Auth_TokenArgs = {
  where: Eatfresh_Auth_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Auth_Token_By_PkArgs = {
  key: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_AuthenticatorsArgs = {
  where: Eatfresh_Authenticators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Authenticators_By_PkArgs = {
  credentialid: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_B2b_CustomerArgs = {
  where: Eatfresh_B2b_Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_B2b_Customer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_B2b_Customer_TypeArgs = {
  where: Eatfresh_B2b_Customer_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_B2b_Customer_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Basic_User_TypeArgs = {
  where: Eatfresh_Basic_User_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Basic_User_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Box_Content_PlanArgs = {
  where: Eatfresh_Box_Content_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Box_Content_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Box_Content_Plan_StatusArgs = {
  where: Eatfresh_Box_Content_Plan_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Box_Content_Plan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Box_Content_To_ArticleArgs = {
  where: Eatfresh_Box_Content_To_Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Box_Content_To_Article_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Commissioning_ProcessArgs = {
  where: Eatfresh_Commissioning_Process_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Commissioning_Process_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Commissioning_Process_PositionArgs = {
  where: Eatfresh_Commissioning_Process_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Commissioning_Process_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Commissioning_Process_StatusArgs = {
  where: Eatfresh_Commissioning_Process_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Commissioning_Process_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Computop_TransactionArgs = {
  where: Eatfresh_Computop_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Computop_Transaction_By_PkArgs = {
  trans_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Connection_StatusArgs = {
  where: Eatfresh_Connection_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Connection_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Cost_ConfigurationArgs = {
  where: Eatfresh_Cost_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Cost_Configuration_KeyArgs = {
  where: Eatfresh_Cost_Configuration_Key_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Cost_Configuration_Key_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_CustomerArgs = {
  where: Eatfresh_Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Customer_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Customer_OrderArgs = {
  where: Eatfresh_Customer_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Customer_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Door_StatusArgs = {
  where: Eatfresh_Door_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Door_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Easy_Refill_PermissionArgs = {
  where: Eatfresh_Easy_Refill_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Easy_Refill_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_External_Warehouse_Pallet_SpotArgs = {
  where: Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_External_Warehouse_Pallet_Spot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Flyway_Schema_HistoryArgs = {
  where: Eatfresh_Flyway_Schema_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Flyway_Schema_History_By_PkArgs = {
  installed_rank: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_FridgeArgs = {
  where: Eatfresh_Fridge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_AlarmArgs = {
  where: Eatfresh_Fridge_Alarm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Alarm_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Article_Stock_SnapshotArgs = {
  where: Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Article_Stock_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_EventArgs = {
  where: Eatfresh_Fridge_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Event_TypeArgs = {
  where: Eatfresh_Fridge_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Event_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_LayoutArgs = {
  where: Eatfresh_Fridge_Layout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_AssignmentArgs = {
  where: Eatfresh_Fridge_Layout_Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_Assignment_StatusArgs = {
  where: Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_LevelArgs = {
  where: Eatfresh_Fridge_Layout_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_Level_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_Level_PositionArgs = {
  where: Eatfresh_Fridge_Layout_Level_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Layout_Level_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_OrderArgs = {
  where: Eatfresh_Fridge_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Status_HistoryArgs = {
  where: Eatfresh_Fridge_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Status_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_StockArgs = {
  where: Eatfresh_Fridge_Stock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Stock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Target_StockArgs = {
  where: Eatfresh_Fridge_Target_Stock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Target_Stock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Target_Stock_PositionArgs = {
  where: Eatfresh_Fridge_Target_Stock_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Target_Stock_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_TypeArgs = {
  where: Eatfresh_Fridge_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Fridge_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_ProblemArgs = {
  where: Eatfresh_Logistics_Problem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_Problem_ImageArgs = {
  where: Eatfresh_Logistics_Problem_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_Problem_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_Problem_StatusArgs = {
  where: Eatfresh_Logistics_Problem_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_Problem_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_Process_TypeArgs = {
  where: Eatfresh_Logistics_Process_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Logistics_Process_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Nutrition_InformationArgs = {
  where: Eatfresh_Nutrition_Information_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Nutrition_Information_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_ExtraArgs = {
  where: Eatfresh_Order_Extra_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_Extra_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_Extra_Customer_OrderArgs = {
  where: Eatfresh_Order_Extra_Customer_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_Extra_Customer_Order_By_PkArgs = {
  customer_order_id: Scalars['uuid']['input'];
  order_extra_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_PositionArgs = {
  where: Eatfresh_Order_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_Position_CategoryArgs = {
  where: Eatfresh_Order_Position_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_Position_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_StatusArgs = {
  where: Eatfresh_Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Order_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Packaging_TypeArgs = {
  where: Eatfresh_Packaging_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Packaging_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Password_Reset_TokenArgs = {
  where: Eatfresh_Password_Reset_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Password_Reset_Token_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Payment_MethodArgs = {
  where: Eatfresh_Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Payment_Method_By_PkArgs = {
  trans_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Payment_Method_TypeArgs = {
  where: Eatfresh_Payment_Method_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Payment_Method_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Payment_StatusArgs = {
  where: Eatfresh_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Payment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_PlaceArgs = {
  where: Eatfresh_Place_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Place_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_ChangeArgs = {
  where: Eatfresh_Price_Change_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_Change_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_Change_PositionArgs = {
  where: Eatfresh_Price_Change_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_Change_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_Change_Position_StatusArgs = {
  where: Eatfresh_Price_Change_Position_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_Change_Position_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_LockArgs = {
  where: Eatfresh_Price_Lock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Price_Lock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Product_OrientationArgs = {
  where: Eatfresh_Product_Orientation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Product_Orientation_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_RefillArgs = {
  where: Eatfresh_Refill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Refill_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Refill_StatusArgs = {
  where: Eatfresh_Refill_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Refill_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_AssetArgs = {
  where: Eatfresh_Rfid_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Asset_TypeArgs = {
  where: Eatfresh_Rfid_Asset_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Asset_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_BoxArgs = {
  where: Eatfresh_Rfid_Box_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Box_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Box_TypeArgs = {
  where: Eatfresh_Rfid_Box_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Box_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_ScanArgs = {
  where: Eatfresh_Rfid_Scan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Scan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Scan_StatusArgs = {
  where: Eatfresh_Rfid_Scan_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Scan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_ScannerArgs = {
  where: Eatfresh_Rfid_Scanner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Scanner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Scanner_TypeArgs = {
  where: Eatfresh_Rfid_Scanner_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Scanner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_StatusArgs = {
  where: Eatfresh_Rfid_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_TagArgs = {
  where: Eatfresh_Rfid_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Rfid_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Selfly_Cabinet_StateArgs = {
  where: Eatfresh_Selfly_Cabinet_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Selfly_Cabinet_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Session_StepArgs = {
  where: Eatfresh_Session_Step_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Session_Step_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Shelf_TypeArgs = {
  where: Eatfresh_Shelf_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Shelf_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Supplier_ProblemArgs = {
  where: Eatfresh_Supplier_Problem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Supplier_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Supplier_Problem_To_FileArgs = {
  where: Eatfresh_Supplier_Problem_To_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Supplier_Problem_To_File_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Transaction_LogsArgs = {
  where: Eatfresh_Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Uploaded_FileArgs = {
  where: Eatfresh_Uploaded_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Uploaded_File_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_User_AccountArgs = {
  where: Eatfresh_User_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_User_Account_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Vat_CategoryArgs = {
  where: Eatfresh_Vat_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Vat_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Vitamin_MineralArgs = {
  where: Eatfresh_Vitamin_Mineral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Vitamin_Mineral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_WarehouseArgs = {
  where: Eatfresh_Warehouse_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_AssignmentArgs = {
  where: Eatfresh_Warehouse_Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_OrderArgs = {
  where: Eatfresh_Warehouse_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_PositionArgs = {
  where: Eatfresh_Warehouse_Order_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_ReceiptArgs = {
  where: Eatfresh_Warehouse_Order_Receipt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_Receipt_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_Receipt_PositionArgs = {
  where: Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_Receipt_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_StatusArgs = {
  where: Eatfresh_Warehouse_Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_TypeArgs = {
  where: Eatfresh_Warehouse_Order_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Order_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_ShelfArgs = {
  where: Eatfresh_Warehouse_Shelf_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eatfresh_Warehouse_Shelf_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Age_VerificationArgs = {
  objects: Array<Eatfresh_Age_Verification_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Age_Verification_OneArgs = {
  object: Eatfresh_Age_Verification_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Age_Verification_StatusArgs = {
  objects: Array<Eatfresh_Age_Verification_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Age_Verification_Status_OneArgs = {
  object: Eatfresh_Age_Verification_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Age_Verification_TypeArgs = {
  objects: Array<Eatfresh_Age_Verification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Age_Verification_Type_OneArgs = {
  object: Eatfresh_Age_Verification_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Age_Verification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_ArticleArgs = {
  objects: Array<Eatfresh_Article_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Article_DetailsArgs = {
  objects: Array<Eatfresh_Article_Details_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Article_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Article_Details_OneArgs = {
  object: Eatfresh_Article_Details_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Article_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Article_Labeling_ProcessArgs = {
  objects: Array<Eatfresh_Article_Labeling_Process_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Article_Labeling_Process_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Article_Labeling_Process_OneArgs = {
  object: Eatfresh_Article_Labeling_Process_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Article_Labeling_Process_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Article_Labeling_Process_StatusArgs = {
  objects: Array<Eatfresh_Article_Labeling_Process_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Article_Labeling_Process_Status_OneArgs = {
  object: Eatfresh_Article_Labeling_Process_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Article_OneArgs = {
  object: Eatfresh_Article_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_PlacementArgs = {
  objects: Array<Eatfresh_Asset_Placement_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Asset_Placement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Placement_OneArgs = {
  object: Eatfresh_Asset_Placement_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Asset_Placement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_TransferArgs = {
  objects: Array<Eatfresh_Asset_Transfer_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Transfer_OneArgs = {
  object: Eatfresh_Asset_Transfer_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Transfer_ProblemArgs = {
  objects: Array<Eatfresh_Asset_Transfer_Problem_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Transfer_Problem_OneArgs = {
  object: Eatfresh_Asset_Transfer_Problem_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Transfer_Problem_SeverityArgs = {
  objects: Array<Eatfresh_Asset_Transfer_Problem_Severity_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Transfer_Problem_Severity_OneArgs = {
  object: Eatfresh_Asset_Transfer_Problem_Severity_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Transfer_Problem_StatusArgs = {
  objects: Array<Eatfresh_Asset_Transfer_Problem_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Asset_Transfer_Problem_Status_OneArgs = {
  object: Eatfresh_Asset_Transfer_Problem_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Auth_TokenArgs = {
  objects: Array<Eatfresh_Auth_Token_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Auth_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Auth_Token_OneArgs = {
  object: Eatfresh_Auth_Token_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Auth_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_AuthenticatorsArgs = {
  objects: Array<Eatfresh_Authenticators_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Authenticators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Authenticators_OneArgs = {
  object: Eatfresh_Authenticators_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Authenticators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_B2b_CustomerArgs = {
  objects: Array<Eatfresh_B2b_Customer_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_B2b_Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_B2b_Customer_OneArgs = {
  object: Eatfresh_B2b_Customer_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_B2b_Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_B2b_Customer_TypeArgs = {
  objects: Array<Eatfresh_B2b_Customer_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_B2b_Customer_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_B2b_Customer_Type_OneArgs = {
  object: Eatfresh_B2b_Customer_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_B2b_Customer_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Basic_User_TypeArgs = {
  objects: Array<Eatfresh_Basic_User_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Basic_User_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Basic_User_Type_OneArgs = {
  object: Eatfresh_Basic_User_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Basic_User_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Box_Content_PlanArgs = {
  objects: Array<Eatfresh_Box_Content_Plan_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Box_Content_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Box_Content_Plan_OneArgs = {
  object: Eatfresh_Box_Content_Plan_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Box_Content_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Box_Content_Plan_StatusArgs = {
  objects: Array<Eatfresh_Box_Content_Plan_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Box_Content_Plan_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Box_Content_Plan_Status_OneArgs = {
  object: Eatfresh_Box_Content_Plan_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Box_Content_Plan_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Box_Content_To_ArticleArgs = {
  objects: Array<Eatfresh_Box_Content_To_Article_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Box_Content_To_Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Box_Content_To_Article_OneArgs = {
  object: Eatfresh_Box_Content_To_Article_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Box_Content_To_Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Commissioning_ProcessArgs = {
  objects: Array<Eatfresh_Commissioning_Process_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Commissioning_Process_OneArgs = {
  object: Eatfresh_Commissioning_Process_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Commissioning_Process_PositionArgs = {
  objects: Array<Eatfresh_Commissioning_Process_Position_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Commissioning_Process_Position_OneArgs = {
  object: Eatfresh_Commissioning_Process_Position_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Commissioning_Process_StatusArgs = {
  objects: Array<Eatfresh_Commissioning_Process_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Commissioning_Process_Status_OneArgs = {
  object: Eatfresh_Commissioning_Process_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Commissioning_Process_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Computop_TransactionArgs = {
  objects: Array<Eatfresh_Computop_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Computop_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Computop_Transaction_OneArgs = {
  object: Eatfresh_Computop_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Computop_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Connection_StatusArgs = {
  objects: Array<Eatfresh_Connection_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Connection_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Connection_Status_OneArgs = {
  object: Eatfresh_Connection_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Connection_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Cost_ConfigurationArgs = {
  objects: Array<Eatfresh_Cost_Configuration_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Cost_Configuration_KeyArgs = {
  objects: Array<Eatfresh_Cost_Configuration_Key_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Cost_Configuration_Key_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Cost_Configuration_Key_OneArgs = {
  object: Eatfresh_Cost_Configuration_Key_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Cost_Configuration_Key_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Cost_Configuration_OneArgs = {
  object: Eatfresh_Cost_Configuration_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_CustomerArgs = {
  objects: Array<Eatfresh_Customer_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Customer_OneArgs = {
  object: Eatfresh_Customer_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Customer_OrderArgs = {
  objects: Array<Eatfresh_Customer_Order_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Customer_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Customer_Order_OneArgs = {
  object: Eatfresh_Customer_Order_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Customer_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Door_StatusArgs = {
  objects: Array<Eatfresh_Door_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Door_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Door_Status_OneArgs = {
  object: Eatfresh_Door_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Door_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Easy_Refill_PermissionArgs = {
  objects: Array<Eatfresh_Easy_Refill_Permission_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Easy_Refill_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Easy_Refill_Permission_OneArgs = {
  object: Eatfresh_Easy_Refill_Permission_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Easy_Refill_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_External_Warehouse_Pallet_SpotArgs = {
  objects: Array<Eatfresh_External_Warehouse_Pallet_Spot_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_External_Warehouse_Pallet_Spot_OneArgs = {
  object: Eatfresh_External_Warehouse_Pallet_Spot_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Flyway_Schema_HistoryArgs = {
  objects: Array<Eatfresh_Flyway_Schema_History_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Flyway_Schema_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Flyway_Schema_History_OneArgs = {
  object: Eatfresh_Flyway_Schema_History_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Flyway_Schema_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_FridgeArgs = {
  objects: Array<Eatfresh_Fridge_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_AlarmArgs = {
  objects: Array<Eatfresh_Fridge_Alarm_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Alarm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Alarm_OneArgs = {
  object: Eatfresh_Fridge_Alarm_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Alarm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Article_Stock_SnapshotArgs = {
  objects: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Article_Stock_Snapshot_OneArgs = {
  object: Eatfresh_Fridge_Article_Stock_Snapshot_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_EventArgs = {
  objects: Array<Eatfresh_Fridge_Event_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Event_OneArgs = {
  object: Eatfresh_Fridge_Event_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Event_TypeArgs = {
  objects: Array<Eatfresh_Fridge_Event_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Event_Type_OneArgs = {
  object: Eatfresh_Fridge_Event_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_LayoutArgs = {
  objects: Array<Eatfresh_Fridge_Layout_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_AssignmentArgs = {
  objects: Array<Eatfresh_Fridge_Layout_Assignment_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_Assignment_OneArgs = {
  object: Eatfresh_Fridge_Layout_Assignment_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_Assignment_StatusArgs = {
  objects: Array<Eatfresh_Fridge_Layout_Assignment_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_Assignment_Status_OneArgs = {
  object: Eatfresh_Fridge_Layout_Assignment_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_LevelArgs = {
  objects: Array<Eatfresh_Fridge_Layout_Level_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_Level_OneArgs = {
  object: Eatfresh_Fridge_Layout_Level_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_Level_PositionArgs = {
  objects: Array<Eatfresh_Fridge_Layout_Level_Position_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_Level_Position_OneArgs = {
  object: Eatfresh_Fridge_Layout_Level_Position_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Layout_OneArgs = {
  object: Eatfresh_Fridge_Layout_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Layout_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_OneArgs = {
  object: Eatfresh_Fridge_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_OrderArgs = {
  objects: Array<Eatfresh_Fridge_Order_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Order_OneArgs = {
  object: Eatfresh_Fridge_Order_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Status_HistoryArgs = {
  objects: Array<Eatfresh_Fridge_Status_History_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Status_History_OneArgs = {
  object: Eatfresh_Fridge_Status_History_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_StockArgs = {
  objects: Array<Eatfresh_Fridge_Stock_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Stock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Stock_OneArgs = {
  object: Eatfresh_Fridge_Stock_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Stock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Target_StockArgs = {
  objects: Array<Eatfresh_Fridge_Target_Stock_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Target_Stock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Target_Stock_OneArgs = {
  object: Eatfresh_Fridge_Target_Stock_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Target_Stock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Target_Stock_PositionArgs = {
  objects: Array<Eatfresh_Fridge_Target_Stock_Position_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Target_Stock_Position_OneArgs = {
  object: Eatfresh_Fridge_Target_Stock_Position_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_TypeArgs = {
  objects: Array<Eatfresh_Fridge_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Fridge_Type_OneArgs = {
  object: Eatfresh_Fridge_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Fridge_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_ProblemArgs = {
  objects: Array<Eatfresh_Logistics_Problem_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_Problem_ImageArgs = {
  objects: Array<Eatfresh_Logistics_Problem_Image_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_Problem_Image_OneArgs = {
  object: Eatfresh_Logistics_Problem_Image_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_Problem_OneArgs = {
  object: Eatfresh_Logistics_Problem_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_Problem_StatusArgs = {
  objects: Array<Eatfresh_Logistics_Problem_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_Problem_Status_OneArgs = {
  object: Eatfresh_Logistics_Problem_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Problem_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_Process_TypeArgs = {
  objects: Array<Eatfresh_Logistics_Process_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Process_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Logistics_Process_Type_OneArgs = {
  object: Eatfresh_Logistics_Process_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Logistics_Process_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Nutrition_InformationArgs = {
  objects: Array<Eatfresh_Nutrition_Information_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Nutrition_Information_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Nutrition_Information_OneArgs = {
  object: Eatfresh_Nutrition_Information_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Nutrition_Information_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_ExtraArgs = {
  objects: Array<Eatfresh_Order_Extra_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Order_Extra_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_Extra_Customer_OrderArgs = {
  objects: Array<Eatfresh_Order_Extra_Customer_Order_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_Extra_Customer_Order_OneArgs = {
  object: Eatfresh_Order_Extra_Customer_Order_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_Extra_OneArgs = {
  object: Eatfresh_Order_Extra_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Order_Extra_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_PositionArgs = {
  objects: Array<Eatfresh_Order_Position_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Order_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_Position_CategoryArgs = {
  objects: Array<Eatfresh_Order_Position_Category_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Order_Position_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_Position_Category_OneArgs = {
  object: Eatfresh_Order_Position_Category_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Order_Position_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_Position_OneArgs = {
  object: Eatfresh_Order_Position_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Order_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_StatusArgs = {
  objects: Array<Eatfresh_Order_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Order_Status_OneArgs = {
  object: Eatfresh_Order_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Packaging_TypeArgs = {
  objects: Array<Eatfresh_Packaging_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Packaging_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Packaging_Type_OneArgs = {
  object: Eatfresh_Packaging_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Packaging_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Password_Reset_TokenArgs = {
  objects: Array<Eatfresh_Password_Reset_Token_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Password_Reset_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Password_Reset_Token_OneArgs = {
  object: Eatfresh_Password_Reset_Token_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Password_Reset_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Payment_MethodArgs = {
  objects: Array<Eatfresh_Payment_Method_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Payment_Method_OneArgs = {
  object: Eatfresh_Payment_Method_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Payment_Method_TypeArgs = {
  objects: Array<Eatfresh_Payment_Method_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Payment_Method_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Payment_Method_Type_OneArgs = {
  object: Eatfresh_Payment_Method_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Payment_Method_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Payment_StatusArgs = {
  objects: Array<Eatfresh_Payment_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Payment_Status_OneArgs = {
  object: Eatfresh_Payment_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Payment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_PlaceArgs = {
  objects: Array<Eatfresh_Place_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Place_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Place_OneArgs = {
  object: Eatfresh_Place_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Place_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_ChangeArgs = {
  objects: Array<Eatfresh_Price_Change_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Price_Change_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_Change_OneArgs = {
  object: Eatfresh_Price_Change_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Price_Change_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_Change_PositionArgs = {
  objects: Array<Eatfresh_Price_Change_Position_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Price_Change_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_Change_Position_OneArgs = {
  object: Eatfresh_Price_Change_Position_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Price_Change_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_Change_Position_StatusArgs = {
  objects: Array<Eatfresh_Price_Change_Position_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Price_Change_Position_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_Change_Position_Status_OneArgs = {
  object: Eatfresh_Price_Change_Position_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Price_Change_Position_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_LockArgs = {
  objects: Array<Eatfresh_Price_Lock_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Price_Lock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Price_Lock_OneArgs = {
  object: Eatfresh_Price_Lock_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Price_Lock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Product_OrientationArgs = {
  objects: Array<Eatfresh_Product_Orientation_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Product_Orientation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Product_Orientation_OneArgs = {
  object: Eatfresh_Product_Orientation_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Product_Orientation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_RefillArgs = {
  objects: Array<Eatfresh_Refill_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Refill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Refill_OneArgs = {
  object: Eatfresh_Refill_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Refill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Refill_StatusArgs = {
  objects: Array<Eatfresh_Refill_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Refill_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Refill_Status_OneArgs = {
  object: Eatfresh_Refill_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Refill_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_AssetArgs = {
  objects: Array<Eatfresh_Rfid_Asset_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Asset_OneArgs = {
  object: Eatfresh_Rfid_Asset_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Asset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Asset_TypeArgs = {
  objects: Array<Eatfresh_Rfid_Asset_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Asset_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Asset_Type_OneArgs = {
  object: Eatfresh_Rfid_Asset_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Asset_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_BoxArgs = {
  objects: Array<Eatfresh_Rfid_Box_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Box_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Box_OneArgs = {
  object: Eatfresh_Rfid_Box_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Box_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Box_TypeArgs = {
  objects: Array<Eatfresh_Rfid_Box_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Box_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Box_Type_OneArgs = {
  object: Eatfresh_Rfid_Box_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Box_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_ScanArgs = {
  objects: Array<Eatfresh_Rfid_Scan_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Scan_OneArgs = {
  object: Eatfresh_Rfid_Scan_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Scan_StatusArgs = {
  objects: Array<Eatfresh_Rfid_Scan_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scan_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Scan_Status_OneArgs = {
  object: Eatfresh_Rfid_Scan_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scan_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_ScannerArgs = {
  objects: Array<Eatfresh_Rfid_Scanner_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scanner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Scanner_OneArgs = {
  object: Eatfresh_Rfid_Scanner_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scanner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Scanner_TypeArgs = {
  objects: Array<Eatfresh_Rfid_Scanner_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scanner_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Scanner_Type_OneArgs = {
  object: Eatfresh_Rfid_Scanner_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Scanner_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_StatusArgs = {
  objects: Array<Eatfresh_Rfid_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Status_OneArgs = {
  object: Eatfresh_Rfid_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_TagArgs = {
  objects: Array<Eatfresh_Rfid_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Rfid_Tag_OneArgs = {
  object: Eatfresh_Rfid_Tag_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Rfid_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Selfly_Cabinet_StateArgs = {
  objects: Array<Eatfresh_Selfly_Cabinet_State_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Selfly_Cabinet_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Selfly_Cabinet_State_OneArgs = {
  object: Eatfresh_Selfly_Cabinet_State_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Selfly_Cabinet_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Session_StepArgs = {
  objects: Array<Eatfresh_Session_Step_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Session_Step_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Session_Step_OneArgs = {
  object: Eatfresh_Session_Step_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Session_Step_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Shelf_TypeArgs = {
  objects: Array<Eatfresh_Shelf_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Shelf_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Shelf_Type_OneArgs = {
  object: Eatfresh_Shelf_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Shelf_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Supplier_ProblemArgs = {
  objects: Array<Eatfresh_Supplier_Problem_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Supplier_Problem_OneArgs = {
  object: Eatfresh_Supplier_Problem_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Supplier_Problem_To_FileArgs = {
  objects: Array<Eatfresh_Supplier_Problem_To_File_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_To_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Supplier_Problem_To_File_OneArgs = {
  object: Eatfresh_Supplier_Problem_To_File_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Supplier_Problem_To_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Transaction_LogsArgs = {
  objects: Array<Eatfresh_Transaction_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Transaction_Logs_OneArgs = {
  object: Eatfresh_Transaction_Logs_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Transaction_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Uploaded_FileArgs = {
  objects: Array<Eatfresh_Uploaded_File_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Uploaded_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Uploaded_File_OneArgs = {
  object: Eatfresh_Uploaded_File_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Uploaded_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_User_AccountArgs = {
  objects: Array<Eatfresh_User_Account_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_User_Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_User_Account_OneArgs = {
  object: Eatfresh_User_Account_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_User_Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Vat_CategoryArgs = {
  objects: Array<Eatfresh_Vat_Category_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Vat_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Vat_Category_OneArgs = {
  object: Eatfresh_Vat_Category_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Vat_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Vitamin_MineralArgs = {
  objects: Array<Eatfresh_Vitamin_Mineral_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Vitamin_Mineral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Vitamin_Mineral_OneArgs = {
  object: Eatfresh_Vitamin_Mineral_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Vitamin_Mineral_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_WarehouseArgs = {
  objects: Array<Eatfresh_Warehouse_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_AssignmentArgs = {
  objects: Array<Eatfresh_Warehouse_Assignment_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Assignment_OneArgs = {
  object: Eatfresh_Warehouse_Assignment_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Assignment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_OneArgs = {
  object: Eatfresh_Warehouse_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_OrderArgs = {
  objects: Array<Eatfresh_Warehouse_Order_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_OneArgs = {
  object: Eatfresh_Warehouse_Order_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_PositionArgs = {
  objects: Array<Eatfresh_Warehouse_Order_Position_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_Position_OneArgs = {
  object: Eatfresh_Warehouse_Order_Position_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_ReceiptArgs = {
  objects: Array<Eatfresh_Warehouse_Order_Receipt_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_Receipt_OneArgs = {
  object: Eatfresh_Warehouse_Order_Receipt_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_Receipt_PositionArgs = {
  objects: Array<Eatfresh_Warehouse_Order_Receipt_Position_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_Receipt_Position_OneArgs = {
  object: Eatfresh_Warehouse_Order_Receipt_Position_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_StatusArgs = {
  objects: Array<Eatfresh_Warehouse_Order_Status_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_Status_OneArgs = {
  object: Eatfresh_Warehouse_Order_Status_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_TypeArgs = {
  objects: Array<Eatfresh_Warehouse_Order_Type_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Order_Type_OneArgs = {
  object: Eatfresh_Warehouse_Order_Type_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Order_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_ShelfArgs = {
  objects: Array<Eatfresh_Warehouse_Shelf_Insert_Input>;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Shelf_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eatfresh_Warehouse_Shelf_OneArgs = {
  object: Eatfresh_Warehouse_Shelf_Insert_Input;
  on_conflict?: InputMaybe<Eatfresh_Warehouse_Shelf_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_VerificationArgs = {
  _set?: InputMaybe<Eatfresh_Age_Verification_Set_Input>;
  where: Eatfresh_Age_Verification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Age_Verification_Set_Input>;
  pk_columns: Eatfresh_Age_Verification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_ManyArgs = {
  updates: Array<Eatfresh_Age_Verification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Age_Verification_Status_Set_Input>;
  where: Eatfresh_Age_Verification_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Age_Verification_Status_Set_Input>;
  pk_columns: Eatfresh_Age_Verification_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_Status_ManyArgs = {
  updates: Array<Eatfresh_Age_Verification_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Age_Verification_Type_Set_Input>;
  where: Eatfresh_Age_Verification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Age_Verification_Type_Set_Input>;
  pk_columns: Eatfresh_Age_Verification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Age_Verification_Type_ManyArgs = {
  updates: Array<Eatfresh_Age_Verification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_ArticleArgs = {
  _inc?: InputMaybe<Eatfresh_Article_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Article_Set_Input>;
  where: Eatfresh_Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Article_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Article_Set_Input>;
  pk_columns: Eatfresh_Article_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_DetailsArgs = {
  _inc?: InputMaybe<Eatfresh_Article_Details_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Article_Details_Set_Input>;
  where: Eatfresh_Article_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Details_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Article_Details_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Article_Details_Set_Input>;
  pk_columns: Eatfresh_Article_Details_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Details_ManyArgs = {
  updates: Array<Eatfresh_Article_Details_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Labeling_ProcessArgs = {
  _inc?: InputMaybe<Eatfresh_Article_Labeling_Process_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Article_Labeling_Process_Set_Input>;
  where: Eatfresh_Article_Labeling_Process_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Labeling_Process_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Article_Labeling_Process_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Article_Labeling_Process_Set_Input>;
  pk_columns: Eatfresh_Article_Labeling_Process_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Labeling_Process_ManyArgs = {
  updates: Array<Eatfresh_Article_Labeling_Process_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Labeling_Process_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Set_Input>;
  where: Eatfresh_Article_Labeling_Process_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Labeling_Process_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Set_Input>;
  pk_columns: Eatfresh_Article_Labeling_Process_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_Labeling_Process_Status_ManyArgs = {
  updates: Array<Eatfresh_Article_Labeling_Process_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Article_ManyArgs = {
  updates: Array<Eatfresh_Article_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_PlacementArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Placement_Set_Input>;
  where: Eatfresh_Asset_Placement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Placement_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Placement_Set_Input>;
  pk_columns: Eatfresh_Asset_Placement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Placement_ManyArgs = {
  updates: Array<Eatfresh_Asset_Placement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_TransferArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Set_Input>;
  where: Eatfresh_Asset_Transfer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Set_Input>;
  pk_columns: Eatfresh_Asset_Transfer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_ManyArgs = {
  updates: Array<Eatfresh_Asset_Transfer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_ProblemArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Set_Input>;
  where: Eatfresh_Asset_Transfer_Problem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Set_Input>;
  pk_columns: Eatfresh_Asset_Transfer_Problem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_ManyArgs = {
  updates: Array<Eatfresh_Asset_Transfer_Problem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_SeverityArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Set_Input>;
  where: Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_Severity_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Set_Input>;
  pk_columns: Eatfresh_Asset_Transfer_Problem_Severity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_Severity_ManyArgs = {
  updates: Array<Eatfresh_Asset_Transfer_Problem_Severity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Set_Input>;
  where: Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Set_Input>;
  pk_columns: Eatfresh_Asset_Transfer_Problem_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Asset_Transfer_Problem_Status_ManyArgs = {
  updates: Array<Eatfresh_Asset_Transfer_Problem_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Auth_TokenArgs = {
  _set?: InputMaybe<Eatfresh_Auth_Token_Set_Input>;
  where: Eatfresh_Auth_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Auth_Token_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Auth_Token_Set_Input>;
  pk_columns: Eatfresh_Auth_Token_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Auth_Token_ManyArgs = {
  updates: Array<Eatfresh_Auth_Token_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_AuthenticatorsArgs = {
  _inc?: InputMaybe<Eatfresh_Authenticators_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Authenticators_Set_Input>;
  where: Eatfresh_Authenticators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Authenticators_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Authenticators_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Authenticators_Set_Input>;
  pk_columns: Eatfresh_Authenticators_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Authenticators_ManyArgs = {
  updates: Array<Eatfresh_Authenticators_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_B2b_CustomerArgs = {
  _set?: InputMaybe<Eatfresh_B2b_Customer_Set_Input>;
  where: Eatfresh_B2b_Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_B2b_Customer_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_B2b_Customer_Set_Input>;
  pk_columns: Eatfresh_B2b_Customer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_B2b_Customer_ManyArgs = {
  updates: Array<Eatfresh_B2b_Customer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_B2b_Customer_TypeArgs = {
  _set?: InputMaybe<Eatfresh_B2b_Customer_Type_Set_Input>;
  where: Eatfresh_B2b_Customer_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_B2b_Customer_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_B2b_Customer_Type_Set_Input>;
  pk_columns: Eatfresh_B2b_Customer_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_B2b_Customer_Type_ManyArgs = {
  updates: Array<Eatfresh_B2b_Customer_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Basic_User_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Basic_User_Type_Set_Input>;
  where: Eatfresh_Basic_User_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Basic_User_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Basic_User_Type_Set_Input>;
  pk_columns: Eatfresh_Basic_User_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Basic_User_Type_ManyArgs = {
  updates: Array<Eatfresh_Basic_User_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_PlanArgs = {
  _set?: InputMaybe<Eatfresh_Box_Content_Plan_Set_Input>;
  where: Eatfresh_Box_Content_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_Plan_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Box_Content_Plan_Set_Input>;
  pk_columns: Eatfresh_Box_Content_Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_Plan_ManyArgs = {
  updates: Array<Eatfresh_Box_Content_Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_Plan_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Set_Input>;
  where: Eatfresh_Box_Content_Plan_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_Plan_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Set_Input>;
  pk_columns: Eatfresh_Box_Content_Plan_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_Plan_Status_ManyArgs = {
  updates: Array<Eatfresh_Box_Content_Plan_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_To_ArticleArgs = {
  _inc?: InputMaybe<Eatfresh_Box_Content_To_Article_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Box_Content_To_Article_Set_Input>;
  where: Eatfresh_Box_Content_To_Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_To_Article_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Box_Content_To_Article_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Box_Content_To_Article_Set_Input>;
  pk_columns: Eatfresh_Box_Content_To_Article_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Box_Content_To_Article_ManyArgs = {
  updates: Array<Eatfresh_Box_Content_To_Article_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_ProcessArgs = {
  _inc?: InputMaybe<Eatfresh_Commissioning_Process_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Set_Input>;
  where: Eatfresh_Commissioning_Process_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Commissioning_Process_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Set_Input>;
  pk_columns: Eatfresh_Commissioning_Process_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_ManyArgs = {
  updates: Array<Eatfresh_Commissioning_Process_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_PositionArgs = {
  _inc?: InputMaybe<Eatfresh_Commissioning_Process_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Position_Set_Input>;
  where: Eatfresh_Commissioning_Process_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_Position_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Commissioning_Process_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Position_Set_Input>;
  pk_columns: Eatfresh_Commissioning_Process_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_Position_ManyArgs = {
  updates: Array<Eatfresh_Commissioning_Process_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Status_Set_Input>;
  where: Eatfresh_Commissioning_Process_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Commissioning_Process_Status_Set_Input>;
  pk_columns: Eatfresh_Commissioning_Process_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Commissioning_Process_Status_ManyArgs = {
  updates: Array<Eatfresh_Commissioning_Process_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Computop_TransactionArgs = {
  _set?: InputMaybe<Eatfresh_Computop_Transaction_Set_Input>;
  where: Eatfresh_Computop_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Computop_Transaction_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Computop_Transaction_Set_Input>;
  pk_columns: Eatfresh_Computop_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Computop_Transaction_ManyArgs = {
  updates: Array<Eatfresh_Computop_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Connection_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Connection_Status_Set_Input>;
  where: Eatfresh_Connection_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Connection_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Connection_Status_Set_Input>;
  pk_columns: Eatfresh_Connection_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Connection_Status_ManyArgs = {
  updates: Array<Eatfresh_Connection_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Cost_ConfigurationArgs = {
  _inc?: InputMaybe<Eatfresh_Cost_Configuration_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Cost_Configuration_Set_Input>;
  where: Eatfresh_Cost_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Cost_Configuration_KeyArgs = {
  _set?: InputMaybe<Eatfresh_Cost_Configuration_Key_Set_Input>;
  where: Eatfresh_Cost_Configuration_Key_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Cost_Configuration_Key_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Cost_Configuration_Key_Set_Input>;
  pk_columns: Eatfresh_Cost_Configuration_Key_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Cost_Configuration_Key_ManyArgs = {
  updates: Array<Eatfresh_Cost_Configuration_Key_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Cost_Configuration_ManyArgs = {
  updates: Array<Eatfresh_Cost_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_CustomerArgs = {
  _set?: InputMaybe<Eatfresh_Customer_Set_Input>;
  where: Eatfresh_Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Customer_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Customer_Set_Input>;
  pk_columns: Eatfresh_Customer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Customer_ManyArgs = {
  updates: Array<Eatfresh_Customer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Customer_OrderArgs = {
  _inc?: InputMaybe<Eatfresh_Customer_Order_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Customer_Order_Set_Input>;
  where: Eatfresh_Customer_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Customer_Order_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Customer_Order_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Customer_Order_Set_Input>;
  pk_columns: Eatfresh_Customer_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Customer_Order_ManyArgs = {
  updates: Array<Eatfresh_Customer_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Door_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Door_Status_Set_Input>;
  where: Eatfresh_Door_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Door_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Door_Status_Set_Input>;
  pk_columns: Eatfresh_Door_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Door_Status_ManyArgs = {
  updates: Array<Eatfresh_Door_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Easy_Refill_PermissionArgs = {
  _set?: InputMaybe<Eatfresh_Easy_Refill_Permission_Set_Input>;
  where: Eatfresh_Easy_Refill_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Easy_Refill_Permission_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Easy_Refill_Permission_Set_Input>;
  pk_columns: Eatfresh_Easy_Refill_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Easy_Refill_Permission_ManyArgs = {
  updates: Array<Eatfresh_Easy_Refill_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_External_Warehouse_Pallet_SpotArgs = {
  _set?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Set_Input>;
  where: Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_External_Warehouse_Pallet_Spot_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Set_Input>;
  pk_columns: Eatfresh_External_Warehouse_Pallet_Spot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_External_Warehouse_Pallet_Spot_ManyArgs = {
  updates: Array<Eatfresh_External_Warehouse_Pallet_Spot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Flyway_Schema_HistoryArgs = {
  _inc?: InputMaybe<Eatfresh_Flyway_Schema_History_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Flyway_Schema_History_Set_Input>;
  where: Eatfresh_Flyway_Schema_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Flyway_Schema_History_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Flyway_Schema_History_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Flyway_Schema_History_Set_Input>;
  pk_columns: Eatfresh_Flyway_Schema_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Flyway_Schema_History_ManyArgs = {
  updates: Array<Eatfresh_Flyway_Schema_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_FridgeArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Set_Input>;
  where: Eatfresh_Fridge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_AlarmArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Alarm_Set_Input>;
  where: Eatfresh_Fridge_Alarm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Alarm_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Alarm_Set_Input>;
  pk_columns: Eatfresh_Fridge_Alarm_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Alarm_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Alarm_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Article_Stock_SnapshotArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Set_Input>;
  where: Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Article_Stock_Snapshot_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Set_Input>;
  pk_columns: Eatfresh_Fridge_Article_Stock_Snapshot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Article_Stock_Snapshot_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Set_Input>;
  pk_columns: Eatfresh_Fridge_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_EventArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Event_Set_Input>;
  where: Eatfresh_Fridge_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Event_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Event_Set_Input>;
  pk_columns: Eatfresh_Fridge_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Event_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Event_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Event_Type_Set_Input>;
  where: Eatfresh_Fridge_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Event_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Event_Type_Set_Input>;
  pk_columns: Eatfresh_Fridge_Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Event_Type_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Event_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_LayoutArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Set_Input>;
  where: Eatfresh_Fridge_Layout_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_AssignmentArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Set_Input>;
  where: Eatfresh_Fridge_Layout_Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Assignment_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Set_Input>;
  pk_columns: Eatfresh_Fridge_Layout_Assignment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Assignment_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Layout_Assignment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Assignment_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Set_Input>;
  where: Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Assignment_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Set_Input>;
  pk_columns: Eatfresh_Fridge_Layout_Assignment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Assignment_Status_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Layout_Assignment_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Set_Input>;
  pk_columns: Eatfresh_Fridge_Layout_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_LevelArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Layout_Level_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Level_Set_Input>;
  where: Eatfresh_Fridge_Layout_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Level_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Layout_Level_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Level_Set_Input>;
  pk_columns: Eatfresh_Fridge_Layout_Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Level_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Layout_Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Level_PositionArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Set_Input>;
  where: Eatfresh_Fridge_Layout_Level_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Level_Position_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Set_Input>;
  pk_columns: Eatfresh_Fridge_Layout_Level_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_Level_Position_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Layout_Level_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Layout_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Layout_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_OrderArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Order_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Order_Set_Input>;
  where: Eatfresh_Fridge_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Order_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Order_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Order_Set_Input>;
  pk_columns: Eatfresh_Fridge_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Order_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Status_HistoryArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Status_History_Set_Input>;
  where: Eatfresh_Fridge_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Status_History_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Status_History_Set_Input>;
  pk_columns: Eatfresh_Fridge_Status_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Status_History_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Status_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_StockArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Stock_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Stock_Set_Input>;
  where: Eatfresh_Fridge_Stock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Stock_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Stock_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Stock_Set_Input>;
  pk_columns: Eatfresh_Fridge_Stock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Stock_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Stock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Target_StockArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Target_Stock_Set_Input>;
  where: Eatfresh_Fridge_Target_Stock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Target_Stock_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Target_Stock_Set_Input>;
  pk_columns: Eatfresh_Fridge_Target_Stock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Target_Stock_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Target_Stock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Target_Stock_PositionArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Set_Input>;
  where: Eatfresh_Fridge_Target_Stock_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Target_Stock_Position_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Set_Input>;
  pk_columns: Eatfresh_Fridge_Target_Stock_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Target_Stock_Position_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Target_Stock_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Type_Set_Input>;
  where: Eatfresh_Fridge_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Fridge_Type_Set_Input>;
  pk_columns: Eatfresh_Fridge_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Fridge_Type_ManyArgs = {
  updates: Array<Eatfresh_Fridge_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_ProblemArgs = {
  _append?: InputMaybe<Eatfresh_Logistics_Problem_Append_Input>;
  _delete_at_path?: InputMaybe<Eatfresh_Logistics_Problem_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Eatfresh_Logistics_Problem_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Eatfresh_Logistics_Problem_Delete_Key_Input>;
  _prepend?: InputMaybe<Eatfresh_Logistics_Problem_Prepend_Input>;
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Set_Input>;
  where: Eatfresh_Logistics_Problem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_By_PkArgs = {
  _append?: InputMaybe<Eatfresh_Logistics_Problem_Append_Input>;
  _delete_at_path?: InputMaybe<Eatfresh_Logistics_Problem_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Eatfresh_Logistics_Problem_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Eatfresh_Logistics_Problem_Delete_Key_Input>;
  _prepend?: InputMaybe<Eatfresh_Logistics_Problem_Prepend_Input>;
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Set_Input>;
  pk_columns: Eatfresh_Logistics_Problem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_ImageArgs = {
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Image_Set_Input>;
  where: Eatfresh_Logistics_Problem_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_Image_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Image_Set_Input>;
  pk_columns: Eatfresh_Logistics_Problem_Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_Image_ManyArgs = {
  updates: Array<Eatfresh_Logistics_Problem_Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_ManyArgs = {
  updates: Array<Eatfresh_Logistics_Problem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Status_Set_Input>;
  where: Eatfresh_Logistics_Problem_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Logistics_Problem_Status_Set_Input>;
  pk_columns: Eatfresh_Logistics_Problem_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Problem_Status_ManyArgs = {
  updates: Array<Eatfresh_Logistics_Problem_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Process_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Logistics_Process_Type_Set_Input>;
  where: Eatfresh_Logistics_Process_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Process_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Logistics_Process_Type_Set_Input>;
  pk_columns: Eatfresh_Logistics_Process_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Logistics_Process_Type_ManyArgs = {
  updates: Array<Eatfresh_Logistics_Process_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Nutrition_InformationArgs = {
  _inc?: InputMaybe<Eatfresh_Nutrition_Information_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Nutrition_Information_Set_Input>;
  where: Eatfresh_Nutrition_Information_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Nutrition_Information_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Nutrition_Information_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Nutrition_Information_Set_Input>;
  pk_columns: Eatfresh_Nutrition_Information_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Nutrition_Information_ManyArgs = {
  updates: Array<Eatfresh_Nutrition_Information_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_ExtraArgs = {
  _inc?: InputMaybe<Eatfresh_Order_Extra_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Order_Extra_Set_Input>;
  where: Eatfresh_Order_Extra_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Extra_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Order_Extra_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Order_Extra_Set_Input>;
  pk_columns: Eatfresh_Order_Extra_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Extra_Customer_OrderArgs = {
  _set?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Set_Input>;
  where: Eatfresh_Order_Extra_Customer_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Extra_Customer_Order_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Set_Input>;
  pk_columns: Eatfresh_Order_Extra_Customer_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Extra_Customer_Order_ManyArgs = {
  updates: Array<Eatfresh_Order_Extra_Customer_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Extra_ManyArgs = {
  updates: Array<Eatfresh_Order_Extra_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_PositionArgs = {
  _inc?: InputMaybe<Eatfresh_Order_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Order_Position_Set_Input>;
  where: Eatfresh_Order_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Position_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Order_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Order_Position_Set_Input>;
  pk_columns: Eatfresh_Order_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Position_CategoryArgs = {
  _set?: InputMaybe<Eatfresh_Order_Position_Category_Set_Input>;
  where: Eatfresh_Order_Position_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Position_Category_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Order_Position_Category_Set_Input>;
  pk_columns: Eatfresh_Order_Position_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Position_Category_ManyArgs = {
  updates: Array<Eatfresh_Order_Position_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Position_ManyArgs = {
  updates: Array<Eatfresh_Order_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Order_Status_Set_Input>;
  where: Eatfresh_Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Order_Status_Set_Input>;
  pk_columns: Eatfresh_Order_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Order_Status_ManyArgs = {
  updates: Array<Eatfresh_Order_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Packaging_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Packaging_Type_Set_Input>;
  where: Eatfresh_Packaging_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Packaging_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Packaging_Type_Set_Input>;
  pk_columns: Eatfresh_Packaging_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Packaging_Type_ManyArgs = {
  updates: Array<Eatfresh_Packaging_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Password_Reset_TokenArgs = {
  _set?: InputMaybe<Eatfresh_Password_Reset_Token_Set_Input>;
  where: Eatfresh_Password_Reset_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Password_Reset_Token_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Password_Reset_Token_Set_Input>;
  pk_columns: Eatfresh_Password_Reset_Token_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Password_Reset_Token_ManyArgs = {
  updates: Array<Eatfresh_Password_Reset_Token_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_MethodArgs = {
  _set?: InputMaybe<Eatfresh_Payment_Method_Set_Input>;
  where: Eatfresh_Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_Method_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Payment_Method_Set_Input>;
  pk_columns: Eatfresh_Payment_Method_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_Method_ManyArgs = {
  updates: Array<Eatfresh_Payment_Method_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_Method_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Payment_Method_Type_Set_Input>;
  where: Eatfresh_Payment_Method_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_Method_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Payment_Method_Type_Set_Input>;
  pk_columns: Eatfresh_Payment_Method_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_Method_Type_ManyArgs = {
  updates: Array<Eatfresh_Payment_Method_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Payment_Status_Set_Input>;
  where: Eatfresh_Payment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Payment_Status_Set_Input>;
  pk_columns: Eatfresh_Payment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Payment_Status_ManyArgs = {
  updates: Array<Eatfresh_Payment_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_PlaceArgs = {
  _inc?: InputMaybe<Eatfresh_Place_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Place_Set_Input>;
  where: Eatfresh_Place_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Place_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Place_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Place_Set_Input>;
  pk_columns: Eatfresh_Place_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Place_ManyArgs = {
  updates: Array<Eatfresh_Place_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_ChangeArgs = {
  _inc?: InputMaybe<Eatfresh_Price_Change_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Price_Change_Set_Input>;
  where: Eatfresh_Price_Change_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Price_Change_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Price_Change_Set_Input>;
  pk_columns: Eatfresh_Price_Change_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_ManyArgs = {
  updates: Array<Eatfresh_Price_Change_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_PositionArgs = {
  _set?: InputMaybe<Eatfresh_Price_Change_Position_Set_Input>;
  where: Eatfresh_Price_Change_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_Position_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Price_Change_Position_Set_Input>;
  pk_columns: Eatfresh_Price_Change_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_Position_ManyArgs = {
  updates: Array<Eatfresh_Price_Change_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_Position_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Price_Change_Position_Status_Set_Input>;
  where: Eatfresh_Price_Change_Position_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_Position_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Price_Change_Position_Status_Set_Input>;
  pk_columns: Eatfresh_Price_Change_Position_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Change_Position_Status_ManyArgs = {
  updates: Array<Eatfresh_Price_Change_Position_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_LockArgs = {
  _inc?: InputMaybe<Eatfresh_Price_Lock_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Price_Lock_Set_Input>;
  where: Eatfresh_Price_Lock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Lock_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Price_Lock_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Price_Lock_Set_Input>;
  pk_columns: Eatfresh_Price_Lock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Price_Lock_ManyArgs = {
  updates: Array<Eatfresh_Price_Lock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Product_OrientationArgs = {
  _set?: InputMaybe<Eatfresh_Product_Orientation_Set_Input>;
  where: Eatfresh_Product_Orientation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Product_Orientation_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Product_Orientation_Set_Input>;
  pk_columns: Eatfresh_Product_Orientation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Product_Orientation_ManyArgs = {
  updates: Array<Eatfresh_Product_Orientation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_RefillArgs = {
  _inc?: InputMaybe<Eatfresh_Refill_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Refill_Set_Input>;
  where: Eatfresh_Refill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Refill_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Refill_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Refill_Set_Input>;
  pk_columns: Eatfresh_Refill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Refill_ManyArgs = {
  updates: Array<Eatfresh_Refill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Refill_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Refill_Status_Set_Input>;
  where: Eatfresh_Refill_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Refill_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Refill_Status_Set_Input>;
  pk_columns: Eatfresh_Refill_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Refill_Status_ManyArgs = {
  updates: Array<Eatfresh_Refill_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_AssetArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Asset_Set_Input>;
  where: Eatfresh_Rfid_Asset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Asset_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Asset_Set_Input>;
  pk_columns: Eatfresh_Rfid_Asset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Asset_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Asset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Asset_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Asset_Type_Set_Input>;
  where: Eatfresh_Rfid_Asset_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Asset_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Asset_Type_Set_Input>;
  pk_columns: Eatfresh_Rfid_Asset_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Asset_Type_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Asset_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_BoxArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Box_Set_Input>;
  where: Eatfresh_Rfid_Box_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Box_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Box_Set_Input>;
  pk_columns: Eatfresh_Rfid_Box_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Box_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Box_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Box_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Box_Type_Set_Input>;
  where: Eatfresh_Rfid_Box_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Box_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Box_Type_Set_Input>;
  pk_columns: Eatfresh_Rfid_Box_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Box_Type_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Box_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_ScanArgs = {
  _inc?: InputMaybe<Eatfresh_Rfid_Scan_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Rfid_Scan_Set_Input>;
  where: Eatfresh_Rfid_Scan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scan_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Rfid_Scan_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Rfid_Scan_Set_Input>;
  pk_columns: Eatfresh_Rfid_Scan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scan_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Scan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scan_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Scan_Status_Set_Input>;
  where: Eatfresh_Rfid_Scan_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scan_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Scan_Status_Set_Input>;
  pk_columns: Eatfresh_Rfid_Scan_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scan_Status_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Scan_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_ScannerArgs = {
  _inc?: InputMaybe<Eatfresh_Rfid_Scanner_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Rfid_Scanner_Set_Input>;
  where: Eatfresh_Rfid_Scanner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scanner_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Rfid_Scanner_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Rfid_Scanner_Set_Input>;
  pk_columns: Eatfresh_Rfid_Scanner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scanner_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Scanner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scanner_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Set_Input>;
  where: Eatfresh_Rfid_Scanner_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scanner_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Set_Input>;
  pk_columns: Eatfresh_Rfid_Scanner_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Scanner_Type_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Scanner_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Status_Set_Input>;
  where: Eatfresh_Rfid_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Rfid_Status_Set_Input>;
  pk_columns: Eatfresh_Rfid_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Status_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_TagArgs = {
  _inc?: InputMaybe<Eatfresh_Rfid_Tag_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Rfid_Tag_Set_Input>;
  where: Eatfresh_Rfid_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Tag_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Rfid_Tag_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Rfid_Tag_Set_Input>;
  pk_columns: Eatfresh_Rfid_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Rfid_Tag_ManyArgs = {
  updates: Array<Eatfresh_Rfid_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Selfly_Cabinet_StateArgs = {
  _set?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Set_Input>;
  where: Eatfresh_Selfly_Cabinet_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Selfly_Cabinet_State_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Set_Input>;
  pk_columns: Eatfresh_Selfly_Cabinet_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Selfly_Cabinet_State_ManyArgs = {
  updates: Array<Eatfresh_Selfly_Cabinet_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Session_StepArgs = {
  _set?: InputMaybe<Eatfresh_Session_Step_Set_Input>;
  where: Eatfresh_Session_Step_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Session_Step_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Session_Step_Set_Input>;
  pk_columns: Eatfresh_Session_Step_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Session_Step_ManyArgs = {
  updates: Array<Eatfresh_Session_Step_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Shelf_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Shelf_Type_Set_Input>;
  where: Eatfresh_Shelf_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Shelf_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Shelf_Type_Set_Input>;
  pk_columns: Eatfresh_Shelf_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Shelf_Type_ManyArgs = {
  updates: Array<Eatfresh_Shelf_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Supplier_ProblemArgs = {
  _inc?: InputMaybe<Eatfresh_Supplier_Problem_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Supplier_Problem_Set_Input>;
  where: Eatfresh_Supplier_Problem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Supplier_Problem_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Supplier_Problem_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Supplier_Problem_Set_Input>;
  pk_columns: Eatfresh_Supplier_Problem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Supplier_Problem_ManyArgs = {
  updates: Array<Eatfresh_Supplier_Problem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Supplier_Problem_To_FileArgs = {
  _set?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Set_Input>;
  where: Eatfresh_Supplier_Problem_To_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Supplier_Problem_To_File_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Set_Input>;
  pk_columns: Eatfresh_Supplier_Problem_To_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Supplier_Problem_To_File_ManyArgs = {
  updates: Array<Eatfresh_Supplier_Problem_To_File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Transaction_LogsArgs = {
  _set?: InputMaybe<Eatfresh_Transaction_Logs_Set_Input>;
  where: Eatfresh_Transaction_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Transaction_Logs_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Transaction_Logs_Set_Input>;
  pk_columns: Eatfresh_Transaction_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Transaction_Logs_ManyArgs = {
  updates: Array<Eatfresh_Transaction_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Uploaded_FileArgs = {
  _set?: InputMaybe<Eatfresh_Uploaded_File_Set_Input>;
  where: Eatfresh_Uploaded_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Uploaded_File_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Uploaded_File_Set_Input>;
  pk_columns: Eatfresh_Uploaded_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Uploaded_File_ManyArgs = {
  updates: Array<Eatfresh_Uploaded_File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_User_AccountArgs = {
  _set?: InputMaybe<Eatfresh_User_Account_Set_Input>;
  where: Eatfresh_User_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_User_Account_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_User_Account_Set_Input>;
  pk_columns: Eatfresh_User_Account_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_User_Account_ManyArgs = {
  updates: Array<Eatfresh_User_Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Vat_CategoryArgs = {
  _inc?: InputMaybe<Eatfresh_Vat_Category_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Vat_Category_Set_Input>;
  where: Eatfresh_Vat_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Vat_Category_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Vat_Category_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Vat_Category_Set_Input>;
  pk_columns: Eatfresh_Vat_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Vat_Category_ManyArgs = {
  updates: Array<Eatfresh_Vat_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Vitamin_MineralArgs = {
  _inc?: InputMaybe<Eatfresh_Vitamin_Mineral_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Vitamin_Mineral_Set_Input>;
  where: Eatfresh_Vitamin_Mineral_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Vitamin_Mineral_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Vitamin_Mineral_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Vitamin_Mineral_Set_Input>;
  pk_columns: Eatfresh_Vitamin_Mineral_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Vitamin_Mineral_ManyArgs = {
  updates: Array<Eatfresh_Vitamin_Mineral_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_WarehouseArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Set_Input>;
  where: Eatfresh_Warehouse_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_AssignmentArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Assignment_Set_Input>;
  where: Eatfresh_Warehouse_Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Assignment_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Assignment_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Assignment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Assignment_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Assignment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_OrderArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Set_Input>;
  where: Eatfresh_Warehouse_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_PositionArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Position_Set_Input>;
  where: Eatfresh_Warehouse_Order_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Position_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Position_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Order_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Position_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Order_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_ReceiptArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Set_Input>;
  where: Eatfresh_Warehouse_Order_Receipt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Receipt_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Order_Receipt_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Receipt_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Order_Receipt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Receipt_PositionArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Set_Input>;
  where: Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Receipt_Position_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Order_Receipt_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Receipt_Position_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Order_Receipt_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_StatusArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Status_Set_Input>;
  where: Eatfresh_Warehouse_Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Status_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Status_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Order_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Status_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Order_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_TypeArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Type_Set_Input>;
  where: Eatfresh_Warehouse_Order_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Type_By_PkArgs = {
  _set?: InputMaybe<Eatfresh_Warehouse_Order_Type_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Order_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Order_Type_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Order_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_ShelfArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Shelf_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Shelf_Set_Input>;
  where: Eatfresh_Warehouse_Shelf_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Shelf_By_PkArgs = {
  _inc?: InputMaybe<Eatfresh_Warehouse_Shelf_Inc_Input>;
  _set?: InputMaybe<Eatfresh_Warehouse_Shelf_Set_Input>;
  pk_columns: Eatfresh_Warehouse_Shelf_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Eatfresh_Warehouse_Shelf_ManyArgs = {
  updates: Array<Eatfresh_Warehouse_Shelf_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "eatfresh.age_verification" */
  eatfresh_age_verification: Array<Eatfresh_Age_Verification>;
  /** fetch aggregated fields from the table: "eatfresh.age_verification" */
  eatfresh_age_verification_aggregate: Eatfresh_Age_Verification_Aggregate;
  /** fetch data from the table: "eatfresh.age_verification" using primary key columns */
  eatfresh_age_verification_by_pk?: Maybe<Eatfresh_Age_Verification>;
  /** fetch data from the table: "eatfresh.age_verification_status" */
  eatfresh_age_verification_status: Array<Eatfresh_Age_Verification_Status>;
  /** fetch aggregated fields from the table: "eatfresh.age_verification_status" */
  eatfresh_age_verification_status_aggregate: Eatfresh_Age_Verification_Status_Aggregate;
  /** fetch data from the table: "eatfresh.age_verification_status" using primary key columns */
  eatfresh_age_verification_status_by_pk?: Maybe<Eatfresh_Age_Verification_Status>;
  /** fetch data from the table: "eatfresh.age_verification_type" */
  eatfresh_age_verification_type: Array<Eatfresh_Age_Verification_Type>;
  /** fetch aggregated fields from the table: "eatfresh.age_verification_type" */
  eatfresh_age_verification_type_aggregate: Eatfresh_Age_Verification_Type_Aggregate;
  /** fetch data from the table: "eatfresh.age_verification_type" using primary key columns */
  eatfresh_age_verification_type_by_pk?: Maybe<Eatfresh_Age_Verification_Type>;
  /** fetch data from the table: "eatfresh.article" */
  eatfresh_article: Array<Eatfresh_Article>;
  /** fetch aggregated fields from the table: "eatfresh.article" */
  eatfresh_article_aggregate: Eatfresh_Article_Aggregate;
  /** fetch data from the table: "eatfresh.article" using primary key columns */
  eatfresh_article_by_pk?: Maybe<Eatfresh_Article>;
  /** fetch data from the table: "eatfresh.article_details" */
  eatfresh_article_details: Array<Eatfresh_Article_Details>;
  /** fetch aggregated fields from the table: "eatfresh.article_details" */
  eatfresh_article_details_aggregate: Eatfresh_Article_Details_Aggregate;
  /** fetch data from the table: "eatfresh.article_details" using primary key columns */
  eatfresh_article_details_by_pk?: Maybe<Eatfresh_Article_Details>;
  /** fetch data from the table: "eatfresh.article_labeling_process" */
  eatfresh_article_labeling_process: Array<Eatfresh_Article_Labeling_Process>;
  /** fetch aggregated fields from the table: "eatfresh.article_labeling_process" */
  eatfresh_article_labeling_process_aggregate: Eatfresh_Article_Labeling_Process_Aggregate;
  /** fetch data from the table: "eatfresh.article_labeling_process" using primary key columns */
  eatfresh_article_labeling_process_by_pk?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** fetch data from the table: "eatfresh.article_labeling_process_status" */
  eatfresh_article_labeling_process_status: Array<Eatfresh_Article_Labeling_Process_Status>;
  /** fetch aggregated fields from the table: "eatfresh.article_labeling_process_status" */
  eatfresh_article_labeling_process_status_aggregate: Eatfresh_Article_Labeling_Process_Status_Aggregate;
  /** fetch data from the table: "eatfresh.article_labeling_process_status" using primary key columns */
  eatfresh_article_labeling_process_status_by_pk?: Maybe<Eatfresh_Article_Labeling_Process_Status>;
  /** fetch data from the table: "eatfresh.asset_placement" */
  eatfresh_asset_placement: Array<Eatfresh_Asset_Placement>;
  /** fetch aggregated fields from the table: "eatfresh.asset_placement" */
  eatfresh_asset_placement_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** fetch data from the table: "eatfresh.asset_placement" using primary key columns */
  eatfresh_asset_placement_by_pk?: Maybe<Eatfresh_Asset_Placement>;
  /** fetch data from the table: "eatfresh.asset_transfer" */
  eatfresh_asset_transfer: Array<Eatfresh_Asset_Transfer>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer" */
  eatfresh_asset_transfer_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer" using primary key columns */
  eatfresh_asset_transfer_by_pk?: Maybe<Eatfresh_Asset_Transfer>;
  /** fetch data from the table: "eatfresh.asset_transfer_problem" */
  eatfresh_asset_transfer_problem: Array<Eatfresh_Asset_Transfer_Problem>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer_problem" */
  eatfresh_asset_transfer_problem_aggregate: Eatfresh_Asset_Transfer_Problem_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer_problem" using primary key columns */
  eatfresh_asset_transfer_problem_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem>;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_severity" */
  eatfresh_asset_transfer_problem_severity: Array<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer_problem_severity" */
  eatfresh_asset_transfer_problem_severity_aggregate: Eatfresh_Asset_Transfer_Problem_Severity_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_severity" using primary key columns */
  eatfresh_asset_transfer_problem_severity_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_status" */
  eatfresh_asset_transfer_problem_status: Array<Eatfresh_Asset_Transfer_Problem_Status>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer_problem_status" */
  eatfresh_asset_transfer_problem_status_aggregate: Eatfresh_Asset_Transfer_Problem_Status_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_status" using primary key columns */
  eatfresh_asset_transfer_problem_status_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Status>;
  /** fetch data from the table: "eatfresh.auth_token" */
  eatfresh_auth_token: Array<Eatfresh_Auth_Token>;
  /** fetch aggregated fields from the table: "eatfresh.auth_token" */
  eatfresh_auth_token_aggregate: Eatfresh_Auth_Token_Aggregate;
  /** fetch data from the table: "eatfresh.auth_token" using primary key columns */
  eatfresh_auth_token_by_pk?: Maybe<Eatfresh_Auth_Token>;
  /** fetch data from the table: "eatfresh.authenticators" */
  eatfresh_authenticators: Array<Eatfresh_Authenticators>;
  /** fetch aggregated fields from the table: "eatfresh.authenticators" */
  eatfresh_authenticators_aggregate: Eatfresh_Authenticators_Aggregate;
  /** fetch data from the table: "eatfresh.authenticators" using primary key columns */
  eatfresh_authenticators_by_pk?: Maybe<Eatfresh_Authenticators>;
  /** fetch data from the table: "eatfresh.b2b_customer" */
  eatfresh_b2b_customer: Array<Eatfresh_B2b_Customer>;
  /** fetch aggregated fields from the table: "eatfresh.b2b_customer" */
  eatfresh_b2b_customer_aggregate: Eatfresh_B2b_Customer_Aggregate;
  /** fetch data from the table: "eatfresh.b2b_customer" using primary key columns */
  eatfresh_b2b_customer_by_pk?: Maybe<Eatfresh_B2b_Customer>;
  /** fetch data from the table: "eatfresh.b2b_customer_type" */
  eatfresh_b2b_customer_type: Array<Eatfresh_B2b_Customer_Type>;
  /** fetch aggregated fields from the table: "eatfresh.b2b_customer_type" */
  eatfresh_b2b_customer_type_aggregate: Eatfresh_B2b_Customer_Type_Aggregate;
  /** fetch data from the table: "eatfresh.b2b_customer_type" using primary key columns */
  eatfresh_b2b_customer_type_by_pk?: Maybe<Eatfresh_B2b_Customer_Type>;
  /** fetch data from the table: "eatfresh.basic_user_type" */
  eatfresh_basic_user_type: Array<Eatfresh_Basic_User_Type>;
  /** fetch aggregated fields from the table: "eatfresh.basic_user_type" */
  eatfresh_basic_user_type_aggregate: Eatfresh_Basic_User_Type_Aggregate;
  /** fetch data from the table: "eatfresh.basic_user_type" using primary key columns */
  eatfresh_basic_user_type_by_pk?: Maybe<Eatfresh_Basic_User_Type>;
  /** fetch data from the table: "eatfresh.box_content_plan" */
  eatfresh_box_content_plan: Array<Eatfresh_Box_Content_Plan>;
  /** fetch aggregated fields from the table: "eatfresh.box_content_plan" */
  eatfresh_box_content_plan_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  /** fetch data from the table: "eatfresh.box_content_plan" using primary key columns */
  eatfresh_box_content_plan_by_pk?: Maybe<Eatfresh_Box_Content_Plan>;
  /** fetch data from the table: "eatfresh.box_content_plan_status" */
  eatfresh_box_content_plan_status: Array<Eatfresh_Box_Content_Plan_Status>;
  /** fetch aggregated fields from the table: "eatfresh.box_content_plan_status" */
  eatfresh_box_content_plan_status_aggregate: Eatfresh_Box_Content_Plan_Status_Aggregate;
  /** fetch data from the table: "eatfresh.box_content_plan_status" using primary key columns */
  eatfresh_box_content_plan_status_by_pk?: Maybe<Eatfresh_Box_Content_Plan_Status>;
  /** fetch data from the table: "eatfresh.box_content_to_article" */
  eatfresh_box_content_to_article: Array<Eatfresh_Box_Content_To_Article>;
  /** fetch aggregated fields from the table: "eatfresh.box_content_to_article" */
  eatfresh_box_content_to_article_aggregate: Eatfresh_Box_Content_To_Article_Aggregate;
  /** fetch data from the table: "eatfresh.box_content_to_article" using primary key columns */
  eatfresh_box_content_to_article_by_pk?: Maybe<Eatfresh_Box_Content_To_Article>;
  /** fetch data from the table: "eatfresh.commissioning_process" */
  eatfresh_commissioning_process: Array<Eatfresh_Commissioning_Process>;
  /** fetch aggregated fields from the table: "eatfresh.commissioning_process" */
  eatfresh_commissioning_process_aggregate: Eatfresh_Commissioning_Process_Aggregate;
  /** fetch data from the table: "eatfresh.commissioning_process" using primary key columns */
  eatfresh_commissioning_process_by_pk?: Maybe<Eatfresh_Commissioning_Process>;
  /** fetch data from the table: "eatfresh.commissioning_process_position" */
  eatfresh_commissioning_process_position: Array<Eatfresh_Commissioning_Process_Position>;
  /** fetch aggregated fields from the table: "eatfresh.commissioning_process_position" */
  eatfresh_commissioning_process_position_aggregate: Eatfresh_Commissioning_Process_Position_Aggregate;
  /** fetch data from the table: "eatfresh.commissioning_process_position" using primary key columns */
  eatfresh_commissioning_process_position_by_pk?: Maybe<Eatfresh_Commissioning_Process_Position>;
  /** fetch data from the table: "eatfresh.commissioning_process_status" */
  eatfresh_commissioning_process_status: Array<Eatfresh_Commissioning_Process_Status>;
  /** fetch aggregated fields from the table: "eatfresh.commissioning_process_status" */
  eatfresh_commissioning_process_status_aggregate: Eatfresh_Commissioning_Process_Status_Aggregate;
  /** fetch data from the table: "eatfresh.commissioning_process_status" using primary key columns */
  eatfresh_commissioning_process_status_by_pk?: Maybe<Eatfresh_Commissioning_Process_Status>;
  /** fetch data from the table: "eatfresh.computop_transaction" */
  eatfresh_computop_transaction: Array<Eatfresh_Computop_Transaction>;
  /** fetch aggregated fields from the table: "eatfresh.computop_transaction" */
  eatfresh_computop_transaction_aggregate: Eatfresh_Computop_Transaction_Aggregate;
  /** fetch data from the table: "eatfresh.computop_transaction" using primary key columns */
  eatfresh_computop_transaction_by_pk?: Maybe<Eatfresh_Computop_Transaction>;
  /** fetch data from the table: "eatfresh.connection_status" */
  eatfresh_connection_status: Array<Eatfresh_Connection_Status>;
  /** fetch aggregated fields from the table: "eatfresh.connection_status" */
  eatfresh_connection_status_aggregate: Eatfresh_Connection_Status_Aggregate;
  /** fetch data from the table: "eatfresh.connection_status" using primary key columns */
  eatfresh_connection_status_by_pk?: Maybe<Eatfresh_Connection_Status>;
  /** fetch data from the table: "eatfresh.cost_configuration" */
  eatfresh_cost_configuration: Array<Eatfresh_Cost_Configuration>;
  /** fetch aggregated fields from the table: "eatfresh.cost_configuration" */
  eatfresh_cost_configuration_aggregate: Eatfresh_Cost_Configuration_Aggregate;
  /** fetch data from the table: "eatfresh.cost_configuration_key" */
  eatfresh_cost_configuration_key: Array<Eatfresh_Cost_Configuration_Key>;
  /** fetch aggregated fields from the table: "eatfresh.cost_configuration_key" */
  eatfresh_cost_configuration_key_aggregate: Eatfresh_Cost_Configuration_Key_Aggregate;
  /** fetch data from the table: "eatfresh.cost_configuration_key" using primary key columns */
  eatfresh_cost_configuration_key_by_pk?: Maybe<Eatfresh_Cost_Configuration_Key>;
  /** fetch data from the table: "eatfresh.customer" */
  eatfresh_customer: Array<Eatfresh_Customer>;
  /** fetch aggregated fields from the table: "eatfresh.customer" */
  eatfresh_customer_aggregate: Eatfresh_Customer_Aggregate;
  /** fetch data from the table: "eatfresh.customer" using primary key columns */
  eatfresh_customer_by_pk?: Maybe<Eatfresh_Customer>;
  /** fetch data from the table: "eatfresh.customer_order" */
  eatfresh_customer_order: Array<Eatfresh_Customer_Order>;
  /** fetch aggregated fields from the table: "eatfresh.customer_order" */
  eatfresh_customer_order_aggregate: Eatfresh_Customer_Order_Aggregate;
  /** fetch data from the table: "eatfresh.customer_order" using primary key columns */
  eatfresh_customer_order_by_pk?: Maybe<Eatfresh_Customer_Order>;
  /** fetch data from the table: "eatfresh.door_status" */
  eatfresh_door_status: Array<Eatfresh_Door_Status>;
  /** fetch aggregated fields from the table: "eatfresh.door_status" */
  eatfresh_door_status_aggregate: Eatfresh_Door_Status_Aggregate;
  /** fetch data from the table: "eatfresh.door_status" using primary key columns */
  eatfresh_door_status_by_pk?: Maybe<Eatfresh_Door_Status>;
  /** fetch data from the table: "eatfresh.easy_refill_permission" */
  eatfresh_easy_refill_permission: Array<Eatfresh_Easy_Refill_Permission>;
  /** fetch aggregated fields from the table: "eatfresh.easy_refill_permission" */
  eatfresh_easy_refill_permission_aggregate: Eatfresh_Easy_Refill_Permission_Aggregate;
  /** fetch data from the table: "eatfresh.easy_refill_permission" using primary key columns */
  eatfresh_easy_refill_permission_by_pk?: Maybe<Eatfresh_Easy_Refill_Permission>;
  /** fetch data from the table: "eatfresh.external_warehouse_pallet_spot" */
  eatfresh_external_warehouse_pallet_spot: Array<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** fetch aggregated fields from the table: "eatfresh.external_warehouse_pallet_spot" */
  eatfresh_external_warehouse_pallet_spot_aggregate: Eatfresh_External_Warehouse_Pallet_Spot_Aggregate;
  /** fetch data from the table: "eatfresh.external_warehouse_pallet_spot" using primary key columns */
  eatfresh_external_warehouse_pallet_spot_by_pk?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** fetch data from the table: "eatfresh.flyway_schema_history" */
  eatfresh_flyway_schema_history: Array<Eatfresh_Flyway_Schema_History>;
  /** fetch aggregated fields from the table: "eatfresh.flyway_schema_history" */
  eatfresh_flyway_schema_history_aggregate: Eatfresh_Flyway_Schema_History_Aggregate;
  /** fetch data from the table: "eatfresh.flyway_schema_history" using primary key columns */
  eatfresh_flyway_schema_history_by_pk?: Maybe<Eatfresh_Flyway_Schema_History>;
  /** fetch data from the table: "eatfresh.fridge" */
  eatfresh_fridge: Array<Eatfresh_Fridge>;
  /** fetch data from the table: "eatfresh.fridge_active_daily" */
  eatfresh_fridge_active_daily: Array<Eatfresh_Fridge_Active_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_active_daily" */
  eatfresh_fridge_active_daily_aggregate: Eatfresh_Fridge_Active_Daily_Aggregate;
  /** fetch aggregated fields from the table: "eatfresh.fridge" */
  eatfresh_fridge_aggregate: Eatfresh_Fridge_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_alarm" */
  eatfresh_fridge_alarm: Array<Eatfresh_Fridge_Alarm>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_alarm" */
  eatfresh_fridge_alarm_aggregate: Eatfresh_Fridge_Alarm_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_alarm" using primary key columns */
  eatfresh_fridge_alarm_by_pk?: Maybe<Eatfresh_Fridge_Alarm>;
  /** fetch data from the table: "eatfresh.fridge_article_stock" */
  eatfresh_fridge_article_stock: Array<Eatfresh_Fridge_Article_Stock>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock" */
  eatfresh_fridge_article_stock_aggregate: Eatfresh_Fridge_Article_Stock_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot" */
  eatfresh_fridge_article_stock_snapshot: Array<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock_snapshot" */
  eatfresh_fridge_article_stock_snapshot_aggregate: Eatfresh_Fridge_Article_Stock_Snapshot_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot" using primary key columns */
  eatfresh_fridge_article_stock_snapshot_by_pk?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot_daily" */
  eatfresh_fridge_article_stock_snapshot_daily: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock_snapshot_daily" */
  eatfresh_fridge_article_stock_snapshot_daily_aggregate: Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
  eatfresh_fridge_article_stock_snapshot_enabled_daily: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
  eatfresh_fridge_article_stock_snapshot_enabled_daily_aggregate: Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Aggregate;
  /** fetch data from the table: "eatfresh.fridge" using primary key columns */
  eatfresh_fridge_by_pk?: Maybe<Eatfresh_Fridge>;
  /** fetch data from the table: "eatfresh.fridge_event" */
  eatfresh_fridge_event: Array<Eatfresh_Fridge_Event>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_event" */
  eatfresh_fridge_event_aggregate: Eatfresh_Fridge_Event_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_event" using primary key columns */
  eatfresh_fridge_event_by_pk?: Maybe<Eatfresh_Fridge_Event>;
  /** fetch data from the table: "eatfresh.fridge_event_type" */
  eatfresh_fridge_event_type: Array<Eatfresh_Fridge_Event_Type>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_event_type" */
  eatfresh_fridge_event_type_aggregate: Eatfresh_Fridge_Event_Type_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_event_type" using primary key columns */
  eatfresh_fridge_event_type_by_pk?: Maybe<Eatfresh_Fridge_Event_Type>;
  /** fetch data from the table: "eatfresh.fridge_layout" */
  eatfresh_fridge_layout: Array<Eatfresh_Fridge_Layout>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout" */
  eatfresh_fridge_layout_aggregate: Eatfresh_Fridge_Layout_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment" */
  eatfresh_fridge_layout_assignment: Array<Eatfresh_Fridge_Layout_Assignment>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_assignment" */
  eatfresh_fridge_layout_assignment_aggregate: Eatfresh_Fridge_Layout_Assignment_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment" using primary key columns */
  eatfresh_fridge_layout_assignment_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment>;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment_status" */
  eatfresh_fridge_layout_assignment_status: Array<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_assignment_status" */
  eatfresh_fridge_layout_assignment_status_aggregate: Eatfresh_Fridge_Layout_Assignment_Status_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment_status" using primary key columns */
  eatfresh_fridge_layout_assignment_status_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** fetch data from the table: "eatfresh.fridge_layout" using primary key columns */
  eatfresh_fridge_layout_by_pk?: Maybe<Eatfresh_Fridge_Layout>;
  /** fetch data from the table: "eatfresh.fridge_layout_level" */
  eatfresh_fridge_layout_level: Array<Eatfresh_Fridge_Layout_Level>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_level" */
  eatfresh_fridge_layout_level_aggregate: Eatfresh_Fridge_Layout_Level_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_level" using primary key columns */
  eatfresh_fridge_layout_level_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level>;
  /** fetch data from the table: "eatfresh.fridge_layout_level_position" */
  eatfresh_fridge_layout_level_position: Array<Eatfresh_Fridge_Layout_Level_Position>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_level_position" */
  eatfresh_fridge_layout_level_position_aggregate: Eatfresh_Fridge_Layout_Level_Position_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_level_position" using primary key columns */
  eatfresh_fridge_layout_level_position_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level_Position>;
  /** fetch data from the table: "eatfresh.fridge_order" */
  eatfresh_fridge_order: Array<Eatfresh_Fridge_Order>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_order" */
  eatfresh_fridge_order_aggregate: Eatfresh_Fridge_Order_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_order" using primary key columns */
  eatfresh_fridge_order_by_pk?: Maybe<Eatfresh_Fridge_Order>;
  /** fetch data from the table: "eatfresh.fridge_status_history" */
  eatfresh_fridge_status_history: Array<Eatfresh_Fridge_Status_History>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_status_history" */
  eatfresh_fridge_status_history_aggregate: Eatfresh_Fridge_Status_History_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_status_history" using primary key columns */
  eatfresh_fridge_status_history_by_pk?: Maybe<Eatfresh_Fridge_Status_History>;
  /** fetch data from the table: "eatfresh.fridge_stock" */
  eatfresh_fridge_stock: Array<Eatfresh_Fridge_Stock>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_stock" */
  eatfresh_fridge_stock_aggregate: Eatfresh_Fridge_Stock_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_stock" using primary key columns */
  eatfresh_fridge_stock_by_pk?: Maybe<Eatfresh_Fridge_Stock>;
  /** fetch data from the table: "eatfresh.fridge_stocked_enabled_daily" */
  eatfresh_fridge_stocked_enabled_daily: Array<Eatfresh_Fridge_Stocked_Enabled_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_stocked_enabled_daily" */
  eatfresh_fridge_stocked_enabled_daily_aggregate: Eatfresh_Fridge_Stocked_Enabled_Daily_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_stocked_enabled_per_place_daily" */
  eatfresh_fridge_stocked_enabled_per_place_daily: Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_stocked_enabled_per_place_daily" */
  eatfresh_fridge_stocked_enabled_per_place_daily_aggregate: Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_target_stock" */
  eatfresh_fridge_target_stock: Array<Eatfresh_Fridge_Target_Stock>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_target_stock" */
  eatfresh_fridge_target_stock_aggregate: Eatfresh_Fridge_Target_Stock_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_target_stock" using primary key columns */
  eatfresh_fridge_target_stock_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock>;
  /** fetch data from the table: "eatfresh.fridge_target_stock_position" */
  eatfresh_fridge_target_stock_position: Array<Eatfresh_Fridge_Target_Stock_Position>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_target_stock_position" */
  eatfresh_fridge_target_stock_position_aggregate: Eatfresh_Fridge_Target_Stock_Position_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_target_stock_position" using primary key columns */
  eatfresh_fridge_target_stock_position_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock_Position>;
  /** fetch data from the table: "eatfresh.fridge_type" */
  eatfresh_fridge_type: Array<Eatfresh_Fridge_Type>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_type" */
  eatfresh_fridge_type_aggregate: Eatfresh_Fridge_Type_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_type" using primary key columns */
  eatfresh_fridge_type_by_pk?: Maybe<Eatfresh_Fridge_Type>;
  /** fetch data from the table: "eatfresh.logistics_problem" */
  eatfresh_logistics_problem: Array<Eatfresh_Logistics_Problem>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_problem" */
  eatfresh_logistics_problem_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_problem" using primary key columns */
  eatfresh_logistics_problem_by_pk?: Maybe<Eatfresh_Logistics_Problem>;
  /** fetch data from the table: "eatfresh.logistics_problem_image" */
  eatfresh_logistics_problem_image: Array<Eatfresh_Logistics_Problem_Image>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_problem_image" */
  eatfresh_logistics_problem_image_aggregate: Eatfresh_Logistics_Problem_Image_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_problem_image" using primary key columns */
  eatfresh_logistics_problem_image_by_pk?: Maybe<Eatfresh_Logistics_Problem_Image>;
  /** fetch data from the table: "eatfresh.logistics_problem_status" */
  eatfresh_logistics_problem_status: Array<Eatfresh_Logistics_Problem_Status>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_problem_status" */
  eatfresh_logistics_problem_status_aggregate: Eatfresh_Logistics_Problem_Status_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_problem_status" using primary key columns */
  eatfresh_logistics_problem_status_by_pk?: Maybe<Eatfresh_Logistics_Problem_Status>;
  /** fetch data from the table: "eatfresh.logistics_process_type" */
  eatfresh_logistics_process_type: Array<Eatfresh_Logistics_Process_Type>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_process_type" */
  eatfresh_logistics_process_type_aggregate: Eatfresh_Logistics_Process_Type_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_process_type" using primary key columns */
  eatfresh_logistics_process_type_by_pk?: Maybe<Eatfresh_Logistics_Process_Type>;
  /** fetch data from the table: "eatfresh.nutrition_information" */
  eatfresh_nutrition_information: Array<Eatfresh_Nutrition_Information>;
  /** fetch aggregated fields from the table: "eatfresh.nutrition_information" */
  eatfresh_nutrition_information_aggregate: Eatfresh_Nutrition_Information_Aggregate;
  /** fetch data from the table: "eatfresh.nutrition_information" using primary key columns */
  eatfresh_nutrition_information_by_pk?: Maybe<Eatfresh_Nutrition_Information>;
  /** fetch data from the table: "eatfresh.order_extra" */
  eatfresh_order_extra: Array<Eatfresh_Order_Extra>;
  /** fetch aggregated fields from the table: "eatfresh.order_extra" */
  eatfresh_order_extra_aggregate: Eatfresh_Order_Extra_Aggregate;
  /** fetch data from the table: "eatfresh.order_extra" using primary key columns */
  eatfresh_order_extra_by_pk?: Maybe<Eatfresh_Order_Extra>;
  /** fetch data from the table: "eatfresh.order_extra_customer_order" */
  eatfresh_order_extra_customer_order: Array<Eatfresh_Order_Extra_Customer_Order>;
  /** fetch aggregated fields from the table: "eatfresh.order_extra_customer_order" */
  eatfresh_order_extra_customer_order_aggregate: Eatfresh_Order_Extra_Customer_Order_Aggregate;
  /** fetch data from the table: "eatfresh.order_extra_customer_order" using primary key columns */
  eatfresh_order_extra_customer_order_by_pk?: Maybe<Eatfresh_Order_Extra_Customer_Order>;
  /** fetch data from the table: "eatfresh.order_position" */
  eatfresh_order_position: Array<Eatfresh_Order_Position>;
  /** fetch aggregated fields from the table: "eatfresh.order_position" */
  eatfresh_order_position_aggregate: Eatfresh_Order_Position_Aggregate;
  /** fetch data from the table: "eatfresh.order_position" using primary key columns */
  eatfresh_order_position_by_pk?: Maybe<Eatfresh_Order_Position>;
  /** fetch data from the table: "eatfresh.order_position_category" */
  eatfresh_order_position_category: Array<Eatfresh_Order_Position_Category>;
  /** fetch aggregated fields from the table: "eatfresh.order_position_category" */
  eatfresh_order_position_category_aggregate: Eatfresh_Order_Position_Category_Aggregate;
  /** fetch data from the table: "eatfresh.order_position_category" using primary key columns */
  eatfresh_order_position_category_by_pk?: Maybe<Eatfresh_Order_Position_Category>;
  /** fetch data from the table: "eatfresh.order_status" */
  eatfresh_order_status: Array<Eatfresh_Order_Status>;
  /** fetch aggregated fields from the table: "eatfresh.order_status" */
  eatfresh_order_status_aggregate: Eatfresh_Order_Status_Aggregate;
  /** fetch data from the table: "eatfresh.order_status" using primary key columns */
  eatfresh_order_status_by_pk?: Maybe<Eatfresh_Order_Status>;
  /** fetch data from the table: "eatfresh.packaging_type" */
  eatfresh_packaging_type: Array<Eatfresh_Packaging_Type>;
  /** fetch aggregated fields from the table: "eatfresh.packaging_type" */
  eatfresh_packaging_type_aggregate: Eatfresh_Packaging_Type_Aggregate;
  /** fetch data from the table: "eatfresh.packaging_type" using primary key columns */
  eatfresh_packaging_type_by_pk?: Maybe<Eatfresh_Packaging_Type>;
  /** fetch data from the table: "eatfresh.password_reset_token" */
  eatfresh_password_reset_token: Array<Eatfresh_Password_Reset_Token>;
  /** fetch aggregated fields from the table: "eatfresh.password_reset_token" */
  eatfresh_password_reset_token_aggregate: Eatfresh_Password_Reset_Token_Aggregate;
  /** fetch data from the table: "eatfresh.password_reset_token" using primary key columns */
  eatfresh_password_reset_token_by_pk?: Maybe<Eatfresh_Password_Reset_Token>;
  /** fetch data from the table: "eatfresh.payment_method" */
  eatfresh_payment_method: Array<Eatfresh_Payment_Method>;
  /** fetch aggregated fields from the table: "eatfresh.payment_method" */
  eatfresh_payment_method_aggregate: Eatfresh_Payment_Method_Aggregate;
  /** fetch data from the table: "eatfresh.payment_method" using primary key columns */
  eatfresh_payment_method_by_pk?: Maybe<Eatfresh_Payment_Method>;
  /** fetch data from the table: "eatfresh.payment_method_type" */
  eatfresh_payment_method_type: Array<Eatfresh_Payment_Method_Type>;
  /** fetch aggregated fields from the table: "eatfresh.payment_method_type" */
  eatfresh_payment_method_type_aggregate: Eatfresh_Payment_Method_Type_Aggregate;
  /** fetch data from the table: "eatfresh.payment_method_type" using primary key columns */
  eatfresh_payment_method_type_by_pk?: Maybe<Eatfresh_Payment_Method_Type>;
  /** fetch data from the table: "eatfresh.payment_status" */
  eatfresh_payment_status: Array<Eatfresh_Payment_Status>;
  /** fetch aggregated fields from the table: "eatfresh.payment_status" */
  eatfresh_payment_status_aggregate: Eatfresh_Payment_Status_Aggregate;
  /** fetch data from the table: "eatfresh.payment_status" using primary key columns */
  eatfresh_payment_status_by_pk?: Maybe<Eatfresh_Payment_Status>;
  /** fetch data from the table: "eatfresh.place" */
  eatfresh_place: Array<Eatfresh_Place>;
  /** fetch aggregated fields from the table: "eatfresh.place" */
  eatfresh_place_aggregate: Eatfresh_Place_Aggregate;
  /** fetch data from the table: "eatfresh.place" using primary key columns */
  eatfresh_place_by_pk?: Maybe<Eatfresh_Place>;
  /** fetch data from the table: "eatfresh.price_change" */
  eatfresh_price_change: Array<Eatfresh_Price_Change>;
  /** fetch aggregated fields from the table: "eatfresh.price_change" */
  eatfresh_price_change_aggregate: Eatfresh_Price_Change_Aggregate;
  /** fetch data from the table: "eatfresh.price_change" using primary key columns */
  eatfresh_price_change_by_pk?: Maybe<Eatfresh_Price_Change>;
  /** fetch data from the table: "eatfresh.price_change_position" */
  eatfresh_price_change_position: Array<Eatfresh_Price_Change_Position>;
  /** fetch aggregated fields from the table: "eatfresh.price_change_position" */
  eatfresh_price_change_position_aggregate: Eatfresh_Price_Change_Position_Aggregate;
  /** fetch data from the table: "eatfresh.price_change_position" using primary key columns */
  eatfresh_price_change_position_by_pk?: Maybe<Eatfresh_Price_Change_Position>;
  /** fetch data from the table: "eatfresh.price_change_position_status" */
  eatfresh_price_change_position_status: Array<Eatfresh_Price_Change_Position_Status>;
  /** fetch aggregated fields from the table: "eatfresh.price_change_position_status" */
  eatfresh_price_change_position_status_aggregate: Eatfresh_Price_Change_Position_Status_Aggregate;
  /** fetch data from the table: "eatfresh.price_change_position_status" using primary key columns */
  eatfresh_price_change_position_status_by_pk?: Maybe<Eatfresh_Price_Change_Position_Status>;
  /** fetch data from the table: "eatfresh.price_lock" */
  eatfresh_price_lock: Array<Eatfresh_Price_Lock>;
  /** fetch aggregated fields from the table: "eatfresh.price_lock" */
  eatfresh_price_lock_aggregate: Eatfresh_Price_Lock_Aggregate;
  /** fetch data from the table: "eatfresh.price_lock" using primary key columns */
  eatfresh_price_lock_by_pk?: Maybe<Eatfresh_Price_Lock>;
  /** fetch data from the table: "eatfresh.product_orientation" */
  eatfresh_product_orientation: Array<Eatfresh_Product_Orientation>;
  /** fetch aggregated fields from the table: "eatfresh.product_orientation" */
  eatfresh_product_orientation_aggregate: Eatfresh_Product_Orientation_Aggregate;
  /** fetch data from the table: "eatfresh.product_orientation" using primary key columns */
  eatfresh_product_orientation_by_pk?: Maybe<Eatfresh_Product_Orientation>;
  /** fetch data from the table: "eatfresh.refill" */
  eatfresh_refill: Array<Eatfresh_Refill>;
  /** fetch aggregated fields from the table: "eatfresh.refill" */
  eatfresh_refill_aggregate: Eatfresh_Refill_Aggregate;
  /** fetch data from the table: "eatfresh.refill" using primary key columns */
  eatfresh_refill_by_pk?: Maybe<Eatfresh_Refill>;
  /** fetch data from the table: "eatfresh.refill_status" */
  eatfresh_refill_status: Array<Eatfresh_Refill_Status>;
  /** fetch aggregated fields from the table: "eatfresh.refill_status" */
  eatfresh_refill_status_aggregate: Eatfresh_Refill_Status_Aggregate;
  /** fetch data from the table: "eatfresh.refill_status" using primary key columns */
  eatfresh_refill_status_by_pk?: Maybe<Eatfresh_Refill_Status>;
  /** fetch data from the table: "eatfresh.rfid_asset" */
  eatfresh_rfid_asset: Array<Eatfresh_Rfid_Asset>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_asset" */
  eatfresh_rfid_asset_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_asset" using primary key columns */
  eatfresh_rfid_asset_by_pk?: Maybe<Eatfresh_Rfid_Asset>;
  /** fetch data from the table: "eatfresh.rfid_asset_type" */
  eatfresh_rfid_asset_type: Array<Eatfresh_Rfid_Asset_Type>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_asset_type" */
  eatfresh_rfid_asset_type_aggregate: Eatfresh_Rfid_Asset_Type_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_asset_type" using primary key columns */
  eatfresh_rfid_asset_type_by_pk?: Maybe<Eatfresh_Rfid_Asset_Type>;
  /** fetch data from the table: "eatfresh.rfid_box" */
  eatfresh_rfid_box: Array<Eatfresh_Rfid_Box>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_box" */
  eatfresh_rfid_box_aggregate: Eatfresh_Rfid_Box_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_box" using primary key columns */
  eatfresh_rfid_box_by_pk?: Maybe<Eatfresh_Rfid_Box>;
  /** fetch data from the table: "eatfresh.rfid_box_type" */
  eatfresh_rfid_box_type: Array<Eatfresh_Rfid_Box_Type>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_box_type" */
  eatfresh_rfid_box_type_aggregate: Eatfresh_Rfid_Box_Type_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_box_type" using primary key columns */
  eatfresh_rfid_box_type_by_pk?: Maybe<Eatfresh_Rfid_Box_Type>;
  /** fetch data from the table: "eatfresh.rfid_scan" */
  eatfresh_rfid_scan: Array<Eatfresh_Rfid_Scan>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scan" */
  eatfresh_rfid_scan_aggregate: Eatfresh_Rfid_Scan_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scan" using primary key columns */
  eatfresh_rfid_scan_by_pk?: Maybe<Eatfresh_Rfid_Scan>;
  /** fetch data from the table: "eatfresh.rfid_scan_status" */
  eatfresh_rfid_scan_status: Array<Eatfresh_Rfid_Scan_Status>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scan_status" */
  eatfresh_rfid_scan_status_aggregate: Eatfresh_Rfid_Scan_Status_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scan_status" using primary key columns */
  eatfresh_rfid_scan_status_by_pk?: Maybe<Eatfresh_Rfid_Scan_Status>;
  /** fetch data from the table: "eatfresh.rfid_scanner" */
  eatfresh_rfid_scanner: Array<Eatfresh_Rfid_Scanner>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scanner" */
  eatfresh_rfid_scanner_aggregate: Eatfresh_Rfid_Scanner_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scanner" using primary key columns */
  eatfresh_rfid_scanner_by_pk?: Maybe<Eatfresh_Rfid_Scanner>;
  /** fetch data from the table: "eatfresh.rfid_scanner_type" */
  eatfresh_rfid_scanner_type: Array<Eatfresh_Rfid_Scanner_Type>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scanner_type" */
  eatfresh_rfid_scanner_type_aggregate: Eatfresh_Rfid_Scanner_Type_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scanner_type" using primary key columns */
  eatfresh_rfid_scanner_type_by_pk?: Maybe<Eatfresh_Rfid_Scanner_Type>;
  /** fetch data from the table: "eatfresh.rfid_status" */
  eatfresh_rfid_status: Array<Eatfresh_Rfid_Status>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_status" */
  eatfresh_rfid_status_aggregate: Eatfresh_Rfid_Status_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_status" using primary key columns */
  eatfresh_rfid_status_by_pk?: Maybe<Eatfresh_Rfid_Status>;
  /** fetch data from the table: "eatfresh.rfid_tag" */
  eatfresh_rfid_tag: Array<Eatfresh_Rfid_Tag>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_tag" */
  eatfresh_rfid_tag_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_tag" using primary key columns */
  eatfresh_rfid_tag_by_pk?: Maybe<Eatfresh_Rfid_Tag>;
  /** fetch data from the table: "eatfresh.rfid_tag_sales_daily" */
  eatfresh_rfid_tag_sales_daily: Array<Eatfresh_Rfid_Tag_Sales_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_tag_sales_daily" */
  eatfresh_rfid_tag_sales_daily_aggregate: Eatfresh_Rfid_Tag_Sales_Daily_Aggregate;
  /** fetch data from the table: "eatfresh.selfly_cabinet_state" */
  eatfresh_selfly_cabinet_state: Array<Eatfresh_Selfly_Cabinet_State>;
  /** fetch aggregated fields from the table: "eatfresh.selfly_cabinet_state" */
  eatfresh_selfly_cabinet_state_aggregate: Eatfresh_Selfly_Cabinet_State_Aggregate;
  /** fetch data from the table: "eatfresh.selfly_cabinet_state" using primary key columns */
  eatfresh_selfly_cabinet_state_by_pk?: Maybe<Eatfresh_Selfly_Cabinet_State>;
  /** fetch data from the table: "eatfresh.session_step" */
  eatfresh_session_step: Array<Eatfresh_Session_Step>;
  /** fetch aggregated fields from the table: "eatfresh.session_step" */
  eatfresh_session_step_aggregate: Eatfresh_Session_Step_Aggregate;
  /** fetch data from the table: "eatfresh.session_step" using primary key columns */
  eatfresh_session_step_by_pk?: Maybe<Eatfresh_Session_Step>;
  /** fetch data from the table: "eatfresh.shelf_type" */
  eatfresh_shelf_type: Array<Eatfresh_Shelf_Type>;
  /** fetch aggregated fields from the table: "eatfresh.shelf_type" */
  eatfresh_shelf_type_aggregate: Eatfresh_Shelf_Type_Aggregate;
  /** fetch data from the table: "eatfresh.shelf_type" using primary key columns */
  eatfresh_shelf_type_by_pk?: Maybe<Eatfresh_Shelf_Type>;
  /** fetch data from the table: "eatfresh.sold_item_cost" */
  eatfresh_sold_item_cost: Array<Eatfresh_Sold_Item_Cost>;
  /** fetch aggregated fields from the table: "eatfresh.sold_item_cost" */
  eatfresh_sold_item_cost_aggregate: Eatfresh_Sold_Item_Cost_Aggregate;
  /** fetch data from the table: "eatfresh.supplier_problem" */
  eatfresh_supplier_problem: Array<Eatfresh_Supplier_Problem>;
  /** fetch aggregated fields from the table: "eatfresh.supplier_problem" */
  eatfresh_supplier_problem_aggregate: Eatfresh_Supplier_Problem_Aggregate;
  /** fetch data from the table: "eatfresh.supplier_problem" using primary key columns */
  eatfresh_supplier_problem_by_pk?: Maybe<Eatfresh_Supplier_Problem>;
  /** fetch data from the table: "eatfresh.supplier_problem_to_file" */
  eatfresh_supplier_problem_to_file: Array<Eatfresh_Supplier_Problem_To_File>;
  /** fetch aggregated fields from the table: "eatfresh.supplier_problem_to_file" */
  eatfresh_supplier_problem_to_file_aggregate: Eatfresh_Supplier_Problem_To_File_Aggregate;
  /** fetch data from the table: "eatfresh.supplier_problem_to_file" using primary key columns */
  eatfresh_supplier_problem_to_file_by_pk?: Maybe<Eatfresh_Supplier_Problem_To_File>;
  /** fetch data from the table: "eatfresh.transaction_logs" */
  eatfresh_transaction_logs: Array<Eatfresh_Transaction_Logs>;
  /** fetch aggregated fields from the table: "eatfresh.transaction_logs" */
  eatfresh_transaction_logs_aggregate: Eatfresh_Transaction_Logs_Aggregate;
  /** fetch data from the table: "eatfresh.transaction_logs" using primary key columns */
  eatfresh_transaction_logs_by_pk?: Maybe<Eatfresh_Transaction_Logs>;
  /** fetch data from the table: "eatfresh.uploaded_file" */
  eatfresh_uploaded_file: Array<Eatfresh_Uploaded_File>;
  /** fetch aggregated fields from the table: "eatfresh.uploaded_file" */
  eatfresh_uploaded_file_aggregate: Eatfresh_Uploaded_File_Aggregate;
  /** fetch data from the table: "eatfresh.uploaded_file" using primary key columns */
  eatfresh_uploaded_file_by_pk?: Maybe<Eatfresh_Uploaded_File>;
  /** fetch data from the table: "eatfresh.user_account" */
  eatfresh_user_account: Array<Eatfresh_User_Account>;
  /** fetch aggregated fields from the table: "eatfresh.user_account" */
  eatfresh_user_account_aggregate: Eatfresh_User_Account_Aggregate;
  /** fetch data from the table: "eatfresh.user_account" using primary key columns */
  eatfresh_user_account_by_pk?: Maybe<Eatfresh_User_Account>;
  /** fetch data from the table: "eatfresh.vat_category" */
  eatfresh_vat_category: Array<Eatfresh_Vat_Category>;
  /** fetch aggregated fields from the table: "eatfresh.vat_category" */
  eatfresh_vat_category_aggregate: Eatfresh_Vat_Category_Aggregate;
  /** fetch data from the table: "eatfresh.vat_category" using primary key columns */
  eatfresh_vat_category_by_pk?: Maybe<Eatfresh_Vat_Category>;
  /** fetch data from the table: "eatfresh.vitamin_mineral" */
  eatfresh_vitamin_mineral: Array<Eatfresh_Vitamin_Mineral>;
  /** fetch aggregated fields from the table: "eatfresh.vitamin_mineral" */
  eatfresh_vitamin_mineral_aggregate: Eatfresh_Vitamin_Mineral_Aggregate;
  /** fetch data from the table: "eatfresh.vitamin_mineral" using primary key columns */
  eatfresh_vitamin_mineral_by_pk?: Maybe<Eatfresh_Vitamin_Mineral>;
  /** fetch data from the table: "eatfresh.warehouse" */
  eatfresh_warehouse: Array<Eatfresh_Warehouse>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse" */
  eatfresh_warehouse_aggregate: Eatfresh_Warehouse_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_assignment" */
  eatfresh_warehouse_assignment: Array<Eatfresh_Warehouse_Assignment>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_assignment" */
  eatfresh_warehouse_assignment_aggregate: Eatfresh_Warehouse_Assignment_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_assignment" using primary key columns */
  eatfresh_warehouse_assignment_by_pk?: Maybe<Eatfresh_Warehouse_Assignment>;
  /** fetch data from the table: "eatfresh.warehouse" using primary key columns */
  eatfresh_warehouse_by_pk?: Maybe<Eatfresh_Warehouse>;
  /** fetch data from the table: "eatfresh.warehouse_order" */
  eatfresh_warehouse_order: Array<Eatfresh_Warehouse_Order>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order" */
  eatfresh_warehouse_order_aggregate: Eatfresh_Warehouse_Order_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order" using primary key columns */
  eatfresh_warehouse_order_by_pk?: Maybe<Eatfresh_Warehouse_Order>;
  /** fetch data from the table: "eatfresh.warehouse_order_position" */
  eatfresh_warehouse_order_position: Array<Eatfresh_Warehouse_Order_Position>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_position" */
  eatfresh_warehouse_order_position_aggregate: Eatfresh_Warehouse_Order_Position_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_position" using primary key columns */
  eatfresh_warehouse_order_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Position>;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt" */
  eatfresh_warehouse_order_receipt: Array<Eatfresh_Warehouse_Order_Receipt>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_receipt" */
  eatfresh_warehouse_order_receipt_aggregate: Eatfresh_Warehouse_Order_Receipt_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt" using primary key columns */
  eatfresh_warehouse_order_receipt_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt>;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt_position" */
  eatfresh_warehouse_order_receipt_position: Array<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_receipt_position" */
  eatfresh_warehouse_order_receipt_position_aggregate: Eatfresh_Warehouse_Order_Receipt_Position_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt_position" using primary key columns */
  eatfresh_warehouse_order_receipt_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** fetch data from the table: "eatfresh.warehouse_order_status" */
  eatfresh_warehouse_order_status: Array<Eatfresh_Warehouse_Order_Status>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_status" */
  eatfresh_warehouse_order_status_aggregate: Eatfresh_Warehouse_Order_Status_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_status" using primary key columns */
  eatfresh_warehouse_order_status_by_pk?: Maybe<Eatfresh_Warehouse_Order_Status>;
  /** fetch data from the table: "eatfresh.warehouse_order_type" */
  eatfresh_warehouse_order_type: Array<Eatfresh_Warehouse_Order_Type>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_type" */
  eatfresh_warehouse_order_type_aggregate: Eatfresh_Warehouse_Order_Type_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_type" using primary key columns */
  eatfresh_warehouse_order_type_by_pk?: Maybe<Eatfresh_Warehouse_Order_Type>;
  /** fetch data from the table: "eatfresh.warehouse_shelf" */
  eatfresh_warehouse_shelf: Array<Eatfresh_Warehouse_Shelf>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_shelf" */
  eatfresh_warehouse_shelf_aggregate: Eatfresh_Warehouse_Shelf_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_shelf" using primary key columns */
  eatfresh_warehouse_shelf_by_pk?: Maybe<Eatfresh_Warehouse_Shelf>;
};


export type Query_RootEatfresh_Age_VerificationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


export type Query_RootEatfresh_Age_Verification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


export type Query_RootEatfresh_Age_Verification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Age_Verification_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Age_Verification_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Age_Verification_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Age_Verification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Age_Verification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Age_Verification_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};


export type Query_RootEatfresh_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};


export type Query_RootEatfresh_Article_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Article_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


export type Query_RootEatfresh_Article_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


export type Query_RootEatfresh_Article_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Article_Labeling_ProcessArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


export type Query_RootEatfresh_Article_Labeling_Process_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


export type Query_RootEatfresh_Article_Labeling_Process_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Article_Labeling_Process_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Article_Labeling_Process_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Article_Labeling_Process_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Asset_PlacementArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Placement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Placement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Asset_TransferArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Asset_Transfer_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Asset_Transfer_Problem_SeverityArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_Problem_Severity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_Problem_Severity_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Asset_Transfer_Problem_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_Problem_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Asset_Transfer_Problem_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Auth_TokenArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Auth_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Auth_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Auth_Token_Bool_Exp>;
};


export type Query_RootEatfresh_Auth_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Auth_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Auth_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Auth_Token_Bool_Exp>;
};


export type Query_RootEatfresh_Auth_Token_By_PkArgs = {
  key: Scalars['String']['input'];
};


export type Query_RootEatfresh_AuthenticatorsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Authenticators_Order_By>>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};


export type Query_RootEatfresh_Authenticators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Authenticators_Order_By>>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};


export type Query_RootEatfresh_Authenticators_By_PkArgs = {
  credentialid: Scalars['String']['input'];
};


export type Query_RootEatfresh_B2b_CustomerArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
};


export type Query_RootEatfresh_B2b_Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
};


export type Query_RootEatfresh_B2b_Customer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_B2b_Customer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Type_Bool_Exp>;
};


export type Query_RootEatfresh_B2b_Customer_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Type_Bool_Exp>;
};


export type Query_RootEatfresh_B2b_Customer_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Basic_User_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Basic_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Basic_User_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Basic_User_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Basic_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Basic_User_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Basic_User_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Box_Content_PlanArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


export type Query_RootEatfresh_Box_Content_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


export type Query_RootEatfresh_Box_Content_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Box_Content_Plan_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Box_Content_Plan_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Box_Content_Plan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Box_Content_To_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


export type Query_RootEatfresh_Box_Content_To_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


export type Query_RootEatfresh_Box_Content_To_Article_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Commissioning_ProcessArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


export type Query_RootEatfresh_Commissioning_Process_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


export type Query_RootEatfresh_Commissioning_Process_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Commissioning_Process_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Commissioning_Process_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Commissioning_Process_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Commissioning_Process_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Commissioning_Process_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Commissioning_Process_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Computop_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Computop_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Computop_Transaction_Order_By>>;
  where?: InputMaybe<Eatfresh_Computop_Transaction_Bool_Exp>;
};


export type Query_RootEatfresh_Computop_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Computop_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Computop_Transaction_Order_By>>;
  where?: InputMaybe<Eatfresh_Computop_Transaction_Bool_Exp>;
};


export type Query_RootEatfresh_Computop_Transaction_By_PkArgs = {
  trans_id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Connection_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Connection_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Connection_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Connection_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Connection_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Connection_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Connection_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Cost_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
};


export type Query_RootEatfresh_Cost_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
};


export type Query_RootEatfresh_Cost_Configuration_KeyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
};


export type Query_RootEatfresh_Cost_Configuration_Key_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
};


export type Query_RootEatfresh_Cost_Configuration_Key_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_CustomerArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
};


export type Query_RootEatfresh_Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
};


export type Query_RootEatfresh_Customer_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Customer_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Customer_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Customer_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Door_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Door_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Door_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Door_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Door_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Door_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Door_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Easy_Refill_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


export type Query_RootEatfresh_Easy_Refill_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


export type Query_RootEatfresh_Easy_Refill_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_External_Warehouse_Pallet_SpotArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


export type Query_RootEatfresh_External_Warehouse_Pallet_Spot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


export type Query_RootEatfresh_External_Warehouse_Pallet_Spot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Flyway_Schema_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Flyway_Schema_History_Bool_Exp>;
};


export type Query_RootEatfresh_Flyway_Schema_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Flyway_Schema_History_Bool_Exp>;
};


export type Query_RootEatfresh_Flyway_Schema_History_By_PkArgs = {
  installed_rank: Scalars['Int']['input'];
};


export type Query_RootEatfresh_FridgeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Active_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Active_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Active_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Active_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_AlarmArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Alarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Alarm_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Article_StockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Article_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Article_Stock_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Article_Stock_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Article_Stock_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Article_Stock_Snapshot_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Article_Stock_Snapshot_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Article_Stock_Snapshot_Enabled_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_EventArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Event_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Fridge_LayoutArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Layout_Assignment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Assignment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Fridge_Layout_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Layout_LevelArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Level_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Layout_Level_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Level_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Layout_Level_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Status_History_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Status_History_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Status_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_StockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Stock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Stocked_Enabled_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Stocked_Enabled_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Stocked_Enabled_Per_Place_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Target_StockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Target_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Target_Stock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_Target_Stock_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Target_Stock_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Target_Stock_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Fridge_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Fridge_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Logistics_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Logistics_Problem_ImageArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Problem_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Problem_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Logistics_Problem_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Problem_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Problem_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Logistics_Process_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Process_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Logistics_Process_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Nutrition_InformationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Nutrition_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Nutrition_Information_Order_By>>;
  where?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
};


export type Query_RootEatfresh_Nutrition_Information_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Nutrition_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Nutrition_Information_Order_By>>;
  where?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
};


export type Query_RootEatfresh_Nutrition_Information_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Order_ExtraArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Extra_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Extra_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Order_Extra_Customer_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Extra_Customer_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Extra_Customer_Order_By_PkArgs = {
  customer_order_id: Scalars['uuid']['input'];
  order_extra_id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Order_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Order_Position_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Position_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Position_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Order_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Order_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Packaging_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Packaging_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Packaging_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Packaging_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Packaging_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Packaging_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Packaging_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Password_Reset_TokenArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


export type Query_RootEatfresh_Password_Reset_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


export type Query_RootEatfresh_Password_Reset_Token_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Payment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


export type Query_RootEatfresh_Payment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


export type Query_RootEatfresh_Payment_Method_By_PkArgs = {
  trans_id: Scalars['String']['input'];
};


export type Query_RootEatfresh_Payment_Method_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Payment_Method_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Payment_Method_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Payment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_PlaceArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Place_Order_By>>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};


export type Query_RootEatfresh_Place_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Place_Order_By>>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};


export type Query_RootEatfresh_Place_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Price_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Change_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Change_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Price_Change_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Change_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Change_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Price_Change_Position_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Change_Position_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Change_Position_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Price_LockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Lock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


export type Query_RootEatfresh_Price_Lock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Product_OrientationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Product_Orientation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Product_Orientation_Order_By>>;
  where?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
};


export type Query_RootEatfresh_Product_Orientation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Product_Orientation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Product_Orientation_Order_By>>;
  where?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
};


export type Query_RootEatfresh_Product_Orientation_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_RefillArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


export type Query_RootEatfresh_Refill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


export type Query_RootEatfresh_Refill_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Refill_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Refill_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Refill_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Rfid_AssetArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Rfid_Asset_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Asset_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Asset_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Rfid_BoxArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Box_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Box_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Rfid_Box_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Box_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Box_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Rfid_ScanArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Rfid_Scan_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scan_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Rfid_ScannerArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scanner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scanner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Rfid_Scanner_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scanner_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Scanner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Rfid_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Rfid_TagArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Rfid_Tag_Sales_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Rfid_Tag_Sales_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>;
};


export type Query_RootEatfresh_Selfly_Cabinet_StateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Order_By>>;
  where?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
};


export type Query_RootEatfresh_Selfly_Cabinet_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Order_By>>;
  where?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
};


export type Query_RootEatfresh_Selfly_Cabinet_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Session_StepArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Session_Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Session_Step_Order_By>>;
  where?: InputMaybe<Eatfresh_Session_Step_Bool_Exp>;
};


export type Query_RootEatfresh_Session_Step_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Session_Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Session_Step_Order_By>>;
  where?: InputMaybe<Eatfresh_Session_Step_Bool_Exp>;
};


export type Query_RootEatfresh_Session_Step_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Shelf_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Shelf_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Shelf_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Shelf_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Shelf_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Shelf_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Shelf_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Sold_Item_CostArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Order_By>>;
  where?: InputMaybe<Eatfresh_Sold_Item_Cost_Bool_Exp>;
};


export type Query_RootEatfresh_Sold_Item_Cost_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Order_By>>;
  where?: InputMaybe<Eatfresh_Sold_Item_Cost_Bool_Exp>;
};


export type Query_RootEatfresh_Supplier_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};


export type Query_RootEatfresh_Supplier_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};


export type Query_RootEatfresh_Supplier_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Supplier_Problem_To_FileArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};


export type Query_RootEatfresh_Supplier_Problem_To_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};


export type Query_RootEatfresh_Supplier_Problem_To_File_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};


export type Query_RootEatfresh_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};


export type Query_RootEatfresh_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Uploaded_FileArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Uploaded_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};


export type Query_RootEatfresh_Uploaded_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Uploaded_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};


export type Query_RootEatfresh_Uploaded_File_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_User_AccountArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};


export type Query_RootEatfresh_User_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};


export type Query_RootEatfresh_User_Account_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Vat_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vat_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vat_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
};


export type Query_RootEatfresh_Vat_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vat_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vat_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
};


export type Query_RootEatfresh_Vat_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Vitamin_MineralArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Order_By>>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};


export type Query_RootEatfresh_Vitamin_Mineral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Order_By>>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};


export type Query_RootEatfresh_Vitamin_Mineral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_WarehouseArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Warehouse_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Warehouse_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Warehouse_Order_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Warehouse_Order_ReceiptArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Receipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Receipt_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Warehouse_Order_Receipt_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Receipt_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Receipt_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEatfresh_Warehouse_Order_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Warehouse_Order_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Type_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Order_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEatfresh_Warehouse_ShelfArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Shelf_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};


export type Query_RootEatfresh_Warehouse_Shelf_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "eatfresh.age_verification" */
  eatfresh_age_verification: Array<Eatfresh_Age_Verification>;
  /** fetch aggregated fields from the table: "eatfresh.age_verification" */
  eatfresh_age_verification_aggregate: Eatfresh_Age_Verification_Aggregate;
  /** fetch data from the table: "eatfresh.age_verification" using primary key columns */
  eatfresh_age_verification_by_pk?: Maybe<Eatfresh_Age_Verification>;
  /** fetch data from the table: "eatfresh.age_verification_status" */
  eatfresh_age_verification_status: Array<Eatfresh_Age_Verification_Status>;
  /** fetch aggregated fields from the table: "eatfresh.age_verification_status" */
  eatfresh_age_verification_status_aggregate: Eatfresh_Age_Verification_Status_Aggregate;
  /** fetch data from the table: "eatfresh.age_verification_status" using primary key columns */
  eatfresh_age_verification_status_by_pk?: Maybe<Eatfresh_Age_Verification_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.age_verification_status" */
  eatfresh_age_verification_status_stream: Array<Eatfresh_Age_Verification_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.age_verification" */
  eatfresh_age_verification_stream: Array<Eatfresh_Age_Verification>;
  /** fetch data from the table: "eatfresh.age_verification_type" */
  eatfresh_age_verification_type: Array<Eatfresh_Age_Verification_Type>;
  /** fetch aggregated fields from the table: "eatfresh.age_verification_type" */
  eatfresh_age_verification_type_aggregate: Eatfresh_Age_Verification_Type_Aggregate;
  /** fetch data from the table: "eatfresh.age_verification_type" using primary key columns */
  eatfresh_age_verification_type_by_pk?: Maybe<Eatfresh_Age_Verification_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.age_verification_type" */
  eatfresh_age_verification_type_stream: Array<Eatfresh_Age_Verification_Type>;
  /** fetch data from the table: "eatfresh.article" */
  eatfresh_article: Array<Eatfresh_Article>;
  /** fetch aggregated fields from the table: "eatfresh.article" */
  eatfresh_article_aggregate: Eatfresh_Article_Aggregate;
  /** fetch data from the table: "eatfresh.article" using primary key columns */
  eatfresh_article_by_pk?: Maybe<Eatfresh_Article>;
  /** fetch data from the table: "eatfresh.article_details" */
  eatfresh_article_details: Array<Eatfresh_Article_Details>;
  /** fetch aggregated fields from the table: "eatfresh.article_details" */
  eatfresh_article_details_aggregate: Eatfresh_Article_Details_Aggregate;
  /** fetch data from the table: "eatfresh.article_details" using primary key columns */
  eatfresh_article_details_by_pk?: Maybe<Eatfresh_Article_Details>;
  /** fetch data from the table in a streaming manner: "eatfresh.article_details" */
  eatfresh_article_details_stream: Array<Eatfresh_Article_Details>;
  /** fetch data from the table: "eatfresh.article_labeling_process" */
  eatfresh_article_labeling_process: Array<Eatfresh_Article_Labeling_Process>;
  /** fetch aggregated fields from the table: "eatfresh.article_labeling_process" */
  eatfresh_article_labeling_process_aggregate: Eatfresh_Article_Labeling_Process_Aggregate;
  /** fetch data from the table: "eatfresh.article_labeling_process" using primary key columns */
  eatfresh_article_labeling_process_by_pk?: Maybe<Eatfresh_Article_Labeling_Process>;
  /** fetch data from the table: "eatfresh.article_labeling_process_status" */
  eatfresh_article_labeling_process_status: Array<Eatfresh_Article_Labeling_Process_Status>;
  /** fetch aggregated fields from the table: "eatfresh.article_labeling_process_status" */
  eatfresh_article_labeling_process_status_aggregate: Eatfresh_Article_Labeling_Process_Status_Aggregate;
  /** fetch data from the table: "eatfresh.article_labeling_process_status" using primary key columns */
  eatfresh_article_labeling_process_status_by_pk?: Maybe<Eatfresh_Article_Labeling_Process_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.article_labeling_process_status" */
  eatfresh_article_labeling_process_status_stream: Array<Eatfresh_Article_Labeling_Process_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.article_labeling_process" */
  eatfresh_article_labeling_process_stream: Array<Eatfresh_Article_Labeling_Process>;
  /** fetch data from the table in a streaming manner: "eatfresh.article" */
  eatfresh_article_stream: Array<Eatfresh_Article>;
  /** fetch data from the table: "eatfresh.asset_placement" */
  eatfresh_asset_placement: Array<Eatfresh_Asset_Placement>;
  /** fetch aggregated fields from the table: "eatfresh.asset_placement" */
  eatfresh_asset_placement_aggregate: Eatfresh_Asset_Placement_Aggregate;
  /** fetch data from the table: "eatfresh.asset_placement" using primary key columns */
  eatfresh_asset_placement_by_pk?: Maybe<Eatfresh_Asset_Placement>;
  /** fetch data from the table in a streaming manner: "eatfresh.asset_placement" */
  eatfresh_asset_placement_stream: Array<Eatfresh_Asset_Placement>;
  /** fetch data from the table: "eatfresh.asset_transfer" */
  eatfresh_asset_transfer: Array<Eatfresh_Asset_Transfer>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer" */
  eatfresh_asset_transfer_aggregate: Eatfresh_Asset_Transfer_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer" using primary key columns */
  eatfresh_asset_transfer_by_pk?: Maybe<Eatfresh_Asset_Transfer>;
  /** fetch data from the table: "eatfresh.asset_transfer_problem" */
  eatfresh_asset_transfer_problem: Array<Eatfresh_Asset_Transfer_Problem>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer_problem" */
  eatfresh_asset_transfer_problem_aggregate: Eatfresh_Asset_Transfer_Problem_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer_problem" using primary key columns */
  eatfresh_asset_transfer_problem_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem>;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_severity" */
  eatfresh_asset_transfer_problem_severity: Array<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer_problem_severity" */
  eatfresh_asset_transfer_problem_severity_aggregate: Eatfresh_Asset_Transfer_Problem_Severity_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_severity" using primary key columns */
  eatfresh_asset_transfer_problem_severity_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** fetch data from the table in a streaming manner: "eatfresh.asset_transfer_problem_severity" */
  eatfresh_asset_transfer_problem_severity_stream: Array<Eatfresh_Asset_Transfer_Problem_Severity>;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_status" */
  eatfresh_asset_transfer_problem_status: Array<Eatfresh_Asset_Transfer_Problem_Status>;
  /** fetch aggregated fields from the table: "eatfresh.asset_transfer_problem_status" */
  eatfresh_asset_transfer_problem_status_aggregate: Eatfresh_Asset_Transfer_Problem_Status_Aggregate;
  /** fetch data from the table: "eatfresh.asset_transfer_problem_status" using primary key columns */
  eatfresh_asset_transfer_problem_status_by_pk?: Maybe<Eatfresh_Asset_Transfer_Problem_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.asset_transfer_problem_status" */
  eatfresh_asset_transfer_problem_status_stream: Array<Eatfresh_Asset_Transfer_Problem_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.asset_transfer_problem" */
  eatfresh_asset_transfer_problem_stream: Array<Eatfresh_Asset_Transfer_Problem>;
  /** fetch data from the table in a streaming manner: "eatfresh.asset_transfer" */
  eatfresh_asset_transfer_stream: Array<Eatfresh_Asset_Transfer>;
  /** fetch data from the table: "eatfresh.auth_token" */
  eatfresh_auth_token: Array<Eatfresh_Auth_Token>;
  /** fetch aggregated fields from the table: "eatfresh.auth_token" */
  eatfresh_auth_token_aggregate: Eatfresh_Auth_Token_Aggregate;
  /** fetch data from the table: "eatfresh.auth_token" using primary key columns */
  eatfresh_auth_token_by_pk?: Maybe<Eatfresh_Auth_Token>;
  /** fetch data from the table in a streaming manner: "eatfresh.auth_token" */
  eatfresh_auth_token_stream: Array<Eatfresh_Auth_Token>;
  /** fetch data from the table: "eatfresh.authenticators" */
  eatfresh_authenticators: Array<Eatfresh_Authenticators>;
  /** fetch aggregated fields from the table: "eatfresh.authenticators" */
  eatfresh_authenticators_aggregate: Eatfresh_Authenticators_Aggregate;
  /** fetch data from the table: "eatfresh.authenticators" using primary key columns */
  eatfresh_authenticators_by_pk?: Maybe<Eatfresh_Authenticators>;
  /** fetch data from the table in a streaming manner: "eatfresh.authenticators" */
  eatfresh_authenticators_stream: Array<Eatfresh_Authenticators>;
  /** fetch data from the table: "eatfresh.b2b_customer" */
  eatfresh_b2b_customer: Array<Eatfresh_B2b_Customer>;
  /** fetch aggregated fields from the table: "eatfresh.b2b_customer" */
  eatfresh_b2b_customer_aggregate: Eatfresh_B2b_Customer_Aggregate;
  /** fetch data from the table: "eatfresh.b2b_customer" using primary key columns */
  eatfresh_b2b_customer_by_pk?: Maybe<Eatfresh_B2b_Customer>;
  /** fetch data from the table in a streaming manner: "eatfresh.b2b_customer" */
  eatfresh_b2b_customer_stream: Array<Eatfresh_B2b_Customer>;
  /** fetch data from the table: "eatfresh.b2b_customer_type" */
  eatfresh_b2b_customer_type: Array<Eatfresh_B2b_Customer_Type>;
  /** fetch aggregated fields from the table: "eatfresh.b2b_customer_type" */
  eatfresh_b2b_customer_type_aggregate: Eatfresh_B2b_Customer_Type_Aggregate;
  /** fetch data from the table: "eatfresh.b2b_customer_type" using primary key columns */
  eatfresh_b2b_customer_type_by_pk?: Maybe<Eatfresh_B2b_Customer_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.b2b_customer_type" */
  eatfresh_b2b_customer_type_stream: Array<Eatfresh_B2b_Customer_Type>;
  /** fetch data from the table: "eatfresh.basic_user_type" */
  eatfresh_basic_user_type: Array<Eatfresh_Basic_User_Type>;
  /** fetch aggregated fields from the table: "eatfresh.basic_user_type" */
  eatfresh_basic_user_type_aggregate: Eatfresh_Basic_User_Type_Aggregate;
  /** fetch data from the table: "eatfresh.basic_user_type" using primary key columns */
  eatfresh_basic_user_type_by_pk?: Maybe<Eatfresh_Basic_User_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.basic_user_type" */
  eatfresh_basic_user_type_stream: Array<Eatfresh_Basic_User_Type>;
  /** fetch data from the table: "eatfresh.box_content_plan" */
  eatfresh_box_content_plan: Array<Eatfresh_Box_Content_Plan>;
  /** fetch aggregated fields from the table: "eatfresh.box_content_plan" */
  eatfresh_box_content_plan_aggregate: Eatfresh_Box_Content_Plan_Aggregate;
  /** fetch data from the table: "eatfresh.box_content_plan" using primary key columns */
  eatfresh_box_content_plan_by_pk?: Maybe<Eatfresh_Box_Content_Plan>;
  /** fetch data from the table: "eatfresh.box_content_plan_status" */
  eatfresh_box_content_plan_status: Array<Eatfresh_Box_Content_Plan_Status>;
  /** fetch aggregated fields from the table: "eatfresh.box_content_plan_status" */
  eatfresh_box_content_plan_status_aggregate: Eatfresh_Box_Content_Plan_Status_Aggregate;
  /** fetch data from the table: "eatfresh.box_content_plan_status" using primary key columns */
  eatfresh_box_content_plan_status_by_pk?: Maybe<Eatfresh_Box_Content_Plan_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.box_content_plan_status" */
  eatfresh_box_content_plan_status_stream: Array<Eatfresh_Box_Content_Plan_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.box_content_plan" */
  eatfresh_box_content_plan_stream: Array<Eatfresh_Box_Content_Plan>;
  /** fetch data from the table: "eatfresh.box_content_to_article" */
  eatfresh_box_content_to_article: Array<Eatfresh_Box_Content_To_Article>;
  /** fetch aggregated fields from the table: "eatfresh.box_content_to_article" */
  eatfresh_box_content_to_article_aggregate: Eatfresh_Box_Content_To_Article_Aggregate;
  /** fetch data from the table: "eatfresh.box_content_to_article" using primary key columns */
  eatfresh_box_content_to_article_by_pk?: Maybe<Eatfresh_Box_Content_To_Article>;
  /** fetch data from the table in a streaming manner: "eatfresh.box_content_to_article" */
  eatfresh_box_content_to_article_stream: Array<Eatfresh_Box_Content_To_Article>;
  /** fetch data from the table: "eatfresh.commissioning_process" */
  eatfresh_commissioning_process: Array<Eatfresh_Commissioning_Process>;
  /** fetch aggregated fields from the table: "eatfresh.commissioning_process" */
  eatfresh_commissioning_process_aggregate: Eatfresh_Commissioning_Process_Aggregate;
  /** fetch data from the table: "eatfresh.commissioning_process" using primary key columns */
  eatfresh_commissioning_process_by_pk?: Maybe<Eatfresh_Commissioning_Process>;
  /** fetch data from the table: "eatfresh.commissioning_process_position" */
  eatfresh_commissioning_process_position: Array<Eatfresh_Commissioning_Process_Position>;
  /** fetch aggregated fields from the table: "eatfresh.commissioning_process_position" */
  eatfresh_commissioning_process_position_aggregate: Eatfresh_Commissioning_Process_Position_Aggregate;
  /** fetch data from the table: "eatfresh.commissioning_process_position" using primary key columns */
  eatfresh_commissioning_process_position_by_pk?: Maybe<Eatfresh_Commissioning_Process_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.commissioning_process_position" */
  eatfresh_commissioning_process_position_stream: Array<Eatfresh_Commissioning_Process_Position>;
  /** fetch data from the table: "eatfresh.commissioning_process_status" */
  eatfresh_commissioning_process_status: Array<Eatfresh_Commissioning_Process_Status>;
  /** fetch aggregated fields from the table: "eatfresh.commissioning_process_status" */
  eatfresh_commissioning_process_status_aggregate: Eatfresh_Commissioning_Process_Status_Aggregate;
  /** fetch data from the table: "eatfresh.commissioning_process_status" using primary key columns */
  eatfresh_commissioning_process_status_by_pk?: Maybe<Eatfresh_Commissioning_Process_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.commissioning_process_status" */
  eatfresh_commissioning_process_status_stream: Array<Eatfresh_Commissioning_Process_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.commissioning_process" */
  eatfresh_commissioning_process_stream: Array<Eatfresh_Commissioning_Process>;
  /** fetch data from the table: "eatfresh.computop_transaction" */
  eatfresh_computop_transaction: Array<Eatfresh_Computop_Transaction>;
  /** fetch aggregated fields from the table: "eatfresh.computop_transaction" */
  eatfresh_computop_transaction_aggregate: Eatfresh_Computop_Transaction_Aggregate;
  /** fetch data from the table: "eatfresh.computop_transaction" using primary key columns */
  eatfresh_computop_transaction_by_pk?: Maybe<Eatfresh_Computop_Transaction>;
  /** fetch data from the table in a streaming manner: "eatfresh.computop_transaction" */
  eatfresh_computop_transaction_stream: Array<Eatfresh_Computop_Transaction>;
  /** fetch data from the table: "eatfresh.connection_status" */
  eatfresh_connection_status: Array<Eatfresh_Connection_Status>;
  /** fetch aggregated fields from the table: "eatfresh.connection_status" */
  eatfresh_connection_status_aggregate: Eatfresh_Connection_Status_Aggregate;
  /** fetch data from the table: "eatfresh.connection_status" using primary key columns */
  eatfresh_connection_status_by_pk?: Maybe<Eatfresh_Connection_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.connection_status" */
  eatfresh_connection_status_stream: Array<Eatfresh_Connection_Status>;
  /** fetch data from the table: "eatfresh.cost_configuration" */
  eatfresh_cost_configuration: Array<Eatfresh_Cost_Configuration>;
  /** fetch aggregated fields from the table: "eatfresh.cost_configuration" */
  eatfresh_cost_configuration_aggregate: Eatfresh_Cost_Configuration_Aggregate;
  /** fetch data from the table: "eatfresh.cost_configuration_key" */
  eatfresh_cost_configuration_key: Array<Eatfresh_Cost_Configuration_Key>;
  /** fetch aggregated fields from the table: "eatfresh.cost_configuration_key" */
  eatfresh_cost_configuration_key_aggregate: Eatfresh_Cost_Configuration_Key_Aggregate;
  /** fetch data from the table: "eatfresh.cost_configuration_key" using primary key columns */
  eatfresh_cost_configuration_key_by_pk?: Maybe<Eatfresh_Cost_Configuration_Key>;
  /** fetch data from the table in a streaming manner: "eatfresh.cost_configuration_key" */
  eatfresh_cost_configuration_key_stream: Array<Eatfresh_Cost_Configuration_Key>;
  /** fetch data from the table in a streaming manner: "eatfresh.cost_configuration" */
  eatfresh_cost_configuration_stream: Array<Eatfresh_Cost_Configuration>;
  /** fetch data from the table: "eatfresh.customer" */
  eatfresh_customer: Array<Eatfresh_Customer>;
  /** fetch aggregated fields from the table: "eatfresh.customer" */
  eatfresh_customer_aggregate: Eatfresh_Customer_Aggregate;
  /** fetch data from the table: "eatfresh.customer" using primary key columns */
  eatfresh_customer_by_pk?: Maybe<Eatfresh_Customer>;
  /** fetch data from the table: "eatfresh.customer_order" */
  eatfresh_customer_order: Array<Eatfresh_Customer_Order>;
  /** fetch aggregated fields from the table: "eatfresh.customer_order" */
  eatfresh_customer_order_aggregate: Eatfresh_Customer_Order_Aggregate;
  /** fetch data from the table: "eatfresh.customer_order" using primary key columns */
  eatfresh_customer_order_by_pk?: Maybe<Eatfresh_Customer_Order>;
  /** fetch data from the table in a streaming manner: "eatfresh.customer_order" */
  eatfresh_customer_order_stream: Array<Eatfresh_Customer_Order>;
  /** fetch data from the table in a streaming manner: "eatfresh.customer" */
  eatfresh_customer_stream: Array<Eatfresh_Customer>;
  /** fetch data from the table: "eatfresh.door_status" */
  eatfresh_door_status: Array<Eatfresh_Door_Status>;
  /** fetch aggregated fields from the table: "eatfresh.door_status" */
  eatfresh_door_status_aggregate: Eatfresh_Door_Status_Aggregate;
  /** fetch data from the table: "eatfresh.door_status" using primary key columns */
  eatfresh_door_status_by_pk?: Maybe<Eatfresh_Door_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.door_status" */
  eatfresh_door_status_stream: Array<Eatfresh_Door_Status>;
  /** fetch data from the table: "eatfresh.easy_refill_permission" */
  eatfresh_easy_refill_permission: Array<Eatfresh_Easy_Refill_Permission>;
  /** fetch aggregated fields from the table: "eatfresh.easy_refill_permission" */
  eatfresh_easy_refill_permission_aggregate: Eatfresh_Easy_Refill_Permission_Aggregate;
  /** fetch data from the table: "eatfresh.easy_refill_permission" using primary key columns */
  eatfresh_easy_refill_permission_by_pk?: Maybe<Eatfresh_Easy_Refill_Permission>;
  /** fetch data from the table in a streaming manner: "eatfresh.easy_refill_permission" */
  eatfresh_easy_refill_permission_stream: Array<Eatfresh_Easy_Refill_Permission>;
  /** fetch data from the table: "eatfresh.external_warehouse_pallet_spot" */
  eatfresh_external_warehouse_pallet_spot: Array<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** fetch aggregated fields from the table: "eatfresh.external_warehouse_pallet_spot" */
  eatfresh_external_warehouse_pallet_spot_aggregate: Eatfresh_External_Warehouse_Pallet_Spot_Aggregate;
  /** fetch data from the table: "eatfresh.external_warehouse_pallet_spot" using primary key columns */
  eatfresh_external_warehouse_pallet_spot_by_pk?: Maybe<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** fetch data from the table in a streaming manner: "eatfresh.external_warehouse_pallet_spot" */
  eatfresh_external_warehouse_pallet_spot_stream: Array<Eatfresh_External_Warehouse_Pallet_Spot>;
  /** fetch data from the table: "eatfresh.flyway_schema_history" */
  eatfresh_flyway_schema_history: Array<Eatfresh_Flyway_Schema_History>;
  /** fetch aggregated fields from the table: "eatfresh.flyway_schema_history" */
  eatfresh_flyway_schema_history_aggregate: Eatfresh_Flyway_Schema_History_Aggregate;
  /** fetch data from the table: "eatfresh.flyway_schema_history" using primary key columns */
  eatfresh_flyway_schema_history_by_pk?: Maybe<Eatfresh_Flyway_Schema_History>;
  /** fetch data from the table in a streaming manner: "eatfresh.flyway_schema_history" */
  eatfresh_flyway_schema_history_stream: Array<Eatfresh_Flyway_Schema_History>;
  /** fetch data from the table: "eatfresh.fridge" */
  eatfresh_fridge: Array<Eatfresh_Fridge>;
  /** fetch data from the table: "eatfresh.fridge_active_daily" */
  eatfresh_fridge_active_daily: Array<Eatfresh_Fridge_Active_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_active_daily" */
  eatfresh_fridge_active_daily_aggregate: Eatfresh_Fridge_Active_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_active_daily" */
  eatfresh_fridge_active_daily_stream: Array<Eatfresh_Fridge_Active_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge" */
  eatfresh_fridge_aggregate: Eatfresh_Fridge_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_alarm" */
  eatfresh_fridge_alarm: Array<Eatfresh_Fridge_Alarm>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_alarm" */
  eatfresh_fridge_alarm_aggregate: Eatfresh_Fridge_Alarm_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_alarm" using primary key columns */
  eatfresh_fridge_alarm_by_pk?: Maybe<Eatfresh_Fridge_Alarm>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_alarm" */
  eatfresh_fridge_alarm_stream: Array<Eatfresh_Fridge_Alarm>;
  /** fetch data from the table: "eatfresh.fridge_article_stock" */
  eatfresh_fridge_article_stock: Array<Eatfresh_Fridge_Article_Stock>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock" */
  eatfresh_fridge_article_stock_aggregate: Eatfresh_Fridge_Article_Stock_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot" */
  eatfresh_fridge_article_stock_snapshot: Array<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock_snapshot" */
  eatfresh_fridge_article_stock_snapshot_aggregate: Eatfresh_Fridge_Article_Stock_Snapshot_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot" using primary key columns */
  eatfresh_fridge_article_stock_snapshot_by_pk?: Maybe<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot_daily" */
  eatfresh_fridge_article_stock_snapshot_daily: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock_snapshot_daily" */
  eatfresh_fridge_article_stock_snapshot_daily_aggregate: Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_article_stock_snapshot_daily" */
  eatfresh_fridge_article_stock_snapshot_daily_stream: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily>;
  /** fetch data from the table: "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
  eatfresh_fridge_article_stock_snapshot_enabled_daily: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
  eatfresh_fridge_article_stock_snapshot_enabled_daily_aggregate: Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_article_stock_snapshot_enabled_daily" */
  eatfresh_fridge_article_stock_snapshot_enabled_daily_stream: Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_article_stock_snapshot" */
  eatfresh_fridge_article_stock_snapshot_stream: Array<Eatfresh_Fridge_Article_Stock_Snapshot>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_article_stock" */
  eatfresh_fridge_article_stock_stream: Array<Eatfresh_Fridge_Article_Stock>;
  /** fetch data from the table: "eatfresh.fridge" using primary key columns */
  eatfresh_fridge_by_pk?: Maybe<Eatfresh_Fridge>;
  /** fetch data from the table: "eatfresh.fridge_event" */
  eatfresh_fridge_event: Array<Eatfresh_Fridge_Event>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_event" */
  eatfresh_fridge_event_aggregate: Eatfresh_Fridge_Event_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_event" using primary key columns */
  eatfresh_fridge_event_by_pk?: Maybe<Eatfresh_Fridge_Event>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_event" */
  eatfresh_fridge_event_stream: Array<Eatfresh_Fridge_Event>;
  /** fetch data from the table: "eatfresh.fridge_event_type" */
  eatfresh_fridge_event_type: Array<Eatfresh_Fridge_Event_Type>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_event_type" */
  eatfresh_fridge_event_type_aggregate: Eatfresh_Fridge_Event_Type_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_event_type" using primary key columns */
  eatfresh_fridge_event_type_by_pk?: Maybe<Eatfresh_Fridge_Event_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_event_type" */
  eatfresh_fridge_event_type_stream: Array<Eatfresh_Fridge_Event_Type>;
  /** fetch data from the table: "eatfresh.fridge_layout" */
  eatfresh_fridge_layout: Array<Eatfresh_Fridge_Layout>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout" */
  eatfresh_fridge_layout_aggregate: Eatfresh_Fridge_Layout_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment" */
  eatfresh_fridge_layout_assignment: Array<Eatfresh_Fridge_Layout_Assignment>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_assignment" */
  eatfresh_fridge_layout_assignment_aggregate: Eatfresh_Fridge_Layout_Assignment_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment" using primary key columns */
  eatfresh_fridge_layout_assignment_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment>;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment_status" */
  eatfresh_fridge_layout_assignment_status: Array<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_assignment_status" */
  eatfresh_fridge_layout_assignment_status_aggregate: Eatfresh_Fridge_Layout_Assignment_Status_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_assignment_status" using primary key columns */
  eatfresh_fridge_layout_assignment_status_by_pk?: Maybe<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_layout_assignment_status" */
  eatfresh_fridge_layout_assignment_status_stream: Array<Eatfresh_Fridge_Layout_Assignment_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_layout_assignment" */
  eatfresh_fridge_layout_assignment_stream: Array<Eatfresh_Fridge_Layout_Assignment>;
  /** fetch data from the table: "eatfresh.fridge_layout" using primary key columns */
  eatfresh_fridge_layout_by_pk?: Maybe<Eatfresh_Fridge_Layout>;
  /** fetch data from the table: "eatfresh.fridge_layout_level" */
  eatfresh_fridge_layout_level: Array<Eatfresh_Fridge_Layout_Level>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_level" */
  eatfresh_fridge_layout_level_aggregate: Eatfresh_Fridge_Layout_Level_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_level" using primary key columns */
  eatfresh_fridge_layout_level_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level>;
  /** fetch data from the table: "eatfresh.fridge_layout_level_position" */
  eatfresh_fridge_layout_level_position: Array<Eatfresh_Fridge_Layout_Level_Position>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_layout_level_position" */
  eatfresh_fridge_layout_level_position_aggregate: Eatfresh_Fridge_Layout_Level_Position_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_layout_level_position" using primary key columns */
  eatfresh_fridge_layout_level_position_by_pk?: Maybe<Eatfresh_Fridge_Layout_Level_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_layout_level_position" */
  eatfresh_fridge_layout_level_position_stream: Array<Eatfresh_Fridge_Layout_Level_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_layout_level" */
  eatfresh_fridge_layout_level_stream: Array<Eatfresh_Fridge_Layout_Level>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_layout" */
  eatfresh_fridge_layout_stream: Array<Eatfresh_Fridge_Layout>;
  /** fetch data from the table: "eatfresh.fridge_order" */
  eatfresh_fridge_order: Array<Eatfresh_Fridge_Order>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_order" */
  eatfresh_fridge_order_aggregate: Eatfresh_Fridge_Order_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_order" using primary key columns */
  eatfresh_fridge_order_by_pk?: Maybe<Eatfresh_Fridge_Order>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_order" */
  eatfresh_fridge_order_stream: Array<Eatfresh_Fridge_Order>;
  /** fetch data from the table: "eatfresh.fridge_status_history" */
  eatfresh_fridge_status_history: Array<Eatfresh_Fridge_Status_History>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_status_history" */
  eatfresh_fridge_status_history_aggregate: Eatfresh_Fridge_Status_History_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_status_history" using primary key columns */
  eatfresh_fridge_status_history_by_pk?: Maybe<Eatfresh_Fridge_Status_History>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_status_history" */
  eatfresh_fridge_status_history_stream: Array<Eatfresh_Fridge_Status_History>;
  /** fetch data from the table: "eatfresh.fridge_stock" */
  eatfresh_fridge_stock: Array<Eatfresh_Fridge_Stock>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_stock" */
  eatfresh_fridge_stock_aggregate: Eatfresh_Fridge_Stock_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_stock" using primary key columns */
  eatfresh_fridge_stock_by_pk?: Maybe<Eatfresh_Fridge_Stock>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_stock" */
  eatfresh_fridge_stock_stream: Array<Eatfresh_Fridge_Stock>;
  /** fetch data from the table: "eatfresh.fridge_stocked_enabled_daily" */
  eatfresh_fridge_stocked_enabled_daily: Array<Eatfresh_Fridge_Stocked_Enabled_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_stocked_enabled_daily" */
  eatfresh_fridge_stocked_enabled_daily_aggregate: Eatfresh_Fridge_Stocked_Enabled_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_stocked_enabled_daily" */
  eatfresh_fridge_stocked_enabled_daily_stream: Array<Eatfresh_Fridge_Stocked_Enabled_Daily>;
  /** fetch data from the table: "eatfresh.fridge_stocked_enabled_per_place_daily" */
  eatfresh_fridge_stocked_enabled_per_place_daily: Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_stocked_enabled_per_place_daily" */
  eatfresh_fridge_stocked_enabled_per_place_daily_aggregate: Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_stocked_enabled_per_place_daily" */
  eatfresh_fridge_stocked_enabled_per_place_daily_stream: Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge" */
  eatfresh_fridge_stream: Array<Eatfresh_Fridge>;
  /** fetch data from the table: "eatfresh.fridge_target_stock" */
  eatfresh_fridge_target_stock: Array<Eatfresh_Fridge_Target_Stock>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_target_stock" */
  eatfresh_fridge_target_stock_aggregate: Eatfresh_Fridge_Target_Stock_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_target_stock" using primary key columns */
  eatfresh_fridge_target_stock_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock>;
  /** fetch data from the table: "eatfresh.fridge_target_stock_position" */
  eatfresh_fridge_target_stock_position: Array<Eatfresh_Fridge_Target_Stock_Position>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_target_stock_position" */
  eatfresh_fridge_target_stock_position_aggregate: Eatfresh_Fridge_Target_Stock_Position_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_target_stock_position" using primary key columns */
  eatfresh_fridge_target_stock_position_by_pk?: Maybe<Eatfresh_Fridge_Target_Stock_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_target_stock_position" */
  eatfresh_fridge_target_stock_position_stream: Array<Eatfresh_Fridge_Target_Stock_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_target_stock" */
  eatfresh_fridge_target_stock_stream: Array<Eatfresh_Fridge_Target_Stock>;
  /** fetch data from the table: "eatfresh.fridge_type" */
  eatfresh_fridge_type: Array<Eatfresh_Fridge_Type>;
  /** fetch aggregated fields from the table: "eatfresh.fridge_type" */
  eatfresh_fridge_type_aggregate: Eatfresh_Fridge_Type_Aggregate;
  /** fetch data from the table: "eatfresh.fridge_type" using primary key columns */
  eatfresh_fridge_type_by_pk?: Maybe<Eatfresh_Fridge_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.fridge_type" */
  eatfresh_fridge_type_stream: Array<Eatfresh_Fridge_Type>;
  /** fetch data from the table: "eatfresh.logistics_problem" */
  eatfresh_logistics_problem: Array<Eatfresh_Logistics_Problem>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_problem" */
  eatfresh_logistics_problem_aggregate: Eatfresh_Logistics_Problem_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_problem" using primary key columns */
  eatfresh_logistics_problem_by_pk?: Maybe<Eatfresh_Logistics_Problem>;
  /** fetch data from the table: "eatfresh.logistics_problem_image" */
  eatfresh_logistics_problem_image: Array<Eatfresh_Logistics_Problem_Image>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_problem_image" */
  eatfresh_logistics_problem_image_aggregate: Eatfresh_Logistics_Problem_Image_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_problem_image" using primary key columns */
  eatfresh_logistics_problem_image_by_pk?: Maybe<Eatfresh_Logistics_Problem_Image>;
  /** fetch data from the table in a streaming manner: "eatfresh.logistics_problem_image" */
  eatfresh_logistics_problem_image_stream: Array<Eatfresh_Logistics_Problem_Image>;
  /** fetch data from the table: "eatfresh.logistics_problem_status" */
  eatfresh_logistics_problem_status: Array<Eatfresh_Logistics_Problem_Status>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_problem_status" */
  eatfresh_logistics_problem_status_aggregate: Eatfresh_Logistics_Problem_Status_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_problem_status" using primary key columns */
  eatfresh_logistics_problem_status_by_pk?: Maybe<Eatfresh_Logistics_Problem_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.logistics_problem_status" */
  eatfresh_logistics_problem_status_stream: Array<Eatfresh_Logistics_Problem_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.logistics_problem" */
  eatfresh_logistics_problem_stream: Array<Eatfresh_Logistics_Problem>;
  /** fetch data from the table: "eatfresh.logistics_process_type" */
  eatfresh_logistics_process_type: Array<Eatfresh_Logistics_Process_Type>;
  /** fetch aggregated fields from the table: "eatfresh.logistics_process_type" */
  eatfresh_logistics_process_type_aggregate: Eatfresh_Logistics_Process_Type_Aggregate;
  /** fetch data from the table: "eatfresh.logistics_process_type" using primary key columns */
  eatfresh_logistics_process_type_by_pk?: Maybe<Eatfresh_Logistics_Process_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.logistics_process_type" */
  eatfresh_logistics_process_type_stream: Array<Eatfresh_Logistics_Process_Type>;
  /** fetch data from the table: "eatfresh.nutrition_information" */
  eatfresh_nutrition_information: Array<Eatfresh_Nutrition_Information>;
  /** fetch aggregated fields from the table: "eatfresh.nutrition_information" */
  eatfresh_nutrition_information_aggregate: Eatfresh_Nutrition_Information_Aggregate;
  /** fetch data from the table: "eatfresh.nutrition_information" using primary key columns */
  eatfresh_nutrition_information_by_pk?: Maybe<Eatfresh_Nutrition_Information>;
  /** fetch data from the table in a streaming manner: "eatfresh.nutrition_information" */
  eatfresh_nutrition_information_stream: Array<Eatfresh_Nutrition_Information>;
  /** fetch data from the table: "eatfresh.order_extra" */
  eatfresh_order_extra: Array<Eatfresh_Order_Extra>;
  /** fetch aggregated fields from the table: "eatfresh.order_extra" */
  eatfresh_order_extra_aggregate: Eatfresh_Order_Extra_Aggregate;
  /** fetch data from the table: "eatfresh.order_extra" using primary key columns */
  eatfresh_order_extra_by_pk?: Maybe<Eatfresh_Order_Extra>;
  /** fetch data from the table: "eatfresh.order_extra_customer_order" */
  eatfresh_order_extra_customer_order: Array<Eatfresh_Order_Extra_Customer_Order>;
  /** fetch aggregated fields from the table: "eatfresh.order_extra_customer_order" */
  eatfresh_order_extra_customer_order_aggregate: Eatfresh_Order_Extra_Customer_Order_Aggregate;
  /** fetch data from the table: "eatfresh.order_extra_customer_order" using primary key columns */
  eatfresh_order_extra_customer_order_by_pk?: Maybe<Eatfresh_Order_Extra_Customer_Order>;
  /** fetch data from the table in a streaming manner: "eatfresh.order_extra_customer_order" */
  eatfresh_order_extra_customer_order_stream: Array<Eatfresh_Order_Extra_Customer_Order>;
  /** fetch data from the table in a streaming manner: "eatfresh.order_extra" */
  eatfresh_order_extra_stream: Array<Eatfresh_Order_Extra>;
  /** fetch data from the table: "eatfresh.order_position" */
  eatfresh_order_position: Array<Eatfresh_Order_Position>;
  /** fetch aggregated fields from the table: "eatfresh.order_position" */
  eatfresh_order_position_aggregate: Eatfresh_Order_Position_Aggregate;
  /** fetch data from the table: "eatfresh.order_position" using primary key columns */
  eatfresh_order_position_by_pk?: Maybe<Eatfresh_Order_Position>;
  /** fetch data from the table: "eatfresh.order_position_category" */
  eatfresh_order_position_category: Array<Eatfresh_Order_Position_Category>;
  /** fetch aggregated fields from the table: "eatfresh.order_position_category" */
  eatfresh_order_position_category_aggregate: Eatfresh_Order_Position_Category_Aggregate;
  /** fetch data from the table: "eatfresh.order_position_category" using primary key columns */
  eatfresh_order_position_category_by_pk?: Maybe<Eatfresh_Order_Position_Category>;
  /** fetch data from the table in a streaming manner: "eatfresh.order_position_category" */
  eatfresh_order_position_category_stream: Array<Eatfresh_Order_Position_Category>;
  /** fetch data from the table in a streaming manner: "eatfresh.order_position" */
  eatfresh_order_position_stream: Array<Eatfresh_Order_Position>;
  /** fetch data from the table: "eatfresh.order_status" */
  eatfresh_order_status: Array<Eatfresh_Order_Status>;
  /** fetch aggregated fields from the table: "eatfresh.order_status" */
  eatfresh_order_status_aggregate: Eatfresh_Order_Status_Aggregate;
  /** fetch data from the table: "eatfresh.order_status" using primary key columns */
  eatfresh_order_status_by_pk?: Maybe<Eatfresh_Order_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.order_status" */
  eatfresh_order_status_stream: Array<Eatfresh_Order_Status>;
  /** fetch data from the table: "eatfresh.packaging_type" */
  eatfresh_packaging_type: Array<Eatfresh_Packaging_Type>;
  /** fetch aggregated fields from the table: "eatfresh.packaging_type" */
  eatfresh_packaging_type_aggregate: Eatfresh_Packaging_Type_Aggregate;
  /** fetch data from the table: "eatfresh.packaging_type" using primary key columns */
  eatfresh_packaging_type_by_pk?: Maybe<Eatfresh_Packaging_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.packaging_type" */
  eatfresh_packaging_type_stream: Array<Eatfresh_Packaging_Type>;
  /** fetch data from the table: "eatfresh.password_reset_token" */
  eatfresh_password_reset_token: Array<Eatfresh_Password_Reset_Token>;
  /** fetch aggregated fields from the table: "eatfresh.password_reset_token" */
  eatfresh_password_reset_token_aggregate: Eatfresh_Password_Reset_Token_Aggregate;
  /** fetch data from the table: "eatfresh.password_reset_token" using primary key columns */
  eatfresh_password_reset_token_by_pk?: Maybe<Eatfresh_Password_Reset_Token>;
  /** fetch data from the table in a streaming manner: "eatfresh.password_reset_token" */
  eatfresh_password_reset_token_stream: Array<Eatfresh_Password_Reset_Token>;
  /** fetch data from the table: "eatfresh.payment_method" */
  eatfresh_payment_method: Array<Eatfresh_Payment_Method>;
  /** fetch aggregated fields from the table: "eatfresh.payment_method" */
  eatfresh_payment_method_aggregate: Eatfresh_Payment_Method_Aggregate;
  /** fetch data from the table: "eatfresh.payment_method" using primary key columns */
  eatfresh_payment_method_by_pk?: Maybe<Eatfresh_Payment_Method>;
  /** fetch data from the table in a streaming manner: "eatfresh.payment_method" */
  eatfresh_payment_method_stream: Array<Eatfresh_Payment_Method>;
  /** fetch data from the table: "eatfresh.payment_method_type" */
  eatfresh_payment_method_type: Array<Eatfresh_Payment_Method_Type>;
  /** fetch aggregated fields from the table: "eatfresh.payment_method_type" */
  eatfresh_payment_method_type_aggregate: Eatfresh_Payment_Method_Type_Aggregate;
  /** fetch data from the table: "eatfresh.payment_method_type" using primary key columns */
  eatfresh_payment_method_type_by_pk?: Maybe<Eatfresh_Payment_Method_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.payment_method_type" */
  eatfresh_payment_method_type_stream: Array<Eatfresh_Payment_Method_Type>;
  /** fetch data from the table: "eatfresh.payment_status" */
  eatfresh_payment_status: Array<Eatfresh_Payment_Status>;
  /** fetch aggregated fields from the table: "eatfresh.payment_status" */
  eatfresh_payment_status_aggregate: Eatfresh_Payment_Status_Aggregate;
  /** fetch data from the table: "eatfresh.payment_status" using primary key columns */
  eatfresh_payment_status_by_pk?: Maybe<Eatfresh_Payment_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.payment_status" */
  eatfresh_payment_status_stream: Array<Eatfresh_Payment_Status>;
  /** fetch data from the table: "eatfresh.place" */
  eatfresh_place: Array<Eatfresh_Place>;
  /** fetch aggregated fields from the table: "eatfresh.place" */
  eatfresh_place_aggregate: Eatfresh_Place_Aggregate;
  /** fetch data from the table: "eatfresh.place" using primary key columns */
  eatfresh_place_by_pk?: Maybe<Eatfresh_Place>;
  /** fetch data from the table in a streaming manner: "eatfresh.place" */
  eatfresh_place_stream: Array<Eatfresh_Place>;
  /** fetch data from the table: "eatfresh.price_change" */
  eatfresh_price_change: Array<Eatfresh_Price_Change>;
  /** fetch aggregated fields from the table: "eatfresh.price_change" */
  eatfresh_price_change_aggregate: Eatfresh_Price_Change_Aggregate;
  /** fetch data from the table: "eatfresh.price_change" using primary key columns */
  eatfresh_price_change_by_pk?: Maybe<Eatfresh_Price_Change>;
  /** fetch data from the table: "eatfresh.price_change_position" */
  eatfresh_price_change_position: Array<Eatfresh_Price_Change_Position>;
  /** fetch aggregated fields from the table: "eatfresh.price_change_position" */
  eatfresh_price_change_position_aggregate: Eatfresh_Price_Change_Position_Aggregate;
  /** fetch data from the table: "eatfresh.price_change_position" using primary key columns */
  eatfresh_price_change_position_by_pk?: Maybe<Eatfresh_Price_Change_Position>;
  /** fetch data from the table: "eatfresh.price_change_position_status" */
  eatfresh_price_change_position_status: Array<Eatfresh_Price_Change_Position_Status>;
  /** fetch aggregated fields from the table: "eatfresh.price_change_position_status" */
  eatfresh_price_change_position_status_aggregate: Eatfresh_Price_Change_Position_Status_Aggregate;
  /** fetch data from the table: "eatfresh.price_change_position_status" using primary key columns */
  eatfresh_price_change_position_status_by_pk?: Maybe<Eatfresh_Price_Change_Position_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.price_change_position_status" */
  eatfresh_price_change_position_status_stream: Array<Eatfresh_Price_Change_Position_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.price_change_position" */
  eatfresh_price_change_position_stream: Array<Eatfresh_Price_Change_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.price_change" */
  eatfresh_price_change_stream: Array<Eatfresh_Price_Change>;
  /** fetch data from the table: "eatfresh.price_lock" */
  eatfresh_price_lock: Array<Eatfresh_Price_Lock>;
  /** fetch aggregated fields from the table: "eatfresh.price_lock" */
  eatfresh_price_lock_aggregate: Eatfresh_Price_Lock_Aggregate;
  /** fetch data from the table: "eatfresh.price_lock" using primary key columns */
  eatfresh_price_lock_by_pk?: Maybe<Eatfresh_Price_Lock>;
  /** fetch data from the table in a streaming manner: "eatfresh.price_lock" */
  eatfresh_price_lock_stream: Array<Eatfresh_Price_Lock>;
  /** fetch data from the table: "eatfresh.product_orientation" */
  eatfresh_product_orientation: Array<Eatfresh_Product_Orientation>;
  /** fetch aggregated fields from the table: "eatfresh.product_orientation" */
  eatfresh_product_orientation_aggregate: Eatfresh_Product_Orientation_Aggregate;
  /** fetch data from the table: "eatfresh.product_orientation" using primary key columns */
  eatfresh_product_orientation_by_pk?: Maybe<Eatfresh_Product_Orientation>;
  /** fetch data from the table in a streaming manner: "eatfresh.product_orientation" */
  eatfresh_product_orientation_stream: Array<Eatfresh_Product_Orientation>;
  /** fetch data from the table: "eatfresh.refill" */
  eatfresh_refill: Array<Eatfresh_Refill>;
  /** fetch aggregated fields from the table: "eatfresh.refill" */
  eatfresh_refill_aggregate: Eatfresh_Refill_Aggregate;
  /** fetch data from the table: "eatfresh.refill" using primary key columns */
  eatfresh_refill_by_pk?: Maybe<Eatfresh_Refill>;
  /** fetch data from the table: "eatfresh.refill_status" */
  eatfresh_refill_status: Array<Eatfresh_Refill_Status>;
  /** fetch aggregated fields from the table: "eatfresh.refill_status" */
  eatfresh_refill_status_aggregate: Eatfresh_Refill_Status_Aggregate;
  /** fetch data from the table: "eatfresh.refill_status" using primary key columns */
  eatfresh_refill_status_by_pk?: Maybe<Eatfresh_Refill_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.refill_status" */
  eatfresh_refill_status_stream: Array<Eatfresh_Refill_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.refill" */
  eatfresh_refill_stream: Array<Eatfresh_Refill>;
  /** fetch data from the table: "eatfresh.rfid_asset" */
  eatfresh_rfid_asset: Array<Eatfresh_Rfid_Asset>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_asset" */
  eatfresh_rfid_asset_aggregate: Eatfresh_Rfid_Asset_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_asset" using primary key columns */
  eatfresh_rfid_asset_by_pk?: Maybe<Eatfresh_Rfid_Asset>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_asset" */
  eatfresh_rfid_asset_stream: Array<Eatfresh_Rfid_Asset>;
  /** fetch data from the table: "eatfresh.rfid_asset_type" */
  eatfresh_rfid_asset_type: Array<Eatfresh_Rfid_Asset_Type>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_asset_type" */
  eatfresh_rfid_asset_type_aggregate: Eatfresh_Rfid_Asset_Type_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_asset_type" using primary key columns */
  eatfresh_rfid_asset_type_by_pk?: Maybe<Eatfresh_Rfid_Asset_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_asset_type" */
  eatfresh_rfid_asset_type_stream: Array<Eatfresh_Rfid_Asset_Type>;
  /** fetch data from the table: "eatfresh.rfid_box" */
  eatfresh_rfid_box: Array<Eatfresh_Rfid_Box>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_box" */
  eatfresh_rfid_box_aggregate: Eatfresh_Rfid_Box_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_box" using primary key columns */
  eatfresh_rfid_box_by_pk?: Maybe<Eatfresh_Rfid_Box>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_box" */
  eatfresh_rfid_box_stream: Array<Eatfresh_Rfid_Box>;
  /** fetch data from the table: "eatfresh.rfid_box_type" */
  eatfresh_rfid_box_type: Array<Eatfresh_Rfid_Box_Type>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_box_type" */
  eatfresh_rfid_box_type_aggregate: Eatfresh_Rfid_Box_Type_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_box_type" using primary key columns */
  eatfresh_rfid_box_type_by_pk?: Maybe<Eatfresh_Rfid_Box_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_box_type" */
  eatfresh_rfid_box_type_stream: Array<Eatfresh_Rfid_Box_Type>;
  /** fetch data from the table: "eatfresh.rfid_scan" */
  eatfresh_rfid_scan: Array<Eatfresh_Rfid_Scan>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scan" */
  eatfresh_rfid_scan_aggregate: Eatfresh_Rfid_Scan_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scan" using primary key columns */
  eatfresh_rfid_scan_by_pk?: Maybe<Eatfresh_Rfid_Scan>;
  /** fetch data from the table: "eatfresh.rfid_scan_status" */
  eatfresh_rfid_scan_status: Array<Eatfresh_Rfid_Scan_Status>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scan_status" */
  eatfresh_rfid_scan_status_aggregate: Eatfresh_Rfid_Scan_Status_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scan_status" using primary key columns */
  eatfresh_rfid_scan_status_by_pk?: Maybe<Eatfresh_Rfid_Scan_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_scan_status" */
  eatfresh_rfid_scan_status_stream: Array<Eatfresh_Rfid_Scan_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_scan" */
  eatfresh_rfid_scan_stream: Array<Eatfresh_Rfid_Scan>;
  /** fetch data from the table: "eatfresh.rfid_scanner" */
  eatfresh_rfid_scanner: Array<Eatfresh_Rfid_Scanner>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scanner" */
  eatfresh_rfid_scanner_aggregate: Eatfresh_Rfid_Scanner_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scanner" using primary key columns */
  eatfresh_rfid_scanner_by_pk?: Maybe<Eatfresh_Rfid_Scanner>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_scanner" */
  eatfresh_rfid_scanner_stream: Array<Eatfresh_Rfid_Scanner>;
  /** fetch data from the table: "eatfresh.rfid_scanner_type" */
  eatfresh_rfid_scanner_type: Array<Eatfresh_Rfid_Scanner_Type>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_scanner_type" */
  eatfresh_rfid_scanner_type_aggregate: Eatfresh_Rfid_Scanner_Type_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_scanner_type" using primary key columns */
  eatfresh_rfid_scanner_type_by_pk?: Maybe<Eatfresh_Rfid_Scanner_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_scanner_type" */
  eatfresh_rfid_scanner_type_stream: Array<Eatfresh_Rfid_Scanner_Type>;
  /** fetch data from the table: "eatfresh.rfid_status" */
  eatfresh_rfid_status: Array<Eatfresh_Rfid_Status>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_status" */
  eatfresh_rfid_status_aggregate: Eatfresh_Rfid_Status_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_status" using primary key columns */
  eatfresh_rfid_status_by_pk?: Maybe<Eatfresh_Rfid_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_status" */
  eatfresh_rfid_status_stream: Array<Eatfresh_Rfid_Status>;
  /** fetch data from the table: "eatfresh.rfid_tag" */
  eatfresh_rfid_tag: Array<Eatfresh_Rfid_Tag>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_tag" */
  eatfresh_rfid_tag_aggregate: Eatfresh_Rfid_Tag_Aggregate;
  /** fetch data from the table: "eatfresh.rfid_tag" using primary key columns */
  eatfresh_rfid_tag_by_pk?: Maybe<Eatfresh_Rfid_Tag>;
  /** fetch data from the table: "eatfresh.rfid_tag_sales_daily" */
  eatfresh_rfid_tag_sales_daily: Array<Eatfresh_Rfid_Tag_Sales_Daily>;
  /** fetch aggregated fields from the table: "eatfresh.rfid_tag_sales_daily" */
  eatfresh_rfid_tag_sales_daily_aggregate: Eatfresh_Rfid_Tag_Sales_Daily_Aggregate;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_tag_sales_daily" */
  eatfresh_rfid_tag_sales_daily_stream: Array<Eatfresh_Rfid_Tag_Sales_Daily>;
  /** fetch data from the table in a streaming manner: "eatfresh.rfid_tag" */
  eatfresh_rfid_tag_stream: Array<Eatfresh_Rfid_Tag>;
  /** fetch data from the table: "eatfresh.selfly_cabinet_state" */
  eatfresh_selfly_cabinet_state: Array<Eatfresh_Selfly_Cabinet_State>;
  /** fetch aggregated fields from the table: "eatfresh.selfly_cabinet_state" */
  eatfresh_selfly_cabinet_state_aggregate: Eatfresh_Selfly_Cabinet_State_Aggregate;
  /** fetch data from the table: "eatfresh.selfly_cabinet_state" using primary key columns */
  eatfresh_selfly_cabinet_state_by_pk?: Maybe<Eatfresh_Selfly_Cabinet_State>;
  /** fetch data from the table in a streaming manner: "eatfresh.selfly_cabinet_state" */
  eatfresh_selfly_cabinet_state_stream: Array<Eatfresh_Selfly_Cabinet_State>;
  /** fetch data from the table: "eatfresh.session_step" */
  eatfresh_session_step: Array<Eatfresh_Session_Step>;
  /** fetch aggregated fields from the table: "eatfresh.session_step" */
  eatfresh_session_step_aggregate: Eatfresh_Session_Step_Aggregate;
  /** fetch data from the table: "eatfresh.session_step" using primary key columns */
  eatfresh_session_step_by_pk?: Maybe<Eatfresh_Session_Step>;
  /** fetch data from the table in a streaming manner: "eatfresh.session_step" */
  eatfresh_session_step_stream: Array<Eatfresh_Session_Step>;
  /** fetch data from the table: "eatfresh.shelf_type" */
  eatfresh_shelf_type: Array<Eatfresh_Shelf_Type>;
  /** fetch aggregated fields from the table: "eatfresh.shelf_type" */
  eatfresh_shelf_type_aggregate: Eatfresh_Shelf_Type_Aggregate;
  /** fetch data from the table: "eatfresh.shelf_type" using primary key columns */
  eatfresh_shelf_type_by_pk?: Maybe<Eatfresh_Shelf_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.shelf_type" */
  eatfresh_shelf_type_stream: Array<Eatfresh_Shelf_Type>;
  /** fetch data from the table: "eatfresh.sold_item_cost" */
  eatfresh_sold_item_cost: Array<Eatfresh_Sold_Item_Cost>;
  /** fetch aggregated fields from the table: "eatfresh.sold_item_cost" */
  eatfresh_sold_item_cost_aggregate: Eatfresh_Sold_Item_Cost_Aggregate;
  /** fetch data from the table in a streaming manner: "eatfresh.sold_item_cost" */
  eatfresh_sold_item_cost_stream: Array<Eatfresh_Sold_Item_Cost>;
  /** fetch data from the table: "eatfresh.supplier_problem" */
  eatfresh_supplier_problem: Array<Eatfresh_Supplier_Problem>;
  /** fetch aggregated fields from the table: "eatfresh.supplier_problem" */
  eatfresh_supplier_problem_aggregate: Eatfresh_Supplier_Problem_Aggregate;
  /** fetch data from the table: "eatfresh.supplier_problem" using primary key columns */
  eatfresh_supplier_problem_by_pk?: Maybe<Eatfresh_Supplier_Problem>;
  /** fetch data from the table in a streaming manner: "eatfresh.supplier_problem" */
  eatfresh_supplier_problem_stream: Array<Eatfresh_Supplier_Problem>;
  /** fetch data from the table: "eatfresh.supplier_problem_to_file" */
  eatfresh_supplier_problem_to_file: Array<Eatfresh_Supplier_Problem_To_File>;
  /** fetch aggregated fields from the table: "eatfresh.supplier_problem_to_file" */
  eatfresh_supplier_problem_to_file_aggregate: Eatfresh_Supplier_Problem_To_File_Aggregate;
  /** fetch data from the table: "eatfresh.supplier_problem_to_file" using primary key columns */
  eatfresh_supplier_problem_to_file_by_pk?: Maybe<Eatfresh_Supplier_Problem_To_File>;
  /** fetch data from the table in a streaming manner: "eatfresh.supplier_problem_to_file" */
  eatfresh_supplier_problem_to_file_stream: Array<Eatfresh_Supplier_Problem_To_File>;
  /** fetch data from the table: "eatfresh.transaction_logs" */
  eatfresh_transaction_logs: Array<Eatfresh_Transaction_Logs>;
  /** fetch aggregated fields from the table: "eatfresh.transaction_logs" */
  eatfresh_transaction_logs_aggregate: Eatfresh_Transaction_Logs_Aggregate;
  /** fetch data from the table: "eatfresh.transaction_logs" using primary key columns */
  eatfresh_transaction_logs_by_pk?: Maybe<Eatfresh_Transaction_Logs>;
  /** fetch data from the table in a streaming manner: "eatfresh.transaction_logs" */
  eatfresh_transaction_logs_stream: Array<Eatfresh_Transaction_Logs>;
  /** fetch data from the table: "eatfresh.uploaded_file" */
  eatfresh_uploaded_file: Array<Eatfresh_Uploaded_File>;
  /** fetch aggregated fields from the table: "eatfresh.uploaded_file" */
  eatfresh_uploaded_file_aggregate: Eatfresh_Uploaded_File_Aggregate;
  /** fetch data from the table: "eatfresh.uploaded_file" using primary key columns */
  eatfresh_uploaded_file_by_pk?: Maybe<Eatfresh_Uploaded_File>;
  /** fetch data from the table in a streaming manner: "eatfresh.uploaded_file" */
  eatfresh_uploaded_file_stream: Array<Eatfresh_Uploaded_File>;
  /** fetch data from the table: "eatfresh.user_account" */
  eatfresh_user_account: Array<Eatfresh_User_Account>;
  /** fetch aggregated fields from the table: "eatfresh.user_account" */
  eatfresh_user_account_aggregate: Eatfresh_User_Account_Aggregate;
  /** fetch data from the table: "eatfresh.user_account" using primary key columns */
  eatfresh_user_account_by_pk?: Maybe<Eatfresh_User_Account>;
  /** fetch data from the table in a streaming manner: "eatfresh.user_account" */
  eatfresh_user_account_stream: Array<Eatfresh_User_Account>;
  /** fetch data from the table: "eatfresh.vat_category" */
  eatfresh_vat_category: Array<Eatfresh_Vat_Category>;
  /** fetch aggregated fields from the table: "eatfresh.vat_category" */
  eatfresh_vat_category_aggregate: Eatfresh_Vat_Category_Aggregate;
  /** fetch data from the table: "eatfresh.vat_category" using primary key columns */
  eatfresh_vat_category_by_pk?: Maybe<Eatfresh_Vat_Category>;
  /** fetch data from the table in a streaming manner: "eatfresh.vat_category" */
  eatfresh_vat_category_stream: Array<Eatfresh_Vat_Category>;
  /** fetch data from the table: "eatfresh.vitamin_mineral" */
  eatfresh_vitamin_mineral: Array<Eatfresh_Vitamin_Mineral>;
  /** fetch aggregated fields from the table: "eatfresh.vitamin_mineral" */
  eatfresh_vitamin_mineral_aggregate: Eatfresh_Vitamin_Mineral_Aggregate;
  /** fetch data from the table: "eatfresh.vitamin_mineral" using primary key columns */
  eatfresh_vitamin_mineral_by_pk?: Maybe<Eatfresh_Vitamin_Mineral>;
  /** fetch data from the table in a streaming manner: "eatfresh.vitamin_mineral" */
  eatfresh_vitamin_mineral_stream: Array<Eatfresh_Vitamin_Mineral>;
  /** fetch data from the table: "eatfresh.warehouse" */
  eatfresh_warehouse: Array<Eatfresh_Warehouse>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse" */
  eatfresh_warehouse_aggregate: Eatfresh_Warehouse_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_assignment" */
  eatfresh_warehouse_assignment: Array<Eatfresh_Warehouse_Assignment>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_assignment" */
  eatfresh_warehouse_assignment_aggregate: Eatfresh_Warehouse_Assignment_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_assignment" using primary key columns */
  eatfresh_warehouse_assignment_by_pk?: Maybe<Eatfresh_Warehouse_Assignment>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_assignment" */
  eatfresh_warehouse_assignment_stream: Array<Eatfresh_Warehouse_Assignment>;
  /** fetch data from the table: "eatfresh.warehouse" using primary key columns */
  eatfresh_warehouse_by_pk?: Maybe<Eatfresh_Warehouse>;
  /** fetch data from the table: "eatfresh.warehouse_order" */
  eatfresh_warehouse_order: Array<Eatfresh_Warehouse_Order>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order" */
  eatfresh_warehouse_order_aggregate: Eatfresh_Warehouse_Order_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order" using primary key columns */
  eatfresh_warehouse_order_by_pk?: Maybe<Eatfresh_Warehouse_Order>;
  /** fetch data from the table: "eatfresh.warehouse_order_position" */
  eatfresh_warehouse_order_position: Array<Eatfresh_Warehouse_Order_Position>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_position" */
  eatfresh_warehouse_order_position_aggregate: Eatfresh_Warehouse_Order_Position_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_position" using primary key columns */
  eatfresh_warehouse_order_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_order_position" */
  eatfresh_warehouse_order_position_stream: Array<Eatfresh_Warehouse_Order_Position>;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt" */
  eatfresh_warehouse_order_receipt: Array<Eatfresh_Warehouse_Order_Receipt>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_receipt" */
  eatfresh_warehouse_order_receipt_aggregate: Eatfresh_Warehouse_Order_Receipt_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt" using primary key columns */
  eatfresh_warehouse_order_receipt_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt>;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt_position" */
  eatfresh_warehouse_order_receipt_position: Array<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_receipt_position" */
  eatfresh_warehouse_order_receipt_position_aggregate: Eatfresh_Warehouse_Order_Receipt_Position_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_receipt_position" using primary key columns */
  eatfresh_warehouse_order_receipt_position_by_pk?: Maybe<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_order_receipt_position" */
  eatfresh_warehouse_order_receipt_position_stream: Array<Eatfresh_Warehouse_Order_Receipt_Position>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_order_receipt" */
  eatfresh_warehouse_order_receipt_stream: Array<Eatfresh_Warehouse_Order_Receipt>;
  /** fetch data from the table: "eatfresh.warehouse_order_status" */
  eatfresh_warehouse_order_status: Array<Eatfresh_Warehouse_Order_Status>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_status" */
  eatfresh_warehouse_order_status_aggregate: Eatfresh_Warehouse_Order_Status_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_status" using primary key columns */
  eatfresh_warehouse_order_status_by_pk?: Maybe<Eatfresh_Warehouse_Order_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_order_status" */
  eatfresh_warehouse_order_status_stream: Array<Eatfresh_Warehouse_Order_Status>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_order" */
  eatfresh_warehouse_order_stream: Array<Eatfresh_Warehouse_Order>;
  /** fetch data from the table: "eatfresh.warehouse_order_type" */
  eatfresh_warehouse_order_type: Array<Eatfresh_Warehouse_Order_Type>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_order_type" */
  eatfresh_warehouse_order_type_aggregate: Eatfresh_Warehouse_Order_Type_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_order_type" using primary key columns */
  eatfresh_warehouse_order_type_by_pk?: Maybe<Eatfresh_Warehouse_Order_Type>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_order_type" */
  eatfresh_warehouse_order_type_stream: Array<Eatfresh_Warehouse_Order_Type>;
  /** fetch data from the table: "eatfresh.warehouse_shelf" */
  eatfresh_warehouse_shelf: Array<Eatfresh_Warehouse_Shelf>;
  /** fetch aggregated fields from the table: "eatfresh.warehouse_shelf" */
  eatfresh_warehouse_shelf_aggregate: Eatfresh_Warehouse_Shelf_Aggregate;
  /** fetch data from the table: "eatfresh.warehouse_shelf" using primary key columns */
  eatfresh_warehouse_shelf_by_pk?: Maybe<Eatfresh_Warehouse_Shelf>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse_shelf" */
  eatfresh_warehouse_shelf_stream: Array<Eatfresh_Warehouse_Shelf>;
  /** fetch data from the table in a streaming manner: "eatfresh.warehouse" */
  eatfresh_warehouse_stream: Array<Eatfresh_Warehouse>;
};


export type Subscription_RootEatfresh_Age_VerificationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Age_Verification_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Age_Verification_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Age_Verification_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Age_Verification_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Age_Verification_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Age_Verification_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Age_Verification_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Age_Verification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Age_Verification_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Article_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Details_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Details_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Article_Details_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Article_Details_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Article_Details_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Labeling_ProcessArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Labeling_Process_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Labeling_Process_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Article_Labeling_Process_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Labeling_Process_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Article_Labeling_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Labeling_Process_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Article_Labeling_Process_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Article_Labeling_Process_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_Labeling_Process_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Article_Labeling_Process_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Article_Labeling_Process_Bool_Exp>;
};


export type Subscription_RootEatfresh_Article_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Article_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_PlacementArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Placement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Placement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Placement_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Placement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Asset_Placement_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Asset_Placement_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Asset_Placement_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_TransferArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Asset_Transfer_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_SeverityArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_Severity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Severity_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_Severity_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_Severity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Severity_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Asset_Transfer_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_Problem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Asset_Transfer_Problem_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Asset_Transfer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Asset_Transfer_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Asset_Transfer_Bool_Exp>;
};


export type Subscription_RootEatfresh_Auth_TokenArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Auth_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Auth_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Auth_Token_Bool_Exp>;
};


export type Subscription_RootEatfresh_Auth_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Auth_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Auth_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Auth_Token_Bool_Exp>;
};


export type Subscription_RootEatfresh_Auth_Token_By_PkArgs = {
  key: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Auth_Token_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Auth_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Auth_Token_Bool_Exp>;
};


export type Subscription_RootEatfresh_AuthenticatorsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Authenticators_Order_By>>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};


export type Subscription_RootEatfresh_Authenticators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Authenticators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Authenticators_Order_By>>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};


export type Subscription_RootEatfresh_Authenticators_By_PkArgs = {
  credentialid: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Authenticators_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Authenticators_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Authenticators_Bool_Exp>;
};


export type Subscription_RootEatfresh_B2b_CustomerArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
};


export type Subscription_RootEatfresh_B2b_Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
};


export type Subscription_RootEatfresh_B2b_Customer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_B2b_Customer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_B2b_Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
};


export type Subscription_RootEatfresh_B2b_Customer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_B2b_Customer_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_B2b_Customer_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_B2b_Customer_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_B2b_Customer_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Basic_User_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Basic_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Basic_User_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Basic_User_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Basic_User_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Basic_User_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Basic_User_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Basic_User_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Basic_User_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Basic_User_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_PlanArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Box_Content_Plan_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_Plan_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_Plan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_Plan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Box_Content_Plan_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Box_Content_Plan_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_Plan_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Box_Content_Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Box_Content_Plan_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_To_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_To_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Box_Content_To_Article_Order_By>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


export type Subscription_RootEatfresh_Box_Content_To_Article_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Box_Content_To_Article_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Box_Content_To_Article_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Box_Content_To_Article_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_ProcessArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Commissioning_Process_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Commissioning_Process_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Commissioning_Process_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Commissioning_Process_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Commissioning_Process_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Commissioning_Process_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Commissioning_Process_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Commissioning_Process_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Commissioning_Process_Bool_Exp>;
};


export type Subscription_RootEatfresh_Computop_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Computop_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Computop_Transaction_Order_By>>;
  where?: InputMaybe<Eatfresh_Computop_Transaction_Bool_Exp>;
};


export type Subscription_RootEatfresh_Computop_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Computop_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Computop_Transaction_Order_By>>;
  where?: InputMaybe<Eatfresh_Computop_Transaction_Bool_Exp>;
};


export type Subscription_RootEatfresh_Computop_Transaction_By_PkArgs = {
  trans_id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Computop_Transaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Computop_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Computop_Transaction_Bool_Exp>;
};


export type Subscription_RootEatfresh_Connection_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Connection_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Connection_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Connection_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Connection_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Connection_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Connection_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Connection_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Connection_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Connection_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Cost_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
};


export type Subscription_RootEatfresh_Cost_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
};


export type Subscription_RootEatfresh_Cost_Configuration_KeyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
};


export type Subscription_RootEatfresh_Cost_Configuration_Key_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Cost_Configuration_Key_Order_By>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
};


export type Subscription_RootEatfresh_Cost_Configuration_Key_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Cost_Configuration_Key_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Cost_Configuration_Key_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Key_Bool_Exp>;
};


export type Subscription_RootEatfresh_Cost_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Cost_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Cost_Configuration_Bool_Exp>;
};


export type Subscription_RootEatfresh_CustomerArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
};


export type Subscription_RootEatfresh_Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
};


export type Subscription_RootEatfresh_Customer_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Customer_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Customer_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Customer_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Customer_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Customer_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Customer_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Customer_Bool_Exp>;
};


export type Subscription_RootEatfresh_Door_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Door_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Door_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Door_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Door_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Door_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Door_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Door_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Door_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Door_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Easy_Refill_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


export type Subscription_RootEatfresh_Easy_Refill_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


export type Subscription_RootEatfresh_Easy_Refill_Permission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Easy_Refill_Permission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Easy_Refill_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Easy_Refill_Permission_Bool_Exp>;
};


export type Subscription_RootEatfresh_External_Warehouse_Pallet_SpotArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


export type Subscription_RootEatfresh_External_Warehouse_Pallet_Spot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_External_Warehouse_Pallet_Spot_Order_By>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


export type Subscription_RootEatfresh_External_Warehouse_Pallet_Spot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_External_Warehouse_Pallet_Spot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_External_Warehouse_Pallet_Spot_Bool_Exp>;
};


export type Subscription_RootEatfresh_Flyway_Schema_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Flyway_Schema_History_Bool_Exp>;
};


export type Subscription_RootEatfresh_Flyway_Schema_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Flyway_Schema_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Flyway_Schema_History_Bool_Exp>;
};


export type Subscription_RootEatfresh_Flyway_Schema_History_By_PkArgs = {
  installed_rank: Scalars['Int']['input'];
};


export type Subscription_RootEatfresh_Flyway_Schema_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Flyway_Schema_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Flyway_Schema_History_Bool_Exp>;
};


export type Subscription_RootEatfresh_FridgeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Active_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Active_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Active_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Active_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Active_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Active_Daily_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Active_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Active_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_AlarmArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Alarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Alarm_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Alarm_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Alarm_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Alarm_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Alarm_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_StockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_Daily_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_Enabled_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_Snapshot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Snapshot_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Article_Stock_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Article_Stock_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Article_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_EventArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Event_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Event_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Fridge_Event_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Event_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_LayoutArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Layout_Assignment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Assignment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Assignment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Fridge_Layout_Assignment_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Assignment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Layout_Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Assignment_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Layout_LevelArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Level_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Layout_Level_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Level_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Level_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Level_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Layout_Level_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_Level_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Layout_Level_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Level_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Layout_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Layout_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Status_History_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Status_History_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Status_History_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Status_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Status_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Status_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Status_History_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_StockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Stock_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Stock_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stocked_Enabled_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stocked_Enabled_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stocked_Enabled_Daily_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stocked_Enabled_Per_Place_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Target_StockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Target_Stock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Target_Stock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Target_Stock_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Target_Stock_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Target_Stock_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Target_Stock_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Fridge_Target_Stock_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Target_Stock_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Target_Stock_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Target_Stock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Fridge_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Fridge_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Fridge_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Fridge_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Fridge_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Logistics_Problem_ImageArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Image_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_Image_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Logistics_Problem_Image_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Logistics_Problem_Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Image_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Problem_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Logistics_Problem_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Logistics_Problem_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Problem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Logistics_Problem_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Logistics_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Process_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Process_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Logistics_Process_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Logistics_Process_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Logistics_Process_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Logistics_Process_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Logistics_Process_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Nutrition_InformationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Nutrition_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Nutrition_Information_Order_By>>;
  where?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
};


export type Subscription_RootEatfresh_Nutrition_Information_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Nutrition_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Nutrition_Information_Order_By>>;
  where?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
};


export type Subscription_RootEatfresh_Nutrition_Information_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Nutrition_Information_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Nutrition_Information_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Nutrition_Information_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_ExtraArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Extra_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Extra_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Order_Extra_Customer_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Extra_Customer_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Extra_Customer_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Extra_Customer_Order_By_PkArgs = {
  customer_order_id: Scalars['uuid']['input'];
  order_extra_id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Order_Extra_Customer_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Order_Extra_Customer_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Customer_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Extra_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Order_Extra_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Order_Extra_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Order_Position_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Position_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Position_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Position_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Position_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Order_Position_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Order_Position_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Order_Position_Category_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Order_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Order_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Order_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Order_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Order_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Order_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Packaging_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Packaging_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Packaging_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Packaging_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Packaging_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Packaging_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Packaging_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Packaging_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Packaging_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Packaging_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Password_Reset_TokenArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


export type Subscription_RootEatfresh_Password_Reset_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Password_Reset_Token_Order_By>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


export type Subscription_RootEatfresh_Password_Reset_Token_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Password_Reset_Token_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Password_Reset_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Password_Reset_Token_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_Method_By_PkArgs = {
  trans_id: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Payment_Method_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Payment_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_Method_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_Method_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Method_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_Method_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Payment_Method_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Payment_Method_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Payment_Method_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Payment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Payment_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Payment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Payment_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Payment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Payment_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_PlaceArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Place_Order_By>>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};


export type Subscription_RootEatfresh_Place_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Place_Order_By>>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};


export type Subscription_RootEatfresh_Place_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Place_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Place_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Place_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Price_Change_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Price_Change_Position_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_Position_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Change_Position_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_Position_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Price_Change_Position_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Price_Change_Position_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Price_Change_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Price_Change_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Change_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Price_Change_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Price_Change_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_LockArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Lock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Price_Lock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Price_Lock_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Price_Lock_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Price_Lock_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
};


export type Subscription_RootEatfresh_Product_OrientationArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Product_Orientation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Product_Orientation_Order_By>>;
  where?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
};


export type Subscription_RootEatfresh_Product_Orientation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Product_Orientation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Product_Orientation_Order_By>>;
  where?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
};


export type Subscription_RootEatfresh_Product_Orientation_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Product_Orientation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Product_Orientation_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Product_Orientation_Bool_Exp>;
};


export type Subscription_RootEatfresh_RefillArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


export type Subscription_RootEatfresh_Refill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


export type Subscription_RootEatfresh_Refill_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Refill_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Refill_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Refill_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Refill_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Refill_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Refill_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Refill_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Refill_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Refill_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Refill_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Refill_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_AssetArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Asset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Asset_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Rfid_Asset_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Asset_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Asset_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Asset_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Asset_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Asset_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Rfid_Asset_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Asset_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Asset_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_BoxArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Box_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Box_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Rfid_Box_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Box_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Box_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Box_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Box_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Box_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Rfid_Box_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Box_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Box_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_ScanArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Rfid_Scan_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scan_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scan_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Rfid_Scan_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Scan_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scan_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Scan_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Scan_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_ScannerArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scanner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scanner_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Rfid_Scanner_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Scanner_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scanner_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scanner_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Scanner_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Scanner_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Rfid_Scanner_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Scanner_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Rfid_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_TagArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Tag_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Rfid_Tag_Sales_DailyArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Tag_Sales_Daily_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Rfid_Tag_Sales_Daily_Order_By>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Tag_Sales_Daily_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Tag_Sales_Daily_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp>;
};


export type Subscription_RootEatfresh_Rfid_Tag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Rfid_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Rfid_Tag_Bool_Exp>;
};


export type Subscription_RootEatfresh_Selfly_Cabinet_StateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Order_By>>;
  where?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
};


export type Subscription_RootEatfresh_Selfly_Cabinet_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Selfly_Cabinet_State_Order_By>>;
  where?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
};


export type Subscription_RootEatfresh_Selfly_Cabinet_State_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Selfly_Cabinet_State_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Selfly_Cabinet_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Selfly_Cabinet_State_Bool_Exp>;
};


export type Subscription_RootEatfresh_Session_StepArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Session_Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Session_Step_Order_By>>;
  where?: InputMaybe<Eatfresh_Session_Step_Bool_Exp>;
};


export type Subscription_RootEatfresh_Session_Step_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Session_Step_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Session_Step_Order_By>>;
  where?: InputMaybe<Eatfresh_Session_Step_Bool_Exp>;
};


export type Subscription_RootEatfresh_Session_Step_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Session_Step_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Session_Step_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Session_Step_Bool_Exp>;
};


export type Subscription_RootEatfresh_Shelf_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Shelf_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Shelf_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Shelf_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Shelf_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Shelf_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Shelf_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Shelf_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Shelf_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Shelf_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Sold_Item_CostArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Order_By>>;
  where?: InputMaybe<Eatfresh_Sold_Item_Cost_Bool_Exp>;
};


export type Subscription_RootEatfresh_Sold_Item_Cost_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Sold_Item_Cost_Order_By>>;
  where?: InputMaybe<Eatfresh_Sold_Item_Cost_Bool_Exp>;
};


export type Subscription_RootEatfresh_Sold_Item_Cost_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Sold_Item_Cost_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Sold_Item_Cost_Bool_Exp>;
};


export type Subscription_RootEatfresh_Supplier_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Supplier_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Supplier_Problem_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Supplier_Problem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Supplier_Problem_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_Bool_Exp>;
};


export type Subscription_RootEatfresh_Supplier_Problem_To_FileArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};


export type Subscription_RootEatfresh_Supplier_Problem_To_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Supplier_Problem_To_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};


export type Subscription_RootEatfresh_Supplier_Problem_To_File_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Supplier_Problem_To_File_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Supplier_Problem_To_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Supplier_Problem_To_File_Bool_Exp>;
};


export type Subscription_RootEatfresh_Transaction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootEatfresh_Transaction_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Transaction_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Transaction_Logs_Order_By>>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootEatfresh_Transaction_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Transaction_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Transaction_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Transaction_Logs_Bool_Exp>;
};


export type Subscription_RootEatfresh_Uploaded_FileArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Uploaded_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};


export type Subscription_RootEatfresh_Uploaded_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Uploaded_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Uploaded_File_Order_By>>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};


export type Subscription_RootEatfresh_Uploaded_File_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Uploaded_File_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Uploaded_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Uploaded_File_Bool_Exp>;
};


export type Subscription_RootEatfresh_User_AccountArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};


export type Subscription_RootEatfresh_User_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_User_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};


export type Subscription_RootEatfresh_User_Account_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_User_Account_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_User_Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
};


export type Subscription_RootEatfresh_Vat_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vat_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vat_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
};


export type Subscription_RootEatfresh_Vat_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vat_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vat_Category_Order_By>>;
  where?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
};


export type Subscription_RootEatfresh_Vat_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Vat_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Vat_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
};


export type Subscription_RootEatfresh_Vitamin_MineralArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Order_By>>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};


export type Subscription_RootEatfresh_Vitamin_Mineral_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Vitamin_Mineral_Order_By>>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};


export type Subscription_RootEatfresh_Vitamin_Mineral_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Vitamin_Mineral_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Vitamin_Mineral_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Vitamin_Mineral_Bool_Exp>;
};


export type Subscription_RootEatfresh_WarehouseArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Assignment_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Assignment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Assignment_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Warehouse_OrderArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Order_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Order_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Order_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_ReceiptArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Receipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Receipt_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Order_Receipt_PositionArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Receipt_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Receipt_Position_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Receipt_Position_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Order_Receipt_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Receipt_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Order_Receipt_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Receipt_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_StatusArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Status_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Order_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Order_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Status_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_TypeArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Order_Type_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Order_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Order_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Order_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Order_Type_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_ShelfArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Shelf_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Warehouse_Shelf_Order_By>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_Shelf_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEatfresh_Warehouse_Shelf_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Shelf_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Shelf_Bool_Exp>;
};


export type Subscription_RootEatfresh_Warehouse_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Eatfresh_Warehouse_Stream_Cursor_Input>>;
  where?: InputMaybe<Eatfresh_Warehouse_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type FridgeEventsSubscriptionVariables = Exact<{
  fridgeId: Scalars['uuid']['input'];
  after?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type FridgeEventsSubscription = { __typename?: 'subscription_root', eatfresh_fridge_event: Array<{ __typename?: 'eatfresh_fridge_event', id: string, fridge_id?: string | null, event_type: Eatfresh_Fridge_Event_Type_Enum, item_id?: string | null, order_id?: string | null, updated: string, created: string }> };

export type MockUnstoredRfidsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MockUnstoredRfidsQueryQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', name: string, id: string, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', rfid_number?: string | null, id: string, article_id?: string | null, best_before_date: string, rfid_status: Eatfresh_Rfid_Status_Enum, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', epc: string } | null }> }> };

export type MockFridgeCatalogArticlesQueryVariables = Exact<{
  names: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MockFridgeCatalogArticlesQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, name: string }> };

export type KpiRfidCostAggregateQueryVariables = Exact<{
  where: Eatfresh_Rfid_Tag_Bool_Exp;
}>;


export type KpiRfidCostAggregateQuery = { __typename?: 'query_root', eatfresh_rfid_tag_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', sum?: { __typename?: 'eatfresh_rfid_tag_sum_fields', purchase_price?: number | null, labeling_cost_attribution?: number | null, commissioning_cost_attribution?: number | null, warehouse_order_cost_attribution?: number | null, warehouse_order_receipt_cost_attribution?: number | null, payment_cost_attribution?: number | null, delivery_cost_attribution?: number | null } | null } | null } };

export type CustomersOrdersQueryVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type CustomersOrdersQuery = { __typename?: 'query_root', eatfresh_customer_order: Array<{ __typename?: 'eatfresh_customer_order', created: string, user_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, payment_method?: string | null, paymentMethodByTransId?: { __typename?: 'eatfresh_payment_method', payment_method_type: Eatfresh_Payment_Method_Type_Enum } | null }> };

export type CustomersRegistrationsQueryVariables = Exact<{
  where: Eatfresh_User_Account_Bool_Exp;
}>;


export type CustomersRegistrationsQuery = { __typename?: 'query_root', eatfresh_user_account: Array<{ __typename?: 'eatfresh_user_account', created: string }> };

export type CustomersOrdersCountQueryVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type CustomersOrdersCountQuery = { __typename?: 'query_root', eatfresh_customer_order_aggregate: { __typename?: 'eatfresh_customer_order_aggregate', aggregate?: { __typename?: 'eatfresh_customer_order_aggregate_fields', count: number } | null } };

export type CustomersRegCountQueryVariables = Exact<{
  where: Eatfresh_User_Account_Bool_Exp;
}>;


export type CustomersRegCountQuery = { __typename?: 'query_root', eatfresh_user_account_aggregate: { __typename?: 'eatfresh_user_account_aggregate', aggregate?: { __typename?: 'eatfresh_user_account_aggregate_fields', count: number } | null } };

export type CustomersActiveUsersQueryVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type CustomersActiveUsersQuery = { __typename?: 'query_root', eatfresh_customer_order_aggregate: { __typename?: 'eatfresh_customer_order_aggregate', aggregate?: { __typename?: 'eatfresh_customer_order_aggregate_fields', count: number } | null } };

export type KpiLocationCostRowsQueryVariables = Exact<{
  where: Eatfresh_Sold_Item_Cost_Bool_Exp;
}>;


export type KpiLocationCostRowsQuery = { __typename?: 'query_root', eatfresh_sold_item_cost: Array<{ __typename?: 'eatfresh_sold_item_cost', given_id?: string | null, cost_cents?: number | null }> };

export type KpiLocationUnitRowsQueryVariables = Exact<{
  where: Eatfresh_Order_Position_Bool_Exp;
}>;


export type KpiLocationUnitRowsQuery = { __typename?: 'query_root', eatfresh_order_position: Array<{ __typename?: 'eatfresh_order_position', quantity?: number | null, customer_order: { __typename?: 'eatfresh_customer_order', given_id?: string | null } }> };

export type KpiEmptyShelfSnapshotQueryVariables = Exact<{
  where: Eatfresh_Fridge_Article_Stock_Snapshot_Enabled_Daily_Bool_Exp;
}>;


export type KpiEmptyShelfSnapshotQuery = { __typename?: 'query_root', eatfresh_fridge_article_stock_snapshot_enabled_daily: Array<{ __typename?: 'eatfresh_fridge_article_stock_snapshot_enabled_daily', snapshot_day?: string | null, empty_count?: number | null, total_count?: number | null }> };

export type KpiOverviewCostRatioQueryVariables = Exact<{
  where: Eatfresh_Rfid_Tag_Bool_Exp;
}>;


export type KpiOverviewCostRatioQuery = { __typename?: 'query_root', eatfresh_rfid_tag_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', sum?: { __typename?: 'eatfresh_rfid_tag_sum_fields', purchase_price?: number | null, labeling_cost_attribution?: number | null, commissioning_cost_attribution?: number | null, warehouse_order_cost_attribution?: number | null, warehouse_order_receipt_cost_attribution?: number | null, payment_cost_attribution?: number | null, delivery_cost_attribution?: number | null } | null } | null } };

export type KpiOverviewCostRatioRowsQueryVariables = Exact<{
  where: Eatfresh_Rfid_Tag_Bool_Exp;
}>;


export type KpiOverviewCostRatioRowsQuery = { __typename?: 'query_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', sold_at?: string | null, purchase_price: number, labeling_cost_attribution: number, commissioning_cost_attribution: number, warehouse_order_cost_attribution: number, warehouse_order_receipt_cost_attribution: number, payment_cost_attribution: number, delivery_cost_attribution: number }> };

export type KpiProductSoldItemsQueryVariables = Exact<{
  where: Eatfresh_Sold_Item_Cost_Bool_Exp;
}>;


export type KpiProductSoldItemsQuery = { __typename?: 'query_root', eatfresh_sold_item_cost: Array<{ __typename?: 'eatfresh_sold_item_cost', article_id?: string | null, article_name?: string | null, ean?: string | null, revenue_cents?: number | null, cost_cents?: number | null, created?: string | null }> };

export type KpiProductLocationsStockingQueryVariables = Exact<{
  where: Eatfresh_Fridge_Target_Stock_Position_Bool_Exp;
}>;


export type KpiProductLocationsStockingQuery = { __typename?: 'query_root', eatfresh_fridge_target_stock_position: Array<{ __typename?: 'eatfresh_fridge_target_stock_position', article_id: string, fridge_target_stock: { __typename?: 'eatfresh_fridge_target_stock', fridge: { __typename?: 'eatfresh_fridge', place_id: string } } }> };

export type KpiProductFridgeCountQueryVariables = Exact<{
  where: Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp;
}>;


export type KpiProductFridgeCountQuery = { __typename?: 'query_root', eatfresh_fridge_stocked_enabled_daily: Array<{ __typename?: 'eatfresh_fridge_stocked_enabled_daily', day?: string | null, article_id?: string | null, enabled_fridge_count?: number | null }> };

export type KpiProductUnitsByEanQueryVariables = Exact<{
  where: Eatfresh_Order_Position_Bool_Exp;
}>;


export type KpiProductUnitsByEanQuery = { __typename?: 'query_root', eatfresh_order_position_aggregate: { __typename?: 'eatfresh_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_order_position_aggregate_fields', sum?: { __typename?: 'eatfresh_order_position_sum_fields', quantity?: number | null } | null } | null } };

export type MonitoringCheckoutFailuresQueryVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type MonitoringCheckoutFailuresQuery = { __typename?: 'query_root', eatfresh_customer_order: Array<{ __typename?: 'eatfresh_customer_order', id: string, created: string, order_status: Eatfresh_Order_Status_Enum, given_id?: string | null, location?: string | null }> };

export type KpiPulseFridgesQueryVariables = Exact<{
  where: Eatfresh_Fridge_Bool_Exp;
}>;


export type KpiPulseFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', given_id: string, place: { __typename?: 'eatfresh_place', id: string, name: string } }> };

export type KpiOrdersAggregateQueryVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type KpiOrdersAggregateQuery = { __typename?: 'query_root', eatfresh_customer_order_aggregate: { __typename?: 'eatfresh_customer_order_aggregate', aggregate?: { __typename?: 'eatfresh_customer_order_aggregate_fields', count: number, sum?: { __typename?: 'eatfresh_customer_order_sum_fields', total_sum?: number | null } | null } | null } };

export type KpiRevenueByDayQueryVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type KpiRevenueByDayQuery = { __typename?: 'query_root', eatfresh_customer_order: Array<{ __typename?: 'eatfresh_customer_order', created: string, given_id?: string | null, total_sum: number }> };

export type KpiPulseFridgeActiveDailyQueryVariables = Exact<{
  where: Eatfresh_Fridge_Active_Daily_Bool_Exp;
}>;


export type KpiPulseFridgeActiveDailyQuery = { __typename?: 'query_root', eatfresh_fridge_active_daily: Array<{ __typename?: 'eatfresh_fridge_active_daily', day?: string | null, active_count?: number | null }> };

export type KpiPulseFridgePerPlaceDailyQueryVariables = Exact<{
  where: Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp;
}>;


export type KpiPulseFridgePerPlaceDailyQuery = { __typename?: 'query_root', eatfresh_fridge_stocked_enabled_per_place_daily: Array<{ __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily', day?: string | null, place_id?: string | null, enabled_fridge_count?: number | null }> };

export type KpiPositionsAggregateQueryVariables = Exact<{
  where: Eatfresh_Order_Position_Bool_Exp;
}>;


export type KpiPositionsAggregateQuery = { __typename?: 'query_root', eatfresh_order_position_aggregate: { __typename?: 'eatfresh_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_order_position_aggregate_fields', sum?: { __typename?: 'eatfresh_order_position_sum_fields', quantity?: number | null } | null } | null } };

export type KpiTopSellerPositionsQueryVariables = Exact<{
  where: Eatfresh_Order_Position_Bool_Exp;
}>;


export type KpiTopSellerPositionsQuery = { __typename?: 'query_root', eatfresh_order_position: Array<{ __typename?: 'eatfresh_order_position', article_name: string, ean?: string | null, quantity?: number | null, gross_sales_price?: number | null }> };

export type KpiPulseMarginAggregateQueryVariables = Exact<{
  where: Eatfresh_Sold_Item_Cost_Bool_Exp;
}>;


export type KpiPulseMarginAggregateQuery = { __typename?: 'query_root', eatfresh_sold_item_cost_aggregate: { __typename?: 'eatfresh_sold_item_cost_aggregate', aggregate?: { __typename?: 'eatfresh_sold_item_cost_aggregate_fields', count: number, sum?: { __typename?: 'eatfresh_sold_item_cost_sum_fields', cost_cents?: number | null } | null } | null } };

export type KpiPulseUnitsByDayQueryVariables = Exact<{
  where: Eatfresh_Order_Position_Bool_Exp;
}>;


export type KpiPulseUnitsByDayQuery = { __typename?: 'query_root', eatfresh_order_position: Array<{ __typename?: 'eatfresh_order_position', quantity?: number | null, customer_order: { __typename?: 'eatfresh_customer_order', created: string } }> };

export type KpiPulseNewCustomersByDayQueryVariables = Exact<{
  where: Eatfresh_Payment_Method_Bool_Exp;
}>;


export type KpiPulseNewCustomersByDayQuery = { __typename?: 'query_root', eatfresh_payment_method: Array<{ __typename?: 'eatfresh_payment_method', created_at?: string | null }> };

export type KpiPulseMarginByDayQueryVariables = Exact<{
  where: Eatfresh_Sold_Item_Cost_Bool_Exp;
}>;


export type KpiPulseMarginByDayQuery = { __typename?: 'query_root', eatfresh_sold_item_cost: Array<{ __typename?: 'eatfresh_sold_item_cost', created?: string | null, cost_cents?: number | null }> };

export type FridgeLayoutKpiGlobalFridgesQueryVariables = Exact<{ [key: string]: never; }>;


export type FridgeLayoutKpiGlobalFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', given_id: string }> };

export type FridgeLayoutKpiOrderPositionsQueryVariables = Exact<{
  where: Eatfresh_Order_Position_Bool_Exp;
}>;


export type FridgeLayoutKpiOrderPositionsQuery = { __typename?: 'query_root', eatfresh_order_position: Array<{ __typename?: 'eatfresh_order_position', ean?: string | null, quantity?: number | null }> };

export type FridgeLayoutKpiSoldItemsQueryVariables = Exact<{
  where: Eatfresh_Sold_Item_Cost_Bool_Exp;
}>;


export type FridgeLayoutKpiSoldItemsQuery = { __typename?: 'query_root', eatfresh_sold_item_cost: Array<{ __typename?: 'eatfresh_sold_item_cost', article_id?: string | null, ean?: string | null, revenue_cents?: number | null, cost_cents?: number | null }> };

export type FridgeLayoutKpiProductFridgeCountsQueryVariables = Exact<{
  where: Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp;
}>;


export type FridgeLayoutKpiProductFridgeCountsQuery = { __typename?: 'query_root', eatfresh_fridge_stocked_enabled_daily: Array<{ __typename?: 'eatfresh_fridge_stocked_enabled_daily', day?: string | null, article_id?: string | null, enabled_fridge_count?: number | null }> };

export type ArticleSalesQueryVariables = Exact<{
  where: Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp;
}>;


export type ArticleSalesQuery = { __typename?: 'query_root', eatfresh_rfid_tag_sales_daily: Array<{ __typename?: 'eatfresh_rfid_tag_sales_daily', article_id?: string | null, sale_count?: number | null }> };

export type FridgeByArticleQueryVariables = Exact<{
  where: Eatfresh_Fridge_Stocked_Enabled_Daily_Bool_Exp;
}>;


export type FridgeByArticleQuery = { __typename?: 'query_root', eatfresh_fridge_stocked_enabled_daily: Array<{ __typename?: 'eatfresh_fridge_stocked_enabled_daily', day?: string | null, article_id?: string | null, enabled_fridge_count?: number | null }> };

export type KpiFridgeStockedEnabledPerPlaceDailyQueryVariables = Exact<{
  where: Eatfresh_Fridge_Stocked_Enabled_Per_Place_Daily_Bool_Exp;
}>;


export type KpiFridgeStockedEnabledPerPlaceDailyQuery = { __typename?: 'query_root', eatfresh_fridge_stocked_enabled_per_place_daily: Array<{ __typename?: 'eatfresh_fridge_stocked_enabled_per_place_daily', day?: string | null, place_id?: string | null, enabled_fridge_count?: number | null }> };

export type KpiFridgeActiveDailyQueryVariables = Exact<{
  where: Eatfresh_Fridge_Active_Daily_Bool_Exp;
}>;


export type KpiFridgeActiveDailyQuery = { __typename?: 'query_root', eatfresh_fridge_active_daily: Array<{ __typename?: 'eatfresh_fridge_active_daily', day?: string | null, active_count?: number | null }> };

export type KpiSalesDailyAggregateQueryVariables = Exact<{
  where: Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp;
}>;


export type KpiSalesDailyAggregateQuery = { __typename?: 'query_root', eatfresh_rfid_tag_sales_daily_aggregate: { __typename?: 'eatfresh_rfid_tag_sales_daily_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_sales_daily_aggregate_fields', sum?: { __typename?: 'eatfresh_rfid_tag_sales_daily_sum_fields', sale_count?: number | null } | null } | null } };

export type KpiSalesDailyQueryVariables = Exact<{
  where: Eatfresh_Rfid_Tag_Sales_Daily_Bool_Exp;
}>;


export type KpiSalesDailyQuery = { __typename?: 'query_root', eatfresh_rfid_tag_sales_daily: Array<{ __typename?: 'eatfresh_rfid_tag_sales_daily', sale_day?: string | null, sale_count?: number | null }> };

export type B2bWarehouseOrderFragment = { __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, b2b_customer_id?: string | null, shipped_at?: string | null, logistics_order_id?: string | null, created_at: any, updated_at: any };

export type B2bPlaceFragment = { __typename?: 'eatfresh_place', id: string, name: string, latitude: number, longitude: number, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null };

export type B2bWarehouseFragment = { __typename?: 'eatfresh_warehouse', id: string, name: string, external: boolean, b2b_customer_id?: string | null, place_id: string, created_at: any, updated_at: any, place: { __typename?: 'eatfresh_place', id: string, name: string, latitude: number, longitude: number, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null }, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null };

export type B2bUserAccountFragment = { __typename?: 'eatfresh_user_account', id: string, email?: string | null, first_name?: string | null, last_name?: string | null, basic_user_type: Eatfresh_Basic_User_Type_Enum, b2b_customer_id?: string | null, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null };

export type B2bMyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type B2bMyAccountQuery = { __typename?: 'query_root', eatfresh_user_account: Array<{ __typename?: 'eatfresh_user_account', id: string, email?: string | null, first_name?: string | null, last_name?: string | null, basic_user_type: Eatfresh_Basic_User_Type_Enum, b2b_customer_id?: string | null, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null }>, primary_location: Array<{ __typename?: 'eatfresh_warehouse', id: string, name: string, place: { __typename?: 'eatfresh_place', id: string, city: string } }> };

export type B2bOrderByIdQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
  customerId: Scalars['uuid']['input'];
}>;


export type B2bOrderByIdQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, created_at: any, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string, place: { __typename?: 'eatfresh_place', city: string } }, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', id: string, article_id?: string | null, packaging_units?: number | null, total_articles: number, article?: { __typename?: 'eatfresh_article', id: string, name: string, article_detail?: { __typename?: 'eatfresh_article_details', wholesale_price?: number | null, deposit_value_single_item?: number | null, items_per_package_unit?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', rate: number } } | null } | null }> }> };

export type B2bOrderReviewQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
  warehouseId: Scalars['uuid']['input'];
}>;


export type B2bOrderReviewQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, created_at: any, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string, place: { __typename?: 'eatfresh_place', city: string } }, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', id: string, article_id?: string | null, packaging_units?: number | null, total_articles: number, article?: { __typename?: 'eatfresh_article', id: string, name: string, article_detail?: { __typename?: 'eatfresh_article_details', wholesale_price?: number | null, items_per_package_unit?: number | null } | null } | null }> }> };

export type B2bActiveDraftWarehouseQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
}>;


export type B2bActiveDraftWarehouseQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, warehouse_id: string }> };

export type B2bHomeStatsQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
}>;


export type B2bHomeStatsQuery = { __typename?: 'query_root', open_orders: { __typename?: 'eatfresh_warehouse_order_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_aggregate_fields', count: number } | null }, delivered_recent: { __typename?: 'eatfresh_warehouse_order_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_aggregate_fields', count: number } | null }, locations: { __typename?: 'eatfresh_warehouse_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_aggregate_fields', count: number } | null }, articles_count: { __typename?: 'eatfresh_article_aggregate', aggregate?: { __typename?: 'eatfresh_article_aggregate_fields', count: number } | null }, open_draft: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, b2b_customer_id?: string | null, shipped_at?: string | null, logistics_order_id?: string | null, created_at: any, updated_at: any, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string }, warehouse_order_positions_aggregate: { __typename?: 'eatfresh_warehouse_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_position_aggregate_fields', sum?: { __typename?: 'eatfresh_warehouse_order_position_sum_fields', packaging_units?: number | null } | null } | null } }>, recent_orders: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, b2b_customer_id?: string | null, shipped_at?: string | null, logistics_order_id?: string | null, created_at: any, updated_at: any, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string }, warehouse_order_positions_aggregate: { __typename?: 'eatfresh_warehouse_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_position_aggregate_fields', sum?: { __typename?: 'eatfresh_warehouse_order_position_sum_fields', packaging_units?: number | null } | null } | null } }> };

export type B2bOrdersQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type B2bOrdersQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, b2b_customer_id?: string | null, shipped_at?: string | null, logistics_order_id?: string | null, created_at: any, updated_at: any, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string, place: { __typename?: 'eatfresh_place', city: string } }, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', article_id?: string | null, packaging_units?: number | null, total_articles: number, article?: { __typename?: 'eatfresh_article', id: string, name: string, article_detail?: { __typename?: 'eatfresh_article_details', wholesale_price?: number | null, deposit_value_single_item?: number | null, items_per_package_unit?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', rate: number } } | null } | null }> }>, eatfresh_warehouse_order_aggregate: { __typename?: 'eatfresh_warehouse_order_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_aggregate_fields', count: number } | null } };

export type B2bArticlesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: Eatfresh_Article_Bool_Exp;
}>;


export type B2bArticlesQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, name: string, ean: string, description?: string | null, manufacturer?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_category?: string | null, items_per_package_unit?: number | null, wholesale_price?: number | null, remaining_shelf_life?: number | null, net_fill_volume?: number | null, net_weight?: number | null, deposit_value_single_item?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', rate: number } } | null }>, eatfresh_article_aggregate: { __typename?: 'eatfresh_article_aggregate', aggregate?: { __typename?: 'eatfresh_article_aggregate_fields', count: number } | null } };

export type B2bArticlesByEansQueryVariables = Exact<{
  eans: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type B2bArticlesByEansQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, name: string, ean: string, article_detail?: { __typename?: 'eatfresh_article_details', items_per_package_unit?: number | null, wholesale_price?: number | null, deposit_value_single_item?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', rate: number } } | null }> };

export type B2bDraftOrderDetailQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
  warehouseId: Scalars['uuid']['input'];
}>;


export type B2bDraftOrderDetailQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, warehouse_id: string, b2b_customer_id?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', id: string, article_id?: string | null, packaging_units?: number | null, total_articles: number, article?: { __typename?: 'eatfresh_article', id: string, name: string, article_detail?: { __typename?: 'eatfresh_article_details', wholesale_price?: number | null, deposit_value_single_item?: number | null, items_per_package_unit?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', rate: number } } | null } | null }> }> };

export type B2bLocationsQueryVariables = Exact<{
  customerId: Scalars['uuid']['input'];
}>;


export type B2bLocationsQuery = { __typename?: 'query_root', eatfresh_warehouse: Array<{ __typename?: 'eatfresh_warehouse', id: string, name: string, external: boolean, b2b_customer_id?: string | null, place_id: string, created_at: any, updated_at: any, place: { __typename?: 'eatfresh_place', id: string, name: string, latitude: number, longitude: number, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null }, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null }> };

export type UserFragmentFragment = { __typename?: 'eatfresh_user_account', active?: boolean | null, basic_user_type: Eatfresh_Basic_User_Type_Enum, created: string, email?: string | null, first_name?: string | null, last_name?: string | null, id: string, last_login?: string | null, requires_password_change?: boolean | null, updated: string, agb_accepted: boolean, stripe_customer_id?: string | null, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null };

export type UserFragmentAnonymousFragment = { __typename?: 'eatfresh_user_account', email?: string | null, id: string, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null };

export type AnonUserFragmentFragment = { __typename?: 'eatfresh_user_account', email?: string | null, id: string, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null };

export type RfidFragment = { __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null };

export type ArticleFragment = { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null };

export type AdminArticleFragment = { __typename?: 'eatfresh_article', markup_percentage?: number | null, margin_percentage?: number | null, margin_euros?: number | null, retail_confirmed_at_purchase_price?: number | null, has_task: boolean, id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null };

export type NutritionInformationFragment = { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null };

export type VitaminMineralFragment = { __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string };

export type VatCategoryFragment = { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number };

export type PasswordResetTokenFragment = { __typename?: 'eatfresh_password_reset_token', id: string, user_id: string, user_email: string, token: string, created_at?: string | null, expires_at?: string | null, used: boolean };

export type ArticleDetailsFragment = { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } };

export type RfidScannerFragment = { __typename?: 'eatfresh_rfid_scanner', id: string, given_id: string, name: string, type: Eatfresh_Rfid_Scanner_Type_Enum };

export type RfidScannerAdminFragment = { __typename?: 'eatfresh_rfid_scanner', power_in_dbm: number, authtoken?: string | null, baseurl?: string | null, id: string, given_id: string, name: string, type: Eatfresh_Rfid_Scanner_Type_Enum };

export type RfidBoxFragment = { __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum };

export type RfidAssetFragment = { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null };

export type RfidScanFragment = { __typename?: 'eatfresh_rfid_scan', id: string, rfid_scanner_id: string, scanned_at: string, created_at: string, epcs: Array<string>, status: Eatfresh_Rfid_Scan_Status_Enum, error?: string | null, reading_time: number, reading_time_left: number, read_finished: boolean, scan_id?: string | null };

export type BoxContentPlanFragment = { __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> };

export type PlaceFragment = { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null };

export type WarehouseFragment = { __typename?: 'eatfresh_warehouse', created_at: any, id: string, name: string, updated_at: any, external: boolean, b2b_customer_id?: string | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null };

export type WarehouseOrderFragment = { __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null };

export type FridgeTargetStockFragment = { __typename?: 'eatfresh_fridge_target_stock', id: string, fridge_id: string };

export type FridgeTargetStockPositionFragment = { __typename?: 'eatfresh_fridge_target_stock_position', id: string, article_id: string, quantity: number };

export type FridgeFragment = { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } };

export type FridgeOrderFragment = { __typename?: 'eatfresh_fridge_order', id: string, fridge_id: string, priority: number, active: boolean, last_serviced_at?: any | null };

export type CommissioningProcessFragment = { __typename?: 'eatfresh_commissioning_process', id: string, fridge_order_id: string, scanner_id: string, user_id: string, status: Eatfresh_Commissioning_Process_Status_Enum };

export type BoxContentPlanWithBoxFragment = { __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, rfid_scans_aggregate: { __typename?: 'eatfresh_rfid_scan_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_scan_aggregate_fields', max?: { __typename?: 'eatfresh_rfid_scan_max_fields', scanned_at?: string | null } | null } | null }, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null }>, rfid_box?: { __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum, error_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, labeling_id?: string | null, commissioning_id?: string | null, confirmed_at?: string | null, box_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> }>, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null, warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null, pallet_spot?: { __typename?: 'eatfresh_external_warehouse_pallet_spot', id: string, external_warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string } } | null } | null } } | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> };

export type AssetPlacementFragment = { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null };

export type WarehouseShelfFragment = { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number };

export type WarehouseOrderReceiptPositionFragment = { __typename?: 'eatfresh_warehouse_order_receipt_position', id: string, best_before_date?: any | null, article_id?: string | null, created_at: any, updated_at: any, quality?: boolean | null, expected_quantity: number, usable_quantity?: number | null, actual_quantity: number, labeled_quantity: number, items_per_package_unit?: number | null, warehouse_order_receipt: { __typename?: 'eatfresh_warehouse_order_receipt', id: string, created_at: any, warehouse_order: { __typename?: 'eatfresh_warehouse_order', created_at: any, supplier?: string | null } }, article?: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } | null };

export type LogisticsProblemFragment = { __typename?: 'eatfresh_logistics_problem', id: string, created_at?: string | null, closed_at?: string | null, user_id: string, process_type: Eatfresh_Logistics_Process_Type_Enum, problem_type: string, description: string, status: Eatfresh_Logistics_Problem_Status_Enum };

export type WarehouseOrderTypeFragment = { __typename?: 'eatfresh_warehouse_order_type', value: string, description?: string | null };

export type B2bCustomerFragment = { __typename?: 'eatfresh_b2b_customer', id: string, name: string, use_smartstore24_api?: boolean | null, ss24_location_id?: string | null, ss24_company_id?: string | null, billing_address: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } };

export type FridgeScannedQueryVariables = Exact<{
  given_id: Scalars['String']['input'];
}>;


export type FridgeScannedQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, connection_status: Eatfresh_Connection_Status_Enum, temperature?: number | null, given_id: string, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }> };

export type AdminUsersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<Eatfresh_User_Account_Bool_Exp>;
  order_by?: InputMaybe<Array<Eatfresh_User_Account_Order_By> | Eatfresh_User_Account_Order_By>;
}>;


export type AdminUsersQuery = { __typename?: 'query_root', eatfresh_user_account: Array<{ __typename?: 'eatfresh_user_account', active?: boolean | null, basic_user_type: Eatfresh_Basic_User_Type_Enum, created: string, email?: string | null, first_name?: string | null, last_name?: string | null, id: string, last_login?: string | null, requires_password_change?: boolean | null, updated: string, agb_accepted: boolean, stripe_customer_id?: string | null, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null }>, eatfresh_user_account_aggregate: { __typename?: 'eatfresh_user_account_aggregate', aggregate?: { __typename?: 'eatfresh_user_account_aggregate_fields', count: number } | null } };

export type AdminOrdersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By> | Eatfresh_Customer_Order_Order_By>;
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
}>;


export type AdminOrdersQuery = { __typename?: 'query_root', eatfresh_customer_order: Array<{ __typename?: 'eatfresh_customer_order', id: string, created: string, finished_at?: string | null, gross_total_sum?: number | null, total_sum: number, given_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, door_opened?: boolean | null, payment_method?: string | null, payment_details?: string | null, updated: string, user_id?: string | null, longitude?: number | null, latitude?: number | null, trans_id?: string | null, demo_flag?: boolean | null, order_positions: Array<{ __typename?: 'eatfresh_order_position', id: string, article_name: string, gross_sales_price?: number | null, quantity?: number | null, tax_rate?: number | null, category: Eatfresh_Order_Position_Category_Enum, ean?: string | null, deposit?: number | null }>, user_account?: { __typename?: 'eatfresh_user_account', id: string, email?: string | null } | null }>, eatfresh_customer_order_aggregate: { __typename?: 'eatfresh_customer_order_aggregate', aggregate?: { __typename?: 'eatfresh_customer_order_aggregate_fields', count: number } | null } };

export type LoggedInUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type LoggedInUserQuery = { __typename?: 'query_root', eatfresh_user_account_by_pk?: { __typename?: 'eatfresh_user_account', active?: boolean | null, basic_user_type: Eatfresh_Basic_User_Type_Enum, created: string, email?: string | null, first_name?: string | null, last_name?: string | null, id: string, last_login?: string | null, requires_password_change?: boolean | null, updated: string, agb_accepted: boolean, stripe_customer_id?: string | null, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null } | null };

export type AdminRfidsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rfid_number: Scalars['String']['input'];
  rfid_status: Array<Eatfresh_Rfid_Status_Enum> | Eatfresh_Rfid_Status_Enum;
  article_id?: InputMaybe<Uuid_Comparison_Exp>;
}>;


export type AdminRfidsQuery = { __typename?: 'query_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }>, eatfresh_rfid_tag_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', count: number } | null } };

export type AdminArticlesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Eatfresh_Article_Order_By> | Eatfresh_Article_Order_By>;
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
}>;


export type AdminArticlesQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', markup_percentage?: number | null, margin_percentage?: number | null, margin_euros?: number | null, retail_confirmed_at_purchase_price?: number | null, has_task: boolean, id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', wholesale_price?: number | null, id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }>, eatfresh_article_aggregate: { __typename?: 'eatfresh_article_aggregate', aggregate?: { __typename?: 'eatfresh_article_aggregate_fields', count: number } | null } };

export type AdminFridgeLayoutArticleCandidatesQueryVariables = Exact<{
  where?: InputMaybe<Eatfresh_Article_Bool_Exp>;
}>;


export type AdminFridgeLayoutArticleCandidatesQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, ean: string, name: string }>, eatfresh_article_aggregate: { __typename?: 'eatfresh_article_aggregate', aggregate?: { __typename?: 'eatfresh_article_aggregate_fields', count: number } | null } };

export type AdminArticleRfidCountsQueryVariables = Exact<{
  article_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type AdminArticleRfidCountsQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, rfid_tags_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', count: number } | null } }> };

export type ArticleIdsInAssignedFridgeLayoutsQueryVariables = Exact<{ [key: string]: never; }>;


export type ArticleIdsInAssignedFridgeLayoutsQuery = { __typename?: 'query_root', eatfresh_fridge_layout_level_position: Array<{ __typename?: 'eatfresh_fridge_layout_level_position', article_id: string }> };

export type FridgesMapQueryVariables = Exact<{ [key: string]: never; }>;


export type FridgesMapQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, type: Eatfresh_Fridge_Type_Enum, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }, fridge_stocks: Array<{ __typename?: 'eatfresh_fridge_stock', quantity?: number | null, rfid_tag?: { __typename?: 'eatfresh_rfid_tag', id: string, article?: { __typename?: 'eatfresh_article', uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null } | null }> }> };

export type FridgesMapPinsQueryVariables = Exact<{ [key: string]: never; }>;


export type FridgesMapPinsQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, place: { __typename?: 'eatfresh_place', id: string, name: string, latitude: number, longitude: number } }> };

export type FridgesStockQueryVariables = Exact<{
  given_ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type FridgesStockQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', id: string, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, article?: { __typename?: 'eatfresh_article', name: string, id: string, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, fridge_layout_assignments: Array<{ __typename?: 'eatfresh_fridge_layout_assignment', fridge_layout: { __typename?: 'eatfresh_fridge_layout', fridge_layout_levels: Array<{ __typename?: 'eatfresh_fridge_layout_level', order_index: number, fridge_layout_level_positions: Array<{ __typename?: 'eatfresh_fridge_layout_level_position', order_index: number, article: { __typename?: 'eatfresh_article', id: string } }> }> } }> }> };

export type UnstoredRfidsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnstoredRfidsQuery = { __typename?: 'query_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> };

export type AdminVatCategoriesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Eatfresh_Vat_Category_Order_By> | Eatfresh_Vat_Category_Order_By>;
  where?: InputMaybe<Eatfresh_Vat_Category_Bool_Exp>;
}>;


export type AdminVatCategoriesQuery = { __typename?: 'query_root', eatfresh_vat_category: Array<{ __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number }>, eatfresh_vat_category_aggregate: { __typename?: 'eatfresh_vat_category_aggregate', aggregate?: { __typename?: 'eatfresh_vat_category_aggregate_fields', count: number } | null } };

export type AdminFridgesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Order_By> | Eatfresh_Fridge_Order_By>;
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
}>;


export type AdminFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, asset_placements_aggregate: { __typename?: 'eatfresh_asset_placement_aggregate', aggregate?: { __typename?: 'eatfresh_asset_placement_aggregate_fields', count: number } | null }, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }>, eatfresh_fridge_aggregate: { __typename?: 'eatfresh_fridge_aggregate', aggregate?: { __typename?: 'eatfresh_fridge_aggregate_fields', count: number } | null } };

export type SelectVatCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectVatCategoriesQuery = { __typename?: 'query_root', eatfresh_vat_category: Array<{ __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number }> };

export type PasswordResetTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type PasswordResetTokenQuery = { __typename?: 'query_root', eatfresh_password_reset_token: Array<{ __typename?: 'eatfresh_password_reset_token', id: string, user_id: string, user_email: string, token: string, created_at?: string | null, expires_at?: string | null, used: boolean }> };

export type Article_By_PkQueryVariables = Exact<{
  articleId: Scalars['uuid']['input'];
}>;


export type Article_By_PkQuery = { __typename?: 'query_root', eatfresh_article_by_pk?: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } | null };

export type ArticleWithDetailsQueryVariables = Exact<{
  articleId: Scalars['uuid']['input'];
}>;


export type ArticleWithDetailsQuery = { __typename?: 'query_root', eatfresh_article_by_pk?: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } | null };

export type RfidScannersQueryVariables = Exact<{ [key: string]: never; }>;


export type RfidScannersQuery = { __typename?: 'query_root', eatfresh_rfid_scanner: Array<{ __typename?: 'eatfresh_rfid_scanner', id: string, given_id: string, name: string, type: Eatfresh_Rfid_Scanner_Type_Enum }> };

export type RfidScannersAdminQueryVariables = Exact<{
  where?: InputMaybe<Eatfresh_Rfid_Scanner_Bool_Exp>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type RfidScannersAdminQuery = { __typename?: 'query_root', eatfresh_rfid_scanner: Array<{ __typename?: 'eatfresh_rfid_scanner', power_in_dbm: number, authtoken?: string | null, baseurl?: string | null, id: string, given_id: string, name: string, type: Eatfresh_Rfid_Scanner_Type_Enum }>, eatfresh_rfid_scanner_aggregate: { __typename?: 'eatfresh_rfid_scanner_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_scanner_aggregate_fields', count: number } | null } };

export type ArticleQueryVariables = Exact<{
  where: Eatfresh_Article_Bool_Exp;
}>;


export type ArticleQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }> };

export type ArticleByEanQueryVariables = Exact<{
  ean: Scalars['String']['input'];
}>;


export type ArticleByEanQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }> };

export type RfidBoxesQueryVariables = Exact<{ [key: string]: never; }>;


export type RfidBoxesQuery = { __typename?: 'query_root', eatfresh_rfid_box: Array<{ __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null } }> };

export type WarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type WarehousesQuery = { __typename?: 'query_root', eatfresh_warehouse: Array<{ __typename?: 'eatfresh_warehouse', created_at: any, id: string, name: string, updated_at: any, external: boolean, b2b_customer_id?: string | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null }> };

export type WarehouseOrderNamesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type WarehouseOrderNamesByIdsQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string } }> };

export type AdminWarehousesQueryVariables = Exact<{
  where: Eatfresh_Warehouse_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type AdminWarehousesQuery = { __typename?: 'query_root', eatfresh_warehouse: Array<{ __typename?: 'eatfresh_warehouse', created_at: any, id: string, name: string, updated_at: any, external: boolean, b2b_customer_id?: string | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null }>, eatfresh_warehouse_aggregate: { __typename?: 'eatfresh_warehouse_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_aggregate_fields', count: number } | null } };

export type WarehouseOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type WarehouseOrderQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null, warehouse_order_receipt?: { __typename?: 'eatfresh_warehouse_order_receipt', uploaded_file: { __typename?: 'eatfresh_uploaded_file', url?: string | null } } | null }> };

export type WarehouseOrderPositionsByPkQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type WarehouseOrderPositionsByPkQuery = { __typename?: 'query_root', eatfresh_warehouse_order_by_pk?: { __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null, warehouse_order_receipt?: { __typename?: 'eatfresh_warehouse_order_receipt', id: string } | null, warehouse_order_positions_aggregate: { __typename?: 'eatfresh_warehouse_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_position_aggregate_fields', sum?: { __typename?: 'eatfresh_warehouse_order_position_sum_fields', total_articles?: number | null } | null } | null }, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', article_id?: string | null, created_at: any, id: string, packaging_units?: number | null, boxes?: number | null, items_per_pu?: number | null, total_articles: number, purchase_price: number, updated_at: any, warehouse_order_id?: string | null, article?: { __typename?: 'eatfresh_article', name: string, active_for_retail: boolean, active_for_wholesale: boolean, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } | null };

export type OrderRfidTagsQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type OrderRfidTagsQuery = { __typename?: 'query_root', shelf_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', min?: { __typename?: 'eatfresh_rfid_tag_min_fields', best_before_date?: string | null } | null } | null }, order_rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, article_id?: string | null }> };

export type AdminWarehouseOrderIdsQueryVariables = Exact<{
  where: Eatfresh_Warehouse_Order_Bool_Exp;
}>;


export type AdminWarehouseOrderIdsQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string }> };

export type AdminWarehouseOrdersQueryVariables = Exact<{
  supplier: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type AdminWarehouseOrdersQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null }>, eatfresh_warehouse_order_aggregate: { __typename?: 'eatfresh_warehouse_order_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_aggregate_fields', count: number } | null } };

export type AdminWarehouseOrderByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  offset: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type AdminWarehouseOrderByPkQuery = { __typename?: 'query_root', eatfresh_warehouse_order_by_pk?: { __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null, warehouse: { __typename?: 'eatfresh_warehouse', name: string }, source_warehouse?: { __typename?: 'eatfresh_warehouse', name: string } | null, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', id: string, packaging_units?: number | null, boxes?: number | null, items_per_pu?: number | null, total_articles: number, purchase_price: number, article?: { __typename?: 'eatfresh_article', name: string, id: string } | null }> } | null, eatfresh_warehouse_order_position_aggregate: { __typename?: 'eatfresh_warehouse_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_position_aggregate_fields', count: number } | null } };

export type WarehouseOrderStatusHeaderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type WarehouseOrderStatusHeaderQuery = { __typename?: 'query_root', eatfresh_warehouse_order_by_pk?: { __typename?: 'eatfresh_warehouse_order', id: string, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse: { __typename?: 'eatfresh_warehouse', name: string }, source_warehouse?: { __typename?: 'eatfresh_warehouse', name: string } | null } | null };

export type Admin_Warehouse_Order_Query_Positions_NewQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  before?: InputMaybe<Scalars['timestamp']['input']>;
  after?: InputMaybe<Scalars['timestamp']['input']>;
  selectedStatuses: Array<Eatfresh_Warehouse_Order_Status_Enum> | Eatfresh_Warehouse_Order_Status_Enum;
}>;


export type Admin_Warehouse_Order_Query_Positions_NewQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null, source_warehouse?: { __typename?: 'eatfresh_warehouse', id: string, name: string } | null, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string, external: boolean } }>, eatfresh_warehouse_order_aggregate: { __typename?: 'eatfresh_warehouse_order_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_aggregate_fields', count: number } | null } };

export type LabelWarehouseOrderReceiptPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LabelWarehouseOrderReceiptPositionsQuery = { __typename?: 'query_root', eatfresh_warehouse_order_receipt: Array<{ __typename?: 'eatfresh_warehouse_order_receipt', id: string, warehouse_order: { __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null }, warehouse_order_receipt_positions: Array<{ __typename?: 'eatfresh_warehouse_order_receipt_position', id: string, best_before_date?: any | null, article_id?: string | null, created_at: any, updated_at: any, quality?: boolean | null, expected_quantity: number, usable_quantity?: number | null, actual_quantity: number, labeled_quantity: number, items_per_package_unit?: number | null, article_labeling_processes: Array<{ __typename?: 'eatfresh_article_labeling_process', status: Eatfresh_Article_Labeling_Process_Status_Enum, id: string, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_tags_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', count: number } | null } }> }>, warehouse_order_receipt: { __typename?: 'eatfresh_warehouse_order_receipt', id: string, created_at: any, warehouse_order: { __typename?: 'eatfresh_warehouse_order', created_at: any, supplier?: string | null } }, article?: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } | null }> }> };

export type WarehouseOrderReceiptPositionsQueryVariables = Exact<{
  where: Eatfresh_Warehouse_Order_Receipt_Position_Bool_Exp;
}>;


export type WarehouseOrderReceiptPositionsQuery = { __typename?: 'query_root', eatfresh_warehouse_order_receipt_position: Array<{ __typename?: 'eatfresh_warehouse_order_receipt_position', id: string, best_before_date?: any | null, article_id?: string | null, created_at: any, updated_at: any, quality?: boolean | null, expected_quantity: number, usable_quantity?: number | null, actual_quantity: number, labeled_quantity: number, items_per_package_unit?: number | null, warehouse_order_receipt: { __typename?: 'eatfresh_warehouse_order_receipt', id: string, created_at: any, warehouse_order: { __typename?: 'eatfresh_warehouse_order', created_at: any, supplier?: string | null } }, article?: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } | null }> };

export type Scanner_Exists_By_PkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Scanner_Exists_By_PkQuery = { __typename?: 'query_root', eatfresh_rfid_scanner_by_pk?: { __typename?: 'eatfresh_rfid_scanner', id: string, given_id: string, type: Eatfresh_Rfid_Scanner_Type_Enum } | null };

export type Scanner_Exists_By_Given_IdQueryVariables = Exact<{
  givenId: Scalars['String']['input'];
}>;


export type Scanner_Exists_By_Given_IdQuery = { __typename?: 'query_root', eatfresh_rfid_scanner: Array<{ __typename?: 'eatfresh_rfid_scanner', id: string, given_id: string, type: Eatfresh_Rfid_Scanner_Type_Enum }> };

export type AdminFridgeTargetStockQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  fridgeId: Scalars['uuid']['input'];
}>;


export type AdminFridgeTargetStockQuery = { __typename?: 'query_root', eatfresh_fridge_by_pk?: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, fridge_target_stocks: Array<{ __typename?: 'eatfresh_fridge_target_stock', id: string, fridge_id: string, fridge_target_stock_positions: Array<{ __typename?: 'eatfresh_fridge_target_stock_position', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }>, fridge_target_stock_positions_aggregate: { __typename?: 'eatfresh_fridge_target_stock_position_aggregate', aggregate?: { __typename?: 'eatfresh_fridge_target_stock_position_aggregate_fields', count: number } | null } }>, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } } | null };

export type AdminFridgeOrderQueryVariables = Exact<{
  fridgeOrderId: Scalars['uuid']['input'];
}>;


export type AdminFridgeOrderQuery = { __typename?: 'query_root', eatfresh_fridge_order_by_pk?: { __typename?: 'eatfresh_fridge_order', id: string, fridge_id: string, priority: number, active: boolean, last_serviced_at?: any | null, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, rfid_scans_aggregate: { __typename?: 'eatfresh_rfid_scan_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_scan_aggregate_fields', max?: { __typename?: 'eatfresh_rfid_scan_max_fields', scanned_at?: string | null } | null } | null }, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null }>, rfid_box?: { __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum, error_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, labeling_id?: string | null, commissioning_id?: string | null, confirmed_at?: string | null, box_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> }>, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null, warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null, pallet_spot?: { __typename?: 'eatfresh_external_warehouse_pallet_spot', id: string, external_warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string } } | null } | null } } | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> }> } | null };

export type AdminPlacesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type AdminPlacesQuery = { __typename?: 'query_root', eatfresh_place: Array<{ __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, warehouses_aggregate: { __typename?: 'eatfresh_warehouse_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_aggregate_fields', count: number } | null }, fridges_aggregate: { __typename?: 'eatfresh_fridge_aggregate', aggregate?: { __typename?: 'eatfresh_fridge_aggregate_fields', count: number } | null }, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }>, eatfresh_place_aggregate: { __typename?: 'eatfresh_place_aggregate', aggregate?: { __typename?: 'eatfresh_place_aggregate_fields', count: number } | null } };

export type AdminPlaceByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AdminPlaceByNameQuery = { __typename?: 'query_root', eatfresh_place: Array<{ __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }> };

export type RefillerFridgesInPlaceQueryVariables = Exact<{
  place_id: Scalars['uuid']['input'];
}>;


export type RefillerFridgesInPlaceQuery = { __typename?: 'query_root', eatfresh_place_by_pk?: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, fridges: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, fridge_order?: { __typename?: 'eatfresh_fridge_order', id: string, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string }> } | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }>, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } | null };

export type Pending_Received_Warehouse_Orders_AggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type Pending_Received_Warehouse_Orders_AggregateQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string }> };

export type ExternalWarehouseOrdersQueryVariables = Exact<{
  source_warehouse_id: Scalars['uuid']['input'];
}>;


export type ExternalWarehouseOrdersQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string, external: boolean }, source_warehouse?: { __typename?: 'eatfresh_warehouse', id: string, name: string } | null, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', id: string, article_id?: string | null, packaging_units?: number | null, boxes?: number | null, items_per_pu?: number | null, total_articles: number, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string } | null }> }> };

export type DraftExternalOrderForRouteQueryVariables = Exact<{
  source_warehouse_id: Scalars['uuid']['input'];
  destination_warehouse_id: Scalars['uuid']['input'];
}>;


export type DraftExternalOrderForRouteQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, created_at: any, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_order_positions_aggregate: { __typename?: 'eatfresh_warehouse_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_position_aggregate_fields', count: number } | null } }> };

export type ExternalWarehouseOrdersShippedQueryVariables = Exact<{
  source_warehouse_id: Scalars['uuid']['input'];
}>;


export type ExternalWarehouseOrdersShippedQuery = { __typename?: 'query_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', shipped_at?: string | null, logistics_order_id?: string | null, id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, updated_at: any, created_at: any, b2b_customer_id?: string | null, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string, external: boolean }, source_warehouse?: { __typename?: 'eatfresh_warehouse', id: string, name: string } | null, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', id: string, article_id?: string | null, packaging_units?: number | null, boxes?: number | null, items_per_pu?: number | null, total_articles: number, article?: { __typename?: 'eatfresh_article', id: string, name: string } | null }> }> };

export type Warehouse_Order_Receipt_Positions_Where_Items_Per_Package_Unit_Is_NullQueryVariables = Exact<{
  warehouse_order_id: Scalars['uuid']['input'];
}>;


export type Warehouse_Order_Receipt_Positions_Where_Items_Per_Package_Unit_Is_NullQuery = { __typename?: 'query_root', eatfresh_warehouse_order_receipt_position: Array<{ __typename?: 'eatfresh_warehouse_order_receipt_position', article_id?: string | null }> };

export type Warehouse_Articles_By_Id_ArrayQueryVariables = Exact<{
  idArray: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type Warehouse_Articles_By_Id_ArrayQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }> };

export type AdminArticlesByIdArrayQueryVariables = Exact<{
  idArray: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type AdminArticlesByIdArrayQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', wholesale_price?: number | null, id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }> };

export type Warehouse_Order_Receipt_Position_By_IdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Warehouse_Order_Receipt_Position_By_IdQuery = { __typename?: 'query_root', eatfresh_warehouse_order_receipt_position_by_pk?: { __typename?: 'eatfresh_warehouse_order_receipt_position', id: string, best_before_date?: any | null, article_id?: string | null, created_at: any, updated_at: any, quality?: boolean | null, expected_quantity: number, usable_quantity?: number | null, actual_quantity: number, labeled_quantity: number, items_per_package_unit?: number | null, warehouse_order_receipt: { __typename?: 'eatfresh_warehouse_order_receipt', id: string, created_at: any, warehouse_order: { __typename?: 'eatfresh_warehouse_order', created_at: any, supplier?: string | null } }, article?: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } | null } | null };

export type LogisticsProblemQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type LogisticsProblemQuery = { __typename?: 'query_root', eatfresh_logistics_problem_by_pk?: { __typename?: 'eatfresh_logistics_problem', id: string, created_at?: string | null, closed_at?: string | null, user_id: string, process_type: Eatfresh_Logistics_Process_Type_Enum, problem_type: string, description: string, status: Eatfresh_Logistics_Problem_Status_Enum } | null };

export type EasyRefillPermissionsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: Eatfresh_Easy_Refill_Permission_Bool_Exp;
  order_by?: InputMaybe<Array<Eatfresh_Easy_Refill_Permission_Order_By> | Eatfresh_Easy_Refill_Permission_Order_By>;
}>;


export type EasyRefillPermissionsQuery = { __typename?: 'query_root', eatfresh_easy_refill_permission: Array<{ __typename?: 'eatfresh_easy_refill_permission', id: string, fridge_id: string, created_at: string, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } } }>, eatfresh_easy_refill_permission_aggregate: { __typename?: 'eatfresh_easy_refill_permission_aggregate', aggregate?: { __typename?: 'eatfresh_easy_refill_permission_aggregate_fields', count: number } | null } };

export type WarehouseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type WarehouseTypesQuery = { __typename?: 'query_root', eatfresh_warehouse_order_type: Array<{ __typename?: 'eatfresh_warehouse_order_type', value: string, description?: string | null }> };

export type AdminB2bCustomersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Eatfresh_B2b_Customer_Order_By> | Eatfresh_B2b_Customer_Order_By>;
  where?: InputMaybe<Eatfresh_B2b_Customer_Bool_Exp>;
}>;


export type AdminB2bCustomersQuery = { __typename?: 'query_root', eatfresh_b2b_customer: Array<{ __typename?: 'eatfresh_b2b_customer', id: string, name: string, use_smartstore24_api?: boolean | null, ss24_location_id?: string | null, ss24_company_id?: string | null, billing_address: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }>, eatfresh_b2b_customer_aggregate: { __typename?: 'eatfresh_b2b_customer_aggregate', aggregate?: { __typename?: 'eatfresh_b2b_customer_aggregate_fields', count: number } | null } };

export type B2bCustomersSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type B2bCustomersSelectQuery = { __typename?: 'query_root', eatfresh_b2b_customer: Array<{ __typename?: 'eatfresh_b2b_customer', id: string, name: string }> };

export type MyWarehouseAssignmentQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWarehouseAssignmentQuery = { __typename?: 'query_root', eatfresh_warehouse_assignment: Array<{ __typename?: 'eatfresh_warehouse_assignment', id: string, enforce_quick_labeling: boolean, warehouse_id?: string | null }> };

export type FridgeSubscriptionVariables = Exact<{
  given_id_or_selfly_device_code: Scalars['String']['input'];
}>;


export type FridgeSubscription = { __typename?: 'subscription_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }> };

export type CustomerArticlesInFridgeSubscriptionVariables = Exact<{
  fridge_id: Scalars['uuid']['input'];
}>;


export type CustomerArticlesInFridgeSubscription = { __typename?: 'subscription_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null, article_id?: string | null, best_before_date: string, retail_price: number }>, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }> };

export type ArticlesInFridgeSubscriptionVariables = Exact<{
  fridge_id: Scalars['uuid']['input'];
}>;


export type ArticlesInFridgeSubscription = { __typename?: 'subscription_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, fridge_target_stock_positions: Array<{ __typename?: 'eatfresh_fridge_target_stock_position', article_id: string, quantity: number }>, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }>, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }> };

export type ExpiredArticlesInFridgeSubscriptionVariables = Exact<{
  fridge_id: Scalars['uuid']['input'];
}>;


export type ExpiredArticlesInFridgeSubscription = { __typename?: 'subscription_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }>, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }> };

export type OperationsFridgeHealthSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OperationsFridgeHealthSubscription = { __typename?: 'subscription_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, selfly_device_code?: string | null, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, inventory_synced: boolean, inventory_last_synced_at?: string | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, last_seen_online?: string | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }, fridge_alarms: Array<{ __typename?: 'eatfresh_fridge_alarm', alarm_type: string, active_since: string }>, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', rfid_asset: { __typename?: 'eatfresh_rfid_asset', rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null, article_id?: string | null, retail_price: number, best_before_date: string, article?: { __typename?: 'eatfresh_article', id: string, name: string, retail_price: number } | null }> } }>, price_locks: Array<{ __typename?: 'eatfresh_price_lock', article_id: string, locked_retail_price: number, price_changes: Array<{ __typename?: 'eatfresh_price_change', price_change_positions: Array<{ __typename?: 'eatfresh_price_change_position', fridge_id: string }> }> }>, price_change_positions: Array<{ __typename?: 'eatfresh_price_change_position', confirmed_at?: string | null, price_change: { __typename?: 'eatfresh_price_change', article_id: string, new_retail_price: number } }>, fridge_target_stocks: Array<{ __typename?: 'eatfresh_fridge_target_stock', fridge_target_stock_positions: Array<{ __typename?: 'eatfresh_fridge_target_stock_position', article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, name: string } }> }> }> };

export type OperationsRecentOrdersSubscriptionVariables = Exact<{
  since: Scalars['timestamptz']['input'];
}>;


export type OperationsRecentOrdersSubscription = { __typename?: 'subscription_root', eatfresh_customer_order: Array<{ __typename?: 'eatfresh_customer_order', id: string, given_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, created: string }> };

export type PaymentMethodsSubscriptionVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type PaymentMethodsSubscription = { __typename?: 'subscription_root', eatfresh_payment_method: Array<{ __typename?: 'eatfresh_payment_method', trans_id: string, payment_method_type: Eatfresh_Payment_Method_Type_Enum, pseudo_card_number?: string | null, brand?: string | null, expirydate?: string | null, status?: string | null }> };

export type DraftRefillSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DraftRefillSubscription = { __typename?: 'subscription_root', eatfresh_refill_by_pk?: { __typename?: 'eatfresh_refill', id: string, refill_status: Eatfresh_Refill_Status_Enum, given_id: string, user_id: string, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string }> } | null };

export type RfidTagsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RfidTagsSubscription = { __typename?: 'subscription_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum }> };

export type FridgesSubscriptionSubscriptionVariables = Exact<{
  offset: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  selectedStatuses: Array<Eatfresh_Connection_Status_Enum> | Eatfresh_Connection_Status_Enum;
  given_id: Scalars['String']['input'];
}>;


export type FridgesSubscriptionSubscription = { __typename?: 'subscription_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', connection_status: Eatfresh_Connection_Status_Enum, created: string, disabled: boolean, door_status: Eatfresh_Door_Status_Enum, given_id: string, id: string, temperature?: number | null, updated: string, demo_flag?: boolean | null, type: Eatfresh_Fridge_Type_Enum, place_id: string, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }, asset_placements_aggregate: { __typename?: 'eatfresh_asset_placement_aggregate', aggregate?: { __typename?: 'eatfresh_asset_placement_aggregate_fields', count: number } | null } }> };

export type FridgesAggregateSubscriptionSubscriptionVariables = Exact<{
  selectedStatuses: Array<Eatfresh_Connection_Status_Enum> | Eatfresh_Connection_Status_Enum;
  given_id: Scalars['String']['input'];
}>;


export type FridgesAggregateSubscriptionSubscription = { __typename?: 'subscription_root', eatfresh_fridge_aggregate: { __typename?: 'eatfresh_fridge_aggregate', aggregate?: { __typename?: 'eatfresh_fridge_aggregate_fields', count: number } | null } };

export type MockFridgeSubscriptionVariables = Exact<{
  given_id: Scalars['String']['input'];
}>;


export type MockFridgeSubscription = { __typename?: 'subscription_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null }, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }> }> };

export type ArticleLabelingProcessSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ArticleLabelingProcessSubscription = { __typename?: 'subscription_root', eatfresh_article_labeling_process_by_pk?: { __typename?: 'eatfresh_article_labeling_process', id: string, status: Eatfresh_Article_Labeling_Process_Status_Enum, scanner_id?: string | null, expected_number_of_items: number, article_id: string, best_before_date: any, user_id: string, rfid_assets: Array<{ __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null }>, to_label_assets: Array<{ __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null }>, rfid_scanner?: { __typename?: 'eatfresh_rfid_scanner', id: string, given_id: string, name: string, type: Eatfresh_Rfid_Scanner_Type_Enum } | null, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null }, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, rfid_scans_aggregate: { __typename?: 'eatfresh_rfid_scan_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_scan_aggregate_fields', max?: { __typename?: 'eatfresh_rfid_scan_max_fields', scanned_at?: string | null } | null } | null }, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null }>, rfid_box?: { __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum, error_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, labeling_id?: string | null, commissioning_id?: string | null, confirmed_at?: string | null, box_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> }>, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null, warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null, pallet_spot?: { __typename?: 'eatfresh_external_warehouse_pallet_spot', id: string, external_warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string } } | null } | null } } | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> }>, rfid_scans: Array<{ __typename?: 'eatfresh_rfid_scan', id: string, rfid_scanner_id: string, scanned_at: string, created_at: string, epcs: Array<string>, status: Eatfresh_Rfid_Scan_Status_Enum, error?: string | null, reading_time: number, reading_time_left: number, read_finished: boolean, scan_id?: string | null }> } | null };

export type SupplierActiveCommissioningsSubscriptionVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type SupplierActiveCommissioningsSubscription = { __typename?: 'subscription_root', eatfresh_commissioning_process: Array<{ __typename?: 'eatfresh_commissioning_process', id: string, fridge_order_id: string, scanner_id: string, user_id: string, status: Eatfresh_Commissioning_Process_Status_Enum, fridge_order: { __typename?: 'eatfresh_fridge_order', id: string, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } } }, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, rfid_scans_aggregate: { __typename?: 'eatfresh_rfid_scan_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_scan_aggregate_fields', max?: { __typename?: 'eatfresh_rfid_scan_max_fields', scanned_at?: string | null } | null } | null }, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null }>, rfid_box?: { __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum, error_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, labeling_id?: string | null, commissioning_id?: string | null, confirmed_at?: string | null, box_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> }>, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null, warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null, pallet_spot?: { __typename?: 'eatfresh_external_warehouse_pallet_spot', id: string, external_warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string } } | null } | null } } | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> }> }> };

export type SupplierFridgeOrdersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SupplierFridgeOrdersSubscription = { __typename?: 'subscription_root', eatfresh_fridge_order: Array<{ __typename?: 'eatfresh_fridge_order', id: string, fridge_id: string, priority: number, active: boolean, last_serviced_at?: any | null, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> }> }> };

export type SupplierCommissioningProcessSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SupplierCommissioningProcessSubscription = { __typename?: 'subscription_root', eatfresh_commissioning_process_by_pk?: { __typename?: 'eatfresh_commissioning_process', id: string, fridge_order_id: string, scanner_id: string, user_id: string, status: Eatfresh_Commissioning_Process_Status_Enum, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, rfid_scans_aggregate: { __typename?: 'eatfresh_rfid_scan_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_scan_aggregate_fields', max?: { __typename?: 'eatfresh_rfid_scan_max_fields', scanned_at?: string | null } | null } | null }, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null }>, rfid_box?: { __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum, error_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, labeling_id?: string | null, commissioning_id?: string | null, confirmed_at?: string | null, box_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> }>, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null, warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null, pallet_spot?: { __typename?: 'eatfresh_external_warehouse_pallet_spot', id: string, external_warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string } } | null } | null } } | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> }>, rfid_boxes: Array<{ __typename?: 'eatfresh_rfid_box', id: string, type: Eatfresh_Rfid_Box_Type_Enum, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> }>, rfid_assets: Array<{ __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, article_id?: string | null, article?: { __typename?: 'eatfresh_article', id: string, name: string } | null }> }>, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null } }>, fridge_order: { __typename?: 'eatfresh_fridge_order', id: string, fridge_id: string, priority: number, active: boolean, last_serviced_at?: any | null, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } } }, rfid_scanner: { __typename?: 'eatfresh_rfid_scanner', id: string, given_id: string, name: string, type: Eatfresh_Rfid_Scanner_Type_Enum }, rfid_scans: Array<{ __typename?: 'eatfresh_rfid_scan', id: string, rfid_scanner_id: string, scanned_at: string, created_at: string, epcs: Array<string>, status: Eatfresh_Rfid_Scan_Status_Enum, error?: string | null, reading_time: number, reading_time_left: number, read_finished: boolean, scan_id?: string | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, shortcode?: string | null, package_id?: string | null, confirmed_at?: string | null, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> } | null }> } | null };

export type AdminFridgeSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminFridgeSubscription = { __typename?: 'subscription_root', eatfresh_fridge_by_pk?: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } } | null };

export type RefillInProgressSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RefillInProgressSubscription = { __typename?: 'subscription_root', eatfresh_refill_by_pk?: { __typename?: 'eatfresh_refill', id: string, refill_status: Eatfresh_Refill_Status_Enum, fridge_id: string, confirmation_image_required: boolean, box_content_plans: Array<{ __typename?: 'eatfresh_box_content_plan', id: string, shortcode?: string | null, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }>, box_content_to_articles: Array<{ __typename?: 'eatfresh_box_content_to_article', id: string, article_id: string, quantity: number, article: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, created: string, description?: string | null, ean: string, name: string, product_image_id?: string | null, supplier?: string | null, updated: string, retail_price: number, article_detail?: { __typename?: 'eatfresh_article_details', id: string, article_id: string, name: string, purchase_price?: number | null, recommended_price?: number | null, article_number?: string | null, gln?: string | null, ifs_broker_certified?: boolean | null, co_id?: string | null, origin_country?: string | null, remaining_shelf_life?: number | null, total_mhd?: number | null, min_storage_temperature?: number | null, max_storage_temperature?: number | null, ean?: string | null, packaging_type?: string | null, net_fill_volume?: number | null, net_weight?: number | null, gross_weight_single_item?: number | null, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, gtin_package_unit?: string | null, packaging_type_package_unit?: string | null, items_per_package_unit?: number | null, gross_weigth_package_unit?: number | null, width_package_unit?: number | null, height_package_unit?: number | null, depth_package_unit?: number | null, is_deposit_required?: boolean | null, returnable?: boolean | null, deposit_value_single_item?: number | null, deposit_value_package_unit?: number | null, alcohol_content?: number | null, designation_according_to_lmiv?: string | null, ingredient_list?: string | null, fruit_content_percentage?: number | null, preservatives?: Array<string> | null, stabilizers?: Array<string> | null, dyes_coloring?: Array<string> | null, flavor_enhancer?: Array<string> | null, other_additives?: Array<string> | null, contains_gluten?: boolean | null, contains_eggs?: boolean | null, contains_peanuts?: boolean | null, contains_milk?: boolean | null, contains_crustaceans?: boolean | null, contains_fish?: boolean | null, contains_soy?: boolean | null, contains_lactose?: boolean | null, may_contain_traces_of?: Array<string> | null, bio_control_number?: string | null, regional?: boolean | null, eu_approval_number?: string | null, vegan?: boolean | null, vegetarian?: boolean | null, kosher?: boolean | null, storage_box_capacity?: number | null, halal?: boolean | null, article_category?: string | null, nutrition_information?: { __typename?: 'eatfresh_nutrition_information', id: string, nutritional_values_unit?: string | null, calories_kcal?: number | null, calories_kj?: number | null, fat_g?: number | null, salt_g?: number | null, saturated_fat_g?: number | null, carbohydrates_g?: number | null, sugar_g?: number | null, fiber_g?: number | null, protein_g?: number | null } | null, vitamin_minerals: Array<{ __typename?: 'eatfresh_vitamin_mineral', id: string, name?: string | null, weight?: number | null, percentage?: number | null, article_details_id: string }>, vat_category: { __typename?: 'eatfresh_vat_category', id: string, name: string, rate: number } } | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', file_type: string, url?: string | null, name?: string | null, id: string } | null } }> }>, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }>, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null }>, fridge_layout_assignments: Array<{ __typename?: 'eatfresh_fridge_layout_assignment', id: string, status: Eatfresh_Fridge_Layout_Assignment_Status_Enum, fridge_layout: { __typename?: 'eatfresh_fridge_layout', id: string, name: string, parent_layout_id?: string | null, created_at: string, fridge_layout_levels: Array<{ __typename?: 'eatfresh_fridge_layout_level', id: string, order_index: number, fridge_layout_id: string, fridge_layout_level_positions: Array<{ __typename?: 'eatfresh_fridge_layout_level_position', id: string, target_quantity: number, slots: number, lines_per_slot: number, order_index: number, w_orientation: Eatfresh_Product_Orientation_Enum, d_orientation: Eatfresh_Product_Orientation_Enum, article: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number, active_for_retail: boolean, active_for_wholesale: boolean, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, url?: string | null } | null, article_detail?: { __typename?: 'eatfresh_article_details', id: string, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, net_weight?: number | null, net_fill_volume?: number | null, purchase_price?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', id: string, rate: number } } | null } }> }>, fridge_layout_assignments: Array<{ __typename?: 'eatfresh_fridge_layout_assignment', id: string, status: Eatfresh_Fridge_Layout_Assignment_Status_Enum, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string } }> } }>, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, asset_transfers: Array<{ __typename?: 'eatfresh_asset_transfer', id: string, rfid_asset_id: string, from_fridge_id?: string | null, to_fridge_id?: string | null, rfid_asset: { __typename?: 'eatfresh_rfid_asset', id: string, type: Eatfresh_Rfid_Asset_Type_Enum, epc: string, labeling_id?: string | null, rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> } }>, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, url?: string | null } | null } | null };

export type RefillerEasyFridgesSubscriptionVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type RefillerEasyFridgesSubscription = { __typename?: 'subscription_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }> };

export type AdminWarehouseOrdersSubscriptionSubscriptionVariables = Exact<{
  offset: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  where: Eatfresh_Warehouse_Order_Bool_Exp;
  order_by: Array<Eatfresh_Warehouse_Order_Order_By> | Eatfresh_Warehouse_Order_Order_By;
}>;


export type AdminWarehouseOrdersSubscriptionSubscription = { __typename?: 'subscription_root', eatfresh_warehouse_order: Array<{ __typename?: 'eatfresh_warehouse_order', id: string, name?: string | null, type: Eatfresh_Warehouse_Order_Type_Enum, warehouse_order_status: Eatfresh_Warehouse_Order_Status_Enum, warehouse_id: string, source_warehouse_id?: string | null, supplier?: string | null, cost: number, shipped_at?: string | null, logistics_order_id?: string | null, updated_at: any, created_at: any, b2b_customer_id?: string | null, source_warehouse?: { __typename?: 'eatfresh_warehouse', id: string, name: string } | null, warehouse: { __typename?: 'eatfresh_warehouse', id: string, name: string, external: boolean, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', id: string, name: string } | null }, warehouse_order_positions: Array<{ __typename?: 'eatfresh_warehouse_order_position', id: string, total_articles: number, packaging_units?: number | null, boxes?: number | null, purchase_price: number, article?: { __typename?: 'eatfresh_article', id: string, active_for_retail: boolean, active_for_wholesale: boolean, article_detail?: { __typename?: 'eatfresh_article_details', remaining_shelf_life?: number | null } | null } | null }>, warehouse_order_positions_aggregate: { __typename?: 'eatfresh_warehouse_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_position_aggregate_fields', sum?: { __typename?: 'eatfresh_warehouse_order_position_sum_fields', total_articles?: number | null } | null } | null } }> };

export type AdminWarehouseOrdersCountSubscriptionSubscriptionVariables = Exact<{
  where: Eatfresh_Warehouse_Order_Bool_Exp;
}>;


export type AdminWarehouseOrdersCountSubscriptionSubscription = { __typename?: 'subscription_root', eatfresh_warehouse_order_aggregate: { __typename?: 'eatfresh_warehouse_order_aggregate', aggregate?: { __typename?: 'eatfresh_warehouse_order_aggregate_fields', count: number } | null } };

export type AgeVerificationFragment = { __typename?: 'eatfresh_age_verification', id: string, nonce: string, user_id: string, status: Eatfresh_Age_Verification_Status_Enum, type: Eatfresh_Age_Verification_Type_Enum, href: string, error?: string | null, last_checked_at?: string | null, created_at?: string | null, updated_at?: string | null };

export type AgeVerificationSubscriptionVariables = Exact<{
  where: Eatfresh_Age_Verification_Bool_Exp;
}>;


export type AgeVerificationSubscription = { __typename?: 'subscription_root', eatfresh_age_verification: Array<{ __typename?: 'eatfresh_age_verification', id: string, nonce: string, user_id: string, status: Eatfresh_Age_Verification_Status_Enum, type: Eatfresh_Age_Verification_Type_Enum, href: string, error?: string | null, last_checked_at?: string | null, created_at?: string | null, updated_at?: string | null }> };

export type CostConfigurationFragment = { __typename?: 'eatfresh_cost_configuration', id?: string | null, cost_key: Eatfresh_Cost_Configuration_Key_Enum, value: number, created_at: string, deprecated_at?: string | null, cost_configuration_key: { __typename?: 'eatfresh_cost_configuration_key', description?: string | null } };

export type CostConfigurationQueryVariables = Exact<{
  where: Eatfresh_Cost_Configuration_Bool_Exp;
}>;


export type CostConfigurationQuery = { __typename?: 'query_root', eatfresh_cost_configuration: Array<{ __typename?: 'eatfresh_cost_configuration', id?: string | null, cost_key: Eatfresh_Cost_Configuration_Key_Enum, value: number, created_at: string, deprecated_at?: string | null, cost_configuration_key: { __typename?: 'eatfresh_cost_configuration_key', description?: string | null } }>, eatfresh_cost_configuration_aggregate: { __typename?: 'eatfresh_cost_configuration_aggregate', aggregate?: { __typename?: 'eatfresh_cost_configuration_aggregate_fields', count: number } | null } };

export type FridgesQueryVariables = Exact<{
  where?: InputMaybe<Eatfresh_Fridge_Bool_Exp>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, connection_status: Eatfresh_Connection_Status_Enum, door_status: Eatfresh_Door_Status_Enum, disabled: boolean, type: Eatfresh_Fridge_Type_Enum, demo_flag?: boolean | null, inventory_synced: boolean, inventory_last_synced_at?: string | null, directions_summary?: string | null, age_verification_type?: Eatfresh_Age_Verification_Type_Enum | null, selfly_cabinet_state?: Eatfresh_Selfly_Cabinet_State_Enum | null, place: { __typename?: 'eatfresh_place', id: string, name: string, longitude: number, latitude: number, description: string, directions_pdf_id?: string | null, directions_summary?: string | null, google_maps_url: string, street: string, nb: string, city: string, zip_code: string, country: string, additional_line?: string | null, location_name?: string | null, updated: string, created: string, last_sync?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, name?: string | null, url?: string | null } | null } }>, eatfresh_fridge_aggregate: { __typename?: 'eatfresh_fridge_aggregate', aggregate?: { __typename?: 'eatfresh_fridge_aggregate_fields', count: number } | null } };

export type FridgeLayoutLevelPositionFragment = { __typename?: 'eatfresh_fridge_layout_level_position', id: string, target_quantity: number, slots: number, lines_per_slot: number, order_index: number, w_orientation: Eatfresh_Product_Orientation_Enum, d_orientation: Eatfresh_Product_Orientation_Enum, article: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number, active_for_retail: boolean, active_for_wholesale: boolean, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, url?: string | null } | null, article_detail?: { __typename?: 'eatfresh_article_details', id: string, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, net_weight?: number | null, net_fill_volume?: number | null, purchase_price?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', id: string, rate: number } } | null } };

export type FridgeLayoutLevelFragment = { __typename?: 'eatfresh_fridge_layout_level', id: string, order_index: number, fridge_layout_id: string, fridge_layout_level_positions: Array<{ __typename?: 'eatfresh_fridge_layout_level_position', id: string, target_quantity: number, slots: number, lines_per_slot: number, order_index: number, w_orientation: Eatfresh_Product_Orientation_Enum, d_orientation: Eatfresh_Product_Orientation_Enum, article: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number, active_for_retail: boolean, active_for_wholesale: boolean, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, url?: string | null } | null, article_detail?: { __typename?: 'eatfresh_article_details', id: string, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, net_weight?: number | null, net_fill_volume?: number | null, purchase_price?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', id: string, rate: number } } | null } }> };

export type FridgeLayoutFragment = { __typename?: 'eatfresh_fridge_layout', id: string, name: string, parent_layout_id?: string | null, created_at: string, fridge_layout_levels: Array<{ __typename?: 'eatfresh_fridge_layout_level', id: string, order_index: number, fridge_layout_id: string, fridge_layout_level_positions: Array<{ __typename?: 'eatfresh_fridge_layout_level_position', id: string, target_quantity: number, slots: number, lines_per_slot: number, order_index: number, w_orientation: Eatfresh_Product_Orientation_Enum, d_orientation: Eatfresh_Product_Orientation_Enum, article: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number, active_for_retail: boolean, active_for_wholesale: boolean, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, url?: string | null } | null, article_detail?: { __typename?: 'eatfresh_article_details', id: string, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, net_weight?: number | null, net_fill_volume?: number | null, purchase_price?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', id: string, rate: number } } | null } }> }>, fridge_layout_assignments: Array<{ __typename?: 'eatfresh_fridge_layout_assignment', id: string, status: Eatfresh_Fridge_Layout_Assignment_Status_Enum, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string } }> };

export type FridgeLayoutsQueryVariables = Exact<{
  where?: InputMaybe<Eatfresh_Fridge_Layout_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Eatfresh_Fridge_Layout_Order_By> | Eatfresh_Fridge_Layout_Order_By>;
}>;


export type FridgeLayoutsQuery = { __typename?: 'query_root', eatfresh_fridge_layout: Array<{ __typename?: 'eatfresh_fridge_layout', id: string, name: string, parent_layout_id?: string | null, created_at: string, fridge_layout_levels: Array<{ __typename?: 'eatfresh_fridge_layout_level', id: string, order_index: number, fridge_layout_id: string, fridge_layout_level_positions: Array<{ __typename?: 'eatfresh_fridge_layout_level_position', id: string, target_quantity: number, slots: number, lines_per_slot: number, order_index: number, w_orientation: Eatfresh_Product_Orientation_Enum, d_orientation: Eatfresh_Product_Orientation_Enum, article: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number, active_for_retail: boolean, active_for_wholesale: boolean, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, url?: string | null } | null, article_detail?: { __typename?: 'eatfresh_article_details', id: string, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, net_weight?: number | null, net_fill_volume?: number | null, purchase_price?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', id: string, rate: number } } | null } }> }>, fridge_layout_assignments: Array<{ __typename?: 'eatfresh_fridge_layout_assignment', id: string, status: Eatfresh_Fridge_Layout_Assignment_Status_Enum, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string } }> }>, eatfresh_fridge_layout_aggregate: { __typename?: 'eatfresh_fridge_layout_aggregate', aggregate?: { __typename?: 'eatfresh_fridge_layout_aggregate_fields', count: number } | null } };

export type FridgeLayoutQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type FridgeLayoutQuery = { __typename?: 'query_root', eatfresh_fridge_layout_by_pk?: { __typename?: 'eatfresh_fridge_layout', id: string, name: string, parent_layout_id?: string | null, created_at: string, fridge_layout_levels: Array<{ __typename?: 'eatfresh_fridge_layout_level', id: string, order_index: number, fridge_layout_id: string, fridge_layout_level_positions: Array<{ __typename?: 'eatfresh_fridge_layout_level_position', id: string, target_quantity: number, slots: number, lines_per_slot: number, order_index: number, w_orientation: Eatfresh_Product_Orientation_Enum, d_orientation: Eatfresh_Product_Orientation_Enum, article: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number, active_for_retail: boolean, active_for_wholesale: boolean, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', id: string, url?: string | null } | null, article_detail?: { __typename?: 'eatfresh_article_details', id: string, width_single_item?: number | null, height_single_item?: number | null, depth_single_item?: number | null, net_weight?: number | null, net_fill_volume?: number | null, purchase_price?: number | null, vat_category: { __typename?: 'eatfresh_vat_category', id: string, rate: number } } | null } }> }>, fridge_layout_assignments: Array<{ __typename?: 'eatfresh_fridge_layout_assignment', id: string, status: Eatfresh_Fridge_Layout_Assignment_Status_Enum, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string } }> } | null };

export type CustomerOrderFieldsFragment = { __typename?: 'eatfresh_customer_order', id: string, created: string, finished_at?: string | null, gross_total_sum?: number | null, total_sum: number, given_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, door_opened?: boolean | null, payment_method?: string | null, payment_details?: string | null, updated: string, user_id?: string | null, longitude?: number | null, latitude?: number | null, trans_id?: string | null, demo_flag?: boolean | null, order_positions: Array<{ __typename?: 'eatfresh_order_position', id: string, article_name: string, gross_sales_price?: number | null, quantity?: number | null, tax_rate?: number | null, category: Eatfresh_Order_Position_Category_Enum, ean?: string | null, deposit?: number | null }>, user_account?: { __typename?: 'eatfresh_user_account', id: string, email?: string | null } | null };

export type CustomerOrderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CustomerOrderQuery = { __typename?: 'query_root', eatfresh_customer_order_by_pk?: { __typename?: 'eatfresh_customer_order', id: string, created: string, finished_at?: string | null, gross_total_sum?: number | null, total_sum: number, given_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, door_opened?: boolean | null, payment_method?: string | null, payment_details?: string | null, updated: string, user_id?: string | null, longitude?: number | null, latitude?: number | null, trans_id?: string | null, demo_flag?: boolean | null, order_positions: Array<{ __typename?: 'eatfresh_order_position', id: string, article_name: string, gross_sales_price?: number | null, quantity?: number | null, tax_rate?: number | null, category: Eatfresh_Order_Position_Category_Enum, ean?: string | null, deposit?: number | null }>, user_account?: { __typename?: 'eatfresh_user_account', id: string, email?: string | null } | null } | null };

export type CustomerOrdersQueryVariables = Exact<{
  where?: InputMaybe<Eatfresh_Customer_Order_Bool_Exp>;
  order_by?: InputMaybe<Array<Eatfresh_Customer_Order_Order_By> | Eatfresh_Customer_Order_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerOrdersQuery = { __typename?: 'query_root', eatfresh_customer_order: Array<{ __typename?: 'eatfresh_customer_order', id: string, created: string, finished_at?: string | null, gross_total_sum?: number | null, total_sum: number, given_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, door_opened?: boolean | null, payment_method?: string | null, payment_details?: string | null, updated: string, user_id?: string | null, longitude?: number | null, latitude?: number | null, trans_id?: string | null, demo_flag?: boolean | null, order_positions: Array<{ __typename?: 'eatfresh_order_position', id: string, article_name: string, gross_sales_price?: number | null, quantity?: number | null, tax_rate?: number | null, category: Eatfresh_Order_Position_Category_Enum, ean?: string | null, deposit?: number | null }>, user_account?: { __typename?: 'eatfresh_user_account', id: string, email?: string | null } | null }>, eatfresh_customer_order_aggregate: { __typename?: 'eatfresh_customer_order_aggregate', aggregate?: { __typename?: 'eatfresh_customer_order_aggregate_fields', count: number } | null } };

export type OrderSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type OrderSubscription = { __typename?: 'subscription_root', eatfresh_customer_order_by_pk?: { __typename?: 'eatfresh_customer_order', id: string, created: string, finished_at?: string | null, gross_total_sum?: number | null, total_sum: number, given_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, door_opened?: boolean | null, payment_method?: string | null, payment_details?: string | null, updated: string, user_id?: string | null, longitude?: number | null, latitude?: number | null, trans_id?: string | null, demo_flag?: boolean | null, order_positions: Array<{ __typename?: 'eatfresh_order_position', id: string, article_name: string, gross_sales_price?: number | null, quantity?: number | null, tax_rate?: number | null, category: Eatfresh_Order_Position_Category_Enum, ean?: string | null, deposit?: number | null }>, user_account?: { __typename?: 'eatfresh_user_account', id: string, email?: string | null } | null } | null };

export type OrdersSubscriptionVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type OrdersSubscription = { __typename?: 'subscription_root', eatfresh_customer_order: Array<{ __typename?: 'eatfresh_customer_order', id: string, created: string, finished_at?: string | null, gross_total_sum?: number | null, total_sum: number, given_id?: string | null, order_status: Eatfresh_Order_Status_Enum, payment_status: Eatfresh_Payment_Status_Enum, door_opened?: boolean | null, payment_method?: string | null, payment_details?: string | null, updated: string, user_id?: string | null, longitude?: number | null, latitude?: number | null, trans_id?: string | null, demo_flag?: boolean | null, order_positions: Array<{ __typename?: 'eatfresh_order_position', id: string, article_name: string, gross_sales_price?: number | null, quantity?: number | null, tax_rate?: number | null, category: Eatfresh_Order_Position_Category_Enum, ean?: string | null, deposit?: number | null }>, user_account?: { __typename?: 'eatfresh_user_account', id: string, email?: string | null } | null }> };

export type OrderPositionFragmentFragment = { __typename?: 'eatfresh_order_position', order_id: string, gross_sales_price?: number | null, tax_rate?: number | null, quantity?: number | null, article_name: string };

export type Fetch_Order_Positions_QueryQueryVariables = Exact<{
  orderID: Scalars['uuid']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Fetch_Order_Positions_QueryQuery = { __typename?: 'query_root', eatfresh_order_position: Array<{ __typename?: 'eatfresh_order_position', order_id: string, gross_sales_price?: number | null, tax_rate?: number | null, quantity?: number | null, article_name: string }>, eatfresh_order_position_aggregate: { __typename?: 'eatfresh_order_position_aggregate', aggregate?: { __typename?: 'eatfresh_order_position_aggregate_fields', count: number } | null } };

export type PaymentMethodFieldsFragment = { __typename?: 'eatfresh_payment_method', trans_id: string, payment_method_type: Eatfresh_Payment_Method_Type_Enum, pseudo_card_number?: string | null, brand?: string | null, expirydate?: string | null, status?: string | null };

export type Fetch_Rfid_Id_Tags_QueryQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type Fetch_Rfid_Id_Tags_QueryQuery = { __typename?: 'query_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }>, eatfresh_rfid_tag_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', count: number } | null } };

export type Fetch_Rfid_Tag_QueryQueryVariables = Exact<{
  rfidNumber: Scalars['String']['input'];
}>;


export type Fetch_Rfid_Tag_QueryQuery = { __typename?: 'query_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', best_before_date: string, id: string, rfid_asset_id?: string | null, rfid_number?: string | null, article_id?: string | null, rfid_status: Eatfresh_Rfid_Status_Enum, created: string, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', id: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', id: string, rfid_asset_id: string, fridge_id?: string | null, place_id?: string | null, warehouse_id?: string | null, shelf_id?: string | null, rfid_box_id?: string | null, labeling_id?: string | null, commissioning_id?: string | null, refill_id?: string | null } | null } | null, box_content_plan?: { __typename?: 'eatfresh_box_content_plan', id: string, status: Eatfresh_Box_Content_Plan_Status_Enum, rfid_box?: { __typename?: 'eatfresh_rfid_box', rfid_asset: { __typename?: 'eatfresh_rfid_asset', epc: string, asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_shelf?: { __typename?: 'eatfresh_warehouse_shelf', id: string, type: string, shelf_row: number, shelf_column: number } | null } | null } } | null } | null, article?: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, product_image_id?: string | null, supplier?: string | null, uploaded_file?: { __typename?: 'eatfresh_uploaded_file', url?: string | null } | null } | null }> };

export type Anonymous_Rfid_Tag_QueryQueryVariables = Exact<{
  rfidNumber: Scalars['String']['input'];
}>;


export type Anonymous_Rfid_Tag_QueryQuery = { __typename?: 'query_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', id: string, rfid_number?: string | null, article_id?: string | null, best_before_date: string, rfid_status: Eatfresh_Rfid_Status_Enum, is_whitelabel?: boolean | null, retail_price: number }> };

export type Fetch_User_By_Id_QueryQueryVariables = Exact<{
  user_ID: Scalars['uuid']['input'];
}>;


export type Fetch_User_By_Id_QueryQuery = { __typename?: 'query_root', eatfresh_user_account: Array<{ __typename?: 'eatfresh_user_account', active?: boolean | null, basic_user_type: Eatfresh_Basic_User_Type_Enum, created: string, email?: string | null, first_name?: string | null, last_name?: string | null, id: string, last_login?: string | null, requires_password_change?: boolean | null, updated: string, agb_accepted: boolean, stripe_customer_id?: string | null, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null, payment_methods: Array<{ __typename?: 'eatfresh_payment_method', trans_id: string, payment_method_type: Eatfresh_Payment_Method_Type_Enum, pseudo_card_number?: string | null, brand?: string | null, expirydate?: string | null, status?: string | null }> }> };

export type Fetch_User_By_Id_Anonymous_QueryQueryVariables = Exact<{
  user_ID: Scalars['uuid']['input'];
}>;


export type Fetch_User_By_Id_Anonymous_QueryQuery = { __typename?: 'query_root', eatfresh_user_account: Array<{ __typename?: 'eatfresh_user_account', email?: string | null, id: string, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null }> };

export type Fetch_User_By_Email_QueryQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type Fetch_User_By_Email_QueryQuery = { __typename?: 'query_root', eatfresh_user_account: Array<{ __typename?: 'eatfresh_user_account', email?: string | null, id: string, biometrics?: boolean | null, current_challenge?: string | null, has_password?: boolean | null }> };

export type FridgeLayoutLiveStockQueryVariables = Exact<{
  fridge_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  article_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type FridgeLayoutLiveStockQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, asset_placements: Array<{ __typename?: 'eatfresh_asset_placement', rfid_asset: { __typename?: 'eatfresh_rfid_asset', rfid_tags: Array<{ __typename?: 'eatfresh_rfid_tag', article_id?: string | null }> } }> }> };

export type ActivePriceLocksForFridgeSubscriptionVariables = Exact<{
  fridge_id: Scalars['uuid']['input'];
}>;


export type ActivePriceLocksForFridgeSubscription = { __typename?: 'subscription_root', eatfresh_price_lock: Array<{ __typename?: 'eatfresh_price_lock', id: string, article_id: string, locked_retail_price: number, created_at: string }> };

export type KpiCostsFridgesQueryVariables = Exact<{
  where: Eatfresh_Fridge_Bool_Exp;
}>;


export type KpiCostsFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', given_id: string }> };

export type KpiCostsTableAggregateQueryVariables = Exact<{
  where: Eatfresh_Rfid_Tag_Bool_Exp;
}>;


export type KpiCostsTableAggregateQuery = { __typename?: 'query_root', eatfresh_rfid_tag_aggregate: { __typename?: 'eatfresh_rfid_tag_aggregate', aggregate?: { __typename?: 'eatfresh_rfid_tag_aggregate_fields', sum?: { __typename?: 'eatfresh_rfid_tag_sum_fields', purchase_price?: number | null, labeling_cost_attribution?: number | null, commissioning_cost_attribution?: number | null, warehouse_order_cost_attribution?: number | null, warehouse_order_receipt_cost_attribution?: number | null, payment_cost_attribution?: number | null, delivery_cost_attribution?: number | null } | null } | null } };

export type CustomersFridgesQueryVariables = Exact<{
  where: Eatfresh_Fridge_Bool_Exp;
}>;


export type CustomersFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', given_id: string }> };

export type KpiPlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiPlacesQuery = { __typename?: 'query_root', eatfresh_place: Array<{ __typename?: 'eatfresh_place', id: string, name: string }> };

export type KpiLayoutPlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiLayoutPlacesQuery = { __typename?: 'query_root', eatfresh_place: Array<{ __typename?: 'eatfresh_place', id: string, name: string }> };

export type KpiLocationsFridgesQueryVariables = Exact<{
  where: Eatfresh_Fridge_Bool_Exp;
}>;


export type KpiLocationsFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', given_id: string, place: { __typename?: 'eatfresh_place', id: string, name: string, created: string, latitude: number, longitude: number } }> };

export type KpiOverviewFridgesQueryVariables = Exact<{
  where: Eatfresh_Fridge_Bool_Exp;
}>;


export type KpiOverviewFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', given_id: string, place: { __typename?: 'eatfresh_place', id: string, name: string } }> };

export type KpiProductsFridgesQueryVariables = Exact<{
  where: Eatfresh_Fridge_Bool_Exp;
}>;


export type KpiProductsFridgesQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', given_id: string }> };

export type MonitoringTxnCountQueryVariables = Exact<{
  where: Eatfresh_Customer_Order_Bool_Exp;
}>;


export type MonitoringTxnCountQuery = { __typename?: 'query_root', eatfresh_customer_order_aggregate: { __typename?: 'eatfresh_customer_order_aggregate', aggregate?: { __typename?: 'eatfresh_customer_order_aggregate_fields', count: number } | null } };

export type PriceLocksQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<Eatfresh_Price_Lock_Bool_Exp>;
  order_by?: InputMaybe<Array<Eatfresh_Price_Lock_Order_By> | Eatfresh_Price_Lock_Order_By>;
}>;


export type PriceLocksQuery = { __typename?: 'query_root', eatfresh_price_lock: Array<{ __typename?: 'eatfresh_price_lock', id: string, article_id: string, fridge_id: string, locked_retail_price: number, created_at: string, article: { __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number }, fridge: { __typename?: 'eatfresh_fridge', id: string, given_id: string, place: { __typename?: 'eatfresh_place', name: string } } }>, eatfresh_price_lock_aggregate: { __typename?: 'eatfresh_price_lock_aggregate', aggregate?: { __typename?: 'eatfresh_price_lock_aggregate_fields', count: number } | null } };

export type ArticlesForPriceLockQueryVariables = Exact<{ [key: string]: never; }>;


export type ArticlesForPriceLockQuery = { __typename?: 'query_root', eatfresh_article: Array<{ __typename?: 'eatfresh_article', id: string, name: string, ean: string, retail_price: number }> };

export type FridgesForPriceLockQueryVariables = Exact<{ [key: string]: never; }>;


export type FridgesForPriceLockQuery = { __typename?: 'query_root', eatfresh_fridge: Array<{ __typename?: 'eatfresh_fridge', id: string, given_id: string, place: { __typename?: 'eatfresh_place', name: string } }> };

export type StockDistributionByArticlesQueryVariables = Exact<{
  articleIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type StockDistributionByArticlesQuery = { __typename?: 'query_root', eatfresh_rfid_tag: Array<{ __typename?: 'eatfresh_rfid_tag', article_id?: string | null, rfid_asset?: { __typename?: 'eatfresh_rfid_asset', asset_placement?: { __typename?: 'eatfresh_asset_placement', warehouse_id?: string | null, fridge_id?: string | null, warehouse?: { __typename?: 'eatfresh_warehouse', name: string } | null, fridge?: { __typename?: 'eatfresh_fridge', given_id: string, place: { __typename?: 'eatfresh_place', name: string } } | null } | null } | null }> };

export type OrderWarehousesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type OrderWarehousesByIdsQuery = { __typename?: 'query_root', eatfresh_warehouse: Array<{ __typename?: 'eatfresh_warehouse', id: string, name: string, b2b_customer?: { __typename?: 'eatfresh_b2b_customer', name: string } | null }> };

export const B2bWarehouseOrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bWarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<B2bWarehouseOrderFragment, unknown>;
export const B2bPlaceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bPlace"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}}]}}]} as unknown as DocumentNode<B2bPlaceFragment, unknown>;
export const B2bWarehouseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bWarehouse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bPlace"}}]}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bPlace"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}}]}}]} as unknown as DocumentNode<B2bWarehouseFragment, unknown>;
export const B2bUserAccountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bUserAccount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"basic_user_type"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<B2bUserAccountFragment, unknown>;
export const UserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"basic_user_type"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_login"}},{"kind":"Field","name":{"kind":"Name","value":"requires_password_change"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"agb_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}}]} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const UserFragmentAnonymousFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragmentAnonymous"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}}]} as unknown as DocumentNode<UserFragmentAnonymousFragment, unknown>;
export const AnonUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnonUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}}]} as unknown as DocumentNode<AnonUserFragmentFragment, unknown>;
export const NutritionInformationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}}]} as unknown as DocumentNode<NutritionInformationFragment, unknown>;
export const VitaminMineralFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}}]} as unknown as DocumentNode<VitaminMineralFragment, unknown>;
export const VatCategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]} as unknown as DocumentNode<VatCategoryFragment, unknown>;
export const ArticleDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]} as unknown as DocumentNode<ArticleDetailsFragment, unknown>;
export const ArticleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}}]} as unknown as DocumentNode<ArticleFragment, unknown>;
export const AdminArticleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminArticle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"markup_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"margin_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"margin_euros"}},{"kind":"Field","name":{"kind":"Name","value":"retail_confirmed_at_purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"has_task"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminArticleFragment, unknown>;
export const PasswordResetTokenFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PasswordResetToken"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_password_reset_token"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_email"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"used"}}]}}]} as unknown as DocumentNode<PasswordResetTokenFragment, unknown>;
export const RfidScannerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<RfidScannerFragment, unknown>;
export const RfidScannerAdminFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScannerAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScanner"}},{"kind":"Field","name":{"kind":"Name","value":"power_in_dbm"}},{"kind":"Field","name":{"kind":"Name","value":"authtoken"}},{"kind":"Field","name":{"kind":"Name","value":"baseurl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<RfidScannerAdminFragment, unknown>;
export const RfidScanFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scanner_id"}},{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"epcs"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"reading_time"}},{"kind":"Field","name":{"kind":"Name","value":"reading_time_left"}},{"kind":"Field","name":{"kind":"Name","value":"read_finished"}},{"kind":"Field","name":{"kind":"Name","value":"scan_id"}}]}}]} as unknown as DocumentNode<RfidScanFragment, unknown>;
export const PlaceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PlaceFragment, unknown>;
export const WarehouseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Warehouse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<WarehouseFragment, unknown>;
export const WarehouseOrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<WarehouseOrderFragment, unknown>;
export const FridgeTargetStockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeTargetStock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_target_stock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}}]}}]} as unknown as DocumentNode<FridgeTargetStockFragment, unknown>;
export const FridgeTargetStockPositionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeTargetStockPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_target_stock_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]} as unknown as DocumentNode<FridgeTargetStockPositionFragment, unknown>;
export const FridgeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<FridgeFragment, unknown>;
export const FridgeOrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"last_serviced_at"}}]}}]} as unknown as DocumentNode<FridgeOrderFragment, unknown>;
export const CommissioningProcessFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommissioningProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_commissioning_process"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"scanner_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<CommissioningProcessFragment, unknown>;
export const BoxContentPlanFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BoxContentPlanFragment, unknown>;
export const RfidBoxFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_box"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<RfidBoxFragment, unknown>;
export const AssetPlacementFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}}]} as unknown as DocumentNode<AssetPlacementFragment, unknown>;
export const WarehouseShelfFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}}]} as unknown as DocumentNode<WarehouseShelfFragment, unknown>;
export const RfidFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}}]} as unknown as DocumentNode<RfidFragment, unknown>;
export const RfidAssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}}]} as unknown as DocumentNode<RfidAssetFragment, unknown>;
export const BoxContentPlanWithBoxFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlanWithBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scans_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidBox"}},{"kind":"Field","alias":{"kind":"Name","value":"error_plans"},"name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ERROR"},{"kind":"EnumValue","value":"CONFIRMED"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pallet_spot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"external_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_box"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}}]} as unknown as DocumentNode<BoxContentPlanWithBoxFragment, unknown>;
export const WarehouseOrderReceiptPositionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrderReceiptPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"quality"}},{"kind":"Field","name":{"kind":"Name","value":"expected_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"usable_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actual_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"labeled_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<WarehouseOrderReceiptPositionFragment, unknown>;
export const LogisticsProblemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogisticsProblem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_logistics_problem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"closed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"process_type"}},{"kind":"Field","name":{"kind":"Name","value":"problem_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<LogisticsProblemFragment, unknown>;
export const WarehouseOrderTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrderType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<WarehouseOrderTypeFragment, unknown>;
export const B2bCustomerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bCustomer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_b2b_customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billing_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"use_smartstore24_api"}},{"kind":"Field","name":{"kind":"Name","value":"ss24_location_id"}},{"kind":"Field","name":{"kind":"Name","value":"ss24_company_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<B2bCustomerFragment, unknown>;
export const AgeVerificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgeVerification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_age_verification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"last_checked_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<AgeVerificationFragment, unknown>;
export const CostConfigurationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CostConfiguration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_cost_configuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cost_key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated_at"}},{"kind":"Field","name":{"kind":"Name","value":"cost_configuration_key"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CostConfigurationFragment, unknown>;
export const FridgeLayoutLevelPositionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"lines_per_slot"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"w_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"d_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutLevelPositionFragment, unknown>;
export const FridgeLayoutLevelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_level_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"lines_per_slot"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"w_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"d_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutLevelFragment, unknown>;
export const FridgeLayoutFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"DEPRECATED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"lines_per_slot"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"w_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"d_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_level_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutFragment, unknown>;
export const CustomerOrderFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerOrderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"finished_at"}},{"kind":"Field","name":{"kind":"Name","value":"gross_total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_opened"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<CustomerOrderFieldsFragment, unknown>;
export const OrderPositionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPositionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}}]}}]} as unknown as DocumentNode<OrderPositionFragmentFragment, unknown>;
export const PaymentMethodFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_payment_method"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_type"}},{"kind":"Field","name":{"kind":"Name","value":"pseudo_card_number"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expirydate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<PaymentMethodFieldsFragment, unknown>;
export const FridgeEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FridgeEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridgeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridgeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"item_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<FridgeEventsSubscription, FridgeEventsSubscriptionVariables>;
export const MockUnstoredRfidsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MockUnstoredRfidsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_for_retail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_for_wholesale"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_tags_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"IN_FRIDGE"},{"kind":"EnumValue","value":"IN_STORAGE_BOX"}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"IN_FRIDGE"},{"kind":"EnumValue","value":"IN_STORAGE_BOX"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MockUnstoredRfidsQueryQuery, MockUnstoredRfidsQueryQueryVariables>;
export const MockFridgeCatalogArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MockFridgeCatalogArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"names"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"names"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MockFridgeCatalogArticlesQuery, MockFridgeCatalogArticlesQueryVariables>;
export const KpiRfidCostAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiRfidCostAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"payment_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_cost_attribution"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiRfidCostAggregateQuery, KpiRfidCostAggregateQueryVariables>;
export const CustomersOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomersOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodByTransId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_method_type"}}]}}]}}]}}]} as unknown as DocumentNode<CustomersOrdersQuery, CustomersOrdersQueryVariables>;
export const CustomersRegistrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomersRegistrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<CustomersRegistrationsQuery, CustomersRegistrationsQueryVariables>;
export const CustomersOrdersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomersOrdersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CustomersOrdersCountQuery, CustomersOrdersCountQueryVariables>;
export const CustomersRegCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomersRegCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CustomersRegCountQuery, CustomersRegCountQueryVariables>;
export const CustomersActiveUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomersActiveUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"user_id"}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}}]}}]} as unknown as DocumentNode<CustomersActiveUsersQuery, CustomersActiveUsersQueryVariables>;
export const KpiLocationCostRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiLocationCostRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_sold_item_cost_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_sold_item_cost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"cost_cents"}}]}}]}}]} as unknown as DocumentNode<KpiLocationCostRowsQuery, KpiLocationCostRowsQueryVariables>;
export const KpiLocationUnitRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiLocationUnitRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"customer_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]}}]} as unknown as DocumentNode<KpiLocationUnitRowsQuery, KpiLocationUnitRowsQueryVariables>;
export const KpiEmptyShelfSnapshotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiEmptyShelfSnapshot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_article_stock_snapshot_enabled_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_article_stock_snapshot_enabled_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"snapshot_day"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"snapshot_day"}},{"kind":"Field","name":{"kind":"Name","value":"empty_count"}},{"kind":"Field","name":{"kind":"Name","value":"total_count"}}]}}]}}]} as unknown as DocumentNode<KpiEmptyShelfSnapshotQuery, KpiEmptyShelfSnapshotQueryVariables>;
export const KpiOverviewCostRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiOverviewCostRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"payment_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_cost_attribution"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiOverviewCostRatioQuery, KpiOverviewCostRatioQueryVariables>;
export const KpiOverviewCostRatioRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiOverviewCostRatioRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sold_at"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"payment_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_cost_attribution"}}]}}]}}]} as unknown as DocumentNode<KpiOverviewCostRatioRowsQuery, KpiOverviewCostRatioRowsQueryVariables>;
export const KpiProductSoldItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiProductSoldItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_sold_item_cost_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_sold_item_cost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"revenue_cents"}},{"kind":"Field","name":{"kind":"Name","value":"cost_cents"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<KpiProductSoldItemsQuery, KpiProductSoldItemsQueryVariables>;
export const KpiProductLocationsStockingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiProductLocationsStocking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_target_stock_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_target_stock_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_target_stock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiProductLocationsStockingQuery, KpiProductLocationsStockingQueryVariables>;
export const KpiProductFridgeCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiProductFridgeCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_fridge_count"}}]}}]}}]} as unknown as DocumentNode<KpiProductFridgeCountQuery, KpiProductFridgeCountQueryVariables>;
export const KpiProductUnitsByEanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiProductUnitsByEan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiProductUnitsByEanQuery, KpiProductUnitsByEanQueryVariables>;
export const MonitoringCheckoutFailuresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MonitoringCheckoutFailures"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]} as unknown as DocumentNode<MonitoringCheckoutFailuresQuery, MonitoringCheckoutFailuresQueryVariables>;
export const KpiPulseFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPulseFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<KpiPulseFridgesQuery, KpiPulseFridgesQueryVariables>;
export const KpiOrdersAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiOrdersAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_sum"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiOrdersAggregateQuery, KpiOrdersAggregateQueryVariables>;
export const KpiRevenueByDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiRevenueByDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"total_sum"}}]}}]}}]} as unknown as DocumentNode<KpiRevenueByDayQuery, KpiRevenueByDayQueryVariables>;
export const KpiPulseFridgeActiveDailyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPulseFridgeActiveDaily"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_active_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_active_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"active_count"}}]}}]}}]} as unknown as DocumentNode<KpiPulseFridgeActiveDailyQuery, KpiPulseFridgeActiveDailyQueryVariables>;
export const KpiPulseFridgePerPlaceDailyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPulseFridgePerPlaceDaily"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_per_place_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_per_place_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_fridge_count"}}]}}]}}]} as unknown as DocumentNode<KpiPulseFridgePerPlaceDailyQuery, KpiPulseFridgePerPlaceDailyQueryVariables>;
export const KpiPositionsAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPositionsAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiPositionsAggregateQuery, KpiPositionsAggregateQueryVariables>;
export const KpiTopSellerPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiTopSellerPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}}]}}]}}]} as unknown as DocumentNode<KpiTopSellerPositionsQuery, KpiTopSellerPositionsQueryVariables>;
export const KpiPulseMarginAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPulseMarginAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_sold_item_cost_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_sold_item_cost_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cost_cents"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiPulseMarginAggregateQuery, KpiPulseMarginAggregateQueryVariables>;
export const KpiPulseUnitsByDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPulseUnitsByDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"customer_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}}]} as unknown as DocumentNode<KpiPulseUnitsByDayQuery, KpiPulseUnitsByDayQueryVariables>;
export const KpiPulseNewCustomersByDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPulseNewCustomersByDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_payment_method_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_payment_method"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<KpiPulseNewCustomersByDayQuery, KpiPulseNewCustomersByDayQueryVariables>;
export const KpiPulseMarginByDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPulseMarginByDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_sold_item_cost_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_sold_item_cost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"cost_cents"}}]}}]}}]} as unknown as DocumentNode<KpiPulseMarginByDayQuery, KpiPulseMarginByDayQueryVariables>;
export const FridgeLayoutKpiGlobalFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeLayoutKpiGlobalFridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"SELFLY"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"demo_flag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutKpiGlobalFridgesQuery, FridgeLayoutKpiGlobalFridgesQueryVariables>;
export const FridgeLayoutKpiOrderPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeLayoutKpiOrderPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutKpiOrderPositionsQuery, FridgeLayoutKpiOrderPositionsQueryVariables>;
export const FridgeLayoutKpiSoldItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeLayoutKpiSoldItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_sold_item_cost_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_sold_item_cost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"revenue_cents"}},{"kind":"Field","name":{"kind":"Name","value":"cost_cents"}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutKpiSoldItemsQuery, FridgeLayoutKpiSoldItemsQueryVariables>;
export const FridgeLayoutKpiProductFridgeCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeLayoutKpiProductFridgeCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_fridge_count"}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutKpiProductFridgeCountsQuery, FridgeLayoutKpiProductFridgeCountsQueryVariables>;
export const ArticleSalesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleSales"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag_sales_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_sales_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sale_day"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_count"}}]}}]}}]} as unknown as DocumentNode<ArticleSalesQuery, ArticleSalesQueryVariables>;
export const FridgeByArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeByArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_fridge_count"}}]}}]}}]} as unknown as DocumentNode<FridgeByArticleQuery, FridgeByArticleQueryVariables>;
export const KpiFridgeStockedEnabledPerPlaceDailyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiFridgeStockedEnabledPerPlaceDaily"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_per_place_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_stocked_enabled_per_place_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled_fridge_count"}}]}}]}}]} as unknown as DocumentNode<KpiFridgeStockedEnabledPerPlaceDailyQuery, KpiFridgeStockedEnabledPerPlaceDailyQueryVariables>;
export const KpiFridgeActiveDailyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiFridgeActiveDaily"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_active_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_active_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"active_count"}}]}}]}}]} as unknown as DocumentNode<KpiFridgeActiveDailyQuery, KpiFridgeActiveDailyQueryVariables>;
export const KpiSalesDailyAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiSalesDailyAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag_sales_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_sales_daily_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sale_count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiSalesDailyAggregateQuery, KpiSalesDailyAggregateQueryVariables>;
export const KpiSalesDailyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiSalesDaily"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag_sales_daily_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_sales_daily"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sale_day"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sale_day"}},{"kind":"Field","name":{"kind":"Name","value":"sale_count"}}]}}]}}]} as unknown as DocumentNode<KpiSalesDailyQuery, KpiSalesDailyQueryVariables>;
export const B2bMyAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bMyAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bUserAccount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primary_location"},"name":{"kind":"Name","value":"eatfresh_warehouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"external"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bUserAccount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"basic_user_type"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<B2bMyAccountQuery, B2bMyAccountQueryVariables>;
export const B2bOrderByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bOrderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<B2bOrderByIdQuery, B2bOrderByIdQueryVariables>;
export const B2bOrderReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bOrderReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warehouseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warehouseId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DRAFT"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<B2bOrderReviewQuery, B2bOrderReviewQueryVariables>;
export const B2bActiveDraftWarehouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bActiveDraftWarehouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DRAFT"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}}]}}]}}]} as unknown as DocumentNode<B2bActiveDraftWarehouseQuery, B2bActiveDraftWarehouseQueryVariables>;
export const B2bHomeStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bHomeStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"open_orders"},"name":{"kind":"Name","value":"eatfresh_warehouse_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DRAFT"},{"kind":"EnumValue","value":"PLACED"},{"kind":"EnumValue","value":"READY_TO_SHIP"},{"kind":"EnumValue","value":"TRANSPORT_REQUESTED"},{"kind":"EnumValue","value":"IN_TRANSIT"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delivered_recent"},"name":{"kind":"Name","value":"eatfresh_warehouse_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DELIVERED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"eatfresh_warehouse_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"external"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"articles_count"},"name":{"kind":"Name","value":"eatfresh_article_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_for_wholesale"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"open_draft"},"name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DRAFT"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bWarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recent_orders"},"name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bWarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bWarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<B2bHomeStatsQuery, B2bHomeStatsQueryVariables>;
export const B2bOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bWarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bWarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<B2bOrdersQuery, B2bOrdersQueryVariables>;
export const B2bArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<B2bArticlesQuery, B2bArticlesQueryVariables>;
export const B2bArticlesByEansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bArticlesByEans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eans"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_for_wholesale"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ean"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eans"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article_detail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wholesale_price"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article_detail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"items_per_package_unit"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<B2bArticlesByEansQuery, B2bArticlesByEansQueryVariables>;
export const B2bDraftOrderDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bDraftOrderDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warehouseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"WHOLESALE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warehouseId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DRAFT"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<B2bDraftOrderDetailQuery, B2bDraftOrderDetailQueryVariables>;
export const B2bLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"external"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"b2b_customer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bWarehouse"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bPlace"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bWarehouse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bPlace"}}]}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<B2bLocationsQuery, B2bLocationsQueryVariables>;
export const FridgeScannedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeScanned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<FridgeScannedQuery, FridgeScannedQueryVariables>;
export const AdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_login"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"basic_user_type"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_login"}},{"kind":"Field","name":{"kind":"Name","value":"requires_password_change"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"agb_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}}]} as unknown as DocumentNode<AdminUsersQuery, AdminUsersQueryVariables>;
export const AdminOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerOrderFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerOrderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"finished_at"}},{"kind":"Field","name":{"kind":"Name","value":"gross_total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_opened"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<AdminOrdersQuery, AdminOrdersQueryVariables>;
export const LoggedInUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoggedInUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"basic_user_type"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_login"}},{"kind":"Field","name":{"kind":"Name","value":"requires_password_change"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"agb_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}}]} as unknown as DocumentNode<LoggedInUserQuery, LoggedInUserQueryVariables>;
export const AdminRfidsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminRfids"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rfid_number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rfid_status"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_status_enum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"article_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid_comparison_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rfid_number"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rfid_status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"article_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"article_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rfid_number"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rfid_status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"article_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"article_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<AdminRfidsQuery, AdminRfidsQueryVariables>;
export const AdminArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdminArticle"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}},{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdminArticle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"markup_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"margin_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"margin_euros"}},{"kind":"Field","name":{"kind":"Name","value":"retail_confirmed_at_purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"has_task"}}]}}]} as unknown as DocumentNode<AdminArticlesQuery, AdminArticlesQueryVariables>;
export const AdminFridgeLayoutArticleCandidatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminFridgeLayoutArticleCandidates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<AdminFridgeLayoutArticleCandidatesQuery, AdminFridgeLayoutArticleCandidatesQueryVariables>;
export const AdminArticleRfidCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminArticleRfidCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"article_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"article_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminArticleRfidCountsQuery, AdminArticleRfidCountsQueryVariables>;
export const ArticleIdsInAssignedFridgeLayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleIdsInAssignedFridgeLayouts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_layout_level_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_layout_level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_layout"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_layout_assignments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"REQUESTED"},{"kind":"EnumValue","value":"ACTIVE"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}}]}}]}}]} as unknown as DocumentNode<ArticleIdsInAssignedFridgeLayoutsQuery, ArticleIdsInAssignedFridgeLayoutsQueryVariables>;
export const FridgesMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgesMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DEMO"},{"kind":"EnumValue","value":"SELFLY"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_stocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<FridgesMapQuery, FridgesMapQueryVariables>;
export const FridgesMapPinsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgesMapPins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DEMO"},{"kind":"EnumValue","value":"SELFLY"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"connection_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"ONLINE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<FridgesMapPinsQuery, FridgesMapPinsQueryVariables>;
export const FridgesStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgesStock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"given_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"given_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fridge_layout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_level_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FridgesStockQuery, FridgesStockQueryVariables>;
export const UnstoredRfidsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnstoredRfids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"UNSTORED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UnstoredRfidsQuery, UnstoredRfidsQueryVariables>;
export const AdminVatCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminVatCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_vat_category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_vat_category_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]} as unknown as DocumentNode<AdminVatCategoriesQuery, AdminVatCategoriesQueryVariables>;
export const AdminFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]} as unknown as DocumentNode<AdminFridgesQuery, AdminFridgesQueryVariables>;
export const SelectVatCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectVatCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]} as unknown as DocumentNode<SelectVatCategoriesQuery, SelectVatCategoriesQueryVariables>;
export const PasswordResetTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PasswordResetToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_password_reset_token"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PasswordResetToken"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PasswordResetToken"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_password_reset_token"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_email"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"expires_at"}},{"kind":"Field","name":{"kind":"Name","value":"used"}}]}}]} as unknown as DocumentNode<PasswordResetTokenQuery, PasswordResetTokenQueryVariables>;
export const Article_By_PkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ARTICLE_BY_PK"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Article_By_PkQuery, Article_By_PkQueryVariables>;
export const ArticleWithDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleWithDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ArticleWithDetailsQuery, ArticleWithDetailsQueryVariables>;
export const RfidScannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RfidScanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_scanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScanner"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<RfidScannersQuery, RfidScannersQueryVariables>;
export const RfidScannersAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RfidScannersAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_scanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScannerAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_scanner_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScannerAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScanner"}},{"kind":"Field","name":{"kind":"Name","value":"power_in_dbm"}},{"kind":"Field","name":{"kind":"Name","value":"authtoken"}},{"kind":"Field","name":{"kind":"Name","value":"baseurl"}}]}}]} as unknown as DocumentNode<RfidScannersAdminQuery, RfidScannersAdminQueryVariables>;
export const ArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Article"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ArticleQuery, ArticleQueryVariables>;
export const ArticleByEanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleByEan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ean"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ean"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ean"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ean"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ArticleByEanQuery, ArticleByEanQueryVariables>;
export const RfidBoxesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RfidBoxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidBox"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_box"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}}]} as unknown as DocumentNode<RfidBoxesQuery, RfidBoxesQueryVariables>;
export const WarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Warehouse"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Warehouse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<WarehousesQuery, WarehousesQueryVariables>;
export const WarehouseOrderNamesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehouseOrderNamesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<WarehouseOrderNamesByIdsQuery, WarehouseOrderNamesByIdsQueryVariables>;
export const AdminWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Warehouse"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Warehouse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AdminWarehousesQuery, AdminWarehousesQueryVariables>;
export const WarehouseOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehouseOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source_warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<WarehouseOrderQuery, WarehouseOrderQueryVariables>;
export const WarehouseOrderPositionsByPkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehouseOrderPositionsByPk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_articles"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_pu"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<WarehouseOrderPositionsByPkQuery, WarehouseOrderPositionsByPkQueryVariables>;
export const OrderRfidTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderRfidTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shelf_aggregate"},"name":{"kind":"Name","value":"eatfresh_rfid_tag_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wholesale_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"external_warehouse_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"best_before_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"order_rfid_tags"},"name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wholesale_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"external_warehouse_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}}]}}]}}]} as unknown as DocumentNode<OrderRfidTagsQuery, OrderRfidTagsQueryVariables>;
export const AdminWarehouseOrderIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminWarehouseOrderIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminWarehouseOrderIdsQuery, AdminWarehouseOrderIdsQueryVariables>;
export const AdminWarehouseOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminWarehouseOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supplier"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supplier"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supplier"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<AdminWarehouseOrdersQuery, AdminWarehouseOrdersQueryVariables>;
export const AdminWarehouseOrderByPkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminWarehouseOrderByPk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_pu"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_position_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<AdminWarehouseOrderByPkQuery, AdminWarehouseOrderByPkQueryVariables>;
export const WarehouseOrderStatusHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehouseOrderStatusHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<WarehouseOrderStatusHeaderQuery, WarehouseOrderStatusHeaderQueryVariables>;
export const Admin_Warehouse_Order_Query_Positions_NewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ADMIN_WAREHOUSE_ORDER_QUERY_POSITIONS_NEW"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedStatuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_status_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedStatuses"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"external"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedStatuses"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<Admin_Warehouse_Order_Query_Positions_NewQuery, Admin_Warehouse_Order_Query_Positions_NewQueryVariables>;
export const LabelWarehouseOrderReceiptPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabelWarehouseOrderReceiptPositions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DELIVERED"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_receipt_positions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_labeled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt_positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_labeled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrderReceiptPosition"}},{"kind":"Field","name":{"kind":"Name","value":"article_labeling_processes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrderReceiptPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"quality"}},{"kind":"Field","name":{"kind":"Name","value":"expected_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"usable_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actual_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"labeled_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]} as unknown as DocumentNode<LabelWarehouseOrderReceiptPositionsQuery, LabelWarehouseOrderReceiptPositionsQueryVariables>;
export const WarehouseOrderReceiptPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehouseOrderReceiptPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrderReceiptPosition"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrderReceiptPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"quality"}},{"kind":"Field","name":{"kind":"Name","value":"expected_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"usable_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actual_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"labeled_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]} as unknown as DocumentNode<WarehouseOrderReceiptPositionsQuery, WarehouseOrderReceiptPositionsQueryVariables>;
export const Scanner_Exists_By_PkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SCANNER_EXISTS_BY_PK"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_scanner_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<Scanner_Exists_By_PkQuery, Scanner_Exists_By_PkQueryVariables>;
export const Scanner_Exists_By_Given_IdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SCANNER_EXISTS_BY_GIVEN_ID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"givenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_scanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"givenId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<Scanner_Exists_By_Given_IdQuery, Scanner_Exists_By_Given_IdQueryVariables>;
export const AdminFridgeTargetStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminFridgeTargetStock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridgeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridgeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_target_stocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeTargetStock"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_target_stock_positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeTargetStockPosition"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_target_stock_positions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeTargetStock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_target_stock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeTargetStockPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_target_stock_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminFridgeTargetStockQuery, AdminFridgeTargetStockQueryVariables>;
export const AdminFridgeOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminFridgeOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridgeOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_order_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridgeOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"GENERATED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlanWithBox"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_box"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"last_serviced_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlanWithBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scans_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidBox"}},{"kind":"Field","alias":{"kind":"Name","value":"error_plans"},"name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ERROR"},{"kind":"EnumValue","value":"CONFIRMED"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pallet_spot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"external_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminFridgeOrderQuery, AdminFridgeOrderQueryVariables>;
export const AdminPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_place"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}},{"kind":"Field","name":{"kind":"Name","value":"warehouses_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridges_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_place_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AdminPlacesQuery, AdminPlacesQueryVariables>;
export const AdminPlaceByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminPlaceByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_place"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AdminPlaceByNameQuery, AdminPlaceByNameQueryVariables>;
export const RefillerFridgesInPlaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefillerFridgesInPlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_place_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}},{"kind":"Field","name":{"kind":"Name","value":"fridges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"PICKED_UP"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]} as unknown as DocumentNode<RefillerFridgesInPlaceQuery, RefillerFridgesInPlaceQueryVariables>;
export const Pending_Received_Warehouse_Orders_AggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PENDING_RECEIVED_WAREHOUSE_ORDERS_AGGREGATE"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DRAFT"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source_warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Pending_Received_Warehouse_Orders_AggregateQuery, Pending_Received_Warehouse_Orders_AggregateQueryVariables>;
export const ExternalWarehouseOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalWarehouseOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source_warehouse_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source_warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source_warehouse_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PLACED"},{"kind":"EnumValue","value":"READY_TO_SHIP"},{"kind":"EnumValue","value":"TRANSPORT_REQUESTED"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"external"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_pu"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<ExternalWarehouseOrdersQuery, ExternalWarehouseOrdersQueryVariables>;
export const DraftExternalOrderForRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DraftExternalOrderForRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source_warehouse_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destination_warehouse_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source_warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source_warehouse_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destination_warehouse_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DRAFT"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DraftExternalOrderForRouteQuery, DraftExternalOrderForRouteQueryVariables>;
export const ExternalWarehouseOrdersShippedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalWarehouseOrdersShipped"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source_warehouse_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source_warehouse_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source_warehouse_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"IN_TRANSIT"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"external"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_pu"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<ExternalWarehouseOrdersShippedQuery, ExternalWarehouseOrdersShippedQueryVariables>;
export const Warehouse_Order_Receipt_Positions_Where_Items_Per_Package_Unit_Is_NullDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WAREHOUSE_ORDER_RECEIPT_POSITIONS_WHERE_ITEMS_PER_PACKAGE_UNIT_IS_NULL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warehouse_order_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article_detail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"items_per_package_unit"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"storage_box_capacity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_receipt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"warehouse_order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warehouse_order_id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}}]}}]}}]} as unknown as DocumentNode<Warehouse_Order_Receipt_Positions_Where_Items_Per_Package_Unit_Is_NullQuery, Warehouse_Order_Receipt_Positions_Where_Items_Per_Package_Unit_Is_NullQueryVariables>;
export const Warehouse_Articles_By_Id_ArrayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WAREHOUSE_ARTICLES_BY_ID_ARRAY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idArray"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idArray"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Warehouse_Articles_By_Id_ArrayQuery, Warehouse_Articles_By_Id_ArrayQueryVariables>;
export const AdminArticlesByIdArrayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminArticlesByIdArray"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idArray"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idArray"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}},{"kind":"Field","name":{"kind":"Name","value":"wholesale_price"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminArticlesByIdArrayQuery, AdminArticlesByIdArrayQueryVariables>;
export const Warehouse_Order_Receipt_Position_By_IdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WAREHOUSE_ORDER_RECEIPT_POSITION_BY_ID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrderReceiptPosition"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrderReceiptPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_receipt_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"quality"}},{"kind":"Field","name":{"kind":"Name","value":"expected_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"usable_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actual_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"labeled_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]} as unknown as DocumentNode<Warehouse_Order_Receipt_Position_By_IdQuery, Warehouse_Order_Receipt_Position_By_IdQueryVariables>;
export const LogisticsProblemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LogisticsProblem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_logistics_problem_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogisticsProblem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogisticsProblem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_logistics_problem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"closed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"process_type"}},{"kind":"Field","name":{"kind":"Name","value":"problem_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<LogisticsProblemQuery, LogisticsProblemQueryVariables>;
export const EasyRefillPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EasyRefillPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_easy_refill_permission_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_easy_refill_permission_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_easy_refill_permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_easy_refill_permission_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]} as unknown as DocumentNode<EasyRefillPermissionsQuery, EasyRefillPermissionsQueryVariables>;
export const WarehouseTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehouseTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrderType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrderType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<WarehouseTypesQuery, WarehouseTypesQueryVariables>;
export const AdminB2bCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminB2bCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_b2b_customer_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_b2b_customer_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_b2b_customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"B2bCustomer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_b2b_customer_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"B2bCustomer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_b2b_customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billing_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"use_smartstore24_api"}},{"kind":"Field","name":{"kind":"Name","value":"ss24_location_id"}},{"kind":"Field","name":{"kind":"Name","value":"ss24_company_id"}}]}}]} as unknown as DocumentNode<AdminB2bCustomersQuery, AdminB2bCustomersQueryVariables>;
export const B2bCustomersSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"B2bCustomersSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_b2b_customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<B2bCustomersSelectQuery, B2bCustomersSelectQueryVariables>;
export const MyWarehouseAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyWarehouseAssignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_assignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enforce_quick_labeling"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}}]}}]}}]} as unknown as DocumentNode<MyWarehouseAssignmentQuery, MyWarehouseAssignmentQueryVariables>;
export const FridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"Fridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"given_id_or_selfly_device_code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"given_id_or_selfly_device_code"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"selfly_device_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"given_id_or_selfly_device_code"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]} as unknown as DocumentNode<FridgeSubscription, FridgeSubscriptionVariables>;
export const CustomerArticlesInFridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CustomerArticlesInFridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_placement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_placement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CustomerArticlesInFridgeSubscription, CustomerArticlesInFridgeSubscriptionVariables>;
export const ArticlesInFridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ArticlesInFridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_placement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_target_stock_positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_target_stock"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_placement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}}]} as unknown as DocumentNode<ArticlesInFridgeSubscription, ArticlesInFridgeSubscriptionVariables>;
export const ExpiredArticlesInFridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ExpiredArticlesInFridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"best_before_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"EnumValue","value":"NOW"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_placement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"best_before_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"EnumValue","value":"NOW"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_placement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}}]} as unknown as DocumentNode<ExpiredArticlesInFridgeSubscription, ExpiredArticlesInFridgeSubscriptionVariables>;
export const OperationsFridgeHealthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OperationsFridgeHealth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MOCK"},{"kind":"EnumValue","value":"SELFLY"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_device_code"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen_online"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_alarms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alarm_type"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_locks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"locked_retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_changes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"price_change_positions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"CONFIRMED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_change_positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"CONFIRMED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_change_positions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"CONFIRMED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"confirmed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"price_change"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"new_retail_price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_target_stocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fridge_target_stock_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<OperationsFridgeHealthSubscription, OperationsFridgeHealthSubscriptionVariables>;
export const OperationsRecentOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OperationsRecentOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"demo_flag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<OperationsRecentOrdersSubscription, OperationsRecentOrdersSubscriptionVariables>;
export const PaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_payment_method"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_method_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_payment_method"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_type"}},{"kind":"Field","name":{"kind":"Name","value":"pseudo_card_number"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expirydate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<PaymentMethodsSubscription, PaymentMethodsSubscriptionVariables>;
export const DraftRefillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"DraftRefill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_refill_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_status"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DraftRefillSubscription, DraftRefillSubscriptionVariables>;
export const RfidTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"RfidTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}}]}}]}}]} as unknown as DocumentNode<RfidTagsSubscription, RfidTagsSubscriptionVariables>;
export const FridgesSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FridgesSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedStatuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_connection_status_enum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connection_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedStatuses"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<FridgesSubscriptionSubscription, FridgesSubscriptionSubscriptionVariables>;
export const FridgesAggregateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FridgesAggregateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedStatuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_connection_status_enum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connection_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedStatuses"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FridgesAggregateSubscriptionSubscription, FridgesAggregateSubscriptionSubscriptionVariables>;
export const MockFridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MockFridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"given_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<MockFridgeSubscription, MockFridgeSubscriptionVariables>;
export const ArticleLabelingProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ArticleLabelingProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article_labeling_process_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scanner_id"}},{"kind":"Field","name":{"kind":"Name","value":"expected_number_of_items"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to_label_assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScanner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"confirmed_at"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlanWithBox"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScan"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_box"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlanWithBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scans_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidBox"}},{"kind":"Field","alias":{"kind":"Name","value":"error_plans"},"name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ERROR"},{"kind":"EnumValue","value":"CONFIRMED"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pallet_spot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"external_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scanner_id"}},{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"epcs"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"reading_time"}},{"kind":"Field","name":{"kind":"Name","value":"reading_time_left"}},{"kind":"Field","name":{"kind":"Name","value":"read_finished"}},{"kind":"Field","name":{"kind":"Name","value":"scan_id"}}]}}]} as unknown as DocumentNode<ArticleLabelingProcessSubscription, ArticleLabelingProcessSubscriptionVariables>;
export const SupplierActiveCommissioningsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SupplierActiveCommissionings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_commissioning_process"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"IN_PROGRESS"},{"kind":"EnumValue","value":"PAUSED"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommissioningProcess"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlanWithBox"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_box"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommissioningProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_commissioning_process"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"scanner_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlanWithBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scans_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidBox"}},{"kind":"Field","alias":{"kind":"Name","value":"error_plans"},"name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ERROR"},{"kind":"EnumValue","value":"CONFIRMED"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pallet_spot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"external_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierActiveCommissioningsSubscription, SupplierActiveCommissioningsSubscriptionVariables>;
export const SupplierFridgeOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SupplierFridgeOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"GENERATED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"commissioning_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"last_serviced_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}}]} as unknown as DocumentNode<SupplierFridgeOrdersSubscription, SupplierFridgeOrdersSubscriptionVariables>;
export const SupplierCommissioningProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SupplierCommissioningProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_commissioning_process_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommissioningProcess"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"confirmed_at"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlanWithBox"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_boxes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_assets_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidBox"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"commissioning_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScanner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidScan"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"package_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_box"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommissioningProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_commissioning_process"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"scanner_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxContentPlanWithBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_box_content_plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxContentPlan"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scans_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidBox"}},{"kind":"Field","alias":{"kind":"Name","value":"error_plans"},"name":{"kind":"Name","value":"box_content_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ERROR"},{"kind":"EnumValue","value":"CONFIRMED"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_at"}},{"kind":"Field","name":{"kind":"Name","value":"box_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pallet_spot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"external_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"last_serviced_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidScan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_scan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_scanner_id"}},{"kind":"Field","name":{"kind":"Name","value":"scanned_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"epcs"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"reading_time"}},{"kind":"Field","name":{"kind":"Name","value":"reading_time_left"}},{"kind":"Field","name":{"kind":"Name","value":"read_finished"}},{"kind":"Field","name":{"kind":"Name","value":"scan_id"}}]}}]} as unknown as DocumentNode<SupplierCommissioningProcessSubscription, SupplierCommissioningProcessSubscriptionVariables>;
export const AdminFridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AdminFridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]} as unknown as DocumentNode<AdminFridgeSubscription, AdminFridgeSubscriptionVariables>;
export const RefillInProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"RefillInProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_refill_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_status"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmation_image_required"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortcode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"box_content_to_articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Article"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"REQUESTED"},{"kind":"EnumValue","value":"ACTIVE"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayout"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_transfers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RfidAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NutritionInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_nutrition_information"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nutritional_values_unit"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kcal"}},{"kind":"Field","name":{"kind":"Name","value":"calories_kj"}},{"kind":"Field","name":{"kind":"Name","value":"fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"salt_g"}},{"kind":"Field","name":{"kind":"Name","value":"saturated_fat_g"}},{"kind":"Field","name":{"kind":"Name","value":"carbohydrates_g"}},{"kind":"Field","name":{"kind":"Name","value":"sugar_g"}},{"kind":"Field","name":{"kind":"Name","value":"fiber_g"}},{"kind":"Field","name":{"kind":"Name","value":"protein_g"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VitaminMineral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vitamin_mineral"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"article_details_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_vat_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article_details"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_number"}},{"kind":"Field","name":{"kind":"Name","value":"gln"}},{"kind":"Field","name":{"kind":"Name","value":"ifs_broker_certified"}},{"kind":"Field","name":{"kind":"Name","value":"co_id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_country"}},{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}},{"kind":"Field","name":{"kind":"Name","value":"total_mhd"}},{"kind":"Field","name":{"kind":"Name","value":"min_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"max_storage_temperature"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weight_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"gtin_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_type_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"items_per_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"gross_weigth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"width_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"height_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"depth_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_deposit_required"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"deposit_value_package_unit"}},{"kind":"Field","name":{"kind":"Name","value":"alcohol_content"}},{"kind":"Field","name":{"kind":"Name","value":"designation_according_to_lmiv"}},{"kind":"Field","name":{"kind":"Name","value":"ingredient_list"}},{"kind":"Field","name":{"kind":"Name","value":"fruit_content_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"preservatives"}},{"kind":"Field","name":{"kind":"Name","value":"stabilizers"}},{"kind":"Field","name":{"kind":"Name","value":"dyes_coloring"}},{"kind":"Field","name":{"kind":"Name","value":"flavor_enhancer"}},{"kind":"Field","name":{"kind":"Name","value":"other_additives"}},{"kind":"Field","name":{"kind":"Name","value":"contains_gluten"}},{"kind":"Field","name":{"kind":"Name","value":"contains_eggs"}},{"kind":"Field","name":{"kind":"Name","value":"contains_peanuts"}},{"kind":"Field","name":{"kind":"Name","value":"contains_milk"}},{"kind":"Field","name":{"kind":"Name","value":"contains_crustaceans"}},{"kind":"Field","name":{"kind":"Name","value":"contains_fish"}},{"kind":"Field","name":{"kind":"Name","value":"contains_soy"}},{"kind":"Field","name":{"kind":"Name","value":"contains_lactose"}},{"kind":"Field","name":{"kind":"Name","value":"may_contain_traces_of"}},{"kind":"Field","name":{"kind":"Name","value":"bio_control_number"}},{"kind":"Field","name":{"kind":"Name","value":"regional"}},{"kind":"Field","name":{"kind":"Name","value":"eu_approval_number"}},{"kind":"Field","name":{"kind":"Name","value":"vegan"}},{"kind":"Field","name":{"kind":"Name","value":"vegetarian"}},{"kind":"Field","name":{"kind":"Name","value":"kosher"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"halal"}},{"kind":"Field","name":{"kind":"Name","value":"storage_box_capacity"}},{"kind":"Field","name":{"kind":"Name","value":"article_category"}},{"kind":"Field","name":{"kind":"Name","value":"nutrition_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NutritionInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vitamin_minerals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VitaminMineral"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatCategory"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"lines_per_slot"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"w_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"d_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_level_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Article"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"DEPRECATED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RfidAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}}]}}]} as unknown as DocumentNode<RefillInProgressSubscription, RefillInProgressSubscriptionVariables>;
export const RefillerEasyFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"RefillerEasyFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"easy_refill_permissions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"revoked_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]} as unknown as DocumentNode<RefillerEasyFridgesSubscription, RefillerEasyFridgesSubscriptionVariables>;
export const AdminWarehouseOrdersSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AdminWarehouseOrdersSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_order_by"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"external"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total_articles"}},{"kind":"Field","name":{"kind":"Name","value":"packaging_units"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remaining_shelf_life"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_positions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_articles"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"shipped_at"}},{"kind":"Field","name":{"kind":"Name","value":"logistics_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer_id"}}]}}]} as unknown as DocumentNode<AdminWarehouseOrdersSubscriptionSubscription, AdminWarehouseOrdersSubscriptionSubscriptionVariables>;
export const AdminWarehouseOrdersCountSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AdminWarehouseOrdersCountSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<AdminWarehouseOrdersCountSubscriptionSubscription, AdminWarehouseOrdersCountSubscriptionSubscriptionVariables>;
export const AgeVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AgeVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_age_verification_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_age_verification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgeVerification"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgeVerification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_age_verification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"last_checked_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<AgeVerificationSubscription, AgeVerificationSubscriptionVariables>;
export const CostConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CostConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_cost_configuration_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_cost_configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CostConfiguration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_cost_configuration_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CostConfiguration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_cost_configuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cost_key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deprecated_at"}},{"kind":"Field","name":{"kind":"Name","value":"cost_configuration_key"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CostConfigurationQuery, CostConfigurationQueryVariables>;
export const FridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Fridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Fridge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Place"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directions_pdf_id"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"google_maps_url"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"nb"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip_code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additional_line"}},{"kind":"Field","name":{"kind":"Name","value":"location_name"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"last_sync"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Fridge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"connection_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_status"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_synced"}},{"kind":"Field","name":{"kind":"Name","value":"inventory_last_synced_at"}},{"kind":"Field","name":{"kind":"Name","value":"directions_summary"}},{"kind":"Field","name":{"kind":"Name","value":"age_verification_type"}},{"kind":"Field","name":{"kind":"Name","value":"selfly_cabinet_state"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Place"}}]}}]}}]} as unknown as DocumentNode<FridgesQuery, FridgesQueryVariables>;
export const FridgeLayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeLayouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_layout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayout"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_layout_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"lines_per_slot"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"w_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"d_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_level_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"DEPRECATED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutsQuery, FridgeLayoutsQueryVariables>;
export const FridgeLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge_layout_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayout"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"lines_per_slot"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"w_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"d_orientation"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_retail"}},{"kind":"Field","name":{"kind":"Name","value":"active_for_wholesale"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"article_detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vat_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"width_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"height_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"depth_single_item"}},{"kind":"Field","name":{"kind":"Name","value":"net_weight"}},{"kind":"Field","name":{"kind":"Name","value":"net_fill_volume"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayoutLevel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout_level"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_index"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_level_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevelPosition"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FridgeLayout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_layout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_layout_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_levels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FridgeLayoutLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge_layout_assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"DEPRECATED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutQuery, FridgeLayoutQueryVariables>;
export const CustomerOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerOrderFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerOrderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"finished_at"}},{"kind":"Field","name":{"kind":"Name","value":"gross_total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_opened"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<CustomerOrderQuery, CustomerOrderQueryVariables>;
export const CustomerOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerOrderFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerOrderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"finished_at"}},{"kind":"Field","name":{"kind":"Name","value":"gross_total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_opened"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<CustomerOrdersQuery, CustomerOrdersQueryVariables>;
export const OrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"Order"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerOrderFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerOrderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"finished_at"}},{"kind":"Field","name":{"kind":"Name","value":"gross_total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_opened"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<OrderSubscription, OrderSubscriptionVariables>;
export const OrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"Orders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerOrderFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerOrderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"finished_at"}},{"kind":"Field","name":{"kind":"Name","value":"gross_total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"total_sum"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_status"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"door_opened"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method"}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"demo_flag"}},{"kind":"Field","name":{"kind":"Name","value":"order_positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"deposit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<OrdersSubscription, OrdersSubscriptionVariables>;
export const Fetch_Order_Positions_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_ORDER_POSITIONS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderPositionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_order_position_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderPositionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_order_position"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_sales_price"}},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"article_name"}}]}}]} as unknown as DocumentNode<Fetch_Order_Positions_QueryQuery, Fetch_Order_Positions_QueryQueryVariables>;
export const Fetch_Rfid_Id_Tags_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_RFID_ID_TAGS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<Fetch_Rfid_Id_Tags_QueryQuery, Fetch_Rfid_Id_Tags_QueryQueryVariables>;
export const Fetch_Rfid_Tag_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_RFID_TAG_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rfidNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rfidNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Rfid"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetPlacement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_asset_placement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box_id"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_id"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_id"}},{"kind":"Field","name":{"kind":"Name","value":"refill_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WarehouseShelf"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_warehouse_shelf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_row"}},{"kind":"Field","name":{"kind":"Name","value":"shelf_column"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Rfid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetPlacement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"box_content_plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_box"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epc"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_shelf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WarehouseShelf"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"product_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<Fetch_Rfid_Tag_QueryQuery, Fetch_Rfid_Tag_QueryQueryVariables>;
export const Anonymous_Rfid_Tag_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ANONYMOUS_RFID_TAG_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rfidNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rfid_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rfidNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_number"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"best_before_date"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_status"}},{"kind":"Field","name":{"kind":"Name","value":"is_whitelabel"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}}]}}]}}]} as unknown as DocumentNode<Anonymous_Rfid_Tag_QueryQuery, Anonymous_Rfid_Tag_QueryQueryVariables>;
export const Fetch_User_By_Id_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_USER_BY_ID_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_ID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_ID"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}},{"kind":"Field","name":{"kind":"Name","value":"payment_methods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"basic_user_type"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_login"}},{"kind":"Field","name":{"kind":"Name","value":"requires_password_change"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"agb_accepted"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_payment_method"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trans_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_method_type"}},{"kind":"Field","name":{"kind":"Name","value":"pseudo_card_number"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expirydate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<Fetch_User_By_Id_QueryQuery, Fetch_User_By_Id_QueryQueryVariables>;
export const Fetch_User_By_Id_Anonymous_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_USER_BY_ID_ANONYMOUS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_ID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_ID"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnonUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnonUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}}]} as unknown as DocumentNode<Fetch_User_By_Id_Anonymous_QueryQuery, Fetch_User_By_Id_Anonymous_QueryQueryVariables>;
export const Fetch_User_By_Email_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_USER_BY_EMAIL_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_user_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnonUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnonUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_user_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"biometrics"}},{"kind":"Field","name":{"kind":"Name","value":"current_challenge"}},{"kind":"Field","name":{"kind":"Name","value":"has_password"}}]}}]} as unknown as DocumentNode<Fetch_User_By_Email_QueryQuery, Fetch_User_By_Email_QueryQueryVariables>;
export const FridgeLayoutLiveStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgeLayoutLiveStock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridge_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"article_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_placements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rfid_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"article_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FridgeLayoutLiveStockQuery, FridgeLayoutLiveStockQueryVariables>;
export const ActivePriceLocksForFridgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ActivePriceLocksForFridge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_price_lock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridge_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fridge_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deprecated_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"locked_retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<ActivePriceLocksForFridgeSubscription, ActivePriceLocksForFridgeSubscriptionVariables>;
export const KpiCostsFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiCostsFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]} as unknown as DocumentNode<KpiCostsFridgesQuery, KpiCostsFridgesQueryVariables>;
export const KpiCostsTableAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiCostsTableAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_rfid_tag_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"labeling_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"commissioning_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse_order_receipt_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"payment_cost_attribution"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_cost_attribution"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KpiCostsTableAggregateQuery, KpiCostsTableAggregateQueryVariables>;
export const CustomersFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomersFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]} as unknown as DocumentNode<CustomersFridgesQuery, CustomersFridgesQueryVariables>;
export const KpiPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiPlaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_place"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridges"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MOCK"},{"kind":"EnumValue","value":"SELFLY"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"demo_flag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<KpiPlacesQuery, KpiPlacesQueryVariables>;
export const KpiLayoutPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiLayoutPlaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_place"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fridges"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"SELFLY"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"demo_flag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<KpiLayoutPlacesQuery, KpiLayoutPlacesQueryVariables>;
export const KpiLocationsFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiLocationsFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<KpiLocationsFridgesQuery, KpiLocationsFridgesQueryVariables>;
export const KpiOverviewFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiOverviewFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<KpiOverviewFridgesQuery, KpiOverviewFridgesQueryVariables>;
export const KpiProductsFridgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpiProductsFridges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_fridge_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}}]}}]}}]} as unknown as DocumentNode<KpiProductsFridgesQuery, KpiProductsFridgesQueryVariables>;
export const MonitoringTxnCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MonitoringTxnCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_customer_order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_customer_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<MonitoringTxnCountQuery, MonitoringTxnCountQueryVariables>;
export const PriceLocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceLocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_price_lock_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eatfresh_price_lock_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_price_lock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"locked_retail_price"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eatfresh_price_lock_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<PriceLocksQuery, PriceLocksQueryVariables>;
export const ArticlesForPriceLockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticlesForPriceLock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_for_retail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_for_wholesale"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"retail_price"}}]}}]}}]} as unknown as DocumentNode<ArticlesForPriceLockQuery, ArticlesForPriceLockQueryVariables>;
export const FridgesForPriceLockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FridgesForPriceLock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_fridge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"given_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FridgesForPriceLockQuery, FridgesForPriceLockQueryVariables>;
export const StockDistributionByArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StockDistributionByArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_rfid_tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"article_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sold_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article_id"}},{"kind":"Field","name":{"kind":"Name","value":"rfid_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_placement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouse_id"}},{"kind":"Field","name":{"kind":"Name","value":"fridge_id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"given_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StockDistributionByArticlesQuery, StockDistributionByArticlesQueryVariables>;
export const OrderWarehousesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderWarehousesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eatfresh_warehouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<OrderWarehousesByIdsQuery, OrderWarehousesByIdsQueryVariables>;